
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("48Eol", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $b9k8w = parcelRequire("b9k8w");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $gyUf8 = parcelRequire("gyUf8");


var $iODl6 = parcelRequire("iODl6");


var $gtMdU = parcelRequire("gtMdU");










const $db51e5cdbc5c7da8$export$79cc7820899d3234 = /*#__PURE__*/ (0, $cozmU.createContext)(false);



var $fvwa0 = parcelRequire("fvwa0");

const $71c85943ef41ca73$export$797f6437373337da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, value: value } = t0;
    const isCustomIsFhsEnabled = (0, $cozmU.useContext)((0, $db51e5cdbc5c7da8$export$79cc7820899d3234));
    if (isCustomIsFhsEnabled) throw new Error("A custom value for IsFhsEnabledContext has already been provided");
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db51e5cdbc5c7da8$export$79cc7820899d3234).Provider, {
            value: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fvwa0.IsFhsEnabledContext).Provider, {
            value: value
        }, children));
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, value: value })=>{
    const isCustomIsFhsEnabled = (0, $cozmU.useContext)((0, $db51e5cdbc5c7da8$export$79cc7820899d3234));
    if (isCustomIsFhsEnabled) throw new Error('A custom value for IsFhsEnabledContext has already been provided');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db51e5cdbc5c7da8$export$79cc7820899d3234).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fvwa0.IsFhsEnabledContext).Provider, {
        value: value
    }, children));
};



var $b0qTi = parcelRequire("b0qTi");











var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $eaAhc = parcelRequire("eaAhc");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $kPxjF = parcelRequire("kPxjF");


var $b24kF = parcelRequire("b24kF");


var $eyPWA = parcelRequire("eyPWA");

const $5660beed5219c07c$var$styles = {
    root: "_1xC2CJweDq _4bt5LAnQyn _2WAcuGnQyn _0jFU0V9QlX _2I62gzdnbC _1mT5xdHE3j _42Yu6B8OLE",
    fullHeightSidebar: "_42Yu6B7LI7"
}; /**
    * The banner layout area. It will always be displayed at the top of the screen.
    *
    * Should be used to render a `Banner` component from `@atlaskit/banner`.
    */ 
const $5660beed5219c07c$export$3b4e64e77073e307 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Banner(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { children: children, xcss: xcss, height: t1, skipLinkLabel: t2, testId: testId, id: providedId } = t0;
    const height = t1 === undefined ? 48 : t1;
    const skipLinkLabel = t2 === undefined ? "Banner" : t2;
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    let t3;
    if ($[0] !== providedId) {
        t3 = {
            providedId: providedId
        };
        $[0] = providedId;
        $[1] = t3;
    } else t3 = $[1];
    const id = (0, $eyPWA.useLayoutId)(t3);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    let t4;
    if ($[2] !== height) {
        t4 = height === 0 || (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1");
        $[2] = height;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== id || $[5] !== skipLinkLabel || $[6] !== t4) {
        t5 = {
            id: id,
            label: skipLinkLabel,
            isHidden: t4
        };
        $[4] = id;
        $[5] = skipLinkLabel;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    (0, $eaAhc.useSkipLinkInternal)(t5);
    const t6 = isFhsEnabled && $5660beed5219c07c$var$styles.fullHeightSidebar;
    let t7;
    if ($[8] !== t6 || $[9] !== xcss) {
        t7 = (0, $hekY6.default)([
            $5660beed5219c07c$var$styles.root,
            t6,
            xcss
        ]);
        $[8] = t6;
        $[9] = xcss;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== height) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
            variableName: (0, $liCgE.bannerMountedVar),
            value: height
        });
        $[11] = height;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== dangerouslyHoistSlotSizes || $[14] !== height) {
        t9 = dangerouslyHoistSlotSizes && /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $liCgE.UNSAFE_bannerVar),
            value: height
        });
        $[13] = dangerouslyHoistSlotSizes;
        $[14] = height;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== children || $[17] !== id || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 || $[21] !== testId) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: id,
            "data-layout-slot": true,
            className: t7,
            "data-testid": testId
        }, t8, t9, children);
        $[16] = children;
        $[17] = id;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
        $[21] = testId;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
} : function Banner({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)(); /**
                                           * Don't show the skip link if the slot has 0 height.
                                           *
                                           * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
                                           */ 
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0 || (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hekY6.default)([
            $5660beed5219c07c$var$styles.root,
            isFhsEnabled && $5660beed5219c07c$var$styles.fullHeightSidebar,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
        variableName: (0, $liCgE.bannerMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_bannerVar),
        value: height
    }), children);
};



var $dyjRd = parcelRequire("dyjRd");


var $31TvY = parcelRequire("31TvY");


var $9wGTI = parcelRequire("9wGTI");


var $58PBI = parcelRequire("58PBI");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7xVCs = parcelRequire("7xVCs");


var $5XPyz = parcelRequire("5XPyz");


var $hrAmX = parcelRequire("hrAmX");


var $cgsIj = parcelRequire("cgsIj");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $1C7kY = parcelRequire("1C7kY");


var $3u0dr = parcelRequire("3u0dr");














var $7akNQ = parcelRequire("7akNQ");





var $jsuJ9 = parcelRequire("jsuJ9");


var $28WJb = parcelRequire("28WJb");


var $lRhY3 = parcelRequire("lRhY3");







const $36b11f7822ba6f88$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    panelSplitter: {
        id: "preview-panel-api.resize.label",
        defaultMessage: "Resize panel"
    }
});


const $2c25ef82052c394f$var$PreviewPanelSplitter = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    const { setPanelWidth: setPanelWidth } = (0, $lRhY3.usePreviewPanelsActions)();
    let t0;
    if ($[0] !== setPanelWidth) {
        t0 = (t1)=>{
            const { finalWidth: finalWidth } = t1;
            setPanelWidth(finalWidth);
        };
        $[0] = setPanelWidth;
        $[1] = t0;
    } else t0 = $[1];
    const onResizeEnd = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onResizeEnd || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
            label: t1,
            onResizeEnd: onResizeEnd
        });
        $[4] = onResizeEnd;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { setPanelWidth: setPanelWidth } = (0, $lRhY3.usePreviewPanelsActions)();
    const onResizeEnd = (0, $cozmU.useCallback)(({ finalWidth: finalWidth })=>{
        setPanelWidth(finalWidth);
    }, [
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
        label: intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter),
        onResizeEnd: onResizeEnd
    });
};
const $2c25ef82052c394f$var$NavWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, width: width } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0qTi.Panel), {
            defaultWidth: width
        }, t1, children);
        $[1] = children;
        $[2] = width;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0qTi.Panel), {
        defaultWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null), children);
const $2c25ef82052c394f$export$f143b4bd86d1e004 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PreviewPanelContainer() {
    const $ = (0, $bDgLe.c)(5);
    const panel = (0, $28WJb.useCurrentPreviewPanel)();
    const PanelContent = panel?.content ?? null;
    let t0;
    if ($[0] !== PanelContent || $[1] !== panel) {
        t0 = panel != null && PanelContent != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$NavWrapper, {
            width: panel.width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PanelContent, null))) : null;
        $[0] = PanelContent;
        $[1] = panel;
        $[2] = t0;
    } else t0 = $[2];
    const previewPanel = t0;
    if ((0, $9wGTI.fg)("platform-dst-motion-uplift-panel")) {
        let t1;
        if ($[3] !== previewPanel) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, previewPanel);
            $[3] = previewPanel;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    return previewPanel;
} : function PreviewPanelContainer() {
    const panel = (0, $28WJb.useCurrentPreviewPanel)();
    // When there is no active panel we still want the ExitingPersistence wrapper (below) to remain
    // mounted so the Panel's built-in exit motion can play before it is removed from the DOM.
    const PanelContent = panel?.content ?? null;
    const previewPanel = panel != null && PanelContent != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$NavWrapper, {
        width: panel.width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PanelContent, null))) : null;
    // The ADS Panel only animates its enter/exit (via its internal useMotion hook) when the
    // `platform-dst-motion-uplift-panel` gate is enabled. Behind the same gate we keep an
    // always-mounted ExitingPersistence and render the Panel conditionally inside it so the exit
    // motion can play before the Panel unmounts. With the gate off we keep the previous behaviour of
    // returning null when there is no active panel.
    if ((0, $9wGTI.fg)('platform-dst-motion-uplift-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, previewPanel);
    return previewPanel;
};



var $6mKj3 = parcelRequire("6mKj3");


var $4vI1F = parcelRequire("4vI1F");


var $jvYFk = parcelRequire("jvYFk");


var $aWwYt = parcelRequire("aWwYt");


var $2vuKf = parcelRequire("2vuKf");


var $aboIx = parcelRequire("aboIx");


var $8zMP3 = parcelRequire("8zMP3");


var $fZAJP = parcelRequire("fZAJP");


var $jAOzg = parcelRequire("jAOzg");





var $ep3mz = parcelRequire("ep3mz");








var $bpufi = parcelRequire("bpufi");


var $ftFOj = parcelRequire("ftFOj");

/**
 * Inner component that runs the sync hook. Kept separate so the ErrorBoundary
 * above it can catch any errors thrown during the hook's execution without
 * taking down the rest of the page layout.
 */ const $3260f1cb149f21d4$var$SmartFolderAncestorSyncInner = ({ contentId: contentId, shouldExcludeAutoSync: shouldExcludeAutoSync })=>{
    (0, $bpufi.useSmartFolderAncestorSync)(contentId, {
        shouldExcludeAutoSync: shouldExcludeAutoSync
    });
    return null;
};
const $3260f1cb149f21d4$export$2e1f52d6d7a935bc = ({ contentId: contentId, shouldExcludeAutoSync: shouldExcludeAutoSync })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSmartFoldersEnabled: isSmartFoldersEnabled } = (0, $ftFOj.useIsSmartFoldersEnabled)(spaceKey);
    if (!isSmartFoldersEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3260f1cb149f21d4$var$SmartFolderAncestorSyncInner, {
        contentId: contentId,
        shouldExcludeAutoSync: shouldExcludeAutoSync
    }));
};









var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $lFjPc = parcelRequire("lFjPc");

const $bd996ec529999f47$export$ac3e7903e24ee02d = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { view: view, children: children, navVersion: navVersion } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker || $[1] !== navVersion) {
        t1 = (name)=>experienceTracker.abort({
                name: name,
                reason: "navigation container view changed",
                attributes: {
                    navVersion: navVersion
                }
            });
        $[0] = experienceTracker;
        $[1] = navVersion;
        $[2] = t1;
    } else t1 = $[2];
    const abortExp = t1;
    let t2;
    if ($[3] !== experienceTracker || $[4] !== navVersion) {
        t2 = (name_0)=>experienceTracker.start({
                name: name_0,
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: navVersion
                }
            });
        $[3] = experienceTracker;
        $[4] = navVersion;
        $[5] = t2;
    } else t2 = $[5];
    const startExp = t2;
    let t3;
    let t4;
    if ($[6] !== abortExp || $[7] !== startExp || $[8] !== view) {
        t3 = ()=>{
            bb6: switch(view){
                case 0, $lFjPc.CONTAINER_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $lFjPc.PRODUCT_HOME_ID:
                case 0, $lFjPc.PRODUCT_ADDONS_ID:
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $lFjPc.ADMIN_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
            }
        };
        t4 = [
            view,
            startExp,
            abortExp
        ];
        $[6] = abortExp;
        $[7] = startExp;
        $[8] = view;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== startExp) {
        t5 = ()=>{
            startExp((0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE));
        };
        t6 = [
            startExp
        ];
        $[11] = startExp;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t5, t6);
    let t7;
    if ($[14] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[14] = children;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
};












var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $65DSU = parcelRequire("65DSU");


var $kz1Yj = parcelRequire("kz1Yj");





var $jYwSK = parcelRequire("jYwSK");


var $1o3CH = parcelRequire("1o3CH");











var $9EOlJ = parcelRequire("9EOlJ");


var $64VTj = parcelRequire("64VTj");


var $9bYqt = parcelRequire("9bYqt");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)

























const $d7827ca4fe42bedf$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("9z9Sl")),
    da: ()=>(parcelRequire("kdftj")),
    de: ()=>(parcelRequire("Is4v8")),
    en: ()=>Promise.resolve((parcelRequire("9bYqt"))),
    'en-GB': ()=>(parcelRequire("78Q3c")),
    'en-ZZ': ()=>(parcelRequire("1bED2")),
    es: ()=>(parcelRequire("7qcoz")),
    fi: ()=>(parcelRequire("aruDH")),
    fr: ()=>(parcelRequire("ebEFX")),
    hu: ()=>(parcelRequire("j1P3i")),
    it: ()=>(parcelRequire("96lDB")),
    ja: ()=>(parcelRequire("7xpIz")),
    ko: ()=>(parcelRequire("kDdpi")),
    nb: ()=>(parcelRequire("furxn")),
    nl: ()=>(parcelRequire("1xorX")),
    pl: ()=>(parcelRequire("a8BIS")),
    'pt-BR': ()=>(parcelRequire("2L1sx")),
    ru: ()=>(parcelRequire("ctn08")),
    sv: ()=>(parcelRequire("abBcf")),
    th: ()=>(parcelRequire("9XDV4")),
    tr: ()=>(parcelRequire("7p3hh")),
    uk: ()=>(parcelRequire("gqOnY")),
    vi: ()=>(parcelRequire("gMVzI")),
    zh: ()=>(parcelRequire("fnG5V")),
    'zh-TW': ()=>(parcelRequire("d3dgL"))
};


const $62d8f7e2bf3ae1c6$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $d7827ca4fe42bedf$export$3770c7a7737d463c) ? locale : locale.replace(/-/g, '_') in (0, $d7827ca4fe42bedf$export$3770c7a7737d463c) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $d7827ca4fe42bedf$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $9bYqt.default);
    } catch (e) {
    // ignore
    }
    return 0, $9bYqt.default;
};


















var $I7hWB = parcelRequire("I7hWB");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");







const $f40e5e073a099109$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorStateHeading: {
        id: "navigation.global-invite.error-state-heading",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: "navigation.global-invite.error-state-description",
        defaultMessage: "Try refreshing the page or contact us if the problem persists."
    }
});


const $07d827fb36a0f134$var$styles = (0, $buxP3.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
const $07d827fb36a0f134$export$c1ed4f415b9e7023 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorState() {
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateHeading);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateDescription);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
            size: "small",
            color: "color.text.subtle"
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.Stack), {
            space: "space.050",
            testId: "global-invite--error-state",
            xcss: $07d827fb36a0f134$var$styles
        }, t1, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function ErrorState() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.Stack), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $07d827fb36a0f134$var$styles
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateHeading)), /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateDescription)));
};
























var $a9aSv = parcelRequire("a9aSv");


var $9GVkD = parcelRequire("9GVkD");




const $c8d51695e79dec85$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "navigation.global-invite.loading-visually-hidden-label",
        defaultMessage: "Loading"
    }
});


const $4a6133b8f42476bc$var$styles = (0, $buxP3.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
const $4a6133b8f42476bc$export$62aa48085237e36f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingState() {
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = Array.from({
            length: 5
        }, $4a6133b8f42476bc$var$_temp);
        $[0] = t0;
    } else t0 = $[0];
    const items = t0;
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $c8d51695e79dec85$export$defe85febe8b728c).loadingLabel);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.Stack), {
            space: "space.100",
            testId: "skeleton-group"
        }, items);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $4a6133b8f42476bc$var$styles,
            testId: "global-invite--loading-state"
        }, t2, t3);
        $[6] = t2;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function LoadingState() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering",
            key: index
        }));
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $4a6133b8f42476bc$var$styles,
        testId: "global-invite--loading-state"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, formatMessage((0, $c8d51695e79dec85$export$defe85febe8b728c).loadingLabel)), /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.Stack), {
        space: "space.100",
        testId: "skeleton-group"
    }, items));
};
function $4a6133b8f42476bc$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: "100%",
        height: "var(--ds-space-200, 16px)",
        testId: "skeleton-shimmering",
        key: index
    });
}


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $852mP = parcelRequire("852mP");





var $ad7Ou = parcelRequire("ad7Ou");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");

const $ec4769fe605d5191$export$bb76aeb9f599715c = 'global-invite';
const $ec4769fe605d5191$export$7622d28bacf170d1 = 'modal-dialog';
const $ec4769fe605d5191$export$1dab7caa4b20a4cc = 'trigger-element';
const $ec4769fe605d5191$export$85183a312807388d = 'navigation';


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag */ 



var $jpjVJ = parcelRequire("jpjVJ");

function $11f1795bb9e02885$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $jpjVJ.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        }
    }, children);
}





const $65fb141c89aa0f68$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalDialogLabel: {
        id: "navigation.global-invite.modal-dialog-label",
        defaultMessage: "Invite people"
    }
});


function $87f81968be2f8255$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $ec4769fe605d5191$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $cozmU.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $cozmU.useState)(false);
        const openModalDialog = (0, $cozmU.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $ec4769fe605d5191$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $cozmU.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $cozmU.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $ec4769fe605d5191$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $cozmU.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $ec4769fe605d5191$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $cozmU.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ $cozmU.createElement((0, $11f1795bb9e02885$export$804bcbe0913c6ba3), {
            product: props.product
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId
        }, TriggerElement ? /*#__PURE__*/ $cozmU.createElement(TriggerElement, {
            onClick: openModalDialog
        }) : /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            shouldFitContainer: true,
            onClick: openModalDialog,
            testId: `${testId}--${(0, $ec4769fe605d5191$export$1dab7caa4b20a4cc)}`
        }, children), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isModalDialogOpen ? // eslint-disable-next-line @atlaskit/design-system/no-modal-label
        /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            width: "small",
            shouldScrollInViewport: true,
            shouldReturnFocus: true,
            onClose: onCancel,
            onOpenComplete: focusDialog,
            label: formatMessage((0, $65fb141c89aa0f68$export$defe85febe8b728c).modalDialogLabel),
            testId: `${testId}--${(0, $ec4769fe605d5191$export$7622d28bacf170d1)}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement(Content, {
            onAdminMenuItemClick: onAdminMenuItemClick,
            onCancel: onCancel,
            onInviteCompleted: onInviteCompleted,
            ...props
        }))) : null)));
    };
}



const $f329be46c63c86a6$var$LazyGlobalInviteModalDialogContentWithRelayProvider = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jDSaY")).then((module)=>({
            default: module.ModalDialogContentWithRelayProvider
        })));
const $f329be46c63c86a6$var$AsyncGlobalInviteModalDialogContentWithRelayProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $07d827fb36a0f134$export$c1ed4f415b9e7023), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4a6133b8f42476bc$export$62aa48085237e36f), null);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        const modalContent = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: t1
        }, /*#__PURE__*/ $cozmU.createElement($f329be46c63c86a6$var$LazyGlobalInviteModalDialogContentWithRelayProvider, props)));
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $64VTj.default), {
            defaultMessages: (0, $9bYqt.default),
            loaderFn: (0, $62d8f7e2bf3ae1c6$export$e4882a930a0d91f2)
        }, modalContent);
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const modalContent = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $07d827fb36a0f134$export$c1ed4f415b9e7023), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $4a6133b8f42476bc$export$62aa48085237e36f), null)
    }, /*#__PURE__*/ $cozmU.createElement($f329be46c63c86a6$var$LazyGlobalInviteModalDialogContentWithRelayProvider, props)));
    return /*#__PURE__*/ $cozmU.createElement((0, $64VTj.default), {
        defaultMessages: (0, $9bYqt.default),
        loaderFn: (0, $62d8f7e2bf3ae1c6$export$e4882a930a0d91f2)
    }, modalContent);
};
const $f329be46c63c86a6$export$73b6b212789f5472 = (0, $87f81968be2f8255$export$2d7d84d397d9a585)($f329be46c63c86a6$var$AsyncGlobalInviteModalDialogContentWithRelayProvider);




// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $i834V = parcelRequire("i834V");




var $b3j2Y = parcelRequire("b3j2Y");





var $hSqtY = parcelRequire("hSqtY");


var $1uFM6 = parcelRequire("1uFM6");





var $7aRa9 = parcelRequire("7aRa9");


var $jFFx4 = parcelRequire("jFFx4");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $de2j9 = parcelRequire("de2j9");


var $jmjWc = parcelRequire("jmjWc");


const $f92bf53981932d65$export$347b3004b45f815 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "x9Mbz",
    name: "AdminNavigationLoader",
    loader: async ()=>(await (parcelRequire("hebSF"))).AdminNavigation
});












var $f922E = parcelRequire("f922E");








var $5avUB = parcelRequire("5avUB");





var $gmhHk = parcelRequire("gmhHk");

var $4X3mP = parcelRequire("4X3mP");


var $huaOC = parcelRequire("huaOC");





var $dVkip = parcelRequire("dVkip");





var $iKskQ = parcelRequire("iKskQ");


var $bQm3c = parcelRequire("bQm3c");





var $hXDOc = parcelRequire("hXDOc");














var $eKMV3 = parcelRequire("eKMV3");


var $cJ0FD = parcelRequire("cJ0FD");





var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");




var $b2d926c5e3ae50ad$exports = {};
$b2d926c5e3ae50ad$exports = new URL("starred-spaces-empty-state.8df4e846.svg", import.meta.url).toString();


var $950be737651a4af5$exports = {};
$950be737651a4af5$exports = new URL("starred-spaces-empty-state-dark.a60ed5cc.svg", import.meta.url).toString();


const $4a3f9d0dfa2492b5$var$SOURCE = 'starredSpacesEmptyState';
const $4a3f9d0dfa2492b5$var$styles = {
    emptyState: "_0bjKvD8fU6 _0KLXrunmFW _39xV02N91d",
    emptyStateContent: "_39xV02N91d",
    emptyStateIcon: "_4bt5LAYvD1 _2WAcuGYvD1 _3YEZNOdnbC _0jFU0VUofl _1mT5xdRAKS _39xV02Uofl",
    emptyStateImage: "_0jFU0VcGqM _3OE6xYdnbC _1mT5xdWVPG _2IhTon5UaJ _39xV02kouU",
    emptyStateText: "_2O5Vij7dHp _4ouGXIdnbC",
    emptyStateAction: "_39xV02N91d"
};
const $4a3f9d0dfa2492b5$var$i18n = (0, $kSwu1.defineMessages)({
    emptyStateExploreSpacesDescription: {
        id: "side-navigation.starred-spaces-list.empty-state-explore-spaces-description",
        defaultMessage: "Star spaces to keep them here for quick access."
    },
    exploreSpaces: {
        id: "side-navigation.starred-spaces-list.empty-state-explore-spaces",
        defaultMessage: "Explore spaces"
    }
});
const $4a3f9d0dfa2492b5$export$3f0aa198e68feb23 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { onExploreSpacesClick: onExploreSpacesClick } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "starredSpacesEmptyStateScreen",
                    source: $4a3f9d0dfa2492b5$var$SOURCE,
                    attributes: {
                        navVersion: "4"
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent
        ];
        $[0] = createAnalyticsEvent;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateImage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b2d926c5e3ae50ad$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($950be737651a4af5$exports))),
            alt: "",
            height: "39px",
            width: "41px"
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.200",
            shouldWrap: false,
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateContent
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4a3f9d0dfa2492b5$var$i18n.emptyStateExploreSpacesDescription))));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $1NBp8.SPACE_DIRECTORY).toUrl();
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== intl) {
        t6 = intl.formatMessage($4a3f9d0dfa2492b5$var$i18n.exploreSpaces);
        $[6] = intl;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== onExploreSpacesClick || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: "space.150",
            paddingInline: "space.150",
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "center",
            space: "space.100"
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateAction
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            spacing: "compact",
            shouldFitContainer: true,
            href: t5,
            onClick: onExploreSpacesClick
        }, t6))));
        $[8] = onExploreSpacesClick;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
};

















const $60de7f0fe776e4b8$export$a6ddf69d627430ea = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.075",
            paddingInlineStart: "space.075",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};


const $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics = (createAnalyticsEvent, navVersion, options = {})=>{
    const { componentType: componentType, itemId: itemId, itemType: itemType, section: section } = options;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'spacesNavigationMenuItem',
            source: 'globalNavigation',
            attributes: {
                navigationLayer: 'global',
                navigationContainer: 'sidebar',
                navVersion: navVersion,
                componentType: componentType,
                itemId: itemId,
                itemType: itemType,
                section: section
            }
        }
    }).fire();
};
const $38b2da651c37b412$var$StarredSpacesListComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { flags: flags } = t0;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== isLicensed) {
        t1 = {
            isLicensed: isLicensed
        };
        $[0] = isLicensed;
        $[1] = t1;
    } else t1 = $[1];
    const { starredSpaces: starredSpaces, error: error, loading: loading } = (0, $dVkip.useStarredData)(t1);
    const isStarredSpacesEmpty = !loading && starredSpaces.length === 0;
    let t2;
    if ($[2] !== isStarredSpacesEmpty) {
        t2 = isStarredSpacesEmpty && (0, $6mKj3.expVal)("cc_mohiti_nav_empty_states", "isEnabled", false);
        $[2] = isStarredSpacesEmpty;
        $[3] = t2;
    } else t2 = $[3];
    const isMohitiEmptyStateEnabled = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent) {
        t3 = ()=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "fixedItem",
                itemId: "viewAllSpaces",
                section: "starredSpaces"
            });
        };
        $[4] = createAnalyticsEvent;
        $[5] = t3;
    } else t3 = $[5];
    const onViewAllClick = t3;
    let t4;
    if ($[6] !== createAnalyticsEvent) {
        t4 = ()=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "fixedItem",
                itemId: "exploreSpaces",
                section: "starredSpaces"
            });
        };
        $[6] = createAnalyticsEvent;
        $[7] = t4;
    } else t4 = $[7];
    const onExploreSpacesClick = t4;
    let t5;
    if ($[8] !== createAnalyticsEvent) {
        t5 = (spaceId)=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "customItem",
                itemType: "space",
                itemId: spaceId,
                section: "starredSpaces"
            });
        };
        $[8] = createAnalyticsEvent;
        $[9] = t5;
    } else t5 = $[9];
    const onStarredSpaceItemClick = t5;
    let t6;
    let t7;
    if ($[10] !== error || $[11] !== flags || $[12] !== loading) {
        t6 = ()=>{
            if (!loading && error) flags.showErrorFlag({
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
        };
        t7 = [
            loading,
            error,
            flags
        ];
        $[10] = error;
        $[11] = flags;
        $[12] = loading;
        $[13] = t6;
        $[14] = t7;
    } else {
        t6 = $[13];
        t7 = $[14];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4X3mP.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.title));
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== loading) {
        t9 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60de7f0fe776e4b8$export$a6ddf69d627430ea), null);
        $[16] = loading;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== intl || $[19] !== isMohitiEmptyStateEnabled || $[20] !== isStarredSpacesEmpty || $[21] !== onExploreSpacesClick) {
        t10 = isStarredSpacesEmpty && (isMohitiEmptyStateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a3f9d0dfa2492b5$export$3f0aa198e68feb23), {
            onExploreSpacesClick: onExploreSpacesClick
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: "space.100",
            xcss: $38b2da651c37b412$var$emptySpacesTextStyles
        }, intl.formatMessage($38b2da651c37b412$var$i18n.empty)));
        $[18] = intl;
        $[19] = isMohitiEmptyStateEnabled;
        $[20] = isStarredSpacesEmpty;
        $[21] = onExploreSpacesClick;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== loading || $[24] !== onStarredSpaceItemClick || $[25] !== starredSpaces) {
        t11 = !loading && starredSpaces && starredSpaces.map((space)=>{
            const spaceAlias = space.alias || space.key;
            const url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                spaceKey: spaceAlias
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
                key: space.id,
                name: "starred-spaces",
                preloadUrl: url,
                preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                key: space.id,
                href: url,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKskQ.SpaceIcon), {
                    size: "xsmall",
                    src: space.icon?.path
                }),
                onClick: ()=>onStarredSpaceItemClick(space.id)
            }, space.name));
        });
        $[23] = loading;
        $[24] = onStarredSpaceItemClick;
        $[25] = starredSpaces;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== isMohitiEmptyStateEnabled || $[28] !== isStarredSpacesEmpty || $[29] !== loading || $[30] !== onViewAllClick) {
        t12 = !loading && (!isMohitiEmptyStateEnabled || !isStarredSpacesEmpty) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_DIRECTORY).toUrl(),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onViewAllClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.viewAll));
        $[27] = isMohitiEmptyStateEnabled;
        $[28] = isStarredSpacesEmpty;
        $[29] = loading;
        $[30] = onViewAllClick;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmhHk.MenuSection), null, t8, t9, t10, t11, t12);
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
        $[35] = t9;
        $[36] = t13;
    } else t13 = $[36];
    return t13;
};
const $38b2da651c37b412$export$79ffca654f6ab234 = (0, $7aRa9.withFlags)($38b2da651c37b412$var$StarredSpacesListComponent);
const $38b2da651c37b412$var$emptySpacesTextStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small'
});
const $38b2da651c37b412$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "side-navigation.starred-spaces-list.title",
        defaultMessage: "Starred spaces"
    },
    viewAll: {
        id: "side-navigation.starred-spaces-list.view-all",
        defaultMessage: "View all spaces"
    },
    empty: {
        id: "side-navigation.starred-spaces-list.empty-message",
        defaultMessage: "Spaces you star will appear here"
    },
    errorFlagTitle: {
        id: "side-navigation.starred-spaces-list.error-flag-title",
        defaultMessage: "We couldn\u2019t load starred spaces"
    },
    errorFlagDescription: {
        id: "side-navigation.starred-spaces-list.error-flag-description",
        defaultMessage: "We are unable to show your spaces at this time. Refresh the page or try again."
    }
});






const $4ad4ea954990a797$export$9c64eb3c7e74d13c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zC56Y",
    loader: async ()=>(await (parcelRequire("gx8UM"))).HubSettingsNavigation,
    name: 'HubSettingsNavigation'
});


















var $kThSt = parcelRequire("kThSt");





var $feuG2 = parcelRequire("feuG2");


var $cLo2u = parcelRequire("cLo2u");

const $5a5cd25c242b4596$var$SpaceAdminNavigationInternal = ()=>{
    const $ = (0, $bDgLe.c)(13);
    const spaceAlias = (0, $cLo2u.useSpaceKey)();
    const isCollapsed = (0, $kThSt.useIsSideNavCollapsed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { location: location, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const t0 = location?.pathname || "";
    let t1;
    if ($[0] !== matchRoute || $[1] !== t0) {
        t1 = matchRoute(t0);
        $[0] = matchRoute;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const route = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== isCollapsed || $[5] !== route?.name) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "spaceAdminSideNavigation",
                    attributes: {
                        tab: route?.name || "",
                        isVisible: !isCollapsed
                    }
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = isCollapsed;
        $[5] = route?.name;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = route?.name;
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== isCollapsed || $[9] !== t3) {
        t4 = [
            createAnalyticsEvent,
            isCollapsed,
            t3
        ];
        $[7] = createAnalyticsEvent;
        $[8] = isCollapsed;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    (0, $cozmU.useEffect)(t2, t4);
    const t5 = spaceAlias || "";
    let t6;
    if ($[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $feuG2.SpaceSettingsSideNavigation), {
            spaceAlias: t5
        });
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};
const $5a5cd25c242b4596$export$a5608b5e4da20698 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a5cd25c242b4596$var$SpaceAdminNavigationInternal, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $7boqA = parcelRequire("7boqA");


var $1uFsv = parcelRequire("1uFsv");


const $4ccde8579962336f$var$GlobalNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6E8ob",
    name: "GlobalNavigationLoader",
    loader: async ()=>(await (parcelRequire("ciI1q"))).GlobalNavigationComponent
});
const $4ccde8579962336f$export$796d3395e4dcf32b = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ccde8579962336f$var$GlobalNavigationLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};



var $2qRJj = parcelRequire("2qRJj");


var $dJFqB = parcelRequire("dJFqB");


var $l65Bo = parcelRequire("l65Bo");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");





var $cEgMD = parcelRequire("cEgMD");





var $hQnHK = parcelRequire("hQnHK");








var $1xpoY = parcelRequire("1xpoY");


var $euozR = parcelRequire("euozR");








var $l3wuH = parcelRequire("l3wuH");


var $4ez2K = parcelRequire("4ez2K");


var $1sCHt = parcelRequire("1sCHt");







const $ba0fa5890838b7bb$export$ee8ecac8c80214c1 = ()=>{
    const [closedMessage, setClosedMessage] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    (0, $cozmU.useEffect)(()=>{
        if (closedMessage) setClosedMessage(false);
    // Should only fire when spaceKey changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    if (closedMessage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        testId: "anonymous-access-side-nav-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ba0fa5890838b7bb$var$i18n.anonymousAccessMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: ()=>setClosedMessage(true),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage($ba0fa5890838b7bb$var$i18n.close),
        appearance: "subtle",
        spacing: "compact"
    })));
};
const $ba0fa5890838b7bb$var$i18n = (0, $kSwu1.defineMessages)({
    anonymousAccessMessage: {
        id: "anonymous-access.anonymous-access-side-nav-message.text",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        /* oxlint-disable-next-line eslint-core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You\u2018re viewing this with anonymous access, so some content might be blocked."
    },
    close: {
        id: "anonymous-access.anonymous-access-side-nav-message.close",
        defaultMessage: "Close"
    }
});



var $gsSsC = parcelRequire("gsSsC");

/**
 * @generated SignedSource<<5ec95094f4eaf95b6ea6233997fc4ccb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6195faf897db3ea9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsUserViewingSpaceAsAnon_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isAnonymouslyAuthorized"
                }
            ]
        }
    ],
    "type": "Space"
};
$6195faf897db3ea9$var$node.hash = "af78d76c454aa1c9a6bc480bc1d76f7a";
var $6195faf897db3ea9$export$2e2bcd8739ae039 = $6195faf897db3ea9$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $da0a91219ee54603$export$48298ef379a0676f = (0, $6195faf897db3ea9$export$2e2bcd8739ae039);
const $da0a91219ee54603$export$b1d9964175452d0b = ({ spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $gsSsC.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skipQuery || !spaceKey,
        __callerPackage__: "anonymous-access"
    });
    // For restricted spaces the preloader's query returns a 403 which Apollo evicts from
    // its cache. This leaves `useQueryInterop` in a perpetual `loading: true` state during
    // SSR, while on the client the same query resolves with `loading: false` and
    // `space: null`. The resulting mismatch causes a hydration error in the SideNav footer.
    //
    // The preloader detects this case and persists the space key in a global
    // (`__RESTRICTED_SPACES_FROM_PRELOAD__`). When present, we short-circuit here so both
    // SSR and client agree on `{ loading: false, isUserViewingSpaceAsAnon: false }`.
    const restrictedSpaces = typeof window !== 'undefined' ? window.__RESTRICTED_SPACES_FROM_PRELOAD__ : globalThis.__RESTRICTED_SPACES_FROM_PRELOAD__;
    if (restrictedSpaces?.[spaceKey]) return {
        isUserViewingSpaceAsAnon: false,
        loading: false,
        error: undefined
    };
    return {
        isUserViewingSpaceAsAnon: Boolean(data?.space?.currentUser?.isAnonymouslyAuthorized),
        loading: loading,
        error: error
    };
};
const $da0a91219ee54603$export$7e928e8d9b707669 = ({ spaceKey: spaceKey, spaceFragmentRef: spaceFragmentRef })=>{
    const space = (0, $6SsN4.useFragment)($da0a91219ee54603$export$48298ef379a0676f, spaceFragmentRef);
    const restrictedSpaces = window.__RESTRICTED_SPACES_FROM_PRELOAD__;
    return {
        isUserViewingSpaceAsAnon: restrictedSpaces?.[spaceKey] ? false : Boolean(space.currentUser?.isAnonymouslyAuthorized),
        loading: false,
        error: undefined
    };
};



/**
 * @generated SignedSource<<b48ad5572e4ea5894a5dcaf2de279ab8>>
 * @relayHash a912afe2fbea3fe5bd99ea14ca3598df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b
const $068b1fe48e1495bf$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "licenseConsumingUserCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a912afe2fbea3fe5bd99ea14ca3598df",
            "id": "80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b",
            "metadata": {},
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "operationKind": "query",
            "text": "query usePersistentInviteButtonEligibleLicenseDetailsQuery{license{licenseConsumingUserCount,trialEndDate}}"
        }
    };
}();
$068b1fe48e1495bf$var$node.hash = "ba822387cdd604c4581f577b0c57ca7a";
var $068b1fe48e1495bf$export$2e2bcd8739ae039 = $068b1fe48e1495bf$var$node;









var $2Zz3q = parcelRequire("2Zz3q");





var $8Lx5S = parcelRequire("8Lx5S");





var $euL71 = parcelRequire("euL71");


var $dPJCf = parcelRequire("dPJCf");





var $BrMrN = parcelRequire("BrMrN");

/**
 * @generated SignedSource<<9b094bbcdda2f46307c7cfbcad678225>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8787de172edc7fd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PersistentInviteEligibleQuery_license",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "licenseConsumingUserCount"
        },
        {
            "kind": "ScalarField",
            "name": "trialEndDate"
        }
    ],
    "type": "License"
};
$e8787de172edc7fd$var$node.hash = "8efb7d4229974be7992fd55823652fe0";
var $e8787de172edc7fd$export$2e2bcd8739ae039 = $e8787de172edc7fd$var$node;


/**
 * @generated SignedSource<<125d69e295fbdfeaa53769e17d7e0ac0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9e3909e4c150e334$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PersistentInviteEligibleQuery_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isAnonymouslyAuthorized"
                }
            ]
        }
    ],
    "type": "Space"
};
$9e3909e4c150e334$var$node.hash = "a7c9c234a13381dbf5bbe25ee1058d5f";
var $9e3909e4c150e334$export$2e2bcd8739ae039 = $9e3909e4c150e334$var$node;


const $8f090db6c0dc0794$export$ee318b4fd2ba55c2 = (0, $9e3909e4c150e334$export$2e2bcd8739ae039);
const $8f090db6c0dc0794$export$1dfb39d259f37912 = (0, $e8787de172edc7fd$export$2e2bcd8739ae039);
const $8f090db6c0dc0794$export$6987d8916b4890c6 = (0, $BrMrN.default);


function $463b48fb68db8bff$export$b3cda0b328199f72() {
    return $463b48fb68db8bff$var$usePersistentInviteButtonEligibleInternal();
}
function $463b48fb68db8bff$export$34874fe08f3adc38({ licenseFragmentRef: licenseFragmentRef }) {
    const licenseData = (0, $6SsN4.useFragment)((0, $8f090db6c0dc0794$export$1dfb39d259f37912), licenseFragmentRef);
    return $463b48fb68db8bff$var$usePersistentInviteButtonEligibleInternal(licenseData);
}
function $463b48fb68db8bff$var$usePersistentInviteButtonEligibleInternal(routeLicenseData) {
    const { edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = (0, $8Lx5S.useIsLicensed)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const skipLicenseQuery = isFreeEdition || !isLoggedIn || (!(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_license_error_fix') ? !hasLicensedAccess : !isLicensed);
    const usesRouteData = routeLicenseData !== undefined;
    const { refetch: refetch, data: licenseDetailsData, loading: licenseDetailsLoading, error: licenseDetailsDataError } = (0, $jMyy4.useQueryInterop)((0, $068b1fe48e1495bf$export$2e2bcd8739ae039), {
        skip: skipLicenseQuery || usesRouteData,
        __callerPackage__: "persistent-invite-button"
    });
    const hasChildQueryData = licenseDetailsData != null;
    const licenseData = hasChildQueryData ? licenseDetailsData.license : routeLicenseData;
    const trialDaysLeft = (0, $2Zz3q.getTrialDaysLeftFromTrialEndDate)(licenseData?.trialEndDate);
    const isInTrial = (skipLicenseQuery || licenseData?.licenseConsumingUserCount == null) && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_license_error_fix') ? false : trialDaysLeft ? trialDaysLeft > 0 : false;
    // Sometimes, the trial end date is not set on the initial load for a new tenant, even though they have been put into a trial.
    // This can lead to the invite button not appearing. To mitigate this, we refetch the license details on page transition if we
    // suspect the user is in a trial, but the trial end date is null.
    const transitionId = (0, $dPJCf.useTransitionId)();
    const hasRefetched = (0, $cozmU.useRef)(false);
    const initialTransitionId = (0, $cozmU.useRef)(transitionId);
    (0, $cozmU.useEffect)(()=>{
        if (isInTrial || skipLicenseQuery || licenseDetailsLoading || licenseDetailsDataError) return;
        const trialSuspected = Boolean(licenseData?.trialEndDate === null && licenseData?.licenseConsumingUserCount === 1 && !isFreeEdition);
        if (!hasRefetched.current && trialSuspected && transitionId > initialTransitionId.current) {
            refetch();
            hasRefetched.current = true;
        }
    }, [
        edition,
        isFreeEdition,
        isInTrial,
        isLicensed,
        isLoggedIn,
        licenseData,
        licenseDetailsDataError,
        licenseDetailsLoading,
        refetch,
        skipLicenseQuery,
        transitionId
    ]);
    return {
        loading: usesRouteData && !hasChildQueryData ? false : licenseDetailsLoading,
        error: usesRouteData && !hasChildQueryData ? undefined : licenseDetailsDataError,
        isEligible: isInTrial || isFreeEdition
    };
}




var $7Sm4c = parcelRequire("7Sm4c");


var $9HB34 = parcelRequire("9HB34");













var $92JEG = parcelRequire("92JEG");


const $f542602a6e0f4176$export$4283c4ef2b834aa2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "USWMG",
    name: "Nav4CollapseReminderSpotlightLoader",
    loader: async ()=>(await (parcelRequire("6ZrZD"))).Nav4CollapseReminderSpotlight
});



var $4q9NN = parcelRequire("4q9NN");


var $gEtAQ = parcelRequire("gEtAQ");


var $b0EGa = parcelRequire("b0EGa");














const $95859b7288e22ff6$var$PlatformNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xsgSo",
    name: "PlatformNavigationLoader",
    loader: async ()=>(await (parcelRequire("kSYYC"))).PlatformNavigationComponent
});
const $95859b7288e22ff6$export$446e292f3fdcabd = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95859b7288e22ff6$var$PlatformNavigationLoader, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};



var $hrvfP = parcelRequire("hrvfP");











var $i3jcY = parcelRequire("i3jcY");








var $3jwuS = parcelRequire("3jwuS");










const $e486084baed62696$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $e486084baed62696$export$7b73ec245f6c47f8 = ()=>{
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const showRecap2025QueryParam = $e486084baed62696$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isEditorPage;
    // Check if user has already collapsed the sidebar for recap before
    const hasCollapsedBefore = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED) === 'true';
    const shouldCollapse = isEligible && !hasCollapsedBefore;
    // Set the persisted flag when we determine we should collapse
    // This marks that the user has seen this behavior (first visit)
    (0, $cozmU.useEffect)(()=>{
        if (shouldCollapse && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED, 'true');
    }, [
        shouldCollapse
    ]);
    return shouldCollapse;
};



var $1P7Cq = parcelRequire("1P7Cq");




const $1b5aa9dc12e56400$export$444990cc7caeb4e0 = 320;
const $1b5aa9dc12e56400$export$6deddaa54d32585b = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const shouldCollapseForRecap = (0, $e486084baed62696$export$7b73ec245f6c47f8)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = !userId;
    if ((0, $i3jcY.isStableUIEnabledForTests)()) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                initialCollapsedState: "expanded",
                initialWidth: $1b5aa9dc12e56400$export$444990cc7caeb4e0,
                shouldForceExpand: true,
                needsPostHydrationCollapse: false
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? "expanded";
        $[1] = t0;
    } else t0 = $[1];
    const persistedCollapseState = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH) || $1b5aa9dc12e56400$export$444990cc7caeb4e0;
        $[2] = t1;
    } else t1 = $[2];
    let persistedWidth = parseInt(t1, 10);
    if (Number.isNaN(persistedWidth)) persistedWidth = $1b5aa9dc12e56400$export$444990cc7caeb4e0;
    const isWidthTooLarge = persistedWidth > window.innerWidth;
    const fittedSidebarWidth = isWidthTooLarge ? $1b5aa9dc12e56400$export$444990cc7caeb4e0 : persistedWidth;
    if (isAnonymousUser && renderServerPlaceholder) {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                initialCollapsedState: "expanded",
                initialWidth: fittedSidebarWidth,
                shouldForceExpand: false,
                needsPostHydrationCollapse: persistedCollapseState === "collapsed"
            };
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let initialCollapsedState;
    if (shouldCollapseForRecap) initialCollapsedState = "collapsed";
    else initialCollapsedState = persistedCollapseState;
    let t2;
    if ($[4] !== initialCollapsedState) {
        t2 = {
            initialCollapsedState: initialCollapsedState,
            initialWidth: fittedSidebarWidth,
            shouldForceExpand: false,
            needsPostHydrationCollapse: false
        };
        $[4] = initialCollapsedState;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};





// Paths
const $ba0a4d7f1b78ed67$export$4b542de2568592b5 = 'container/home/loading';
const $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae = 'container/home';
const $ba0a4d7f1b78ed67$export$c3f826fbea17177 = 'container/admin/home';
const $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1 = 'admin/home';
const $ba0a4d7f1b78ed67$export$823dfce5c2bceecb = 'product/home';


const $ad0ecba6dc7e91fa$export$ccd8c615ba434dec = ({ view: view })=>{
    const pageTreeUpdater = (0, $cozmU.useRef)();
    const scrollTree = (0, $cozmU.useCallback)(()=>{
        if (view === (0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae) && pageTreeUpdater.current) pageTreeUpdater.current.scrollToCurrentPage();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        view,
        pageTreeUpdater.current
    ]);
    return {
        pageTreeUpdater: pageTreeUpdater,
        scrollTree: scrollTree
    };
};










var $eGUIL = parcelRequire("eGUIL");




const $b524a1c7212bd91f$export$fc95973351613945 = ({ children: children })=>{
    const sideNavRef = (0, $cozmU.useRef)(null);
    const handleScrollToTop = (0, $cozmU.useCallback)(()=>{
        if (sideNavRef.current) sideNavRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        sideNavRef
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            sideNavRef: sideNavRef,
            handleScrollToTop: handleScrollToTop
        }), [
        sideNavRef,
        handleScrollToTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eGUIL.SideNavigationContext).Provider, {
        value: contextValue
    }, (0, $9wGTI.fg)('navx-global-side-nav-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        sideNavContentRef: sideNavRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavBody), {
        testId: "side-navigation-content",
        ref: sideNavRef
    }, children));
};


const $b56ca6efd7e1c0fa$var$i18n = (0, $kSwu1.defineMessages)({
    dragHandle: {
        id: "page-layout.side-navigation.drag-handle",
        defaultMessage: "Side Navigation Drag Handle"
    },
    sideNavPanelSplitterTooltipContent: {
        id: "page-layout.side-navigation.side-nav-panel-splitter-tooltip-content",
        defaultMessage: "Double click to collapse"
    },
    globalInviteButtonLabel: {
        id: "page-layout.side-navigation.global-invite-button-label",
        defaultMessage: "Invite people"
    }
});
const $b56ca6efd7e1c0fa$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
}; /**
    * Used when the built-in ADS side nav interactions are enabled.
    * Uses the `Ctrl+[` shortcut that is built into the ADS navigation system, instead of Confluence's
    * own `Ctrl+[` shortcut (UNIVERSAL_SIDE_NAVIGATION_SHORTCUT).
    * But, we keep Confluence's `[` shortcut (SIDE_NAVIGATION_SHORTCUT) on non-edit routes, and display
    * an educational flag pointing to the new shortcut.
    */ 
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS = (0, $7aRa9.withFlags)(({ flags: flags, onToggleFromShortcut: onToggleFromShortcut })=>{
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    const toggleSideNav = (0, $jYwSK.useToggleSideNav)();
    const toggle = (0, $cozmU.useCallback)(()=>{
        if (!(0, $l65Bo.isDialogShown)()) {
            onToggleFromShortcut();
            toggleSideNav(); // Show the educational flag for the `Ctrl+[` shortcut, when the `[` shortcut is used.
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
                accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT)
            });
        }
    }, [
        flags,
        onToggleFromShortcut,
        toggleSideNav
    ]);
    if (isEditorOpen) // Edit routes will still have the side nav shortcut that is built into the ADS SideNav component.
    return null;
     // Non-edit routes still have the `[` shortcut, which will eventually be deprecated.
    // An educational flag is shown during the transition process.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    });
});
const $b56ca6efd7e1c0fa$var$useIsModeGlobal = ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== match?.query?.mode || $[1] !== spaceKey) {
        t0 = match?.query?.mode === "global" || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[0] = match?.query?.mode;
        $[1] = spaceKey;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}; //todo: are all these views still relevant? I'm not certain they are
const $b56ca6efd7e1c0fa$var$getProductSideNavigation = (view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, unhandledError, isLicensed)=>{
    // hide product nav if mode=global unless we're on a settings page
    if (isModeGlobal && !isOnAnySettingsScreen) return null;
    switch(view){
        case 0, $ba0a4d7f1b78ed67$export$4b542de2568592b5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null);
        case 0, $ba0a4d7f1b78ed67$export$c3f826fbea17177:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a5cd25c242b4596$export$a5608b5e4da20698), null);
        case 0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ad4ea954990a797$export$9c64eb3c7e74d13c), null);
        case 0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f92bf53981932d65$export$347b3004b45f815), null);
        case 0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qRJj.SpaceNavigation), {
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                ...unhandledError && {
                    unhandledError: unhandledError
                },
                isBlogNavigation: (0, $gEtAQ.isBlogPage)()
            });
        default:
            return isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38b2da651c37b412$export$79ffca654f6ab234), null) : null;
    }
};
const $b56ca6efd7e1c0fa$var$ConfluenceRelayEnvironmentBoundary = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    if (!(0, $9wGTI.fg)("navx-confluence-product-nav-relay-boundary")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9HB34.getRelayEnvironment)();
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t1
        }, children);
        $[3] = children;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
// that prop by reference, and a fresh element re-renders the navigation tree (COPPER-1474).
const $b56ca6efd7e1c0fa$var$postOfficeSideNavPlacement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i834V.PostOfficeConfluenceSideNavPlacement), null);
const $b56ca6efd7e1c0fa$var$PlatformNavigationInner = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const affordanceData = (0, $dJFqB.useSpaceNavigationAffordanceData)();
    let t0;
    if ($[0] !== affordanceData || $[1] !== props || $[2] !== spaceKey) {
        t0 = affordanceData?.spaceFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$RouteBackedPlatformNavigationInner, {
            ...props,
            spaceKey: spaceKey || "",
            spaceFragmentRef: affordanceData.spaceFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$LegacyPlatformNavigationInner, {
            ...props,
            spaceKey: spaceKey || ""
        });
        $[0] = affordanceData;
        $[1] = props;
        $[2] = spaceKey;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
const $b56ca6efd7e1c0fa$var$RouteBackedPlatformNavigationInner = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let props;
    let spaceFragmentRef;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, spaceFragmentRef: spaceFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = spaceFragmentRef;
        $[3] = spaceKey;
    } else {
        props = $[1];
        spaceFragmentRef = $[2];
        spaceKey = $[3];
    }
    let t1;
    if ($[4] !== spaceFragmentRef || $[5] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey,
            spaceFragmentRef: spaceFragmentRef
        };
        $[4] = spaceFragmentRef;
        $[5] = spaceKey;
        $[6] = t1;
    } else t1 = $[6];
    const anonymousAccessEligibility = (0, $da0a91219ee54603$export$7e928e8d9b707669)(t1);
    let t2;
    if ($[7] !== anonymousAccessEligibility || $[8] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$PlatformNavigationInnerLayout, {
            ...props,
            anonymousAccessEligibility: anonymousAccessEligibility
        });
        $[7] = anonymousAccessEligibility;
        $[8] = props;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
const $b56ca6efd7e1c0fa$var$LegacyPlatformNavigationInner = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let props;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = spaceKey;
    } else {
        props = $[1];
        spaceKey = $[2];
    }
    let t1;
    if ($[3] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    const anonymousAccessEligibility = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t1);
    let t2;
    if ($[5] !== anonymousAccessEligibility || $[6] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$PlatformNavigationInnerLayout, {
            ...props,
            anonymousAccessEligibility: anonymousAccessEligibility
        });
        $[5] = anonymousAccessEligibility;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $b56ca6efd7e1c0fa$var$PlatformNavigationInnerLayout = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, anonymousAccessEligibility: anonymousAccessEligibility } = t0;
    let t1;
    if ($[0] !== view) {
        t1 = {
            view: view
        };
        $[0] = view;
        $[1] = t1;
    } else t1 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t1);
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = anonymousAccessEligibility;
    let t2;
    if ($[2] !== anonymousAccessQueryError || $[3] !== isLicensed || $[4] !== isModeGlobal || $[5] !== isOnAnySettingsScreen || $[6] !== isSpaceSettingsScreen || $[7] !== view) {
        t2 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[2] = anonymousAccessQueryError;
        $[3] = isLicensed;
        $[4] = isModeGlobal;
        $[5] = isOnAnySettingsScreen;
        $[6] = isSpaceSettingsScreen;
        $[7] = view;
        $[8] = t2;
    } else t2 = $[8];
    const productSideNavigation = t2;
    let t3;
    if ($[9] !== productSideNavigation) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$ConfluenceRelayEnvironmentBoundary, null, productSideNavigation);
        $[9] = productSideNavigation;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hrvfP.ConnectorPromoSidebarEntry), {
            isNav4: true
        });
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== anonymousAccessQueryError || $[13] !== anonymousAccessQueryLoading || $[14] !== isUserViewingSpaceAsAnon) {
        t5 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba0fa5890838b7bb$export$ee8ecac8c80214c1), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[12] = anonymousAccessQueryError;
        $[13] = anonymousAccessQueryLoading;
        $[14] = isUserViewingSpaceAsAnon;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t3 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t5);
        $[16] = t3;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    const content = t6;
    let t7;
    if ($[19] !== content || $[20] !== isOnAnySettingsScreen || $[21] !== onCollapse || $[22] !== onExpand || $[23] !== onPeekEnd || $[24] !== onPeekStart || $[25] !== scrollTree) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "side-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95859b7288e22ff6$export$446e292f3fdcabd), {
            content: content,
            hideGSN: isOnAnySettingsScreen,
            scrollTreeToCurrent: scrollTree,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            bottomElem: (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? $b56ca6efd7e1c0fa$var$postOfficeSideNavPlacement : undefined
        })));
        $[19] = content;
        $[20] = isOnAnySettingsScreen;
        $[21] = onCollapse;
        $[22] = onExpand;
        $[23] = onPeekEnd;
        $[24] = onPeekStart;
        $[25] = scrollTree;
        $[26] = t7;
    } else t7 = $[26];
    return t7;
};
const $b56ca6efd7e1c0fa$var$SideNavigationInner = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const affordanceData = (0, $dJFqB.useSpaceNavigationAffordanceData)();
    let t0;
    if ($[0] !== affordanceData || $[1] !== props || $[2] !== spaceKey) {
        t0 = affordanceData?.spaceFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$RouteBackedSideNavigationInner, {
            ...props,
            spaceKey: spaceKey || "",
            spaceFragmentRef: affordanceData.spaceFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$LegacySideNavigationInner, {
            ...props,
            spaceKey: spaceKey || ""
        });
        $[0] = affordanceData;
        $[1] = props;
        $[2] = spaceKey;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
const $b56ca6efd7e1c0fa$var$RouteBackedSideNavigationInner = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let props;
    let spaceFragmentRef;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, spaceFragmentRef: spaceFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = spaceFragmentRef;
        $[3] = spaceKey;
    } else {
        props = $[1];
        spaceFragmentRef = $[2];
        spaceKey = $[3];
    }
    let t1;
    if ($[4] !== spaceFragmentRef || $[5] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey,
            spaceFragmentRef: spaceFragmentRef
        };
        $[4] = spaceFragmentRef;
        $[5] = spaceKey;
        $[6] = t1;
    } else t1 = $[6];
    const anonymousAccessEligibility = (0, $da0a91219ee54603$export$7e928e8d9b707669)(t1);
    let t2;
    if ($[7] !== anonymousAccessEligibility || $[8] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationInnerLayout, {
            ...props,
            anonymousAccessEligibility: anonymousAccessEligibility
        });
        $[7] = anonymousAccessEligibility;
        $[8] = props;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
const $b56ca6efd7e1c0fa$var$LegacySideNavigationInner = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let props;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = spaceKey;
    } else {
        props = $[1];
        spaceKey = $[2];
    }
    let t1;
    if ($[3] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    const anonymousAccessEligibility = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t1);
    let t2;
    if ($[5] !== anonymousAccessEligibility || $[6] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationInnerLayout, {
            ...props,
            anonymousAccessEligibility: anonymousAccessEligibility
        });
        $[5] = anonymousAccessEligibility;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $b56ca6efd7e1c0fa$var$SideNavigationInnerLayout = (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, setTriggeredByShortcut: setTriggeredByShortcut, anonymousAccessEligibility: anonymousAccessEligibility } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand, needsPostHydrationCollapse: needsPostHydrationCollapse } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jFFx4.useSettingsBackButtonUtils)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const toggleSideNav = (0, $jYwSK.useToggleSideNav)();
    const hasAppliedPostHydrationCollapse = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== needsPostHydrationCollapse || $[1] !== toggleSideNav) {
        t1 = ()=>{
            if (needsPostHydrationCollapse && !hasAppliedPostHydrationCollapse.current) {
                hasAppliedPostHydrationCollapse.current = true;
                toggleSideNav();
            }
        };
        t2 = [
            needsPostHydrationCollapse,
            toggleSideNav
        ];
        $[0] = needsPostHydrationCollapse;
        $[1] = toggleSideNav;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const pressTracing = (0, $1o3CH.default)("side-nav-collapse-reminder-spotlight");
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = anonymousAccessEligibility;
    const [t3] = (0, $kThSt.useSideNavigationCollapsedState)();
    const { isCollapsed: isCollapsed } = t3;
    let t4;
    if ($[4] !== anonymousAccessQueryError || $[5] !== isLicensed || $[6] !== isModeGlobal || $[7] !== isOnAnySettingsScreen || $[8] !== isSpaceSettingsScreen || $[9] !== view) {
        t4 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[4] = anonymousAccessQueryError;
        $[5] = isLicensed;
        $[6] = isModeGlobal;
        $[7] = isOnAnySettingsScreen;
        $[8] = isSpaceSettingsScreen;
        $[9] = view;
        $[10] = t4;
    } else t4 = $[10];
    const productSideNavigation = t4;
    let t5;
    if ($[11] !== createAnalyticsEvent) {
        t5 = (t6)=>{
            const { initialWidth: initialWidth_0, finalWidth: finalWidth } = t6;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "resized",
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        initialWidth: initialWidth_0,
                        finalWidth: finalWidth
                    }
                }
            }).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = t5;
    } else t5 = $[12];
    const fireSidebarResizeEndAnalytics = t5;
    let t6;
    if ($[13] !== setTriggeredByShortcut) {
        t6 = ()=>{
            setTriggeredByShortcut(true);
        };
        $[13] = setTriggeredByShortcut;
        $[14] = t6;
    } else t6 = $[14];
    const handleToggleFromShortcut = t6;
    if (!isPageWithinSpaceSettings && !isPageWithinSiteSettings && !isHubSettingsScreen) saveCurrentRoute();
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $92JEG.useHasDismissedNav4CollapseReminderSpotlight)();
    const canToggleWithShortcut = $b56ca6efd7e1c0fa$var$_temp;
    const t7 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            errorBoundaryId: "sideNavigation-globalNavigation"
        };
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== isCollapsed || $[17] !== isOnAnySettingsScreen || $[18] !== productSideNavigation) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t8
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ccde8579962336f$export$796d3395e4dcf32b), {
            productSideNavigation: productSideNavigation,
            isOnAnySettingsScreen: isOnAnySettingsScreen,
            isCollapsed: isCollapsed
        }));
        $[16] = isCollapsed;
        $[17] = isOnAnySettingsScreen;
        $[18] = productSideNavigation;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== isNav4CollapseReminderSpotlightActive || $[21] !== setIsNav4CollapseReminderSpotlightActive) {
        t10 = isNav4CollapseReminderSpotlightActive && setIsNav4CollapseReminderSpotlightActive && !(0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f542602a6e0f4176$export$4283c4ef2b834aa2), {
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[20] = isNav4CollapseReminderSpotlightActive;
        $[21] = setIsNav4CollapseReminderSpotlightActive;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== handleToggleFromShortcut || $[24] !== shouldForceExpand) {
        t11 = !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS, {
            onToggleFromShortcut: handleToggleFromShortcut
        });
        $[23] = handleToggleFromShortcut;
        $[24] = shouldForceExpand;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== fireSidebarResizeEndAnalytics || $[27] !== isNav4CollapseReminderSpotlightActive || $[28] !== isNav4CollapseReminderSpotlightDismissed || $[29] !== pressTracing || $[30] !== setIsNav4CollapseReminderSpotlightActive) {
        t12 = (t13)=>{
            const { initialWidth: initialWidth_1, finalWidth: finalWidth_0 } = t13;
            $b56ca6efd7e1c0fa$var$handleResizeEnd({
                finalWidth: finalWidth_0,
                eligibleForCollapseReminderSpotlight: !isNav4CollapseReminderSpotlightActive && !isNav4CollapseReminderSpotlightDismissed,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                pressTracing: pressTracing
            });
            fireSidebarResizeEndAnalytics({
                initialWidth: initialWidth_1,
                finalWidth: finalWidth_0
            });
        };
        $[26] = fireSidebarResizeEndAnalytics;
        $[27] = isNav4CollapseReminderSpotlightActive;
        $[28] = isNav4CollapseReminderSpotlightDismissed;
        $[29] = pressTracing;
        $[30] = setIsNav4CollapseReminderSpotlightActive;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== intl) {
        t13 = intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.dragHandle);
        $[32] = intl;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== intl) {
        t14 = intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.sideNavPanelSplitterTooltipContent);
        $[34] = intl;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== t12 || $[37] !== t13 || $[38] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavPanelSplitter), {
            onResizeEnd: t12,
            onResizeStart: $b56ca6efd7e1c0fa$var$onResizeStart,
            label: t13,
            testId: "side-navigation-panel-splitter",
            tooltipContent: t14
        });
        $[36] = t12;
        $[37] = t13;
        $[38] = t14;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== t10 || $[41] !== t11 || $[42] !== t15 || $[43] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, t9, t10, t11, t15);
        $[40] = t10;
        $[41] = t11;
        $[42] = t15;
        $[43] = t9;
        $[44] = t16;
    } else t16 = $[44];
    let t17;
    if ($[45] !== anonymousAccessQueryError || $[46] !== anonymousAccessQueryLoading || $[47] !== isUserViewingSpaceAsAnon) {
        t17 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba0fa5890838b7bb$export$ee8ecac8c80214c1), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[45] = anonymousAccessQueryError;
        $[46] = anonymousAccessQueryLoading;
        $[47] = isUserViewingSpaceAsAnon;
        $[48] = t17;
    } else t17 = $[48];
    let t18;
    if ($[49] !== t16 || $[50] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "side-nav"
        }, t16, t17);
        $[49] = t16;
        $[50] = t17;
        $[51] = t18;
    } else t18 = $[51];
    let t19;
    if ($[52] !== initialWidth || $[53] !== onCollapse || $[54] !== onExpand || $[55] !== onPeekEnd || $[56] !== onPeekStart || $[57] !== t18 || $[58] !== t7) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t7,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: "side-navigation",
            canToggleWithShortcut: canToggleWithShortcut
        }, t18);
        $[52] = initialWidth;
        $[53] = onCollapse;
        $[54] = onExpand;
        $[55] = onPeekEnd;
        $[56] = onPeekStart;
        $[57] = t18;
        $[58] = t7;
        $[59] = t19;
    } else t19 = $[59];
    return t19;
};
const $b56ca6efd7e1c0fa$var$SideNavigationSkeleton = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const t0 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "side-nav-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null)));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== initialWidth || $[2] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t0,
            id: "side-navigation-skeleton"
        }, t1);
        $[1] = initialWidth;
        $[2] = t0;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $b56ca6efd7e1c0fa$export$cc4f63927c41742f = (props)=>{
    const $ = (0, $bDgLe.c)(30);
    const { setIsCollapsed: setIsCollapsed } = (0, $kThSt.useSideNavigationCollapsedActions)();
    const [triggeredByShortcut, setTriggeredByShortcut] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== props.view) {
        t0 = {
            view: props.view
        };
        $[0] = props.view;
        $[1] = t0;
    } else t0 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t0);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOnEditRoute) {
        t1 = (action, triggeredBy)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        isOnEditRoute: isOnEditRoute,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = isOnEditRoute;
        $[4] = t1;
    } else t1 = $[4];
    const fireSidebarToggleAnalytics = t1;
    let t2;
    if ($[5] !== fireSidebarToggleAnalytics || $[6] !== setIsCollapsed || $[7] !== triggeredByShortcut) {
        t2 = ()=>{
            setIsCollapsed(true);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "collapsed");
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("collapsed", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[5] = fireSidebarToggleAnalytics;
        $[6] = setIsCollapsed;
        $[7] = triggeredByShortcut;
        $[8] = t2;
    } else t2 = $[8];
    const onCollapse = t2;
    let t3;
    if ($[9] !== fireSidebarToggleAnalytics || $[10] !== scrollTree || $[11] !== setIsCollapsed || $[12] !== triggeredByShortcut) {
        t3 = ()=>{
            setIsCollapsed(false);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "expanded");
            scrollTree();
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("expanded", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[9] = fireSidebarToggleAnalytics;
        $[10] = scrollTree;
        $[11] = setIsCollapsed;
        $[12] = triggeredByShortcut;
        $[13] = t3;
    } else t3 = $[13];
    const onExpand = t3;
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    let t4;
    if ($[14] !== requestHideOmniBar) {
        t4 = ()=>{
            requestHideOmniBar();
        };
        $[14] = requestHideOmniBar;
        $[15] = t4;
    } else t4 = $[15];
    const onPeekStart = t4;
    let t5;
    if ($[16] !== releaseHideOmniBar) {
        t5 = ()=>{
            releaseHideOmniBar();
        };
        $[16] = releaseHideOmniBar;
        $[17] = t5;
    } else t5 = $[17];
    const onPeekEnd = t5;
    let t6;
    let t7;
    if ($[18] !== releaseHideOmniBar) {
        t6 = ()=>()=>{
                releaseHideOmniBar();
            };
        t7 = [
            releaseHideOmniBar
        ];
        $[18] = releaseHideOmniBar;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[21] !== spaceKey) {
        t8 = (sideNavigation)=>spaceKey && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_affordances_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dJFqB.SpaceNavigationAffordanceDataProvider), {
                spaceKey: spaceKey
            }, sideNavigation) : sideNavigation;
        $[21] = spaceKey;
        $[22] = t8;
    } else t8 = $[22];
    const withAffordanceData = t8;
    let t9;
    if ($[23] !== onCollapse || $[24] !== onExpand || $[25] !== onPeekEnd || $[26] !== onPeekStart || $[27] !== props || $[28] !== withAffordanceData) {
        t9 = (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "side-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, withAffordanceData(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$PlatformNavigationInner, {
            view: props.view,
            isSpaceSettingsScreen: props.isSpaceSettingsScreen,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "side-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, withAffordanceData(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationInner, {
            ...props,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            setTriggeredByShortcut: setTriggeredByShortcut
        })));
        $[23] = onCollapse;
        $[24] = onExpand;
        $[25] = onPeekEnd;
        $[26] = onPeekStart;
        $[27] = props;
        $[28] = withAffordanceData;
        $[29] = t9;
    } else t9 = $[29];
    return t9;
};
const $b56ca6efd7e1c0fa$var$getSideNavContent = ()=>{
    // Because we render the PostOfficeConfluenceSideNavPlacement in the bottomElem of the PlatformNavigation when navx-global-side-nav-confluence is enabled, we don't want to render it twice in the SideNavFooter.
    return !(0, $9wGTI.fg)('navx-global-side-nav-confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i834V.PostOfficeConfluenceSideNavPlacement), null);
};
const $b56ca6efd7e1c0fa$var$SideNavFooterWrapped = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, $b56ca6efd7e1c0fa$var$getSideNavContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b56ca6efd7e1c0fa$var$globalInviteButtonStyles = {
    root: "_2O5Vij7dHp"
};
const $b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b56ca6efd7e1c0fa$var$globalInviteButtonStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f329be46c63c86a6$export$73b6b212789f5472), {
        product: "confluence",
        showFlag: flags.showFlag
    }, intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.globalInviteButtonLabel))));
});
const $b56ca6efd7e1c0fa$var$SideNavFooterContent = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const affordanceData = (0, $dJFqB.useSpaceNavigationAffordanceData)();
    let t0;
    if ($[0] !== affordanceData) {
        t0 = affordanceData?.licenseFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$RouteBackedSideNavFooterContent, {
            licenseFragmentRef: affordanceData.licenseFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$LegacySideNavFooterContent, null);
        $[0] = affordanceData;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $b56ca6efd7e1c0fa$var$RouteBackedSideNavFooterContent = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { licenseFragmentRef: licenseFragmentRef } = t0;
    let t1;
    if ($[0] !== licenseFragmentRef) {
        t1 = {
            licenseFragmentRef: licenseFragmentRef
        };
        $[0] = licenseFragmentRef;
        $[1] = t1;
    } else t1 = $[1];
    const eligibility = (0, $463b48fb68db8bff$export$34874fe08f3adc38)(t1);
    let t2;
    if ($[2] !== eligibility) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContentLayout, {
            eligibility: eligibility
        });
        $[2] = eligibility;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $b56ca6efd7e1c0fa$var$LegacySideNavFooterContent = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const eligibility = (0, $463b48fb68db8bff$export$b3cda0b328199f72)();
    let t0;
    if ($[0] !== eligibility) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContentLayout, {
            eligibility: eligibility
        });
        $[0] = eligibility;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $b56ca6efd7e1c0fa$var$SideNavFooterContentLayout = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { eligibility: t1 } = t0;
    const { error: error, loading: loading, isEligible: isEligible } = t1;
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else {
            let t2;
            if ($[0] !== error) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                $[0] = error;
                $[1] = t2;
            } else t2 = $[1];
            return t2;
        }
    }
    let t2;
    if ($[2] !== isEligible) {
        t2 = isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent, null)));
        $[2] = isEligible;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
}; // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
// Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
const $b56ca6efd7e1c0fa$var$onResizeStart = ()=>{
    if (typeof document !== 'undefined') document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
};
const $b56ca6efd7e1c0fa$var$handleResizeEnd = ({ finalWidth: finalWidth, eligibleForCollapseReminderSpotlight: eligibleForCollapseReminderSpotlight, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, pressTracing: pressTracing })=>{
    // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    if (typeof document !== 'undefined') document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, finalWidth);
    if (eligibleForCollapseReminderSpotlight) {
        pressTracing();
        setIsNav4CollapseReminderSpotlightActive?.(true);
    }
};
function $b56ca6efd7e1c0fa$var$_temp() {
    return !(0, $l65Bo.isDialogShown)();
}




var $lpfM9 = parcelRequire("lpfM9");




const $5fff77e1c664da88$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    TopNav: {
        id: "page-layout.top.nav",
        defaultMessage: "Confluence navigation"
    },
    Banner: {
        id: "page-layout.banner",
        defaultMessage: "Banner"
    },
    SideNav: {
        id: "page-layout.side.nav",
        defaultMessage: "Side navigation"
    },
    Main: {
        id: "page-layout.main",
        defaultMessage: "Page"
    },
    SkipLinks: {
        id: "page-layout.skip.links",
        defaultMessage: "Jump to"
    }
});











var $9aYkv = parcelRequire("9aYkv");


var $ek5IE = parcelRequire("ek5IE");




const $234a7212b3053f5f$var$SSR_LAYOUT_DATA_ATTR = 'data-main-content';
const $234a7212b3053f5f$var$SSR_IFRAME_ATTR = 'data-flex-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $234a7212b3053f5f$export$712225703044cda = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showBreadcrumbNavHeader: showBreadcrumbNavHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c _0NtCE6647S _4mFZ4BvbUu _0akdpx647S _2hCIEYPHpH _1uOrYSvbUu",
            __cmplp.showBreadcrumbNavHeader ? "_2RQz4yfI2J" : "_2RQz4ydnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $234a7212b3053f5f$export$6bdda512681a5774 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { zIndex: zIndex, showQuickStart: showQuickStart, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, $9aYkv.default)(__cmplp.zIndex)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_42Yu6B5WJb _01B0ifdnbC",
                __cmplp.showQuickStart ? "_3iDTPbvLZJ" : "_3iDTPbYbGa",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // This uses CCS variables from atlaskit/page-layout to make sure
const $234a7212b3053f5f$export$d1bb8697b964b9c = `
#ui-global-sidebar-section {
	z-index: auto !important;
	width: 100%;
}

[${$234a7212b3053f5f$var$SSR_LAYOUT_DATA_ATTR}], [${$234a7212b3053f5f$var$SSR_IFRAME_ATTR}] {
	width: calc(
		100% - ${(0, $ek5IE.LEFT_PANEL_WIDTH)} - ${(0, $ek5IE.LEFT_SIDEBAR_WIDTH)} - ${(0, $ek5IE.RIGHT_PANEL_WIDTH)} -
			${(0, $ek5IE.RIGHT_SIDEBAR_WIDTH)}
	) !important;
	position: absolute;
	left: calc(${(0, $ek5IE.LEFT_PANEL_WIDTH)} + ${(0, $ek5IE.LEFT_SIDEBAR_WIDTH)});
	z-index: auto;
	box-sizing: border-box;
	bottom: 0px;
	overflow: auto;
	top: ${(0, $liCgE.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)};

	&#admin-content {
		/* admin nav -> manage apps */
		.upm-manage {
			#upm-manage-type, /* app type dropdown filter */
		.upm-details .upm-plugin-info .upm-column {
				/* expand accordion to show app detail -> 3 column info table */
				z-index: 1;
			}
		}
	}
}
[${$234a7212b3053f5f$var$SSR_IFRAME_ATTR}] > [${$234a7212b3053f5f$var$SSR_LAYOUT_DATA_ATTR}] {
	display: none;
}

/* add overflow scrolling to ssred pages with heights longer than side navigation */
[${$234a7212b3053f5f$var$SSR_IFRAME_ATTR}] > main#main.aui-page-panel {
	overflow: hidden;
	overflow-y: auto;
	height: calc(100vh - ${(0, $liCgE.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px);
	min-height: calc(
		100vh - ${(0, $liCgE.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px
	); /* for responsiveness in small height windows */
}
`;
const $234a7212b3053f5f$export$191b652ca0b16b3f = `
	/* CSS hack for code block */
	.code-block.right-shadow {
		z-index: 2;
	}
	/* CSS hack for noPrint */
	[data-ds--page-layout--slot='top-navigation'],
	[data-ds--page-layout--slot='left-sidebar'] {
		@media print {
			display: none !important;
		}
	}
	/* To make sure we are using the same font family set by atlassian-frontend theme. */
	.PageContent {
		font-family: ${"var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
	/* To remove cls from more action dropdown */
	[data-testid='content-tools-dropdown-menu--content'] {
		width: 220px;
	}

	/* CSS hack to override batch CSS h3 styling for account menu */
	[data-testid='confluence-account-menu--content--details--name'] {
		font: ${"var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
`;













var $2E1ay = parcelRequire("2E1ay");


var $eaL9e = parcelRequire("eaL9e");





var $j5cB3 = parcelRequire("j5cB3");


var $89bON = parcelRequire("89bON");


var $k3d9G = parcelRequire("k3d9G");

const $4773940cc2485ba5$var$rgbOffset = {
    red: 0,
    // Pure red has a hue of 0 degrees
    green: 120,
    // Pure green has a hue of 120 degrees
    blue: 240 // Pure blue has a hue of 240 degrees
};
/**
 * Returns the contribution of the given RGB channel to the provided hue.
 *
 * Maximum value is 1, meaning it's the main channel for the hue
 * Minimum value is -1, meaning it doesn't contribute to the hue at all
 *
 * The function looks like a single trapezoidal wave that is
 * horizontally shifted according to the hue offset of the given channel.
 */ const $4773940cc2485ba5$var$getChannelContributionToHue = ({ rgbChannel: rgbChannel, hue: hue })=>{
    const k = (360 - $4773940cc2485ba5$var$rgbOffset[rgbChannel] + hue) / 30 % 12;
    return Math.max(-1, Math.min(k - 3, 9 - k, 1));
};
/**
 * Derived from Wikipedia article on HSL:
 * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
 *
 * You can think of it as taking an RGB channel, and the saturation and lightness values
 * to construct a function mapping hue to channel intensity.
 *
 * It then evaluates the function for the given hue.
 */ const $4773940cc2485ba5$var$getRgbChannel = ({ rgbChannel: rgbChannel, color: { h: hue, s: saturation, l: lightness } })=>{
    const shiftY = lightness;
    const scaleY = -1 * saturation * Math.min(lightness, 1 - lightness);
    /**
   * Value between 0-1 describing how much the RGB channel contributes to the given HSL color.
   *
   * `getChannelContributionToHue` is the channel contribution for the pure hue,
   * which is why we need to adjust and scale according to saturation and lightness.
   */ const channelContribution = shiftY + scaleY * $4773940cc2485ba5$var$getChannelContributionToHue({
        rgbChannel: rgbChannel,
        hue: hue
    });
    return Math.round(255 * channelContribution);
};
function $4773940cc2485ba5$export$cbd2e6c3c3c00218(color) {
    /**
   * I was creating increasingly complex regular expressions, aiming for correct parsing.
   *
   * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
   * with some slight improvements.
   *
   * We can refine it as needed.
   *
   * Known limitations of this approach:
   *
   * - It is overly permissive and will allow some invalid syntax,
   *   for example `hsl(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
   * - Only the integer parts of non-integers will be parsed
   * - Only supports the legacy, comma-separated syntax
   */ const [h, s, l] = color.replace(/hsl\(|[)%\s]/g, '').split(',').map((value)=>parseInt(value, 10));
    if ([
        h,
        s,
        l
    ].some((channel)=>!Number.isInteger(channel))) return null;
    /**
   * Normalized HSL value so that:
   *
   * - hue angle is from 0 (inclusive) to 360 (not inclusive)
   * - saturation and lightness percentages are expressed as fractional values from 0 to 1
   */ const normal = {
        h: h % 360,
        s: Math.min(s / 100, 1),
        l: Math.min(l / 100, 1)
    };
    return {
        r: $4773940cc2485ba5$var$getRgbChannel({
            rgbChannel: 'red',
            color: normal
        }),
        g: $4773940cc2485ba5$var$getRgbChannel({
            rgbChannel: 'green',
            color: normal
        }),
        b: $4773940cc2485ba5$var$getRgbChannel({
            rgbChannel: 'blue',
            color: normal
        })
    };
}


function $d204618c89e145c4$export$3f3b9febf881d58b(color) {
    /**
   * I was creating increasingly complex regular expressions, aiming for correct parsing.
   *
   * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
   * with some slight improvements.
   *
   * We can refine it as needed.
   *
   * Known limitations of this approach:
   *
   * - It is overly permissive and will allow some invalid syntax,
   *   for example `rgb(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
   * - Only the integer parts of non-integers will be parsed
   * - Only supports the legacy, comma-separated syntax
   */ const [r, g, b] = color.replace(/rgb\(|[)\s]/g, '').split(',').map((value)=>parseInt(value, 10))// Clamping to align with CSS behavior
    .map((value)=>Math.max(0, Math.min(value, 255)));
    if ([
        r,
        g,
        b
    ].some((n)=>!Number.isInteger(n))) return null;
    return {
        r: r,
        g: g,
        b: b
    };
}


function $528d260c17b7be38$export$1d30bac67697545c(color) {
    if (color.startsWith('#')) return (0, $k3d9G.parseHex)(color);
    if (color.startsWith('rgb(')) return (0, $d204618c89e145c4$export$3f3b9febf881d58b)(color);
    if (color.startsWith('hsl(')) return (0, $4773940cc2485ba5$export$cbd2e6c3c3c00218)(color);
    return null;
}



var $iRKv3 = parcelRequire("iRKv3");

const $1b7b278c93e24711$var$NULL_THEME_RESULT = {
    backgroundColor: null,
    highlightColor: null
};
const $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES = [
    '0052CC',
    // ADG3,
    '0C66E4',
    // ADG4
    '1868DB'
];
const $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e = ({ backgroundColorRaw: backgroundColorRaw, highlightColorRaw: highlightColorRaw, isDarkMode: isDarkMode })=>{
    if (!backgroundColorRaw || !highlightColorRaw) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    const backgroundColor = $1b7b278c93e24711$var$parseColor(backgroundColorRaw);
    const highlightColor = $1b7b278c93e24711$var$parseColor(highlightColorRaw);
    if ($1b7b278c93e24711$var$isDefaultTheme(backgroundColor, highlightColor)) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    return {
        backgroundColor: isDarkMode && backgroundColor ? $1b7b278c93e24711$var$applyDarkModeTransformation(backgroundColor) : backgroundColor,
        highlightColor: highlightColor
    };
};
/**
 * Determines if the given colors match the default theme.
 */ const $1b7b278c93e24711$var$isDefaultTheme = (backgroundColor, highlightColor)=>{
    if (!backgroundColor || !highlightColor) return false;
    const currentDefaultBackground = $1b7b278c93e24711$var$parseColor((0, $89bON.getTokenValue)('elevation.surface', '#ffffff'));
    const isDefaultBackground = $1b7b278c93e24711$var$areColorsEqual(backgroundColor, currentDefaultBackground);
    const isDefaultHighlight = $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES.some((color)=>{
        const currentDefaultColor = $1b7b278c93e24711$var$parseColor((0, $89bON.getTokenValue)('color.text.brand', `#${color}`));
        return $1b7b278c93e24711$var$areColorsEqual(highlightColor, currentDefaultColor);
    });
    return isDefaultBackground && isDefaultHighlight;
};
/**
 * Parses and validates a color string using platform utilities.
 * Returns RGB object or null if invalid.
 */ const $1b7b278c93e24711$var$parseColor = (colorToParse)=>{
    if (colorToParse.startsWith('rgba(') && colorToParse.split(',').length === 4) colorToParse = `rgb(${colorToParse.substring(5, colorToParse.lastIndexOf(','))})`;
    else if (colorToParse.startsWith('var(')) colorToParse = $1b7b278c93e24711$var$getCSSVariableValue(colorToParse); // Will only get re-calculated if the variable is from ADS
    return (0, $528d260c17b7be38$export$1d30bac67697545c)(colorToParse);
};
/**
 * Transforms a background color for dark mode by either using the dark surface token
 * or reducing lightness for custom colors.
 */ const $1b7b278c93e24711$var$getDarkModeBackgroundColor = (currentBackgroundColor)=>{
    if (currentBackgroundColor.toLowerCase() === '#ffffff') // getTokenValue doesn't work in SSR thus hardcode fallback to current surface value, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    return (0, $89bON.getTokenValue)('elevation.surface', '#1d2125');
    else {
        const lightnessPercentage = (0, $iRKv3.getLightnessPercentage)(currentBackgroundColor);
        if (lightnessPercentage === undefined) return currentBackgroundColor;
        return lightnessPercentage > $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX ? (0, $iRKv3.reduceLightness)(currentBackgroundColor, $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX) : currentBackgroundColor;
    }
};
const $1b7b278c93e24711$var$applyDarkModeTransformation = (color)=>{
    const hexColor = $1b7b278c93e24711$var$rgbToHex(color); // utility functions require hex colors
    const darkHex = $1b7b278c93e24711$var$getDarkModeBackgroundColor(hexColor);
    return (0, $528d260c17b7be38$export$1d30bac67697545c)(darkHex);
};
const $1b7b278c93e24711$var$areColorsEqual = (color1, color2)=>{
    if (!color1 || !color2) return color1 === color2;
    return color1.r === color2.r && color1.g === color2.g && color1.b === color2.b;
};
const $1b7b278c93e24711$var$rgbToHex = (rgb)=>{
    const toHex = (n)=>{
        const hex = Math.round(n).toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };
    return `#${toHex(rgb.r)}${toHex(rgb.g)}${toHex(rgb.b)}`.toUpperCase();
};
const $1b7b278c93e24711$var$getCSSVariableValue = (variableExpression)=>{
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        .getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};


const $a61833f951c42c7b$export$c0c5f5b297b77726 = (backgroundColorRaw, highlightColorRaw)=>{
    const $ = (0, $bDgLe.c)(4);
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    let t0;
    if ($[0] !== backgroundColorRaw || $[1] !== highlightColorRaw || $[2] !== isDarkMode) {
        t0 = (0, $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e)({
            backgroundColorRaw: backgroundColorRaw,
            highlightColorRaw: highlightColorRaw,
            isDarkMode: isDarkMode
        });
        $[0] = backgroundColorRaw;
        $[1] = highlightColorRaw;
        $[2] = isDarkMode;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};


















var $aJv6Q = parcelRequire("aJv6Q");


const $3183c72dd59199f3$var$ImpersonationFlagV2Loader = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "61Lty",
    name: "ImpersonationFlagV2Loader",
    loader: async ()=>(await (parcelRequire("b2F0e"))).ImpersonationFlag
});
const $3183c72dd59199f3$var$LazyImpersonationFlagComponent = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3183c72dd59199f3$var$ImpersonationFlagV2Loader, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $3183c72dd59199f3$export$4fca365a8ad2f625 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($3183c72dd59199f3$var$LazyImpersonationFlagComponent);



var $emNvf = parcelRequire("emNvf");




const $f06013f8e99ab858$export$41d0d88a6b0e456f = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { defaultCollapsed: defaultCollapsed, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive } = t0;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $emNvf.default), {
        __callerPackage__: "page-layout"
    });
    const horizontalHeader = data?.lookAndFeel?.custom?.horizontalHeader;
    const customTheme = (0, $a61833f951c42c7b$export$c0c5f5b297b77726)(horizontalHeader?.backgroundColor, horizontalHeader?.primaryNavigation?.highlightColor);
    let t1;
    if ($[0] !== customTheme || $[1] !== defaultCollapsed || $[2] !== isNav4CollapseReminderSpotlightActive || $[3] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaL9e.TopNavigationBase), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[0] = customTheme;
        $[1] = defaultCollapsed;
        $[2] = isNav4CollapseReminderSpotlightActive;
        $[3] = setIsNav4CollapseReminderSpotlightActive;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3183c72dd59199f3$export$4fca365a8ad2f625), null);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "top-nav"
        }, t1, t2);
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== error) {
        t4 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[8] = error;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== customTheme || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2E1ay.TopNav), {
            testId: "grid-topNav",
            customTheme: customTheme
        }, t3, t4);
        $[10] = customTheme;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};









var $ibHYv = parcelRequire("ibHYv");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");














var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");











var $5NAso = parcelRequire("5NAso");




const $76328abce97d8d37$export$fae700fb5dfcb093 = ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    let t0;
    let t1;
    if ($[0] !== fireFailedAnalytic) {
        t0 = ()=>{
            (0, $5NAso.setOnCreateError)((info)=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_CREATE, {
                    reason: info.reason,
                    ...info.statusCode !== undefined && {
                        statusCode: info.statusCode
                    }
                });
            });
            return $76328abce97d8d37$var$_temp;
        };
        t1 = [
            fireFailedAnalytic
        ];
        $[0] = fireFailedAnalytic;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
function $76328abce97d8d37$var$_temp() {
    (0, $5NAso.setOnCreateError)(null);
}












var $2Qxf3 = parcelRequire("2Qxf3");




const $37d6b5f846525abd$export$f43ff4d4aa562c2f = ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { fireOperationalAnalytic: fireOperationalAnalytic, fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    let t0;
    let t1;
    if ($[0] !== fireFailedAnalytic || $[1] !== fireOperationalAnalytic || $[2] !== fireSuccessAnalytic) {
        t0 = ()=>{
            (0, $2Qxf3.setOnFetchComplete)((metrics)=>{
                fireOperationalAnalytic({
                    actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                    action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FETCHED,
                    attributes: metrics
                });
            });
            (0, $2Qxf3.setOnFetchScopeSuccess)((info)=>{
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {
                    scope: info.scope
                });
            });
            (0, $2Qxf3.setOnFetchScopeError)((info_0)=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {
                    scope: info_0.scope,
                    ...info_0.reason !== undefined && {
                        reason: info_0.reason
                    },
                    ...info_0.statusCode !== undefined && {
                        statusCode: info_0.statusCode
                    }
                });
            });
            return $37d6b5f846525abd$var$_temp;
        };
        t1 = [
            fireOperationalAnalytic,
            fireFailedAnalytic,
            fireSuccessAnalytic
        ];
        $[0] = fireFailedAnalytic;
        $[1] = fireOperationalAnalytic;
        $[2] = fireSuccessAnalytic;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
function $37d6b5f846525abd$var$_temp() {
    (0, $2Qxf3.setOnFetchComplete)(null);
    (0, $2Qxf3.setOnFetchScopeSuccess)(null);
    (0, $2Qxf3.setOnFetchScopeError)(null);
}



var $cYuYM = parcelRequire("cYuYM");


var $5vi32 = parcelRequire("5vi32");





var $dZUkS = parcelRequire("dZUkS");

const $326f6c6e797b3c09$export$607850563f346b34 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children } = t0;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const locale = intlLocale;
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    (0, $37d6b5f846525abd$export$f43ff4d4aa562c2f)();
    (0, $76328abce97d8d37$export$fae700fb5dfcb093)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isSnippetCreateEnabled = (0, $cYuYM.useIsSnippetCreateEnabled)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t1;
    let t2;
    if ($[0] !== fireFailedAnalytic || $[1] !== isEmbeddedConfluence || $[2] !== isLoggedIn || $[3] !== isSnippetCreateEnabled || $[4] !== locale || $[5] !== snippetsActions) {
        t1 = ()=>{
            if (!(0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false)) return;
            if (isEmbeddedConfluence && !isSnippetCreateEnabled) return;
            if (!isLoggedIn) return;
            snippetsActions.fetchSnippets(locale).catch(()=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {});
            });
        };
        t2 = [
            snippetsActions,
            fireFailedAnalytic,
            isEmbeddedConfluence,
            isSnippetCreateEnabled,
            isLoggedIn,
            locale
        ];
        $[0] = fireFailedAnalytic;
        $[1] = isEmbeddedConfluence;
        $[2] = isLoggedIn;
        $[3] = isSnippetCreateEnabled;
        $[4] = locale;
        $[5] = snippetsActions;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[8] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[8] = children;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};



var $laFNM = parcelRequire("laFNM");





const $e33908ef21162ab8$export$968a8c4aa27e5f45 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children } = t0;
    const { initialCollapsedState: initialCollapsedState } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const t1 = initialCollapsedState === "collapsed";
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kThSt.SideNavigationCollapsedContainer), {
            isGlobal: true,
            initialIsCollapsed: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ibHYv.PostOfficeSideNavMessageProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cLgYq.InProductHelpProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $326f6c6e797b3c09$export$607850563f346b34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laFNM.ApprovalsProvider), null, children)))));
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};



var $9Zall = parcelRequire("9Zall");

const $ba2ff1d1fd865be7$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $ba2ff1d1fd865be7$var$PopoverSpotlightWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $ba2ff1d1fd865be7$var$SpotlightManagerSpotlightWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), {
            blanketIsTinted: true
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $ba2ff1d1fd865be7$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, fillContainer: fillContainer, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader } = t0;
    let t1;
    if ($[0] !== children || $[1] !== editorPreloader || $[2] !== fillContainer || $[3] !== isSpaceSettingsScreen || $[4] !== standalone || $[5] !== view) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba2ff1d1fd865be7$export$f94607b1528a8807, {
            fillContainer: fillContainer,
            children: children,
            view: view,
            standalone: standalone,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            editorPreloader: editorPreloader
        }));
        $[0] = children;
        $[1] = editorPreloader;
        $[2] = fillContainer;
        $[3] = isSpaceSettingsScreen;
        $[4] = standalone;
        $[5] = view;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
});
const $ba2ff1d1fd865be7$export$f94607b1528a8807 = (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { children: children, fillContainer: fillContainer, view: view, standalone: standalone, isSpaceSettingsScreen: t1, editorPreloader: t2 } = t0;
    const isSpaceSettingsScreen = t1 === undefined ? false : t1;
    const editorPreloader = t2 === undefined ? $ba2ff1d1fd865be7$var$noopEditorPreloader : t2;
    let t3;
    if ($[0] !== view) {
        t3 = {
            view: view
        };
        $[0] = view;
        $[1] = t3;
    } else t3 = $[1];
    const { pageTreeUpdater: pageTreeUpdater } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t3);
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    const { location: location, match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t4;
    if ($[2] !== location?.pathname) {
        t4 = $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$ba2ff1d1fd865be7$var$isRoute(location?.pathname, route));
        $[2] = location?.pathname;
        $[3] = t4;
    } else t4 = $[3];
    const showBreadcrumbNavHeader = t4;
    let t5;
    if ($[4] !== intl) {
        t5 = intl.formatMessage((0, $5fff77e1c664da88$export$a7357cdd1f0b0168).SideNav);
        $[4] = intl;
        $[5] = t5;
    } else t5 = $[5];
    const SideNavSkiplinkText = t5;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const globalLayoutStyles = !(fillContainer && (0, $9wGTI.fg)("rovo_fps_fix_duplicate_scrollbars")) && (0, $9wGTI.fg)("confluence_stable_scrollbar_gutter") ? `${0, $234a7212b3053f5f$export$191b652ca0b16b3f}\n#AkMainContent { scrollbar-gutter: stable; }` : (0, $234a7212b3053f5f$export$191b652ca0b16b3f);
    let t6;
    if ($[6] !== globalLayoutStyles || $[7] !== standalone) {
        t6 = ()=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$d1bb8697b964b9c)
                },
                "data-testid": "global-styles-SSR"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: globalLayoutStyles
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
                "data-testid": "global-styles",
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: globalLayoutStyles
                }
            });
        $[6] = globalLayoutStyles;
        $[7] = standalone;
        $[8] = t6;
    } else t6 = $[8];
    const standaloneGlobalStylesCompiled = t6;
    const [isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive] = (0, $cozmU.useState)(false);
    const { initialCollapsedState: initialCollapsedState } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const currentContentId = match?.params?.contentId ?? null;
    const isContentRoute = Boolean(currentContentId);
    let t7;
    if ($[9] !== location?.pathname || $[10] !== match?.name) {
        t7 = match?.name === (0, $1NBp8.SPACE_SUGGESTIONS).name || $ba2ff1d1fd865be7$var$isRoute(location?.pathname, (0, $1NBp8.SPACE_SUGGESTIONS));
        $[9] = location?.pathname;
        $[10] = match?.name;
        $[11] = t7;
    } else t7 = $[11];
    const isSpaceSuggestionsRoute = t7;
    const isSpaceSuggestionReviewPanel = panel?.id === (0, $jvYFk.PanelName).SpaceSuggestionReviewPanel;
    let t8;
    if ($[12] !== isContentRoute || $[13] !== isSpaceSuggestionReviewPanel || $[14] !== isSpaceSuggestionsRoute || $[15] !== panel?.id) {
        t8 = (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && (isContentRoute || isSpaceSuggestionsRoute && isSpaceSuggestionReviewPanel);
        $[12] = isContentRoute;
        $[13] = isSpaceSuggestionReviewPanel;
        $[14] = isSpaceSuggestionsRoute;
        $[15] = panel?.id;
        $[16] = t8;
    } else t8 = $[16];
    const canRenderObjectSidebarPanel = t8;
    const shouldRenderObjectSidebarPanel = isObjectSidebarShown && canRenderObjectSidebarPanel;
    const SpaceSuggestionReviewPanelBodyComponent = isSpaceSuggestionReviewPanel ? panel?.BodyComponent : undefined;
    let t10;
    let t9;
    if ($[17] !== canRenderObjectSidebarPanel || $[18] !== hideObjectSidebar || $[19] !== isObjectSidebarShown) {
        t9 = ()=>{
            if (isObjectSidebarShown && !canRenderObjectSidebarPanel && (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar")) hideObjectSidebar();
        };
        t10 = [
            canRenderObjectSidebarPanel,
            hideObjectSidebar,
            isObjectSidebarShown
        ];
        $[17] = canRenderObjectSidebarPanel;
        $[18] = hideObjectSidebar;
        $[19] = isObjectSidebarShown;
        $[20] = t10;
        $[21] = t9;
    } else {
        t10 = $[20];
        t9 = $[21];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[22] !== isSpaceSuggestionReviewPanel || $[23] !== shouldRenderObjectSidebarPanel) {
        t11 = shouldRenderObjectSidebarPanel && ((0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") || isSpaceSuggestionReviewPanel);
        $[22] = isSpaceSuggestionReviewPanel;
        $[23] = shouldRenderObjectSidebarPanel;
        $[24] = t11;
    } else t11 = $[24];
    const shouldRenderObjectSidebarPanelElement = t11;
    let t12;
    if ($[25] !== SpaceSuggestionReviewPanelBodyComponent || $[26] !== shouldRenderObjectSidebarPanelElement) {
        t12 = shouldRenderObjectSidebarPanelElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0qTi.Panel), {
            defaultWidth: 400,
            label: "Object Sidebar"
        }, SpaceSuggestionReviewPanelBodyComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpaceSuggestionReviewPanelBodyComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vI1F.ObjectSidebarContent), null)) : null;
        $[25] = SpaceSuggestionReviewPanelBodyComponent;
        $[26] = shouldRenderObjectSidebarPanelElement;
        $[27] = t12;
    } else t12 = $[27];
    const objectSidebarPanel = t12;
    let t13;
    if ($[28] !== currentContentId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3260f1cb149f21d4$export$2e1f52d6d7a935bc), {
            contentId: currentContentId,
            shouldExcludeAutoSync: (0, $aboIx.shouldExcludeDevDocsAutoSync)
        });
        $[28] = currentContentId;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "NavigationLoading"
        });
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== SideNavSkiplinkText || $[32] !== areKeyboardShortcutsEnabled || $[33] !== children || $[34] !== initialCollapsedState || $[35] !== isNav4CollapseReminderSpotlightActive || $[36] !== isSpaceSettingsScreen || $[37] !== objectSidebarPanel || $[38] !== pageTreeUpdater || $[39] !== showBreadcrumbNavHeader || $[40] !== standalone || $[41] !== standaloneGlobalStylesCompiled || $[42] !== view) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: $ba2ff1d1fd865be7$var$bannerStateContainerArray
        }, (bannerState)=>{
            const bannerHeight = bannerState.getTotalHeight(false);
            const SpotlightWrapper = (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? $ba2ff1d1fd865be7$var$PopoverSpotlightWrapper : $ba2ff1d1fd865be7$var$SpotlightManagerSpotlightWrapper;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpotlightWrapper, null, standaloneGlobalStylesCompiled(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e33908ef21162ab8$export$968a8c4aa27e5f45), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71c85943ef41ca73$export$797f6437373337da), {
                value: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31TvY.Root), {
                UNSAFE_dangerouslyHoistSlotSizes: true,
                testId: "page-layout-root",
                defaultSideNavCollapsed: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false) ? initialCollapsedState === "collapsed" : undefined,
                isSideNavShortcutEnabled: areKeyboardShortcutsEnabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5660beed5219c07c$export$3b4e64e77073e307), {
                height: bannerHeight,
                id: "AkBanner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5XPyz.BannerContainer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                dataFetcherName: "top-nav"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f06013f8e99ab858$export$41d0d88a6b0e456f), {
                defaultCollapsed: initialCollapsedState === "collapsed",
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b56ca6efd7e1c0fa$export$cc4f63927c41742f), {
                view: view,
                skiplinkText: SideNavSkiplinkText,
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                setTriggeredByShortcut: $ba2ff1d1fd865be7$var$_temp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dyjRd.Main), {
                testId: "grid-main-container",
                id: "AkMainContent"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234a7212b3053f5f$export$712225703044cda), {
                id: "layout-main-wrapper",
                showBreadcrumbNavHeader: showBreadcrumbNavHeader
            }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgsIj.FixedBreadcrumbsNavForPageLayoutLoader), null), children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, showBreadcrumbNavHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles
            }, children) : children) : null)), (0, $9wGTI.fg)("platform-dst-motion-uplift-panel") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, objectSidebarPanel) : objectSidebarPanel, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpfM9.PanelLoader), {
                toggleInProductHelp: $ba2ff1d1fd865be7$var$_temp2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>{
                pageTreeUpdater.current = pageTreeStateUpdatesContainer;
                return null;
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c25ef82052c394f$export$f143b4bd86d1e004), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1C7kY.GlobalComponentsLoader), null))));
        });
        $[31] = SideNavSkiplinkText;
        $[32] = areKeyboardShortcutsEnabled;
        $[33] = children;
        $[34] = initialCollapsedState;
        $[35] = isNav4CollapseReminderSpotlightActive;
        $[36] = isSpaceSettingsScreen;
        $[37] = objectSidebarPanel;
        $[38] = pageTreeUpdater;
        $[39] = showBreadcrumbNavHeader;
        $[40] = standalone;
        $[41] = standaloneGlobalStylesCompiled;
        $[42] = view;
        $[43] = t15;
    } else t15 = $[43];
    let t16;
    if ($[44] !== editorPreloader || $[45] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
            value: editorPreloader
        }, t15);
        $[44] = editorPreloader;
        $[45] = t15;
        $[46] = t16;
    } else t16 = $[46];
    let t17;
    if ($[47] !== t16 || $[48] !== view) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd996ec529999f47$export$ac3e7903e24ee02d), {
            view: view,
            navVersion: "4"
        }, t14, t16);
        $[47] = t16;
        $[48] = view;
        $[49] = t17;
    } else t17 = $[49];
    let t18;
    if ($[50] !== t13 || $[51] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jAOzg.SmartFolderSyncProvider), null, t13, t17));
        $[50] = t13;
        $[51] = t17;
        $[52] = t18;
    } else t18 = $[52];
    return t18;
};
const $ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    let t0;
    if ($[0] !== isMultiSelectActive) {
        t0 = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
            isTinted: true,
            testId: "content-tree-multi-select-blanket"
        }) : null;
        $[0] = isMultiSelectActive;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles = (0, $buxP3.xcss)({
    // @ts-ignore This specific value is necessary to ensure the breadcrumbs are offset correctly
    marginTop: '60px'
});
const $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayout-outer'
};
const $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayoutInner'
};
const $ba2ff1d1fd865be7$var$bannerStateContainerArray = [
    (0, $hrAmX.BannerStateContainer)
];
const $ba2ff1d1fd865be7$var$noopEditorPreloader = ()=>null;
function $ba2ff1d1fd865be7$var$_temp() {}
function $ba2ff1d1fd865be7$var$_temp2() {}
module.exports["PageLayout"] = $ba2ff1d1fd865be7$export$6d1402fb58384e4f;
module.exports["PageLayoutInner"] = $ba2ff1d1fd865be7$export$f94607b1528a8807;

});

parcelRegister("b0qTi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $64L5u = parcelRequire("64L5u");


var $iODl6 = parcelRequire("iODl6");


var $cSlj5 = parcelRequire("cSlj5");


var $iDrrr = parcelRequire("iDrrr");


var $eaAhc = parcelRequire("eaAhc");


var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $b24kF = parcelRequire("b24kF");


var $iynkA = parcelRequire("iynkA");


var $1gX7M = parcelRequire("1gX7M");


var $eyPWA = parcelRequire("eyPWA");


var $IRNbu = parcelRequire("IRNbu");


var $6iHsT = parcelRequire("6iHsT");

const $b9784ecf350f165c$var$panelSplitterResizingVar = '--n_pnlRsz';
const $b9784ecf350f165c$var$fallbackDefaultWidth = 365; /**
                                   * We typically use the `defaultWidth` as the minimum resizing width,
                                   * but for large default widths we fallback to a standard value.
                                   *
                                   * This standard value of `400px` is to align with the Global Preview Panels.
                                   */ 
const $b9784ecf350f165c$var$fallbackResizeMinWidth = 400;
const $b9784ecf350f165c$var$styles = {
    root: "_1xC2CJ39pk _2p6ht9F05b _24h04i2Njc _42Yu6B7dHp _0jFU0VlOMI _1mT5xdHE3j _2I62gzgiHs _0KLXruoI2d _39xV02mSzM _2EWYUbwuPN _0hAebtlfZc _3gynorcCME _0E5nkyIZbP",
    border: "_2YmqfPYbGa _2OUyjtGk8v _4uZkDnOeNX _1RYJRxYbGa",
    scrollContainer: "_4bt5LAIZbP _2WAcuGIZbP _0jFU0VN91d",
    hidden: "_3iDTPbYbGa",
    entering: "_1jZhRJ3mzc _2qDx9m7CF6 _03Q0eexlqh _4xtBsMCT93 _4tikTSThaV _3JI830y1CL _2nUT5xdEse",
    exiting: "_1jZhRJiZOe _2qDx9m7CF6 _03Q0eexlqh _4xtBsMouYb _4tikTSThaV _0LZf8iy1CL _2nUT5xcfkA",
    contentEntering: "_2fBhteeOAp",
    contentExiting: "_2fBhtezSOH",
    contentChangeContainer: "_0jFU0VN91d"
};
const $b9784ecf350f165c$var$PanelContentMotion = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children } = t0;
    const { state: state, ref: ref } = (0, $64L5u.useMotion)();
    const t1 = state === "entering" && $b9784ecf350f165c$var$styles.contentEntering;
    const t2 = state === "exiting" && $b9784ecf350f165c$var$styles.contentExiting;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.contentChangeContainer,
            t1,
            t2
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== ref || $[5] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            className: t3
        }, children);
        $[3] = children;
        $[4] = ref;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children })=>{
    const { state: state, ref: ref } = (0, $64L5u.useMotion)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.contentChangeContainer,
            state === 'entering' && $b9784ecf350f165c$var$styles.contentEntering,
            state === 'exiting' && $b9784ecf350f165c$var$styles.contentExiting
        ])
    }, children);
}; /**
    * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
    *
    * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
    *
    * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
    */ 
function $b9784ecf350f165c$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $b9784ecf350f165c$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true, maxWidth: maxWidth, contentKey: contentKey }) {
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    const isMotionUpliftEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-panel');
    const defaultWidth = (0, $6iHsT.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $b9784ecf350f165c$var$fallbackDefaultWidth,
        slotName: 'Panel'
    }); // useMotion is applied only when the `platform-dst-motion-uplift-panel` gate is enabled.
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $64L5u.useMotion)({
        onFinish: (state)=>{
            if (state === 'exiting' && defaultWidthRef.current === 0) // Set width to 0 as animation is complete
            setWidth(0);
        },
        initialState: defaultWidth === 0 ? 'hidden' : undefined
    }); /**
       * Don't show the skip link if the slot has 0 width.
       *
       * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
       *
       * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
       */ 
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $cozmU.useRef)(null);
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth); // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $cozmU.useRef)(defaultWidth); // `mergeRefs` returns a new callback ref on every call, and combined with a new array literal
    // this would cause React to detach/re-attach the ref on every render. Memoise it so the merged
    // ref is stable across renders.
    const mergedRef = (0, $cozmU.useMemo)(()=>isMotionUpliftEnabled ? (0, $lmzCg.default)([
            ref,
            motionRef
        ]) : ref, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isMotionUpliftEnabled,
        motionRef
    ]); /**
                                        * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
                                        * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
                                        * https://jplat.atlassian.net/browse/BLU-3951
                                        */ 
    (0, $cozmU.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        if (isMotionUpliftEnabled) {
            if (defaultWidth === 0) {
                reanimate((0, $cSlj5.Reanimate).exit);
                defaultWidthRef.current = defaultWidth; // Set width to 0 once the exit animation is complete
                return;
            } else if (defaultWidthRef.current === 0) reanimate((0, $cSlj5.Reanimate).enter);
        }
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth,
        isMotionUpliftEnabled,
        reanimate
    ]);
    const sideNavRef = (0, $1gX7M.useSideNavRef)(); /**
                                       * The minimum width that the panel can be resized to by the user.
                                       *
                                       * We only use the `defaultWidth` up to a point to avoid huge panels.
                                       */ 
    const minWidth = Math.min(defaultWidth, $b9784ecf350f165c$var$fallbackResizeMinWidth); /**
                                                                    * Returns the bounds for resizing, evaluated lazily when needed.
                                                                    *
                                                                    * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
                                                                    * and the panel's slot bounds use a complex CSS expression.
                                                                    */ 
    const getResizeBounds = (0, $cozmU.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0; /**
                                                                * By default the panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
                                                                *
                                                                * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
                                                                *
                                                                * Consumers can opt in to a larger maximum via the `maxWidth` prop.
                                                                */ 
        const defaultMaxWidth = `${Math.round((window.innerWidth - sideNavWidth) / 2)}px`;
        return {
            min: `${minWidth}px`,
            max: maxWidth ?? defaultMaxWidth
        };
    }, [
        maxWidth,
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        // Consumers can opt in to a larger maximum via the `maxWidth` prop.
        max: maxWidth ?? `round(nearest, calc((100vw - var(${0, $liCgE.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $IRNbu.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $b9784ecf350f165c$var$panelSplitterResizingVar,
        panelId: (0, $liCgE.panelPanelSplitterId)
    });
    return /*#__PURE__*/ $cozmU.createElement("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.root,
            isMotionUpliftEnabled && state === 'hidden' && $b9784ecf350f165c$var$styles.hidden,
            isMotionUpliftEnabled && state === 'entering' && $b9784ecf350f165c$var$styles.entering,
            isMotionUpliftEnabled && state === 'exiting' && $b9784ecf350f165c$var$styles.exiting,
            !isMotionUpliftEnabled && defaultWidth === 0 && $b9784ecf350f165c$var$styles.hidden,
            hasBorder && $b9784ecf350f165c$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $liCgE.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: mergedRef
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_panelLayoutVar),
        value: "0px",
        mediaQuery: '@media (min-width: 90rem)',
        responsiveValue: `var(${$b9784ecf350f165c$var$panelSplitterResizingVar}, ${panelVariableWidth})`
    }), /*#__PURE__*/ $cozmU.createElement((0, $iynkA.PanelSplitterProvider), {
        panelId: (0, $liCgE.panelPanelSplitterId),
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: getResizeBounds,
        resizingCssVar: $b9784ecf350f165c$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.scrollContainer,
            isMotionUpliftEnabled && state === 'entering' && $b9784ecf350f165c$var$styles.contentEntering,
            isMotionUpliftEnabled && state === 'exiting' && $b9784ecf350f165c$var$styles.contentExiting
        ])
    }, isMotionUpliftEnabled && contentKey !== undefined ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
        exitThenEnter: true
    }, /*#__PURE__*/ $cozmU.createElement($b9784ecf350f165c$var$PanelContentMotion, {
        key: contentKey
    }, children)) : children)));
}
module.exports["Panel"] = $b9784ecf350f165c$export$2ddb90ad54e5f587;

});

parcelRegister("58PBI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("6CEg5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $cozmU.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("5XPyz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e36ff8521eaa3fdf$export$f316edcbf748c37b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bTjE2",
    name: "BannerContainer",
    loader: async ()=>(await (parcelRequire("8PdlF"))).BannerContainer
});
module.exports["BannerContainer"] = $e36ff8521eaa3fdf$export$f316edcbf748c37b;

});

parcelRegister("8PdlF", function(module, exports) {

let $66cd70e471f1bb3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $66cd70e471f1bb3c$var$load("1RnPt"),
    $66cd70e471f1bb3c$var$load("hhss7"),
    $66cd70e471f1bb3c$var$load("d2O2V"),
    $66cd70e471f1bb3c$var$load("avZlC")
]).then(()=>parcelRequire('9ZNsj'));

});

parcelRegister("hrAmX", function(module, exports) {

var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        /** Frozen at construction: a mid-session flag flip must not change an instance's arithmetic. */ this.topNavHeight = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height.
     * Applied on the next microtask; a suppressed container drops the write entirely.
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if (this.suppressed) return;
            (0, $8zRYE.showBanner)(name, height);
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.suppressed) return;
            (0, $8zRYE.hideBanner)(name);
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        if (this.suppressed) return;
        (0, $8zRYE.seedBanners)(props.initialState?.banners ?? []);
        this.state = {
            banners: (0, $8zRYE.getBanners)()
        };
        // The mirror is synchronous so a read straight after a flush is fresh; the notification is
        // coalesced, so a tick's worth of store changes costs one round no matter which container
        // (or hook) wrote them.
        this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            this.scheduleNotify();
        });
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer: `ssrBannerManager` registers banners regardless of the URL param, so
 * an unguarded hydration seed would give a hydrating render banners the SSR render dropped, and the
 * `useBannerState` hooks never see the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init: an SPA transition changes
    // `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("jecot", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    if (// The increased height change is applied when FHS or app switcher improvements are enabled.
    // Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) || (0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("cgsIj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await (parcelRequire("fL2QU"))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await (parcelRequire("fL2QU"))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("fL2QU", function(module, exports) {

let $b78d753677798bc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b78d753677798bc6$var$load("6wr18"),
    $b78d753677798bc6$var$load("ffEVr"),
    $b78d753677798bc6$var$load("9XFtf"),
    $b78d753677798bc6$var$load("jYCVY"),
    $b78d753677798bc6$var$load("hhss7"),
    $b78d753677798bc6$var$load("i6pyw")
]).then(()=>parcelRequire('8MMdp'));

});

parcelRegister("1C7kY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c9ec1f4c06aad517$export$23822a00be419508 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KYiA6",
    name: "GlobalComponentsLoader",
    loader: async ()=>(await (parcelRequire("4M2NQ"))).GlobalComponents
});
module.exports["GlobalComponentsLoader"] = $c9ec1f4c06aad517$export$23822a00be419508;

});

parcelRegister("4M2NQ", function(module, exports) {

let $379dd1b5d0b10e8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $379dd1b5d0b10e8c$var$load("ea3NB"),
    $379dd1b5d0b10e8c$var$load("1audf"),
    $379dd1b5d0b10e8c$var$load("bpBPu"),
    $379dd1b5d0b10e8c$var$load("6wr18"),
    $379dd1b5d0b10e8c$var$load("bb3WM"),
    $379dd1b5d0b10e8c$var$load("dlYE2"),
    $379dd1b5d0b10e8c$var$load("llcQo"),
    $379dd1b5d0b10e8c$var$load("7EorR"),
    $379dd1b5d0b10e8c$var$load("ffEVr"),
    $379dd1b5d0b10e8c$var$load("aLbuU"),
    $379dd1b5d0b10e8c$var$load("el1U6"),
    $379dd1b5d0b10e8c$var$load("2yyll"),
    $379dd1b5d0b10e8c$var$load("hhss7"),
    $379dd1b5d0b10e8c$var$load("jryQt")
]).then(()=>parcelRequire('73TCo'));

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $cha5E.expVal)("nin_glance_panel", "isEnabled", false) ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $cha5E.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $99V2N = parcelRequire("99V2N");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $99V2N.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $99V2N.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("4vI1F", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zbjaW",
    name: "ObjectSidebarContent",
    loader: async ()=>(await (parcelRequire("9GAWF"))).ObjectSidebarContent
});
module.exports["ObjectSidebarContent"] = $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955;

});

parcelRegister("9GAWF", function(module, exports) {

let $70d4b1e04ffeca99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $70d4b1e04ffeca99$var$load("35mvB"),
    $70d4b1e04ffeca99$var$load("g9l6t"),
    $70d4b1e04ffeca99$var$load("hhu66"),
    $70d4b1e04ffeca99$var$load("3alGb")
]).then(()=>parcelRequire('23xdA'));

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    PanelName["SuggestionsPanel"] = "suggestionsPanel";
    PanelName["AutomationsPanel"] = "automationsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    "suggestionsPanel",
    "automationsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    showSidebarControlIfNoPanel: ()=>({ setState: setState, getState: getState })=>{
            // Read the store at dispatch time rather than relying on a React render snapshot.
            // A deeplink can open the panel between render and a passive effect being flushed.
            if (!getState().isObjectSidebarShown) setState({
                sidebarControlState: 'shown'
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("2vuKf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $kBr4q.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $kBr4q.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $kBr4q.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("aboIx", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS = new Set([
    'bitbucket',
    'github'
]);
const $95f2a41306aaddc5$var$isDevDocsContainerApp = (containerApp)=>Boolean(containerApp && $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS.has(containerApp.trim().toLowerCase()));
const $95f2a41306aaddc5$export$270f9eb55072514a = ({ propertyCollections: propertyCollections = [] })=>{
    if (propertyCollections.some((properties)=>(0, $6rBRz.hasDevDocsContentProperty)(properties))) return true;
    return propertyCollections.some((properties)=>$95f2a41306aaddc5$var$isDevDocsContainerApp((0, $6rBRz.getDevDocsSmartFolderProperties)(properties)?.containerApp));
};
const $95f2a41306aaddc5$export$4977c1f16ed3f03f = ({ ownershipProperties: ownershipProperties, smartFolderProperties: smartFolderProperties })=>$95f2a41306aaddc5$export$270f9eb55072514a({
        propertyCollections: [
            ownershipProperties,
            smartFolderProperties
        ]
    });
module.exports["isDevDocsOwnedFolder"] = $95f2a41306aaddc5$export$270f9eb55072514a;
module.exports["shouldExcludeDevDocsAutoSync"] = $95f2a41306aaddc5$export$4977c1f16ed3f03f;

});

parcelRegister("6rBRz", function(module, exports) {
const $7f56be30e613d57d$export$717f665ef6ce5e67 = 'devdocsProperties';
const $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $7f56be30e613d57d$var$parseContentPropertyValue = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) return null;
            const value = parsedValue.value;
            if (typeof value === 'string' || value && typeof value === 'object') {
                parsedValue = value;
                continue;
            }
            return parsedValue;
        }
    } catch  {
        return null;
    }
    return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : null;
};
const $7f56be30e613d57d$var$getStringValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return typeof value === 'string' && value.length > 0 ? value : null;
};
const $7f56be30e613d57d$var$getBooleanValue = (parsedValue, key)=>parsedValue[key] === true;
const $7f56be30e613d57d$var$getObjectValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
};
const $7f56be30e613d57d$export$48d1088454f9afc1 = (properties)=>{
    const devDocsProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67);
    const parsedValue = devDocsProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(devDocsProperties.value) : null;
    return parsedValue ? {
        customPrompt: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'customPrompt'),
        ref: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'ref'),
        repoName: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'repoName'),
        syncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncTaskAri')
    } : null;
};
const $7f56be30e613d57d$export$8cfd9e7aae7c88a3 = (properties)=>Boolean(properties?.some((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67));
const $7f56be30e613d57d$export$a9f33e9d1e3524ad = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY);
    const parsedValue = smartFolderProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(smartFolderProperties.value) : null;
    return parsedValue ? {
        containerApp: $7f56be30e613d57d$var$getStringValue(parsedValue, 'containerApp'),
        lastSynced: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSynced'),
        lastSyncAttemptedAt: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncAttemptedAt'),
        lastSyncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncTaskAri'),
        syncErrorType: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncErrorType'),
        syncInProgress: $7f56be30e613d57d$var$getBooleanValue(parsedValue, 'syncInProgress')
    } : null;
};
module.exports["getDevDocsProperties"] = $7f56be30e613d57d$export$48d1088454f9afc1;
module.exports["hasDevDocsContentProperty"] = $7f56be30e613d57d$export$8cfd9e7aae7c88a3;
module.exports["getDevDocsSmartFolderProperties"] = $7f56be30e613d57d$export$a9f33e9d1e3524ad;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $hZpML = parcelRequire("hZpML");


var $cemw8 = parcelRequire("cemw8");


var $8zKDl = parcelRequire("8zKDl");


var $dAPGk = parcelRequire("dAPGk");

const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $dAPGk.useSuspenseBoundaryName)();
} : ()=>(0, $dAPGk.useSuspenseBoundaryName)();
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)((0, $dAPGk.SuspenseBoundaryNameContext));
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = (0, $cozmU.useMemo)(()=>[
            ...parentBoundaryChain,
            dataFetcherName
        ], [
        parentBoundaryChain,
        dataFetcherName
    ]);
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAPGk.SuspenseBoundaryNameContext).Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("fZAJP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $cozmU.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("jAOzg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $9612d889a12dc002$var$createSyncStore() {
    let syncingFolderIds = new Set();
    const listeners = new Set();
    const notify = ()=>{
        listeners.forEach((listener)=>listener());
    };
    return {
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        getSnapshot: ()=>syncingFolderIds,
        addSyncingFolder: (folderId)=>{
            if (syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.add(folderId);
            syncingFolderIds = next;
            notify();
        },
        removeSyncingFolder: (folderId)=>{
            if (!syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.delete(folderId);
            syncingFolderIds = next;
            notify();
        }
    };
}
/**
 * A store-based context for tracking which folders are syncing.
 *
 * Uses `useSyncExternalStore` so that each `useIsFolderSyncing(folderId)`
 * subscriber only re-renders when their specific folder's sync boolean
 * changes — not when any arbitrary folder starts/stops syncing.
 *
 * - `SmartFolderSyncStoreContext` holds the store instance.
 * - `SmartFolderSyncActionsContext` holds stable `add`/`remove` callbacks
 *   for writers (e.g. `useSmartFolderSync`) that never re-render on state change.
 */ const $9612d889a12dc002$var$SmartFolderSyncStoreContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $9612d889a12dc002$var$SmartFolderSyncActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    addSyncingFolder: ()=>{},
    removeSyncingFolder: ()=>{}
});
const $9612d889a12dc002$export$a225af674c9c7799 = ({ children: children })=>{
    const storeRef = (0, $cozmU.useRef)(null);
    if (storeRef.current === null) storeRef.current = $9612d889a12dc002$var$createSyncStore();
    const store = storeRef.current;
    const actions = (0, $cozmU.useMemo)(()=>({
            addSyncingFolder: store.addSyncingFolder,
            removeSyncingFolder: store.removeSyncingFolder
        }), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9612d889a12dc002$var$SmartFolderSyncStoreContext.Provider, {
        value: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9612d889a12dc002$var$SmartFolderSyncActionsContext.Provider, {
        value: actions
    }, children));
};
const $9612d889a12dc002$var$EMPTY_SET = new Set();
const $9612d889a12dc002$var$EMPTY_SUBSCRIBE = (_cb)=>()=>{};
const $9612d889a12dc002$var$EMPTY_SNAPSHOT = ()=>$9612d889a12dc002$var$EMPTY_SET;
const $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL = ()=>false;
const $9612d889a12dc002$export$35a8d8248145227a = ()=>{
    const store = (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    return (0, $cozmU.useSyncExternalStore)(store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE, store?.getSnapshot ?? $9612d889a12dc002$var$EMPTY_SNAPSHOT, $9612d889a12dc002$var$EMPTY_SNAPSHOT);
};
const $9612d889a12dc002$export$4cd077b71db9ec99 = (folderId)=>{
    const store = (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    const subscribe = store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE;
    const getSnapshot = (0, $cozmU.useCallback)(()=>store ? store.getSnapshot().has(folderId) : false, [
        store,
        folderId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL);
};
const $9612d889a12dc002$export$8a3c75bc060e9cf8 = ()=>{
    return (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncActionsContext);
};
const $9612d889a12dc002$export$f1204087fc222a72 = (folderId, isSyncing)=>{
    const { addSyncingFolder: addSyncingFolder, removeSyncingFolder: removeSyncingFolder } = $9612d889a12dc002$export$8a3c75bc060e9cf8();
    (0, $cozmU.useEffect)(()=>{
        if (!isSyncing) return;
        addSyncingFolder(folderId);
        return ()=>{
            removeSyncingFolder(folderId);
        };
    }, [
        addSyncingFolder,
        folderId,
        isSyncing,
        removeSyncingFolder
    ]);
};
module.exports["SmartFolderSyncProvider"] = $9612d889a12dc002$export$a225af674c9c7799;
module.exports["useIsFolderSyncing"] = $9612d889a12dc002$export$4cd077b71db9ec99;
module.exports["useFolderSyncActions"] = $9612d889a12dc002$export$8a3c75bc060e9cf8;
module.exports["usePublishSmartFolderSyncState"] = $9612d889a12dc002$export$f1204087fc222a72;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const shouldSkipQuery = !isSmartFoldersSupported || !spaceKey;
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: shouldSkipQuery,
        __callerPackage__: "smart-folder"
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("9bYqt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6ebeb54b6dd4e1b6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $04900d7fce8c855a$export$2e2bcd8739ae039 = {
    "navigation.global-invite.error-state-description": "Try refreshing the page or contact us if the problem persists.",
    "navigation.global-invite.error-state-heading": "We can't load the invite list right now",
    "navigation.global-invite.loading-visually-hidden-label": "Loading",
    "navigation.global-invite.modal-dialog-label": "Invite people"
};


var $6ebeb54b6dd4e1b6$export$2e2bcd8739ae039 = (0, $04900d7fce8c855a$export$2e2bcd8739ae039);

});

parcelRegister("9z9Sl", function(module, exports) {

let $6f6f0b0752b9a0b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f6f0b0752b9a0b8$var$load("3xGk3").then(()=>parcelRequire('6aGGK'));

});

parcelRegister("kdftj", function(module, exports) {

let $eb7105f08e058163$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb7105f08e058163$var$load("6UvAM").then(()=>parcelRequire('9K8Or'));

});

parcelRegister("Is4v8", function(module, exports) {

let $0859e29c49d04aca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0859e29c49d04aca$var$load("deCnX").then(()=>parcelRequire('4bjH0'));

});

parcelRegister("78Q3c", function(module, exports) {

let $5331a7f198e46f3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5331a7f198e46f3c$var$load("cRXHQ").then(()=>parcelRequire('9hlv4'));

});

parcelRegister("1bED2", function(module, exports) {

let $0dd6558cf822ec29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0dd6558cf822ec29$var$load("8y8Lu").then(()=>parcelRequire('ftvNl'));

});

parcelRegister("7qcoz", function(module, exports) {

let $56749394b0186549$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56749394b0186549$var$load("qstvS").then(()=>parcelRequire('7jOgP'));

});

parcelRegister("aruDH", function(module, exports) {

let $79a43156bd6ba3fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79a43156bd6ba3fc$var$load("ikk15").then(()=>parcelRequire('fDO36'));

});

parcelRegister("ebEFX", function(module, exports) {

let $a541a51b39c14bd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a541a51b39c14bd1$var$load("gpMM6").then(()=>parcelRequire('6g5yJ'));

});

parcelRegister("j1P3i", function(module, exports) {

let $dda5b63215b083e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dda5b63215b083e0$var$load("3nWtY").then(()=>parcelRequire('19CEc'));

});

parcelRegister("96lDB", function(module, exports) {

let $6a05756d4af10282$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a05756d4af10282$var$load("liFDI").then(()=>parcelRequire('6cgit'));

});

parcelRegister("7xpIz", function(module, exports) {

let $57cf908394a74bf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57cf908394a74bf6$var$load("imuyR").then(()=>parcelRequire('lMyRe'));

});

parcelRegister("kDdpi", function(module, exports) {

let $f051d97f0752dbbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f051d97f0752dbbb$var$load("eRuEp").then(()=>parcelRequire('i4TtY'));

});

parcelRegister("furxn", function(module, exports) {

let $b46f04ad987e6123$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b46f04ad987e6123$var$load("769BO").then(()=>parcelRequire('k8ECO'));

});

parcelRegister("1xorX", function(module, exports) {

let $11ebd6c775a6afbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11ebd6c775a6afbb$var$load("c72lo").then(()=>parcelRequire('2sPLo'));

});

parcelRegister("a8BIS", function(module, exports) {

let $7617e9b676ce80f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7617e9b676ce80f7$var$load("9puyy").then(()=>parcelRequire('gDLwU'));

});

parcelRegister("2L1sx", function(module, exports) {

let $20211a54b060a3fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20211a54b060a3fd$var$load("6DJB1").then(()=>parcelRequire('4o7FX'));

});

parcelRegister("ctn08", function(module, exports) {

let $914a090474d74ca4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $914a090474d74ca4$var$load("jf3Df").then(()=>parcelRequire('cDFPo'));

});

parcelRegister("abBcf", function(module, exports) {

let $76a7c8ed21e23a68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76a7c8ed21e23a68$var$load("beTW0").then(()=>parcelRequire('8maa8'));

});

parcelRegister("9XDV4", function(module, exports) {

let $740896ed4d14992c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $740896ed4d14992c$var$load("aTIh7").then(()=>parcelRequire('4E2ml'));

});

parcelRegister("7p3hh", function(module, exports) {

let $563d6914de543839$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $563d6914de543839$var$load("bdS5p").then(()=>parcelRequire('5rrGC'));

});

parcelRegister("gqOnY", function(module, exports) {

let $bf6628921bd0ac3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf6628921bd0ac3b$var$load("cvsqT").then(()=>parcelRequire('kTYCB'));

});

parcelRegister("gMVzI", function(module, exports) {

let $c38dca40d60e7516$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c38dca40d60e7516$var$load("1Scrf").then(()=>parcelRequire('iCTIC'));

});

parcelRegister("fnG5V", function(module, exports) {

let $b329a816c356ec60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b329a816c356ec60$var$load("gn448").then(()=>parcelRequire('jgpvp'));

});

parcelRegister("d3dgL", function(module, exports) {

let $9805d930718d6687$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9805d930718d6687$var$load("1szEl").then(()=>parcelRequire('2HMk5'));

});

parcelRegister("a9aSv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("jDSaY", function(module, exports) {

let $e4cbaf0ce986d78c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4cbaf0ce986d78c$var$load("6dLts"),
    $e4cbaf0ce986d78c$var$load("jdPbE"),
    $e4cbaf0ce986d78c$var$load("1audf"),
    $e4cbaf0ce986d78c$var$load("bpBPu"),
    $e4cbaf0ce986d78c$var$load("4g6rd"),
    $e4cbaf0ce986d78c$var$load("6wr18"),
    $e4cbaf0ce986d78c$var$load("hE9re"),
    $e4cbaf0ce986d78c$var$load("lrXQY"),
    $e4cbaf0ce986d78c$var$load("kQNKW"),
    $e4cbaf0ce986d78c$var$load("fo4nX"),
    $e4cbaf0ce986d78c$var$load("kHXvF"),
    $e4cbaf0ce986d78c$var$load("hhss7"),
    $e4cbaf0ce986d78c$var$load("ffEVr"),
    $e4cbaf0ce986d78c$var$load("Wowvf"),
    $e4cbaf0ce986d78c$var$load("7EorR"),
    $e4cbaf0ce986d78c$var$load("kJLMk")
]).then(()=>parcelRequire('b419Y'));

});

parcelRegister("5nuFe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f7e158d3e97078e1$export$e5c6d63c1f3f867f = (0, $cozmU.createContext)({
    usePageRecommendationData: ()=>({
            data: undefined,
            loading: false,
            hoverPageError: undefined,
            recPageError: undefined
        }),
    useInlineReactionsData: (_numberOfReactedUsers, _skip)=>({
            data: {
                authorName: undefined,
                authorAvatar: undefined,
                reactionsCount: undefined,
                reactionsSummary: undefined,
                reactedUsers: undefined,
                userId: undefined,
                activationId: undefined
            },
            loading: false,
            error: undefined
        }),
    getPageDataFromUrl: ()=>({
            contentId: undefined,
            contentType: undefined,
            spaceKey: undefined
        }),
    emojiProvider: undefined
});
module.exports["ConfluenceExperimentsContext"] = $f7e158d3e97078e1$export$e5c6d63c1f3f867f;

});

parcelRegister("ibHYv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $982461640a7c7c8c$export$a4add0dacb108c5e = 'twcg-2112-twc-xflow-conf-pages-templates';
const $982461640a7c7c8c$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $982461640a7c7c8c$export$730cc5718beea0d0 = ()=>{
    return (0, $cozmU.useContext)($982461640a7c7c8c$var$PostOfficeSideNavMessageContext);
};
const $982461640a7c7c8c$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $cozmU.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $cozmU.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const disablePostOfficeSideNavMessage = (0, $cozmU.useCallback)((message)=>{
        setEnabledMessages((prev)=>prev.includes(message) ? prev.filter((enabledMessage)=>enabledMessage !== message) : prev);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage,
            disablePostOfficeSideNavMessage: disablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage,
        disablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($982461640a7c7c8c$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["TEMPLATE_XFLOW_EXPERIMENT_KEY"] = $982461640a7c7c8c$export$a4add0dacb108c5e;
module.exports["usePostOfficeSideNavMessages"] = $982461640a7c7c8c$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $982461640a7c7c8c$export$1a1a764f5b0fd0ac;

});

parcelRegister("3EQfi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $k4HA2 = parcelRequire("k4HA2");


var $1RMKR = parcelRequire("1RMKR");


var $bP5wt = parcelRequire("bP5wt");


var $abSyI = parcelRequire("abSyI");


var $j5DVd = parcelRequire("j5DVd");


var $jS1GQ = parcelRequire("jS1GQ");


var $cozmU = parcelRequire("cozmU");


var $lEAVV = parcelRequire("lEAVV");


var $1ohAV = parcelRequire("1ohAV");

const $bbbd138b1b3c99f0$export$bc250e7dd49b34c = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $bbbd138b1b3c99f0$var$createFrontendPlacementMessageTemplateRouter({
                    ...placementConfig,
                    ...config
                });
                return (0, $lEAVV.createPlacementComponentV2)(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
// The published renderer omits the category from its context; retain its other fields.
const $bbbd138b1b3c99f0$var$MessageCategoryProvider = ({ messageCategory: messageCategory, children: children })=>{
    const messageContext = (0, $k4HA2.useMessageContext)();
    const value = (0, $cozmU.useMemo)(()=>({
            ...messageContext,
            messageCategory: messageCategory
        }), [
        messageContext,
        messageCategory
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
        value: value,
        children: children
    });
};
// Local copy of the flag string. placement-contexts gates page-load order on the same
// name and does not export it. Keep in sync with the test's NARROW_EXPOSURE_V2_GATE.
const $bbbd138b1b3c99f0$var$NARROW_EXPOSURE_V2_GATE = 'post-office_enable_narrow-exposure-v2';
const $bbbd138b1b3c99f0$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        const isHeadless = config.headlessMessageTemplateIds?.includes(messageTemplateId);
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: 'Message',
            stageName: config?.stageName,
            placementId: config.placementId
        };
        (0, $cozmU.useEffect)(()=>{
            if (isHeadless && renderableStage) // eslint-disable-next-line no-console
            console.error(new (0, $1ohAV.PlacementMessageError)({
                ...placementLocation,
                ...config
            }), 'Misconfiguration: message is registered as both headless and has a MessageFrontend renderer. Remove it from headlessMessageTemplateIds or remove the MessageFrontend export.');
            if (!isHeadless && !renderableStage) // eslint-disable-next-line no-console
            console.error(new (0, $1ohAV.PlacementMessageError)({
                ...placementLocation,
                ...config
            }), 'Misconfiguration: message is not registered as headless but has no MessageFrontend renderer. Register it as a headless message by reinstalling or add a MessageFrontend export.');
        }, [
            isHeadless,
            placementLocation,
            renderableStage,
            config
        ]);
        const componentPropsStable = (0, $1RMKR.useStableObject)(props);
        const messageProps = props;
        const triggerType = messageProps.triggerType ?? messageProps.context?.triggerType;
        const hasTrigger = (0, $jS1GQ.isClientTriggeredMessage)(triggerType);
        const isNarrowExposureV2Enabled = (0, $cXtTj.default).checkGate($bbbd138b1b3c99f0$var$NARROW_EXPOSURE_V2_GATE);
        const narrowExposureConfig = isNarrowExposureV2Enabled ? inAppNarrowExposureExperiment : undefined;
        const { waitForTrigger: waitForTrigger } = (0, $bP5wt.useWaitForTrigger)({
            hasTrigger: hasTrigger,
            messageSuccessComponent: undefined,
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            inAppNarrowExposureExperiment: narrowExposureConfig
        });
        if (inAppNarrowExposureExperiment && !isNarrowExposureV2Enabled) return null;
        if (!renderableStage) return null;
        try {
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            });
            const { Component: Component } = renderableStage;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $abSyI.MessageRendererProvider), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                waitForTrigger: waitForTrigger,
                inAppNarrowExposureExperiment: narrowExposureConfig,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)($bbbd138b1b3c99f0$var$MessageCategoryProvider, {
                    messageCategory: messageCategory,
                    children: [
                        !waitForTrigger && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.MessageViewed), {}),
                        /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                            ...props,
                            waitForTrigger: waitForTrigger,
                            children: children
                        })
                    ]
                })
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error((0, $1ohAV.createPlacementMessageError)(error));
            return null;
        }
    };
const $bbbd138b1b3c99f0$var$createFrontendPlacementMessageTemplateRouter = (config)=>{
    const messageTemplateLookup = $bbbd138b1b3c99f0$var$createMessageTemplateByStageLookup(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $bbbd138b1b3c99f0$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId,
                headlessMessageTemplateIds: config.headlessMessageTemplateIds
            })
        }), {});
};
const $bbbd138b1b3c99f0$var$createMessageTemplateByStageLookup = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};
module.exports["createPlacementFrontend"] = $bbbd138b1b3c99f0$export$bc250e7dd49b34c;

});

parcelRegister("1RMKR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $323d99f2c95b5263$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $323d99f2c95b5263$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>obj, $323d99f2c95b5263$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $323d99f2c95b5263$export$ed02d4adf2068b08;

});

parcelRegister("bP5wt", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $wnnKE = parcelRequire("wnnKE");


var $8hKSa = parcelRequire("8hKSa");


var $7NHN3 = parcelRequire("7NHN3");

/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $5ae52cbfb074d546$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $cozmU.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        messageInstanceViewed(additionalMetadataFromFrontend);
        onShow?.();
    // Intentional empty deps: this effect must fire exactly once after the first commit.
    // The values captured here are the ones the caller passed at mount, which is the desired
    // "as of when the message was shown" semantic — if a caller subsequently passes a new
    // onShow or metadata, we should NOT fire again. Using non-empty deps would also cause
    // this effect to re-register on every render whenever a caller passes an unmemoized
    // `additionalMetadataFromFrontend={{ ... }}` literal, even though the body is a no-op
    // after first run. Strict-Mode double-invocation is still handled by hasShownRef.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
const $5ae52cbfb074d546$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const waitForTriggerCalledRef = (0, $cozmU.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $cozmU.useCallback)(({ isTriggerActive: isTriggerActive, messageContent: messageContent, onMessageShown: onMessageShown, additionalMetadataFromFrontend: additionalMetadataFromFrontend, onTeardown: onTeardown })=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        const messageContentWithOptionalTeardown = onTeardown !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hKSa.UnmountCleanup), {
            onCleanup: onTeardown,
            children: messageContent
        }) : messageContent;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $wnnKE.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ae52cbfb074d546$var$OnChoreographerApproved, {
                onShow: onMessageShown,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContentWithOptionalTeardown
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent,
        inAppNarrowExposureExperiment
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
module.exports["useWaitForTrigger"] = $5ae52cbfb074d546$export$b5884e72fa051e28;

});

parcelRegister("wnnKE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $5ydwr = parcelRequire("5ydwr");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $6NRmI = parcelRequire("6NRmI");

const $4a16561cf48266ce$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldClaim = (0, $5ydwr.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        shouldClaim: shouldClaim
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $4a16561cf48266ce$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($4a16561cf48266ce$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $4a16561cf48266ce$export$8db7ba034addcd65;

});

parcelRegister("8hKSa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

const $522a2bdcd9585e84$export$ea970fe2c565070a = ({ onCleanup: onCleanup, children: children })=>{
    const onCleanupRef = (0, $cozmU.useRef)(onCleanup);
    (0, $4mjUI.useLayoutEffect)(()=>{
        onCleanupRef.current = onCleanup;
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onCleanupRef.current?.();
        };
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["UnmountCleanup"] = $522a2bdcd9585e84$export$ea970fe2c565070a;

});

parcelRegister("4mjUI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * `useLayoutEffect` warns during SSR ("Warning: useLayoutEffect does nothing on the server").
 * Fall back to `useEffect` on the server so utilities in this package are safe to render in SSR
 * contexts. In the browser the synchronous commit-time semantics of `useLayoutEffect` are preserved.
 *
 * Consumers import this as `useLayoutEffect` so the call site reads identically to React's hook.
 *
 * See: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */ const $c7f27652ce5a6cdc$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
module.exports["useLayoutEffect"] = $c7f27652ce5a6cdc$export$e5c5a5f917a5871c;

});

parcelRegister("7NHN3", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

const $b15c706fb306d92c$export$39b0f5626e96f41e = (0, $kEPax.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $b15c706fb306d92c$export$39b0f5626e96f41e;

});

parcelRegister("abSyI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $jTNdj = parcelRequire("jTNdj");


var $k4HA2 = parcelRequire("k4HA2");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $wnnKE = parcelRequire("wnnKE");


var $1dHYE = parcelRequire("1dHYE");


var $d4rpM = parcelRequire("d4rpM");


var $gKIF0 = parcelRequire("gKIF0");


var $b4B1V = parcelRequire("b4B1V");


var $44R0O = parcelRequire("44R0O");


var $9Nqm6 = parcelRequire("9Nqm6");

const $0175ab9abc1530ea$var$DEFAULT_RECOMMENDATION_SESSION = {};
// https://switcheroo.atlassian.com/ui/gates/f85b4999-0bc2-4a97-85ef-821877ca73fc/key/post-office_enable_narrow-exposure-v2
const $0175ab9abc1530ea$var$NARROW_EXPOSURE_V2_GATE = 'post-office_enable_narrow-exposure-v2';
const $0175ab9abc1530ea$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), waitForTrigger: waitForTrigger, configSetId: configSetId, journeyId: journeyId, journeyTriggerId: journeyTriggerId, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const subscriptionConfig = (0, $9Nqm6.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    /**
   * Type guard: messageContextMemo must match MessageContextData exactly.
   * If a field is missing or wrong type, the type annotation will catch it.
   */ const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
            name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $cozmU.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            transactionAccountId: componentProps.transactionAccountId,
            analyticsDetails: {
                ...postOffice?.analyticsDetails,
                subscriptionEnabled: subscriptionEnabled
            },
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps.transactionAccountId,
        postOffice?.analyticsDetails,
        subscriptionEnabled,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const message = /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
        fallback: loadingComponent,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gKIF0.MaybeTriggeredMessageValidator), {
            waitForTrigger: waitForTrigger,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4B1V.MessageAnalyticsContextProvider), {
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $44R0O.MaybeManualMessageViewedEvent), {
                    isManual: !!waitForTrigger,
                    children: [
                        !waitForTrigger && messageSuccessComponent,
                        children
                    ]
                })
            })
        })
    });
    const withMessageContext = (content)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
            value: messageContextMemo,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                value: recommendationSession ?? $0175ab9abc1530ea$var$DEFAULT_RECOMMENDATION_SESSION,
                children: content
            })
        });
    const isNarrowExposureV2Enabled = (0, $cXtTj.default).checkGate($0175ab9abc1530ea$var$NARROW_EXPOSURE_V2_GATE);
    // MaybeChoreographerWrapper sits above the lazy template so it can claim its slot while it loads;
    // it no-ops for client-triggered messages, which choreograph via MaybeTriggeredMessageValidator.
    const withChoreographer = (content)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dHYE.MaybeChoreographerWrapper), {
            ChoreographerWrapper: (0, $wnnKE.ChoreographerWrapper),
            enabled: !waitForTrigger,
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            inAppNarrowExposureExperiment: isNarrowExposureV2Enabled ? inAppNarrowExposureExperiment : undefined,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4rpM.FeatureFlaggedUfoWrapper), {
                messageTemplateId: messageTemplateId,
                isEnabled: isUFOEnabled,
                children: content
            })
        });
    // A narrow exposure shouldClaim needs message and recommendation context above the
    // choreographer to post a dropped event for this message.
    return isNarrowExposureV2Enabled ? withMessageContext(withChoreographer(message)) : withChoreographer(withMessageContext(message));
};
module.exports["MessageRendererProvider"] = $0175ab9abc1530ea$export$5fe06fe68913d493;

});

parcelRegister("jTNdj", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $65DSU = parcelRequire("65DSU");

const $8f5948bf59d85fb8$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $b8pma.default),
    UFOSegment: (0, $65DSU.default)
};
module.exports["UFOv2"] = $8f5948bf59d85fb8$export$c91b09caa8ecbab1;

});

parcelRegister("1dHYE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

const $c24c1359cebc9ade$export$738797901aa9197a = ({ ChoreographerWrapper: ChoreographerWrapper, enabled: enabled, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, children: children })=>{
    if (!enabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(ChoreographerWrapper, {
        messageId: messageId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
        children: children
    });
};
module.exports["MaybeChoreographerWrapper"] = $c24c1359cebc9ade$export$738797901aa9197a;

});

parcelRegister("d4rpM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");

const $2edd5268d1298569$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $2edd5268d1298569$export$8e6fb7035018b3e4;

});

parcelRegister("gKIF0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $k50GG = parcelRequire("k50GG");

const $721b9c50d6cef8f5$export$dac988aa97dc7b79 = ({ children: children, waitForTrigger: waitForTrigger })=>{
    if (!waitForTrigger) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k50GG.TriggeredMessageValidator), {
        waitForTrigger: waitForTrigger,
        children: children
    });
};
module.exports["MaybeTriggeredMessageValidator"] = $721b9c50d6cef8f5$export$dac988aa97dc7b79;

});

parcelRegister("k50GG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $7edc18d494c18e25$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $cozmU.useState)('pending');
    (0, $4mjUI.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            setValidated('allowed');
            return;
        }
        // Ref not set after template had a chance to run.
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: isHidden ? $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
};
module.exports["TriggeredMessageValidator"] = $7edc18d494c18e25$export$c8b5f992b8a1b38b;

});

parcelRegister("b4B1V", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $38aadf7fa80db7e7$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $cozmU.createContext)($38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue);
const $38aadf7fa80db7e7$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $cozmU.useRef)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($38aadf7fa80db7e7$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $38aadf7fa80db7e7$export$bb426ba114b64992 = ()=>(0, $cozmU.useContext)($38aadf7fa80db7e7$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $38aadf7fa80db7e7$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $38aadf7fa80db7e7$export$bb426ba114b64992;

});

parcelRegister("44R0O", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $j5DVd = parcelRequire("j5DVd");

const $18ac7c17ff477189$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    return isManual ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["MaybeManualMessageViewedEvent"] = $18ac7c17ff477189$export$9915b88f81e90e6e;

});

parcelRegister("j5DVd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $7NHN3 = parcelRequire("7NHN3");


var $baFbJ = parcelRequire("baFbJ");


var $cozmU = parcelRequire("cozmU");


var $lixOz = parcelRequire("lixOz");


var $b4B1V = parcelRequire("b4B1V");


var $1NVwf = parcelRequire("1NVwf");

const $08ec3000a15d9da6$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
const $08ec3000a15d9da6$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $cozmU.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $08ec3000a15d9da6$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $cozmU.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $lixOz.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $8aG6j.jsx)($08ec3000a15d9da6$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
module.exports["ManualMessageViewedEvent"] = $08ec3000a15d9da6$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $08ec3000a15d9da6$export$14fe1fc3395b6e3f;

});

parcelRegister("baFbJ", function(module, exports) {

var $di43e = parcelRequire("di43e");


var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $4cICV = parcelRequire("4cICV");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $5Rfgj = parcelRequire("5Rfgj");

parcelRequire("aByw7");
var $dEG1b = parcelRequire("dEG1b");


var $lOnm2 = parcelRequire("lOnm2");

const $858a4870c67919f0$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $cozmU.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $lOnm2.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $lOnm2.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $lOnm2.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $cozmU.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};
module.exports["useMessageEvent"] = $858a4870c67919f0$export$3cbbf1e81e2ecb39;

});

parcelRegister("5Rfgj", function(module, exports) {
class $4253c717b3565d29$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $4253c717b3565d29$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}
module.exports["MessageLifecycleContextError"] = $4253c717b3565d29$export$12bb62b204112f55;
module.exports["MessageLifecycleClientError"] = $4253c717b3565d29$export$44f397e2afeb89e0;

});

parcelRegister("aByw7", function(module, exports) {
$parcel$export(module.exports, "MessageEventClient", () => (parcelRequire("dEG1b")).MessageEventClient);
/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */ 
var $dEG1b = parcelRequire("dEG1b");


});

parcelRegister("lOnm2", function(module, exports) {
var $984aeda379ad7f1a$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
module.exports["InAppMessageEventType"] = $984aeda379ad7f1a$export$b31ffc6f7c85f1b;

});

parcelRegister("lixOz", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $f8158248d0f47600$export$6215040b989f9b0f, (v) => $f8158248d0f47600$export$6215040b989f9b0f = v);
var $f8158248d0f47600$export$1e511d4a378977f5;
var $f8158248d0f47600$export$6215040b989f9b0f;
var $f8158248d0f47600$export$436b63fa4855237f;
var $f8158248d0f47600$export$2e2bcd8739ae039;
var $f8158248d0f47600$export$95cef81be5ddcfd4;
"use strict";
$f8158248d0f47600$export$1e511d4a378977f5 = true;
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$export$95cef81be5ddcfd4 = void 0;

var $f8158248d0f47600$var$_handleViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("3Tfn6")));
$f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$var$_handleViewport.default;

var $f8158248d0f47600$var$_useInViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("byriw")));
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$var$_useInViewport.default;
function $f8158248d0f47600$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $f8158248d0f47600$var$customProps = $f8158248d0f47600$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $f8158248d0f47600$var$_default = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$var$_handleViewport.default;

});

parcelRegister("3Tfn6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $2d526ea1e19243c2$export$1e511d4a378977f5, (v) => $2d526ea1e19243c2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2d526ea1e19243c2$export$2e2bcd8739ae039, (v) => $2d526ea1e19243c2$export$2e2bcd8739ae039 = v);
var $2d526ea1e19243c2$export$1e511d4a378977f5;
var $2d526ea1e19243c2$export$2e2bcd8739ae039;
"use strict";
$2d526ea1e19243c2$export$1e511d4a378977f5 = true;
$2d526ea1e19243c2$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $2d526ea1e19243c2$var$_hoistNonReactStatics = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("aH9xZ")));

var $2d526ea1e19243c2$var$_useInViewport = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("byriw")));

var $3dWch = parcelRequire("3dWch");


var $8aG6j = parcelRequire("8aG6j");

var $2d526ea1e19243c2$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $2d526ea1e19243c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2d526ea1e19243c2$var$_extends() {
    return $2d526ea1e19243c2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d526ea1e19243c2$var$_extends.apply(null, arguments);
}
function $2d526ea1e19243c2$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(TargetComponent, $2d526ea1e19243c2$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $3dWch.noop, onLeaveViewport: onLeaveViewport = $3dWch.noop } = _ref, restProps = $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(_ref, $2d526ea1e19243c2$var$_excluded);
        var node = (0, $cozmU.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $2d526ea1e19243c2$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $2d526ea1e19243c2$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ForwardedRefComponent, $2d526ea1e19243c2$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $2d526ea1e19243c2$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $2d526ea1e19243c2$var$_default = $2d526ea1e19243c2$export$2e2bcd8739ae039 = $2d526ea1e19243c2$var$handleViewport;

});

parcelRegister("byriw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $86980b6f9121fe40$export$1e511d4a378977f5, (v) => $86980b6f9121fe40$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $86980b6f9121fe40$export$2e2bcd8739ae039, (v) => $86980b6f9121fe40$export$2e2bcd8739ae039 = v);
var $86980b6f9121fe40$export$1e511d4a378977f5;
var $86980b6f9121fe40$export$2e2bcd8739ae039;
"use strict";
$86980b6f9121fe40$export$1e511d4a378977f5 = true;
$86980b6f9121fe40$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $3dWch = parcelRequire("3dWch");

var $86980b6f9121fe40$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $86980b6f9121fe40$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    if (props === void 0) props = $3dWch.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $cozmU.useState)();
    var observer = (0, $cozmU.useRef)();
    var inViewportRef = (0, $cozmU.useRef)(false);
    var intersected = (0, $cozmU.useRef)(false);
    var enterCountRef = (0, $cozmU.useRef)(0);
    var leaveCountRef = (0, $cozmU.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $cozmU.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $cozmU.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $cozmU.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $86980b6f9121fe40$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $86980b6f9121fe40$var$_default = $86980b6f9121fe40$export$2e2bcd8739ae039 = $86980b6f9121fe40$var$useInViewport;

});

parcelRegister("3dWch", function(module, exports) {
$parcel$export(module.exports, "noop", () => $258fbab87dea3908$export$8793edee2d425525, (v) => $258fbab87dea3908$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $258fbab87dea3908$export$9c21a3269931e1e6, (v) => $258fbab87dea3908$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $258fbab87dea3908$export$ba43bf67f3d48107, (v) => $258fbab87dea3908$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $258fbab87dea3908$export$f84bd70098573c5c, (v) => $258fbab87dea3908$export$f84bd70098573c5c = v);
var $258fbab87dea3908$export$1e511d4a378977f5;
var $258fbab87dea3908$export$8793edee2d425525;
var $258fbab87dea3908$export$9c21a3269931e1e6;
var $258fbab87dea3908$export$ba43bf67f3d48107;
var $258fbab87dea3908$export$f84bd70098573c5c;
"use strict";
$258fbab87dea3908$export$1e511d4a378977f5 = true;
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$export$9c21a3269931e1e6 = $258fbab87dea3908$export$ba43bf67f3d48107 = $258fbab87dea3908$export$f84bd70098573c5c = void 0;
var $258fbab87dea3908$var$defaultOptions = $258fbab87dea3908$export$ba43bf67f3d48107 = {};
var $258fbab87dea3908$var$defaultConfig = $258fbab87dea3908$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $258fbab87dea3908$var$noop = ()=>{};
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$var$noop;
var $258fbab87dea3908$var$defaultProps = $258fbab87dea3908$export$9c21a3269931e1e6 = {
    onEnterViewport: $258fbab87dea3908$var$noop,
    onLeaveViewport: $258fbab87dea3908$var$noop
};

});

parcelRegister("1NVwf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $2808315b9dcd7678$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $2808315b9dcd7678$export$21b400a8c8ebc91a;

});

parcelRegister("9Nqm6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $ffaea1b52a58fd24$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscription: undefined
});
const $ffaea1b52a58fd24$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ffaea1b52a58fd24$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $ffaea1b52a58fd24$export$1129f1fe63b2d7ab = ()=>{
    return (0, $cozmU.useContext)($ffaea1b52a58fd24$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $ffaea1b52a58fd24$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $ffaea1b52a58fd24$export$1129f1fe63b2d7ab;

});

parcelRegister("jS1GQ", function(module, exports) {
const $6bdcc106a64db8f9$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
module.exports["isClientTriggeredMessage"] = $6bdcc106a64db8f9$export$21c420c0c257c346;

});

parcelRegister("lEAVV", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $i3S9F = parcelRequire("i3S9F");


var $iQwJa = parcelRequire("iQwJa");


var $bGVJw = parcelRequire("bGVJw");


var $5h1mk = parcelRequire("5h1mk");


var $1RMKR = parcelRequire("1RMKR");


var $ll379 = parcelRequire("ll379");

var $qzjr4 = parcelRequire("qzjr4");


var $8BCsI = parcelRequire("8BCsI");


var $cozmU = parcelRequire("cozmU");

const $3c006f0a26cabf25$export$71ff7382870ef1b0 = 'create-placement-component';
const $3c006f0a26cabf25$export$66305c2a07eec241 = (placementId, Component, options)=>(0, $8BCsI.withErrorBoundary)(/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const providedContext = (0, $bGVJw.usePostOfficeContext)();
        const route = (0, $5h1mk.usePostOfficeRoute)();
        const stableContext = (0, $1RMKR.useStableObject)(props?.context ?? providedContext);
        if (options?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTrackingSegment), {
            placementId: placementId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $qzjr4.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    subscription: options?.subscription,
                    subscriptionAdapter: options?.subscriptionAdapter,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $3c006f0a26cabf25$export$baf3e7aff0bbcf43 = (placementId, Component, options)=>{
    const placement = $3c006f0a26cabf25$export$66305c2a07eec241(placementId, Component, options);
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        return placement({
            ...props,
            errorBoundaryLocation: $3c006f0a26cabf25$export$71ff7382870ef1b0,
            placementId: placementId,
            fallbackRender: ()=>null
        });
    });
};
module.exports["createPlacementComponentV2"] = $3c006f0a26cabf25$export$baf3e7aff0bbcf43;

});

parcelRegister("5h1mk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $1RMKR = parcelRequire("1RMKR");

const $a524e85936787c13$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $a524e85936787c13$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $a524e85936787c13$var$usePostOfficeRouteStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { subscribe: subscribe, getSnapshot: getSnapshot } = t0;
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
} : ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
};
const $a524e85936787c13$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $a524e85936787c13$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$a524e85936787c13$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $a524e85936787c13$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $cozmU.createContext)($a524e85936787c13$var$initialState);
const $a524e85936787c13$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $a524e85936787c13$export$98c77e1bd702ed15(props);
    const route = $a524e85936787c13$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a524e85936787c13$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $a524e85936787c13$export$79301b66f7808cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f);
} : ()=>(0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $a524e85936787c13$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $a524e85936787c13$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $a524e85936787c13$export$79301b66f7808cd8;

});

parcelRegister("ll379", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $jTNdj = parcelRequire("jTNdj");


var $cozmU = parcelRequire("cozmU");


var $1NVwf = parcelRequire("1NVwf");


var $3WFdt = parcelRequire("3WFdt");

const $0443f5c700dc203b$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $3WFdt.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                name: (0, $jTNdj.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $0443f5c700dc203b$export$b35129264a401b3c = /*#__PURE__*/ (0, $cozmU.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $cXtTj.default).checkGate('post_office_update_ufov2_placements');
    /**
   * If feature gate is not enabled, then we just return the children without the
   * UFO segments attached.
   */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $0443f5c700dc203b$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $0443f5c700dc203b$export$b35129264a401b3c;

});

parcelRegister("3WFdt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7da53318f1fd530c$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(initialData !== undefined);
    const onMount = (0, $cozmU.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $cozmU.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
module.exports["usePerformanceTracking"] = $7da53318f1fd530c$export$317d52099614f316;

});

parcelRegister("qzjr4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $lTlGN = parcelRequire("lTlGN");


var $im2FK = parcelRequire("im2FK");


var $6NRmI = parcelRequire("6NRmI");


var $li4w8 = parcelRequire("li4w8");


var $5SfHd = parcelRequire("5SfHd");


var $9Nqm6 = parcelRequire("9Nqm6");


var $5SRox = parcelRequire("5SRox");


var $ll379 = parcelRequire("ll379");

/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
const $b95d67109e64283f$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 */ const $b95d67109e64283f$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    const isPostOfficeSubscriptionsFeatureGateEnabled = (0, $cXtTj.default).checkGate($b95d67109e64283f$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    if (isPostOfficeSubscriptionsFeatureGateEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Nqm6.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
const $b95d67109e64283f$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $li4w8.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SfHd.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SRox.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $im2FK.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($b95d67109e64283f$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6NRmI.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lTlGN.RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $b95d67109e64283f$export$2b6596bcb1383a71;

});

parcelRegister("lTlGN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $9Nqm6 = parcelRequire("9Nqm6");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $0688fdc237844f49$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $9Nqm6.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $cozmU.useEffect)(()=>{
        if ($0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["RenderTrackerProvider"] = $0688fdc237844f49$export$2d84fd9af6c9e378;

});

parcelRegister("im2FK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $f1G3w = parcelRequire("f1G3w");

const $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "74f419639d5a2d0d3aedf406d2dadcac0ef5ae63",
            b: "24159751",
            t: undefined
        }
    }
};
const $15ac6ff16ee48c24$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData,
        children: children
    });
};
module.exports["StableAnaltyicsProvider"] = $15ac6ff16ee48c24$export$5a66cdc9893b43e;

});

parcelRegister("li4w8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $bGVJw = parcelRequire("bGVJw");


var $1RMKR = parcelRequire("1RMKR");


var $1NJu1 = parcelRequire("1NJu1");

const $52edb35a97f45deb$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $1RMKR.useStableObject)({
        ...(0, $1NJu1.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bGVJw.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
module.exports["StableContextProvider"] = $52edb35a97f45deb$export$d4982c0a28b18f63;

});

parcelRegister("1NJu1", function(module, exports) {
const $bff07b8bbb17f66c$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $bff07b8bbb17f66c$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $bff07b8bbb17f66c$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $bff07b8bbb17f66c$export$71ff7382870ef1b0;

});

parcelRegister("5SfHd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $4cICV = parcelRequire("4cICV");

const $9ea687c3ab35e390$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $1RMKR.useStableObject)(placement);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cICV.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
module.exports["StablePlacementProvider"] = $9ea687c3ab35e390$export$e9fd288527498af6;

});

parcelRegister("5SRox", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $5h1mk = parcelRequire("5h1mk");


var $1RMKR = parcelRequire("1RMKR");


var $2LW9e = parcelRequire("2LW9e");

const $2e96bdbc145ab642$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $2LW9e.useLocationHref)();
    const stableRoute = (0, $1RMKR.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5h1mk.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
module.exports["StableRouteProvider"] = $2e96bdbc145ab642$export$ce13d00e696dfc96;

});

parcelRegister("2LW9e", function(module, exports) {
const $0e2c91a22a84681f$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $0e2c91a22a84681f$export$49fc3f3d8c7f99 = ()=>{
    return $0e2c91a22a84681f$var$isLocationAvailable() ? globalThis.location.href : undefined;
};
module.exports["useLocationHref"] = $0e2c91a22a84681f$export$49fc3f3d8c7f99;

});

parcelRegister("8BCsI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $852mP = parcelRequire("852mP");


var $9TNXZ = parcelRequire("9TNXZ");


var $9EOlJ = parcelRequire("9EOlJ");

const $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: {
                        name: error.name,
                        message: error.message,
                        stack: error.stack
                    },
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $8aG6j.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withErrorBoundary"] = $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7;

});

parcelRegister("1ohAV", function(module, exports) {
class $f0a92f94ee6cacc9$export$8a38dc1cb159944a extends Error {
    constructor(params){
        super(params.message ?? params.error?.message ?? 'unknown placement message error');
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.stageName = void 0;
        this.placementLevel = void 0;
        this.name = params.error?.name ?? 'PlacementMessageError';
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
}
const $f0a92f94ee6cacc9$export$ee31fecb3809975f = (error)=>{
    if (error instanceof $f0a92f94ee6cacc9$export$8a38dc1cb159944a) return error;
    if (error instanceof Error) return new $f0a92f94ee6cacc9$export$8a38dc1cb159944a({
        error: error
    });
    return new $f0a92f94ee6cacc9$export$8a38dc1cb159944a({});
};
module.exports["PlacementMessageError"] = $f0a92f94ee6cacc9$export$8a38dc1cb159944a;
module.exports["createPlacementMessageError"] = $f0a92f94ee6cacc9$export$ee31fecb3809975f;

});

parcelRegister("c25Cq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $6TaGl = parcelRequire("6TaGl");


var $lpNn5 = parcelRequire("lpNn5");


var $9TNXZ = parcelRequire("9TNXZ");


var $k4HA2 = parcelRequire("k4HA2");


var $3jNKT = parcelRequire("3jNKT");


var $baFbJ = parcelRequire("baFbJ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $21rdx = parcelRequire("21rdx");


var $92b2W = parcelRequire("92b2W");


var $2bWU6 = parcelRequire("2bWU6");

const $6828282bee2050b6$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ariaLabelledby: ariaLabelledby, ...triggerProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const ariaLabel = intl.formatMessage({
        id: "post-office.ad-controls.dropdown-menu-trigger.aria-label",
        defaultMessage: "{messageInstanceId} options menu"
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: "post-office.ad-controls.dropdown-menu-trigger.tooltip",
        defaultMessage: "More actions"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $lpNn5.default), {
        content: tooltip,
        isScreenReaderAnnouncementDisabled: true,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                hidden: true,
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                label: tooltip,
                id: "ad-controls-trigger",
                appearance: "subtle",
                ref: triggerRef,
                spacing: spacing,
                icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        ...iconProps,
                        color: iconColor,
                        size: iconSize
                    }),
                "aria-labelledby": ariaLabelledby ? `${ariaLabelledby} ad-controls-trigger` : 'ad-controls-trigger'
            })
        ]
    });
};
const $6828282bee2050b6$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, onRemindMeLater: onRemindMeLater, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default', customDropdownItems: customDropdownItems, ariaLabelledby: ariaLabelledby })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $cozmU.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $baFbJ.useMessageEvent)();
    const { onSnoozed: onSnoozed, onDeclined: onDeclined, onAcknowledged: onAcknowledged } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $cozmU.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { messageSnoozed: messageSnoozed } = (0, $baFbJ.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but retained alongside the semantic snooze event for legacy consumers. See above page for documentation
        onSnoozed({
            interactionIdentifier: 'remindMeLater',
            durationDays: 1,
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onRemindMeLater === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onRemindMeLater(messageInstanceId);
        // rendered outside this component's tree, since onRemindMeLater above unmounts it immediately
        (0, $2bWU6.showStandaloneAdControlsFlag)(messageInstanceId, intl);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        onDeclined({
            interactionIdentifier: 'notInterested',
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        // rendered outside this component's tree, since onDismissed above unmounts it immediately
        (0, $2bWU6.showStandaloneAdControlsFlag)(messageInstanceId, intl);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        onAcknowledged({
            interactionIdentifier: 'adControlsReasons',
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    const fireDropdownMenuOpenAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsDropdown'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)($6828282bee2050b6$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ariaLabelledby: ariaLabelledby,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireDropdownMenuOpenAnalyticsEvent();
                        setCurrIconColor("var(--ds-icon-selected, #1868DB)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $21rdx.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false,
                    customDropdownItems: customDropdownItems
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $92b2W.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            })
        ]
    });
};
module.exports["AdControls"] = $6828282bee2050b6$export$c25b8b7217045de9;

});

parcelRegister("3jNKT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kEPax = parcelRequire("kEPax");


var $8xFOz = parcelRequire("8xFOz");

const $e6e72577d521fafd$export$ee30c4b9efd02415 = ()=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $kEPax.useMessageInstanceEvent)();
    const record = (0, $cozmU.useCallback)((interaction)=>{
        // Dispatch is fire-and-forget: the caller must not wait for analytics before
        // continuing a UI action, and recording an interaction must never break the
        // message.
        messageInstanceClicked((0, $8xFOz.mapInteractionToClickedEvent)(interaction)).catch(()=>{});
    }, [
        messageInstanceClicked
    ]);
    const onCtaActioned = (0, $cozmU.useCallback)((input)=>record({
            kind: 'ctaActioned',
            ...input
        }), [
        record
    ]);
    const onAcknowledged = (0, $cozmU.useCallback)((input)=>record({
            kind: 'acknowledged',
            ...input
        }), [
        record
    ]);
    const onDeclined = (0, $cozmU.useCallback)((input)=>record({
            kind: 'declined',
            ...input
        }), [
        record
    ]);
    const onSnoozed = (0, $cozmU.useCallback)((input)=>record({
            kind: 'snoozed',
            ...input
        }), [
        record
    ]);
    const onClosed = (0, $cozmU.useCallback)((input)=>record({
            kind: 'closed',
            ...input
        }), [
        record
    ]);
    const onStepChanged = (0, $cozmU.useCallback)((input)=>record({
            kind: 'stepChanged',
            ...input
        }), [
        record
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onCtaActioned: onCtaActioned,
            onAcknowledged: onAcknowledged,
            onDeclined: onDeclined,
            onSnoozed: onSnoozed,
            onClosed: onClosed,
            onStepChanged: onStepChanged
        }), [
        onCtaActioned,
        onAcknowledged,
        onDeclined,
        onSnoozed,
        onClosed,
        onStepChanged
    ]);
};
module.exports["usePostOfficeUserInteractions"] = $e6e72577d521fafd$export$ee30c4b9efd02415;

});

parcelRegister("8xFOz", function(module, exports) {

var $eZHZB = parcelRequire("eZHZB");

/**
 * The legacy `clickedElement` shape for kinds that downstream consumers still read as a
 * primary click. Presentation is not intent — this is emitted for backward compatibility
 * only and is removed once consumers read `action.actionType` alone.
 */ const $8935800689fede97$var$primaryButton = (interactionIdentifier)=>({
        clickIdentifier: interactionIdentifier,
        clickedElement: 'button',
        buttonType: 'primary'
    });
/**
 * The legacy `clickedElement` shape for kinds whose meaning does not depend on a rendered
 * element. `closed` in particular covers Escape, click-outside and navigating away.
 *
 * Delegates to `notApplicableClickedElement` rather than building the literal directly —
 * that factory is the only way to produce this branded, PO-owned value.
 */ const $8935800689fede97$var$notApplicable = (interactionIdentifier)=>(0, $eZHZB.notApplicableClickedElement)(interactionIdentifier);
/**
 * Maps a semantic interaction to the `clickedElement` and `action` pair defined by the
 * canonical compatibility mapping.
 *
 * The switch is deliberately exhaustive with no `default`: adding a kind to
 * `SemanticInteraction` without mapping it here is a compile error.
 *
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/7480820497/LYT+IPMs+Semantic+Interaction+Contract+Proposal+Rationale+and+Mapping#1.7-End-to-end-mapping
 */ const $8935800689fede97$var$toClickedEventCore = (interaction)=>{
    const identifier = interaction.interactionIdentifier;
    switch(interaction.kind){
        case 'ctaActioned':
            return {
                clickedElement: $8935800689fede97$var$primaryButton(identifier),
                action: {
                    actionType: 'open',
                    ...interaction.destinationUrl !== undefined && {
                        destinationUrl: interaction.destinationUrl
                    },
                    ...interaction.trackingLinkId !== undefined && {
                        trackingLinkId: interaction.trackingLinkId
                    }
                }
            };
        case 'acknowledged':
            return {
                clickedElement: $8935800689fede97$var$primaryButton(identifier),
                action: {
                    actionType: 'acknowledge'
                }
            };
        case 'declined':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'snoozed':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'snooze',
                    snoozeDuration: interaction.durationDays
                }
            };
        case 'closed':
            // Compatibility mode: `closed` maps to `dismiss` because there is no native
            // `close` actionType yet. Native support is tracked separately, and the split
            // between `declined` and `closed` is preserved in `interactionIdentifier`.
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'stepChanged':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: interaction.direction,
                    currentStep: interaction.toStep,
                    previousStep: interaction.fromStep,
                    ...interaction.stepName !== undefined && {
                        stepName: interaction.stepName
                    }
                }
            };
    }
};
const $8935800689fede97$export$4f02cad8854e08a4 = (interaction)=>({
        messageEventType: 'clicked',
        interactionIdentifier: interaction.interactionIdentifier,
        ...$8935800689fede97$var$toClickedEventCore(interaction),
        ...interaction.additionalMetadata !== undefined && {
            additionalMetadataFromFrontend: interaction.additionalMetadata
        }
    });
module.exports["mapInteractionToClickedEvent"] = $8935800689fede97$export$4f02cad8854e08a4;

});

parcelRegister("21rdx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $kSwu1 = parcelRequire("kSwu1");

const $eae1bdf84f77b888$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?"
        })
    });
const $eae1bdf84f77b888$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested"
        })
    });
const $eae1bdf84f77b888$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later"
        })
    });
const $eae1bdf84f77b888$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater, customDropdownItems: customDropdownItems })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
        children: [
            customDropdownItems?.map((item)=>item),
            showRemindMeLater && /*#__PURE__*/ (0, $8aG6j.jsx)($eae1bdf84f77b888$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($eae1bdf84f77b888$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $8aG6j.jsx)($eae1bdf84f77b888$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });
module.exports["AdControlsDropdown"] = $eae1bdf84f77b888$export$ba7539b3ac68f9f1;

});

parcelRegister("92b2W", function(module, exports) {
/* modal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $i1t43 = parcelRequire("i1t43");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6vJjN = parcelRequire("6vJjN");

const $82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content'; /*--Modal--*/ 
const $82c56ad253185b59$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $6vJjN.portalZIndexFix)($82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: onClose,
            testId: $82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                id: $82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $82c56ad253185b59$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK"
        })
    }); /*--Title--*/ 
const $82c56ad253185b59$var$titleContainerStyles = {
    font: "_2sNsIgWSk4"
};
const $82c56ad253185b59$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $82c56ad253185b59$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?"
        })
    }); /*--Body--*/ 
const $82c56ad253185b59$var$DefaultBody = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:"
        })
    }); /*--Reasons List--*/ 
const $82c56ad253185b59$var$reasonsListStyles = null;
const $82c56ad253185b59$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
        className: (0, $hekY6.default)([
            "_0aNu0LC2EI _2Zuz6QkG2W _3138428HPE"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                children: reason
            }, index))
    }); /*--Privacy Policy Link--*/ 
const $82c56ad253185b59$var$privacyPolicyLinkWrapperStyles = null; /**
                                              * Translated link to Atlassian's privacy policy.
                                              */ 
const $82c56ad253185b59$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_3138428HPE"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian"
            })
        })
    }); /*--Reason Modal--*/ 
const $82c56ad253185b59$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    children: content?.title || /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fEPJS.default), {
                children: content?.body || /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eQiT1.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $82c56ad253185b59$export$b29014abf8076d54 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        onClose: props.onClose,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
module.exports["WhyAmISeeingThisModal"] = $82c56ad253185b59$export$b29014abf8076d54;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = appearance === "default" && $7e44050607850249$var$styles.defaultAppearance;
    const t3 = appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance;
    const t4 = appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance;
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== target || $[13] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[12] = target;
        $[13] = testId;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== children || $[16] !== htmlAttributes || $[17] !== newWindowLabel || $[18] !== ref || $[19] !== t6 || $[20] !== t7 || $[21] !== target || $[22] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[15] = children;
        $[16] = htmlAttributes;
        $[17] = newWindowLabel;
        $[18] = ref;
        $[19] = t6;
        $[20] = t7;
        $[21] = target;
        $[22] = testId;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("6vJjN", function(module, exports) {
const $3ad15545469fd5b2$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $3ad15545469fd5b2$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$3ad15545469fd5b2$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $3ad15545469fd5b2$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $3ad15545469fd5b2$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};
module.exports["portalZIndexFix"] = $3ad15545469fd5b2$export$cef2f5415067aeab;

});

parcelRegister("2bWU6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $fRQ3t = parcelRequire("fRQ3t");


var $kSwu1 = parcelRequire("kSwu1");


var $cUA7n = parcelRequire("cUA7n");

const $287f979bb2ca7b6a$var$pendingCleanups = new Set();
const $287f979bb2ca7b6a$export$4d2a53109859e81a = (messageInstanceId, intl)=>{
    const container = globalThis.document.createElement('div');
    container.dataset.testid = 'post-office-standalone-ad-controls-flag-container';
    globalThis.document.body.appendChild(container);
    const root = (0, $fRQ3t.createRoot)(container);
    const cleanup = ()=>{
        $287f979bb2ca7b6a$var$pendingCleanups.delete(cleanup);
        root.unmount();
        container.remove();
    };
    $287f979bb2ca7b6a$var$pendingCleanups.add(cleanup);
    root.render(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: intl.messages,
        onError: intl.onError,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cUA7n.AdControlsFlag), {
            messageInstanceId: messageInstanceId,
            onCloseFlag: cleanup
        })
    }));
};
const $287f979bb2ca7b6a$export$9623f4d81475c62a = ()=>{
    $287f979bb2ca7b6a$var$pendingCleanups.forEach((cleanup)=>cleanup());
};
module.exports["showStandaloneAdControlsFlag"] = $287f979bb2ca7b6a$export$4d2a53109859e81a;

});

parcelRegister("cUA7n", function(module, exports) {
/* dismissalFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $a2foB = parcelRequire("a2foB");


var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");


var $kSwu1 = parcelRequire("kSwu1");


var $6vJjN = parcelRequire("6vJjN");

const $414b7ed3020225de$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper'; /**-Title--**/ 
const $414b7ed3020225de$var$titleContainerStyles = {
    font: "_2sNsIgEqul"
};
const $414b7ed3020225de$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $414b7ed3020225de$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dismiss-flag.feedback.title",
            defaultMessage: "Thanks for your feedback"
        })
    }); /**--Confirm Icon--*/ 
const $414b7ed3020225de$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        spacing: "spacious",
        label: "Success",
        color: "var(--ds-icon-success, #6A9A23)"
    }); /**-Confirm Dismiss Flag--*/ 
const $414b7ed3020225de$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $6vJjN.portalZIndexFix)($414b7ed3020225de$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            id: $414b7ed3020225de$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2foB.default), {
                icon: /*#__PURE__*/ (0, $8aG6j.jsx)($414b7ed3020225de$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $8aG6j.jsx)($414b7ed3020225de$var$Title, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};
module.exports["AdControlsFlag"] = $414b7ed3020225de$export$6eb98925a948bca3;

});

parcelRegister("8j5U7", function(module, exports) {

var $6lBQA = parcelRequire("6lBQA");

//#region src/static.ts
function $60c4ad8333edba96$var$assertContentDescriptor(value, path) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) throw new Error(`defineContent: ${path} must be a descriptor object`);
    const { id: id, defaultMessage: defaultMessage, description: description, role: role, ...rest } = value;
    const [unsupported] = Object.keys(rest);
    if (unsupported !== void 0) throw new Error(`defineContent: ${path}.${unsupported} is not supported`);
    if (typeof id !== "string" || id.length === 0) throw new Error(`defineContent: ${path}.id must be a non-empty string`);
    if (typeof defaultMessage !== "string") throw new Error(`defineContent: ${path}.defaultMessage must be a string`);
    if (description !== void 0 && typeof description !== "string") throw new Error(`defineContent: ${path}.description must be a string when provided`);
    if (role !== void 0 && !(0, $6lBQA.t).includes(role)) throw new Error(`defineContent: ${path}.role must be 'title' or 'description'`);
}
function $60c4ad8333edba96$var$assertContentUnit(value, contentId) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) throw new Error(`defineContent: content["${contentId}"] must be a content unit object`);
    const keysByRole = /* @__PURE__ */ new Map();
    for (const [key, descriptor] of Object.entries(value)){
        $60c4ad8333edba96$var$assertContentDescriptor(descriptor, `content["${contentId}"]["${key}"]`);
        if (descriptor.role !== void 0) keysByRole.set(descriptor.role, [
            ...keysByRole.get(descriptor.role) ?? [],
            key
        ]);
    }
    for (const role of (0, $6lBQA.t)){
        const keys = keysByRole.get(role) ?? [];
        if (keys.length !== 1) throw new Error(keys.length === 0 ? `defineContent: content["${contentId}"] needs a descriptor with role: '${role}'` : `defineContent: content["${contentId}"] has more than one descriptor with role: '${role}' (${keys.join(", ")})`);
    }
}
function $60c4ad8333edba96$var$toDefinedContent(content) {
    if (typeof content !== "object" || content === null || Array.isArray(content)) throw new Error("defineContent: content must be a content map");
    if (!("default" in content)) throw new Error("defineContent: content.default is required");
    for (const [contentId, contentUnit] of Object.entries(content))$60c4ad8333edba96$var$assertContentUnit(contentUnit, contentId);
    return content;
}
//#endregion
//#region src/index.ts
/**
* Register a static content map for intl extraction and offline discovery. The map holds one
* content unit per config set, plus a `default`; each unit labels one descriptor `role: 'title'`
* and one `role: 'description'`, which is the copy the reranker reads. Providers that resolve
* content at runtime import from `@post-office/define-content/dynamic` instead.
*
* A unit that labels a role wrongly fails the call and names itself, whether or not the export
* carries an annotation. The same rules are enforced again on load, which is what covers copy
* assembled somewhere the compiler cannot follow.
*
* The return is `NoInfer` so an annotation on the export cannot become a second candidate for
* `TContent`. A candidate that disagrees with the argument resolves to the constraint, which would
* run the role check against `ContentUnit` and report a role missing from every unit.
*/ function $60c4ad8333edba96$export$9e779e5a685ebe98(content) {
    return $60c4ad8333edba96$var$toDefinedContent(content);
}
 //# sourceMappingURL=index.mjs.map
module.exports["defineContent"] = $60c4ad8333edba96$export$9e779e5a685ebe98;

});

parcelRegister("6lBQA", function(module, exports) {
//#region src/content-contract.ts
const $49f20fe667b281a7$export$625550452a3fa3ec = [
    "title",
    "description"
];
const $49f20fe667b281a7$export$7ccc53e8f1e7dfc5 = (value)=>$49f20fe667b281a7$export$625550452a3fa3ec.includes(value);
 //# sourceMappingURL=content-contract-BEyp29FQ.mjs.map
module.exports["t"] = $49f20fe667b281a7$export$625550452a3fa3ec;

});

parcelRegister("kB4yd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AssertError = void 0;
class $efeacb103f5d21a9$var$AssertError extends Error {
    constructor(method, path, expected, value){
        const message = path ? `Error on ${method}(): invalid type on ${path}, expect to be ${expected}` : `Error on ${method}(): invalid type, expect to be ${expected}`;
        super(message);
        this.method = method;
        this.path = path;
        this.expected = expected;
        this.value = value;
    }
}
module.exports.AssertError = $efeacb103f5d21a9$var$AssertError;

});

parcelRegister("aePf0", function(module, exports) {
"use strict";
var $7742f59926144658$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7742f59926144658$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7742f59926144658$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7742f59926144658$var$__exportStar((parcelRequire("5OGxy")), module.exports);

});

parcelRegister("5OGxy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iqz3m", function(module, exports) {
const $887c6385e198a62b$export$3f7a3f360cb80be4 = (_valueWithType)=>(input)=>input;
module.exports["noValidation"] = $887c6385e198a62b$export$3f7a3f360cb80be4;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("dAuCI", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 
var $fR63l = parcelRequire("fR63l");


class $a264614d865c7774$export$50e7f6c2eabc665 {
    /**
   * Returns the number of registered configs.
   */ get size() {
        return this.factories.size;
    }
    /**
   * Checks whether a config is registered for the given key.
   */ has(key) {
        return this.factories.has(key);
    }
    /**
   * Returns all registered product keys synchronously.
   */ keys() {
        return Array.from(this.factories.keys());
    }
    /**
   * Asynchronously retrieves a single config by key.
   * The config module is loaded on first access and cached thereafter.
   */ async get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const factory = this.factories.get(key);
        if (!factory) return undefined;
        const config = await factory();
        this.cache.set(key, config);
        return config;
    }
    /**
   * Asynchronously iterates over all entries, invoking the callback for each.
   * Each config is lazily loaded as the iteration reaches it.
   */ async forEach(callbackfn) {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) await callbackfn(config, key);
        }
    }
    /**
   * Async generator that yields [key, config] entries lazily.
   */ async *entries() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield [
                key,
                config
            ];
        }
    }
    /**
   * Async generator that yields config values lazily.
   */ async *values() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield config;
        }
    }
    /**
   * Resolves all configs and returns them as a standard Map.
   * Useful when all configs are needed at once.
   */ async getAll() {
        const result = new Map();
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) result.set(key, config);
        }
        return result;
    }
    constructor(entries){
        this.factories = void 0;
        this.cache = new Map();
        this.factories = new Map(entries);
    }
}

































































































































































































const $a264614d865c7774$export$f7937c5f282f2571 = new $a264614d865c7774$export$50e7f6c2eabc665([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>Promise.resolve((parcelRequire("jAKKt"))).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>Promise.resolve((parcelRequire("7dzhu"))).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>Promise.resolve((parcelRequire("aZX0c"))).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>Promise.resolve((parcelRequire("kFYBW"))).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>Promise.resolve((parcelRequire("gOrBS"))).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>Promise.resolve((parcelRequire("lSeWC"))).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>Promise.resolve((parcelRequire("4TRyZ"))).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>Promise.resolve((parcelRequire("2qza4"))).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>Promise.resolve((parcelRequire("kDG5l"))).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>Promise.resolve((parcelRequire("6sCQO"))).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>Promise.resolve((parcelRequire("6eg6r"))).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>Promise.resolve((parcelRequire("52jas"))).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>Promise.resolve((parcelRequire("ijAga"))).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>Promise.resolve((parcelRequire("dPp45"))).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>Promise.resolve((parcelRequire("4Be7r"))).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>Promise.resolve((parcelRequire("kmEEk"))).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>Promise.resolve((parcelRequire("52Drw"))).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>Promise.resolve((parcelRequire("aaz0Y"))).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>Promise.resolve((parcelRequire("kcCFv"))).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>Promise.resolve((parcelRequire("6lsSn"))).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>Promise.resolve((parcelRequire("k521G"))).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>Promise.resolve((parcelRequire("43W2t"))).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>Promise.resolve((parcelRequire("6ThsT"))).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>Promise.resolve((parcelRequire("4x6XK"))).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>Promise.resolve((parcelRequire("382mb"))).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>Promise.resolve((parcelRequire("8oQ7k"))).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>Promise.resolve((parcelRequire("79ijY"))).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>Promise.resolve((parcelRequire("e7BOf"))).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>Promise.resolve((parcelRequire("fg2gb"))).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>Promise.resolve((parcelRequire("fauGM"))).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>Promise.resolve((parcelRequire("bj13p"))).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>Promise.resolve((parcelRequire("3VdqU"))).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>Promise.resolve((parcelRequire("iN1Vs"))).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>Promise.resolve((parcelRequire("fA9zj"))).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>Promise.resolve((parcelRequire("iTxTm"))).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>Promise.resolve((parcelRequire("5pWqV"))).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>Promise.resolve((parcelRequire("juuLe"))).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>Promise.resolve((parcelRequire("3juV6"))).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>Promise.resolve((parcelRequire("hIDj1"))).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>Promise.resolve((parcelRequire("7WW80"))).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>Promise.resolve((parcelRequire("au9jr"))).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>Promise.resolve((parcelRequire("diJOH"))).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>Promise.resolve((parcelRequire("5bQLl"))).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>Promise.resolve((parcelRequire("dVIA3"))).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>Promise.resolve((parcelRequire("emznk"))).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>Promise.resolve((parcelRequire("fMCQp"))).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>Promise.resolve((parcelRequire("cdiu6"))).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>Promise.resolve((parcelRequire("8djpu"))).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>Promise.resolve((parcelRequire("3P9fk"))).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>Promise.resolve((parcelRequire("lPRuX"))).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>Promise.resolve((parcelRequire("2zNcl"))).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>Promise.resolve((parcelRequire("h8Js2"))).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>Promise.resolve((parcelRequire("9Om9G"))).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>Promise.resolve((parcelRequire("kiNtZ"))).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>Promise.resolve((parcelRequire("1RpaO"))).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>Promise.resolve((parcelRequire("jENKA"))).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>Promise.resolve((parcelRequire("j34lg"))).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>Promise.resolve((parcelRequire("in2Pi"))).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>Promise.resolve((parcelRequire("7vbr8"))).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>Promise.resolve((parcelRequire("k6vRK"))).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>Promise.resolve((parcelRequire("aiL8h"))).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>Promise.resolve((parcelRequire("cY0ZT"))).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>Promise.resolve((parcelRequire("9SYma"))).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>Promise.resolve((parcelRequire("ie06K"))).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>Promise.resolve((parcelRequire("h5NUz"))).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>Promise.resolve((parcelRequire("9Y160"))).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>Promise.resolve((parcelRequire("hdy05"))).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>Promise.resolve((parcelRequire("djF8v"))).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>Promise.resolve((parcelRequire("dChew"))).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>Promise.resolve((parcelRequire("TCovD"))).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>Promise.resolve((parcelRequire("feDPe"))).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>Promise.resolve((parcelRequire("klS4t"))).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>Promise.resolve((parcelRequire("hFdyH"))).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>Promise.resolve((parcelRequire("e6TPF"))).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>Promise.resolve((parcelRequire("7piBv"))).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>Promise.resolve((parcelRequire("3yXQ1"))).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>Promise.resolve((parcelRequire("cmwLF"))).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>Promise.resolve((parcelRequire("brRUk"))).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>Promise.resolve((parcelRequire("dwyZc"))).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>Promise.resolve((parcelRequire("9sIt4"))).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>Promise.resolve((parcelRequire("7UyZr"))).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>Promise.resolve((parcelRequire("2KPYZ"))).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>Promise.resolve((parcelRequire("9lVxQ"))).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>Promise.resolve((parcelRequire("1HfnT"))).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>Promise.resolve((parcelRequire("9JBuG"))).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>Promise.resolve((parcelRequire("aHqTQ"))).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>Promise.resolve((parcelRequire("34wuK"))).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>Promise.resolve((parcelRequire("g36Mb"))).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>Promise.resolve((parcelRequire("eODbN"))).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>Promise.resolve((parcelRequire("2k3z5"))).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>Promise.resolve((parcelRequire("lHAGV"))).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>Promise.resolve((parcelRequire("iPw5B"))).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>Promise.resolve((parcelRequire("3LgSg"))).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>Promise.resolve((parcelRequire("bRkOn"))).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>Promise.resolve((parcelRequire("eoGOF"))).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>Promise.resolve((parcelRequire("jWqmd"))).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>Promise.resolve((parcelRequire("jAKKt"))).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>Promise.resolve((parcelRequire("7dzhu"))).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>Promise.resolve((parcelRequire("aZX0c"))).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>Promise.resolve((parcelRequire("kFYBW"))).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>Promise.resolve((parcelRequire("gOrBS"))).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>Promise.resolve((parcelRequire("lSeWC"))).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>Promise.resolve((parcelRequire("4TRyZ"))).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>Promise.resolve((parcelRequire("2qza4"))).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>Promise.resolve((parcelRequire("kDG5l"))).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>Promise.resolve((parcelRequire("6sCQO"))).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>Promise.resolve((parcelRequire("6eg6r"))).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>Promise.resolve((parcelRequire("52jas"))).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>Promise.resolve((parcelRequire("ijAga"))).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>Promise.resolve((parcelRequire("dPp45"))).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>Promise.resolve((parcelRequire("4Be7r"))).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>Promise.resolve((parcelRequire("kmEEk"))).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>Promise.resolve((parcelRequire("52Drw"))).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>Promise.resolve((parcelRequire("aaz0Y"))).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>Promise.resolve((parcelRequire("kcCFv"))).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>Promise.resolve((parcelRequire("6lsSn"))).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>Promise.resolve((parcelRequire("k521G"))).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>Promise.resolve((parcelRequire("43W2t"))).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>Promise.resolve((parcelRequire("6ThsT"))).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>Promise.resolve((parcelRequire("4x6XK"))).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>Promise.resolve((parcelRequire("382mb"))).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>Promise.resolve((parcelRequire("8oQ7k"))).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>Promise.resolve((parcelRequire("79ijY"))).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>Promise.resolve((parcelRequire("e7BOf"))).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>Promise.resolve((parcelRequire("fg2gb"))).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>Promise.resolve((parcelRequire("fauGM"))).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gong,
        ()=>Promise.resolve((parcelRequire("bzVC8"))).then((m)=>m.gongConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>Promise.resolve((parcelRequire("bj13p"))).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>Promise.resolve((parcelRequire("3VdqU"))).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>Promise.resolve((parcelRequire("iN1Vs"))).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>Promise.resolve((parcelRequire("fA9zj"))).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>Promise.resolve((parcelRequire("iTxTm"))).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>Promise.resolve((parcelRequire("5pWqV"))).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>Promise.resolve((parcelRequire("juuLe"))).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>Promise.resolve((parcelRequire("3juV6"))).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>Promise.resolve((parcelRequire("hIDj1"))).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>Promise.resolve((parcelRequire("7WW80"))).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>Promise.resolve((parcelRequire("au9jr"))).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>Promise.resolve((parcelRequire("diJOH"))).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>Promise.resolve((parcelRequire("5bQLl"))).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>Promise.resolve((parcelRequire("dVIA3"))).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>Promise.resolve((parcelRequire("emznk"))).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>Promise.resolve((parcelRequire("fMCQp"))).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>Promise.resolve((parcelRequire("cdiu6"))).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>Promise.resolve((parcelRequire("8djpu"))).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>Promise.resolve((parcelRequire("3P9fk"))).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>Promise.resolve((parcelRequire("lPRuX"))).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>Promise.resolve((parcelRequire("2zNcl"))).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>Promise.resolve((parcelRequire("h8Js2"))).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>Promise.resolve((parcelRequire("9Om9G"))).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>Promise.resolve((parcelRequire("kiNtZ"))).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>Promise.resolve((parcelRequire("1RpaO"))).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>Promise.resolve((parcelRequire("jENKA"))).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>Promise.resolve((parcelRequire("j34lg"))).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>Promise.resolve((parcelRequire("in2Pi"))).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>Promise.resolve((parcelRequire("7vbr8"))).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>Promise.resolve((parcelRequire("k6vRK"))).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>Promise.resolve((parcelRequire("aiL8h"))).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>Promise.resolve((parcelRequire("cY0ZT"))).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>Promise.resolve((parcelRequire("9SYma"))).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>Promise.resolve((parcelRequire("ie06K"))).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>Promise.resolve((parcelRequire("h5NUz"))).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>Promise.resolve((parcelRequire("9Y160"))).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>Promise.resolve((parcelRequire("hdy05"))).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>Promise.resolve((parcelRequire("djF8v"))).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>Promise.resolve((parcelRequire("dChew"))).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>Promise.resolve((parcelRequire("TCovD"))).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>Promise.resolve((parcelRequire("feDPe"))).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>Promise.resolve((parcelRequire("klS4t"))).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>Promise.resolve((parcelRequire("hFdyH"))).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>Promise.resolve((parcelRequire("e6TPF"))).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>Promise.resolve((parcelRequire("7piBv"))).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>Promise.resolve((parcelRequire("3yXQ1"))).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>Promise.resolve((parcelRequire("cmwLF"))).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>Promise.resolve((parcelRequire("brRUk"))).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>Promise.resolve((parcelRequire("dwyZc"))).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>Promise.resolve((parcelRequire("9sIt4"))).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>Promise.resolve((parcelRequire("7UyZr"))).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>Promise.resolve((parcelRequire("2KPYZ"))).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>Promise.resolve((parcelRequire("9lVxQ"))).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>Promise.resolve((parcelRequire("1HfnT"))).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>Promise.resolve((parcelRequire("9JBuG"))).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>Promise.resolve((parcelRequire("aHqTQ"))).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>Promise.resolve((parcelRequire("34wuK"))).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>Promise.resolve((parcelRequire("g36Mb"))).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>Promise.resolve((parcelRequire("eODbN"))).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>Promise.resolve((parcelRequire("2k3z5"))).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>Promise.resolve((parcelRequire("lHAGV"))).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>Promise.resolve((parcelRequire("iPw5B"))).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>Promise.resolve((parcelRequire("3LgSg"))).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>Promise.resolve((parcelRequire("bRkOn"))).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>Promise.resolve((parcelRequire("eoGOF"))).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>Promise.resolve((parcelRequire("jWqmd"))).then((m)=>m.forgeUnitoBasecampConfig)
    ]
]);
const $a264614d865c7774$var$productKeys3PValues = new Set(Object.values((0, $fR63l.ProductKeys3P)));
const $a264614d865c7774$export$985cb3900add20c8 = (value)=>$a264614d865c7774$var$productKeys3PValues.has(value);
module.exports["ThirdPartyConfigs"] = $a264614d865c7774$export$f7937c5f282f2571;
module.exports["isProductKey3P"] = $a264614d865c7774$export$985cb3900add20c8;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ // oxlint-disable-next-line eslint/no-redeclare
const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong-connector',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("8dynS", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $06fddef4acfae0a8$export$9a80c24535b38e83 = 'confluence_3p_smartlink_connection_link_count';
const $06fddef4acfae0a8$export$d02d73057c4016d5 = 'confluence_3p_smartlink_connection_link_count_by_team_type_';
const $06fddef4acfae0a8$var$SUFFICIENCY_THRESHOLD = 20;
const $06fddef4acfae0a8$export$545eb843b77efaec = 3;
const $06fddef4acfae0a8$export$8594dab83de99a34 = [
    'google-drive',
    'slack',
    'github'
];
const $06fddef4acfae0a8$export$5dbf4404d8d730eb = {
    c_suite: [
        'google-drive',
        'slack',
        'github'
    ],
    customer_service: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    data_science: [
        'google-drive',
        'github',
        'slack'
    ],
    design: [
        'google-drive',
        'figma',
        'slack'
    ],
    engineering: [
        'google-drive',
        'github',
        'slack'
    ],
    finance: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    human_resources: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    information_technology: [
        'google-drive',
        'slack',
        'github'
    ],
    legal: [
        'google-drive',
        'slack',
        'sharepoint'
    ],
    marketing: [
        'google-drive',
        'slack',
        'figma'
    ],
    // `na` is the "no signal" floor row — kept in sync with the standalone
    // `DEFAULT_FALLBACK_APPS` export above by referencing the same constant.
    na: $06fddef4acfae0a8$export$8594dab83de99a34,
    operations: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    other: [
        'google-drive',
        'github',
        'slack'
    ],
    product_management: [
        'google-drive',
        'figma',
        'slack'
    ],
    program_management: [
        'google-drive',
        'onedrive',
        'sharepoint'
    ],
    sales: [
        'google-drive',
        'slack',
        'sharepoint'
    ]
};
const $06fddef4acfae0a8$export$db8c8b18ca3de852 = 'na';
const $06fddef4acfae0a8$var$APP_ID_TO_PRODUCT_KEY_ALIASES = {
    drive: (0, $fR63l.ProductKeys3P).GoogleDrive,
    figma: (0, $fR63l.ProductKeys3P).Figma,
    github: (0, $fR63l.ProductKeys3P).Github,
    'google-drive': (0, $fR63l.ProductKeys3P).GoogleDrive,
    onedrive: (0, $fR63l.ProductKeys3P).OneDrive,
    sharepoint: (0, $fR63l.ProductKeys3P).Sharepoint,
    slack: (0, $fR63l.ProductKeys3P).Slack
};
const $06fddef4acfae0a8$export$acda930d8972381e = (raw)=>{
    if (!raw || raw.trim().length === 0) return [];
    return raw.split(',').map((entry)=>entry.trim()).filter((entry)=>entry.length > 0).map((entry)=>{
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex <= 0 || separatorIndex === entry.length - 1) return undefined;
        const appId = entry.slice(0, separatorIndex).trim();
        const count = Number(entry.slice(separatorIndex + 1).trim());
        if (appId.length === 0 || !Number.isFinite(count)) return undefined;
        return {
            appId: appId,
            count: count
        };
    }).filter((entry)=>entry !== undefined);
};
const $06fddef4acfae0a8$export$299a268eb011b7ef = (raw)=>{
    if (raw === undefined || raw.trim() === '') return undefined;
    const scalarCount = Number(raw);
    if (Number.isInteger(scalarCount) && scalarCount >= 0) return scalarCount;
    const appCounts = $06fddef4acfae0a8$export$acda930d8972381e(raw);
    if (appCounts.length === 0) return undefined;
    // parseAppCounts only guarantees isFinite; re-filter to positive integers before summing.
    const totalCount = appCounts.reduce((total, { count: count })=>{
        if (!Number.isInteger(count) || count <= 0) return total;
        return total + count;
    }, 0);
    return totalCount > 0 ? totalCount : undefined;
};
const $06fddef4acfae0a8$export$fe68bf06dd562208 = (parsed)=>parsed.map((entry, index)=>({
            ...entry,
            index: index
        })).filter((entry)=>entry.count > 0).sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.index - b.index;
    }).map((entry)=>entry.appId);
const $06fddef4acfae0a8$export$f9f1f4a4ade7c6e2 = (appId)=>{
    return $06fddef4acfae0a8$var$APP_ID_TO_PRODUCT_KEY_ALIASES[appId.toLowerCase()];
};
const $06fddef4acfae0a8$export$551da10284cad191 = (apps)=>apps.map($06fddef4acfae0a8$export$f9f1f4a4ade7c6e2).filter((productKey)=>productKey !== undefined);
const $06fddef4acfae0a8$export$7cc148373d70b178 = (existing, incoming, max)=>{
    const result = [];
    const seen = new Set();
    for (const productKey of [
        ...existing,
        ...incoming
    ])if (!seen.has(productKey)) {
        seen.add(productKey);
        result.push(productKey);
        if (result.length >= max) return result;
    }
    return result;
};
const $06fddef4acfae0a8$export$5d0c03a62d0c5b9f = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts, teamTypeKey: teamTypeKey } = {}, maxRecommendedApps = $06fddef4acfae0a8$export$545eb843b77efaec, options = {})=>{
    let productKeys = [];
    // Tier 1 — per-team-type TAP trait, gated on sufficiency.
    //
    // The sufficiency check is intentionally performed against the raw
    // (pre-filter) sum: it reflects whether the site as a whole has enough
    // activity for this team type to trust the signal, independent of which
    // apps we happen to support today. Only positive counts contribute so a
    // malformed TAP row with negatives (`"github:50, x:-40"`) cannot drag the
    // total below the threshold.
    const teamTypeParsed = $06fddef4acfae0a8$export$acda930d8972381e(teamTypeSmartlinkAppCounts);
    const teamTypePositiveSum = teamTypeParsed.reduce((sum, entry)=>sum + Math.max(0, entry.count), 0);
    if (teamTypePositiveSum >= $06fddef4acfae0a8$var$SUFFICIENCY_THRESHOLD) productKeys = $06fddef4acfae0a8$export$7cc148373d70b178([], $06fddef4acfae0a8$export$551da10284cad191($06fddef4acfae0a8$export$fe68bf06dd562208(teamTypeParsed)), maxRecommendedApps);
    // Tier 2 — site-wide TAP trait backfill.
    if (productKeys.length < maxRecommendedApps) {
        const siteWideParsed = $06fddef4acfae0a8$export$acda930d8972381e(siteWideSmartlinkAppCounts);
        productKeys = $06fddef4acfae0a8$export$7cc148373d70b178(productKeys, $06fddef4acfae0a8$export$551da10284cad191($06fddef4acfae0a8$export$fe68bf06dd562208(siteWideParsed)), maxRecommendedApps);
    }
    // Tier 3 — HARDCODED_DEFAULTS for the user's team type.
    //
    // If the caller didn't pass a teamTypeKey, or passed one we don't have
    // a curated row for, fall through to the `na` row. Because
    // HARDCODED_DEFAULTS.na references DEFAULT_FALLBACK_APPS by identity,
    // this single tier covers both the team-type-known case and the
    // "no signal at all" floor — no separate Tier 4 is needed.
    //
    // Skipped when `options.traitOnly` is set so animation callers (which
    // have their own department-based fallback) can distinguish "real signal"
    // from "cold-start defaults".
    if (!options.traitOnly && productKeys.length < maxRecommendedApps) {
        const tier3AppIds = (teamTypeKey ? $06fddef4acfae0a8$export$5dbf4404d8d730eb[teamTypeKey] : undefined) ?? $06fddef4acfae0a8$export$5dbf4404d8d730eb[$06fddef4acfae0a8$export$db8c8b18ca3de852] ?? [];
        productKeys = $06fddef4acfae0a8$export$7cc148373d70b178(productKeys, $06fddef4acfae0a8$export$551da10284cad191(tier3AppIds), maxRecommendedApps);
    }
    return productKeys;
};
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_TRAIT"] = $06fddef4acfae0a8$export$9a80c24535b38e83;
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_BY_TEAM_TYPE_TRAIT_PREFIX"] = $06fddef4acfae0a8$export$d02d73057c4016d5;
module.exports["DEFAULT_FALLBACK_APPS"] = $06fddef4acfae0a8$export$8594dab83de99a34;
module.exports["parseAppCounts"] = $06fddef4acfae0a8$export$acda930d8972381e;
module.exports["parseSmartlinkConnectionLinkCount"] = $06fddef4acfae0a8$export$299a268eb011b7ef;
module.exports["canonicalizeAppIdToProductKey"] = $06fddef4acfae0a8$export$f9f1f4a4ade7c6e2;
module.exports["resolveRecommendedProductKeys"] = $06fddef4acfae0a8$export$5d0c03a62d0c5b9f;

});

parcelRegister("4YcXR", function(module, exports) {
const $a0771ee7650ea498$export$995d9440dbc2c5f1 = {
    onboarding: 'onboarding',
    sideNav: 'side-nav'
};
module.exports["SMARTLINK_CONNECTION_TOUCHPOINTS"] = $a0771ee7650ea498$export$995d9440dbc2c5f1;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("4H55s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59a9afa412fc227cfd2e3839c8269fd5>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $3b8b1dedf3cc6ac9$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#d97757" d="m14.279 29.274 6.294-3.53.105-.307-.105-.17h-.308l-1.053-.065-3.597-.097-3.119-.13-3.022-.161-.761-.162-.713-.94.073-.469.64-.429.915.081 2.026.138 3.038.21 2.203.13 3.265.34h.518l.073-.21-.178-.13-.138-.13-3.143-2.129-3.402-2.25-1.783-1.296-.964-.655-.486-.616-.21-1.343.875-.964 1.174.081.3.081 1.19.915 2.545 1.967 3.321 2.445.486.405.195-.138.024-.097-.219-.364-1.806-3.263-1.928-3.319-.86-1.376-.226-.826c-.081-.34-.138-.623-.138-.971l.997-1.352.55-.178 1.33.178.558.486.826 1.886 1.337 2.97 2.074 4.04.608 1.198.324 1.11.121.34h.21v-.195l.171-2.275.316-2.792.308-3.595.105-1.012.503-1.214.996-.655.778.372.64.915-.09.59-.38 2.47-.745 3.87-.487 2.59h.284l.324-.324 1.312-1.74 2.204-2.753.972-1.093 1.134-1.206.73-.575h1.377l1.012 1.506-.453 1.554-1.418 1.797-1.175 1.522-1.685 2.267-1.053 1.813.097.146.251-.024 3.808-.81 2.058-.372 2.454-.421 1.11.518.122.526-.438 1.076-2.625.648-3.078.615-4.585 1.085-.057.04.065.082 2.066.194.883.048h2.163l4.026.3 1.053.696.632.85-.105.648-1.62.825-2.188-.518-5.104-1.214-1.75-.437h-.243v.146l1.459 1.424 2.673 2.413 3.346 3.108.17.77-.43.606-.453-.064-2.94-2.21-1.135-.996-2.568-2.161h-.17v.226l.591.866 3.127 4.696.162 1.44-.227.47-.81.283-.89-.162-1.832-2.566-1.887-2.89-1.523-2.59-.187.105-.899 9.674-.421.494-.972.372-.81-.615-.43-.996.43-1.967.518-2.566.421-2.04.381-2.534.227-.842-.016-.056-.187.024-1.911 2.623-2.909 3.926-2.3 2.46-.552.22-.956-.495.09-.882.534-.785 3.184-4.048 1.92-2.51 1.24-1.448-.008-.21h-.073l-8.458 5.488-1.507.194-.648-.607.08-.996.309-.324 2.544-1.748z"/></svg>';
function $3b8b1dedf3cc6ac9$export$c6f809367786e4de({ size: size, label: label = 'Claude', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $3b8b1dedf3cc6ac9$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["ClaudeIcon"] = $3b8b1dedf3cc6ac9$export$c6f809367786e4de;

});

parcelRegister("bD1F5", function(module, exports) {
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

const $4c67a4021f7bef2b$var$glyphStyles = null;
const $4c67a4021f7bef2b$var$hexagonSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $4c67a4021f7bef2b$var$updatedHexagonSizeStyles = {
    xxsmall: "_39xV02EGCh _0jFU0VQSd4",
    xsmall: "_39xV029oBa _0jFU0VDwJf",
    small: "_39xV021R6D _0jFU0V7qhK",
    medium: "_39xV02U2XU _0jFU0VRlO4",
    large: "_39xV02s3iu _0jFU0VNmyB",
    xlarge: "_39xV026W6Q _0jFU0VoFHQ"
};
const $4c67a4021f7bef2b$var$updatedHexagonClipPath = null;
const $4c67a4021f7bef2b$var$hexagonRootStyles = null;
const $4c67a4021f7bef2b$var$hexagonStyles = null;
const $4c67a4021f7bef2b$var$hexagonBorderStyles = null;
const $4c67a4021f7bef2b$var$hexagonContentStyles = null;
const $4c67a4021f7bef2b$var$svgIdAttributePattern = /\sid=(["'])([^"']+)\1/g;
const $4c67a4021f7bef2b$var$getSvgIdNamespace = (instanceId)=>`third-party-logo-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '-')}`; /**
                                                                                                                             * Third-party SVGs can contain gradients, masks, and clipPaths with document-wide IDs.
                                                                                                                             * Namespacing each render keeps repeated logos from resolving `url(#id)` references to the
                                                                                                                             * first matching SVG definition elsewhere on the page.
                                                                                                                             */ 
const $4c67a4021f7bef2b$var$namespaceSvgIds = (markup, namespace)=>{
    const ids = Array.from(markup.matchAll($4c67a4021f7bef2b$var$svgIdAttributePattern), ([, , id])=>id);
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.reduce((updatedMarkup, id)=>{
        const namespacedId = `${namespace}-${id}`;
        const escapedId = $4c67a4021f7bef2b$var$escapeRegExp(id);
        return updatedMarkup.replace(new RegExp(`\\sid=(["'])${escapedId}\\1`, 'g'), ` id=$1${namespacedId}$1`).replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${namespacedId})`).replace(new RegExp(`(\\s(?:href|xlink:href)=["'])#${escapedId}(["'])`, 'g'), `$1#${namespacedId}$2`);
    }, markup);
};
const $4c67a4021f7bef2b$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $4c67a4021f7bef2b$export$96b07167eb29fb14({ markup: markup, size: size = 'medium', label: label = '', testId: testId, type: type = 'app', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    const instanceId = (0, $cozmU.useId)();
    const namespacedMarkup = (0, $cozmU.useMemo)(()=>$4c67a4021f7bef2b$var$namespaceSvgIds(markup, $4c67a4021f7bef2b$var$getSvgIdNamespace(instanceId)), [
        markup,
        instanceId
    ]);
    const glyph = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
            __html: namespacedMarkup
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d"
        ])
    });
    if (type === 'agent') return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1RrJLit2nV",
            !UNSAFE_isUpdatedGeometry && $4c67a4021f7bef2b$var$hexagonSizeStyles[size],
            UNSAFE_isUpdatedGeometry && $4c67a4021f7bef2b$var$updatedHexagonSizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _24h04i2Njc _39xV02N91d _0jFU0VN91d _1uo2ZfTcEg",
                "_4c065UNvrM _2Y7lL4NvrM _0KLXruIDZ8",
                UNSAFE_isUpdatedGeometry && "_1uo2ZfEXe0"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _0KLXrut28M _1uo2ZfOLYo"
                ]),
                children: glyph
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Tile's backgroundColor API accepts the semantic `white` value.
    ), {
        backgroundColor: "white",
        label: label,
        size: size,
        testId: testId,
        hasBorder: true,
        isInset: false,
        children: glyph
    });
}
module.exports["ThirdPartyLogoWrapper"] = $4c67a4021f7bef2b$export$96b07167eb29fb14;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("jh2Zn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b3b779f37199a8c52774c0643da229>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $0983d2d116935ae4$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#26251e" d="M36.674 16.124 24.625 9.168a1.25 1.25 0 0 0-1.251 0l-12.05 6.956a1.05 1.05 0 0 0-.525.912v14.028c0 .376.2.723.526.91l12.05 6.958c.386.223.864.223 1.25 0l12.05-6.957c.325-.188.526-.535.526-.911V17.035c0-.376-.2-.723-.526-.91m-.757 1.474L24.286 37.745c-.079.136-.287.08-.287-.077V24.476a.74.74 0 0 0-.369-.64L12.206 17.24c-.136-.078-.08-.286.077-.286h23.264a.43.43 0 0 1 .371.644"/></svg>';
function $0983d2d116935ae4$export$8ce9a6eef5b50cda({ size: size, label: label = 'Cursor', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $0983d2d116935ae4$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["CursorIcon"] = $0983d2d116935ae4$export$8ce9a6eef5b50cda;

});

parcelRegister("kHdfP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c18ba5110b1255363669ed60b71808b4>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $ca5b3c9edbab6b29$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5938" width="30" height="30" x="9" y="9" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M39 9H9v30h30z"/></mask><g mask="url(#mask0_118280_5938)"><path fill="#000" d="M20.506 19.92v-2.85c0-.24.09-.42.298-.54l5.679-3.3c.773-.45 1.694-.66 2.646-.66 3.567 0 5.827 2.79 5.827 5.76 0 .21 0 .45-.03.69l-5.887-3.48a.99.99 0 0 0-1.07 0zm13.26 11.1v-6.81c0-.42-.178-.72-.534-.93l-7.463-4.38 2.438-1.41a.54.54 0 0 1 .595 0l5.679 3.3c1.635.96 2.735 3 2.735 4.98 0 2.28-1.338 4.38-3.45 5.25m-15.014-6-2.438-1.44c-.208-.12-.297-.3-.297-.54v-6.6c0-3.21 2.438-5.64 5.738-5.64 1.25 0 2.408.42 3.39 1.17l-5.857 3.42c-.357.21-.535.51-.535.93zM24 28.08l-3.494-1.98v-4.2L24 19.92l3.493 1.98v4.2zm2.245 9.12c-1.25 0-2.408-.42-3.39-1.17l5.857-3.42c.357-.21.535-.51.535-.93v-8.7l2.468 1.44c.209.12.298.3.298.54v6.6c0 3.21-2.468 5.64-5.768 5.64m-7.047-6.69-5.679-3.3c-1.635-.96-2.735-3-2.735-4.98 0-2.31 1.367-4.38 3.478-5.25v6.84c0 .42.179.72.535.93l7.434 4.35-2.438 1.41a.54.54 0 0 1-.595 0m-.327 4.92c-3.36 0-5.827-2.55-5.827-5.7 0-.24.03-.48.059-.72l5.857 3.42q.536.315 1.07 0l7.463-4.35v2.85c0 .24-.089.42-.297.54l-5.679 3.3c-.773.45-1.695.66-2.646.66M26.245 39c3.597 0 6.6-2.58 7.284-6C36.86 32.13 39 28.98 39 25.77c0-2.1-.892-4.14-2.498-5.61.15-.63.238-1.26.238-1.89a7.45 7.45 0 0 0-7.433-7.5c-.802 0-1.575.12-2.348.39C25.62 9.84 23.777 9 21.755 9c-3.597 0-6.6 2.58-7.284 6C11.14 15.87 9 19.02 9 22.23c0 2.1.892 4.14 2.498 5.61a8.2 8.2 0 0 0-.238 1.89 7.45 7.45 0 0 0 7.433 7.5c.802 0 1.575-.12 2.348-.39C22.38 38.16 24.223 39 26.246 39"/></g></svg>';
function $ca5b3c9edbab6b29$export$cee95da0353e90b6({ size: size, label: label = 'OpenAI', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $ca5b3c9edbab6b29$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["OpenAIIcon"] = $ca5b3c9edbab6b29$export$cee95da0353e90b6;

});

parcelRegister("rBCwg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a024502d374eb01ee1dcb0e7e17b6509>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $052fb455e22ad4bc$var$_react = $052fb455e22ad4bc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $052fb455e22ad4bc$var$_iconNew = $052fb455e22ad4bc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $052fb455e22ad4bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cursor".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/cursor
 * Usage guidance:
 * Selecting the cursor in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $052fb455e22ad4bc$var$CursorIcon = (props)=>/*#__PURE__*/ $052fb455e22ad4bc$var$_react.default.createElement($052fb455e22ad4bc$var$_iconNew.default, Object.assign({
        name: "CursorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.827 2.827 6.914 13.23l1.272-4.134c.134-.436.474-.776.91-.91l4.134-1.272zm-1.5.282C.886 1.99 1.99.887 3.108 1.326L14.11 5.648c1.21.476 1.145 2.212-.099 2.594L9.6 9.6l-1.358 4.412c-.382 1.244-2.118 1.31-2.594.099z" clip-rule="evenodd"/>`
    }, props));
$052fb455e22ad4bc$var$CursorIcon.displayName = 'CursorIcon';
var $052fb455e22ad4bc$var$_default = module.exports.default = $052fb455e22ad4bc$var$CursorIcon;

});

parcelRegister("f9XbP", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");


var $4KkEB = parcelRequire("4KkEB");

class $cecff34dc45d8bb2$export$6c85f5032e75eff9 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $4KkEB.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["StorageClient"] = $cecff34dc45d8bb2$export$6c85f5032e75eff9;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("4KkEB", function(module, exports) {
const $0745f528b71a1a3c$export$3364800d9d60baf9 = 'localStorage';
module.exports["DEFAULT_STORAGE_ENGINE"] = $0745f528b71a1a3c$export$3364800d9d60baf9;

});

parcelRegister("kYBsP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $fxKXz = parcelRequire("fxKXz");

var $l24yD = parcelRequire("l24yD");

const $2be281ab78966229$export$920091e3d72d80ee = (loaders)=>{
    const messagesLoader = $2be281ab78966229$export$99ce90405b04bcbd(loaders);
    const I18n = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxKXz.IntlProvider), {
            messagesLoader: messagesLoader,
            children: children
        });
    return ({ children: children })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)(I18n, {
            children: children
        });
    };
};
const $2be281ab78966229$export$d71c6502467fe725 = (...loaders)=>{
    const messagesLoader = $2be281ab78966229$export$99ce90405b04bcbd(...loaders);
    return (component)=>{
        return (0, $l24yD.withIntlProvider)({
            messagesLoader: messagesLoader
        }, component);
    };
};
const $2be281ab78966229$export$99ce90405b04bcbd = (...loaders)=>async (locale)=>{
        const messagePromises = loaders.filter((e)=>!!e).map((loader)=>loader(locale));
        const loadedMessages = await Promise.allSettled(messagePromises);
        const translatedMessages = {
            messages: {},
            errors: []
        };
        loadedMessages.forEach((result)=>{
            if (result.status === 'rejected') {
                translatedMessages.errors.push(`Failed to load translations with ${result.reason}`);
                return;
            }
            translatedMessages.messages = {
                ...translatedMessages.messages,
                ...result.value
            };
        });
        return translatedMessages;
    };
module.exports["createWithI18n"] = $2be281ab78966229$export$d71c6502467fe725;

});

parcelRegister("9oJIg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gswTK = parcelRequire("gswTK");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("MyxIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $4PX6o = parcelRequire("4PX6o");


var $bkTet = parcelRequire("bkTet");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $6mKj3 = parcelRequire("6mKj3");


var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit, writeData = (url, data)=>$cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data))=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $4PX6o.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        writeData(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions, writeData)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true ? {
                    'x-archetype-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit, writeData);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit, writeData);
    };
    const basePath = (0, $apw3A.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $4PX6o.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $cozmU.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $cozmU.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $cozmU.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const preloadPlacement = (writeData)=>(0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
                postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
                environment: {
                    currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
                }
            }, extraFetchOptions, writeData), postOfficeTimeout);
    if ($cdd1e9f9feeb24fd$var$getIsSSR() && window.__SSR_REACT_STREAMING__ && (0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true)) {
        // Publish only data from a preload that finished before its timeout. A late response
        // must not change the snapshot after SSR has rendered the empty placement.
        const pendingData = new Map();
        const completed = await preloadPlacement((url, data)=>pendingData.set(url, data));
        if (completed) pendingData.forEach((data, url)=>$cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data));
        return completed;
    }
    return preloadPlacement();
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("apw3A", function(module, exports) {

var $3rMm0 = parcelRequire("3rMm0");


var $jdpvF = parcelRequire("jdpvF");

const $9fbb603c3fc74986$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $jdpvF.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $3rMm0.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $9fbb603c3fc74986$export$e8b30f9c4a80230f;

});

parcelRegister("4PX6o", function(module, exports) {
const $dc9030da747a3f79$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $dc9030da747a3f79$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $dc9030da747a3f79$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $dc9030da747a3f79$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $dc9030da747a3f79$export$c4c39037cc4b06ab;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("g95v4", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8aF6s = parcelRequire("8aF6s");


var $bjj9l = parcelRequire("bjj9l");

const $4f70211624fcedf9$export$7098d17bb6837941 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    let t0;
    if ($[0] !== showModal) {
        t0 = (t1)=>{
            const options = t1 === undefined ? {} : t1;
            showModal((0, $bjj9l.AgentsAwarenessModalLoadable), {
                ...options,
                messageType: "transactional"
            });
        };
        $[0] = showModal;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["useOpenAgentsAwarenessModal"] = $4f70211624fcedf9$export$7098d17bb6837941;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bjj9l", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7ff73ce59b909ea5$export$ac9258c1e2a42c0e = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "U0FPT",
    name: "AgentsAwarenessModalLoadable",
    loader: async ()=>(await (parcelRequire("ez30y"))).AgentsAwarenessModalConnected
});
module.exports["AgentsAwarenessModalLoadable"] = $7ff73ce59b909ea5$export$ac9258c1e2a42c0e;

});

parcelRegister("ez30y", function(module, exports) {

let $a9a6aade5012d379$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a9a6aade5012d379$var$load("54ltV"),
    $a9a6aade5012d379$var$load("1audf"),
    $a9a6aade5012d379$var$load("bpBPu"),
    $a9a6aade5012d379$var$load("ahEIC"),
    $a9a6aade5012d379$var$load("dlYE2"),
    $a9a6aade5012d379$var$load("60a9E"),
    $a9a6aade5012d379$var$load("7EorR"),
    $a9a6aade5012d379$var$load("jqoep"),
    $a9a6aade5012d379$var$load("6wr18"),
    $a9a6aade5012d379$var$load("59hV4"),
    $a9a6aade5012d379$var$load("cN2rp"),
    $a9a6aade5012d379$var$load("VXbA1"),
    $a9a6aade5012d379$var$load("ffEVr"),
    $a9a6aade5012d379$var$load("el1U6"),
    $a9a6aade5012d379$var$load("2yyll"),
    $a9a6aade5012d379$var$load("4jVw5")
]).then(()=>parcelRequire('8WeUp'));

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    showCreateWithRovo: (0, $hQnHK.SHOW_CREATE_WITH_ROVO_QUERY_PARAM),
    journeyId: 'journeyId',
    rovoAgentId: 'rovoAgentId',
    templateKey: 'templateKey',
    templateId: 'templateId',
    onboardingEntryPoint: 'onboardingEntryPoint',
    cwrWelcome: 'cwrWelcome'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('showCreateWithRovo' in options && options.showCreateWithRovo !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.showCreateWithRovo] = options.showCreateWithRovo;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('rovoAgentId' in options && options.rovoAgentId) queryParams[$e7afa99020494478$var$queryParamKeys.rovoAgentId] = options.rovoAgentId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    if ('templateId' in options && options.templateId) queryParams[$e7afa99020494478$var$queryParamKeys.templateId] = options.templateId;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) return contentType;
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const rovoAgentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.rovoAgentId);
    const onboardingEntryPoint = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.onboardingEntryPoint);
    const cwrWelcome = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cwrWelcome);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const showCreateWithRovoParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.showCreateWithRovo);
    const showCreateWithRovo = showCreateWithRovoParam ? showCreateWithRovoParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    const templateId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateId);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        showCreateWithRovo: showCreateWithRovo,
        journeyId: journeyId,
        rovoAgentId: rovoAgentId,
        onboardingEntryPoint: onboardingEntryPoint,
        templateKey: templateKey,
        templateId: templateId,
        cwrWelcome: cwrWelcome
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$a90803a9f656fd5f = 'showCreateWithRovo';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$57f29eb0a90c2092 = 'initial-background-style';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["SHOW_CREATE_WITH_ROVO_QUERY_PARAM"] = $0037b6bfd6daf741$export$a90803a9f656fd5f;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["INITIAL_BACKGROUND_STYLE_QUERY_PARAM"] = $0037b6bfd6daf741$export$57f29eb0a90c2092;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("bAyaS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined,
    fallbackToStandard: false
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation,
                fallbackToStandard: false
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined,
                fallbackToStandard: false
            });
        },
    /**
   * Switches an open smart-create drawer over to the standard create flow
   * without closing it, so the user keeps their place in the drawer. The drawer
   * stays open (`showCreateSpaceDrawer` is untouched); only which drawer
   * `ConditionalCreateSpaceDrawer` renders changes.
   */ switchToStandardCreate: ()=>({ setState: setState })=>{
            setState({
                fallbackToStandard: true
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $kBr4q.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("jFFx4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3194c63c7e99e1cb$export$2537d74141d57f9e = ()=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const saveCurrentRoute = (0, $cozmU.useCallback)(()=>{
        const currentRoute = routeDataRef.current?.href;
        if (currentRoute) (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL, currentRoute);
    }, [
        routeDataRef
    ]);
    const getRoute = (0, $cozmU.useCallback)((defaultPath)=>{
        const previousPath = (0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL);
        return previousPath ?? defaultPath;
    }, []);
    return {
        saveCurrentRoute: saveCurrentRoute,
        getRoute: getRoute
    };
};
module.exports["useSettingsBackButtonUtils"] = $3194c63c7e99e1cb$export$2537d74141d57f9e;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("hebSF", function(module, exports) {

let $c8acf5bdde39e7d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c8acf5bdde39e7d5$var$load("aLbuU"),
    $c8acf5bdde39e7d5$var$load("6wr18"),
    $c8acf5bdde39e7d5$var$load("4zjgJ"),
    $c8acf5bdde39e7d5$var$load("iN26T"),
    $c8acf5bdde39e7d5$var$load("ffEVr"),
    $c8acf5bdde39e7d5$var$load("e00ow"),
    $c8acf5bdde39e7d5$var$load("Wowvf"),
    $c8acf5bdde39e7d5$var$load("geh8r")
]).then(()=>parcelRequire('8oHcg'));

});

parcelRegister("gmhHk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $h11I1 = parcelRequire("h11I1");


var $5tUtl = parcelRequire("5tUtl");

const $61ed3f7435f1fd68$export$4b1545b4f2016d26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: t1 } = t0;
    const isMenuListItem = t1 === undefined ? false : t1;
    const id = (0, $6JrSr.useId)();
    const t2 = `${id}-heading`;
    let t3;
    if ($[0] !== ariaLabel || $[1] !== children || $[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "group",
            "aria-labelledby": t2,
            "aria-label": ariaLabel
        }, children);
        $[0] = ariaLabel;
        $[1] = children;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== id || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tUtl.MenuSectionContext).Provider, {
            value: id
        }, t3);
        $[4] = id;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const content = t4;
    if (isMenuListItem) {
        let t5;
        if ($[7] !== content || $[8] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
                testId: testId
            }, content);
            $[7] = content;
            $[8] = testId;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    return content;
} : ({ children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $6JrSr.useId)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tUtl.MenuSectionContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "group",
        "aria-labelledby": `${id}-heading`,
        "aria-label": ariaLabel
    }, children));
    if (isMenuListItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        testId: testId
    }, content);
    // Legacy. isMenuListItem should become default.
    return content;
};
module.exports["MenuSection"] = $61ed3f7435f1fd68$export$4b1545b4f2016d26;

});

parcelRegister("h11I1", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hLtfj = parcelRequire("hLtfj");

const $3bcb034fbc52807a$export$6c2f3257abc4825b = (0, $hLtfj.ListItem);
module.exports["MenuListItem"] = $3bcb034fbc52807a$export$6c2f3257abc4825b;

});

parcelRegister("hLtfj", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $0210a31b93b69349$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $0210a31b93b69349$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $cozmU.forwardRef)($0210a31b93b69349$var$_ListItem);
module.exports["ListItem"] = $0210a31b93b69349$export$a7b06bfba60a8a78;

});

parcelRegister("5tUtl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");

const $f8fd377d923f47fb$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $f8fd377d923f47fb$export$8100cda602411810 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($f8fd377d923f47fb$export$728ac99b9c7eea8a);
    (0, $bB0i2.default)(context, "useMenuSectionContext must be used within a MenuSection");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($f8fd377d923f47fb$export$728ac99b9c7eea8a);
    (0, $bB0i2.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};
module.exports["MenuSectionContext"] = $f8fd377d923f47fb$export$728ac99b9c7eea8a;
module.exports["useMenuSectionContext"] = $f8fd377d923f47fb$export$8100cda602411810;

});

parcelRegister("4X3mP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5tUtl = parcelRequire("5tUtl");

const $81e6b252f2c7d20c$var$styles = {
    root: "_2sNsIgd8bj _4c065U2ADO _1UtDYzKGUX _0LQT5EgVvo"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $81e6b252f2c7d20c$export$5d3acdbf9237a364 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, headingLevel: headingLevel } = t0;
    const id = (0, $5tUtl.useMenuSectionContext)();
    const HeadingTag = headingLevel ? `h${headingLevel}` : "p";
    const t1 = `${id}-heading`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $81e6b252f2c7d20c$var$styles.root
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== HeadingTag || $[2] !== children || $[3] !== t1) {
        t3 = /*#__PURE__*/ $cozmU.createElement(HeadingTag, {
            id: t1,
            className: t2
        }, children);
        $[1] = HeadingTag;
        $[2] = children;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, headingLevel: headingLevel })=>{
    const id = (0, $5tUtl.useMenuSectionContext)();
    const HeadingTag = headingLevel ? `h${headingLevel}` : 'p';
    return /*#__PURE__*/ $cozmU.createElement(HeadingTag, {
        id: `${id}-heading`,
        className: (0, $hekY6.default)([
            $81e6b252f2c7d20c$var$styles.root
        ])
    }, children);
};
module.exports["MenuSectionHeading"] = $81e6b252f2c7d20c$export$5d3acdbf9237a364;

});

parcelRegister("huaOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $hLtfj = parcelRequire("hLtfj");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");

const $e30c6d4ea2de4ef1$var$listItemStyles = {
    root: "_2pQraJ0Qmj"
};
const $e30c6d4ea2de4ef1$var$LinkMenuItemNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(26);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const itemRef = (0, $cozmU.useRef)(null);
    const t1 = isSelected ?? false;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            elementRef: itemRef,
            isSelected: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    (0, $4o9cR.useScrollMenuItemIntoView)(t2);
    const t3 = listItemRef ?? null;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $lmzCg.default)([
            itemRef,
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const ref = t4;
    let t5;
    if ($[4] !== actions || $[5] !== actionsOnHover || $[6] !== children || $[7] !== description || $[8] !== dropIndicator || $[9] !== elemAfter || $[10] !== elemBefore || $[11] !== forwardedRef || $[12] !== hasDragIndicator || $[13] !== href || $[14] !== interactionName || $[15] !== isContentTooltipDisabled || $[16] !== isDragging || $[17] !== isSelected || $[18] !== onClick || $[19] !== target || $[20] !== testId || $[21] !== visualContentRef) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[4] = actions;
        $[5] = actionsOnHover;
        $[6] = children;
        $[7] = description;
        $[8] = dropIndicator;
        $[9] = elemAfter;
        $[10] = elemBefore;
        $[11] = forwardedRef;
        $[12] = hasDragIndicator;
        $[13] = href;
        $[14] = interactionName;
        $[15] = isContentTooltipDisabled;
        $[16] = isDragging;
        $[17] = isSelected;
        $[18] = onClick;
        $[19] = target;
        $[20] = testId;
        $[21] = visualContentRef;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== ref || $[24] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
            ref: ref,
            xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
        }, t5);
        $[23] = ref;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
        ref: ref,
        xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f = (0, $4Qc44.default)($e30c6d4ea2de4ef1$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("KuePV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $3v3yD = parcelRequire("3v3yD");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $5BGbo = parcelRequire("5BGbo");


var $8VFFa = parcelRequire("8VFFa");


var $8AWCX = parcelRequire("8AWCX");


var $1TBPy = parcelRequire("1TBPy");


var $3TF4i = parcelRequire("3TF4i");

function $5638831521affcfb$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $5638831521affcfb$var$defaultAvatarValues = {
    size: 'small'
}; // Stable reference for the anchor's text-decoration reset.
const $5638831521affcfb$var$anchorTextDecorationResetStyle = {
    textDecoration: 'none'
};
const $5638831521affcfb$var$elemAfterDisplayVar = '--elem-after-display';
const $5638831521affcfb$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $5638831521affcfb$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $5638831521affcfb$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $5638831521affcfb$var$notchColorVar = '--notch-color'; // Note: this is also used in `drag-handle.tsx`
const $5638831521affcfb$var$dragHandleDisplayVar = '--drag-handle-display';
const $5638831521affcfb$var$dragCursorAnimation = null; /**
                                   * ## 🤹 `position:relative`
                                   *
                                   * We need `position:relative` on an element that takes
                                   * up the full size of the interactive element so we
                                   * can correctly use `position:absolute` to place:
                                   * 1. the notch for links
                                   * 2. drop indicators for drag and drop
                                   * 3. a child of button / anchor to stretch it out to
                                   *    increase it's pressable area.
                                   *
                                   * ⛔️ We cannot add `position:relative` _only_ on the
                                   * button / anchor as that will cause sibling elements
                                   * to be rendered under the button / anchor when setting
                                   * a background color on the button / anchor.
                                   *
                                   * 📖 Note: `position:relative` elements are painted after
                                   * elements with `position:static` (the default)
                                   * https://drafts.csswg.org/css-position-4/#painting-order
                                   *
                                   * ⛔️ We cannot add `position:relative` to the container
                                   * element, as then the `:focus` ring styles on the
                                   * button / anchor can be cut off by the next sibling if it has
                                   * has a background color set (eg when selected)
                                   *
                                   * ✅ Add `position:relative` to all first level descendants
                                   * of the container element so that we don't impact DOM ordered
                                   * paint ordering within the item and the button / anchor focus
                                   * ring can still bleed over siblings
                                   *
                                   * 📖 We could use `> * { position: relative; }` on the container,
                                   * but that would violate our styling standard.
                                   */ 
const $5638831521affcfb$var$topLevelSiblingStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * All slots on the menu item (eg `elemBefore`) are rendered as siblings
    * of our main button / anchor element and they are visually placed on
    * top of the main button / anchor.
    *
    * 📖 This is done so that we don't nest interactive elements in our markup.
    *
    * ✅ This is great when element in the slot is an interactive element
    * as we don't want the main menu item button / anchor to be triggered
    * when interacting with the element in the slot.
    *
    * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
    * prevent the main button / anchor (that is visually behind the element in
    * the slot) from being clicked. The element in the slot is a sibling of our
    * main button / anchor (not a child of it) so clicking on the element in the
    * slot will not bubble up to the button / anchor.
    *
    * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
    * element so that static content in a slot does not prevent clicking on the main
    * button / anchor.
    */ 
const $5638831521affcfb$var$onTopOfButtonOrAnchorStyles = {
    root: "_2XwD3GYbGa"
}; /**
    * This is being _internally_ exported so it can be used in other menu item wrapper components, like
    * ExpandableMenuItemTrigger.
    *
    * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
    * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
    * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
    * outside the menu item, e.g. if rendered in a portal.
    *
    * An alternative solution might involve wrapping it with a popup context and listening to the popup
    * events through it (and applying the hover style when the popup is open). Exploring this has been
    * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
    */ 
const $5638831521affcfb$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup])';
const $5638831521affcfb$var$containerStyles = {
    root: "_0bjKvDKTcp _24h04i2Njc _3iDTPbgBM8 _2iEGP2dBcB _0ca6V7UfmU _3NN0tOjIhD _4ouGXIL04q _0jFU0VZ49V _0hPCNLDIqT _20VacPYbGa _1UtDYzZpcK _4Gpka1jOvk _0B0jWhQ4SZ _21yOJEdnbC _1GUorvdnbC _0StjZVdnbC _1eOmH6d1Zr _1VxRtD7dHp _13ZyZA7dHp _0B13sOIZbP _2hQYYBIZbP _1fxveC1Y8M _23nUkX1Y8M",
    rootFinesse: "_1eOmH6o126",
    rootMotion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    removeElemAfter: "_0B0jWhYbGa",
    showHoverActions: "_21yOJE7dHp _1GUorvIZbP _0StjZV1Y8M",
    removeElemAfterOnHoverOrOpenNestedPopup: "_3R5mzfYbGa _4g9hZtYbGa",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _4Gpka1kLmD _0clgaMjTy9 _1eOmH6sumd",
    selectedMotion: "_23rrnHWE38 _1B4rbIo10F _3sFUREDdj4",
    disabled: "_1UtDYzot27 _0KLXruZqHV _1eOmH6ZqHV _0clgaMot27",
    hasDescription: "_0jFU0VDuDI",
    dragging: "_1YKVNsWOAI"
};
const $5638831521affcfb$var$nestedOpenPopupStyles = {
    root: "_2QSzKR7dHp _3eEnT0IZbP _1q1Zsn1Y8M _3pCGbVd1Zr",
    rootFinesse: "_3pCGbVo126",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1wwaXwYbGa",
    selected: "_3pCGbVsumd"
};
const $5638831521affcfb$var$buttonOrAnchorStyles = {
    root: "_0bjKvDKTcp _2j3gqAg8pm _3B2K2Q7dHp _3iDTPbgBM8 _2iEGP2qccN _0ca6V7qccN _03SyCP1Y8M _0LQT5E1Y8M _46hvQm1Y8M _0xmtko1Y8M _0KLXrujOvk _1UtDYzZpcK _0hPCNLDIqT _2fwxA57p2s _2FPiMbJNoT",
    rootFinesse: "_2FPiMbN4oS",
    rootMotion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    selected: "_1UtDYzjTy9 _2FPiMbXsxn",
    selectedMotion: "_23rrnHWE38 _1B4rbIo10F _3sFUREDdj4",
    hasDragIndicator: "_3AKos1YbGa _3elJEbYbGa _2b6wcOQ4SZ _2ucLKKOIol _0vzPdeUiLg _4pWA4uMcca _0L8XzkgRhm"
};
const $5638831521affcfb$var$extendButtonOrAnchorStyles = {
    root: "_49OCfRPgdg _1mT5xdWVPG"
};
const $5638831521affcfb$var$notchStyles = {
    root: "_1mT5xdWVPG _2I62gz715P _3iC0zdPgdg _39xV024Jdh _0jFU0VxpxF _1VJPcakruI _0KLXruzNEo"
};
const $5638831521affcfb$var$actionStyles = {
    root: "_2mHwu81Y8M _1xC2CJnO1v _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
};
const $5638831521affcfb$var$actionsOnHoverStyles = {
    root: "_1xC2CJoUfk _2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _1YKVNsXcXg _39xV02xqYT _03SyCPk5xR _3uh4XpyL8i _2yI6tSyL8i"
};
const $5638831521affcfb$var$textStyles = {
    root: "_2mHwu8FQfX _4bt5LAnQyn _2WAcuGnQyn _03SyCP1Y8M _0LQT5E1Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIw0fc _3uh4XpyL8i _2yI6tSyL8i",
    noElemBeforeIndent: "_0LQT5EgVvo"
};
const $5638831521affcfb$var$elemBeforeStyles = {
    root: "_1xC2CJZyOa _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT _0LQT5E1Y8M _24h04iPvdi _3uh4XpyL8i _2yI6tSyL8i"
};
const $5638831521affcfb$var$elemAfterStyles = {
    root: "_1xC2CJoUfk _4bt5LAnQyn _2WAcuGnQyn _3iDTPbx0Ks _3YEZNOdnbC _0jFU0VoWWg _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
}; /**
    * We are using a wrapping element for our interactive content
    * even though only the `Text` element is the only thing not using `position:absolute`
    *
    * Rationale:
    * - Super clear that everything inside the interactive content should be in a specific slot in the grid
    * - To work around a browser bug in Safari where it does not work well with `position:absolute`
    *   on a subgrid child.
    *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
    */ 
const $5638831521affcfb$var$interactiveContentStyles = {
    root: "_1xC2CJxFwi _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXDIqT"
};
function $5638831521affcfb$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
} /**
   * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
   *
   * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
   * expanded content for ExpandableMenuItem.
   */ 
const $5638831521affcfb$var$MenuItemBaseNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(82);
    const { id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const level = (0, $8AWCX.useLevel)();
    const setFlyoutMenuOpen = (0, $1TBPy.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1TBPy.useFlyoutMenuOpen)();
    const isLink = typeof href !== "undefined";
    const isFinesseEnabled = (0, $iDrrr.fg)("platform-dst-tokens-finesse");
    const labelRef = (0, $cozmU.useRef)(null);
    const descriptionRef = (0, $cozmU.useRef)(null);
    const tooltipOnClick = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== isFlyoutMenuOpen || $[1] !== onClick || $[2] !== setFlyoutMenuOpen) {
        t1 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            setFlyoutMenuOpen(!isFlyoutMenuOpen);
            tooltipOnClick.current?.(event);
        };
        $[0] = isFlyoutMenuOpen;
        $[1] = onClick;
        $[2] = setFlyoutMenuOpen;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== isContentTooltipDisabled) {
        t2 = ()=>{
            if (isContentTooltipDisabled) return false;
            const label = labelRef.current;
            const description_0 = descriptionRef.current;
            if (label && $5638831521affcfb$var$isTextClamped(label)) return true;
            return Boolean(description_0 && $5638831521affcfb$var$isTextClamped(description_0));
        };
        $[4] = isContentTooltipDisabled;
        $[5] = t2;
    } else t2 = $[5];
    const canTooltipAppear = t2;
    const showElemBefore = elemBefore !== (0, $3TF4i.COLLAPSE_ELEM_BEFORE);
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $5638831521affcfb$var$interactiveContentStyles.root
        ]);
        $[6] = t3;
    } else t3 = $[6];
    const t4 = `calc(-1 * ${level} * ${(0, $5BGbo.expandableMenuItemIndentation)})`;
    let t5;
    if ($[7] !== t4) {
        t5 = {
            insetInlineStart: t4
        };
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $5638831521affcfb$var$extendButtonOrAnchorStyles.root
        ]);
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t5,
            "aria-hidden": "true",
            className: t6
        });
        $[10] = t5;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = !showElemBefore && $5638831521affcfb$var$textStyles.noElemBeforeIndent;
    let t9;
    if ($[12] !== t8) {
        t9 = (0, $hekY6.default)([
            $5638831521affcfb$var$textStyles.root,
            t8
        ]);
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== isDisabled || $[15] !== isSelected) {
        t10 = $5638831521affcfb$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        });
        $[14] = isDisabled;
        $[15] = isSelected;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== children || $[18] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            maxLines: 1,
            color: t10,
            ref: labelRef
        }, children);
        $[17] = children;
        $[18] = t10;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== description || $[21] !== isDisabled || $[22] !== isSelected) {
        t12 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: $5638831521affcfb$var$getTextColor({
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            size: "small",
            maxLines: 1,
            ref: descriptionRef
        }, description);
        $[20] = description;
        $[21] = isDisabled;
        $[22] = isSelected;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t11 || $[25] !== t12 || $[26] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t9
        }, t11, t12);
        $[24] = t11;
        $[25] = t12;
        $[26] = t9;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== hasDragIndicator) {
        t14 = hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null) : null;
        $[28] = hasDragIndicator;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== dropIndicator || $[31] !== t13 || $[32] !== t14 || $[33] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, t7, t13, t14, dropIndicator);
        $[30] = dropIndicator;
        $[31] = t13;
        $[32] = t14;
        $[33] = t7;
        $[34] = t15;
    } else t15 = $[34];
    const interactiveElemContent = t15;
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    const t16 = (0, $3v3yD.AvatarContext);
    const t17 = $5638831521affcfb$var$defaultAvatarValues;
    const t18 = testId ? `${testId}-container` : undefined;
    const t19 = (0, $hekY6.default)([
        $5638831521affcfb$var$containerStyles.root,
        $5638831521affcfb$var$containerStyles.rootMotion,
        $5638831521affcfb$var$nestedOpenPopupStyles.root,
        isFinesseEnabled && $5638831521affcfb$var$containerStyles.rootFinesse,
        isFinesseEnabled && $5638831521affcfb$var$nestedOpenPopupStyles.rootFinesse,
        isSelected && $5638831521affcfb$var$containerStyles.selected,
        isSelected && $5638831521affcfb$var$containerStyles.selectedMotion,
        isSelected && $5638831521affcfb$var$nestedOpenPopupStyles.selected,
        isDragging && $5638831521affcfb$var$containerStyles.dragging,
        description && $5638831521affcfb$var$containerStyles.hasDescription,
        showHoverActionsWhenNotHovered && $5638831521affcfb$var$containerStyles.showHoverActions,
        showHoverActionsWhenNotHovered && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfter,
        actionsOnHover && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
        actionsOnHover && elemAfter && $5638831521affcfb$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
        isDisabled && $5638831521affcfb$var$containerStyles.disabled
    ]);
    let t20;
    if ($[35] !== children || $[36] !== description) {
        t20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, description) : null);
        $[35] = children;
        $[36] = description;
        $[37] = t20;
    } else t20 = $[37];
    let t21;
    if ($[38] !== ariaControls || $[39] !== ariaExpanded || $[40] !== ariaHasPopup || $[41] !== forwardedRef || $[42] !== handleClick || $[43] !== hasDragIndicator || $[44] !== href || $[45] !== id || $[46] !== interactionName || $[47] !== interactiveElemContent || $[48] !== isDisabled || $[49] !== isFinesseEnabled || $[50] !== isLink || $[51] !== isSelected || $[52] !== target || $[53] !== testId) {
        t21 = (tooltipProps)=>{
            tooltipOnClick.current = tooltipProps.onClick;
            const sharedProps = {
                ...tooltipProps,
                "aria-controls": ariaControls,
                "aria-haspopup": ariaHasPopup,
                ref: (0, $lmzCg.default)([
                    forwardedRef,
                    tooltipProps.ref
                ]),
                id: id,
                testId: testId,
                interactionName: interactionName
            };
            return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
                style: $5638831521affcfb$var$anchorTextDecorationResetStyle,
                "aria-current": isSelected ? "page" : undefined,
                href: href,
                target: target,
                draggable: hasDragIndicator ? undefined : false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $5638831521affcfb$var$notchStyles.root
                ])
            }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
                "aria-expanded": ariaExpanded,
                isDisabled: isDisabled
            }, interactiveElemContent);
        };
        $[38] = ariaControls;
        $[39] = ariaExpanded;
        $[40] = ariaHasPopup;
        $[41] = forwardedRef;
        $[42] = handleClick;
        $[43] = hasDragIndicator;
        $[44] = href;
        $[45] = id;
        $[46] = interactionName;
        $[47] = interactiveElemContent;
        $[48] = isDisabled;
        $[49] = isFinesseEnabled;
        $[50] = isLink;
        $[51] = isSelected;
        $[52] = target;
        $[53] = testId;
        $[54] = t21;
    } else t21 = $[54];
    let t22;
    if ($[55] !== canTooltipAppear || $[56] !== t20 || $[57] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t20,
            position: "right-start",
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, t21);
        $[55] = canTooltipAppear;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
    } else t22 = $[58];
    let t23;
    if ($[59] !== elemBefore || $[60] !== showElemBefore) {
        t23 = showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$elemBeforeStyles.root,
                $5638831521affcfb$var$topLevelSiblingStyles.root,
                $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemBefore);
        $[59] = elemBefore;
        $[60] = showElemBefore;
        $[61] = t23;
    } else t23 = $[61];
    let t24;
    if ($[62] !== actionsOnHover) {
        t24 = actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$actionsOnHoverStyles.root
            ])
        }, actionsOnHover);
        $[62] = actionsOnHover;
        $[63] = t24;
    } else t24 = $[63];
    let t25;
    if ($[64] !== elemAfter) {
        t25 = elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$elemAfterStyles.root,
                $5638831521affcfb$var$topLevelSiblingStyles.root,
                $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemAfter);
        $[64] = elemAfter;
        $[65] = t25;
    } else t25 = $[65];
    let t26;
    if ($[66] !== actions) {
        t26 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$actionStyles.root,
                $5638831521affcfb$var$topLevelSiblingStyles.root,
                $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, actions);
        $[66] = actions;
        $[67] = t26;
    } else t26 = $[67];
    let t27;
    if ($[68] !== isSelected || $[69] !== t18 || $[70] !== t19 || $[71] !== t22 || $[72] !== t23 || $[73] !== t24 || $[74] !== t25 || $[75] !== t26 || $[76] !== visualContentRef) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: visualContentRef,
            "data-testid": t18,
            "data-selected": isSelected,
            className: t19
        }, t22, t23, t24, t25, t26);
        $[68] = isSelected;
        $[69] = t18;
        $[70] = t19;
        $[71] = t22;
        $[72] = t23;
        $[73] = t24;
        $[74] = t25;
        $[75] = t26;
        $[76] = visualContentRef;
        $[77] = t27;
    } else t27 = $[77];
    let t28;
    if ($[78] !== t16.Provider || $[79] !== t17 || $[80] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(t16.Provider, {
            value: t17
        }, t27);
        $[78] = t16.Provider;
        $[79] = t17;
        $[80] = t27;
        $[81] = t28;
    } else t28 = $[81];
    return t28;
} : ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $8AWCX.useLevel)();
    const setFlyoutMenuOpen = (0, $1TBPy.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1TBPy.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const isFinesseEnabled = (0, $iDrrr.fg)('platform-dst-tokens-finesse');
    const labelRef = (0, $cozmU.useRef)(null);
    const descriptionRef = (0, $cozmU.useRef)(null);
    const tooltipOnClick = (0, $cozmU.useRef)(null);
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent); // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]); /**
                                                       * Show the tooltip if _either_ label or description is truncated
                                                       */ 
    const canTooltipAppear = (0, $cozmU.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
         // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description_0 = descriptionRef.current;
        if (label && $5638831521affcfb$var$isTextClamped(label)) return true;
        return Boolean(description_0 && $5638831521affcfb$var$isTextClamped(description_0));
    }, [
        isContentTooltipDisabled
    ]); // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $3TF4i.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // This extends the clickable area of nested menu items to the width
    , {
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: `calc(-1 * ${level} * ${(0, $5BGbo.expandableMenuItemIndentation)})`
        },
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$textStyles.root,
            !showElemBefore && $5638831521affcfb$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1,
        color: $5638831521affcfb$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: $5638831521affcfb$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null) : null, dropIndicator); /**
           *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
           *
           * Note: we also remove the `elemAfter` when showing `actionsOnHover`
           */ 
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3v3yD.AvatarContext).Provider, {
        value: $5638831521affcfb$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$containerStyles.root,
            $5638831521affcfb$var$containerStyles.rootMotion,
            $5638831521affcfb$var$nestedOpenPopupStyles.root,
            isFinesseEnabled && $5638831521affcfb$var$containerStyles.rootFinesse,
            isFinesseEnabled && $5638831521affcfb$var$nestedOpenPopupStyles.rootFinesse,
            isSelected && $5638831521affcfb$var$containerStyles.selected,
            isSelected && $5638831521affcfb$var$containerStyles.selectedMotion,
            isSelected && $5638831521affcfb$var$nestedOpenPopupStyles.selected,
            isDragging && $5638831521affcfb$var$containerStyles.dragging,
            description && $5638831521affcfb$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $5638831521affcfb$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            actionsOnHover && elemAfter && $5638831521affcfb$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $5638831521affcfb$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, description) : null),
        position: "right-start",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered for the menu item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>{
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
            ...tooltipProps,
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, $lmzCg.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        };
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: $5638831521affcfb$var$anchorTextDecorationResetStyle,
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            draggable: hasDragIndicator ? undefined : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }, interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$elemBeforeStyles.root,
            $5638831521affcfb$var$topLevelSiblingStyles.root,
            $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$elemAfterStyles.root,
            $5638831521affcfb$var$topLevelSiblingStyles.root,
            $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$actionStyles.root,
            $5638831521affcfb$var$topLevelSiblingStyles.root,
            $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
}; /**
    * __MenuItemBase__
    *
    * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
    *
    * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
    * This can be inferred from the type of the `onClick` prop.
    */ 
const $5638831521affcfb$export$859b390bf71e044e = (0, $4Qc44.default)($5638831521affcfb$var$MenuItemBaseNoRef);
module.exports["MenuItemBase"] = $5638831521affcfb$export$859b390bf71e044e;

});

parcelRegister("5BGbo", function(module, exports) {
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $45ab1e0d57f7b75e$export$d492445a79a49b48 = '12px';
module.exports["expandableMenuItemIndentation"] = $45ab1e0d57f7b75e$export$d492445a79a49b48;

});

parcelRegister("8VFFa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8LYsc = parcelRequire("8LYsc");

const $8987a63c5c396e33$var$styles = {
    root: "_1UtDYzZpcK _3iDTPblSYR _0aFT5vbt8w _37wbyuDIqT _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _0GTcwRB0rP"
};
const $8987a63c5c396e33$export$a0c24614540b0efb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DragHandle() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $8987a63c5c396e33$var$styles.root
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
            label: "",
            size: "small"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function DragHandle() {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $8987a63c5c396e33$var$styles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
        label: "",
        size: "small"
    }));
};
module.exports["DragHandle"] = $8987a63c5c396e33$export$a0c24614540b0efb;

});

parcelRegister("8AWCX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $6q25I = parcelRequire("6q25I");

const $bcae43b5e5d77907$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$572ce188c913ceba = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$650d12d3c2ddb8fc = (0, $6q25I.ExpandableMenuItemLevelContext);
const $bcae43b5e5d77907$export$37e565a09598825e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$c856e5885cc34d81);
    (0, $bB0i2.default)(context !== null, "useIsExpanded must be used within an ExpandableMenuItem");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$c856e5885cc34d81);
    (0, $bB0i2.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $bcae43b5e5d77907$export$c9a171ea8de5861b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$48cb11cb8691f597);
    (0, $bB0i2.default)(context !== null, "useSetIsExpanded must be used within an ExpandableMenuItem");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$48cb11cb8691f597);
    (0, $bB0i2.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $bcae43b5e5d77907$export$56c8438498b72c7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($bcae43b5e5d77907$export$572ce188c913ceba);
} : ()=>(0, $cozmU.useContext)($bcae43b5e5d77907$export$572ce188c913ceba);
const $bcae43b5e5d77907$export$fdfe9e5e8183d4f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($bcae43b5e5d77907$export$650d12d3c2ddb8fc);
} : ()=>(0, $cozmU.useContext)($bcae43b5e5d77907$export$650d12d3c2ddb8fc);
const $bcae43b5e5d77907$export$57108b5f08ae5194 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($bcae43b5e5d77907$export$9c01e0e6a504d553) ?? true;
} : ()=>(0, $cozmU.useContext)($bcae43b5e5d77907$export$9c01e0e6a504d553) ?? true;
module.exports["AreAllAncestorsExpandedContext"] = $bcae43b5e5d77907$export$9c01e0e6a504d553;
module.exports["IsExpandedContext"] = $bcae43b5e5d77907$export$c856e5885cc34d81;
module.exports["SetIsExpandedContext"] = $bcae43b5e5d77907$export$48cb11cb8691f597;
module.exports["OnExpansionToggleContext"] = $bcae43b5e5d77907$export$572ce188c913ceba;
module.exports["LevelContext"] = $bcae43b5e5d77907$export$650d12d3c2ddb8fc;
module.exports["useIsExpanded"] = $bcae43b5e5d77907$export$37e565a09598825e;
module.exports["useSetIsExpanded"] = $bcae43b5e5d77907$export$c9a171ea8de5861b;
module.exports["useOnExpansionToggle"] = $bcae43b5e5d77907$export$56c8438498b72c7a;
module.exports["useLevel"] = $bcae43b5e5d77907$export$fdfe9e5e8183d4f2;
module.exports["useAreAllAncestorsExpanded"] = $bcae43b5e5d77907$export$57108b5f08ae5194;

});

parcelRegister("6q25I", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b23dba5ac65c5d1$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $cozmU.createContext)(0);
module.exports["ExpandableMenuItemLevelContext"] = $0b23dba5ac65c5d1$export$f8d6463f9b5ca897;

});

parcelRegister("1TBPy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $e3ebb2a554993ae8$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $e3ebb2a554993ae8$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
const $e3ebb2a554993ae8$export$6927118f874a49aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e3ebb2a554993ae8$export$efa4d9670e96ac31);
} : ()=>(0, $cozmU.useContext)($e3ebb2a554993ae8$export$efa4d9670e96ac31);
const $e3ebb2a554993ae8$export$538ac1aa421adb94 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e3ebb2a554993ae8$export$4c55b1c61a116b42);
} : ()=>(0, $cozmU.useContext)($e3ebb2a554993ae8$export$4c55b1c61a116b42);
const $e3ebb2a554993ae8$export$aca29900ef2078d3 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e3ebb2a554993ae8$export$c768f9564e21558a = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e3ebb2a554993ae8$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $cozmU.createContext)({
    current: null
});
const $e3ebb2a554993ae8$export$fb4c7299c436068c = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e3ebb2a554993ae8$export$761b237ca835a288 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e3ebb2a554993ae8$export$fb4c7299c436068c);
} : ()=>(0, $cozmU.useContext)($e3ebb2a554993ae8$export$fb4c7299c436068c);
const $e3ebb2a554993ae8$export$9abe8108f4bc916 = $e3ebb2a554993ae8$export$fb4c7299c436068c.Provider;
module.exports["IsOpenContext"] = $e3ebb2a554993ae8$export$efa4d9670e96ac31;
module.exports["SetIsOpenContext"] = $e3ebb2a554993ae8$export$4c55b1c61a116b42;
module.exports["useFlyoutMenuOpen"] = $e3ebb2a554993ae8$export$6927118f874a49aa;
module.exports["useSetFlyoutMenuOpen"] = $e3ebb2a554993ae8$export$538ac1aa421adb94;
module.exports["SetInitialFocusRefContext"] = $e3ebb2a554993ae8$export$aca29900ef2078d3;
module.exports["InitialFocusOriginContext"] = $e3ebb2a554993ae8$export$c768f9564e21558a;
module.exports["OnCloseContext"] = $e3ebb2a554993ae8$export$7376ab1fc7707bdd;
module.exports["useTitleId"] = $e3ebb2a554993ae8$export$761b237ca835a288;
module.exports["TitleIdContextProvider"] = $e3ebb2a554993ae8$export$9abe8108f4bc916;

});

parcelRegister("3TF4i", function(module, exports) {
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $5a71eb42bbdc1a68$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');
module.exports["COLLAPSE_ELEM_BEFORE"] = $5a71eb42bbdc1a68$export$f4b8e24fae579c6f;

});

parcelRegister("4o9cR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $8AWCX = parcelRequire("8AWCX");

function $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
const $9fe3f1218f1710c7$export$2c52ec851fcc6058 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollMenuItemIntoView(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { elementRef: elementRef, isSelected: isSelected } = t0;
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            type: "waiting-to-be-selected-and-all-ancestors-expanded"
        };
        $[0] = t1;
    } else t1 = $[0];
    const waitingStateRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== areAllAncestorsExpanded || $[2] !== elementRef || $[3] !== isSelected) {
        t2 = ()=>{
            if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
                const shouldScroll = areAllAncestorsExpanded && isSelected;
                if (!shouldScroll) return;
                const element = elementRef.current;
                (0, $bB0i2.default)(element, "Element ref must be set");
                $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
                waitingStateRef.current.type = "waiting-to-be-unselected";
                return;
            }
            if (waitingStateRef.current.type === "waiting-to-be-unselected") {
                if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
                return;
            }
        };
        t3 = [
            areAllAncestorsExpanded,
            elementRef,
            isSelected
        ];
        $[1] = areAllAncestorsExpanded;
        $[2] = elementRef;
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useScrollMenuItemIntoView({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $cozmU.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $cozmU.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $bB0i2.default)(element, 'Element ref must be set');
            $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
};
module.exports["useScrollMenuItemIntoView"] = $9fe3f1218f1710c7$export$2c52ec851fcc6058;

});

parcelRegister("dVkip", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $j3b2C = parcelRequire("j3b2C");


var $5t9S7 = parcelRequire("5t9S7");


var $4eIcx = parcelRequire("4eIcx");


var $4H4Pj = parcelRequire("4H4Pj");


var $gW6rh = parcelRequire("gW6rh");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");


var $ep3mz = parcelRequire("ep3mz");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");

const $568e72a32d90ae8c$export$927df7988fec803 = (0, $gW6rh.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery = (0, $4H4Pj.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery = (0, $4eIcx.default);
const $568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery = (0, $5t9S7.default);
const $568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery = (0, $j3b2C.default);
const $568e72a32d90ae8c$var$hasCurrentSpace = (data)=>'space' in data;
const $568e72a32d90ae8c$var$isCurrentSpaceNotFoundError = (gqlError)=>gqlError.path?.[0] === 'space' && gqlError.extensions?.['statusCode'] === 404;
const $568e72a32d90ae8c$var$processStarredError = (error)=>{
    if (!error) return undefined;
    if ((0, $1uFM6.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$var$processRecentError = (error)=>{
    if (!error) return undefined;
    /**
   * space
   *    403: Expected to occur when the user is on a restricted space
   *    404: Expected to occur when the user is on an invalid space
   * recentSpaces
   *    403: Harmless error temporarily being ignored to mitigate CONFDEV-71458.
   *         Removing in CONFDEV-71656.
   */ if ((0, $1uFM6.isUnauthorizedError)(error) || !error.networkError && error.graphQLErrors.every($568e72a32d90ae8c$var$isCurrentSpaceNotFoundError)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$export$e3e9588fd2c1abdd = ({ isLicensed: isLicensed })=>{
    const { data: starredSpacesData, loading: starredSpacesLoading, error: starredSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$export$927df7988fec803, {
        skip: !isLicensed,
        __callerPackage__: "space-utils"
    });
    const { data: anonymousSpacesData, loading: anonymousSpacesLoading, error: anonymousSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery, {
        skip: isLicensed,
        __callerPackage__: "space-utils"
    });
    const data = isLicensed ? starredSpacesData : anonymousSpacesData;
    const loading = isLicensed ? starredSpacesLoading : anonymousSpacesLoading;
    const error = isLicensed ? starredSpacesError : anonymousSpacesError;
    const starredSpaces = (data?.spaces?.nodes || []).filter((space)=>space != null).map((space_0)=>({
            ...space_0,
            currentUser: {
                isFavourited: isLicensed
            }
        }));
    const unexpectedError = $568e72a32d90ae8c$var$processStarredError(error);
    return {
        starredSpaces: starredSpaces,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$var$useRecentData = (isLicensed)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: myVisitedSpacesWithCurrentSpaceData, loading: myVisitedSpacesWithCurrentSpaceLoading, error: myVisitedSpacesWithCurrentSpaceError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery, {
        skip: !isLicensed || !spaceKey,
        variables: {
            selectedSpaceKey: spaceKey
        },
        errorPolicy: 'all',
        __callerPackage__: "space-utils"
    });
    const { data: myVisitedSpacesData, loading: myVisitedSpacesLoading, error: myVisitedSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery, {
        skip: !isLicensed || !!spaceKey,
        errorPolicy: 'all',
        __callerPackage__: "space-utils"
    });
    const data = spaceKey ? myVisitedSpacesWithCurrentSpaceData : myVisitedSpacesData;
    const loading = spaceKey ? myVisitedSpacesWithCurrentSpaceLoading : myVisitedSpacesLoading;
    const error = spaceKey ? myVisitedSpacesWithCurrentSpaceError : myVisitedSpacesError;
    const currentSpace = data && $568e72a32d90ae8c$var$hasCurrentSpace(data) && data.space || undefined;
    const recentData = data?.myVisitedSpaces?.nodes?.spaces;
    const recentSpaces = (recentData || []).filter((space)=>space != null && (!currentSpace || currentSpace.id !== space.id));
    const unexpectedError = $568e72a32d90ae8c$var$processRecentError(error);
    return {
        recentSpaces: recentSpaces,
        currentSpace: currentSpace,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$export$680b01e9499af50d = ()=>{
    const $ = (0, $bDgLe.c)(18);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== isLicensed) {
        t0 = {
            isLicensed: isLicensed
        };
        $[0] = isLicensed;
        $[1] = t0;
    } else t0 = $[1];
    const { starredSpaces: starredSpaces, loading: starredLoading, error: starredError } = $568e72a32d90ae8c$export$e3e9588fd2c1abdd(t0);
    const { recentSpaces: unfilteredRecents, currentSpace: currentSpace, loading: recentLoading, error: recentError } = $568e72a32d90ae8c$var$useRecentData(isLicensed);
    let t1;
    if ($[2] !== starredSpaces) {
        t1 = new Set(starredSpaces.map($568e72a32d90ae8c$var$_temp));
        $[2] = starredSpaces;
        $[3] = t1;
    } else t1 = $[3];
    const starredIds = t1;
    let t2;
    if ($[4] !== starredIds || $[5] !== unfilteredRecents) {
        let t3;
        if ($[7] !== starredIds) {
            t3 = (recent)=>!starredIds.has(recent.id);
            $[7] = starredIds;
            $[8] = t3;
        } else t3 = $[8];
        t2 = unfilteredRecents.filter(t3).slice(0, 5);
        $[4] = starredIds;
        $[5] = unfilteredRecents;
        $[6] = t2;
    } else t2 = $[6];
    const recentSpaces = t2;
    let errors;
    if ($[9] !== recentError || $[10] !== starredError) {
        errors = [];
        if (starredError) errors.push(starredError);
        if (recentError) errors.push(recentError);
        $[9] = recentError;
        $[10] = starredError;
        $[11] = errors;
    } else errors = $[11];
    const t3 = starredLoading || recentLoading;
    let t4;
    if ($[12] !== currentSpace || $[13] !== errors || $[14] !== recentSpaces || $[15] !== starredSpaces || $[16] !== t3) {
        t4 = {
            errors: errors,
            loading: t3,
            starredSpaces: starredSpaces,
            recentSpaces: recentSpaces,
            currentSpace: currentSpace
        };
        $[12] = currentSpace;
        $[13] = errors;
        $[14] = recentSpaces;
        $[15] = starredSpaces;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
};
const $568e72a32d90ae8c$export$ecaaf759b72f2f3d = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const [executeSearch, { data: data, loading: loading, error: error }] = (0, $lvOsp.useLazyQueryInterop)($568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery, {
        __callerPackage__: "space-utils"
    });
    const spaceSearchResults = (data?.spaces?.nodes || []).filter((space)=>space != null);
    const searchSpaces = (0, $cozmU.useCallback)((pattern)=>{
        if (pattern) executeSearch({
            variables: {
                spaceNamePattern: pattern,
                isLicensed: isLicensed
            }
        });
    }, [
        executeSearch,
        isLicensed
    ]);
    return {
        spaceSearchResults: spaceSearchResults,
        loading: loading,
        error: error,
        searchSpaces: searchSpaces
    };
};
function $568e72a32d90ae8c$var$_temp(starred) {
    return starred.id;
}
module.exports["useStarredData"] = $568e72a32d90ae8c$export$e3e9588fd2c1abdd;
module.exports["useSpacesData"] = $568e72a32d90ae8c$export$680b01e9499af50d;
module.exports["useSpaceSearchData"] = $568e72a32d90ae8c$export$ecaaf759b72f2f3d;

});

parcelRegister("j3b2C", function(module, exports) {
/**
 * @generated SignedSource<<05b9969d72cde883b714d417571da65a>>
 * @relayHash 807f0e620b159313dc25553268599830
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee
const $abc61d7dc008195d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceNamePattern"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Variable",
                    "name": "spaceNamePattern",
                    "variableName": "spaceNamePattern"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourited"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "807f0e620b159313dc25553268599830",
            "id": "70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee",
            "metadata": {},
            "name": "useSpacesDataSearchSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataSearchSpacesQuery($spaceNamePattern:String!,$isLicensed:Boolean!){spaces(first:30,status:\"current\",spaceNamePattern:$spaceNamePattern){nodes{alias,id,name,key,status,icon{path},currentUser@include(if:$isLicensed){isFavourited}}}}"
        }
    };
}();
$abc61d7dc008195d$var$node.hash = "414c959dafecb5d27ba9ddb5658cc68d";
var $abc61d7dc008195d$export$2e2bcd8739ae039 = $abc61d7dc008195d$var$node;
module.exports["default"] = $abc61d7dc008195d$export$2e2bcd8739ae039;

});

parcelRegister("5t9S7", function(module, exports) {
/**
 * @generated SignedSource<<834023d7f0314fe8e5962f6e892c4636>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476
const $410f901cf69fac5d$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(first:10)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
            "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
            "metadata": {},
            "name": "useSpacesDataAnonymousSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$410f901cf69fac5d$var$node.hash = "7f837e22c8d2b27a827944523b07b786";
var $410f901cf69fac5d$export$2e2bcd8739ae039 = $410f901cf69fac5d$var$node;
module.exports["default"] = $410f901cf69fac5d$export$2e2bcd8739ae039;

});

parcelRegister("4eIcx", function(module, exports) {
/**
 * @generated SignedSource<<2801721cb0c85e92874b08f85a0ef8ee>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e
const $f0042d2ade0da40c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedSpaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "selectedSpaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
            "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$f0042d2ade0da40c$var$node.hash = "24da03b127211694c7ed862f0d6a1ac9";
var $f0042d2ade0da40c$export$2e2bcd8739ae039 = $f0042d2ade0da40c$var$node;
module.exports["default"] = $f0042d2ade0da40c$export$2e2bcd8739ae039;

});

parcelRegister("4H4Pj", function(module, exports) {
/**
 * @generated SignedSource<<522284270ccae9ff37ff7a08efdc694a>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79
const $893f79462ca6be46$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
            "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$893f79462ca6be46$var$node.hash = "7082555a280d4e2eb838dda87a12b019";
var $893f79462ca6be46$export$2e2bcd8739ae039 = $893f79462ca6be46$var$node;
module.exports["default"] = $893f79462ca6be46$export$2e2bcd8739ae039;

});

parcelRegister("gW6rh", function(module, exports) {
/**
 * @generated SignedSource<<6731d778ac5ebb58b720918619ebf00d>>
 * @relayHash 3aa9658e6db0cb9714f9e327bc6d5bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8
const $af8a2f26164bd677$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "favourite",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "3aa9658e6db0cb9714f9e327bc6d5bd0",
            "id": "9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8",
            "metadata": {},
            "name": "useSpacesDataStarredSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataStarredSpacesQuery{spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$af8a2f26164bd677$var$node.hash = "519f9d02cbfeb4f3f118821c02e3a7b9";
var $af8a2f26164bd677$export$2e2bcd8739ae039 = $af8a2f26164bd677$var$node;
module.exports["default"] = $af8a2f26164bd677$export$2e2bcd8739ae039;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $7EPz1 = parcelRequire("7EPz1");


var $3u5lg = parcelRequire("3u5lg");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $8BQV6 = parcelRequire("8BQV6");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $jclGA = parcelRequire("jclGA");


var $bUmU8 = parcelRequire("bUmU8");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $7q7rs = parcelRequire("7q7rs");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");


var $bFdYQ = parcelRequire("bFdYQ");


var $3VgTg = parcelRequire("3VgTg");


var $7M67g = parcelRequire("7M67g");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropApollo(query, options);
}
const $278c8d04dad7bc1d$var$useLazyQueryInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(53);
    let apolloFetchPolicy;
    let apolloOptions;
    let interopApolloAggClient;
    let t0;
    if ($[0] !== options) {
        ({ interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {});
        apolloFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.fetchPolicy);
        t0 = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.nextFetchPolicy);
        $[0] = options;
        $[1] = apolloFetchPolicy;
        $[2] = apolloOptions;
        $[3] = interopApolloAggClient;
        $[4] = t0;
    } else {
        apolloFetchPolicy = $[1];
        apolloOptions = $[2];
        interopApolloAggClient = $[3];
        t0 = $[4];
    }
    const apolloNextFetchPolicy = t0;
    const t1 = options?.__callerPackage__;
    let t2;
    if ($[5] !== apolloFetchPolicy || $[6] !== apolloOptions.onCompleted || $[7] !== apolloOptions.variables || $[8] !== interopApolloAggClient || $[9] !== query || $[10] !== t1) {
        t2 = {
            query: query,
            variables: apolloOptions.variables,
            fetchPolicy: apolloFetchPolicy,
            useAggClient: interopApolloAggClient,
            onCompleted: apolloOptions.onCompleted,
            callerPackage: t1
        };
        $[5] = apolloFetchPolicy;
        $[6] = apolloOptions.onCompleted;
        $[7] = apolloOptions.variables;
        $[8] = interopApolloAggClient;
        $[9] = query;
        $[10] = t1;
        $[11] = t2;
    } else t2 = $[11];
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)(t2);
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    let t3;
    if ($[12] !== query) {
        t3 = (0, $86okN.toDocumentNode)(query);
        $[12] = query;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== apolloNextFetchPolicy) {
        t4 = apolloNextFetchPolicy ? {
            nextFetchPolicy: apolloNextFetchPolicy
        } : {};
        $[14] = apolloNextFetchPolicy;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== onApolloCompleted) {
        t5 = onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {};
        $[16] = onApolloCompleted;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== interopApolloAggClient) {
        t6 = interopApolloAggClient ? {
            client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
        } : {};
        $[18] = interopApolloAggClient;
        $[19] = t6;
    } else t6 = $[19];
    const t7 = apolloOptions?.context;
    const t8 = query.params?.id;
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
        t9 = {
            ...t7,
            requestId: t8
        };
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== apolloFetchPolicy || $[24] !== apolloOptions || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t9) {
        t10 = {
            ...apolloOptions,
            fetchPolicy: apolloFetchPolicy,
            ...t4,
            ...t5,
            ...t6,
            context: t9
        };
        $[23] = apolloFetchPolicy;
        $[24] = apolloOptions;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)(t3, t10);
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    let t11;
    if ($[30] !== apolloResult.variables || $[31] !== getCacheBridgeVariables) {
        t11 = getCacheBridgeVariables(apolloResult.variables);
        $[30] = apolloResult.variables;
        $[31] = getCacheBridgeVariables;
        $[32] = t11;
    } else t11 = $[32];
    const apolloVariables = t11;
    let t12;
    let t13;
    if ($[33] !== apolloVariables || $[34] !== isCacheBridgeEnabled || $[35] !== updateLatestVariables) {
        t12 = ()=>{
            if (!isCacheBridgeEnabled) return;
            updateLatestVariables(apolloVariables);
        };
        t13 = [
            apolloVariables,
            isCacheBridgeEnabled,
            updateLatestVariables
        ];
        $[33] = apolloVariables;
        $[34] = isCacheBridgeEnabled;
        $[35] = updateLatestVariables;
        $[36] = t12;
        $[37] = t13;
    } else {
        t12 = $[36];
        t13 = $[37];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[38] !== apolloCalled || $[39] !== apolloData || $[40] !== apolloError || $[41] !== apolloVariables || $[42] !== isCacheBridgeEnabled || $[43] !== syncObservedResult) {
        t14 = ()=>{
            if (!isCacheBridgeEnabled) return;
            syncObservedResult({
                skip: !apolloCalled,
                variables: apolloVariables,
                data: apolloData,
                error: apolloError
            });
        };
        t15 = [
            apolloCalled,
            apolloData,
            apolloError,
            apolloVariables,
            isCacheBridgeEnabled,
            syncObservedResult
        ];
        $[38] = apolloCalled;
        $[39] = apolloData;
        $[40] = apolloError;
        $[41] = apolloVariables;
        $[42] = isCacheBridgeEnabled;
        $[43] = syncObservedResult;
        $[44] = t14;
        $[45] = t15;
    } else {
        t14 = $[44];
        t15 = $[45];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[46] !== executeLazyQuery || $[47] !== getLatestVariables || $[48] !== updateLatestVariables) {
        t16 = (executeOptions)=>{
            updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
            return executeLazyQuery(executeOptions);
        };
        $[46] = executeLazyQuery;
        $[47] = getLatestVariables;
        $[48] = updateLatestVariables;
        $[49] = t16;
    } else t16 = $[49];
    const executeLazyQueryWithCacheBridgeVariables = t16;
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    let t17;
    if ($[50] !== apolloResult || $[51] !== executeLazyQueryWithCacheBridgeVariables) {
        t17 = [
            executeLazyQueryWithCacheBridgeVariables,
            apolloResult
        ];
        $[50] = apolloResult;
        $[51] = executeLazyQueryWithCacheBridgeVariables;
        $[52] = t17;
    } else t17 = $[52];
    return t17;
} : function useLazyQueryInteropApollo(query, options) {
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    // Interop-only policies must be translated before they reach Apollo — see mapFetchPolicyForApollo.
    const apolloFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.fetchPolicy);
    const apolloNextFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.nextFetchPolicy);
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)({
        query: query,
        variables: apolloOptions.variables,
        fetchPolicy: apolloFetchPolicy,
        useAggClient: interopApolloAggClient,
        onCompleted: apolloOptions.onCompleted,
        callerPackage: options?.__callerPackage__
    });
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        fetchPolicy: apolloFetchPolicy,
        ...apolloNextFetchPolicy ? {
            nextFetchPolicy: apolloNextFetchPolicy
        } : {},
        ...onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {},
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    const apolloVariables = getCacheBridgeVariables(apolloResult.variables);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        updateLatestVariables(apolloVariables);
    }, [
        apolloVariables,
        isCacheBridgeEnabled,
        updateLatestVariables
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        syncObservedResult({
            skip: !apolloCalled,
            variables: apolloVariables,
            data: apolloData,
            error: apolloError
        });
    }, [
        apolloCalled,
        apolloData,
        apolloError,
        apolloVariables,
        isCacheBridgeEnabled,
        syncObservedResult
    ]);
    const executeLazyQueryWithCacheBridgeVariables = (0, $cozmU.useCallback)((executeOptions)=>{
        updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
        return executeLazyQuery(executeOptions);
    }, [
        executeLazyQuery,
        getLatestVariables,
        updateLatestVariables
    ]);
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    return [
        executeLazyQueryWithCacheBridgeVariables,
        apolloResult
    ];
};
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    const hookContext = options?.context;
    // Match Apollo's cache-first default rather than inheriting fetchQuery's
    // network-only default when the caller omits fetchPolicy.
    // See the equivalent comment in useQueryInterop: 'no-store' suppresses store reads as well as
    // writes, and is derived from the initial policy only.
    const noStore = (0, $3NBsC.isNoStoreFetchPolicy)(options?.fetchPolicy);
    const initialFetchPolicy = (0, $3NBsC.mapFetchPolicyForQuery)(options?.fetchPolicy);
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const cacheBridgeFetchPolicy = options?.fetchPolicy;
    const cacheBridgeSubsequentFetchPolicy = options?.nextFetchPolicy ?? cacheBridgeFetchPolicy;
    const interopApolloAggClient = options?.interopApolloAggClient;
    const pollInterval = options?.pollInterval ?? 0;
    const notifyOnNetworkStatusChange = options?.notifyOnNetworkStatusChange || false;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    // Defers onCompleted/onError to a post-commit effect so callers observe the state
    // that describes the result being reported, matching Apollo — whose lazy path routes
    // through the same `afterExecute` -> `handleErrorOrCompleted` effect once the query
    // has been run. `queueNotification` is referentially stable, so listing it in the
    // `execute`/`fetchMore` dependency arrays cannot re-issue a request.
    const { queueNotification: queueNotification, markLoading: markLoading } = (0, $bUmU8.useDeferredQueryNotifications)({
        onCompleted: onCompleted,
        onError: onError,
        hasCallbacks: Boolean(options?.onCompleted || options?.onError)
    });
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [called, setCalled] = (0, $cozmU.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $cozmU.useState)(hookVariables);
    // True only while a poll tick is the in-flight request. Apollo reports a tick as
    // `networkStatus: poll` rather than `loading`, and the lazy result has no `networkStatus`
    // field, so this flag is what keeps a tick out of the UFO hold below.
    const [isPollTickInFlight, setIsPollTickInFlight] = (0, $cozmU.useState)(false);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Subscribe to cache updates after query is called to keep data reactive.
    // This ensures that when mutations update the cache, components using this
    // lazy query will automatically re-render with the fresh data, matching
    // Apollo's behavior where useLazyQuery subscribes to cache changes.
    // See: https://hello.atlassian.net/browse/COPPER-XXXXX (Star menu bug)
    (0, $cozmU.useEffect)(()=>{
        if (!called) return;
        // 'no-store' writes nothing, so there is no record of its own to watch — and subscribing
        // would surface *other* operations' writes to the same ids, which is the pollution the
        // policy exists to prevent. These queries refetch explicitly instead.
        if (noStore) return;
        // Subscribe to the Relay store to watch for cache updates (e.g., from mutations).
        // This matches the pattern used in useQueryInterop for reactive cache updates.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), activeVariables);
        const retainDisposable = environment.retain(operation);
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>{
            // Only update if mounted and data is not missing from cache
            // A network payload is normalized before its error policy is checked. Only
            // expose it through execute's success handler while that request is in flight.
            if (isMountedRef.current && (!(0, $9wGTI.fg)('confluence_relay_parity_fixes') || !executeInFlightRef.current) && !snapshot.isMissingData) setData(snapshot.data);
        });
        return ()=>{
            storeSubscription.dispose();
            retainDisposable.dispose();
        };
    }, [
        called,
        environment,
        query,
        activeVariables,
        noStore
    ]);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $cozmU.useRef)(0);
    const failedExecuteRef = (0, $cozmU.useRef)();
    const fetchMoreIdRef = (0, $cozmU.useRef)(0);
    // A poll tick must not race an `execute` for the same query — see `pollTick`.
    const executeInFlightRef = (0, $cozmU.useRef)(false);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const mirrorRelayResultToApollo = (0, $cozmU.useCallback)((relayResult, resultVariables, fetchPolicy)=>{
        // Lazy Relay execution remains the original source of truth; mirror
        // successful payloads into Apollo with the variables from that run.
        (0, $bFdYQ.syncQueryCacheBridge)({
            source: 'relay',
            query: query,
            variables: resultVariables,
            data: relayResult,
            fetchPolicy: fetchPolicy,
            useAggClient: interopApolloAggClient
        });
    }, [
        interopApolloAggClient,
        query
    ]);
    const ufoContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const ufoOperationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $cozmU.useEffect)(()=>{
        // A poll tick is excluded: it can repeat indefinitely, so holding the interaction for one
        // would never release. Mirrors useQueryInterop, which excludes `networkStatus: poll`.
        if (called && loading && !isPollTickInFlight) return ufoContext?.hold(ufoOperationName);
    }, [
        called,
        loading,
        isPollTickInFlight,
        ufoOperationName,
        ufoContext
    ]);
    const execute = (0, $cozmU.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        const cacheBridgeResultFetchPolicy = isFirstCall ? cacheBridgeFetchPolicy : cacheBridgeSubsequentFetchPolicy;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        const requestedFetchPolicy = isFirstCall ? initialFetchPolicy : subsequentFetchPolicy;
        // Relay normalizes partial payloads before errorPolicy rejects them. A retry of that
        // failed request must reach the network instead of treating the partial cache as success.
        const retryingFailedRequest = failedExecuteRef.current?.query === query && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(failedExecuteRef.current.variables, variables);
        const fetchPolicy = requestedFetchPolicy === 'store-or-network' && retryingFailedRequest && (0, $9wGTI.fg)('confluence_relay_parity_fixes') ? 'network-only' : requestedFetchPolicy;
        // A cache hit must not briefly hide existing UI while the resolved promise settles.
        const hasCachedResult = (0, $9wGTI.fg)('confluence_relay_parity_fixes') ? !noStore && fetchPolicy === 'store-or-network' && environment.check((0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables)).status === 'available' : false;
        setCalled(true);
        setActiveVariables(variables);
        setLoading((0, $9wGTI.fg)('confluence_relay_parity_fixes') ? !hasCachedResult : true);
        setError(undefined);
        // Every execute is a fresh loading transition, so a repeat execute with identical
        // variables still reports — matching Apollo, whose dedup guard is bypassed by the
        // loading flag going true.
        markLoading();
        executeInFlightRef.current = true;
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }, {
            noStore: noStore
        }).toPromise().then((result)=>{
            // Cleared even when unmounted, and only by the latest execute, so a superseded
            // response cannot open the door for a poll tick while a newer request is in flight.
            if (id === executeIdRef.current) executeInFlightRef.current = false;
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                failedExecuteRef.current = undefined;
                mirrorRelayResultToApollo(result, variables, cacheBridgeResultFetchPolicy);
                // Relay lookups can allocate equal results. Preserve Apollo's stable data
                // identity so cache-hit executes do not retrigger data-dependent effects.
                if ((0, $9wGTI.fg)('confluence_relay_parity_fixes')) setData((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previous, result) ? previous : result);
                else setData(result);
                setError(undefined);
                queueNotification({
                    type: 'completed',
                    data: result,
                    identity: {
                        query: query,
                        variables: variables
                    }
                });
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
        }).catch((rawErr)=>{
            if (id === executeIdRef.current) executeInFlightRef.current = false;
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            failedExecuteRef.current = {
                query: query,
                variables: variables
            };
            setError(err);
            setLoading(false);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        cacheBridgeFetchPolicy,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        queueNotification,
        markLoading,
        noStore
    ]);
    const fetchMore = (0, $cozmU.useCallback)((fetchMoreOpts)=>{
        const baseVariables = activeVarsRef.current;
        const variables = {
            ...baseVariables,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const executeId = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }, {
            noStore: noStore
        }).toPromise().then((fetchMoreResult)=>{
            // Apollo tears down the previous lazy observable on execute. Its pending
            // fetchMore rejects without calling updateQuery on the replacement query.
            if (executeId !== executeIdRef.current && (0, $9wGTI.fg)('confluence_relay_parity_fixes')) throw new Error('[Relay migration] fetchMore was superseded by a new lazy query execution');
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const pageData = (0, $9wGTI.fg)('confluence_relay_parity_fixes') ? (0, $jclGA.cloneRelayQueryResult)(fetchMoreResult) : fetchMoreResult;
            const merged = fetchMoreOpts.updateQuery((0, $9wGTI.fg)('confluence_relay_parity_fixes') ? (0, $jclGA.cloneRelayQueryResult)(dataRef.current ?? {}) : dataRef.current ?? {}, {
                fetchMoreResult: pageData,
                variables: variables
            });
            // Pages from the same execution merge in completion order, as in Apollo.
            // Keep the execute-generation guard so new executions still invalidate old pages.
            if ((0, $9wGTI.fg)('confluence_relay_parity_fixes') ? isMountedRef.current && executeId === executeIdRef.current : isStillCurrent()) {
                if ((0, $9wGTI.fg)('confluence_relay_parity_fixes')) dataRef.current = merged;
                mirrorRelayResultToApollo(merged, baseVariables, cacheBridgeSubsequentFetchPolicy);
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: (0, $9wGTI.fg)('confluence_relay_parity_fixes') ? pageData : merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // Deliberately does NOT report via onError. Measured against real Apollo
            // (useLazyQuery + fetchMore, success and failure, either
            // notifyOnNetworkStatusChange): neither callback is invoked — the promise
            // rejection is the only signal. Reporting here would over-fire relative to
            // Apollo and disagree with useQueryInterop.fetchMore, which reports nothing.
            // Error state is still surfaced so the hook's `error` field stays accurate.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        noStore
    ]);
    // ── Polling ──────────────────────────────────────────────────────────────────────────────
    // Apollo's lazy queries DO poll, contrary to what this hook previously assumed. `pollInterval`
    // reaches `client.watchQuery`, and `ObservableQuery.setUpQuery` starts the timer as soon as the
    // observable is subscribed — which for `useLazyQuery` is the first `execute`, since
    // `QueryData.execute` short-circuits until `runLazy` is true. Dropping the option left callers
    // with a single request and a promise that never resolves: the report/long-task call sites poll
    // a `ConfluenceLongTask` until it reports success, so one `InProgress` response stalled them
    // forever with no error to show for it.
    // A generation counter invalidates ticks that a `stopPolling()` or an effect teardown has
    // superseded, so an in-flight tick can never schedule its successor after being cancelled.
    const pollGenerationRef = (0, $cozmU.useRef)(0);
    const pollTimeoutRef = (0, $cozmU.useRef)(null);
    // The variables that were active when the caller last called `stopPolling()`. Apollo's
    // `stopPolling` is sticky: it clears `options.pollInterval` on the observable, and polling only
    // resumes once the *prepared* options change — i.e. a later `execute` with different variables
    // (`QueryData.updateObservableQuery` -> `ObservableQuery.setOptions` -> `startPolling`). A bare
    // re-execute with identical variables leaves polling stopped, so the guard is deep-compared
    // against the active variables rather than just cleared on the next execute.
    const pollStoppedVariablesRef = (0, $cozmU.useRef)(null);
    // Declared ahead of `pollTick` so a tick can schedule its successor without referencing its own
    // binding; re-pointed at the freshly-closed-over `pollTick` on every render below.
    const pollTickRef = (0, $cozmU.useRef)(()=>{});
    const cancelScheduledPoll = (0, $cozmU.useCallback)(()=>{
        pollGenerationRef.current += 1;
        if (pollTimeoutRef.current !== null) {
            clearTimeout(pollTimeoutRef.current);
            pollTimeoutRef.current = null;
        }
    }, []);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        pollStoppedVariablesRef.current = activeVarsRef.current;
        cancelScheduledPoll();
    }, [
        cancelScheduledPoll,
        activeVarsRef
    ]);
    // Redefined each render rather than memoised, and reached only through the synced ref below, so
    // a tick always closes over the current environment/variables/callbacks with no stale-closure
    // window and no dependency array that could re-arm the timer.
    const pollTick = (interval, generation)=>{
        const isCurrentGeneration = ()=>isMountedRef.current && generation === pollGenerationRef.current;
        const scheduleNextTick = ()=>{
            if (!isCurrentGeneration()) return;
            // setTimeout chained off the previous tick's settlement, not setInterval: Apollo
            // reschedules in `poll()` only after the fetch resolves or rejects
            // (`QueryManager.startPollingQuery`), so a response slower than the interval can never
            // stack requests.
            pollTimeoutRef.current = setTimeout(()=>pollTickRef.current(interval, generation), interval);
        };
        // Apollo skips a tick outright while a request for the query is already in flight and just
        // reschedules (`maybeFetch` -> `checkInFlight`).
        if (executeInFlightRef.current) {
            scheduleNextTick();
            return;
        }
        const variables = activeVarsRef.current;
        if (notifyOnNetworkStatusChange) {
            setIsPollTickInFlight(true);
            setLoading(true);
        }
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            // Apollo forces `network-only` on every tick regardless of the query's own policy
            // (`startPollingQuery` overrides `info.options.fetchPolicy`) — a poll that could be
            // served from the cache would never observe the change it is polling for.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }, {
            noStore: noStore
        }).toPromise().then((result)=>{
            if (!isMountedRef.current) return;
            if (notifyOnNetworkStatusChange) {
                setIsPollTickInFlight(false);
                setLoading(false);
            }
            if (!isCurrentGeneration()) return;
            // Guard against empty completions so a store-only miss can't wipe `data`.
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeSubsequentFetchPolicy);
                setData(result);
                setError(undefined);
                // `markLoading()` is deliberately NOT called for a tick: the dedup guard in
                // useDeferredQueryNotifications then suppresses this notification for an
                // unchanged operation, which is what makes a tick apply its data without
                // reporting to onCompleted/onError. Same arrangement as useQueryInterop's
                // runPollTick, and the contract callers are documented against.
                queueNotification({
                    type: 'completed',
                    data: result,
                    identity: {
                        query: query,
                        variables: variables
                    }
                });
            }
            scheduleNextTick();
        }).catch((rawErr)=>{
            if (!isMountedRef.current) return;
            if (notifyOnNetworkStatusChange) {
                setIsPollTickInFlight(false);
                setLoading(false);
            }
            if (!isCurrentGeneration()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
            // Apollo keeps polling after a failed tick (`fetchQuery(...).then(poll, poll)`).
            scheduleNextTick();
        });
    };
    pollTickRef.current = pollTick;
    (0, $cozmU.useEffect)(()=>{
        // Gated on `called`, not mount: Apollo cannot poll before the observable is subscribed, and
        // for a lazy query that is the first `execute`.
        if (!called || pollInterval <= 0) return;
        // Apollo's QueryManager does not poll in `ssrMode`.
        if (typeof window === 'undefined') return;
        if (pollStoppedVariablesRef.current !== null && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pollStoppedVariablesRef.current, activeVariables)) return;
        pollStoppedVariablesRef.current = null;
        pollGenerationRef.current += 1;
        const generation = pollGenerationRef.current;
        // First tick lands one interval after the execute, matching Apollo's initial `poll()`.
        pollTimeoutRef.current = setTimeout(()=>pollTickRef.current(pollInterval, generation), pollInterval);
        return cancelScheduledPoll;
    // `activeVariables` is a dependency so a re-execute re-arms the timer from now, as Apollo's
    // `setOptions` -> `startPolling` does when the prepared options change.
    }, [
        called,
        pollInterval,
        activeVariables,
        cancelScheduledPoll
    ]);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $iITVA = parcelRequire("iITVA");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_30huDKdnbC _3YEZNOdnbC _0KLXruGsB2",
    loaded: "_0KLXrujOvk"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_0bjKvDKxmn _39xV02SPN1 _0jFU0VSPN1",
    small: "_0bjKvDcjp5 _39xV02oWWg _0jFU0VoWWg",
    medium: "_0bjKvDzXzM _39xV02Uofl _0jFU0VUofl",
    large: "_0bjKvDzXzM _39xV02UF4f _0jFU0VUF4f",
    xlarge: "_0bjKvDKTcp _39xV02JgOI _0jFU0VJgOI"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $hekY6.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    const setLoaded = (0, $cozmU.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Only the everything mode proceeds to data preloading.
        if (preloadOptions?.preloadingMode !== "everything") return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("gx8UM", function(module, exports) {

let $c096a4b9df7de379$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c096a4b9df7de379$var$load("6wr18"),
    $c096a4b9df7de379$var$load("e00ow"),
    $c096a4b9df7de379$var$load("ffEVr"),
    $c096a4b9df7de379$var$load("830Zv")
]).then(()=>parcelRequire('lC5h8'));

});

parcelRegister("kThSt", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $600905f17fc8a032$var$initialState = {
    isCollapsed: false
};
const $600905f17fc8a032$var$actions = {
    setIsCollapsed: (collapsed)=>({ setState: setState })=>{
            setState({
                isCollapsed: collapsed
            });
        }
};
const $600905f17fc8a032$export$c0c3c6fb1b0fe561 = (0, $8s9DV.createStore)({
    initialState: $600905f17fc8a032$var$initialState,
    actions: $600905f17fc8a032$var$actions
});
const $600905f17fc8a032$export$7d924aef7db527f0 = (0, $kBr4q.createHook)($600905f17fc8a032$export$c0c3c6fb1b0fe561);
const $600905f17fc8a032$export$ee6f665bc19ef05d = (0, $kBr4q.createActionsHook)($600905f17fc8a032$export$c0c3c6fb1b0fe561);
const $600905f17fc8a032$export$755dc35be9740363 = (0, $kBr4q.createStateHook)($600905f17fc8a032$export$c0c3c6fb1b0fe561, {
    selector: (state)=>state.isCollapsed
});
const $600905f17fc8a032$export$e2787a8e4c22c183 = (0, $j8on0.createContainer)($600905f17fc8a032$export$c0c3c6fb1b0fe561, {
    onInit: ()=>({ setState: setState }, { initialIsCollapsed: initialIsCollapsed })=>{
            setState({
                isCollapsed: initialIsCollapsed
            });
        }
});
module.exports["useSideNavigationCollapsedState"] = $600905f17fc8a032$export$7d924aef7db527f0;
module.exports["useSideNavigationCollapsedActions"] = $600905f17fc8a032$export$ee6f665bc19ef05d;
module.exports["useIsSideNavCollapsed"] = $600905f17fc8a032$export$755dc35be9740363;
module.exports["SideNavigationCollapsedContainer"] = $600905f17fc8a032$export$e2787a8e4c22c183;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $knAY5 = parcelRequire("knAY5");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("1uFsv", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $ee0fdcfc2b35384d$export$b79a5979472006ce = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.GLOBAL_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["GLOBAL_NAVIGATION_METRIC"] = $ee0fdcfc2b35384d$export$b79a5979472006ce;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $gXfti.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("ciI1q", function(module, exports) {

let $8f49505482f132e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8f49505482f132e7$var$load("aWuCm"),
    $8f49505482f132e7$var$load("iWnyc"),
    $8f49505482f132e7$var$load("1audf"),
    $8f49505482f132e7$var$load("bpBPu"),
    $8f49505482f132e7$var$load("6wr18"),
    $8f49505482f132e7$var$load("frPQh"),
    $8f49505482f132e7$var$load("8yk9S"),
    $8f49505482f132e7$var$load("RHpNJ"),
    $8f49505482f132e7$var$load("3jKKg"),
    $8f49505482f132e7$var$load("cQZE2"),
    $8f49505482f132e7$var$load("k0Z8C"),
    $8f49505482f132e7$var$load("Wowvf"),
    $8f49505482f132e7$var$load("ffEVr"),
    $8f49505482f132e7$var$load("9XFtf"),
    $8f49505482f132e7$var$load("jYCVY"),
    $8f49505482f132e7$var$load("a8R25"),
    $8f49505482f132e7$var$load("8OeKT"),
    $8f49505482f132e7$var$load("cD5e0")
]).then(()=>parcelRequire('C9t7g'));

});

parcelRegister("2qRJj", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $ENihE = parcelRequire("ENihE");


var $aWrnw = parcelRequire("aWrnw");

const $662218afe73e5a2d$var$separatorStyles = null;
const $662218afe73e5a2d$var$separatorStylesFallback = null;

const $662218afe73e5a2d$export$d97a74b7c2565df0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcP7O",
    name: "SpaceNavigationLoader",
    loader: async ()=>(await (parcelRequire("4I9Op"))).SpaceNavigation,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        })
});
const $662218afe73e5a2d$export$a91923d0186f609a = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_30huDKPgdg _3SamIHPgdg _2YLqiKB0rP _1x1D3gOeNX"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_30huDKdnbC _3SamIHPgdg _2YLqiKB0rP _1x1D3gOeNX"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    const separatorHr = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_NAVIGATION_METRIC)
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, separatorHr, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($662218afe73e5a2d$export$d97a74b7c2565df0, props));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $662218afe73e5a2d$export$d4aec89b198b6129 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SpaceNavigationLoader"] = $662218afe73e5a2d$export$d97a74b7c2565df0;
module.exports["SpaceNavigation"] = $662218afe73e5a2d$export$a91923d0186f609a;
module.exports["SpaceNavigationLoadingSkeleton"] = $662218afe73e5a2d$export$d4aec89b198b6129;

});

parcelRegister("ENihE", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $a0Wth = parcelRequire("a0Wth");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a59a0b51f845364$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0KLXrulfZc _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_24h04i2Njc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isloadingState: isloadingState, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT _24h04i2Njc _3iDTPbQ4SZ _0aFT5vvVnP _0jFU0VUF4f _1Znuxb2ADO",
            __cmplp.isloadingState ? "_2Zuz6Q70UD" : "_2Zuz6QuFDC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruaVjy _3YEZNOdnbC _0jFU0VoWWg _0adFHs5zaO _39xV02oWWg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Line = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKxmn _0jFU0Vey7F _39xV02v6H3 _0KLXruaVjy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$export$73d04a98c9062109 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { header: t1, loader: loader } = t0;
    const header = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== header || $[1] !== loader) {
        t2 = loader && header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a0Wth.SpaceHeaderSkeleton), null) : null;
        $[0] = header;
        $[1] = loader;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] !== loader) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t3, t4);
        $[5] = loader;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    let t8;
    if ($[9] !== loader) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t6, t7);
        $[9] = loader;
        $[10] = t8;
    } else t8 = $[10];
    let t10;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    let t11;
    if ($[13] !== loader) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t9, t10);
        $[13] = loader;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[15] = t12;
        $[16] = t13;
    } else {
        t12 = $[15];
        t13 = $[16];
    }
    let t14;
    if ($[17] !== loader) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t12, t13);
        $[17] = loader;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    let t16;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[19] = t15;
        $[20] = t16;
    } else {
        t15 = $[19];
        t16 = $[20];
    }
    let t17;
    if ($[21] !== loader) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t15, t16);
        $[21] = loader;
        $[22] = t17;
    } else t17 = $[22];
    let t18;
    if ($[23] !== t11 || $[24] !== t14 || $[25] !== t17 || $[26] !== t2 || $[27] !== t5 || $[28] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonContainer, {
            "data-testid": "sidebar-skeleton"
        }, t2, t5, t8, t11, t14, t17));
        $[23] = t11;
        $[24] = t14;
        $[25] = t17;
        $[26] = t2;
        $[27] = t5;
        $[28] = t8;
        $[29] = t18;
    } else t18 = $[29];
    return t18;
});
module.exports["ContainerSkeleton"] = $2a59a0b51f845364$export$73d04a98c9062109;

});

parcelRegister("a0Wth", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fd8870c1509e72c$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEs8lO _0hPCNLDIqT _24h04i2Njc _3iDTPbQ4SZ _39xV02aG3x",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceIconSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKTcp _39xV02oWWg _0jFU0VoWWg _0KLXruaVjy _0adFHs70UD",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceTitleSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKxmn _39xV02b1xp _0jFU0Vey7F _0KLXruaVjy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $4fd8870c1509e72c$export$76f5179c9c39352c() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fd8870c1509e72c$var$SkeletonContainer, {
            "data-testid": "space-header-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fd8870c1509e72c$var$SpaceIconSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fd8870c1509e72c$var$SpaceTitleSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
module.exports["SpaceHeaderSkeleton"] = $4fd8870c1509e72c$export$76f5179c9c39352c;

});

parcelRegister("aWrnw", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("4I9Op", function(module, exports) {

let $36e2e1f172c04208$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $36e2e1f172c04208$var$load("hhu66"),
    $36e2e1f172c04208$var$load("aLbuU"),
    $36e2e1f172c04208$var$load("e4XZ1"),
    $36e2e1f172c04208$var$load("lEedB"),
    $36e2e1f172c04208$var$load("a8R25"),
    $36e2e1f172c04208$var$load("7EorR"),
    $36e2e1f172c04208$var$load("aYgZt")
]).then(()=>parcelRequire('absYu'));

});

parcelRegister("dJFqB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $euL71 = parcelRequire("euL71");


var $9HB34 = parcelRequire("9HB34");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $1xpoY = parcelRequire("1xpoY");


var $dGmBZ = parcelRequire("dGmBZ");

const $ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $ec7296adc394eb50$export$8290219e59a270d8 = ()=>{
    return (0, $cozmU.useContext)($ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext);
};
const $ec7296adc394eb50$var$SpaceNavigationAffordanceDataProviderInner = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, spaceKey: spaceKey, variables: variables } = t0;
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = (0, $8Lx5S.useIsLicensed)();
    let t1;
    if ($[0] !== edition || $[1] !== hasLicensedAccess || $[2] !== isLicensed || $[3] !== isLoggedIn) {
        t1 = edition !== (0, $euL71.ConfluenceEdition).FREE && isLoggedIn && (!(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_license_error_fix") ? hasLicensedAccess : isLicensed);
        $[0] = edition;
        $[1] = hasLicensedAccess;
        $[2] = isLicensed;
        $[3] = isLoggedIn;
        $[4] = t1;
    } else t1 = $[4];
    const includePersistentInviteLicense = t1;
    let t2;
    if ($[5] !== cloudId || $[6] !== includePersistentInviteLicense || $[7] !== isLicensed || $[8] !== spaceKey || $[9] !== variables) {
        t2 = variables ?? {
            cloudId: cloudId,
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            includePersistentInviteLicense: includePersistentInviteLicense,
            includeSpaceCurationCount: false,
            includeSpaceViewsPersistence: false
        };
        $[5] = cloudId;
        $[6] = includePersistentInviteLicense;
        $[7] = isLicensed;
        $[8] = spaceKey;
        $[9] = variables;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fetchPolicy: "store-only"
        };
        $[11] = t3;
    } else t3 = $[11];
    const routeData = (0, $6SsN4.useLazyLoadQuery)((0, $dGmBZ.default), t2, t3);
    routeData.user?.confluence?.permissionType;
    let t4;
    bb0: {
        if (!routeData.space) {
            t4 = undefined;
            break bb0;
        }
        const t5 = routeData.user?.confluence?.permissionType === "EXTERNAL";
        let t6;
        if ($[12] !== routeData.license || $[13] !== routeData.space || $[14] !== routeData.spaceCurationSuggestionCount || $[15] !== t5) {
            t6 = {
                spaceFragmentRef: routeData.space,
                licenseFragmentRef: routeData.license,
                suggestionCountFragmentRef: routeData.spaceCurationSuggestionCount,
                isUserExternalCollaborator: t5
            };
            $[12] = routeData.license;
            $[13] = routeData.space;
            $[14] = routeData.spaceCurationSuggestionCount;
            $[15] = t5;
            $[16] = t6;
        } else t6 = $[16];
        t4 = t6;
    }
    const affordanceData = t4;
    if (!affordanceData) {
        let t5;
        if ($[17] !== children) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[17] = children;
            $[18] = t5;
        } else t5 = $[18];
        return t5;
    }
    let t5;
    if ($[19] !== affordanceData || $[20] !== children) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext.Provider, {
            value: affordanceData
        }, children);
        $[19] = affordanceData;
        $[20] = children;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
};
const $ec7296adc394eb50$export$653a8018007c119 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, spaceKey: spaceKey, variables: variables } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9HB34.getRelayEnvironment)();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== spaceKey || $[3] !== variables) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec7296adc394eb50$var$SpaceNavigationAffordanceDataProviderInner, {
            spaceKey: spaceKey,
            variables: variables
        }, children));
        $[1] = children;
        $[2] = spaceKey;
        $[3] = variables;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["useSpaceNavigationAffordanceData"] = $ec7296adc394eb50$export$8290219e59a270d8;
module.exports["SpaceNavigationAffordanceDataProvider"] = $ec7296adc394eb50$export$653a8018007c119;

});

parcelRegister("dGmBZ", function(module, exports) {
/**
 * @generated SignedSource<<1739ca03f6fad0b631a0f08eae777c45>>
 * @relayHash a07195cae5d2b99a2cf43d6d813de062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46fc5c59951bd2f66d5c1c78755260056ef440699c828ec8cde652f80a2d47a6
const $819504ce5ddad46c$var$node = function() {
    var v0 = {
        "defaultValue": 40,
        "kind": "LocalArgument",
        "name": "blogFirst"
    }, v1 = {
        "defaultValue": "metadata.createdDate desc",
        "kind": "LocalArgument",
        "name": "blogOrderBy"
    }, v2 = {
        "defaultValue": [
            "current",
            "draft"
        ],
        "kind": "LocalArgument",
        "name": "blogStatuses"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBlogTree"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeHomepageTreeVariant"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePageTree"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePersistentInviteLicense"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSharedSpaceDetails"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceCreationEligibility"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceCurationCount"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceViewsPersistence"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
    }, v20 = [
        v18 /*: any*/ ,
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "id"
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v24 = [
        v23 /*: any*/ 
    ], v25 = [
        {
            "kind": "Literal",
            "name": "includeHidden",
            "value": true
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "webItemKey"
    }, v27 = {
        "kind": "ScalarField",
        "name": "webItemCompleteKey"
    }, v28 = {
        "kind": "ScalarField",
        "name": "title"
    }, v29 = {
        "kind": "ScalarField",
        "name": "url"
    }, v30 = {
        "kind": "ScalarField",
        "name": "position"
    }, v31 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v32 = {
        "kind": "ScalarField",
        "name": "path"
    }, v33 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "width"
            },
            {
                "kind": "ScalarField",
                "name": "height"
            },
            {
                "kind": "ScalarField",
                "name": "isDefault"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "iconClass"
    }, v35 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v36 = {
        "kind": "ScalarField",
        "name": "canHide"
    }, v37 = {
        "kind": "ScalarField",
        "name": "tooltip"
    }, v38 = {
        "kind": "ScalarField",
        "name": "linkIdentifier"
    }, v39 = {
        "kind": "ScalarField",
        "name": "type"
    }, v40 = {
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "quick",
        "plural": true,
        "selections": [
            v21 /*: any*/ ,
            v29 /*: any*/ ,
            v30 /*: any*/ ,
            v28 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v41 = [
        v19 /*: any*/ 
    ], v42 = {
        "kind": "ScalarField",
        "name": "key"
    }, v43 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v21 /*: any*/ 
        ]
    }, v44 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "didContainUserContent"
    }, v46 = {
        "kind": "ScalarField",
        "name": "name"
    }, v47 = {
        "kind": "ScalarField",
        "name": "status"
    }, v48 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v32 /*: any*/ 
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "homepageId"
    }, v50 = {
        "kind": "ScalarField",
        "name": "isAdmin"
    }, v51 = {
        "kind": "ScalarField",
        "name": "isFavourited"
    }, v52 = {
        "kind": "ScalarField",
        "name": "isWatched"
    }, v53 = {
        "kind": "ScalarField",
        "name": "containsExternalCollaborators"
    }, v54 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v55 = {
        "concreteType": "SpaceHistory",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
            v54 /*: any*/ 
        ]
    }, v56 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v57 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v58 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v59 = [
        v56 /*: any*/ ,
        v57 /*: any*/ ,
        v58 /*: any*/ 
    ], v60 = {
        "kind": "FragmentSpread",
        "name": "PageTreeQuery_ptpage"
    }, v61 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v62 = [
        v61 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "endCursor"
        }
    ], v63 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": v62 /*: any*/ 
    }, v64 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v61 /*: any*/ 
        ]
    }, v65 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v60 /*: any*/ 
            ]
        },
        v64 /*: any*/ 
    ], v66 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v65 /*: any*/ 
    }, v67 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v65 /*: any*/ 
    }, v68 = [
        v60 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                v63 /*: any*/ ,
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v60 /*: any*/ ,
                        v66 /*: any*/ ,
                        v67 /*: any*/ 
                    ]
                }
            ]
        },
        v66 /*: any*/ ,
        v67 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v65 /*: any*/ 
        }
    ], v69 = [
        v56 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        v57 /*: any*/ ,
        v23 /*: any*/ ,
        v58 /*: any*/ 
    ], v70 = [
        v56 /*: any*/ ,
        v57 /*: any*/ ,
        v23 /*: any*/ ,
        v58 /*: any*/ 
    ], v71 = [
        v60 /*: any*/ ,
        v67 /*: any*/ 
    ], v72 = [
        v23 /*: any*/ ,
        v58 /*: any*/ 
    ], v73 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "blogFirst"
        },
        {
            "kind": "Variable",
            "name": "orderby",
            "variableName": "blogOrderBy"
        },
        v23 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "blogStatuses"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "blogpost"
        }
    ], v74 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": v62 /*: any*/ 
    }, v75 = {
        "kind": "ScalarField",
        "name": "value"
    }, v76 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v75 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v77 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v78 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v79 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v80 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v81 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v80 /*: any*/ 
    }, v82 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v21 /*: any*/ ,
                    v42 /*: any*/ ,
                    v75 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v83 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v84 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v21 /*: any*/ ,
                v28 /*: any*/ ,
                v47 /*: any*/ ,
                v76 /*: any*/ ,
                v77 /*: any*/ ,
                v78 /*: any*/ ,
                v39 /*: any*/ ,
                v79 /*: any*/ ,
                v81 /*: any*/ ,
                v82 /*: any*/ ,
                v83 /*: any*/ 
            ]
        },
        v64 /*: any*/ 
    ], v85 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v84 /*: any*/ 
    }, v86 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v84 /*: any*/ 
    }, v87 = [
        v21 /*: any*/ ,
        v28 /*: any*/ ,
        v47 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v78 /*: any*/ ,
        v39 /*: any*/ ,
        v79 /*: any*/ ,
        v81 /*: any*/ ,
        v82 /*: any*/ ,
        v83 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                v63 /*: any*/ ,
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v21 /*: any*/ ,
                        v28 /*: any*/ ,
                        v47 /*: any*/ ,
                        v76 /*: any*/ ,
                        v77 /*: any*/ ,
                        v78 /*: any*/ ,
                        v39 /*: any*/ ,
                        v79 /*: any*/ ,
                        v81 /*: any*/ ,
                        v82 /*: any*/ ,
                        v83 /*: any*/ ,
                        v85 /*: any*/ ,
                        v86 /*: any*/ 
                    ]
                }
            ]
        },
        v85 /*: any*/ ,
        v86 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v84 /*: any*/ 
        }
    ], v88 = [
        v21 /*: any*/ ,
        v28 /*: any*/ ,
        v47 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v78 /*: any*/ ,
        v39 /*: any*/ ,
        v79 /*: any*/ ,
        v81 /*: any*/ ,
        v82 /*: any*/ ,
        v83 /*: any*/ ,
        v86 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceNavigationQuery",
            "selections": [
                {
                    "condition": "includeSpaceCreationEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "creationEligibilitySpace",
                            "args": v20 /*: any*/ ,
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SpaceCreationEligibility_space"
                                }
                            ]
                        }
                    ]
                },
                v22 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeHomepageTreeVariant",
                            "variableName": "includeHomepageTreeVariant"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePageTree",
                            "variableName": "includePageTree"
                        },
                        {
                            "kind": "Variable",
                            "name": "isSuperAdmin",
                            "variableName": "isSuperAdmin"
                        },
                        {
                            "kind": "Variable",
                            "name": "paginationLimit",
                            "variableName": "paginationLimit"
                        },
                        {
                            "kind": "Variable",
                            "name": "ptStatuses",
                            "variableName": "ptStatuses"
                        },
                        v23 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PageTreeInitialData_query"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "blogFirst",
                            "variableName": "blogFirst"
                        },
                        {
                            "kind": "Variable",
                            "name": "blogOrderBy",
                            "variableName": "blogOrderBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "blogStatuses",
                            "variableName": "blogStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeBlogTree",
                            "variableName": "includeBlogTree"
                        },
                        v23 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BlogTreeInitialData_query"
                },
                {
                    "condition": "includeSpaceCurationCount",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "useFetchSuggestionCount_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "spaceCurationSuggestionCount"
                        }
                    ]
                },
                {
                    "condition": "includePersistentInviteLicense",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "License",
                            "kind": "LinkedField",
                            "name": "license",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PersistentInviteEligibleQuery_license"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SpaceMoreActionsMenuSpaceTools_license"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "SpaceSidebarLinks",
                    "kind": "LinkedField",
                    "name": "spaceSidebarLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SpaceLinks_spaceSidebarLinks"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ShortcutsSection_spaceSidebarLinks"
                        },
                        {
                            "args": v25 /*: any*/ ,
                            "concreteType": "SpaceSidebarLink",
                            "kind": "LinkedField",
                            "name": "main",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v39 /*: any*/ 
                            ],
                            "storageKey": "main(includeHidden:true)"
                        },
                        v40 /*: any*/ 
                    ]
                },
                {
                    "args": v41 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeSharedSpaceDetails",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "SpaceDetail_space"
                                            }
                                        ],
                                        "type": "Space"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "sharedSpaceDetail"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "useIsUserViewingSpaceAsAnon_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PersistentInviteEligibleQuery_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ExternalCollaboratorsSpaceInformationMessage_space"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isLicensed",
                                    "variableName": "isLicensed"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "SpaceHeader_space"
                        },
                        v21 /*: any*/ ,
                        v42 /*: any*/ ,
                        v43 /*: any*/ ,
                        v44 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "SpaceOperationsFragment"
                        },
                        v45 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "useSpaceViewsData_space"
                        },
                        v46 /*: any*/ ,
                        v39 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        v49 /*: any*/ ,
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        v50 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v52 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v53 /*: any*/ ,
                        v55 /*: any*/ ,
                        {
                            "condition": "includeHomepageTreeVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v59 /*: any*/ ,
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "pageTree",
                                    "plural": false,
                                    "selections": v68 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePageTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "currentPage",
                            "args": v69 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v68 /*: any*/ 
                        },
                        {
                            "alias": "rootPageTree",
                            "args": v70 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v71 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeHomepageTreeVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "homepageRootPageTree",
                            "args": v72 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v71 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeBlogTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "blogPosts",
                            "args": v73 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v74 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "BlogTreeRootComponent_content"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceViewsPersistence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "useSpaceViewsOptionsPersistence_userPreferences"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v17 /*: any*/ ,
                v13 /*: any*/ ,
                v8 /*: any*/ ,
                v11 /*: any*/ ,
                v4 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v14 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v12 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceNavigationQuery",
            "selections": [
                v22 /*: any*/ ,
                {
                    "args": v41 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v21 /*: any*/ ,
                        v43 /*: any*/ ,
                        v44 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymouslyAuthorized"
                                },
                                v50 /*: any*/ 
                            ]
                        },
                        v46 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "externalCollaboratorCount"
                        },
                        v42 /*: any*/ ,
                        v39 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        v53 /*: any*/ ,
                        v45 /*: any*/ ,
                        v49 /*: any*/ ,
                        v55 /*: any*/ ,
                        {
                            "condition": "includeHomepageTreeVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v59 /*: any*/ ,
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "pageTree",
                                    "plural": false,
                                    "selections": v87 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "includeSharedSpaceDetails",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "homepage",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v39 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        v51 /*: any*/ ,
                                        v52 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "SpaceSidebarLinks",
                    "kind": "LinkedField",
                    "name": "spaceSidebarLinks",
                    "plural": false,
                    "selections": [
                        {
                            "args": v25 /*: any*/ ,
                            "concreteType": "SpaceSidebarLink",
                            "kind": "LinkedField",
                            "name": "main",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v27 /*: any*/ ,
                                v30 /*: any*/ ,
                                v35 /*: any*/ ,
                                v26 /*: any*/ ,
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                v31 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v36 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v39 /*: any*/ 
                            ],
                            "storageKey": "main(includeHidden:true)"
                        },
                        v40 /*: any*/ 
                    ]
                },
                {
                    "condition": "includeSpaceCreationEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "creationEligibilitySpace",
                            "args": v20 /*: any*/ ,
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v42 /*: any*/ ,
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "SpaceTypeSettings",
                                    "kind": "LinkedField",
                                    "name": "spaceTypeSettings",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "EnabledContentTypes",
                                            "kind": "LinkedField",
                                            "name": "enabledContentTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isLivePagesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isWhiteboardsEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDatabasesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isBlogsEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEmbedsEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSlidesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFoldersEnabled"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v45 /*: any*/ ,
                                v44 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePageTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "currentPage",
                            "args": v69 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v87 /*: any*/ 
                        },
                        {
                            "alias": "rootPageTree",
                            "args": v70 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v88 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeHomepageTreeVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "homepageRootPageTree",
                            "args": v72 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v88 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeBlogTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "blogPosts",
                            "args": v73 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v74 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v78 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published",
                                                        "emoji-title-draft",
                                                        "editor"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v75 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                                        },
                                        {
                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": v80 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastModifiedDate"
                                                },
                                                v54 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceCurationCount",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                v23 /*: any*/ 
                            ],
                            "kind": "ScalarField",
                            "name": "confluence_remoteObjectSuggestionCount"
                        }
                    ]
                },
                {
                    "condition": "includePersistentInviteLicense",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "License",
                            "kind": "LinkedField",
                            "name": "license",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "licenseConsumingUserCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "trialEndDate"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceViewsPersistence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "spaceViewsPersistence"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a07195cae5d2b99a2cf43d6d813de062",
            "id": "46fc5c59951bd2f66d5c1c78755260056ef440699c828ec8cde652f80a2d47a6",
            "metadata": {},
            "name": "SpaceNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceNavigationQuery($cloudId:ID!,$spaceKey:String!,$isLicensed:Boolean!,$includePersistentInviteLicense:Boolean=false,$includeSpaceCurationCount:Boolean=false,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false,$includeBlogTree:Boolean=false,$blogFirst:Int=40,$blogOrderBy:String=\"metadata.createdDate desc\",$blogStatuses:[String]=[\"current\",\"draft\"],$includeSpaceViewsPersistence:Boolean=false,$includeSharedSpaceDetails:Boolean=false,$includeSpaceCreationEligibility:Boolean=false){creationEligibilitySpace:space(cloudId:$cloudId,key:$spaceKey)@include(if:$includeSpaceCreationEligibility){...SpaceCreationEligibility_space,id},user:confluence_atlassianUser(current:true){id,confluence{permissionType}},...PageTreeInitialData_query_4jV106,...BlogTreeInitialData_query_2C9WBt,...useFetchSuggestionCount_query@include(if:$includeSpaceCurationCount),license@include(if:$includePersistentInviteLicense){...PersistentInviteEligibleQuery_license,...SpaceMoreActionsMenuSpaceTools_license},spaceSidebarLinks(spaceKey:$spaceKey){...SpaceLinks_spaceSidebarLinks,...ShortcutsSection_spaceSidebarLinks,main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){...SpaceDetail_space@include(if:$includeSharedSpaceDetails),...useIsUserViewingSpaceAsAnon_space,...PersistentInviteEligibleQuery_space,...ExternalCollaboratorsSpaceInformationMessage_space,...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,...useSpaceViewsData_space,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{...BlogTreeRootComponent_content,id}},userPreferences@include(if:$includeSpaceViewsPersistence){...useSpaceViewsOptionsPersistence_userPreferences}}fragment BlogTreeInitialData_query_2C9WBt on Query{blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}fragment BlogTreeRootComponent_content on Content{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}fragment ContextualCreateContentButton_space on Space{id,operations{operation,targetType}}fragment ExternalCollaboratorsSpaceInformationMessage_space on Space{id,name,externalCollaboratorCount,currentUser{isAdmin}}fragment FooterCreateButtons_space on Space{id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}fragment PageTreeInitialData_query_4jV106 on Query{currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}}fragment PersistentInviteEligibleQuery_license on License{licenseConsumingUserCount,trialEndDate}fragment PersistentInviteEligibleQuery_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment ShortcutsSection_spaceSidebarLinks on SpaceSidebarLinks{quick{id,url,position,title,styleClass}}fragment SpaceCreationEligibility_space on Space{key,...FooterCreateButtons_space,...useSpaceEnabledContentTypes_space,...ContextualCreateContentButton_space}fragment SpaceDetail_space on Space{id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceLinks_spaceSidebarLinks on SpaceSidebarLinks{main(includeHidden:true){id,webItemCompleteKey,position,hidden}}fragment SpaceMoreActionsMenuSpaceTools_license on License{trialEndDate}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}fragment useFetchSuggestionCount_query on Query{confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}fragment useIsUserViewingSpaceAsAnon_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment useSpaceEnabledContentTypes_space on Space{id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}fragment useSpaceViewsData_space on Space{id,homepage{id},operations{operation,targetType}}fragment useSpaceViewsOptionsPersistence_userPreferences on UserPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}"
        }
    };
}();
$819504ce5ddad46c$var$node.hash = "817b4f1db29044b27bbbbdd6f57e0d2f";
var $819504ce5ddad46c$export$2e2bcd8739ae039 = $819504ce5ddad46c$var$node;
module.exports["default"] = $819504ce5ddad46c$export$2e2bcd8739ae039;

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("5tx03"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("5tx03", function(module, exports) {

let $3fc94240cbfcef2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3fc94240cbfcef2f$var$load("aLbuU"),
    $3fc94240cbfcef2f$var$load("hhss7"),
    $3fc94240cbfcef2f$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("euozR", function(module, exports) {

var $7rovI = parcelRequire("7rovI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $8e83317b0c681e7b$export$1cffcb5a5e9a9c48 = ()=>{
    const [t0] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEditAvailable, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    const isEditorOpen = isLiveEditMode || isOnEditRoute || isAccessLinkEditAvailable && isAccessLinkEditing;
    return isEditorOpen;
};
module.exports["useIsEditorOpen"] = $8e83317b0c681e7b$export$1cffcb5a5e9a9c48;

});

parcelRegister("7rovI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $deabcafb397cc045$var$initialState = {
    isAvailable: false,
    isEditMode: false
};
const $deabcafb397cc045$var$setAvailable = (isAvailable)=>({ setState: setState })=>{
        // Leaving the route must also clear edit mode, or a later visit inherits it.
        setState(isAvailable ? {
            isAvailable: isAvailable
        } : {
            isAvailable: false,
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$enterEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: true
        });
    };
const $deabcafb397cc045$var$exitEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$actions = {
    setAvailable: $deabcafb397cc045$var$setAvailable,
    enterEditMode: $deabcafb397cc045$var$enterEditMode,
    exitEditMode: $deabcafb397cc045$var$exitEditMode
};
const $deabcafb397cc045$var$AccessLinkEditModeStore = (0, $8s9DV.createStore)({
    initialState: $deabcafb397cc045$var$initialState,
    actions: $deabcafb397cc045$var$actions,
    name: 'AccessLinkEditModeStore'
});
const $deabcafb397cc045$var$useAccessLinkEditModeStore = (0, $kBr4q.createHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$var$isOnAccessLinkRouteArgs = {
    selector: (routeName)=>{
        return (0, $1NBp8.ACCESS_LINK).name === routeName;
    }
};
/** Actions without a state subscription, so callers that only dispatch do not re-render. */ const $deabcafb397cc045$var$useAccessLinkEditModeStoreActions = (0, $kBr4q.createActionsHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$export$87e25a0d26a92fdb = ()=>{
    const isAvailable = (0, $dPJCf.useRouteName)($deabcafb397cc045$var$isOnAccessLinkRouteArgs);
    const [{ isEditMode: isEditMode }, { enterEditMode: enter, exitEditMode: exit }] = $deabcafb397cc045$var$useAccessLinkEditModeStore();
    return {
        isAvailable: isAvailable,
        isEditMode: isEditMode,
        enterEditMode: enter,
        exitEditMode: exit
    };
};
const $deabcafb397cc045$export$b9623d5da41a49e7 = ({ children: children })=>{
    const { exitEditMode: exitEditMode } = $deabcafb397cc045$var$useAccessLinkEditModeStoreActions();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            exitEditMode();
        };
    }, [
        exitEditMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["useAccessLinkEditMode"] = $deabcafb397cc045$export$87e25a0d26a92fdb;
module.exports["AccessLinkEditModeProvider"] = $deabcafb397cc045$export$b9623d5da41a49e7;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<22eb52565a522d08d6ca261a792fda3a>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "298be37d19bd8e07f912f849fbe70f5a";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("2Zz3q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g4vf3 = parcelRequire("g4vf3");

function $9d9e360fdbb0177e$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $g4vf3.MILLISECONDS_IN_A_DAY));
}
function $9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $9d9e360fdbb0177e$export$954628993bf3188e(trialEndTime - Date.now());
}
function $9d9e360fdbb0177e$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $9d9e360fdbb0177e$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $9d9e360fdbb0177e$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $9d9e360fdbb0177e$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $9d9e360fdbb0177e$export$ee6c4faab08346c;

});

parcelRegister("g4vf3", function(module, exports) {
const $d163a47e1480b111$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $d163a47e1480b111$export$98a7370239de6730;

});

parcelRegister("BrMrN", function(module, exports) {
/**
 * @generated SignedSource<<6f8fac148313e50a2a47839f6fce409e>>
 * @relayHash fd1963a9d2faefb7e31ad7e80c7ff686
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725
const $e8059ce1e4b75624$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipLicenseQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipSpaceQuery"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "condition": "skipSpaceQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymouslyAuthorized"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "skipLicenseQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "License",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseConsumingUserCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PersistentInviteEligibleQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PersistentInviteEligibleQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "fd1963a9d2faefb7e31ad7e80c7ff686",
            "id": "8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725",
            "metadata": {},
            "name": "PersistentInviteEligibleQuery",
            "operationKind": "query",
            "text": "query PersistentInviteEligibleQuery($spaceKey:String,$skipLicenseQuery:Boolean!,$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id,currentUser{isAnonymouslyAuthorized}},license@skip(if:$skipLicenseQuery){licenseConsumingUserCount,trialEndDate}}"
        }
    };
}();
$e8059ce1e4b75624$var$node.hash = "364b36bbc5d65271345dded2654a0688";
var $e8059ce1e4b75624$export$2e2bcd8739ae039 = $e8059ce1e4b75624$var$node;
module.exports["default"] = $e8059ce1e4b75624$export$2e2bcd8739ae039;

});

parcelRegister("6ZrZD", function(module, exports) {

let $516e276a52fd828c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $516e276a52fd828c$var$load("fSc0b").then(()=>parcelRequire('vavBY'));

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 1000 * 60 * 60 * 24 * 7);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("4tOXV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_4c065UFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    base: "_0bjKvDKxmn _4c065UFQfX _2Y7lL42ADO _3iDTPbvbI6 _2XsHFMFQfX _0adFHsFQfX",
    contentBefore: "_2XsHFM1Y8M _0adFHsPgdg",
    darkBackground: "_0KLXrueZ10",
    lightBackground: "_0KLXrumhAQ"
};
const $05ef07480c610d29$var$i18n = (0, $kSwu1.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $iMnC5.Box);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $w6R6I.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("b0EGa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                hasReceivedHideRequest: true
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $8s9DV.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $kBr4q.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("kSYYC", function(module, exports) {

let $f3482683895baa70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f3482683895baa70$var$load("aWuCm"),
    $f3482683895baa70$var$load("iWnyc"),
    $f3482683895baa70$var$load("1audf"),
    $f3482683895baa70$var$load("bpBPu"),
    $f3482683895baa70$var$load("60m6Z"),
    $f3482683895baa70$var$load("6wr18"),
    $f3482683895baa70$var$load("frPQh"),
    $f3482683895baa70$var$load("8yk9S"),
    $f3482683895baa70$var$load("RHpNJ"),
    $f3482683895baa70$var$load("9Pwou"),
    $f3482683895baa70$var$load("cQZE2"),
    $f3482683895baa70$var$load("bxj2D"),
    $f3482683895baa70$var$load("i66V7"),
    $f3482683895baa70$var$load("k0Z8C"),
    $f3482683895baa70$var$load("7EorR"),
    $f3482683895baa70$var$load("Wowvf"),
    $f3482683895baa70$var$load("hhss7"),
    $f3482683895baa70$var$load("ffEVr"),
    $f3482683895baa70$var$load("9XFtf"),
    $f3482683895baa70$var$load("jYCVY"),
    $f3482683895baa70$var$load("a8R25"),
    $f3482683895baa70$var$load("8OeKT"),
    $f3482683895baa70$var$load("9IEev")
]).then(()=>parcelRequire('7dXG0'));

});

parcelRegister("hrvfP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jb2R2 = parcelRequire("jb2R2");


var $9wGTI = parcelRequire("9wGTI");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7N8s0 = parcelRequire("7N8s0");


var $kKl1I = parcelRequire("kKl1I");

function $7753a4d6370fffc0$export$d19426ed5c8e7319() {
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const isAdmin = (0, $8Lx5S.useIsAdmin)();
    const shouldSkipForPreConditions = !isRovoEnabled || !isAdmin;
    const { onboardingState: onboardingState, loading: isOnboardingStateLoading, error: onboardingStateError } = (0, $kKl1I.useConnectorOnboardingState)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-rollout') || shouldSkipForPreConditions
    });
    if (shouldSkipForPreConditions || isOnboardingStateLoading) return {
        isEnabled: false
    };
    // Unauthorized errors are already marked as handled inside useConnectorOnboardingState.
    // Non-unauthorized errors are left unhandled so they reach error monitoring.
    if (onboardingStateError) return {
        isEnabled: false
    };
    const { enrolmentDate: enrolmentDate, promoDismissed: promoDismissed } = onboardingState ?? {};
    // The sidebar is the only remaining promo surface, so a sidebar dismissal
    // (on its own or as part of 'both') disables the experiment outright.
    if (promoDismissed === 'sidebar' || promoDismissed === 'both') return {
        isEnabled: false
    };
    // Only show to users within the enrolment window
    const isWithinEnrolmentWindow = Boolean(enrolmentDate) && (0, $jb2R2.default)(new Date(), new Date(enrolmentDate)) < (0, $7N8s0.ENROLMENT_WINDOW_DAYS);
    if (!isWithinEnrolmentWindow) return {
        isEnabled: false
    };
    return {
        isEnabled: (0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-rollout')
    };
}



var $jmjWc = parcelRequire("jmjWc");


const $29b721c4c738c525$export$decbed6147e4374b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "67V1_",
    name: "ConnectorPromoSidebarLoader",
    loader: async ()=>(await (parcelRequire("11YyD"))).ConnectorPromoSidebar
});


function $fd2f508bb96e47e2$export$89d5931071c38802({ isNav4: isNav4 } = {}) {
    const { isEnabled: isEnabled } = (0, $7753a4d6370fffc0$export$d19426ed5c8e7319)();
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_CFIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29b721c4c738c525$export$decbed6147e4374b), {
        isNav4: isNav4
    }));
}
module.exports["ConnectorPromoSidebarEntry"] = $fd2f508bb96e47e2$export$89d5931071c38802;

});

parcelRegister("kKl1I", function(module, exports) {

var $gikGR = parcelRequire("gikGR");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iQzVo = parcelRequire("iQzVo");

const $28cbb6f1931650bc$var$EMPTY_ENTRIES = [];
const $28cbb6f1931650bc$var$connectorOnboardingStateQuery = (0, $gikGR.default);
// Optimistic local overrides layered on top of the AGG query result, so dismiss
// and spotlight updates apply immediately without waiting for a refetch.
const $28cbb6f1931650bc$var$LocalOnboardingStateStore = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        updateLocalOnboardingState: ({ key: key, value: value })=>({ setState: setState })=>{
                switch(key){
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE:
                        setState({
                            enrolmentDate: value
                        });
                        break;
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN:
                        setState({
                            spotlightShown: value === 'true'
                        });
                        break;
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED:
                        setState({
                            promoDismissed: value
                        });
                        break;
                }
            }
    },
    name: 'Twcg1489LocalOnboardingStateStore'
});
const $28cbb6f1931650bc$var$useLocalOnboardingState = (0, $kBr4q.createStateHook)($28cbb6f1931650bc$var$LocalOnboardingStateStore);
const $28cbb6f1931650bc$var$useLocalOnboardingStateActions = (0, $kBr4q.createActionsHook)($28cbb6f1931650bc$var$LocalOnboardingStateStore);
function $28cbb6f1931650bc$export$f605414f82afac1e({ skip: skip } = {}) {
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($28cbb6f1931650bc$var$connectorOnboardingStateQuery, {
        variables: {},
        skip: skip || !isLicensed,
        interopApolloAggClient: true,
        fetchPolicy: 'cache-first',
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    const entries = data?.userPreferences?.onboardingState ?? $28cbb6f1931650bc$var$EMPTY_ENTRIES;
    const localOnboardingStateSnapshot = $28cbb6f1931650bc$var$useLocalOnboardingState();
    const { updateLocalOnboardingState: updateOnboardingState } = $28cbb6f1931650bc$var$useLocalOnboardingStateActions();
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            onboardingState: undefined,
            loading: false,
            error: error,
            updateOnboardingState: updateOnboardingState
        };
    }
    if (loading) return {
        onboardingState: undefined,
        loading: true,
        updateOnboardingState: updateOnboardingState
    };
    const findValue = (key)=>entries.find((e)=>e.key === key)?.value ?? undefined;
    const queryOnboardingState = {
        enrolmentDate: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE),
        spotlightShown: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN) === 'true',
        promoDismissed: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED)
    };
    return {
        onboardingState: {
            ...queryOnboardingState,
            ...localOnboardingStateSnapshot
        },
        loading: false,
        updateOnboardingState: updateOnboardingState
    };
}
module.exports["useConnectorOnboardingState"] = $28cbb6f1931650bc$export$f605414f82afac1e;

});

parcelRegister("iQzVo", function(module, exports) {
const $ac3059bce5b9a0ea$export$7bed14e1f2921c0a = {
    ENROLMENT_DATE: 'twcg-1489:enrolmentDate',
    SPOTLIGHT_SHOWN: 'twcg-1489:spotlightShown',
    PROMO_DISMISSED: 'twcg-1489:promoDismissed'
};
const $ac3059bce5b9a0ea$export$461c2b41206d7875 = Object.values($ac3059bce5b9a0ea$export$7bed14e1f2921c0a);
module.exports["TWCG_1489_CONNECTOR_ONBOARDING"] = $ac3059bce5b9a0ea$export$7bed14e1f2921c0a;
module.exports["Twcg1489ConnectorOnboardingKeys"] = $ac3059bce5b9a0ea$export$461c2b41206d7875;

});

parcelRegister("11YyD", function(module, exports) {

let $0c04dbe754a791cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c04dbe754a791cf$var$load("5oWNT").then(()=>parcelRequire('iXTnk'));

});

parcelRegister("eGUIL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $cozmU.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("lpfM9", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("lLwem"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("lLwem", function(module, exports) {

let $fd86fd17ca5bba9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd86fd17ca5bba9b$var$load("46Rej"),
    $fd86fd17ca5bba9b$var$load("lNndt"),
    $fd86fd17ca5bba9b$var$load("2hPbk"),
    $fd86fd17ca5bba9b$var$load("icYyL"),
    $fd86fd17ca5bba9b$var$load("1audf"),
    $fd86fd17ca5bba9b$var$load("bpBPu"),
    $fd86fd17ca5bba9b$var$load("abBST"),
    $fd86fd17ca5bba9b$var$load("6wr18"),
    $fd86fd17ca5bba9b$var$load("ezYRV"),
    $fd86fd17ca5bba9b$var$load("hhu66"),
    $fd86fd17ca5bba9b$var$load("fo4nX"),
    $fd86fd17ca5bba9b$var$load("8KP5u"),
    $fd86fd17ca5bba9b$var$load("Wowvf"),
    $fd86fd17ca5bba9b$var$load("fKQ9j"),
    $fd86fd17ca5bba9b$var$load("7EorR"),
    $fd86fd17ca5bba9b$var$load("iNbHV"),
    $fd86fd17ca5bba9b$var$load("bT16J"),
    $fd86fd17ca5bba9b$var$load("cGkFm"),
    $fd86fd17ca5bba9b$var$load("aqMLH"),
    $fd86fd17ca5bba9b$var$load("ctdyb"),
    $fd86fd17ca5bba9b$var$load("ffEVr"),
    $fd86fd17ca5bba9b$var$load("9XFtf"),
    $fd86fd17ca5bba9b$var$load("jYCVY"),
    $fd86fd17ca5bba9b$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("ek5IE", function(module, exports) {
/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $a0aabcb40e04178c$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $a0aabcb40e04178c$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $a0aabcb40e04178c$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $a0aabcb40e04178c$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $a0aabcb40e04178c$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $a0aabcb40e04178c$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';
module.exports["LEFT_PANEL_WIDTH"] = $a0aabcb40e04178c$export$f963aecf2d4465bd;
module.exports["RIGHT_PANEL_WIDTH"] = $a0aabcb40e04178c$export$750459958906793;
module.exports["LEFT_SIDEBAR_WIDTH"] = $a0aabcb40e04178c$export$f897e1ed9f8ed251;
module.exports["RIGHT_SIDEBAR_WIDTH"] = $a0aabcb40e04178c$export$b44ab66843c05a69;
module.exports["TOP_NAVIGATION_HEIGHT"] = $a0aabcb40e04178c$export$aeff86a16f13529;
module.exports["BANNER_HEIGHT"] = $a0aabcb40e04178c$export$ed7cc0d417ee89e;

});

parcelRegister("j5cB3", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $IQ4Dz = parcelRequire("IQ4Dz");


const $43c705326a57355f$export$c720381daa58fcbb = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const adsTheme = (0, $IQ4Dz.useThemeObserver)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("b2F0e", function(module, exports) {

let $809fafebc28e9d4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $809fafebc28e9d4c$var$load("kNFat").then(()=>parcelRequire('iETFY'));

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("cLgYq", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");

const $80f6c4cf061c88c5$export$909966f260e2b2b = (articleId, setArticleId, routeName, setRouteName, routeGroup, setRouteGroup)=>({
        getArticleId: ()=>articleId,
        setArticleId: setArticleId,
        getRouteName: ()=>routeName,
        setRouteName: setRouteName,
        getRouteGroup: ()=>routeGroup,
        setRouteGroup: setRouteGroup
    });
const $80f6c4cf061c88c5$var$initialInProductHelpState = {
    articleId: '',
    routeName: '',
    routeGroup: ''
};
const $80f6c4cf061c88c5$var$inProductHelpActions = {
    setArticleId: (articleId)=>({ setState: setState })=>{
            setState({
                articleId: articleId
            });
        },
    setRouteName: (routeName)=>({ setState: setState })=>{
            setState({
                routeName: routeName
            });
        },
    setRouteGroup: (routeGroup)=>({ setState: setState })=>{
            setState({
                routeGroup: routeGroup
            });
        }
};
const $80f6c4cf061c88c5$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$80f6c4cf061c88c5$var$initialInProductHelpState
    },
    actions: $80f6c4cf061c88c5$var$inProductHelpActions,
    name: 'inProductHelpContext'
});
const $80f6c4cf061c88c5$export$d9f3a3de6974e16a = (0, $kBr4q.createActionsHook)($80f6c4cf061c88c5$var$Store);
const $80f6c4cf061c88c5$export$b1fca540f7ef5476 = (0, $kBr4q.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.articleId
});
const $80f6c4cf061c88c5$export$15e1d4730ce65e9d = (0, $kBr4q.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeName
});
const $80f6c4cf061c88c5$export$1dfb78b8caec7720 = (0, $kBr4q.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeGroup
});
const $80f6c4cf061c88c5$export$a611b87b3ebe1475 = (0, $j8on0.createContainer)($80f6c4cf061c88c5$var$Store, {
    onInit: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        },
    onUpdate: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        }
});
const $80f6c4cf061c88c5$export$a61d77bd8effd79e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($80f6c4cf061c88c5$export$a611b87b3ebe1475, null, children);
};
module.exports["useInProductHelpActions"] = $80f6c4cf061c88c5$export$d9f3a3de6974e16a;
module.exports["useInProductHelpArticleId"] = $80f6c4cf061c88c5$export$b1fca540f7ef5476;
module.exports["InProductHelpProvider"] = $80f6c4cf061c88c5$export$a61d77bd8effd79e;

});

parcelRegister("jxXkP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $hPTbh = parcelRequire("hPTbh");


var $4uowN = parcelRequire("4uowN");

const $5d19246504a43db4$export$8076fd3f013c4bb9 = (origin)=>{
    const $ = (0, $bDgLe.c)(34);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== origin) {
        t0 = (data)=>{
            createAnalyticsEvent((0, $4uowN.buildSnippetUIEvent)(data, origin)).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = origin;
        $[2] = t0;
    } else t0 = $[2];
    const fireUIAnalytic = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== origin) {
        t1 = (data_0)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_OPERATIONAL_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).OPERATIONAL,
                    ...data_0,
                    attributes: (0, $4uowN.mergeOriginIntoAttributes)(origin, data_0.attributes)
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = origin;
        $[5] = t1;
    } else t1 = $[5];
    const fireOperationalAnalytic = t1;
    let t2;
    if ($[6] !== createAnalyticsEvent || $[7] !== origin) {
        t2 = (data_1)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_TRACK_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    ...data_1,
                    attributes: (0, $4uowN.mergeOriginIntoAttributes)(origin, data_1.attributes)
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = origin;
        $[8] = t2;
    } else t2 = $[8];
    const fireTrackAnalytic = t2;
    let t3;
    if ($[9] !== fireUIAnalytic) {
        t3 = (actionSubjectId, attributes)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        };
        $[9] = fireUIAnalytic;
        $[10] = t3;
    } else t3 = $[10];
    const fireButtonClickedAnalytic = t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== origin) {
        t4 = (attributes_0)=>{
            createAnalyticsEvent((0, $4uowN.buildSnippetUIEvent)({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).VIEWED,
                actionSubjectId: (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPETS,
                attributes: attributes_0
            }, origin)).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = origin;
        $[13] = t4;
    } else t4 = $[13];
    const fireScreenViewedAnalytic = t4;
    let t5;
    if ($[14] !== fireUIAnalytic) {
        t5 = (actionSubjectId_0, attributes_1)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).MODAL,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLOSED,
                actionSubjectId: actionSubjectId_0,
                attributes: attributes_1
            });
        };
        $[14] = fireUIAnalytic;
        $[15] = t5;
    } else t5 = $[15];
    const fireModalClosedAnalytic = t5;
    let t6;
    if ($[16] !== fireUIAnalytic) {
        t6 = (actionSubjectId_1, attributes_2)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).TEXT_FIELD,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).TYPED,
                actionSubjectId: actionSubjectId_1,
                attributes: attributes_2
            });
        };
        $[16] = fireUIAnalytic;
        $[17] = t6;
    } else t6 = $[17];
    const fireTextFieldTypedAnalytic = t6;
    let t7;
    if ($[18] !== fireUIAnalytic) {
        t7 = (actionSubjectId_2, attributes_3)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).DROPDOWN_ITEM,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId_2,
                attributes: attributes_3
            });
        };
        $[18] = fireUIAnalytic;
        $[19] = t7;
    } else t7 = $[19];
    const fireDropdownItemClickedAnalytic = t7;
    let t8;
    if ($[20] !== fireOperationalAnalytic) {
        t8 = (actionSubject, attributes_4)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FAILED,
                attributes: attributes_4
            });
        };
        $[20] = fireOperationalAnalytic;
        $[21] = t8;
    } else t8 = $[21];
    const fireFailedAnalytic = t8;
    let t9;
    if ($[22] !== fireOperationalAnalytic) {
        t9 = (actionSubject_0, attributes_5)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject_0,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).SUCCEEDED,
                attributes: attributes_5
            });
        };
        $[22] = fireOperationalAnalytic;
        $[23] = t9;
    } else t9 = $[23];
    const fireSuccessAnalytic = t9;
    let t10;
    if ($[24] !== fireButtonClickedAnalytic || $[25] !== fireDropdownItemClickedAnalytic || $[26] !== fireFailedAnalytic || $[27] !== fireModalClosedAnalytic || $[28] !== fireOperationalAnalytic || $[29] !== fireScreenViewedAnalytic || $[30] !== fireSuccessAnalytic || $[31] !== fireTextFieldTypedAnalytic || $[32] !== fireTrackAnalytic) {
        t10 = {
            fireOperationalAnalytic: fireOperationalAnalytic,
            fireTrackAnalytic: fireTrackAnalytic,
            fireButtonClickedAnalytic: fireButtonClickedAnalytic,
            fireScreenViewedAnalytic: fireScreenViewedAnalytic,
            fireModalClosedAnalytic: fireModalClosedAnalytic,
            fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic,
            fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic,
            fireFailedAnalytic: fireFailedAnalytic,
            fireSuccessAnalytic: fireSuccessAnalytic
        };
        $[24] = fireButtonClickedAnalytic;
        $[25] = fireDropdownItemClickedAnalytic;
        $[26] = fireFailedAnalytic;
        $[27] = fireModalClosedAnalytic;
        $[28] = fireOperationalAnalytic;
        $[29] = fireScreenViewedAnalytic;
        $[30] = fireSuccessAnalytic;
        $[31] = fireTextFieldTypedAnalytic;
        $[32] = fireTrackAnalytic;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};
module.exports["useSnippetAnalytics"] = $5d19246504a43db4$export$8076fd3f013c4bb9;

});

parcelRegister("cYuYM", function(module, exports) {

var $5vi32 = parcelRequire("5vi32");


var $9bL1w = parcelRequire("9bL1w");

const $955ee3c4efc889bc$export$349f17fbd3b37cd1 = ()=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
module.exports["useIsSnippetCreateEnabled"] = $955ee3c4efc889bc$export$349f17fbd3b37cd1;

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo');
    const showShare = allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("36Uax", function(module, exports) {

var $kTPbu = parcelRequire("kTPbu");


var $bVevd = parcelRequire("bVevd");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("4PNpW", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

const $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40 = (0, $36Uax.ALLOWED_FEATURES).view;
const $ff056bb0ad02bd7c$export$2c7469b01e61fde2 = (0, $36Uax.ALLOWED_FEATURES).edit;
const $ff056bb0ad02bd7c$export$72afc086e90eb0bf = (0, $36Uax.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $ff056bb0ad02bd7c$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1eD4P = parcelRequire("1eD4P");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $cozmU.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $cozmU.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");

 //# sourceMappingURL=index.js.map

});

parcelRegister("blsdD", function(module, exports) {
const $91a4a128f3ac2264$var$observations = new Map();
let $91a4a128f3ac2264$var$observer;
function $91a4a128f3ac2264$export$4d315c8c80147824(element, listener) {
    if (typeof window === 'undefined' || !window.ResizeObserver) return;
    $91a4a128f3ac2264$var$observer ?? ($91a4a128f3ac2264$var$observer = new ResizeObserver((entries)=>{
        for (const { target: target, contentRect: { height: height, width: width } } of entries){
            const observation = $91a4a128f3ac2264$var$observations.get(target);
            if (!observation || !Number.isFinite(height) || !Number.isFinite(width) || height < 0 || width < 0) continue;
            const dimensions = {
                height: Math.round(height),
                width: Math.round(width)
            };
            if (observation.dimensions?.height === dimensions.height && observation.dimensions?.width === dimensions.width) continue;
            observation.dimensions = dimensions;
            observation.listeners.forEach((notify)=>notify(dimensions));
        }
    }));
    let observation = $91a4a128f3ac2264$var$observations.get(element);
    if (!observation) {
        observation = {
            listeners: new Set()
        };
        $91a4a128f3ac2264$var$observations.set(element, observation);
        $91a4a128f3ac2264$var$observer.observe(element);
    }
    observation.listeners.add(listener);
    if (observation.dimensions) listener(observation.dimensions);
    return ()=>{
        if (!observation.listeners.delete(listener) || observation.listeners.size) return;
        $91a4a128f3ac2264$var$observer?.unobserve(element);
        $91a4a128f3ac2264$var$observations.delete(element);
        if (!$91a4a128f3ac2264$var$observations.size) {
            $91a4a128f3ac2264$var$observer?.disconnect();
            $91a4a128f3ac2264$var$observer = undefined;
        }
    };
}
module.exports["observeElementDimensions"] = $91a4a128f3ac2264$export$4d315c8c80147824;

});

parcelRegister("7W9kD", function(module, exports) {

var $blsdD = parcelRequire("blsdD");

const $9f0ae7ee0cebc5b7$var$registrations = new Map();
// Bound the addition to the existing UFO payload, even on tenants with many apps.
const $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS = 50;
const $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b = (element, source, extensionId)=>{
    if (!extensionId || !window.ResizeObserver) return;
    $9f0ae7ee0cebc5b7$var$registrations.get(element)?.stop?.();
    const registration = {
        source: source,
        extensionId: extensionId
    };
    $9f0ae7ee0cebc5b7$var$registrations.set(element, registration);
    registration.stop = (0, $blsdD.observeElementDimensions)(element, (dimensions)=>{
        registration.dimensions = dimensions;
    });
    return ()=>{
        if ($9f0ae7ee0cebc5b7$var$registrations.get(element) !== registration) return;
        registration.stop?.();
        $9f0ae7ee0cebc5b7$var$registrations.delete(element);
    };
};
const $9f0ae7ee0cebc5b7$export$e4b460b98000468c = ()=>{
    const groups = new Map();
    for (const [element, { source: source, extensionId: extensionId, dimensions: dimensions }] of $9f0ae7ee0cebc5b7$var$registrations){
        if (!element.isConnected || !dimensions) continue;
        const group = groups.get(source) ?? new Map();
        group.set(extensionId, {
            ...dimensions
        });
        groups.set(source, group);
    }
    let reported = 0;
    let omitted = 0;
    const extensionDimensions = Object.fromEntries(Array.from(groups, ([source, dimensions])=>[
            source,
            Object.fromEntries(Array.from(dimensions).filter(()=>{
                if (reported < $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS) {
                    reported++;
                    return true;
                }
                omitted++;
                return false;
            }))
        ]));
    return {
        extensionDimensions: extensionDimensions,
        ...omitted ? {
            extensionDimensionsOmittedCount: omitted
        } : {}
    };
};
module.exports["observeExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b;
module.exports["getExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$e4b460b98000468c;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("dYU3e", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__, relayQueryPreloadRetention: relayQueryPreloadRetention }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__,
        relayQueryPreloadRetention: relayQueryPreloadRetention
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeAggQuery"] = $48ba6fb41a85dc7e$export$5e270d77b1b480de;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("fEmGS", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bFdYQ = parcelRequire("bFdYQ");


var $bqzdu = parcelRequire("bqzdu");


var $aSAi6 = parcelRequire("aSAi6");


var $9xOXQ = parcelRequire("9xOXQ");


var $7M67g = parcelRequire("7M67g");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Relay builds field storage keys from the operation's *resolved* variables, so a query declaring
    // `$first: Int = 20` normalizes under `field(...,first:20)` even when the caller omits `first`.
    // Resolving the artifact's declared defaults here keeps every Relay write below on the same
    // records Relay normalized and the UI subscribes to; using the raw variables would silently
    // write to a sibling record nobody reads. See getRelayOperationVariablesWithDefaults.
    const variables = (0, $7M67g.getRelayOperationVariablesWithDefaults)(params.query, params.variables);
    // Inside a Relay-native optimistic layer (commitMutation optimisticUpdater/updater), route the
    // write onto the provided store proxy so it participates in Relay's disposable layer instead of
    // committing permanently. This upserts records (incl. connection list changes) via the store
    // proxy — the capability the in-place path lacks — so no snapshot/replay rollback is needed;
    // Relay reverts the whole layer atomically. The cache bridge is intentionally skipped here.
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (ambientStore && source === 'relay' && params.data) {
        const queryNode = params.query;
        const selections = queryNode?.operation?.selections;
        if (selections) {
            (0, $9xOXQ.writeQueryPayloadToStore)(ambientStore, // Normalization selections are a superset of the reader selections the primitive walks
            // (scalar/linked/inline-fragment/condition); matches the cast in writeQueryInteropRelay.
            selections, params.data, variables);
            return;
        }
    }
    const didWrite = source === 'relay' ? $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) : $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
    if (didWrite) (0, $bFdYQ.syncQueryCacheBridge)({
        source: // The bridge mirrors into the *other* cache, which applies its own document defaults, so it
        // keeps receiving the caller's variables rather than the Relay-resolved ones.
        source,
        query: params.query,
        variables: params.variables,
        data: params.data
    });
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data } = params;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for writeQueryInterop; ${params.__callerPackage__}.`);
    if (!data) return false;
    let didWrite = false;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) didWrite = (0, $aSAi6.writeQueryFields)(root, queryFields, data, variables);
    });
    if (!didWrite) {
        // If no existing Relay records were updated, fall back to Relay's normal payload
        // write path. Invalid Relay artifacts should still throw here, preserving the
        // original writeQueryInterop failure behavior.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables);
        relayEnv.commitPayload(operation, data);
        didWrite = true;
    }
    return didWrite;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
    return true;
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("aSAi6", function(module, exports) {

var $2ItkX = parcelRequire("2ItkX");

function $52093bfafa102098$export$77bf2d076cc42a0e(record, fields, data, variables) {
    if (!record || !$52093bfafa102098$var$isObjectRecord(data)) return false;
    // Relay commitUpdate is not transactional. Preflight the selection tree before
    // writing so list rewrites that require Relay normalization fall through to
    // commitPayload instead of committing partial in-place updates.
    if (!$52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables)) return false;
    return $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables);
}
function $52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables) {
    for (const field of fields){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude && !$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'InlineFragment') {
            if (!$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) return false;
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords || fieldData.length !== existingRecords.length) return false;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    if (item == null) continue;
                    if (!$52093bfafa102098$var$isObjectRecord(item)) return false;
                    const existingRecord = existingRecords[index];
                    if (!existingRecord || $52093bfafa102098$var$hasDifferentRecordId(existingRecord, item)) return false;
                    if (!$52093bfafa102098$var$canWriteQueryFields(existingRecord, linkedField.selections, item, variables)) return false;
                }
                continue;
            }
            if (!$52093bfafa102098$var$isObjectRecord(fieldData)) return false;
            const linkedRecord = record.getLinkedRecord(fieldKey);
            if (!linkedRecord || $52093bfafa102098$var$hasDifferentRecordId(linkedRecord, fieldData)) return false;
            if (!$52093bfafa102098$var$canWriteQueryFields(linkedRecord, linkedField.selections, fieldData, variables)) return false;
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && !$52093bfafa102098$var$isRelaySetValue(scalarValue)) return false;
            continue;
        }
    }
    return true;
}
function $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables) {
    let didWrite = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Honour @include/@skip so conditional fields (e.g. userPreferences) get written.
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        } else if (field.kind === 'InlineFragment') didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                // Read plural fields with getLinkedRecords; the singular getter throws on
                // plural data. Missing/changed list records are handled by the commitPayload
                // fallback so this in-place path only updates known records.
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords) continue;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    const existingRecord = existingRecords[index];
                    if (existingRecord && $52093bfafa102098$var$isObjectRecord(item)) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(existingRecord, linkedField.selections, item, variables) || didWrite;
                }
            } else if ($52093bfafa102098$var$isObjectRecord(fieldData)) {
                const linkedRecord = record.getLinkedRecord(fieldKey);
                if (linkedRecord) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(linkedRecord, linkedField.selections, fieldData, variables) || didWrite;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && $52093bfafa102098$var$isRelaySetValue(scalarValue)) {
                record.setValue(scalarValue, (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
                didWrite = true;
            }
        }
    }
    return didWrite;
}
function $52093bfafa102098$var$getRecordIdFromData(data) {
    const id = data.id;
    return typeof id === 'string' || typeof id === 'number' ? String(id) : null;
}
function $52093bfafa102098$var$hasDifferentRecordId(record, data) {
    const id = $52093bfafa102098$var$getRecordIdFromData(data);
    return Boolean(id && record.getDataID() !== id);
}
function $52093bfafa102098$var$isObjectRecord(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
function $52093bfafa102098$var$isRelaySetValue(value) {
    if (Array.isArray(value)) // Relay scalar arrays can contain nulls, but undefined elements are not valid setValue payloads.
    return value.every((item)=>item !== undefined && $52093bfafa102098$var$isRelaySetValue(item));
    return value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
} /* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ 
module.exports["writeQueryFields"] = $52093bfafa102098$export$77bf2d076cc42a0e;

});

parcelRegister("9xOXQ", function(module, exports) {
/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity -- bounded recursive walk of a Relay operation's reader selections, matching the sibling relayQueryWriteOperations/fragmentCacheOperations modules */ 
var $2ItkX = parcelRequire("2ItkX");

// Writes a query/mutation-response-shaped payload into a Relay store via a RecordSourceProxy,
// UPSERTING records (creating missing ones) as it goes. This is the capability the optimistic
// interop needs that `writeQueryInterop`'s in-place path lacks: it can append/remove nodes in a
// connection (a list-length change) inside a Relay optimistic layer, where `commitPayload` cannot
// run. Records with an `id` field are normalised under that id; id-less embedded records (e.g. a
// union `location`) use Relay's client ids via getOrCreateLinkedRecord.
//
// The traversal is driven by the operation's reader selections so field storage keys, aliases,
// @include/@skip, plural fields, and concrete-type inline-fragment narrowing all match how Relay
// itself reads the data back.
const $25b015eeee02787d$var$TYPENAME_KEY = '__typename';
function $25b015eeee02787d$var$isObjectRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
function $25b015eeee02787d$var$inlineFragmentApplies(record, inlineFragment) {
    const abstractKey = inlineFragment.abstractKey;
    if (abstractKey != null) return true;
    // Concrete narrowing: only descend when the payload's __typename matches. When the payload has
    // no __typename we descend so we never drop fields the caller intended to write.
    const typename = record?.[$25b015eeee02787d$var$TYPENAME_KEY];
    return typename == null ? true : typename === inlineFragment.type;
}
// Compute the normalized dataID the way this environment stores id-bearing records: `Type:id`
// (matching the interop's fragmentCacheOperations convention and the store's actual keys, e.g.
// `Comment:123`, `ConfluenceContentModified:456`). Using the raw id here would miss the canonical
// record on store.get and create an orphan duplicate that collides with other writes for the same id.
function $25b015eeee02787d$var$dataIdFromValue(value, typeName) {
    const id = value.id;
    if (typeof id !== 'string' && typeof id !== 'number') return null;
    const idString = String(id);
    return idString.startsWith(`${typeName}:`) ? idString : `${typeName}:${idString}`;
}
function $25b015eeee02787d$var$resolveTypeName(value, linkedField) {
    const typename = value[$25b015eeee02787d$var$TYPENAME_KEY];
    if (typeof typename === 'string') return typename;
    // ReaderLinkedField carries the concrete type for non-abstract fields.
    return linkedField.concreteType ?? 'ClientRecord';
}
// Get or create the singular child record for a linked field. Id-bearing children are normalised
// under their id; id-less embedded children get a stable Relay client id from the parent.
function $25b015eeee02787d$var$getOrCreateSingularChild(store, parent, linkedField, value, fieldKey) {
    const typeName = $25b015eeee02787d$var$resolveTypeName(value, linkedField);
    const id = $25b015eeee02787d$var$dataIdFromValue(value, typeName);
    if (id != null) return store.get(id) ?? store.create(id, typeName);
    return parent.getOrCreateLinkedRecord(fieldKey, typeName);
}
function $25b015eeee02787d$var$getOrCreatePluralChild(store, parent, linkedField, value, fieldKey, index) {
    const typeName = $25b015eeee02787d$var$resolveTypeName(value, linkedField);
    const id = $25b015eeee02787d$var$dataIdFromValue(value, typeName);
    if (id != null) return store.get(id) ?? store.create(id, typeName);
    // Stable client id per index for id-less plural items so re-writes reuse the same record.
    const clientId = `${parent.getDataID()}:${fieldKey}:${index}`;
    return store.get(clientId) ?? store.create(clientId, typeName);
}
function $25b015eeee02787d$var$writeSelections(store, record, selections, data, variables) {
    for (const field of selections){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) $25b015eeee02787d$var$writeSelections(store, record, field.selections, data, variables);
            continue;
        }
        if (field.kind === 'InlineFragment') {
            const inlineFragment = field;
            if ($25b015eeee02787d$var$inlineFragmentApplies(data, inlineFragment)) $25b015eeee02787d$var$writeSelections(store, record, inlineFragment.selections, data, variables);
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            record.setValue(data[responseKey], (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (fieldData == null) {
                record.setValue(null, fieldKey);
                continue;
            }
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                const children = fieldData.map((item, index)=>{
                    if (item == null) return null;
                    if (!$25b015eeee02787d$var$isObjectRecord(item)) return null;
                    const pluralChild = $25b015eeee02787d$var$getOrCreatePluralChild(store, record, linkedField, item, fieldKey, index);
                    $25b015eeee02787d$var$writeSelections(store, pluralChild, linkedField.selections, item, variables);
                    return pluralChild;
                });
                record.setLinkedRecords(children, fieldKey);
                continue;
            }
            if (!$25b015eeee02787d$var$isObjectRecord(fieldData)) continue;
            const child = $25b015eeee02787d$var$getOrCreateSingularChild(store, record, linkedField, fieldData, fieldKey);
            $25b015eeee02787d$var$writeSelections(store, child, linkedField.selections, fieldData, variables);
            record.setLinkedRecord(child, fieldKey);
        }
    }
}
function $25b015eeee02787d$export$26fe3b45bb24fd81(store, selections, data, variables = {}) {
    $25b015eeee02787d$var$writeSelections(store, store.getRoot(), selections, data, variables);
}
module.exports["writeQueryPayloadToStore"] = $25b015eeee02787d$export$26fe3b45bb24fd81;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("lyWac", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $3mugH = parcelRequire("3mugH");

// Mirrors GraphqlErrorProcessor's mark. Read through the global symbol registry rather than
// importing `isErrorMarkedAsHandled`, because ~20 test files mock
// `@confluence/graphql-error-processor` partially and a new import here would break all of them.
// The registry is the same mechanism GraphqlErrorProcessor relies on to share the mark across the
// preloader and main-app bundles, and `ignores errors already marked as handled` in this module's
// tests exercises the real `markErrorAsHandled`, so the key cannot drift unnoticed.
const $6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
function $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) {
    return typeof error === 'object' && error !== null && Boolean(error[$6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL]);
}
const $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
/**
 * A page the viewer is not allowed to see is a normal SSR outcome, not a defect — the render falls
 * back to the restricted-content screen. `query()` marks these as handled when a preloader resolves
 * with its query result, but a task that *rejects* with a permission error (or resolves with the
 * error itself) never passes through that path, so the handled mark alone does not keep restricted
 * pages out of the SSR prepare errors.
 *
 * Covers both status codes of the permission contract — 401 (unauthenticated) and 403 (not
 * permitted) — plus the legacy `extensions.data.authorized === false` shape, matching
 * `@confluence/unauthorized-error-boundary`. `isStatusCodeError` walks `graphQLErrors`,
 * `networkError` and `originalError`, so a rejected ApolloError wrapping a 403 is recognised too.
 * `@confluence/error-types` is used rather than the boundary's copy of this predicate to keep React
 * out of the preloader bundle.
 *
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ function $6e8f7926b945fe5e$var$isPermissionError(error) {
    const candidate = error;
    return (0, $aMcHK.isStatusCodeError)(candidate, '403', $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError) || (0, $aMcHK.isStatusCodeError)(candidate, '401');
}
/**
 * Errors that are an expected outcome of preloading and must not be reported as SSR prepare errors.
 */ function $6e8f7926b945fe5e$var$isExpectedPreloadError(error) {
    return $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) || $6e8f7926b945fe5e$var$isPermissionError(error);
}
function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
/**
 * `query()` and `queryAgg()` resolve to `{ data, errors, hasErrors }` rather than rejecting or
 * resolving to an `Error`, so a preloader that returns its result object straight into the task
 * list would otherwise slip past the `instanceof Error` checks below.
 */ function $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) {
    return typeof value === 'object' && value !== null && value.hasErrors === true && Array.isArray(value.errors);
}
/**
 * Only surfaces errors nobody has claimed. `query()` marks the expected ones (unauthorized,
 * not-found, and other known shapes) as handled before resolving, and those still come back with
 * `hasErrors: true` — reporting them here would turn every restricted or missing page into a bogus
 * SSR prepare error, since preloaders like `preloadPageStatusQuery` return their result object
 * straight into the task list.
 *
 * Filtering happens here, before the conversion below, because `new Error(message)` drops
 * `extensions` — the only place the permission status code lives on a plain GraphQL error object.
 */ function $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(result) {
    const unhandledErrors = [];
    for (const error of result.errors ?? []){
        if ($6e8f7926b945fe5e$var$isExpectedPreloadError(error)) continue;
        unhandledErrors.push(error instanceof Error ? error : new Error(String(error?.message ?? error)));
    }
    return unhandledErrors;
}
function $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(fulfilledValue) {
    if (fulfilledValue instanceof Error) return $6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue);
    if (Array.isArray(fulfilledValue)) return fulfilledValue.flatMap((value)=>value instanceof Error || $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) ? $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(value) : []);
    if ($6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(fulfilledValue)) return $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(fulfilledValue);
    return [];
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') errors.push(...$6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(result.value));
        }
        // Drop the expected outcomes — already-handled and permission errors — so a restricted page
        // does not report a prepare error. Rejections and error values are filtered here rather than
        // at each collection site so that every path is held to the same rule; query results are
        // filtered earlier, while their `extensions` are still intact.
        const reportableErrors = errors.filter((error)=>!$6e8f7926b945fe5e$var$isExpectedPreloadError(error));
        if (reportableErrors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of reportableErrors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return reportableErrors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
    hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575);
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("kyH1y", function(module, exports) {

var $jevsd = parcelRequire("jevsd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/workspace/manifest.ts
var $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jevsd.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $jevsd.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ef785b50c9b3efca$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ef785b50c9b3efca$export$d47d8a7e69df1865;

});

parcelRegister("jevsd", function(module, exports) {
// src/confluence/workspace/types.ts
var $e007b94796479ac0$export$19f1a63686ec0369 = "confluence", $e007b94796479ac0$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $e007b94796479ac0$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $e007b94796479ac0$export$f1c423a93fbc71;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");


var $eSLr0 = parcelRequire("eSLr0");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
const $2272f3d6a41ef128$var$isSystemBatchLocation = (location)=>location.length === 2 && location.includes((0, $eSLr0.SYSTEM_HEADER_LEFT)) && location.includes((0, $eSLr0.SYSTEM_USER));
const $2272f3d6a41ef128$var$filterSectionsByLocations = (webItemSections, locations)=>webItemSections.filter((section)=>locations.some((location)=>section?.id?.startsWith(`${location}/`)));
const $2272f3d6a41ef128$var$writeWebItemLocationCache = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iEfsZ.default),
        variables: {
            location: null,
            locations: locations,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        data: {
            webItemSections: webItemSections
        },
        __callerPackage__: "web-item-location"
    });
};
const $2272f3d6a41ef128$var$writeWebItemLocationEntries = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    locations.forEach((location)=>{
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: location,
                locations: [],
                contentId: contentId,
                spaceKey: spaceKey,
                version: version
            },
            data: {
                webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(webItemSections, [
                    location
                ])
            },
            __callerPackage__: "web-item-location"
        });
    });
};
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, context: context } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        context: context,
        __callerPackage__: "web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        context: context,
        __callerPackage__: "web-item-location"
    });
    if (Array.isArray(location)) {
        const shouldWriteSystemBatchEntries = (0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true) && $2272f3d6a41ef128$var$isSystemBatchLocation(location);
        if (shouldWriteSystemBatchEntries) result.then(({ data: data })=>{
            if (!data?.webItemSections) return;
            $2272f3d6a41ef128$var$writeWebItemLocationCache({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            $2272f3d6a41ef128$var$writeWebItemLocationEntries({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("3Ww6H", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $50aee1cd0289a711$export$b4958caff08a0960 = (...args)=>{
    (0, $jmjuG.ufologger).log(...args);
};
module.exports["ufolog"] = $50aee1cd0289a711$export$b4958caff08a0960;

});

parcelRegister("jmjuG", function(module, exports) {
class $fdaa18971c6567c6$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$fdaa18971c6567c6$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $fdaa18971c6567c6$export$4ab84f6f04f6566d = new $fdaa18971c6567c6$var$UFOLogger();
module.exports["ufologger"] = $fdaa18971c6567c6$export$4ab84f6f04f6566d;

});

parcelRegister("cNAch", function(module, exports) {

var $YHNTN = parcelRequire("YHNTN");

class $c65b2e96b7a8c980$export$c00d22927c60484a extends (0, $YHNTN.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $c65b2e96b7a8c980$export$c00d22927c60484a;

});

parcelRegister("YHNTN", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $dd3JJ = parcelRequire("dd3JJ");


var $gDr1n = parcelRequire("gDr1n");


var $11QNa = parcelRequire("11QNa");


var $i3Cqs = parcelRequire("i3Cqs");


var $8D8OR = parcelRequire("8D8OR");


var $3Ww6H = parcelRequire("3Ww6H");


var $bdTYA = parcelRequire("bdTYA");


var $aNeq3 = parcelRequire("aNeq3");


var $f07wD = parcelRequire("f07wD");


var $e22Cc = parcelRequire("e22Cc");


var $j7Sza = parcelRequire("j7Sza");


var $g8bWJ = parcelRequire("g8bWJ");


var $4MiWC = parcelRequire("4MiWC");


var $DJFHw = parcelRequire("DJFHw");

const $35f46dabe2d905ec$var$getPageVisibleState = ()=>{
    return !(0, $e22Cc.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f07wD.PageVisibleState).VISIBLE : (0, $f07wD.PageVisibleState).HIDDEN;
};
class $35f46dabe2d905ec$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $3Ww6H.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g8bWJ.canTransition)(this.state, newState)) {
            (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $j7Sza.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $03RpJ.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $11QNa.getGlobalEventStream)().push((0, $8D8OR.unsubscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3Ww6H.ufolog)('this.parent', this.parent);
                (0, $11QNa.getGlobalEventStream)().push((0, $gDr1n.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bdTYA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $j7Sza.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
            (0, $aNeq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3Ww6H.ufolog)('subscribed', this.id);
                (0, $11QNa.getGlobalEventStream)().push((0, $i3Cqs.subscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f07wD.FMP_MARK) && name !== (0, $f07wD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bdTYA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $DJFHw.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $j7Sza.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f07wD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f07wD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bdTYA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3Ww6H.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $dd3JJ.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $j7Sza.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f07wD.PageVisibleState).MIXED;
            (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["UFOAbstractExperience"] = $35f46dabe2d905ec$export$d31c89db257648c;

});

parcelRegister("dd3JJ", function(module, exports) {
// temp solution until we can get it automated
const $79d018f255564301$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $79d018f255564301$export$2295b861f318254a;

});

parcelRegister("gDr1n", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $7cdf9804f4fb0f15$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["experiencePayloadEvent"] = $7cdf9804f4fb0f15$export$7c957416596ca127;

});

parcelRegister("f07wD", function(module, exports) {
var $ff3bb8d57004c3c7$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $ff3bb8d57004c3c7$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $ff3bb8d57004c3c7$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $ff3bb8d57004c3c7$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $ff3bb8d57004c3c7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $ff3bb8d57004c3c7$export$9f2bf58999404c75 = 'fmp';
const $ff3bb8d57004c3c7$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $ff3bb8d57004c3c7$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $ff3bb8d57004c3c7$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $ff3bb8d57004c3c7$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $ff3bb8d57004c3c7$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $ff3bb8d57004c3c7$export$837e0f79a8056912;

});

parcelRegister("11QNa", function(module, exports) {

var $7Ce5m = parcelRequire("7Ce5m");

const $c1569a93aa4391e4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7Ce5m.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
module.exports["getGlobalEventStream"] = $c1569a93aa4391e4$export$6123a44dc2384540;

});

parcelRegister("7Ce5m", function(module, exports) {
const $0cc5590ab6f8b46e$export$d8b468db8a225bc9 = 250;
module.exports["MAX_EARLY_QUEUE_LENGTH"] = $0cc5590ab6f8b46e$export$d8b468db8a225bc9;

});

parcelRegister("i3Cqs", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $a239602ece96b732$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["subscribeEvent"] = $a239602ece96b732$export$37863216db4b714d;

});

parcelRegister("8D8OR", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["unsubscribeEvent"] = $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e;

});

parcelRegister("bdTYA", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $5c1c0b03503ca679$export$d53d07b6034c4560 = (...args)=>{
    (0, $jmjuG.ufologger).warn(...args);
};
module.exports["ufowarn"] = $5c1c0b03503ca679$export$d53d07b6034c4560;

});

parcelRegister("aNeq3", function(module, exports) {

var $e22Cc = parcelRequire("e22Cc");

class $1043fc05a880bbb3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e22Cc.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1043fc05a880bbb3$export$13e680397ec8f3eb = new $1043fc05a880bbb3$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $1043fc05a880bbb3$export$13e680397ec8f3eb;

});

parcelRegister("e22Cc", function(module, exports) {
const $0f617bf44fb531ac$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $0f617bf44fb531ac$export$15e172712955e18f;

});

parcelRegister("j7Sza", function(module, exports) {
const $f267d4a3139d0594$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $f267d4a3139d0594$export$81b70111112841a0;

});

parcelRegister("g8bWJ", function(module, exports) {

var $j7Sza = parcelRequire("j7Sza");

const $59fdb64e04330d55$var$UFOStateAvailableTransitions = {
    [(0, $j7Sza.UFOExperienceState).NOT_STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).BLOCKED.id]: [
        (0, $j7Sza.UFOExperienceState).RECOVERED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).RECOVERED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).FAILED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).ABORTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ]
};
const $59fdb64e04330d55$export$178881f329fdb81f = (state1, state2)=>{
    return $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id] && $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $59fdb64e04330d55$export$178881f329fdb81f;

});

parcelRegister("4MiWC", function(module, exports) {
var $d8444ff033f3362a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d8444ff033f3362a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $d8444ff033f3362a$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $d8444ff033f3362a$export$cc26007c03242fff;

});

parcelRegister("DJFHw", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2xhEb = parcelRequire("2xhEb");

const $56570a8acedc1b5f$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2xhEb.roundPerfNow)();
};
module.exports["perfNowOrTimestamp"] = $56570a8acedc1b5f$export$c753e8669d30c8ad;

});

parcelRegister("2xhEb", function(module, exports) {
const $a279419ecc31ce6a$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $a279419ecc31ce6a$export$5f490af6b2b115cf;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $gXfti = parcelRequire("gXfti");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    // No preloader counterpart needed: setCrossJoinSuccess is a runtime-only action
    // triggered after a user completes the interactive cross-join flow (navigates to
    // Loom, gets provisioned, and returns). This cannot occur during SSR. The
    // window.__SSR_LOOM_ENTRY_POINT__ write updates the cached signal so that
    // useLoomEntryPointVariant sees CO_USE on subsequent client-side navigations
    // without re-running the permissions fetch — same pattern as crossFlowSuccessCheck.
    setCrossJoinSuccess: ()=>({ setState: setState })=>{
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
            window.__SSR_LOOM_ENTRY_POINT__ = {
                entryPointVariant: 'CO_USE'
            };
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $gXfti.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<f506d70b5432de24b8eac90a42245624>>
 * @relayHash 7d65699b292f3495b83e6d7366aa23df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44dd65d9f59cd0156391eb7142ed652780a02e2d8da4803fd8394da5092527b8
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = {
        "args": [
            {
                "kind": "Literal",
                "name": "permissionIds",
                "value": [
                    "write"
                ]
            },
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "principalIds.0",
                        "variableName": "principalId"
                    }
                ],
                "kind": "ListValue",
                "name": "principalIds"
            },
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "resourceIds.0",
                        "variableName": "loomResourceId"
                    }
                ],
                "kind": "ListValue",
                "name": "resourceIds"
            }
        ],
        "concreteType": "BulkPermittedResponse",
        "kind": "LinkedField",
        "name": "bulkPermitted",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "principalId"
            },
            {
                "kind": "ScalarField",
                "name": "resourceId"
            },
            {
                "kind": "ScalarField",
                "name": "permissionId"
            },
            {
                "kind": "ScalarField",
                "name": "permitted"
            }
        ]
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineDataFragmentSpread",
                    "name": "loomPersonalization_permission",
                    "selections": v3 /*: any*/ ,
                    "argumentDefinitions": [
                        {
                            "kind": "RootArgument",
                            "name": "loomResourceId"
                        },
                        {
                            "kind": "RootArgument",
                            "name": "principalId"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7d65699b292f3495b83e6d7366aa23df",
            "id": "44dd65d9f59cd0156391eb7142ed652780a02e2d8da4803fd8394da5092527b8",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted},...loomPersonalization_permission}fragment loomPersonalization_permission on Query{bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "6960ac36f33e1fcc4b0302c4cf32aae6";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<c76309ebecc567e6d2035e662ccfac45>>
 * @relayHash 079ff2d8b9d5ae3ff6e21263b139d2b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c22267004bc2fd98425f3cabd602d7426662a324fb451ca2cea2f794671999f
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = {
        "concreteType": "ConfluenceTenantContext",
        "kind": "LinkedField",
        "name": "confluence_tenantContext",
        "plural": false,
        "selections": [
            {
                "concreteType": "LicensedProduct",
                "kind": "LinkedField",
                "name": "licensedProducts",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "licenseStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "productKey"
                    }
                ]
            }
        ]
    }, v1 = [
        v0 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "InlineDataFragmentSpread",
                    "name": "loomPersonalization_tenant",
                    "selections": v1 /*: any*/ ,
                    "argumentDefinitions": []
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "079ff2d8b9d5ae3ff6e21263b139d2b8",
            "id": "7c22267004bc2fd98425f3cabd602d7426662a324fb451ca2cea2f794671999f",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}},...loomPersonalization_tenant}fragment loomPersonalization_tenant on Query{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "1993131921e1f069e2bc354ee5138882";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<13773984c152b0614a23977ed3fe74fa>>
 * @relayHash 758204416ec1c35eb472dcfba934fb83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c6c3e4f5926df2b58c96ecf077a734ea0bc76bb3687c7a2a84f0fbf32b22c73
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMeetingRecorderEligibility"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "ConfluenceLoomEntryPoints",
        "kind": "LinkedField",
        "name": "confluence_loomEntryPoints",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isLoomEntryPointsEnabled"
            }
        ]
    }, v2 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "condition": "includeMeetingRecorderEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "concreteType": "LoomSettings",
                "kind": "LinkedField",
                "name": "loom_settings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "meetingRecordingsAvailable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "meetingNotesEligible"
                    }
                ]
            },
            {
                "args": v2 /*: any*/ ,
                "concreteType": "LoomConnectedCalendar",
                "kind": "LinkedField",
                "name": "loom_connectedCalendars",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "guid"
                    }
                ]
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "InlineDataFragmentSpread",
                    "name": "loomPersonalization_entryPoints",
                    "selections": v4 /*: any*/ ,
                    "argumentDefinitions": [
                        {
                            "kind": "RootArgument",
                            "name": "cloudId"
                        },
                        {
                            "kind": "RootArgument",
                            "name": "includeMeetingRecorderEligibility"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "758204416ec1c35eb472dcfba934fb83",
            "id": "0c6c3e4f5926df2b58c96ecf077a734ea0bc76bb3687c7a2a84f0fbf32b22c73",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid},...loomPersonalization_entryPoints}fragment loomPersonalization_entryPoints on Query{confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "c3947215a2ac45ccf65d991a69c73b63";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("c5JFM", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c8d6014c9c636b97$export$7c5b1b3e3108671e = ()=>(0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
module.exports["isMeetingRecorderEligibilityEnabled"] = $c8d6014c9c636b97$export$7c5b1b3e3108671e;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<aa6a269424bc1b4fc1bcb7ed6da5dcee>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "b239b4c898f62763088962d6011df617";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("fxqZn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $d28d5aedb34440f3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $d28d5aedb34440f3$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
const $d28d5aedb34440f3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Bitbucket" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $d28d5aedb34440f3$var$svg,
            customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function BitbucketIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $d28d5aedb34440f3$var$svg,
        customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["BitbucketIcon"] = $d28d5aedb34440f3$export$5fc1066e677788d4;

});

parcelRegister("hZx6a", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $08074ca1ab8ce06c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
const $08074ca1ab8ce06c$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Compass" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $08074ca1ab8ce06c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function CompassIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $08074ca1ab8ce06c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["CompassIcon"] = $08074ca1ab8ce06c$export$f7857fe64d7161d9;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("8JGXU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d0e9af25866402$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $24d0e9af25866402$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
const $24d0e9af25866402$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Trello" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $24d0e9af25866402$var$svg,
            customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function TrelloIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $24d0e9af25866402$var$svg,
        customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TrelloIcon"] = $24d0e9af25866402$export$4384da9b8b140bf4;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("bZF61", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $a6b1de276595dc61$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $a6b1de276595dc61$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $a6b1de276595dc61$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $a6b1de276595dc61$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $a6b1de276595dc61$export$5c07a4287a46fa1f;

});

parcelRegister("fyjce", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6dPGs = parcelRequire("6dPGs");


var $6s56R = parcelRequire("6s56R");


var $8N8EQ = parcelRequire("8N8EQ");


var $7jITD = parcelRequire("7jITD");


var $5oT59 = parcelRequire("5oT59");


var $esAoV = parcelRequire("esAoV");

const $86ca83201018b107$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $6dPGs.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $6dPGs.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $iDrrr.fg)('rovo_fps_use_rovo_config') || (0, $6s56R.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $7jITD.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $esAoV.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $esAoV.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $6dPGs.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $8N8EQ.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $86ca83201018b107$export$e89e805418f4d2c;

});

parcelRegister("6dPGs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("6s56R", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $0f4933595e34bba8$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $0f4933595e34bba8$export$aa9f97d4dfccb6ff;

});

parcelRegister("8N8EQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $20c1508e7bfb5af0$var$NOT_AVAILABLE = 'not_available';
/**
 * HTTP response headers the gateway returns its trace / request IDs on. `fetchAgg` copies these
 * onto the parsed result as `gatewayTracingHeaders`.
 */ const $20c1508e7bfb5af0$var$TRACE_ID_HEADER = 'x-trace-id';
const $20c1508e7bfb5af0$var$REQUEST_ID_HEADER = 'atl-request-id';
const $20c1508e7bfb5af0$export$fca3401e33379daf = (result)=>{
    if (!result || typeof result !== 'object') return undefined;
    const preferTracingHeaders = (0, $iDrrr.fg)('rovo-search-vitalstats-trace-from-headers');
    if (preferTracingHeaders) {
        const tracingHeaders = result.gatewayTracingHeaders;
        const traceId = tracingHeaders?.[$20c1508e7bfb5af0$var$TRACE_ID_HEADER];
        const requestId = tracingHeaders?.[$20c1508e7bfb5af0$var$REQUEST_ID_HEADER];
        if (traceId || requestId) return {
            requestId: requestId,
            traceId: traceId
        };
    }
    if ('extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            // `tId` is the current gateway field name, `trace_id` the older one.
            traceId: preferTracingHeaders ? gateway.tId ?? gateway.trace_id ?? undefined : gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $20c1508e7bfb5af0$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $20c1508e7bfb5af0$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $20c1508e7bfb5af0$export$4acb28c262cd52bd;

});

parcelRegister("7jITD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
const $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD = 86400000;
class $df3ea53f68f38eaa$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $df3ea53f68f38eaa$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const cleanupEnabled = (0, $iDrrr.fg)('search_cache_cleanup_on_write');
        const cutoff = Date.now() - $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD;
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                // Filter persistence only: stale responses remain available in memory.
                // Skip before awaiting so obsolete promises cannot block this write.
                if (cleanupEnabled && entry.getExpirationTime() < cutoff) return;
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $df3ea53f68f38eaa$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $df3ea53f68f38eaa$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $df3ea53f68f38eaa$export$8bedcca5bbd73999 = (args)=>{
    return new $df3ea53f68f38eaa$var$Cache(args);
};
module.exports["getInstance"] = $df3ea53f68f38eaa$export$8bedcca5bbd73999;

});

parcelRegister("9C63M", function(module, exports) {
$parcel$export(module.exports, "DegradeError", () => (parcelRequire("aHhuQ")).DegradeError);

var $aHhuQ = parcelRequire("aHhuQ");

const $40115e6ed8d3612b$export$ff01cc10d3c607be = 6000; // default timeout
const $40115e6ed8d3612b$var$DEGRADE_ERROR = new (0, $aHhuQ.DegradeError)('Promise is degraded');
class $40115e6ed8d3612b$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $40115e6ed8d3612b$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $40115e6ed8d3612b$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($40115e6ed8d3612b$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $40115e6ed8d3612b$export$ea6d6e4c9647fa9;

});

parcelRegister("aHhuQ", function(module, exports) {
class $b0ed35fbaacb89be$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $b0ed35fbaacb89be$export$85bf8e4fb143676a;

});

parcelRegister("coUcA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $004bdc04c72c9ff4$export$b302f369ee895eac = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2');
const $004bdc04c72c9ff4$export$7b6d1790fa3f8f2e = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_t26_eu_code_search');
const $004bdc04c72c9ff4$export$aaeeae77a2d80487 = ()=>!(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') && !(0, $iDrrr.fg)('rovo_t26_eu_code_search') && (0, $iDrrr.fg)('rovo_github_code_search');
const $004bdc04c72c9ff4$export$ccc71f0dafe0e497 = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_t26_eu_code_search') || (0, $iDrrr.fg)('rovo_github_code_search');
const $004bdc04c72c9ff4$var$DOCUMENT_TYPE_KEY = 'document';
const $004bdc04c72c9ff4$export$960dc2d6e44432c6 = ({ products: products, selectedTypes: selectedTypes, isAllProductSearch: isAllProductSearch, codeHostProductKeys: codeHostProductKeys, githubProductKeys: githubProductKeys })=>{
    if ((0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_t26_eu_code_search')) {
        // Permissive `.some`, so the Relay code fragment is never omitted while a filter entry
        // still carries the entity.
        if (products.some((product)=>codeHostProductKeys.includes(product)) && selectedTypes.includes($004bdc04c72c9ff4$var$DOCUMENT_TYPE_KEY)) return 'document';
        // Strict, so mixing a code host with another product does not pull code in.
        if (!isAllProductSearch && selectedTypes.length === 0 && products.length === 1 && codeHostProductKeys.includes(products[0]) && (0, $iDrrr.fg)('rovo_t26_eu_code_search_m2')) return 'all-types';
        return 'none';
    }
    if (products.length === 1 && githubProductKeys.includes(products[0]) && (0, $iDrrr.fg)('rovo_github_code_search')) return 'legacy-github';
    return 'none';
};
module.exports["isCodeSearchEnabled"] = $004bdc04c72c9ff4$export$7b6d1790fa3f8f2e;
module.exports["isLegacyCodeSearchEnabled"] = $004bdc04c72c9ff4$export$aaeeae77a2d80487;
module.exports["isAnyCodeSearchEnabled"] = $004bdc04c72c9ff4$export$ccc71f0dafe0e497;
module.exports["getCodeSearchScope"] = $004bdc04c72c9ff4$export$960dc2d6e44432c6;

});

parcelRegister("jAKKt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krxYo = parcelRequire("krxYo");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2a08l = parcelRequire("2a08l");


var $frXak = parcelRequire("frXak");

const $349db1466702a732$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $frXak.messages)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2a08l.WebDomainSearchResultIcon), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            additionalTexts: [
                ...existingFilters?.additionalTexts || [],
                ...datasource?.workspaceUrl ? [
                    datasource.workspaceUrl
                ] : []
            ]
        })
};
module.exports["atlassianWebCrawlerConfig"] = $349db1466702a732$export$fbd198cf40195606;

});

parcelRegister("dAioJ", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ac1d391d64bfedde$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $ac1d391d64bfedde$export$d520529b4595d46c;

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    PullRequest: 'pull-request',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $b36df32f21d2d1ae$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see `correctedSize` below).
const $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — no compensation needed.
const $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    small: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library");
        $[0] = t1;
    } else t1 = $[0];
    const isAccurateSizeEnabled = t1;
    const t2 = isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize];
    const t3 = label || undefined;
    const t4 = label ? "img" : "presentation";
    let t5;
    if ($[1] !== SVG || $[2] !== accurateSize) {
        t5 = isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: accurateSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[1] = SVG;
        $[2] = accurateSize;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            "aria-label": t3,
            role: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $8a7a1ec4b7d3b7f4$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSizeStyles[resolvedSize] : $8a7a1ec4b7d3b7f4$var$sizeStyles[$8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            legacySize: $8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $6zMm4 = parcelRequire("6zMm4");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6pwcu = parcelRequire("6pwcu");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3LxIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $1efef99f0e02a868$export$7c51f1b21238e429(LegacyIcon, OfficialIcon, defaultSize) {
    return function BrandIcon({ size: size = defaultSize } = {}) {
        if ((0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OfficialIcon, {
            label: "",
            size: size
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LegacyIcon, null);
    };
}
module.exports["withBrandIcon"] = $1efef99f0e02a868$export$7c51f1b21238e429;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("fHkb6", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $aab5ba40d056e465$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("92aTH")).then((m)=>m.MicrosoftTeamsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-teams'
});

const $aab5ba40d056e465$var$LazyTeamsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gEuqq")).then((m)=>m.TeamsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/teams/icon'
});

const $aab5ba40d056e465$var$LazyTeamsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gEuqq")).then((m)=>m.TeamsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/teams/search-result-icon'
});

const $aab5ba40d056e465$var$LazyTeamsIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gEuqq")).then((m)=>m.TeamsIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/teams/icon-borderless'
});
const $aab5ba40d056e465$export$1bcbc9c337da86da = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsIconComponent, null)), $aab5ba40d056e465$var$OfficialIcon, 'small');
const $aab5ba40d056e465$export$fa291efbf00e84d3 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsSearchResultIconComponent, null)), $aab5ba40d056e465$var$OfficialIcon, 'medium');
const $aab5ba40d056e465$export$1b2996b1dd1cd142 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsIconBorderlessComponent, null)), $aab5ba40d056e465$var$OfficialIcon, 'xxsmall');
module.exports["TeamsIcon"] = $aab5ba40d056e465$export$1bcbc9c337da86da;
module.exports["TeamsSearchResultIcon"] = $aab5ba40d056e465$export$fa291efbf00e84d3;
module.exports["TeamsIconBorderless"] = $aab5ba40d056e465$export$1b2996b1dd1cd142;

});

parcelRegister("92aTH", function(module, exports) {

let $693cc0f469dcd892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $693cc0f469dcd892$var$load("c1IkM").then(()=>parcelRequire('aKu7b'));

});

parcelRegister("gEuqq", function(module, exports) {

let $c1f7fb973646ad66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1f7fb973646ad66$var$load("5YFUU").then(()=>parcelRequire('hui2Z'));

});

parcelRegister("9Jc29", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f96caf77f5e0e90e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("4zc1o"))).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'small');
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'medium');
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("jyScu", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $63cad5270e3124a2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jQMxS")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/logo-third-party/figma'
});

const $63cad5270e3124a2$var$LazyFigmaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/icon'
});

const $63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon'
});
const $63cad5270e3124a2$export$54e0f4982aa79afe = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaIconComponent, null)), $63cad5270e3124a2$var$OfficialIcon, 'small');
const $63cad5270e3124a2$export$b31792ff95c3d83f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent, null)), $63cad5270e3124a2$var$OfficialIcon, 'medium');
module.exports["FigmaIcon"] = $63cad5270e3124a2$export$54e0f4982aa79afe;
module.exports["FigmaSearchResultIcon"] = $63cad5270e3124a2$export$b31792ff95c3d83f;

});

parcelRegister("jQMxS", function(module, exports) {

let $e73887c3b4774afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e73887c3b4774afa$var$load("lrpUd").then(()=>parcelRequire('d5OuW'));

});

parcelRegister("lv0ob", function(module, exports) {

let $fa6ccb7c265dd600$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa6ccb7c265dd600$var$load("lXqxA").then(()=>parcelRequire('3jkLL'));

});

parcelRegister("1q7zk", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $795cd329f1dc6efb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7L3HM")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/logo-third-party/miro'
});

const $795cd329f1dc6efb$var$LazyMiroIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/icon'
});

const $795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/search-result-icon'
});
const $795cd329f1dc6efb$export$38410c1d5582587e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroIconComponent, null)), $795cd329f1dc6efb$var$OfficialIcon, 'small');
const $795cd329f1dc6efb$export$c22696a011659024 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent, null)), $795cd329f1dc6efb$var$OfficialIcon, 'medium');
module.exports["MiroIcon"] = $795cd329f1dc6efb$export$38410c1d5582587e;
module.exports["MiroSearchResultIcon"] = $795cd329f1dc6efb$export$c22696a011659024;

});

parcelRegister("7L3HM", function(module, exports) {

let $5a5fcbf4df6462e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a5fcbf4df6462e4$var$load("fDXJE").then(()=>parcelRequire('dPB9D'));

});

parcelRegister("8rXyj", function(module, exports) {

let $626f0a394095201f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $626f0a394095201f$var$load("6cQfl").then(()=>parcelRequire('UNjzi'));

});

parcelRegister("dpFv1", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $eadc98172343aaf6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("duDsS")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/logo-third-party/notion'
});

const $eadc98172343aaf6$var$LazyNotionIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon'
});

const $eadc98172343aaf6$var$LazyNotionSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon'
});

const $eadc98172343aaf6$var$LazyNotionIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless'
});
const $eadc98172343aaf6$export$694ff710b1e20299 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'small');
const $eadc98172343aaf6$export$7dd377a68ecb1d9f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionSearchResultIconComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'medium');
const $eadc98172343aaf6$export$5b5388c6f4e608dd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconBorderlessComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'xxsmall');
module.exports["NotionIcon"] = $eadc98172343aaf6$export$694ff710b1e20299;
module.exports["NotionSearchResultIcon"] = $eadc98172343aaf6$export$7dd377a68ecb1d9f;
module.exports["NotionIconBorderless"] = $eadc98172343aaf6$export$5b5388c6f4e608dd;

});

parcelRegister("duDsS", function(module, exports) {

let $9d2cb0973885463a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d2cb0973885463a$var$load("gSN2U").then(()=>parcelRequire('3zDBO'));

});

parcelRegister("dqLLz", function(module, exports) {

let $9c72c17820ac74dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c72c17820ac74dc$var$load("iCnHc").then(()=>parcelRequire('lRem0'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("8RTwe"))).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});

parcelRegister("2a08l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l1BmH")).then((m)=>m.WebDomainSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/atlassian-web-crawler/search-result-icon'
});
const $f2ed16baff72ba2b$export$b16288f56aa4a879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
module.exports["WebDomainSearchResultIcon"] = $f2ed16baff72ba2b$export$b16288f56aa4a879;

});

parcelRegister("l1BmH", function(module, exports) {

let $f4e6ace1a3666370$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4e6ace1a3666370$var$load("5ZoVX").then(()=>parcelRequire('5TYsy'));

});

parcelRegister("frXak", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $67596226ed2b5a5b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $67596226ed2b5a5b$export$defe85febe8b728c;

});

parcelRegister("4zc1o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac338e9874c603146412047b69e4afeb>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $0245abe18739bd2c$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5589" width="32" height="28" x="8" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#b43333" d="M18.03 12.455c2.659-4.606 9.307-4.607 11.967 0l8.187 14.181C40.844 31.242 37.52 37 32.201 37H15.825c-5.318 0-8.642-5.758-5.983-10.364z"/></mask><g mask="url(#mask0_118280_5589)"><path fill="url(#paint0_linear_118280_5589)" d="M44.178 37.004H27.47l-3.457-5.988 8.353-14.47z"/><path fill="url(#paint1_linear_118280_5589)" d="m3.846 37.004 11.811-20.457-3.456 5.987h6.913l8.354 14.47z"/><path fill="url(#paint2_linear_118280_5589)" d="m24.015 2.074 8.354 14.47-3.457 5.987H12.204z"/></g><defs><linearGradient id="paint0_linear_118280_5589" x1="41.759" x2="25.302" y1="35.836" y2="25.947" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#ffe921"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint1_linear_118280_5589" x1="27.359" x2="9.383" y1="38.75" y2="27.875" gradientUnits="userSpaceOnUse"><stop offset=".15" stop-color="#a9a8ff"/><stop offset=".33" stop-color="#6d97ff"/><stop offset=".48" stop-color="#3186ff"/></linearGradient><linearGradient id="paint2_linear_118280_5589" x1="29.992" x2="11.777" y1="12.613" y2="21.115" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#0ebc5f"/><stop offset=".85" stop-color="#78c9ff"/></linearGradient></defs></svg>';
function $0245abe18739bd2c$export$e16bd899bb4eebf9({ size: size, label: label = 'Google Drive', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $0245abe18739bd2c$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["GoogleDriveIcon"] = $0245abe18739bd2c$export$e16bd899bb4eebf9;

});

parcelRegister("8RTwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2aa8c41b28ad95f2edc4a75dfe3a27>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $9a3d60b77ddc3f21$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint1_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint2_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint3_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint4_linear_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint5_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint6_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint7_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint8_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint9_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="url(#paint10_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="#fff" d="m14.689 31.445 1.31-.683q.221.447.579.659.36.211.79.212.476 0 .726-.193.25-.198.25-.591a.67.67 0 0 0-.24-.52q-.24-.216-.853-.327-1.166-.212-1.695-.74-.525-.53-.525-1.318 0-.981.694-1.569.694-.585 1.83-.586.765 0 1.349.313.583.312.925.894l-1.281.66a1.4 1.4 0 0 0-.457-.472q-.247-.15-.617-.15-.443 0-.675.193a.63.63 0 0 0-.226.5q0 .265.217.467.222.197.886.322 1.117.212 1.666.77.555.553.554 1.4 0 1.03-.66 1.63t-1.883.6q-.886 0-1.599-.384a2.54 2.54 0 0 1-1.064-1.087z"/><defs><radialGradient id="paint1_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.32263 -12.8627 -23.1621 9.55567 25.665 29.882)" gradientUnits="userSpaceOnUse"><stop offset=".29" stop-color="#003b5d" stop-opacity=".2"/><stop offset=".61" stop-color="#004a6c" stop-opacity=".138"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.41835 -10.8865 -19.5798 7.9222 24.391 24.611)" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#002a42" stop-opacity=".31"/><stop offset=".61" stop-color="#004261" stop-opacity=".214"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.56759 8.10392 8.11617 5.55934 27.893 10.686)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint5_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(3.0738 -8.81188 -15.9013 -5.52951 26.098 31.084)" gradientUnits="userSpaceOnUse"><stop stop-color="#003b5d" stop-opacity=".502"/><stop offset=".49" stop-color="#004c6c" stop-opacity=".362"/><stop offset=".97" stop-color="#007a86" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.6396 6.75319 6.76325 4.63263 34.97 19.304)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(12.1028 12.086 12.105 -12.0839 13.08 23.761)" gradientUnits="userSpaceOnUse"><stop offset=".06" stop-color="#00b6bd"/><stop offset=".89" stop-color="#00495c"/></radialGradient><radialGradient id="paint10_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.45945 -9.64483 0 17.124 30.643)" gradientUnits="userSpaceOnUse"><stop offset=".57" stop-color="#1e8581" stop-opacity="0"/><stop offset=".97" stop-color="#1ecbe6" stop-opacity=".6"/></radialGradient><linearGradient id="paint0_linear_118280_5862" x1="16.812" x2="28.885" y1="10.479" y2="26.325" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".41" stop-color="#0097a8"/><stop offset="1" stop-color="#007791"/></linearGradient><linearGradient id="paint4_linear_118280_5862" x1="26.04" x2="36.102" y1="19.279" y2="32.485" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".48" stop-color="#00a2b8"/><stop offset=".95" stop-color="#00637c"/></linearGradient><linearGradient id="paint7_linear_118280_5862" x1="20.506" x2="26.919" y1="26.346" y2="39.17" gradientUnits="userSpaceOnUse"><stop offset=".05" stop-color="#75fff6"/><stop offset=".51" stop-color="#00c7d1"/><stop offset=".96" stop-color="#0096ad"/></linearGradient><linearGradient id="paint8_linear_118280_5862" x1="28.894" x2="25.466" y1="40.029" y2="35.22" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#0e5a5d" stop-opacity=".322"/><stop offset=".54" stop-color="#126c6b" stop-opacity=".222"/><stop offset=".97" stop-color="#1c948a" stop-opacity="0"/></linearGradient></defs></svg>';
function $9a3d60b77ddc3f21$export$18737550276ca4ad({ size: size, label: label = 'Microsoft SharePoint', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $9a3d60b77ddc3f21$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["MicrosoftSharePointIcon"] = $9a3d60b77ddc3f21$export$18737550276ca4ad;

});

parcelRegister("7dzhu", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jyScu = parcelRequire("jyScu");

const $5121b1584cf21fa5$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Figma,
    icon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaIcon), 'Figma', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaSearchResultIcon), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $5121b1584cf21fa5$export$e821d8af66e3adab;

});

parcelRegister("hareu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $572397f4f72859d8$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $572397f4f72859d8$export$9d37c36d8b43baee;

});

parcelRegister("kFLxH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cd2849e7738ca37b$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $cd2849e7738ca37b$export$1dc2d469fb044d48;

});

parcelRegister("aZX0c", function(module, exports) {

var $coUcA = parcelRequire("coUcA");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6suVE = parcelRequire("6suVE");

const $46e7fee1c70574c7$var$getGithubTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Repository, {
        entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).PullRequest, {
        entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Branch, {
        entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Commit, {
        entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).DevopsWorkItem, {
        entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
        subTypes3P: []
    });
    // The Document type option exists in both code search modes.
    if ((0, $coUcA.isAnyCodeSearchEnabled)()) config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $46e7fee1c70574c7$export$71c63cb45707eee = {
    displayName: 'GitHub',
    id: 'github',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Github,
    icon: (0, $i52Hf.get3PLogo)((0, $6suVE.GithubIcon), 'Github', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6suVE.GithubSearchResultIcon), 'Github', 'large'),
    integrationAri: 'ari:cloud:platform::integration/github',
    get typeFilterConfig () {
        return $46e7fee1c70574c7$var$getGithubTypeFilterConfig();
    },
    get filters () {
        return [
            'lastUpdated',
            'onlyTitleMatch',
            'pullRequestStatus',
            'reviewer',
            'createdBy',
            'repository',
            'assignee'
        ];
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["githubConfig"] = $46e7fee1c70574c7$export$71c63cb45707eee;

});

parcelRegister("6Ymez", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $0aab066f73937fd8$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $0aab066f73937fd8$export$7bf025ec33e76761;

});

parcelRegister("bCUcs", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ea564ddf0cc8c2fd$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $ea564ddf0cc8c2fd$export$3e5409bef2addb56;

});

parcelRegister("fmJYG", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $51acdb1b50e4834b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $51acdb1b50e4834b$export$3268f1527392e5ac;

});

parcelRegister("iM9d2", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fe7cd180c5f0ee38$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fe7cd180c5f0ee38$export$c28231fcae6448eb;

});

parcelRegister("2Rsot", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a989069c3574d0d8$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $a989069c3574d0d8$export$d810eae89914369b;

});

parcelRegister("kFYBW", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9Jc29 = parcelRequire("9Jc29");

const $aac32d306159bd81$var$getGoogleDriveTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Document,
            (0, $5PPrc.NounSubtypeKey).Pdf,
            (0, $5PPrc.NounSubtypeKey).Page,
            (0, $5PPrc.NounSubtypeKey).Blogpost
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Spreadsheet, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Presentation, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Presentation
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: [
            ...(0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Video
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Image, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Image
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Folder, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Folder
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Audio, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Audio
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Pdf, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Code, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Code
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Form, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Form
        ]
    });
    // Back-ported (consolidated) shape — replaces individual Page/Blogpost entries
    // with a richer WebPage entry and folds Archive into Other.
    config.set((0, $5PPrc.TypeFilterValueKey).Notebook, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Notebook
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).WebPage, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).WebPage,
            (0, $5PPrc.NounSubtypeKey).Shortcut
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Other, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Other,
            (0, $5PPrc.NounSubtypeKey).Archive
        ]
    });
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats Google Drive comment matches as documents rather than standalone comments.
    if ((0, $iDrrr.fg)('enable_3p_embedded_comments_search')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    return config;
};
const $aac32d306159bd81$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).GoogleDrive,
    icon: (0, $i52Hf.get3PLogo)((0, $9Jc29.GoogleDriveIcon), 'Google Drive', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9Jc29.GoogleDriveIconBorderless), 'Google Drive', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9Jc29.GoogleDriveSearchResultIcon), 'Google Drive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    // Use a getter to evaluate lazily so that it's evaluated when accessed, not at module load.
    // This allows for feature gate mocks in tests to work correctly
    get typeFilterConfig () {
        return $aac32d306159bd81$var$getGoogleDriveTypeFilterConfig();
    },
    get filters () {
        return [
            'lastUpdated',
            'onlyTitleMatch',
            'space',
            'content'
        ];
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["googleDriveConfig"] = $aac32d306159bd81$export$6634ddcb22ed69a;

});

parcelRegister("sRb5o", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cedd31adddcd6a4e$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $cedd31adddcd6a4e$export$a3d7cddace4fe237;

});

parcelRegister("gOrBS", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $Douji = parcelRequire("Douji");

const $9591d824618efc40$var$getSharePointTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Document,
            (0, $5PPrc.NounSubtypeKey).Pdf,
            (0, $5PPrc.NounSubtypeKey).Page,
            (0, $5PPrc.NounSubtypeKey).Blogpost
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Spreadsheet, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Presentation, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Presentation
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Video
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Image, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Image
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Folder, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Folder,
            (0, $5PPrc.NounSubtypeKey).Drive
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Pdf, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Notebook, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Notebook
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).WebPage, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).WebPage,
            (0, $5PPrc.NounSubtypeKey).Shortcut
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Other, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Other,
            (0, $5PPrc.NounSubtypeKey).Archive
        ]
    });
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats SharePoint comment matches as documents rather than standalone comments.
    // SharePoint embedded comments are gated behind a SharePoint-specific flag (independent of the
    // shared 3p flag used for Google Drive) so we can enable/disable SharePoint comment support
    // independently of other 3p products.
    if ((0, $iDrrr.fg)('rovo_fps_sharepoint_embedded_comments')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $9591d824618efc40$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft SharePoint',
    id: 'sharepoint',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sharepoint,
    icon: (0, $i52Hf.get3PLogo)((0, $Douji.SharePointIcon), 'Sharepoint', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $Douji.SharepointIconBorderless), 'Sharepoint', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $Douji.SharePointSearchResultIcon), 'Sharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    // Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    get typeFilterConfig () {
        return $9591d824618efc40$var$getSharePointTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch',
            'space'
        ];
        if ((0, $iDrrr.fg)('rovo_fps_enable_sharepoint_content_filter')) baseFilters.push('content');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sharepointConfig"] = $9591d824618efc40$export$eb46bb6c4f0e628c;

});

parcelRegister("lSeWC", function(module, exports) {

var $lb2PL = parcelRequire("lb2PL");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");

const $248c68d25f33bedd$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $lb2PL.LoomIcon), 'small'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $lb2PL.LoomIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["loomConfig"] = $248c68d25f33bedd$export$9cb908560d4a0a78;

});

parcelRegister("4TRyZ", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gjT9P = parcelRequire("gjT9P");

const $0dfe51a80d18d316$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OneDrive,
    icon: (0, $i52Hf.get3PLogo)((0, $gjT9P.OneDriveIcon), 'OneDrive', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $gjT9P.OneDriveIconBorderless), 'OneDrive', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gjT9P.OneDriveSearchResultIcon), 'OneDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["oneDriveConfig"] = $0dfe51a80d18d316$export$b3b3a7aaf94fe09;

});

parcelRegister("gjT9P", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $a09e3766710471f8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("5TdBT"))).then((m)=>m.MicrosoftOneDriveIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-onedrive'
});

const $a09e3766710471f8$var$LazyOneDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDyw")).then((m)=>m.OneDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/icon'
});

const $a09e3766710471f8$var$LazyOneDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDyw")).then((m)=>m.OneDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/search-result-icon'
});

const $a09e3766710471f8$var$LazyOneDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDyw")).then((m)=>m.OneDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/icon-borderless'
});
const $a09e3766710471f8$export$44884401d09e251c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveIconComponent, null)), $a09e3766710471f8$var$OfficialIcon, 'small');
const $a09e3766710471f8$export$f2ab3f3a9966c07c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveSearchResultIconComponent, null)), $a09e3766710471f8$var$OfficialIcon, 'medium');
const $a09e3766710471f8$export$9b1a95f6ce5942a8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveIconBorderlessComponent, null)), $a09e3766710471f8$var$OfficialIcon, 'xxsmall');
module.exports["OneDriveIcon"] = $a09e3766710471f8$export$44884401d09e251c;
module.exports["OneDriveSearchResultIcon"] = $a09e3766710471f8$export$f2ab3f3a9966c07c;
module.exports["OneDriveIconBorderless"] = $a09e3766710471f8$export$9b1a95f6ce5942a8;

});

parcelRegister("lbDyw", function(module, exports) {

let $f6c94f073561a95b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c94f073561a95b$var$load("3WneE").then(()=>parcelRequire('8EfTH'));

});

parcelRegister("5TdBT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::352a2d656f28112e2ef3d91735e599d7>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $f87149460128dc3a$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_radial_118280_5819)" d="M16.396 15.797c-5.198 0-9.083 4.255-9.376 8.995.181 1.021.776 3.038 1.708 2.935 1.165-.13 4.1 0 6.602-4.531 1.828-3.31 5.589-7.4 1.066-7.4"/><path fill="url(#paint1_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint2_radial_118280_5819)" fill-opacity=".4" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint3_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint4_radial_118280_5819)" fill-opacity=".6" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint5_radial_118280_5819)" fill-opacity=".9" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint6_linear_118280_5819)" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint7_radial_118280_5819)" fill-opacity=".4" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint8_radial_118280_5819)" fill-opacity=".9" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><defs><radialGradient id="paint0_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(50.153 -14.375 16.71)scale(10.7161 17.7747)" gradientUnits="userSpaceOnUse"><stop stop-color="#4894fe"/><stop offset=".695" stop-color="#0934b3"/></radialGradient><radialGradient id="paint1_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(130.923 17.143 10.667)scale(46.0803 34.1459)" gradientUnits="userSpaceOnUse"><stop offset=".165" stop-color="#23c0fe"/><stop offset=".534" stop-color="#1c91ff"/></radialGradient><radialGradient id="paint2_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.014 10.522 6.163)scale(9.36856 21.4466)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".661" stop-color="#adc0ff" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.236 17.663 9.818)scale(10.5597 16.0372)" gradientUnits="userSpaceOnUse"><stop stop-color="#033acc"/><stop offset="1" stop-color="#368eff" stop-opacity="0"/></radialGradient><radialGradient id="paint4_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(66.571 -1.855 16.474)scale(23.1705 25.0138)" gradientUnits="userSpaceOnUse"><stop offset=".593" stop-color="#3464e3" stop-opacity="0"/><stop offset="1" stop-color="#033acc"/></radialGradient><radialGradient id="paint5_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(135 16.558 11.022)scale(34.0831 53.3967)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".544" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><radialGradient id="paint7_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(21.632 -45.065 64.673)scale(15.4444 29.2464)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".785" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="paint8_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(139.243 16.894 16.587)scale(21.1738 21.2455)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".585" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><linearGradient id="paint6_linear_118280_5819" x1="28.722" x2="28.722" y1="34.931" y2="19.517" gradientUnits="userSpaceOnUse"><stop stop-color="#0086ff"/><stop offset=".49" stop-color="#0bf"/></linearGradient></defs></svg>';
function $f87149460128dc3a$export$adf3a43722623322({ size: size, label: label = 'Microsoft OneDrive', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $f87149460128dc3a$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["MicrosoftOneDriveIcon"] = $f87149460128dc3a$export$adf3a43722623322;

});

parcelRegister("2qza4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jkp8o = parcelRequire("jkp8o");

const $f930aa7851f48d68$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dropbox,
    icon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxIcon), 'Dropbox', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxSearchResultIcon), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $f930aa7851f48d68$export$4a63cdb15a145936;

});

parcelRegister("jkp8o", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f91f519b5bcd4961$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ndru")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/logo-third-party/dropbox'
});

const $f91f519b5bcd4961$var$LazyDropboxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/icon'
});

const $f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon'
});
const $f91f519b5bcd4961$export$5e2362bb78414664 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxIconComponent, null)), $f91f519b5bcd4961$var$OfficialIcon, 'small');
const $f91f519b5bcd4961$export$197780c70679b508 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent, null)), $f91f519b5bcd4961$var$OfficialIcon, 'medium');
module.exports["DropboxIcon"] = $f91f519b5bcd4961$export$5e2362bb78414664;
module.exports["DropboxSearchResultIcon"] = $f91f519b5bcd4961$export$197780c70679b508;

});

parcelRegister("8ndru", function(module, exports) {

let $618ae617941e5dc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $618ae617941e5dc0$var$load("1FkAI").then(()=>parcelRequire('7qsey'));

});

parcelRegister("jawnG", function(module, exports) {

let $df4811b549e8b26a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df4811b549e8b26a$var$load("4zHyf").then(()=>parcelRequire('lOu1t'));

});

parcelRegister("kDG5l", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $72Zuk = parcelRequire("72Zuk");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2sFbd = parcelRequire("2sFbd");

const $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig = ()=>{
    const typeFilter = new Map();
    // Always include Message
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Message, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Conversation, {
        entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
        subTypes3P: []
    });
    return typeFilter;
};
const $35e09b6a61d5b2b9$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Slack,
    icon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIcon), 'Slack', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIconBorderless), 'Slack', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackSearchResultIcon), 'Slack', 'large'),
    integrationAri: 'ari:cloud:platform::integration/slack',
    get typeFilterConfig () {
        return $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'slackChannel'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["slackConfig"] = $35e09b6a61d5b2b9$export$c33894e475506863;

});

parcelRegister("6GYKu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $76ad9eb563127536$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $76ad9eb563127536$export$a752b216a5b9069f;

});

parcelRegister("72Zuk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $229f506edf3bbbcc$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $229f506edf3bbbcc$export$8bd7fa13a82672fe;

});

parcelRegister("6sCQO", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $72Zuk = parcelRequire("72Zuk");


var $kFLxH = parcelRequire("kFLxH");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fHkb6 = parcelRequire("fHkb6");

const $5b2f0af1768b93e1$var$getTeamsTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Conversation, {
        entities3P: [
            ...(0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Message, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: []
    });
    // NOTE: Attachment intentionally reuses DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI (same as
    // Message above) because there is no dedicated attachment ATI in the cloud graph schema.
    // This means convertFiltersToQueryParams / extractType cannot distinguish 'attachment'
    // from 'message' when reading back the blob — both produce ati:cloud:graph:message with
    // no differentiating subtypes.
    // To fix this properly, either:
    //   1. Introduce a dedicated ati:cloud:graph:attachment entity ATI, or
    //   2. Add a NounSubtypeKey.Attachment subtype and update the Teams config to use it.
    config.set((0, $5PPrc.TypeFilterValueKey).Attachment, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $5b2f0af1768b93e1$export$a579e078acf13bef = {
    displayName: 'Microsoft Teams',
    id: 'teams',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Teams,
    icon: (0, $i52Hf.get3PLogo)((0, $fHkb6.TeamsIcon), 'Teams', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $fHkb6.TeamsIconBorderless), 'Teams', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fHkb6.TeamsSearchResultIcon), 'Teams', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    get typeFilterConfig () {
        return $5b2f0af1768b93e1$var$getTeamsTypeFilterConfig();
    },
    get filters () {
        const filters = [
            'lastUpdated',
            'hasAttachment',
            'workspaceName'
        ];
        return filters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["teamsConfig"] = $5b2f0af1768b93e1$export$a579e078acf13bef;

});

parcelRegister("6eg6r", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bshDC = parcelRequire("bshDC");

const $5a3e20cfdf519b55$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIcon), 'Google Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIconBorderless), 'Google Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarSearchResultIcon), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};
module.exports["googleCalendarConfig"] = $5a3e20cfdf519b55$export$be326f2f9a08a3a4;

});

parcelRegister("f3t7x", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $353cafebfceb5684$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $353cafebfceb5684$export$733c2acb2513a07a;

});

parcelRegister("bshDC", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $5e54e69c86724cae$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("anZGr")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/logo-third-party/google-calendar'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/search-result-icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon-borderless'
});
const $5e54e69c86724cae$export$5d128e0a6ffc0558 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'small');
const $5e54e69c86724cae$export$aed283b8fb73a449 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'medium');
const $5e54e69c86724cae$export$dc8e328f8eb98139 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'xxsmall');
module.exports["GoogleCalendarIcon"] = $5e54e69c86724cae$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarSearchResultIcon"] = $5e54e69c86724cae$export$aed283b8fb73a449;
module.exports["GoogleCalendarIconBorderless"] = $5e54e69c86724cae$export$dc8e328f8eb98139;

});

parcelRegister("anZGr", function(module, exports) {

let $78fbe6699ea6267d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78fbe6699ea6267d$var$load("eN8m9").then(()=>parcelRequire('dO5IM'));

});

parcelRegister("4w4Kc", function(module, exports) {

let $349dd4aca5d2aad7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $349dd4aca5d2aad7$var$load("41vki").then(()=>parcelRequire('bzpJH'));

});

parcelRegister("52jas", function(module, exports) {

var $iURDc = parcelRequire("iURDc");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4sGAv = parcelRequire("4sGAv");

const $b333d81b934c9f10$export$c771ac380e225e02 = {
    displayName: 'Gmail',
    id: 'gmail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gmail,
    icon: (0, $i52Hf.get3PLogo)((0, $4sGAv.GmailIcon), 'Gmail', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $4sGAv.GmailIconBorderless), 'Gmail', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4sGAv.GmailSearchResultIcon), 'Gmail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $iURDc.FEDERATED_GOOGLE_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    isEnabled: ()=>true,
    isFederated: true
};
module.exports["gmailConfig"] = $b333d81b934c9f10$export$c771ac380e225e02;

});

parcelRegister("iURDc", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ /**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ 




var $sRb5o = parcelRequire("sRb5o");


















const $24284859cca72d32$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $24284859cca72d32$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $24284859cca72d32$export$50adf3273cb5cdeb = [
    $24284859cca72d32$export$6ec0530ffade9ab0,
    $24284859cca72d32$export$dfd3b612305212b4
];
module.exports["FEDERATED_GOOGLE_EMAIL_ENTITY_ATI"] = $24284859cca72d32$export$6ec0530ffade9ab0;
module.exports["FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI"] = $24284859cca72d32$export$dfd3b612305212b4;

});

parcelRegister("2vDkv", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $b3506739b3db16a9$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $b3506739b3db16a9$export$1e3b02869b42f77a;

});

parcelRegister("4moZS", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4dabbc53c19f0eb6$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $4dabbc53c19f0eb6$export$4e0eae9edc1a8907;

});

parcelRegister("kQMkl", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $58e4cb80d7bd8f2a$export$3f89e5cd56d4a568 = [
    'ati:cloud:graph:project'
];
module.exports["DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI"] = $58e4cb80d7bd8f2a$export$3f89e5cd56d4a568;

});

parcelRegister("2eAN0", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $985674bff788ed13$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $985674bff788ed13$export$13c55dcee8605c46;

});

parcelRegister("5L3UP", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c71c6856c01ed4e1$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $c71c6856c01ed4e1$export$8dd471de1c2be682;

});

parcelRegister("lSV0R", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $73e7c9ae902307cd$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $73e7c9ae902307cd$export$5794851cbc8ee193;

});

parcelRegister("5zhyH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c56574206e5d9432$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $c56574206e5d9432$export$f752f74515f17189;

});

parcelRegister("5ET0n", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $9b3a3e2680ba7ccf$export$fedd20c53936ae44 = [
    'ati:cloud:graph:customer-contact'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI"] = $9b3a3e2680ba7ccf$export$fedd20c53936ae44;

});

parcelRegister("l2DTy", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $5b29277d1a8af5e5$export$2b1dc2787f647e40 = [
    'ati:cloud:graph:campaign'
];
module.exports["DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI"] = $5b29277d1a8af5e5$export$2b1dc2787f647e40;

});

parcelRegister("kxWyf", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a8af9f863b3e166c$export$47853cd30a48f750 = [
    'ati:cloud:graph:case'
];
module.exports["DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI"] = $a8af9f863b3e166c$export$47853cd30a48f750;

});

parcelRegister("4sGAv", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $71969d87ce9cceb1$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3Ypdc")).then((m)=>m.GmailIcon), {
    moduleId: '@atlassian/logo-third-party/gmail'
});

const $71969d87ce9cceb1$var$LazyGmailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2LZrP")).then((m)=>m.GmailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gmail/icon'
});

const $71969d87ce9cceb1$var$LazyGmailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2LZrP")).then((m)=>m.GmailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gmail/search-result-icon'
});

const $71969d87ce9cceb1$var$LazyGmailIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2LZrP")).then((m)=>m.GmailIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gmail/icon-borderless'
});
const $71969d87ce9cceb1$export$856bad9032bbc5ed = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailIconComponent, null)), $71969d87ce9cceb1$var$OfficialIcon, 'small');
const $71969d87ce9cceb1$export$5abf8db8f9fa0429 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailSearchResultIconComponent, null)), $71969d87ce9cceb1$var$OfficialIcon, 'medium');
const $71969d87ce9cceb1$export$60f25f99f40f37f6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailIconBorderlessComponent, null)), $71969d87ce9cceb1$var$OfficialIcon, 'xxsmall');
module.exports["GmailIcon"] = $71969d87ce9cceb1$export$856bad9032bbc5ed;
module.exports["GmailSearchResultIcon"] = $71969d87ce9cceb1$export$5abf8db8f9fa0429;
module.exports["GmailIconBorderless"] = $71969d87ce9cceb1$export$60f25f99f40f37f6;

});

parcelRegister("3Ypdc", function(module, exports) {

let $2e4a8843211d2184$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e4a8843211d2184$var$load("fPF58").then(()=>parcelRequire('lscWM'));

});

parcelRegister("2LZrP", function(module, exports) {

let $204fa2d3335e90ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $204fa2d3335e90ee$var$load("4ypyc").then(()=>parcelRequire('lq00l'));

});

parcelRegister("ijAga", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9dIsl = parcelRequire("9dIsl");

const $28f910cc1563149a$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIcon), 'Outlook Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIconBorderless), 'Outlook Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarSearchResultIcon), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["outlookCalendarConfig"] = $28f910cc1563149a$export$3e5044818f2e9ef3;

});

parcelRegister("9dIsl", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b7be050c70ad0dbd$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lwMgp")).then((m)=>m.MicrosoftOutlookIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-outlook'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/search-result-icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon-borderless'
});
const $b7be050c70ad0dbd$export$62b570fbaf793397 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'small');
const $b7be050c70ad0dbd$export$c93fd0887f18cc87 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'medium');
const $b7be050c70ad0dbd$export$dd150ae24aa9e16a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'xxsmall');
module.exports["OutlookCalendarIcon"] = $b7be050c70ad0dbd$export$62b570fbaf793397;
module.exports["OutlookCalendarSearchResultIcon"] = $b7be050c70ad0dbd$export$c93fd0887f18cc87;
module.exports["OutlookCalendarIconBorderless"] = $b7be050c70ad0dbd$export$dd150ae24aa9e16a;

});

parcelRegister("lwMgp", function(module, exports) {

let $fac20645ff50f52d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fac20645ff50f52d$var$load("eLIPc").then(()=>parcelRequire('6Adh3'));

});

parcelRegister("1cK5e", function(module, exports) {

let $0e0aa8a5bee42239$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e0aa8a5bee42239$var$load("kD3mK").then(()=>parcelRequire('izieu'));

});

parcelRegister("dPp45", function(module, exports) {

var $iURDc = parcelRequire("iURDc");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lbM4I = parcelRequire("lbM4I");

const $80f26afb2b86eb44$export$31104d47075e6dfd = {
    displayName: 'Outlook Mail',
    id: 'outlook-mail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OutlookMail,
    icon: (0, $i52Hf.get3PLogo)((0, $lbM4I.OutlookMailIcon), 'Outlook Mail', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $lbM4I.OutlookMailIconBorderless), 'Outlook Mail', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lbM4I.OutlookMailSearchResultIcon), 'Outlook Mail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $iURDc.FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    isEnabled: ()=>true,
    isFederated: true
};
module.exports["outlookMail"] = $80f26afb2b86eb44$export$31104d47075e6dfd;

});

parcelRegister("lbM4I", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b087007c6338cae$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lwMgp")).then((m)=>m.MicrosoftOutlookIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-outlook'
});

const $9b087007c6338cae$var$LazyOutlookMailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1MgDj")).then((m)=>m.OutlookMailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-mail/icon'
});

const $9b087007c6338cae$var$LazyOutlookMailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1MgDj")).then((m)=>m.OutlookMailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-mail/search-result-icon'
});

const $9b087007c6338cae$var$LazyOutlookMailIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1MgDj")).then((m)=>m.OutlookMailIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-mail/icon-borderless'
});
const $9b087007c6338cae$export$d905606eb58fea64 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailIconComponent, null)), $9b087007c6338cae$var$OfficialIcon, 'small');
const $9b087007c6338cae$export$f819ae7cc5008c40 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailSearchResultIconComponent, null)), $9b087007c6338cae$var$OfficialIcon, 'medium');
const $9b087007c6338cae$export$c828641fbf8ac5e9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailIconBorderlessComponent, null)), $9b087007c6338cae$var$OfficialIcon, 'xxsmall');
module.exports["OutlookMailIcon"] = $9b087007c6338cae$export$d905606eb58fea64;
module.exports["OutlookMailSearchResultIcon"] = $9b087007c6338cae$export$f819ae7cc5008c40;
module.exports["OutlookMailIconBorderless"] = $9b087007c6338cae$export$c828641fbf8ac5e9;

});

parcelRegister("1MgDj", function(module, exports) {

let $14b72d21451b9e01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14b72d21451b9e01$var$load("5dATw").then(()=>parcelRequire('cs6al'));

});

parcelRegister("4Be7r", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5SyKL = parcelRequire("5SyKL");

const $e64348b365719323$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaIcon), 'Asana', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Asana,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaSearchResultIcon), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["asanaConfig"] = $e64348b365719323$export$72c8845a87b8934e;

});

parcelRegister("5SyKL", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6e40eba859cc102e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kMuq9")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/logo-third-party/asana'
});

const $6e40eba859cc102e$var$LazyAsanaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/icon'
});

const $6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/search-result-icon'
});
const $6e40eba859cc102e$export$671541d0c7918cd9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaIconComponent, null)), $6e40eba859cc102e$var$OfficialIcon, 'small');
const $6e40eba859cc102e$export$c3fa6bf9156b56f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent, null)), $6e40eba859cc102e$var$OfficialIcon, 'medium');
module.exports["AsanaIcon"] = $6e40eba859cc102e$export$671541d0c7918cd9;
module.exports["AsanaSearchResultIcon"] = $6e40eba859cc102e$export$c3fa6bf9156b56f9;

});

parcelRegister("kMuq9", function(module, exports) {

let $f20fe34add90d72b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f20fe34add90d72b$var$load("d4v6U").then(()=>parcelRequire('2FcOq'));

});

parcelRegister("63WVt", function(module, exports) {

let $46a0bb5c742ef139$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46a0bb5c742ef139$var$load("cQSOF").then(()=>parcelRequire('9fYuQ'));

});

parcelRegister("kmEEk", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ajO8r = parcelRequire("ajO8r");

const $c81e254992debedb$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskIcon), 'Zendesk', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zendesk,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskSearchResultIcon), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Ticket,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Post,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Post
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Article,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Article
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zendeskConfig"] = $c81e254992debedb$export$74a2db0a5eb2da3f;

});

parcelRegister("ajO8r", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $8cf8b8beac6f4758$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eU7gC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/logo-third-party/zendesk'
});

const $8cf8b8beac6f4758$var$LazyZendeskIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/icon'
});

const $8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/search-result-icon'
});
const $8cf8b8beac6f4758$export$9969d63eaadfddf7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskIconComponent, null)), $8cf8b8beac6f4758$var$OfficialIcon, 'small');
const $8cf8b8beac6f4758$export$439dd6b525db0f9a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent, null)), $8cf8b8beac6f4758$var$OfficialIcon, 'medium');
module.exports["ZendeskIcon"] = $8cf8b8beac6f4758$export$9969d63eaadfddf7;
module.exports["ZendeskSearchResultIcon"] = $8cf8b8beac6f4758$export$439dd6b525db0f9a;

});

parcelRegister("eU7gC", function(module, exports) {

let $ad9beeb805548024$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad9beeb805548024$var$load("T8raP").then(()=>parcelRequire('6foYz'));

});

parcelRegister("fmsuC", function(module, exports) {

let $b2ef03301938ca3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2ef03301938ca3f$var$load("2TtSv").then(()=>parcelRequire('iMWOo'));

});

parcelRegister("52Drw", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $inzhp = parcelRequire("inzhp");

const $03fbf292f7174bda$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Airtable,
    icon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableIcon), 'Airtable', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableSearchResultIcon), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["airtableConfig"] = $03fbf292f7174bda$export$962b0679c5bd2c33;

});

parcelRegister("inzhp", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $92a7691f4600f71d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("d0y3M")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/logo-third-party/airtable'
});

const $92a7691f4600f71d$var$LazyAirtableIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/icon'
});

const $92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/search-result-icon'
});
const $92a7691f4600f71d$export$88b64eee273831fd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableIconComponent, null)), $92a7691f4600f71d$var$OfficialIcon, 'small');
const $92a7691f4600f71d$export$826c628c1cea041a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent, null)), $92a7691f4600f71d$var$OfficialIcon, 'medium');
module.exports["AirtableIcon"] = $92a7691f4600f71d$export$88b64eee273831fd;
module.exports["AirtableSearchResultIcon"] = $92a7691f4600f71d$export$826c628c1cea041a;

});

parcelRegister("d0y3M", function(module, exports) {

let $9785b20e7cd3fd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9785b20e7cd3fd83$var$load("1p5Hv").then(()=>parcelRequire('3WMFE'));

});

parcelRegister("kzDsq", function(module, exports) {

let $efa5aef30890ae60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efa5aef30890ae60$var$load("ks6Jw").then(()=>parcelRequire('dIIkr'));

});

parcelRegister("aaz0Y", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g0bLV = parcelRequire("g0bLV");

const $81da3ded26649f38$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Smartsheet,
    icon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetIcon), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetSearchResultIcon), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["smartsheetConfig"] = $81da3ded26649f38$export$aad10bcf647ef696;

});

parcelRegister("g0bLV", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $8f9328e012078649$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iR5v6")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/logo-third-party/smartsheet'
});

const $8f9328e012078649$var$LazySmartsheetIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/icon'
});

const $8f9328e012078649$var$LazySmartsheetSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/search-result-icon'
});
const $8f9328e012078649$export$dd0ad7bd8a5794f4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetIconComponent, null)), $8f9328e012078649$var$OfficialIcon, 'small');
const $8f9328e012078649$export$3b8c4380ae1ed96d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetSearchResultIconComponent, null)), $8f9328e012078649$var$OfficialIcon, 'medium');
module.exports["SmartsheetIcon"] = $8f9328e012078649$export$dd0ad7bd8a5794f4;
module.exports["SmartsheetSearchResultIcon"] = $8f9328e012078649$export$3b8c4380ae1ed96d;

});

parcelRegister("iR5v6", function(module, exports) {

let $dba171869ac506f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dba171869ac506f9$var$load("5ErXe").then(()=>parcelRequire('hRzDR'));

});

parcelRegister("hsPg7", function(module, exports) {

let $cb6cd027ab9362e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb6cd027ab9362e1$var$load("hwAbd").then(()=>parcelRequire('7j9rQ'));

});

parcelRegister("kcCFv", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dpFv1 = parcelRequire("dpFv1");

const $2afe1256651e861b$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Notion,
    icon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIcon), 'Notion', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIconBorderless), 'Notion', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionSearchResultIcon), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["notionConfig"] = $2afe1256651e861b$export$ddf7404f556e473a;

});

parcelRegister("6lsSn", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1q7zk = parcelRequire("1q7zk");

const $b9040784bae93d2b$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Miro,
    icon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroIcon), 'Miro', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroSearchResultIcon), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $b9040784bae93d2b$export$b11bada05d439596;

});

parcelRegister("k521G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XMnx = parcelRequire("3XMnx");

const $3c5ca7e0efe3fba9$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Docusign,
    icon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIcon), 'Docusign', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIconBorderless), 'Docusign', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignSearchResultIcon), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["docusignConfig"] = $3c5ca7e0efe3fba9$export$cee55280cabc1aa1;

});

parcelRegister("3XMnx", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $094cc084c2c96e5c$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2xHBu")).then((m)=>m.DocuSignIcon), {
    moduleId: '@atlassian/logo-third-party/docusign'
});

const $094cc084c2c96e5c$var$LazyDocusignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon'
});

const $094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/search-result-icon'
});

const $094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon-borderless'
});
const $094cc084c2c96e5c$export$393452da0e179bab = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'small');
const $094cc084c2c96e5c$export$4cdd065eb81c5a09 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'medium');
const $094cc084c2c96e5c$export$db2f9bd1f316d475 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'xxsmall');
module.exports["DocusignIcon"] = $094cc084c2c96e5c$export$393452da0e179bab;
module.exports["DocusignSearchResultIcon"] = $094cc084c2c96e5c$export$4cdd065eb81c5a09;
module.exports["DocusignIconBorderless"] = $094cc084c2c96e5c$export$db2f9bd1f316d475;

});

parcelRegister("2xHBu", function(module, exports) {

let $1da07ca46271c18f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1da07ca46271c18f$var$load("7YktL").then(()=>parcelRequire('eF6SD'));

});

parcelRegister("l2dtx", function(module, exports) {

let $f5043cd00e87a001$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5043cd00e87a001$var$load("hY6q1").then(()=>parcelRequire('l3sY5'));

});

parcelRegister("43W2t", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $kSVSf = parcelRequire("kSVSf");

const $20e2732837474949$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Lucid,
    icon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidIcon), 'Lucid', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidSearchResultIcon), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["lucidConfig"] = $20e2732837474949$export$3cac442956139a7e;

});

parcelRegister("kSVSf", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $28a610a168ffc34d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aujOL")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/logo-third-party/lucid'
});

const $28a610a168ffc34d$var$LazyLucidIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/icon'
});

const $28a610a168ffc34d$var$LazyLucidSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon'
});
const $28a610a168ffc34d$export$8664694e1d7db2a0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidIconComponent, null)), $28a610a168ffc34d$var$OfficialIcon, 'small');
const $28a610a168ffc34d$export$6daa097ac5ffeb2c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidSearchResultIconComponent, null)), $28a610a168ffc34d$var$OfficialIcon, 'medium');
module.exports["LucidIcon"] = $28a610a168ffc34d$export$8664694e1d7db2a0;
module.exports["LucidSearchResultIcon"] = $28a610a168ffc34d$export$6daa097ac5ffeb2c;

});

parcelRegister("aujOL", function(module, exports) {

let $7a2c1421be11368f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a2c1421be11368f$var$load("c2c9w").then(()=>parcelRequire('h4FW2'));

});

parcelRegister("627KK", function(module, exports) {

let $4648f18ba45c9e97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4648f18ba45c9e97$var$load("hU3Xi").then(()=>parcelRequire('c6ZRh'));

});

parcelRegister("6ThsT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cJP8d = parcelRequire("cJP8d");

const $03d641d2f237614a$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Monday,
    icon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIcon), 'Monday', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIconBorderless), 'Monday', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondaySearchResultIcon), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["mondayConfig"] = $03d641d2f237614a$export$49283b8341865631;

});

parcelRegister("cJP8d", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $142215abe5670892$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("f2rQp")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/logo-third-party/monday'
});

const $142215abe5670892$var$LazyMondayIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon'
});

const $142215abe5670892$var$LazyMondaySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondaySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon'
});

const $142215abe5670892$var$LazyMondayIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless'
});
const $142215abe5670892$export$37b4104f63b2f4bd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconComponent, null)), $142215abe5670892$var$OfficialIcon, 'small');
const $142215abe5670892$export$bf10d2e61430fb53 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondaySearchResultIconComponent, null)), $142215abe5670892$var$OfficialIcon, 'medium');
const $142215abe5670892$export$43da0494a61d1337 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconBorderlessComponent, null)), $142215abe5670892$var$OfficialIcon, 'xxsmall');
module.exports["MondayIcon"] = $142215abe5670892$export$37b4104f63b2f4bd;
module.exports["MondaySearchResultIcon"] = $142215abe5670892$export$bf10d2e61430fb53;
module.exports["MondayIconBorderless"] = $142215abe5670892$export$43da0494a61d1337;

});

parcelRegister("f2rQp", function(module, exports) {

let $af2ca43c73de70db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af2ca43c73de70db$var$load("8UmJb").then(()=>parcelRequire('863CU'));

});

parcelRegister("9b74Z", function(module, exports) {

let $6aeaa1f9faf92676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aeaa1f9faf92676$var$load("1EOaf").then(()=>parcelRequire('iBWwo'));

});

parcelRegister("4x6XK", function(module, exports) {

var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dULnI = parcelRequire("dULnI");

const $aaf7a143bc096e5d$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AzureDevops,
    icon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsIcon), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsSearchResultIcon), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["azureDevopsConfig"] = $aaf7a143bc096e5d$export$f324080d91cfb196;

});

parcelRegister("382mb", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ehKBQ = parcelRequire("ehKBQ");

const $e23e1846e340baa7$var$getGitlabTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Repository, {
        entities3P: [
            ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Repository,
            (0, $5PPrc.NounSubtypeKey).Project
        ]
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-gitlab-pull-request-noun')) config.set((0, $5PPrc.TypeFilterValueKey).PullRequest, {
        entities3P: [
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).PullRequest
        ]
    });
    return config;
};
const $e23e1846e340baa7$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitlab,
    icon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIcon), 'Gitlab', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIconBorderless), 'Gitlab', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabSearchResultIcon), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    get typeFilterConfig () {
        return $e23e1846e340baa7$var$getGitlabTypeFilterConfig();
    },
    filters: [
        'pullRequestStatus'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gitlabConfig"] = $e23e1846e340baa7$export$72758f81cc2e21e1;

});

parcelRegister("8oQ7k", function(module, exports) {

var $5lkNm = parcelRequire("5lkNm");


var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");

const $e50bb482688d43d3$export$3dab4b73b27a9d7e = {
    displayName: 'Confluence Data Center',
    id: 'confluence-dc',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ConfluenceDC,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $5lkNm.ConfluenceIcon), 'Confluence Data Center'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $5lkNm.ConfluenceIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/confluence-dc',
    typeFilterConfig: (()=>{
        const typeFilter = new Map([
            [
                (0, $5PPrc.TypeFilterValueKey).Space,
                {
                    entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Space
                    ]
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Page,
                {
                    entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Page
                    ]
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Blogpost,
                {
                    entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Blogpost
                    ]
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Comment,
                {
                    entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                    subTypes3P: []
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Attachment,
                {
                    entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Archive,
                        (0, $5PPrc.NounSubtypeKey).Audio,
                        (0, $5PPrc.NounSubtypeKey).Code,
                        (0, $5PPrc.NounSubtypeKey).Document,
                        (0, $5PPrc.NounSubtypeKey).Image,
                        (0, $5PPrc.NounSubtypeKey).Pdf,
                        (0, $5PPrc.NounSubtypeKey).Presentation,
                        (0, $5PPrc.NounSubtypeKey).Spreadsheet,
                        (0, $5PPrc.NounSubtypeKey).Video,
                        (0, $5PPrc.NounSubtypeKey).WebPage,
                        (0, $5PPrc.NounSubtypeKey).Other
                    ]
                }
            ]
        ]);
        return typeFilter;
    })(),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'createdBy',
        'content',
        'space',
        'label'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["confluenceDCConfig"] = $e50bb482688d43d3$export$3dab4b73b27a9d7e;

});

parcelRegister("fg2gb", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fDs5L = parcelRequire("fDs5L");

const $ded2e0e354596c76$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Canva,
    icon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaIcon), 'Canva', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaSearchResultIcon), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["canvaConfig"] = $ded2e0e354596c76$export$75e56657ffc0207b;

});

parcelRegister("fDs5L", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $4d4fb88adf934208$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gefM5")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/logo-third-party/canva'
});

const $4d4fb88adf934208$var$LazyCanvaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/icon'
});

const $4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/search-result-icon'
});
const $4d4fb88adf934208$export$3ad1ba1bf426d64a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaIconComponent, null)), $4d4fb88adf934208$var$OfficialIcon, 'small');
const $4d4fb88adf934208$export$ac6bbd7ba99716e3 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent, null)), $4d4fb88adf934208$var$OfficialIcon, 'medium');
module.exports["CanvaIcon"] = $4d4fb88adf934208$export$3ad1ba1bf426d64a;
module.exports["CanvaSearchResultIcon"] = $4d4fb88adf934208$export$ac6bbd7ba99716e3;

});

parcelRegister("gefM5", function(module, exports) {

let $bd0a30ad629dad14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd0a30ad629dad14$var$load("h6ocG").then(()=>parcelRequire('luZrp'));

});

parcelRegister("6LmRM", function(module, exports) {

let $4ec8dea8ab0a1852$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ec8dea8ab0a1852$var$load("bX5IH").then(()=>parcelRequire('agGaQ'));

});

parcelRegister("fauGM", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6MJWz = parcelRequire("6MJWz");

const $9286766965944e9d$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Box,
    icon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxIcon), 'Box', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxSearchResultIcon), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["boxConfig"] = $9286766965944e9d$export$3e7603f097ea326e;

});

parcelRegister("6MJWz", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b99c2662195c467e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9cFmD")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/logo-third-party/box'
});

const $b99c2662195c467e$var$LazyBoxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/icon'
});

const $b99c2662195c467e$var$LazyBoxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/search-result-icon'
});
const $b99c2662195c467e$export$adedf1569d7107de = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxIconComponent, null)), $b99c2662195c467e$var$OfficialIcon, 'small');
const $b99c2662195c467e$export$f9ea3a56c013af54 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxSearchResultIconComponent, null)), $b99c2662195c467e$var$OfficialIcon, 'medium');
module.exports["BoxIcon"] = $b99c2662195c467e$export$adedf1569d7107de;
module.exports["BoxSearchResultIcon"] = $b99c2662195c467e$export$f9ea3a56c013af54;

});

parcelRegister("9cFmD", function(module, exports) {

let $6b35521bfc8d519c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b35521bfc8d519c$var$load("gzrsz").then(()=>parcelRequire('kmQeH'));

});

parcelRegister("1x79L", function(module, exports) {

let $11de6ca258b12afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11de6ca258b12afa$var$load("1KhjS").then(()=>parcelRequire('h43rp'));

});

parcelRegister("bj13p", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8uEzt = parcelRequire("8uEzt");

const $55934d84816643a8$export$ce290ee9e9d9bcd7 = {
    displayName: 'Zoom',
    id: 'zoom',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zoom,
    icon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomIcon), 'Zoom', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomSearchResultIcon), 'Zoom', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zoom',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zoomConfig"] = $55934d84816643a8$export$ce290ee9e9d9bcd7;

});

parcelRegister("8uEzt", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f1c2fec685aced05$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gByso")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/logo-third-party/zoom'
});

const $f1c2fec685aced05$var$LazyZoomIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/icon'
});

const $f1c2fec685aced05$var$LazyZoomSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/search-result-icon'
});
const $f1c2fec685aced05$export$db7393a57b3e6d84 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomIconComponent, null)), $f1c2fec685aced05$var$OfficialIcon, 'small');
const $f1c2fec685aced05$export$5c9fb0638b666051 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomSearchResultIconComponent, null)), $f1c2fec685aced05$var$OfficialIcon, 'medium');
module.exports["ZoomIcon"] = $f1c2fec685aced05$export$db7393a57b3e6d84;
module.exports["ZoomSearchResultIcon"] = $f1c2fec685aced05$export$5c9fb0638b666051;

});

parcelRegister("gByso", function(module, exports) {

let $c16ad47bb10c0bc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c16ad47bb10c0bc2$var$load("b2JtK").then(()=>parcelRequire('30kpZ'));

});

parcelRegister("brtqH", function(module, exports) {

let $85490b746b3dbf90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85490b746b3dbf90$var$load("kxE93").then(()=>parcelRequire('9e80B'));

});

parcelRegister("3VdqU", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cdPZA = parcelRequire("cdPZA");

const $6e80d7674da45b22$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zeplin,
    icon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIcon), 'Zeplin', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIconBorderless), 'Zeplin', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinSearchResultIcon), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zeplinConfig"] = $6e80d7674da45b22$export$d198c255b2b88327;

});

parcelRegister("cdPZA", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $fbd169a88d312a73$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hafBA")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/logo-third-party/zeplin'
});

const $fbd169a88d312a73$var$LazyZeplinIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon'
});

const $fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/search-result-icon'
});

const $fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon-borderless'
});
const $fbd169a88d312a73$export$81c909fcf490b72b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'small');
const $fbd169a88d312a73$export$e3736b5ffc9fcc9e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'medium');
const $fbd169a88d312a73$export$d013f8d99ccc63fb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'xxsmall');
module.exports["ZeplinIcon"] = $fbd169a88d312a73$export$81c909fcf490b72b;
module.exports["ZeplinSearchResultIcon"] = $fbd169a88d312a73$export$e3736b5ffc9fcc9e;
module.exports["ZeplinIconBorderless"] = $fbd169a88d312a73$export$d013f8d99ccc63fb;

});

parcelRegister("hafBA", function(module, exports) {

let $c7ef79bb151dcf06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7ef79bb151dcf06$var$load("czpIO").then(()=>parcelRequire('ktsV4'));

});

parcelRegister("gAgWa", function(module, exports) {

let $c12d257c331759c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c12d257c331759c7$var$load("dBdPR").then(()=>parcelRequire('cNG5i'));

});

parcelRegister("iN1Vs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4Bw3O = parcelRequire("4Bw3O");

const $b9ccdad19edf777f$var$getServiceNowTypeFilterConfig = ()=>{
    const config = new Map();
    if ((0, $iDrrr.fg)('rovo_fps_servicenow_type_filter_subtypes')) {
        config.set((0, $5PPrc.TypeFilterValueKey).Incident, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Incident
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).CatalogItem, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).CatalogItem
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).RequestedItem, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).RequestedItem
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).Epic, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Epic
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).KnowledgeArticle, {
            entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).KnowledgeArticle
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).NewsArticle, {
            entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).NewsArticle
            ]
        });
    } else config.set((0, $5PPrc.TypeFilterValueKey).WorkItem, {
        entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('enable_rovo_search_comment_filter_for_servicenow')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('enable_rovo_search_project_filter_for_servicenow')) {
        config.set((0, $5PPrc.TypeFilterValueKey).Project, {
            entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Project
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).Demand, {
            entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Demand
            ]
        });
    }
    return config;
};
const $b9ccdad19edf777f$export$d60233309c5c50ab = {
    displayName: 'ServiceNow',
    id: 'servicenow',
    icon: (0, $i52Hf.get3PLogo)((0, $4Bw3O.ServiceNowIcon), 'ServiceNow', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).ServiceNow,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4Bw3O.ServiceNowSearchResultIcon), 'ServiceNow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/servicenow',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    get typeFilterConfig () {
        return $b9ccdad19edf777f$var$getServiceNowTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["serviceNowConfig"] = $b9ccdad19edf777f$export$d60233309c5c50ab;

});

parcelRegister("4Bw3O", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ef61d391b7057faa$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ln1N")).then((m)=>m.ServiceNowIcon), {
    moduleId: '@atlassian/logo-third-party/servicenow'
});

const $ef61d391b7057faa$var$LazyServiceNowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8760j")).then((m)=>m.ServiceNowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/servicenow/icon'
});

const $ef61d391b7057faa$var$LazyServiceNowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8760j")).then((m)=>m.ServiceNowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/servicenow/search-result-icon'
});
const $ef61d391b7057faa$export$829928eabc615ce1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef61d391b7057faa$var$LazyServiceNowIconComponent, null)), $ef61d391b7057faa$var$OfficialIcon, 'small');
const $ef61d391b7057faa$export$4b2cdd8d303d18d0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef61d391b7057faa$var$LazyServiceNowSearchResultIconComponent, null)), $ef61d391b7057faa$var$OfficialIcon, 'medium');
module.exports["ServiceNowIcon"] = $ef61d391b7057faa$export$829928eabc615ce1;
module.exports["ServiceNowSearchResultIcon"] = $ef61d391b7057faa$export$4b2cdd8d303d18d0;

});

parcelRegister("8ln1N", function(module, exports) {

let $613225c42370e9e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $613225c42370e9e7$var$load("3wkDm").then(()=>parcelRequire('emNQw'));

});

parcelRegister("8760j", function(module, exports) {

let $5e83a277194a08ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e83a277194a08ff$var$load("6vNYv").then(()=>parcelRequire('3QvRx'));

});

parcelRegister("fA9zj", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ldmHj = parcelRequire("ldmHj");

const $95e57b030e0f8dca$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceIcon), 'Freshservice', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Freshservice,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceSearchResultIcon), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["freshserviceConfig"] = $95e57b030e0f8dca$export$8120804698f632ae;

});

parcelRegister("ldmHj", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $45beef96d43b57ec$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("d3rS9")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/logo-third-party/freshservice'
});

const $45beef96d43b57ec$var$LazyFreshserviceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/icon'
});

const $45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/search-result-icon'
});
const $45beef96d43b57ec$export$327de5bc0476c8b8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceIconComponent, null)), $45beef96d43b57ec$var$OfficialIcon, 'small');
const $45beef96d43b57ec$export$afb7a1d2b1e9186c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent, null)), $45beef96d43b57ec$var$OfficialIcon, 'medium');
module.exports["FreshserviceIcon"] = $45beef96d43b57ec$export$327de5bc0476c8b8;
module.exports["FreshserviceSearchResultIcon"] = $45beef96d43b57ec$export$afb7a1d2b1e9186c;

});

parcelRegister("d3rS9", function(module, exports) {

let $98112d0f9100e3e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98112d0f9100e3e9$var$load("1TO8o").then(()=>parcelRequire('eVhsQ'));

});

parcelRegister("jwajS", function(module, exports) {

let $e35902b647be50d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e35902b647be50d9$var$load("cgVYM").then(()=>parcelRequire('byKTU'));

});

parcelRegister("iTxTm", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jHpbI = parcelRequire("jHpbI");

const $fe7cdbf0eb82d212$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PowerBI,
    icon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIcon), 'PowerBI', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIconBorderless), 'PowerBI', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBISearchResultIcon), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["powerBIConfig"] = $fe7cdbf0eb82d212$export$b883b80d867cc715;

});

parcelRegister("jHpbI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b89a7a27b28a6f7f$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cZjn1")).then((m)=>m.MicrosoftPowerBIIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-power-bi'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBISearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless'
});
const $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'small');
const $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'medium');
const $b89a7a27b28a6f7f$export$77c3c6e8d16b3669 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'xxsmall');
module.exports["PowerBIIcon"] = $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7;
module.exports["PowerBISearchResultIcon"] = $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09;
module.exports["PowerBIIconBorderless"] = $b89a7a27b28a6f7f$export$77c3c6e8d16b3669;

});

parcelRegister("cZjn1", function(module, exports) {

let $974a3518074827aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $974a3518074827aa$var$load("eLocl").then(()=>parcelRequire('a71rl'));

});

parcelRegister("gLSjb", function(module, exports) {

let $c35b29a88fc41c42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c35b29a88fc41c42$var$load("7yeiN").then(()=>parcelRequire('7NK6P'));

});

parcelRegister("5pWqV", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iq3xJ = parcelRequire("iq3xJ");

const $cec4d02f64d13f8c$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ClickUp,
    icon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIcon), 'ClickUp', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIconBorderless), 'ClickUp', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpSearchResultIcon), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["clickUpConfig"] = $cec4d02f64d13f8c$export$7ef79ba9bf00ce19;

});

parcelRegister("iq3xJ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $530f12575ecdabb5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $530f12575ecdabb5$var$LazyClickUpIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon'
});

const $530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/search-result-icon'
});

const $530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon-borderless'
});
const $530f12575ecdabb5$export$592b235c95c5fb2b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'small');
const $530f12575ecdabb5$export$7ca2508a62493599 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'medium');
const $530f12575ecdabb5$export$d29fdfa1300ec8ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'xxsmall');
module.exports["ClickUpIcon"] = $530f12575ecdabb5$export$592b235c95c5fb2b;
module.exports["ClickUpSearchResultIcon"] = $530f12575ecdabb5$export$7ca2508a62493599;
module.exports["ClickUpIconBorderless"] = $530f12575ecdabb5$export$d29fdfa1300ec8ae;

});

parcelRegister("7sd0z", function(module, exports) {

let $56d53d15de41d2d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d53d15de41d2d2$var$load("lXXxc").then(()=>parcelRequire('el36N'));

});

parcelRegister("eZzOO", function(module, exports) {

let $aea28c0308a21713$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aea28c0308a21713$var$load("Wo3LI").then(()=>parcelRequire('aFqIo'));

});

parcelRegister("juuLe", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8DGA8 = parcelRequire("8DGA8");

const $bf887cabcde61381$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Amplitude,
    icon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeIcon), 'Amplitude', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeSearchResultIcon), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["amplitudeConfig"] = $bf887cabcde61381$export$a0702b571a9392d4;

});

parcelRegister("8DGA8", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $1c1e864948fda48c$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fLb3r")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/logo-third-party/amplitude'
});

const $1c1e864948fda48c$var$LazyAmplitudeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/icon'
});

const $1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/search-result-icon'
});
const $1c1e864948fda48c$export$5e013c7991ef7bd0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeIconComponent, null)), $1c1e864948fda48c$var$OfficialIcon, 'small');
const $1c1e864948fda48c$export$49b3130ea0e9d6dd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent, null)), $1c1e864948fda48c$var$OfficialIcon, 'medium');
module.exports["AmplitudeIcon"] = $1c1e864948fda48c$export$5e013c7991ef7bd0;
module.exports["AmplitudeSearchResultIcon"] = $1c1e864948fda48c$export$49b3130ea0e9d6dd;

});

parcelRegister("fLb3r", function(module, exports) {

let $b793d1fa98c7296a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b793d1fa98c7296a$var$load("7ZEab").then(()=>parcelRequire('aIs8c'));

});

parcelRegister("1Lj2x", function(module, exports) {

let $1488f32e8fa7fe12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1488f32e8fa7fe12$var$load("aHKXM").then(()=>parcelRequire('7uWoZ'));

});

parcelRegister("3juV6", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9PLia = parcelRequire("9PLia");

const $92674268e4049146$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Stripe,
    icon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeIcon), 'Stripe', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeSearchResultIcon), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["stripeConfig"] = $92674268e4049146$export$3be693d67bbce82;

});

parcelRegister("9PLia", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $33b6aea29cf3117b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4qEUM")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/logo-third-party/stripe'
});

const $33b6aea29cf3117b$var$LazyStripeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/icon'
});

const $33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/search-result-icon'
});
const $33b6aea29cf3117b$export$86ab8f6f2448222e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeIconComponent, null)), $33b6aea29cf3117b$var$OfficialIcon, 'small');
const $33b6aea29cf3117b$export$efbbc3acb0731d93 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent, null)), $33b6aea29cf3117b$var$OfficialIcon, 'medium');
module.exports["StripeIcon"] = $33b6aea29cf3117b$export$86ab8f6f2448222e;
module.exports["StripeSearchResultIcon"] = $33b6aea29cf3117b$export$efbbc3acb0731d93;

});

parcelRegister("4qEUM", function(module, exports) {

let $339953fb1179e69d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $339953fb1179e69d$var$load("iZ7w3").then(()=>parcelRequire('fc8zu'));

});

parcelRegister("cp8O6", function(module, exports) {

let $907ea6b91679f987$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $907ea6b91679f987$var$load("12xPP").then(()=>parcelRequire('5eELb'));

});

parcelRegister("hIDj1", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $01lrE = parcelRequire("01lrE");

const $9077aa6f5e17fbbd$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeXD,
    icon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDIcon), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDSearchResultIcon), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeXDConfig"] = $9077aa6f5e17fbbd$export$e69f90b2aa757835;

});

parcelRegister("01lrE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9542dedcb7e547d5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cD7ku")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/logo-third-party/adobexd'
});

const $9542dedcb7e547d5$var$LazyAdobeXDIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon'
});

const $9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon'
});
const $9542dedcb7e547d5$export$be8cba599441db6e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDIconComponent, null)), $9542dedcb7e547d5$var$OfficialIcon, 'small');
const $9542dedcb7e547d5$export$145a936ff16d9011 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent, null)), $9542dedcb7e547d5$var$OfficialIcon, 'medium');
module.exports["AdobeXDIcon"] = $9542dedcb7e547d5$export$be8cba599441db6e;
module.exports["AdobeXDSearchResultIcon"] = $9542dedcb7e547d5$export$145a936ff16d9011;

});

parcelRegister("cD7ku", function(module, exports) {

let $931ed00f35da9582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $931ed00f35da9582$var$load("bPHKE").then(()=>parcelRequire('8E3YW'));

});

parcelRegister("6qisw", function(module, exports) {

let $4ad37d5fd1b448bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ad37d5fd1b448bd$var$load("jIck0").then(()=>parcelRequire('1M0ll'));

});

parcelRegister("7WW80", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9DXSY = parcelRequire("9DXSY");

const $c8bb031355bf837b$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Aha,
    icon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaIcon), 'Aha', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaSearchResultIcon), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["ahaConfig"] = $c8bb031355bf837b$export$ad976bfe08240460;

});

parcelRegister("9DXSY", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2d91c1380dbfeb61$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ajWin")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/logo-third-party/aha'
});

const $2d91c1380dbfeb61$var$LazyAhaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/icon'
});

const $2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon'
});
const $2d91c1380dbfeb61$export$f28fe6c5ebff8c30 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaIconComponent, null)), $2d91c1380dbfeb61$var$OfficialIcon, 'small');
const $2d91c1380dbfeb61$export$7dd76757b7d2d978 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent, null)), $2d91c1380dbfeb61$var$OfficialIcon, 'medium');
module.exports["AhaIcon"] = $2d91c1380dbfeb61$export$f28fe6c5ebff8c30;
module.exports["AhaSearchResultIcon"] = $2d91c1380dbfeb61$export$7dd76757b7d2d978;

});

parcelRegister("ajWin", function(module, exports) {

let $7838e6019e3525a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7838e6019e3525a7$var$load("jX4pB").then(()=>parcelRequire('4fs5C'));

});

parcelRegister("eC0Ay", function(module, exports) {

let $aa35122a7f0ad582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa35122a7f0ad582$var$load("crPYr").then(()=>parcelRequire('52Csx'));

});

parcelRegister("au9jr", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $exlh6 = parcelRequire("exlh6");

const $5a9c1a558ebaa3a8$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeSign,
    icon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignIcon), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignSearchResultIcon), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeSignConfig"] = $5a9c1a558ebaa3a8$export$8130889f372e8ca5;

});

parcelRegister("exlh6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $0790bbd11d84640d$var$LazyAdobeSignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/icon'
});

const $0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/search-result-icon'
});
const $0790bbd11d84640d$export$600af2172b0f5fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
const $0790bbd11d84640d$export$9efd1df023dc9339 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
module.exports["AdobeSignIcon"] = $0790bbd11d84640d$export$600af2172b0f5fb;
module.exports["AdobeSignSearchResultIcon"] = $0790bbd11d84640d$export$9efd1df023dc9339;

});

parcelRegister("71Q5J", function(module, exports) {

let $51e108abf4f92495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51e108abf4f92495$var$load("6hjEN").then(()=>parcelRequire('8lSkY'));

});

parcelRegister("diJOH", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fgzey = parcelRequire("fgzey");

const $4cab0849efa124dd$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Mural,
    icon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIcon), 'Mural', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIconBorderless), 'Mural', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralSearchResultIcon), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["muralConfig"] = $4cab0849efa124dd$export$8855f5ba0dd32fb9;

});

parcelRegister("fgzey", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $a97a3de67fb67ec6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("e7Ot5")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/logo-third-party/mural'
});

const $a97a3de67fb67ec6$var$LazyMuralIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon'
});

const $a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/search-result-icon'
});

const $a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon-borderless'
});
const $a97a3de67fb67ec6$export$807a21e0dcf114c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'small');
const $a97a3de67fb67ec6$export$930cc976c0fd31d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'medium');
const $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'xxsmall');
module.exports["MuralIcon"] = $a97a3de67fb67ec6$export$807a21e0dcf114c4;
module.exports["MuralSearchResultIcon"] = $a97a3de67fb67ec6$export$930cc976c0fd31d6;
module.exports["MuralIconBorderless"] = $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a;

});

parcelRegister("e7Ot5", function(module, exports) {

let $a488de0f6b76266c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a488de0f6b76266c$var$load("bHGdS").then(()=>parcelRequire('1YPcS'));

});

parcelRegister("fR633", function(module, exports) {

let $b8b07f4942fa03b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8b07f4942fa03b7$var$load("hZppl").then(()=>parcelRequire('9pV7D'));

});

parcelRegister("5bQLl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9tcvD = parcelRequire("9tcvD");

const $1ec69a9c30a99d71$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Webex,
    icon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIcon), 'Webex', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIconBorderless), 'Webex', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexSearchResultIcon), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["webexConfig"] = $1ec69a9c30a99d71$export$57d2eef9725d4993;

});

parcelRegister("9tcvD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $df7a27f90b6b2c5e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("150aL")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/logo-third-party/webex'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/search-result-icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon-borderless'
});
const $df7a27f90b6b2c5e$export$4079343fb47e7f0d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'small');
const $df7a27f90b6b2c5e$export$37506c98e5c4eabb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'medium');
const $df7a27f90b6b2c5e$export$92866e6fe777cbf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'xxsmall');
module.exports["WebexIcon"] = $df7a27f90b6b2c5e$export$4079343fb47e7f0d;
module.exports["WebexSearchResultIcon"] = $df7a27f90b6b2c5e$export$37506c98e5c4eabb;
module.exports["WebexIconBorderless"] = $df7a27f90b6b2c5e$export$92866e6fe777cbf9;

});

parcelRegister("150aL", function(module, exports) {

let $0c96645c4f95dd26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c96645c4f95dd26$var$load("hpN8h").then(()=>parcelRequire('l8EZo'));

});

parcelRegister("lSDFq", function(module, exports) {

let $fedd6930306be96d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fedd6930306be96d$var$load("cbO8L").then(()=>parcelRequire('4o0Z8'));

});

parcelRegister("dVIA3", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $566qE = parcelRequire("566qE");

const $f809cfee2fd3adf4$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Todoist,
    icon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistIcon), 'Todoist', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistSearchResultIcon), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["todoistConfig"] = $f809cfee2fd3adf4$export$2ece5664272d405b;

});

parcelRegister("566qE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $7f696030f35b1bfe$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("87oFm")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/logo-third-party/todoist'
});

const $7f696030f35b1bfe$var$LazyTodoistIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/icon'
});

const $7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/search-result-icon'
});
const $7f696030f35b1bfe$export$e5f255e151507cba = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistIconComponent, null)), $7f696030f35b1bfe$var$OfficialIcon, 'small');
const $7f696030f35b1bfe$export$c7baa9df7dbe4b13 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent, null)), $7f696030f35b1bfe$var$OfficialIcon, 'medium');
module.exports["TodoistIcon"] = $7f696030f35b1bfe$export$e5f255e151507cba;
module.exports["TodoistSearchResultIcon"] = $7f696030f35b1bfe$export$c7baa9df7dbe4b13;

});

parcelRegister("87oFm", function(module, exports) {

let $5e921c539822847e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e921c539822847e$var$load("el4Li").then(()=>parcelRequire('irDM6'));

});

parcelRegister("7r1J2", function(module, exports) {

let $569c64a902747f35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $569c64a902747f35$var$load("kriZK").then(()=>parcelRequire('bkDWX'));

});

parcelRegister("emznk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cgpdn = parcelRequire("cgpdn");

const $aedb00e010a8a347$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PagerDuty,
    icon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutyIcon), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutySearchResultIcon), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pagerDutyConfig"] = $aedb00e010a8a347$export$cc8a555111f14137;

});

parcelRegister("cgpdn", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $82cf772d0622b4e8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3oqfa")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/logo-third-party/pager-duty'
});

const $82cf772d0622b4e8$var$LazyPagerDutyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon'
});

const $82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon'
});
const $82cf772d0622b4e8$export$e9a3fd43f9d4bddc = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutyIconComponent, null)), $82cf772d0622b4e8$var$OfficialIcon, 'small');
const $82cf772d0622b4e8$export$494d5ec19d75a736 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent, null)), $82cf772d0622b4e8$var$OfficialIcon, 'medium');
module.exports["PagerDutyIcon"] = $82cf772d0622b4e8$export$e9a3fd43f9d4bddc;
module.exports["PagerDutySearchResultIcon"] = $82cf772d0622b4e8$export$494d5ec19d75a736;

});

parcelRegister("3oqfa", function(module, exports) {

let $2787f86fb8a1796c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2787f86fb8a1796c$var$load("3BBsj").then(()=>parcelRequire('hhFQM'));

});

parcelRegister("bUXcS", function(module, exports) {

let $8ad2d9e55360e7ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ad2d9e55360e7ef$var$load("i66KR").then(()=>parcelRequire('BKXay'));

});

parcelRegister("fMCQp", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4dY8b = parcelRequire("4dY8b");

const $3e19c412c5468840$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Pipedrive,
    icon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveIcon), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveSearchResultIcon), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pipedriveConfig"] = $3e19c412c5468840$export$9441b0ee1f92e710;

});

parcelRegister("4dY8b", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $37fe8e692e6a8fbb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a0UGh")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/logo-third-party/pipedrive'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/icon'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/search-result-icon'
});
const $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveIconComponent, null)), $37fe8e692e6a8fbb$var$OfficialIcon, 'small');
const $37fe8e692e6a8fbb$export$18970dea61783916 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent, null)), $37fe8e692e6a8fbb$var$OfficialIcon, 'medium');
module.exports["PipedriveIcon"] = $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1;
module.exports["PipedriveSearchResultIcon"] = $37fe8e692e6a8fbb$export$18970dea61783916;

});

parcelRegister("a0UGh", function(module, exports) {

let $01e1a4a1772b5e57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01e1a4a1772b5e57$var$load("27hzN").then(()=>parcelRequire('7RZ3z'));

});

parcelRegister("1NJ45", function(module, exports) {

let $14fd53058867bdc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14fd53058867bdc5$var$load("1Vgyr").then(()=>parcelRequire('7n163'));

});

parcelRegister("cdiu6", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $i3YNQ = parcelRequire("i3YNQ");

const $cc73151629925938$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Hubspot,
    icon: (0, $i52Hf.get3PLogo)((0, $i3YNQ.HubSpotFilterIcon), 'HubSpot', 'medium'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromGlyph)((0, $i3YNQ.HubSpotIcon), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["hubSpotConfig"] = $cc73151629925938$export$ba5f4c654d743419;

});

parcelRegister("i3YNQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2057a2845d392fbb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $2057a2845d392fbb$var$LazyHubSpotFilterIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotFilterIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/icon'
});

const $2057a2845d392fbb$var$LazyHubSpotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/search-result-icon'
});
const $2057a2845d392fbb$export$bee6964e6c60da93 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotFilterIconComponent, null)), $2057a2845d392fbb$var$OfficialIcon, 'small');
const $2057a2845d392fbb$export$c9a6a66ee7acc43a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotIconComponent, null)), $2057a2845d392fbb$var$OfficialIcon, 'medium');
module.exports["HubSpotFilterIcon"] = $2057a2845d392fbb$export$bee6964e6c60da93;
module.exports["HubSpotIcon"] = $2057a2845d392fbb$export$c9a6a66ee7acc43a;

});

parcelRegister("kQYlp", function(module, exports) {

let $f2e7791a0e64cf65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2e7791a0e64cf65$var$load("5tNoP").then(()=>parcelRequire('7v0Y0'));

});

parcelRegister("iQk0M", function(module, exports) {

let $db7c9b3ae5d37f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db7c9b3ae5d37f01$var$load("jjiWX").then(()=>parcelRequire('7iwl3'));

});

parcelRegister("8djpu", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1IKTt = parcelRequire("1IKTt");

const $a36ea8dac5de07a0$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dovetail,
    icon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailIcon), 'Dovetail', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailSearchResultIcon), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dovetailConfig"] = $a36ea8dac5de07a0$export$74bb7abed969b4a3;

});

parcelRegister("1IKTt", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2f56e48e9ad9c3ed$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jZqjP")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/logo-third-party/dovetail'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/icon'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/search-result-icon'
});
const $2f56e48e9ad9c3ed$export$e67ec9178da81ba8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailIconComponent, null)), $2f56e48e9ad9c3ed$var$OfficialIcon, 'small');
const $2f56e48e9ad9c3ed$export$ba101884e6c20332 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent, null)), $2f56e48e9ad9c3ed$var$OfficialIcon, 'medium');
module.exports["DovetailIcon"] = $2f56e48e9ad9c3ed$export$e67ec9178da81ba8;
module.exports["DovetailSearchResultIcon"] = $2f56e48e9ad9c3ed$export$ba101884e6c20332;

});

parcelRegister("jZqjP", function(module, exports) {

let $e8d8212c9bf885b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8d8212c9bf885b2$var$load("j30YZ").then(()=>parcelRequire('63pax'));

});

parcelRegister("1agKU", function(module, exports) {

let $0d93b8f44ef4ee77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d93b8f44ef4ee77$var$load("lX1Po").then(()=>parcelRequire('2C7nj'));

});

parcelRegister("3P9fk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cGNUU = parcelRequire("cGNUU");

const $c668170e147f45a4$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
    icon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklyIcon), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklySearchResultIcon), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["launchDarklyConfig"] = $c668170e147f45a4$export$e45ddd51efe4cb0c;

});

parcelRegister("cGNUU", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ef4ce76b17680270$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7M0yS")).then((m)=>m.LaunchdarklyIcon), {
    moduleId: '@atlassian/logo-third-party/launchdarkly'
});

const $ef4ce76b17680270$var$LazyLaunchDarklyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/icon'
});

const $ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/search-result-icon'
});
const $ef4ce76b17680270$export$68470e68dec0bc46 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklyIconComponent, null)), $ef4ce76b17680270$var$OfficialIcon, 'small');
const $ef4ce76b17680270$export$66f000bb4bcf5fcd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent, null)), $ef4ce76b17680270$var$OfficialIcon, 'medium');
module.exports["LaunchDarklyIcon"] = $ef4ce76b17680270$export$68470e68dec0bc46;
module.exports["LaunchDarklySearchResultIcon"] = $ef4ce76b17680270$export$66f000bb4bcf5fcd;

});

parcelRegister("7M0yS", function(module, exports) {

let $5a8d739df515d449$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a8d739df515d449$var$load("jdLOX").then(()=>parcelRequire('d9BBd'));

});

parcelRegister("ezxxX", function(module, exports) {

let $a9be5b4384d2d964$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9be5b4384d2d964$var$load("fK6ul").then(()=>parcelRequire('26kgz'));

});

parcelRegister("lPRuX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $f3t7x = parcelRequire("f3t7x");


var $l2DTy = parcelRequire("l2DTy");


var $kxWyf = parcelRequire("kxWyf");


var $5ET0n = parcelRequire("5ET0n");


var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $dAioJ = parcelRequire("dAioJ");


var $958CL = parcelRequire("958CL");


var $kFLxH = parcelRequire("kFLxH");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cP5WD = parcelRequire("cP5WD");

const $6d43d8ef7378751b$var$getSalesforce3PTypeFilterConfig = ()=>{
    const config = new Map();
    // Entries are ordered alphabetically by display label.
    config.set((0, $5PPrc.TypeFilterValueKey).Campaign, {
        entities3P: [
            ...(0, $l2DTy.DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Case, {
        entities3P: [
            ...(0, $kxWyf.DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-calendar-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Calendar, {
        entities3P: [
            ...(0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).CustomerContact, {
        entities3P: [
            ...(0, $5ET0n.DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).CustomerOrg, {
        entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Deal, {
        entities3P: [
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
            ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Deal
        ]
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-document-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-lead-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Lead, {
        entities3P: [
            ...(0, $958CL.DEFAULT_CLOUD_GRAPH_LEAD_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-work-item-noun')) config.set((0, $5PPrc.TypeFilterValueKey).WorkItem, {
        entities3P: [
            ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    return config;
};
const $6d43d8ef7378751b$export$68b7906270c63e2d = {
    displayName: 'Salesforce',
    id: 'salesforce',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Salesforce,
    icon: (0, $i52Hf.get3PLogo)((0, $cP5WD.SalesforceIcon), 'Salesforce', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cP5WD.SalesforceIconBorderless), 'Salesforce', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cP5WD.SalesforceSearchResultIcon), 'Salesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/salesforce',
    // Use getters to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    get typeFilterConfig () {
        return $6d43d8ef7378751b$var$getSalesforce3PTypeFilterConfig();
    },
    get filters () {
        const base = [
            'lastUpdated',
            'onlyTitleMatch',
            'lastUpdatedBy',
            'createdBy',
            'owner',
            'opportunityStatus',
            'closeDate'
        ];
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter') || (0, $iDrrr.fg)('rovo-studio-3p-ux-salesforce-dynamic-stage-filter')) base.push('salesforceStage');
        base.push('campaignStatus');
        base.push('caseStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-document-status-filter')) base.push('documentStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-calendar-type-filter')) base.push('calendarType');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-sf-lead-status-filter')) base.push('leadStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-task-status-filter')) base.push('taskStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-task-type-filter')) base.push('taskType');
        return base;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["salesforceConfig"] = $6d43d8ef7378751b$export$68b7906270c63e2d;

});

parcelRegister("958CL", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $33c1f01c191ac084$export$485669874d5d2ec4 = [
    'ati:cloud:graph:lead'
];
module.exports["DEFAULT_CLOUD_GRAPH_LEAD_ENTITY_ATI"] = $33c1f01c191ac084$export$485669874d5d2ec4;

});

parcelRegister("cP5WD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $099630e1101e7950$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1iIDp")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/logo-third-party/salesforce'
});

const $099630e1101e7950$var$LazySalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7QiUr")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/salesforce/icon'
});

const $099630e1101e7950$var$LazySalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7QiUr")).then((m)=>m.SalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/salesforce/search-result-icon'
});

const $099630e1101e7950$var$LazySalesforceIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7QiUr")).then((m)=>m.SalesforceIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/salesforce/icon-borderless'
});
const $099630e1101e7950$export$89e1f2a7c57f2a4d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceIconComponent, null)), $099630e1101e7950$var$OfficialIcon, 'small');
const $099630e1101e7950$export$1c85788b02a4bdef = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceSearchResultIconComponent, null)), $099630e1101e7950$var$OfficialIcon, 'medium');
const $099630e1101e7950$export$2ca8c87c1acb4a50 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceIconBorderlessComponent, null)), $099630e1101e7950$var$OfficialIcon, 'xxsmall');
module.exports["SalesforceIcon"] = $099630e1101e7950$export$89e1f2a7c57f2a4d;
module.exports["SalesforceSearchResultIcon"] = $099630e1101e7950$export$1c85788b02a4bdef;
module.exports["SalesforceIconBorderless"] = $099630e1101e7950$export$2ca8c87c1acb4a50;

});

parcelRegister("1iIDp", function(module, exports) {

let $0f2a18683fc3a657$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f2a18683fc3a657$var$load("8nWJ9").then(()=>parcelRequire('gwpcy'));

});

parcelRegister("7QiUr", function(module, exports) {

let $5b5c0ebfe669333a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b5c0ebfe669333a$var$load("7YLBK").then(()=>parcelRequire('wQghi'));

});

parcelRegister("2zNcl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gZuUC = parcelRequire("gZuUC");

const $b44f335e0add65f2$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sentry,
    icon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentryIcon), 'Sentry', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentrySearchResultIcon), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sentryConfig"] = $b44f335e0add65f2$export$6c52693ff10aea16;

});

parcelRegister("gZuUC", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2e1e358b3dafc32e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6PzNO")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/logo-third-party/sentry'
});

const $2e1e358b3dafc32e$var$LazySentryIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/icon'
});

const $2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentrySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/search-result-icon'
});
const $2e1e358b3dafc32e$export$ddeafef64c08610e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentryIconComponent, null)), $2e1e358b3dafc32e$var$OfficialIcon, 'small');
const $2e1e358b3dafc32e$export$18b7ca5aa35613ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent, null)), $2e1e358b3dafc32e$var$OfficialIcon, 'medium');
module.exports["SentryIcon"] = $2e1e358b3dafc32e$export$ddeafef64c08610e;
module.exports["SentrySearchResultIcon"] = $2e1e358b3dafc32e$export$18b7ca5aa35613ec;

});

parcelRegister("6PzNO", function(module, exports) {

let $4f9347196859d88a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f9347196859d88a$var$load("kxaOw").then(()=>parcelRequire('fscxt'));

});

parcelRegister("5Kyst", function(module, exports) {

let $42fbfa53463ffb37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42fbfa53463ffb37$var$load("2wWLi").then(()=>parcelRequire('8cuRQ'));

});

parcelRegister("h8Js2", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iS3Tu = parcelRequire("iS3Tu");

const $1575c63b0570ab84$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $iS3Tu.GitbookIcon), 'GitBook'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitbook,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iS3Tu.GitbookSearchResultIcon), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>true
};
module.exports["gitbookConfig"] = $1575c63b0570ab84$export$49c4b548f63d5a90;

});

parcelRegister("9Om9G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8dCVx = parcelRequire("8dCVx");

const $e51655ee0504dbb7$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $8dCVx.AWSS3Icon), 'Amazon Web Services S3'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).AWSS3,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8dCVx.AWSS3SearchResultIcon), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};
module.exports["awss3Config"] = $e51655ee0504dbb7$export$7a257877f5f8c5de;

});

parcelRegister("8dCVx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3Icon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/icon'
});

const $8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3SearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/search-result-icon'
});
const $8d6fe8b599ff2fd4$export$abf71a44e930800c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
const $8d6fe8b599ff2fd4$export$30c777236008d219 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
module.exports["AWSS3Icon"] = $8d6fe8b599ff2fd4$export$abf71a44e930800c;
module.exports["AWSS3SearchResultIcon"] = $8d6fe8b599ff2fd4$export$30c777236008d219;

});

parcelRegister("lyZyY", function(module, exports) {

let $fb2c871e4dc34770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb2c871e4dc34770$var$load("dy0Fn").then(()=>parcelRequire('2tcCJ'));

});

parcelRegister("kiNtZ", function(module, exports) {

var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4mBqr = parcelRequire("4mBqr");

const $436740c22c009a9f$export$a9b5a82aefd10fde = {
    displayName: 'Databricks',
    id: 'databricks',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Databricks,
    icon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksIcon), 'Databricks', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksSearchResultIcon), 'Databricks', 'large'),
    integrationAri: 'ari:cloud:platform::integration/databricks',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["databricksConfig"] = $436740c22c009a9f$export$a9b5a82aefd10fde;

});

parcelRegister("4mBqr", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $4005a63328b92542$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5aTt1")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/logo-third-party/databricks'
});

const $4005a63328b92542$var$LazyDatabricksIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/icon'
});

const $4005a63328b92542$var$LazyDatabricksSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/search-result-icon'
});
const $4005a63328b92542$export$d86876f5e6aac5e0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksIconComponent, null)), $4005a63328b92542$var$OfficialIcon, 'small');
const $4005a63328b92542$export$efd3770b613bb37b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksSearchResultIconComponent, null)), $4005a63328b92542$var$OfficialIcon, 'medium');
module.exports["DatabricksIcon"] = $4005a63328b92542$export$d86876f5e6aac5e0;
module.exports["DatabricksSearchResultIcon"] = $4005a63328b92542$export$efd3770b613bb37b;

});

parcelRegister("5aTt1", function(module, exports) {

let $3c48e987dbae287f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c48e987dbae287f$var$load("ltjdT").then(()=>parcelRequire('6t9s3'));

});

parcelRegister("aug3w", function(module, exports) {

let $7a292913e24060be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a292913e24060be$var$load("cSRnY").then(()=>parcelRequire('8CpxA'));

});

parcelRegister("1RpaO", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bcqy7 = parcelRequire("bcqy7");

const $2080cd553843d21e$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $2080cd553843d21e$export$208b563484d68ba9;

});

parcelRegister("bcqy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/icon'
});

const $93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/search-result-icon'
});
const $93f1018b38c58e9f$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
const $93f1018b38c58e9f$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $93f1018b38c58e9f$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $93f1018b38c58e9f$export$bd28886795da63ae;

});

parcelRegister("bVu7g", function(module, exports) {

let $8aec6105bf7a443e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8aec6105bf7a443e$var$load("ePl2b").then(()=>parcelRequire('kel29'));

});

parcelRegister("jENKA", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eRwR0 = parcelRequire("eRwR0");

const $939217ca713606ec$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
    icon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $939217ca713606ec$export$208b563484d68ba9;

});

parcelRegister("eRwR0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/icon'
});

const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/search-result-icon'
});
const $ecc3a7c114d137a3$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
const $ecc3a7c114d137a3$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $ecc3a7c114d137a3$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $ecc3a7c114d137a3$export$bd28886795da63ae;

});

parcelRegister("4m2wQ", function(module, exports) {

let $32bb2da49487064c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32bb2da49487064c$var$load("5bnED").then(()=>parcelRequire('gKTnp'));

});

parcelRegister("j34lg", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $hareu = parcelRequire("hareu");


var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g3p3u = parcelRequire("g3p3u");

const $6b1eab62b600e75b$export$6bbd9bc3bcb111b9 = {
    displayName: 'Scroll Sites by k15t',
    id: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesDev,
    icon: (0, $i52Hf.get3PLogo)((0, $g3p3u.ForgeK15tScrollSitesIcon), 'ForgeK15tScrollSites', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g3p3u.ForgeK15tScrollSitesSearchResultIcon), 'ForgeK15tScrollSites', 'large'),
    integrationAri: 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeK15tScrollSitesConfig"] = $6b1eab62b600e75b$export$6bbd9bc3bcb111b9;

});

parcelRegister("g3p3u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $330263601da56d87$var$LazyForgeK15tScrollSitesIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("b59ND")).then((m)=>m.ForgeK15tScrollSitesIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-dev/icon'
});

const $330263601da56d87$var$LazyForgeK15tScrollSitesSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("b59ND")).then((m)=>m.ForgeK15tScrollSitesSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-dev/search-result-icon'
});
const $330263601da56d87$export$317be388f2737846 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesIconComponent, null));
const $330263601da56d87$export$62ea9658fc6624da = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
module.exports["ForgeK15tScrollSitesIcon"] = $330263601da56d87$export$317be388f2737846;
module.exports["ForgeK15tScrollSitesSearchResultIcon"] = $330263601da56d87$export$62ea9658fc6624da;

});

parcelRegister("b59ND", function(module, exports) {

let $8117c359d2039e56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8117c359d2039e56$var$load("5tOei").then(()=>parcelRequire('aplI2'));

});

parcelRegister("in2Pi", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $hareu = parcelRequire("hareu");


var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g149F = parcelRequire("g149F");

const $7ddf546c1d92443d$export$6bbd9bc3bcb111b9 = {
    displayName: 'Scroll Sites by k15t',
    id: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesProd,
    icon: (0, $i52Hf.get3PLogo)((0, $g149F.ForgeK15tScrollSitesIcon), 'ForgeK15tScrollSites', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g149F.ForgeK15tScrollSitesSearchResultIcon), 'ForgeK15tScrollSites', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeK15tScrollSitesConfig"] = $7ddf546c1d92443d$export$6bbd9bc3bcb111b9;

});

parcelRegister("g149F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $caff09bd80328dee$var$LazyForgeK15tScrollSitesIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1jv7r")).then((m)=>m.ForgeK15tScrollSitesIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-prod/icon'
});

const $caff09bd80328dee$var$LazyForgeK15tScrollSitesSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1jv7r")).then((m)=>m.ForgeK15tScrollSitesSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-prod/search-result-icon'
});
const $caff09bd80328dee$export$317be388f2737846 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesIconComponent, null));
const $caff09bd80328dee$export$62ea9658fc6624da = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
module.exports["ForgeK15tScrollSitesIcon"] = $caff09bd80328dee$export$317be388f2737846;
module.exports["ForgeK15tScrollSitesSearchResultIcon"] = $caff09bd80328dee$export$62ea9658fc6624da;

});

parcelRegister("1jv7r", function(module, exports) {

let $0f4fb463401f7949$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f4fb463401f7949$var$load("9U12B").then(()=>parcelRequire('5Wybx'));

});

parcelRegister("7vbr8", function(module, exports) {

var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lJJFS = parcelRequire("lJJFS");

const $565f36f2f1b6aee9$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioAwsDev,
    icon: (0, $i52Hf.get3PLogo)((0, $lJJFS.ForgePioAwsIcon), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lJJFS.ForgePioAwsSearchResultIcon), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioAwsConfig"] = $565f36f2f1b6aee9$export$7fa480c37589b20;

});

parcelRegister("lJJFS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $bd58b69f4ea0aad2$var$LazyForgePioAwsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aUJpv")).then((m)=>m.ForgePioAwsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-dev/icon'
});

const $bd58b69f4ea0aad2$var$LazyForgePioAwsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aUJpv")).then((m)=>m.ForgePioAwsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-dev/search-result-icon'
});
const $bd58b69f4ea0aad2$export$9a2f1d62325d249c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsIconComponent, null));
const $bd58b69f4ea0aad2$export$e391bf4e4f614708 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsSearchResultIconComponent, null));
module.exports["ForgePioAwsIcon"] = $bd58b69f4ea0aad2$export$9a2f1d62325d249c;
module.exports["ForgePioAwsSearchResultIcon"] = $bd58b69f4ea0aad2$export$e391bf4e4f614708;

});

parcelRegister("aUJpv", function(module, exports) {

let $7f225be650ed44b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f225be650ed44b9$var$load("dL9uw").then(()=>parcelRequire('caQhm'));

});

parcelRegister("k6vRK", function(module, exports) {

var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9Vl84 = parcelRequire("9Vl84");

const $54f0d63711890722$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioAwsProd,
    icon: (0, $i52Hf.get3PLogo)((0, $9Vl84.ForgePioAwsIcon), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9Vl84.ForgePioAwsSearchResultIcon), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioAwsConfig"] = $54f0d63711890722$export$7fa480c37589b20;

});

parcelRegister("9Vl84", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6e9f77e13cf7efa7$var$LazyForgePioAwsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8Mcta")).then((m)=>m.ForgePioAwsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-prod/icon'
});

const $6e9f77e13cf7efa7$var$LazyForgePioAwsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8Mcta")).then((m)=>m.ForgePioAwsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-prod/search-result-icon'
});
const $6e9f77e13cf7efa7$export$9a2f1d62325d249c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsIconComponent, null));
const $6e9f77e13cf7efa7$export$e391bf4e4f614708 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsSearchResultIconComponent, null));
module.exports["ForgePioAwsIcon"] = $6e9f77e13cf7efa7$export$9a2f1d62325d249c;
module.exports["ForgePioAwsSearchResultIcon"] = $6e9f77e13cf7efa7$export$e391bf4e4f614708;

});

parcelRegister("8Mcta", function(module, exports) {

let $663c7a941f8801fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $663c7a941f8801fe$var$load("hvaIm").then(()=>parcelRequire('esn4d'));

});

parcelRegister("aiL8h", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8xRaD = parcelRequire("8xRaD");

const $3bed2460a9ac74a9$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
    icon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $3bed2460a9ac74a9$export$1e9db6975f6a70ae;

});

parcelRegister("8xRaD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $90c5d9d93ae12793$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/icon'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/search-result-icon'
});
const $90c5d9d93ae12793$export$836fbefaf37221f1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupIconComponent, null)), $90c5d9d93ae12793$var$OfficialIcon, 'small');
const $90c5d9d93ae12793$export$83043b67e00ef5ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent, null)), $90c5d9d93ae12793$var$OfficialIcon, 'medium');
module.exports["ForgePioClickupIcon"] = $90c5d9d93ae12793$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $90c5d9d93ae12793$export$83043b67e00ef5ec;

});

parcelRegister("cIrR2", function(module, exports) {

let $941f336918174642$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $941f336918174642$var$load("8s0tV").then(()=>parcelRequire('8nxWD'));

});

parcelRegister("cY0ZT", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8IQya = parcelRequire("8IQya");

const $5d6955193314318a$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
    icon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $5d6955193314318a$export$1e9db6975f6a70ae;

});

parcelRegister("8IQya", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $87a1e5b2c35074ff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/icon'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/search-result-icon'
});
const $87a1e5b2c35074ff$export$836fbefaf37221f1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent, null)), $87a1e5b2c35074ff$var$OfficialIcon, 'small');
const $87a1e5b2c35074ff$export$83043b67e00ef5ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent, null)), $87a1e5b2c35074ff$var$OfficialIcon, 'medium');
module.exports["ForgePioClickupIcon"] = $87a1e5b2c35074ff$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $87a1e5b2c35074ff$export$83043b67e00ef5ec;

});

parcelRegister("181bf", function(module, exports) {

let $0d2774388cdc3227$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d2774388cdc3227$var$load("fHbPr").then(()=>parcelRequire('lbEqU'));

});

parcelRegister("9SYma", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $luC3K = parcelRequire("luC3K");

const $30c6c0a5f88da5cd$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $30c6c0a5f88da5cd$export$a10b5ae888bd2541;

});

parcelRegister("luC3K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/icon'
});

const $ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/search-result-icon'
});
const $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
const $ff3e09ebc7d38a88$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $ff3e09ebc7d38a88$export$6de477beffd11496;

});

parcelRegister("eaLXQ", function(module, exports) {

let $a517348cc13b5415$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a517348cc13b5415$var$load("doxhZ").then(()=>parcelRequire('5yzek'));

});

parcelRegister("ie06K", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $hqQhc = parcelRequire("hqQhc");

const $7e16e25b4d6e9ae6$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $7e16e25b4d6e9ae6$export$a10b5ae888bd2541;

});

parcelRegister("hqQhc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f7c3187305b5af82$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/icon'
});

const $f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/search-result-icon'
});
const $f7c3187305b5af82$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
const $f7c3187305b5af82$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $f7c3187305b5af82$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $f7c3187305b5af82$export$6de477beffd11496;

});

parcelRegister("cxRlS", function(module, exports) {

let $9221f3aa58abeaa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9221f3aa58abeaa8$var$load("f79rV").then(()=>parcelRequire('jAHFR'));

});

parcelRegister("h5NUz", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bMpOM = parcelRequire("bMpOM");

const $b38ab40b92cfb88e$export$dd7854123286bd26 = {
    displayName: 'Github by Pio',
    id: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGithubDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bMpOM.ForgePioGithubIcon), 'ForgePioGithub', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bMpOM.ForgePioGithubSearchResultIcon), 'ForgePioGithub', 'large'),
    integrationAri: 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    get filters () {
        return [
            'lastUpdated',
            'pullRequestStatus',
            'reviewer',
            'createdBy',
            'repository',
            'assignee'
        ];
    },
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGithubConfig"] = $b38ab40b92cfb88e$export$dd7854123286bd26;

});

parcelRegister("bMpOM", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $7dcd77abcb76f468$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $7dcd77abcb76f468$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxyY4")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-dev/icon'
});

const $7dcd77abcb76f468$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxyY4")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-dev/search-result-icon'
});
const $7dcd77abcb76f468$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dcd77abcb76f468$var$LazyForgePioGithubIconComponent, null)), $7dcd77abcb76f468$var$OfficialIcon, 'small');
const $7dcd77abcb76f468$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dcd77abcb76f468$var$LazyForgePioGithubSearchResultIconComponent, null)), $7dcd77abcb76f468$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $7dcd77abcb76f468$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $7dcd77abcb76f468$export$f318f463f9328f3f;

});

parcelRegister("cxyY4", function(module, exports) {

let $9213b103faa763c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9213b103faa763c2$var$load("9DAHg").then(()=>parcelRequire('9qnlQ'));

});

parcelRegister("9Y160", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iPmoS = parcelRequire("iPmoS");

const $3fed812b1389566f$export$dd7854123286bd26 = {
    displayName: 'Github by Pio',
    id: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGithubProd,
    icon: (0, $i52Hf.get3PLogo)((0, $iPmoS.ForgePioGithubIcon), 'ForgePioGithub', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iPmoS.ForgePioGithubSearchResultIcon), 'ForgePioGithub', 'large'),
    integrationAri: 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    get filters () {
        return [
            'lastUpdated',
            'pullRequestStatus',
            'reviewer',
            'createdBy',
            'repository',
            'assignee'
        ];
    },
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGithubConfig"] = $3fed812b1389566f$export$dd7854123286bd26;

});

parcelRegister("hdy05", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $aw1q4 = parcelRequire("aw1q4");

const $979771840684c647$export$8d71df70076b5c6 = {
    displayName: 'Gitlab by Pio',
    id: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabDev,
    icon: (0, $i52Hf.get3PLogo)((0, $aw1q4.ForgePioGitlabIcon), 'ForgePioGitlab', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $aw1q4.ForgePioGitlabSearchResultIcon), 'ForgePioGitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitlabConfig"] = $979771840684c647$export$8d71df70076b5c6;

});

parcelRegister("aw1q4", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2fdf4191c525e5e6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $2fdf4191c525e5e6$var$LazyForgePioGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8GA7N")).then((m)=>m.ForgePioGitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-dev/icon'
});

const $2fdf4191c525e5e6$var$LazyForgePioGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8GA7N")).then((m)=>m.ForgePioGitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-dev/search-result-icon'
});
const $2fdf4191c525e5e6$export$ccbc2eb39f3b36a7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fdf4191c525e5e6$var$LazyForgePioGitlabIconComponent, null)), $2fdf4191c525e5e6$var$OfficialIcon, 'small');
const $2fdf4191c525e5e6$export$31ecffbb988c6a26 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fdf4191c525e5e6$var$LazyForgePioGitlabSearchResultIconComponent, null)), $2fdf4191c525e5e6$var$OfficialIcon, 'medium');
module.exports["ForgePioGitlabIcon"] = $2fdf4191c525e5e6$export$ccbc2eb39f3b36a7;
module.exports["ForgePioGitlabSearchResultIcon"] = $2fdf4191c525e5e6$export$31ecffbb988c6a26;

});

parcelRegister("8GA7N", function(module, exports) {

let $652e4494ff028aea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $652e4494ff028aea$var$load("fKFEw").then(()=>parcelRequire('dmIao'));

});

parcelRegister("djF8v", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5xmWb = parcelRequire("5xmWb");

const $39b78f0661ba6ff8$export$8d71df70076b5c6 = {
    displayName: 'Gitlab by Pio',
    id: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabProd,
    icon: (0, $i52Hf.get3PLogo)((0, $5xmWb.ForgePioGitlabIcon), 'ForgePioGitlab', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5xmWb.ForgePioGitlabSearchResultIcon), 'ForgePioGitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitlabConfig"] = $39b78f0661ba6ff8$export$8d71df70076b5c6;

});

parcelRegister("5xmWb", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $23319306e79424e9$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $23319306e79424e9$var$LazyForgePioGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("j5rao")).then((m)=>m.ForgePioGitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-prod/icon'
});

const $23319306e79424e9$var$LazyForgePioGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("j5rao")).then((m)=>m.ForgePioGitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-prod/search-result-icon'
});
const $23319306e79424e9$export$ccbc2eb39f3b36a7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23319306e79424e9$var$LazyForgePioGitlabIconComponent, null)), $23319306e79424e9$var$OfficialIcon, 'small');
const $23319306e79424e9$export$31ecffbb988c6a26 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23319306e79424e9$var$LazyForgePioGitlabSearchResultIconComponent, null)), $23319306e79424e9$var$OfficialIcon, 'medium');
module.exports["ForgePioGitlabIcon"] = $23319306e79424e9$export$ccbc2eb39f3b36a7;
module.exports["ForgePioGitlabSearchResultIcon"] = $23319306e79424e9$export$31ecffbb988c6a26;

});

parcelRegister("j5rao", function(module, exports) {

let $de538eb1441efdcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de538eb1441efdcb$var$load("iVQaW").then(()=>parcelRequire('jPghV'));

});

parcelRegister("dChew", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5QuHV = parcelRequire("5QuHV");

const $e57423fd67cdd8c6$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $e57423fd67cdd8c6$export$7b3aebc675da1806;

});

parcelRegister("5QuHV", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b14ef24b242b0f5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("4zc1o"))).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/icon'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/search-result-icon'
});
const $9b14ef24b242b0f5$export$a1f95679f652d1ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent, null)), $9b14ef24b242b0f5$var$OfficialIcon, 'small');
const $9b14ef24b242b0f5$export$4bae7f77a341daa0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent, null)), $9b14ef24b242b0f5$var$OfficialIcon, 'medium');
module.exports["ForgePioGoogleDriveIcon"] = $9b14ef24b242b0f5$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $9b14ef24b242b0f5$export$4bae7f77a341daa0;

});

parcelRegister("2dyBk", function(module, exports) {

let $19d7a2b45b018186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19d7a2b45b018186$var$load("eQyR8").then(()=>parcelRequire('65WlL'));

});

parcelRegister("TCovD", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $f0NBB = parcelRequire("f0NBB");

const $edc55c611b3bef54$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
    icon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $edc55c611b3bef54$export$7b3aebc675da1806;

});

parcelRegister("f0NBB", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2a4f11fd35f1561d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("4zc1o"))).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/icon'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/search-result-icon'
});
const $2a4f11fd35f1561d$export$a1f95679f652d1ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent, null)), $2a4f11fd35f1561d$var$OfficialIcon, 'small');
const $2a4f11fd35f1561d$export$4bae7f77a341daa0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent, null)), $2a4f11fd35f1561d$var$OfficialIcon, 'medium');
module.exports["ForgePioGoogleDriveIcon"] = $2a4f11fd35f1561d$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $2a4f11fd35f1561d$export$4bae7f77a341daa0;

});

parcelRegister("a07eA", function(module, exports) {

let $747f8411ae156579$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $747f8411ae156579$var$load("fPrZJ").then(()=>parcelRequire('foLez'));

});

parcelRegister("feDPe", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cDJLe = parcelRequire("cDJLe");

const $6d6cb4a42f1a5c65$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
    icon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $6d6cb4a42f1a5c65$export$528a99587bc9b40e;

});

parcelRegister("cDJLe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2920441e11b70cd2$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/icon'
});

const $2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/search-result-icon'
});
const $2920441e11b70cd2$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
const $2920441e11b70cd2$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $2920441e11b70cd2$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $2920441e11b70cd2$export$b49ff31395265951;

});

parcelRegister("hIbHQ", function(module, exports) {

let $ce4fa05b13629a64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce4fa05b13629a64$var$load("lxdqb").then(()=>parcelRequire('27bjo'));

});

parcelRegister("klS4t", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4tpeK = parcelRequire("4tpeK");

const $77afbf3b994cdec8$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
    icon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $77afbf3b994cdec8$export$528a99587bc9b40e;

});

parcelRegister("4tpeK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b236eb93e0f85320$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/icon'
});

const $b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/search-result-icon'
});
const $b236eb93e0f85320$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
const $b236eb93e0f85320$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $b236eb93e0f85320$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $b236eb93e0f85320$export$b49ff31395265951;

});

parcelRegister("hReiL", function(module, exports) {

let $d0027aea808a4c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0027aea808a4c93$var$load("l3yCu").then(()=>parcelRequire('5IaNj'));

});

parcelRegister("hFdyH", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9o5zM = parcelRequire("9o5zM");

const $d06de435425db1cd$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $d06de435425db1cd$export$a612366ee7742bc4;

});

parcelRegister("9o5zM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/icon'
});

const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/search-result-icon'
});
const $1a59bb9fa163a26b$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
const $1a59bb9fa163a26b$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $1a59bb9fa163a26b$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $1a59bb9fa163a26b$export$2782a2dcd42b923c;

});

parcelRegister("l85tV", function(module, exports) {

let $f61e98dabceec19b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f61e98dabceec19b$var$load("BZA59").then(()=>parcelRequire('lcok7'));

});

parcelRegister("e6TPF", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XLGG = parcelRequire("3XLGG");

const $ebd7c08029c46f92$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $ebd7c08029c46f92$export$a612366ee7742bc4;

});

parcelRegister("3XLGG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/icon'
});

const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/search-result-icon'
});
const $c3f8a80c4bf2155c$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
const $c3f8a80c4bf2155c$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $c3f8a80c4bf2155c$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $c3f8a80c4bf2155c$export$2782a2dcd42b923c;

});

parcelRegister("8ZtAm", function(module, exports) {

let $68baf8514ec615e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68baf8514ec615e9$var$load("89OPU").then(()=>parcelRequire('exmtD'));

});

parcelRegister("7piBv", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lHmnw = parcelRequire("lHmnw");

const $ff6b770550126248$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
    icon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $ff6b770550126248$export$2bb44bd2479444f9;

});

parcelRegister("lHmnw", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ae4c750f6148d7b8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/icon'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/search-result-icon'
});
const $ae4c750f6148d7b8$export$e87bb425fde16105 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent, null)), $ae4c750f6148d7b8$var$OfficialIcon, 'small');
const $ae4c750f6148d7b8$export$cc1026e3c5b549e1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent, null)), $ae4c750f6148d7b8$var$OfficialIcon, 'medium');
module.exports["ForgePioHubspotIcon"] = $ae4c750f6148d7b8$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $ae4c750f6148d7b8$export$cc1026e3c5b549e1;

});

parcelRegister("gDgqn", function(module, exports) {

let $c1bd0762a9485a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1bd0762a9485a15$var$load("12zSS").then(()=>parcelRequire('577rm'));

});

parcelRegister("3yXQ1", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dB1o2 = parcelRequire("dB1o2");

const $9438ce5263366d16$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $9438ce5263366d16$export$2bb44bd2479444f9;

});

parcelRegister("dB1o2", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $138972da21ac7328$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $138972da21ac7328$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/icon'
});

const $138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/search-result-icon'
});
const $138972da21ac7328$export$e87bb425fde16105 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotIconComponent, null)), $138972da21ac7328$var$OfficialIcon, 'small');
const $138972da21ac7328$export$cc1026e3c5b549e1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent, null)), $138972da21ac7328$var$OfficialIcon, 'medium');
module.exports["ForgePioHubspotIcon"] = $138972da21ac7328$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $138972da21ac7328$export$cc1026e3c5b549e1;

});

parcelRegister("23P54", function(module, exports) {

let $18037c2587a44799$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18037c2587a44799$var$load("6nOSk").then(()=>parcelRequire('5aOBD'));

});

parcelRegister("cmwLF", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5N1qm = parcelRequire("5N1qm");

const $86d0647c502027e9$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5N1qm.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5N1qm.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $86d0647c502027e9$export$6ab686f8808b6986;

});

parcelRegister("5N1qm", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2795db874931a453$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1iIDp")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/logo-third-party/salesforce'
});

const $2795db874931a453$var$LazyForgePioSalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cXnTk")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/icon'
});

const $2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cXnTk")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/search-result-icon'
});
const $2795db874931a453$export$fd669dbaab8ebe1e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceIconComponent, null)), $2795db874931a453$var$OfficialIcon, 'small');
const $2795db874931a453$export$ebba99402341b0c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent, null)), $2795db874931a453$var$OfficialIcon, 'medium');
module.exports["ForgePioSalesforceIcon"] = $2795db874931a453$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $2795db874931a453$export$ebba99402341b0c4;

});

parcelRegister("cXnTk", function(module, exports) {

let $96ed870d8ca0e90e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96ed870d8ca0e90e$var$load("8FiJs").then(()=>parcelRequire('boSNc'));

});

parcelRegister("brRUk", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jW2EI = parcelRequire("jW2EI");

const $57c4a39dfa3b2602$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $jW2EI.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jW2EI.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $57c4a39dfa3b2602$export$6ab686f8808b6986;

});

parcelRegister("jW2EI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ad250f24924a2221$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1iIDp")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/logo-third-party/salesforce'
});

const $ad250f24924a2221$var$LazyForgePioSalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6D4bc")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/icon'
});

const $ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6D4bc")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/search-result-icon'
});
const $ad250f24924a2221$export$fd669dbaab8ebe1e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceIconComponent, null)), $ad250f24924a2221$var$OfficialIcon, 'small');
const $ad250f24924a2221$export$ebba99402341b0c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent, null)), $ad250f24924a2221$var$OfficialIcon, 'medium');
module.exports["ForgePioSalesforceIcon"] = $ad250f24924a2221$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $ad250f24924a2221$export$ebba99402341b0c4;

});

parcelRegister("6D4bc", function(module, exports) {

let $4d39a098c6f42bda$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d39a098c6f42bda$var$load("HN9Az").then(()=>parcelRequire('ezeQe'));

});

parcelRegister("dwyZc", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $7hXqS = parcelRequire("7hXqS");

const $d0c1882acaf8175d$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
    icon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $d0c1882acaf8175d$export$a62192356b6384ff;

});

parcelRegister("7hXqS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b6113d0f81ce6d8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("8RTwe"))).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/icon'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/search-result-icon'
});
const $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent, null)), $9b6113d0f81ce6d8$var$OfficialIcon, 'small');
const $9b6113d0f81ce6d8$export$ff73eba88c3a5de7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent, null)), $9b6113d0f81ce6d8$var$OfficialIcon, 'medium');
module.exports["ForgePioSharepointIcon"] = $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $9b6113d0f81ce6d8$export$ff73eba88c3a5de7;

});

parcelRegister("4NZXw", function(module, exports) {

let $37fbccc6b891f09a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37fbccc6b891f09a$var$load("jSUxV").then(()=>parcelRequire('l1iDy'));

});

parcelRegister("9sIt4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bE1lG = parcelRequire("bE1lG");

const $683bf0dbe93cd230$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
    icon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $683bf0dbe93cd230$export$a62192356b6384ff;

});

parcelRegister("bE1lG", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b90524babf24a663$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("8RTwe"))).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $b90524babf24a663$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/icon'
});

const $b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/search-result-icon'
});
const $b90524babf24a663$export$ecc35ba2a32c7e3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointIconComponent, null)), $b90524babf24a663$var$OfficialIcon, 'small');
const $b90524babf24a663$export$ff73eba88c3a5de7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent, null)), $b90524babf24a663$var$OfficialIcon, 'medium');
module.exports["ForgePioSharepointIcon"] = $b90524babf24a663$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $b90524babf24a663$export$ff73eba88c3a5de7;

});

parcelRegister("4OSjU", function(module, exports) {

let $3825f7c2c9b6438f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3825f7c2c9b6438f$var$load("dGvaI").then(()=>parcelRequire('53U7P'));

});

parcelRegister("7UyZr", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eLukX = parcelRequire("eLukX");

const $7b363fb97ca8421c$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
    icon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $7b363fb97ca8421c$export$cc9a98fbdf14b1ba;

});

parcelRegister("eLukX", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $d275976379838dc2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fBB29")).then((m)=>m.StackOverflowIcon), {
    moduleId: '@atlassian/logo-third-party/stack-overflow'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/icon'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/search-result-icon'
});
const $d275976379838dc2$export$99bc27b78a6e71df = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowIconComponent, null)), $d275976379838dc2$var$OfficialIcon, 'small');
const $d275976379838dc2$export$9a30339a9bdbd3d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent, null)), $d275976379838dc2$var$OfficialIcon, 'medium');
module.exports["ForgePioStackOverflowIcon"] = $d275976379838dc2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d275976379838dc2$export$9a30339a9bdbd3d6;

});

parcelRegister("fBB29", function(module, exports) {

let $b5c709d86027bc48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5c709d86027bc48$var$load("aQKKn").then(()=>parcelRequire('l2bfr'));

});

parcelRegister("kmocd", function(module, exports) {

let $ed28a18858f32988$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed28a18858f32988$var$load("fhGCt").then(()=>parcelRequire('cH70d'));

});

parcelRegister("2KPYZ", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dNyzf = parcelRequire("dNyzf");

const $406347052a44a9c5$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $406347052a44a9c5$export$cc9a98fbdf14b1ba;

});

parcelRegister("dNyzf", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $d7c3a178bcc55be2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fBB29")).then((m)=>m.StackOverflowIcon), {
    moduleId: '@atlassian/logo-third-party/stack-overflow'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/icon'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/search-result-icon'
});
const $d7c3a178bcc55be2$export$99bc27b78a6e71df = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent, null)), $d7c3a178bcc55be2$var$OfficialIcon, 'small');
const $d7c3a178bcc55be2$export$9a30339a9bdbd3d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent, null)), $d7c3a178bcc55be2$var$OfficialIcon, 'medium');
module.exports["ForgePioStackOverflowIcon"] = $d7c3a178bcc55be2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d7c3a178bcc55be2$export$9a30339a9bdbd3d6;

});

parcelRegister("2QdDM", function(module, exports) {

let $211b04dc028d7bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $211b04dc028d7bac$var$load("i47NY").then(()=>parcelRequire('7DqjS'));

});

parcelRegister("9lVxQ", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5vkE3 = parcelRequire("5vkE3");

const $3e70faad8a12b1e6$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $3e70faad8a12b1e6$export$1c8bdcf28097f33d;

});

parcelRegister("5vkE3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/icon'
});

const $d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/search-result-icon'
});
const $d8f18c592b583242$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
const $d8f18c592b583242$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $d8f18c592b583242$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $d8f18c592b583242$export$41e46c9b83e3cfe1;

});

parcelRegister("31MoW", function(module, exports) {

let $2347029a7fa3b936$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2347029a7fa3b936$var$load("5b0ls").then(()=>parcelRequire('krol2'));

});

parcelRegister("1HfnT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cRk65 = parcelRequire("cRk65");

const $86431f8286f0d68f$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $86431f8286f0d68f$export$1c8bdcf28097f33d;

});

parcelRegister("cRk65", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/icon'
});

const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/search-result-icon'
});
const $6130c3bf337d5909$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
const $6130c3bf337d5909$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $6130c3bf337d5909$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $6130c3bf337d5909$export$41e46c9b83e3cfe1;

});

parcelRegister("84tMx", function(module, exports) {

let $5e05cc7d0478333e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e05cc7d0478333e$var$load("etezH").then(()=>parcelRequire('k1qzV'));

});

parcelRegister("3LgSg", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $16Wwz = parcelRequire("16Wwz");

const $03b0710ec10f5545$export$802c434914cc51cb = {
    displayName: 'Asana by Unito',
    id: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaDev,
    icon: (0, $i52Hf.get3PLogo)((0, $16Wwz.ForgeUnitoAsanaDevIcon), 'ForgeUnitoAsana', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $16Wwz.ForgeUnitoAsanaDevSearchResultIcon), 'ForgeUnitoAsana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/6wHDDwNbam77WvGwMKYMGDiTWP8pza54',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoAsanaConfig"] = $03b0710ec10f5545$export$802c434914cc51cb;

});

parcelRegister("16Wwz", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b8ff5851b44fb2d6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kMuq9")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/logo-third-party/asana'
});

const $b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jdE4p")).then((m)=>m.ForgeUnitoAsanaDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/icon'
});

const $b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jdE4p")).then((m)=>m.ForgeUnitoAsanaDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/search-result-icon'
});
const $b8ff5851b44fb2d6$export$84e4ab153a34ad7e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevIconComponent, null)), $b8ff5851b44fb2d6$var$OfficialIcon, 'small');
const $b8ff5851b44fb2d6$export$cd30ec5cd19c805 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevSearchResultIconComponent, null)), $b8ff5851b44fb2d6$var$OfficialIcon, 'medium');
module.exports["ForgeUnitoAsanaDevIcon"] = $b8ff5851b44fb2d6$export$84e4ab153a34ad7e;
module.exports["ForgeUnitoAsanaDevSearchResultIcon"] = $b8ff5851b44fb2d6$export$cd30ec5cd19c805;

});

parcelRegister("jdE4p", function(module, exports) {

let $dfde50523d636ab8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfde50523d636ab8$var$load("6fZlZ").then(()=>parcelRequire('1K5y8'));

});

parcelRegister("bRkOn", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6qL93 = parcelRequire("6qL93");

const $2cb9c75b34e21339$export$802c434914cc51cb = {
    displayName: 'Asana by Unito',
    id: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaProd,
    icon: (0, $i52Hf.get3PLogo)((0, $6qL93.ForgeUnitoAsanaProdIcon), 'ForgeUnitoAsana', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6qL93.ForgeUnitoAsanaProdSearchResultIcon), 'ForgeUnitoAsana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoAsanaConfig"] = $2cb9c75b34e21339$export$802c434914cc51cb;

});

parcelRegister("6qL93", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $cf5194bf62aeff02$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kMuq9")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/logo-third-party/asana'
});

const $cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fPn6N")).then((m)=>m.ForgeUnitoAsanaProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/icon'
});

const $cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fPn6N")).then((m)=>m.ForgeUnitoAsanaProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/search-result-icon'
});
const $cf5194bf62aeff02$export$df888f4c8633dd6a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdIconComponent, null)), $cf5194bf62aeff02$var$OfficialIcon, 'small');
const $cf5194bf62aeff02$export$b7301999a3358df4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdSearchResultIconComponent, null)), $cf5194bf62aeff02$var$OfficialIcon, 'medium');
module.exports["ForgeUnitoAsanaProdIcon"] = $cf5194bf62aeff02$export$df888f4c8633dd6a;
module.exports["ForgeUnitoAsanaProdSearchResultIcon"] = $cf5194bf62aeff02$export$b7301999a3358df4;

});

parcelRegister("fPn6N", function(module, exports) {

let $b85d8b5371f44bee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b85d8b5371f44bee$var$load("badpd").then(()=>parcelRequire('3xxsS'));

});

parcelRegister("bzVC8", function(module, exports) {

var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gkMkb = parcelRequire("gkMkb");

const $cd6088651b1d3011$export$da489f084fc70d3a = {
    displayName: 'Gong',
    id: 'gong',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gong,
    icon: (0, $i52Hf.get3PLogo)((0, $gkMkb.GongIcon), 'Gong', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gkMkb.GongSearchResultIcon), 'Gong', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gong',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gongConfig"] = $cd6088651b1d3011$export$da489f084fc70d3a;

});

parcelRegister("gkMkb", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $46f3e375cd9453c4$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6pBWK")).then((m)=>m.GongIcon), {
    moduleId: '@atlassian/logo-third-party/gong'
});

const $46f3e375cd9453c4$var$LazyGongIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1AiKZ")).then((m)=>m.GongIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gong/icon'
});

const $46f3e375cd9453c4$var$LazyGongSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1W2a0")).then((m)=>m.GongSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gong/search-result-icon'
});
const $46f3e375cd9453c4$export$81a901141c7fd09d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46f3e375cd9453c4$var$LazyGongIconComponent, null)), $46f3e375cd9453c4$var$OfficialIcon, 'small');
const $46f3e375cd9453c4$export$f1670de5ba3e94b4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46f3e375cd9453c4$var$LazyGongSearchResultIconComponent, null)), $46f3e375cd9453c4$var$OfficialIcon, 'medium');
module.exports["GongIcon"] = $46f3e375cd9453c4$export$81a901141c7fd09d;
module.exports["GongSearchResultIcon"] = $46f3e375cd9453c4$export$f1670de5ba3e94b4;

});

parcelRegister("6pBWK", function(module, exports) {

let $4ab28342f43aa805$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab28342f43aa805$var$load("4daxi").then(()=>parcelRequire('8DzYI'));

});

parcelRegister("1AiKZ", function(module, exports) {

let $1277b3fb732798dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1277b3fb732798dd$var$load("1GQMk").then(()=>parcelRequire('bkQed'));

});

parcelRegister("1W2a0", function(module, exports) {

let $168ce23c4db71f08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $168ce23c4db71f08$var$load("5lziI").then(()=>parcelRequire('leql4'));

});

parcelRegister("9dBNg", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $e48c29dee48cfc00$export$ae953a2876729d03 = new Map([
    [
        (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Figma,
        (0, $fR63l.ProductKeys3P).Figma
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Github,
        (0, $fR63l.ProductKeys3P).Github
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).GoogleDrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OneDrive,
        (0, $fR63l.ProductKeys3P).OneDrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Dropbox
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Slack,
        (0, $fR63l.ProductKeys3P).Slack
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Teams,
        (0, $fR63l.ProductKeys3P).Teams
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
        (0, $fR63l.ProductKeys3P).GoogleCalendar
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
        (0, $fR63l.ProductKeys3P).OutlookCalendar
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OutlookMail,
        (0, $fR63l.ProductKeys3P).OutlookMail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gmail,
        (0, $fR63l.ProductKeys3P).Gmail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AdobeSign,
        (0, $fR63l.ProductKeys3P).AdobeSign
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Asana,
        (0, $fR63l.ProductKeys3P).Asana
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zendesk,
        (0, $fR63l.ProductKeys3P).Zendesk
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Airtable,
        (0, $fR63l.ProductKeys3P).Airtable
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Smartsheet
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Notion,
        (0, $fR63l.ProductKeys3P).Notion
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Miro,
        (0, $fR63l.ProductKeys3P).Miro
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Docusign,
        (0, $fR63l.ProductKeys3P).Docusign
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Lucid,
        (0, $fR63l.ProductKeys3P).Lucid
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Monday,
        (0, $fR63l.ProductKeys3P).Monday
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AzureDevops,
        (0, $fR63l.ProductKeys3P).AzureDevops
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gitlab,
        (0, $fR63l.ProductKeys3P).Gitlab
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).ConfluenceDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).JiraDC,
        (0, $fR63l.ProductKeys3P).JiraDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).JsmDC,
        (0, $fR63l.ProductKeys3P).JsmDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Canva,
        (0, $fR63l.ProductKeys3P).Canva
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Box,
        (0, $fR63l.ProductKeys3P).Box
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gong,
        (0, $fR63l.ProductKeys3P).Gong
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zoom,
        (0, $fR63l.ProductKeys3P).Zoom
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zeplin,
        (0, $fR63l.ProductKeys3P).Zeplin
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ServiceNow,
        (0, $fR63l.ProductKeys3P).ServiceNow
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Freshservice,
        (0, $fR63l.ProductKeys3P).Freshservice
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).PowerBI,
        (0, $fR63l.ProductKeys3P).PowerBI
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ClickUp,
        (0, $fR63l.ProductKeys3P).ClickUp
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Amplitude,
        (0, $fR63l.ProductKeys3P).Amplitude
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Stripe,
        (0, $fR63l.ProductKeys3P).Stripe
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AdobeXD,
        (0, $fR63l.ProductKeys3P).AdobeXD
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Aha,
        (0, $fR63l.ProductKeys3P).Aha
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Mural,
        (0, $fR63l.ProductKeys3P).Mural
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Webex,
        (0, $fR63l.ProductKeys3P).Webex
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Todoist,
        (0, $fR63l.ProductKeys3P).Todoist
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).PagerDuty,
        (0, $fR63l.ProductKeys3P).PagerDuty
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Pipedrive,
        (0, $fR63l.ProductKeys3P).Pipedrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Hubspot
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Dovetail,
        (0, $fR63l.ProductKeys3P).Dovetail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
        (0, $fR63l.ProductKeys3P).LaunchDarkly
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Salesforce,
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Sentry,
        (0, $fR63l.ProductKeys3P).Sentry
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gitbook,
        (0, $fR63l.ProductKeys3P).Gitbook
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AWSS3,
        (0, $fR63l.ProductKeys3P).AWSS3
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Databricks,
        (0, $fR63l.ProductKeys3P).Databricks
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesDev,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesProd,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioAwsDev,
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioAwsProd,
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestDev,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestProd,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd
    ]
]);
module.exports["ResourceTypeToProductKeyMap"] = $e48c29dee48cfc00$export$ae953a2876729d03;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.HIDE
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<ecee5cb68219750c899a663dd271634b>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("4UYoK", function(module, exports) {
/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */ const $88afb75838a9f8b5$export$134ea9981ab0c82e = {
    hasSeenUniversalCreateCwRExperimentSpotlight: 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
};
const $88afb75838a9f8b5$export$5b55ba0fa31f0184 = Object.values($88afb75838a9f8b5$export$134ea9981ab0c82e);
module.exports["UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS"] = $88afb75838a9f8b5$export$134ea9981ab0c82e;
module.exports["UniversalCreateCwRExperimentSpotlightOnboardingKeys"] = $88afb75838a9f8b5$export$5b55ba0fa31f0184;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<0fb7b778e884fde647da24980606dd2b>>
 * @relayHash 0e97369e1bfa5659fc7cb13e5e23293d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalExpirationConfig"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeApprovalExpirationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceSettings",
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentStateSettings",
                                "kind": "LinkedField",
                                "name": "contentStateSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ContentState",
                                        "kind": "LinkedField",
                                        "name": "spaceContentStates",
                                        "plural": true,
                                        "selections": [
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "success"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v21 = [
        v8 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v15 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ], v22 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v11 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v11 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v13 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "condition": "includeApprovalExpirationConfig",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ConfluenceApprovalExpirationConfig",
                                        "kind": "LinkedField",
                                        "name": "approvalExpirationConfig",
                                        "plural": false,
                                        "selections": [
                                            v14 /*: any*/ ,
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationInterval",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    v15 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unit"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "restartApproval"
                                            },
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                                                "kind": "LinkedField",
                                                "name": "changeStatus",
                                                "plural": false,
                                                "selections": [
                                                    v14 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "expireToContentStateId"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v16 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v21 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "status"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v26 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v28 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v29 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v30 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v32 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v33 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v32 /*: any*/ 
                ]
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v35 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v34 /*: any*/ 
        ]
    }, v36 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v37 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v38 = [
        v15 /*: any*/ 
    ], v39 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ]
    }, v40 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v15 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v41 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0e97369e1bfa5659fc7cb13e5e23293d",
            "id": "ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a285f0ce20dbf6d66aa1a29a488d317f";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("iOp5s", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

const $e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';
const $e8d397546331cd08$var$isApprovalsDisabledGraphQLError = (error)=>Boolean(error.message?.includes($e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE));
const $e8d397546331cd08$export$b724ffcdc4a2c130 = (error)=>{
    if (!error) return false;
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    if (graphQLErrors?.length) return graphQLErrors.every($e8d397546331cd08$var$isApprovalsDisabledGraphQLError);
    return $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(error);
};
const $e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled = (error)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    const originalCause = error.originalError?.cause;
    if (originalCause && $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(originalCause)) (0, $7Sm4c.markErrorAsHandled)(originalCause);
};
const $e8d397546331cd08$export$50302788ce0889ee = (error)=>{
    if (!error || !$e8d397546331cd08$export$b724ffcdc4a2c130(error)) return;
    (0, $7Sm4c.markErrorAsHandled)(error);
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    graphQLErrors?.forEach($e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled);
};
module.exports["markApprovalsDisabledErrorAsHandled"] = $e8d397546331cd08$export$50302788ce0889ee;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
            !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<d09735fc2cd7a6020b32121ef039e936>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("bAV6O", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/folder/manifest.ts
var $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $870f5b1ead2b6083$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $870f5b1ead2b6083$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("ig7dg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $116c5e27ebbb6682$var$MIN_VALUE = 0;
const $116c5e27ebbb6682$var$MAX_VALUE = 1;
const $116c5e27ebbb6682$var$increasingBarAnimation = null;
const $116c5e27ebbb6682$var$decreasingBarAnimation = null;
const $116c5e27ebbb6682$var$containerStyles = null;
const $116c5e27ebbb6682$var$containerAppearance = {
    default: "_0KLXruDMqu",
    success: "_0KLXruDMqu",
    inverse: "_0KLXruB4sa"
};
const $116c5e27ebbb6682$var$barAppearance = {
    default: "_0KLXrugozt",
    success: "_0KLXruhbjP",
    inverse: "_0KLXrulfZc"
};
const $116c5e27ebbb6682$var$barStyles = null;
const $116c5e27ebbb6682$var$determinateBarStyles = null;
const $116c5e27ebbb6682$var$increasingBarStyles = null;
const $116c5e27ebbb6682$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $116c5e27ebbb6682$var$ProgressBar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: t1, ariaLabel: ariaLabel, isIndeterminate: t2, testId: t3, value: t4 } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const isIndeterminate = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "progress-bar" : t3;
    const value = t4 === undefined ? 0 : t4;
    const valueParsed = isIndeterminate ? $116c5e27ebbb6682$var$MIN_VALUE : Math.max($116c5e27ebbb6682$var$MIN_VALUE, Math.min(value, $116c5e27ebbb6682$var$MAX_VALUE));
    const t5 = $116c5e27ebbb6682$var$containerAppearance[appearance];
    let t6;
    if ($[0] !== t5) {
        t6 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu",
            t5
        ]);
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    let t7;
    if ($[2] !== appearance || $[3] !== isIndeterminate || $[4] !== value) {
        t7 = isIndeterminate ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_0nFVCGFSlo _03m2nySHWH _1gBibytvPq"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_1jakNnwiJJ _0nFVCGFSlo _03m2nySHWH _1gBibyo5Iu"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hekY6.default)([
                "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_23rrnHjh6t"
            ])
        });
        $[2] = appearance;
        $[3] = isIndeterminate;
        $[4] = value;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== ariaLabel || $[7] !== t6 || $[8] !== t7 || $[9] !== testId || $[10] !== valueParsed) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $116c5e27ebbb6682$var$MIN_VALUE,
            "aria-valuenow": valueParsed,
            "aria-valuemax": $116c5e27ebbb6682$var$MAX_VALUE,
            "data-testid": testId,
            className: t6,
            children: t7
        });
        $[6] = ariaLabel;
        $[7] = t6;
        $[8] = t7;
        $[9] = testId;
        $[10] = valueParsed;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $116c5e27ebbb6682$var$MIN_VALUE : Math.max($116c5e27ebbb6682$var$MIN_VALUE, Math.min(value, $116c5e27ebbb6682$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $116c5e27ebbb6682$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $116c5e27ebbb6682$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu",
            $116c5e27ebbb6682$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_0nFVCGFSlo _03m2nySHWH _1gBibytvPq"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_1jakNnwiJJ _0nFVCGFSlo _03m2nySHWH _1gBibyo5Iu"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hekY6.default)([
                "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_23rrnHjh6t"
            ])
        })
    });
};
var $116c5e27ebbb6682$export$2e2bcd8739ae039 = $116c5e27ebbb6682$var$ProgressBar;
module.exports["default"] = $116c5e27ebbb6682$export$2e2bcd8739ae039;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("6U5eU", function(module, exports) {

var $7rM80 = parcelRequire("7rM80");

const $9db2e529afbaed9d$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $7rM80.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $9db2e529afbaed9d$export$8a57effc6307f916;

});

parcelRegister("7rM80", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $i3S9F = parcelRequire("i3S9F");


var $iQwJa = parcelRequire("iQwJa");


var $1RMKR = parcelRequire("1RMKR");


var $gswTK = parcelRequire("gswTK");


var $1NJu1 = parcelRequire("1NJu1");


var $1722n = parcelRequire("1722n");


var $ll379 = parcelRequire("ll379");

var $qzjr4 = parcelRequire("qzjr4");


var $8BCsI = parcelRequire("8BCsI");

const $63c899b662d40d3e$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $8BCsI.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $1RMKR.useStableObject)(context);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gswTK.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $qzjr4.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $63c899b662d40d3e$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $63c899b662d40d3e$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $1722n.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $1NJu1.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $63c899b662d40d3e$export$8a57effc6307f916;

});

parcelRegister("1722n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c99625c3d1d9a9b2$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $cozmU.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $c99625c3d1d9a9b2$export$3d127465d22fe4e5;

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("9UEKm", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.atlassian-store":[{"type":0,"value":"Marketplace apps"}],"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence-inline-reactions-nudge.description.many-reactions":[{"type":1,"value":"user1"},{"type":0,"value":", "},{"type":1,"value":"user2"},{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" other"},{"offset":0,"options":{"one":{"value":[]},"other":{"value":[{"type":0,"value":"s"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.description.no-reactions":[{"type":0,"value":"Be the first one to react"}],"confluence-inline-reactions-nudge.description.one-reaction":[{"type":1,"value":"user"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.description.two-reactions":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.title":[{"type":0,"value":"Love this page? Let "},{"type":1,"value":"authorName"},{"type":0,"value":" know"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-prioritization-template.jpd.title":[{"type":0,"value":"Prioritize ideas"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.app-switcher-discovery-section.app-name":[{"type":0,"value":"Atlas"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.app-switcher-discovery-section.app-name":[{"type":0,"value":"Confluence"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Product Discovery"}],"growth.recommendation-jpd.app-switcher-discovery-section.template-name":[{"type":0,"value":"Product roadmap"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Service Management"}],"growth.recommendation-jsm.app-switcher-discovery-section.template-name":[{"type":0,"value":"Work requests"}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Work Management"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.app-switcher-discovery-section.app-name":[{"type":0,"value":"Loom"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.app-switcher-discovery-section.app-name":[{"type":0,"value":"Opsgenie"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.twc-apps-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-product-benefits-description":[{"type":0,"value":"Run your whole project seamlessly"}],"growth.recommendation-twc.twc-apps-product-benefits-title":[{"type":0,"value":"1 collection, 4 tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.feedback.title":[{"type":0,"value":"Thanks for your feedback"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.jira-board-catch-up-rovo-nudge.secondary-title":[{"type":0,"value":"Get a quick summary of new issues and important activity."}],"post-office.growth.jira-board-catch-up-rovo-nudge.static-prompt":[{"type":0,"value":"Summarize the most recent activity on this Jira board. Create an executive-ready update (max ~8 bullets total) using this structure: 1. Sprint / timeline context\\n- Current sprint or time window, dates, and high-level status (e.g. \\"on track / at risk / off track\\"). 2. Key progress / wins (2-4 bullets)\\n- Focus on issues that moved into In Progress, In Review / Pending Review, or Done in the selected period.\\n- For each, include: issue key, short description (3-7 words), and current status only (no technical deep dive). 3. Blockers / risks (1-3 bullets)\\n- Call out any flagged issues, long-running items stuck in In Progress or In Review, or dependencies that could impact delivery for this sprint / period. 4. Scope & pipeline (1-3 bullets)\\n- Highlight important newly created or To Do issues that are not yet started but are significant for upcoming milestones.\\n- Note if work is skewed toward setup/foundations vs user-visible outcomes. 5. Next-focus recommendation (1-2 bullets)\\n- Recommend the 1-2 highest-leverage next actions to keep the team\'s objectives on track, referencing specific issue keys. Output the answer as concise markdown bullets, optimized for an executive audience (outcomes, risks, and next moves over implementation details)."}],"post-office.growth.jira-board-catch-up-rovo-nudge.title":[{"type":0,"value":"Catch up on recent changes"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork":[{"type":0,"value":"the tools you use (Jira)"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify":[{"type":0,"value":"the way you use your existing tools and apps"}],"post-office.nav-4-projects-recommendations.reasons-modal-explanation":[{"type":0,"value":"We think "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"rovo-3p-party-integration-admin-nudge.action.connect":[{"type":0,"value":"Connect now"}],"rovo-3p-party-integration-admin-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps":[{"type":0,"value":"Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.low-percentage":[{"type":0,"value":"Most of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.one-app":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.more-apps-label":[{"type":0,"value":"More apps"}],"rovo-3p-party-integration-admin-nudge.title.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("l90AK", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.app-switcher-discovery-section.description.no-translate\":[{\"type\":0,\"value\":\"Post Office app-switcher-discovery-section template message.\"}],\"post-office-template.app-switcher-discovery-section.title.no-translate\":[{\"type\":0,\"value\":\"Jira Software\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"post-office-template.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"post-office-template.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("azX2I", function(module, exports) {
module.exports = JSON.parse('{"admin-hub.ci-test.message-template-template-hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"ci-generation.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ci-generation.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ci-generation.email.body.img.alt":[{"type":0,"value":"This is the alt text for the image"}],"ci-generation.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ci-generation.email.body.signoff":[{"type":0,"value":"Regards,"}],"ci-generation.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ci-generation.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"post-office.test-message-digest-email-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-email-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-local-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-local-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-threshold-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-threshold-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-microsoft-teams.sample-hello-message":[{"type":0,"value":"Hello, this is test message from Post Office: "},{"type":1,"value":"text"}],"post-office.test-message.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":"."}],"post-office.test-messages.test-message-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-digest-slack-v2.heading.no-translate":[{"type":0,"value":"Post Office Slack digest v2 delivered "},{"type":1,"value":"count"},{"type":0,"value":" messages"}],"post-office.test-messages.test-message-digest-slack-v2.item.no-translate":[{"type":0,"value":"V2 item: "},{"type":1,"value":"message"}],"post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a redacted test mobile push notification from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.greeting.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate":[{"type":0,"value":"Hello, this is a redacted mobile push notification test from post office."}],"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-slack-notification-v2.sample-hello-message.no-translate":[{"type":0,"value":"Post Office Slack digest v2 source: "},{"type":1,"value":"message"}],"post-office.test-slack-notification.sample-hello-message":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"product-store-personal-use-case.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}],"test-message.test-message-email-onboarding-test.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-message.test-message-email-onboarding-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-message.test-message-email-onboarding-test.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-message.test-message-email-onboarding-test.test-message.email.body.no-translate":[{"type":0,"value":"This is an test onboarding message for "},{"type":1,"value":"team"},{"type":0,"value":" team from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-message.test-message-email-onboarding-test.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-message.test-message-email-onboarding-test.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-message.test-message-email-onboarding-test.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.app-switcher-discovery-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-discovery-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.app-switcher-upgrade-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-upgrade-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.in-app-example.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.in-app-notification-comment-rollup.second-comment":[{"type":1,"value":"actor"},{"type":0,"value":" commented on a page"}],"test-messages.in-app-notification-mention-rollup.first-comment":[{"type":1,"value":"reactor"},{"type":0,"value":" mentioned you in a comment"}],"test-messages.in-app-notification-reaction-rollup.many-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"otherActorsCount"},{"type":0,"value":" others reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.one-actor":[{"type":1,"value":"actor1Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.two-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"actor2Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification.email-onboarding.body":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":", This is an onboarding test message for "},{"type":1,"value":"team"},{"type":0,"value":" team."}],"test-messages.in-app-notification.email-onboarding.title":[{"type":0,"value":"Welcome!"}],"test-messages.in-app-notification.title":[{"type":0,"value":"Test Notification "},{"type":1,"value":"title"}],"test-messages.jira-navigation-topbar-edition-awareness.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.post-office-gold-1.description.no-translate":[{"type":0,"value":"Post Office Gold test message."}],"test-messages.post-office-gold-1.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.redacted-email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate":[{"type":0,"value":"Post Office Redacted Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-client-generation.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-client-generation.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-client-generation.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-client-generation.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-client-generation.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-config-sets.in-app.cs-0.flag.body.no-translate":[{"type":0,"value":"This is the cs-0 test message body"}],"test-messages.test-message-config-sets.in-app.cs-0.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-0)"}],"test-messages.test-message-config-sets.in-app.cs-0.learn-more.no-translate":[{"type":0,"value":"Learn more"}],"test-messages.test-message-config-sets.in-app.cs-1.flag.body.no-translate":[{"type":0,"value":"This is the cs-1 test message body"}],"test-messages.test-message-config-sets.in-app.cs-1.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-1)"}],"test-messages.test-message-config-sets.in-app.cs-2.flag.body.no-translate":[{"type":0,"value":"This is the cs-2 test message body"}],"test-messages.test-message-config-sets.in-app.cs-2.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-2)"}],"test-messages.test-message-config-sets.in-app.cs-chat-app-notification.flag.body.no-translate":[{"type":0,"value":"This is the cs-chat-app-notification test message body"}],"test-messages.test-message-config-sets.in-app.cs-chat-app-notification.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-chat-app-notification)"}],"test-messages.test-message-config-sets.in-app.cs-email.flag.body.no-translate":[{"type":0,"value":"This is the cs-email test message body"}],"test-messages.test-message-config-sets.in-app.cs-email.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-email)"}],"test-messages.test-message-config-sets.in-app.cs-in-app-v2.flag.body.no-translate":[{"type":0,"value":"This is the cs-in-app-v2 test message body"}],"test-messages.test-message-config-sets.in-app.cs-in-app-v2.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-in-app-v2)"}],"test-messages.test-message-config-sets.in-app.cs-in-app.flag.body.no-translate":[{"type":0,"value":"This is the cs-in-app test message body"}],"test-messages.test-message-config-sets.in-app.cs-in-app.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-in-app)"}],"test-messages.test-message-config-sets.in-app.cs-message-objective-fatigue.flag.body.no-translate":[{"type":0,"value":"This is the cs-message-objective-fatigue test message body"}],"test-messages.test-message-config-sets.in-app.cs-message-objective-fatigue.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-message-objective-fatigue)"}],"test-messages.test-message-config-sets.in-app.cs-push-channels.flag.body.no-translate":[{"type":0,"value":"This is the cs-push-channels test message body"}],"test-messages.test-message-config-sets.in-app.cs-push-channels.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-push-channels)"}],"test-messages.test-message-config-sets.in-app.flag.body.no-translate":[{"type":0,"value":"This is the test message body"}],"test-messages.test-message-config-sets.in-app.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-content-diffing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-content-diffing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-delivery-control.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-delivery-control.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.body.no-translate":[{"type":1,"value":"body"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.title.no-translate":[{"type":0,"value":"Template Notification "},{"type":1,"value":"title"}],"test-messages.test-message-delivery-control.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-delivery-control.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-delivery-control.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-delivery-control.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-delivery-control.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-credit-requests-table.email.action-unavailable.no-translate":[{"type":0,"value":"Unavailable"}],"test-messages.test-message-digest-credit-requests-table.email.allocate.no-translate":[{"type":0,"value":"Allocate"}],"test-messages.test-message-digest-credit-requests-table.email.heading.no-translate":[{"type":0,"value":"Approve credit requests"}],"test-messages.test-message-digest-credit-requests-table.email.subject.no-translate":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new request for more credits"}]},"other":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new requests for more credits"}]}},"pluralType":"cardinal","type":6,"value":"requestCount"}],"test-messages.test-message-digest-credit-requests-table.email.summary.empty.no-translate":[{"type":0,"value":"There are no credit requests to review."}],"test-messages.test-message-digest-credit-requests-table.email.summary.many.no-translate":[{"type":1,"value":"firstName"},{"type":0,"value":", "},{"type":1,"value":"secondName"},{"type":0,"value":" and "},{"type":1,"value":"otherCount"},{"type":0,"value":" others from your organization have sent requests to increase their Rovo credit limit."}],"test-messages.test-message-digest-credit-requests-table.email.summary.one.no-translate":[{"type":1,"value":"firstName"},{"type":0,"value":" from your organization has sent a request to increase their Rovo credit limit."}],"test-messages.test-message-digest-credit-requests-table.email.summary.two.no-translate":[{"type":1,"value":"firstName"},{"type":0,"value":" and "},{"type":1,"value":"secondName"},{"type":0,"value":" from your organization have sent requests to increase their Rovo credit limit."}],"test-messages.test-message-digest-credit-requests-table.email.table.aaid.no-translate":[{"type":0,"value":"ID"}],"test-messages.test-message-digest-credit-requests-table.email.table.action.no-translate":[{"type":0,"value":"Action"}],"test-messages.test-message-digest-credit-requests-table.email.table.sequence.no-translate":[{"type":0,"value":"S. No."}],"test-messages.test-message-digest-credit-requests-table.email.table.username.no-translate":[{"type":0,"value":"User"}],"test-messages.test-message-digest-credit-requests-table.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-local.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-local.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-threshold.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-threshold.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-threshold.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-threshold.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-threshold.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-threshold.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-threshold.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-cdn.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-cdn.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-cdn.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-cdn.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-cdn.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate":[{"type":0,"value":"Click me!"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-high-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-log-dropping.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-log-dropping.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-log-dropping.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-log-dropping.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-log-dropping.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-log-dropping.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-log-dropping.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-low-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-low-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-mfc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-mfc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate":[{"type":0,"value":"This is a redacted test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-grouped-recipients.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-grouped-recipients.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-grouped-recipients.test-message.email.body.hello":[{"type":0,"value":"Hello"}],"test-messages.test-message-grouped-recipients.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-grouped-recipients.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-comment-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-mention-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-reaction-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-ep-modal.confirm.no-translate":[{"type":0,"value":"OK"}],"test-messages.test-message-inapp-ep-modal.description.no-translate":[{"type":0,"value":"We\'re also improving how we incorporate the terms you use to define work, so that Jira speaks your language \u2014 no matter what you\'re working on."}],"test-messages.test-message-inapp-ep-modal.read-more.no-translate":[{"type":0,"value":"Read more"}],"test-messages.test-message-inapp-ep-modal.title.no-translate":[{"type":0,"value":"\'Work\' is the new term for items tracked in Jira"}],"test-messages.test-message-inapp-implicit-pendo.description.no-translate":[{"type":0,"value":"Implicit Pendo test message."}],"test-messages.test-message-inapp-implicit-pendo.title.no-translate":[{"type":0,"value":"Conquering "},{"type":1,"value":"planet"},{"type":0,"value":" is "},{"type":1,"value":"status"}],"test-messages.test-message-inapp.description.no-translate":[{"type":0,"value":"Post Office in-app test message."}],"test-messages.test-message-inapp.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Kind Regards,"}],"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.heading.no-translate":[{"type":0,"value":"Origin Tracing \u2014 Tracked Link Test ("},{"type":1,"value":"env"},{"type":0,"value":")"}],"test-messages.test-message-link-tracking.email.intro.no-translate":[{"type":0,"value":"This email tests Post Office tracked links. Tracked links go through the Post Office redirect service; plain links do not. Click each link and inspect the redirect URL to verify origin tracing."}],"test-messages.test-message-link-tracking.email.tracked-link-atl-origin.no-translate":[{"type":0,"value":"TrackedLink with atlOrigin param"}],"test-messages.test-message-link-tracking.email.tracked-link-atlassian.no-translate":[{"type":0,"value":"TrackedLink to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.tracked-link-external.no-translate":[{"type":0,"value":"TrackedLink to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.tracked-link-pdf.no-translate":[{"type":0,"value":"TrackedLink to PDF"}],"test-messages.test-message-link-tracking.email.tracked-link-tenanted.no-translate":[{"type":0,"value":"TrackedLink to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.tracked-section.no-translate":[{"type":0,"value":"Tracked links"}],"test-messages.test-message-link-tracking.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.untracked-link-atl-origin.no-translate":[{"type":0,"value":"Plain link with atlOrigin param"}],"test-messages.test-message-link-tracking.email.untracked-link-atlassian.no-translate":[{"type":0,"value":"Plain link to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.untracked-link-external.no-translate":[{"type":0,"value":"Plain link to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.untracked-link-pdf.no-translate":[{"type":0,"value":"Plain link to PDF"}],"test-messages.test-message-link-tracking.email.untracked-link-tenanted.no-translate":[{"type":0,"value":"Plain link to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.untracked-section.no-translate":[{"type":0,"value":"Plain (untracked) links"}],"test-messages.test-message-load-test-pull-screen-space-flags.description.no-translate":[{"type":0,"value":"Synthetic message for GCP staging pull load tests."}],"test-messages.test-message-load-test-pull-screen-space-flags.title.no-translate":[{"type":0,"value":"Post Office GCP load test"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-marketing.app-switcher-discovery-section.description.no-translate":[{"type":0,"value":"Post Office app-switcher-discovery-section marketing test message."}],"test-messages.test-message-marketing.app-switcher-discovery-section.title.no-translate":[{"type":0,"value":"Jira Software"}],"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-marketing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-marketing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-marketing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-marketing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-message-failures.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-message-failures.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-microsoft-teams-v2-digest.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"test-messages.test-message-microsoft-teams-v2.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"test-messages.test-message-narrow-exposure-experiment-v2.description.no-translate":[{"type":0,"value":"This message tests the second narrow-exposure experiment."}],"test-messages.test-message-narrow-exposure-experiment-v2.title.no-translate":[{"type":0,"value":"Post Office narrow-exposure v2 test message"}],"test-messages.test-message-narrow-exposure-experiment.description.no-translate":[{"type":0,"value":"This message is used to test narrow-exposure experiments."}],"test-messages.test-message-narrow-exposure-experiment.title.no-translate":[{"type":0,"value":"Post Office test message"}],"test-messages.test-message-nd-ni-influents-mapper.influents.message-main.no-translate":[{"type":0,"value":"Main line ("},{"type":1,"value":"text"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.action.no-translate":[{"type":0,"value":"Open ("},{"type":1,"value":"emoji"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.entity.no-translate":[{"type":0,"value":"Entity for "},{"type":1,"value":"team"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.path.no-translate":[{"type":0,"value":"Path ("},{"type":1,"value":"team"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.title.no-translate":[{"type":0,"value":"Team "},{"type":1,"value":"teamName"},{"type":0,"value":" update"}],"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-no-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-no-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"This is a TrackedLink that isn\'t being tracked!"}],"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-notifications-platform.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"test-messages.test-message-persona-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-persona-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-persona-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-persona-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-persona-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-persona-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate":[{"type":1,"value":"greeting"}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi,"}],"test-messages.test-message-raw-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-tap-ingestion-trigger-subscription.description.no-translate":[{"type":0,"value":"TAP ingestion trigger subscription test message."}],"test-messages.test-message-tap-ingestion-trigger-subscription.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-tap-ingestion-trigger-subscription.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-tap-ingestion-trigger-subscription.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-transform-metadata.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-triggered.description.no-translate":[{"type":0,"value":"This triggered message tests narrow-exposure experiments."}],"test-messages.test-message-triggered.title.no-translate":[{"type":0,"value":"Post Office triggered test message"}],"test-messages.test-message.app.img.alt.large":[{"type":0,"value":"test image 2"}],"test-messages.test-message.app.img.alt.plant":[{"type":0,"value":"test image 1"}],"test-messages.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.redacted-email.body":[{"type":0,"value":"This is the redacted version of the test email message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.redacted-email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.redacted-email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.redacted-email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.redacted-email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"wac-global-nav-product-recommendation.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}]}');

});

parcelRegister("2tp0D", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $4OYR1 = parcelRequire("4OYR1");


var $jTNdj = parcelRequire("jTNdj");


var $o0RSX = parcelRequire("o0RSX");


var $k4HA2 = parcelRequire("k4HA2");


var $b4B1V = parcelRequire("b4B1V");


var $d4rpM = parcelRequire("d4rpM");


var $gKIF0 = parcelRequire("gKIF0");


var $bP5wt = parcelRequire("bP5wt");


var $44R0O = parcelRequire("44R0O");


var $jS1GQ = parcelRequire("jS1GQ");


var $1NVwf = parcelRequire("1NVwf");


var $8BCsI = parcelRequire("8BCsI");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $g7aP0 = parcelRequire("g7aP0");


var $1dHYE = parcelRequire("1dHYE");

const $210c900388def499$var$STABLE_EMPTY_OBJECT = {};
const $210c900388def499$export$7192d943ff7d5979 = 'post-office_enable_narrow-exposure-classic';
const $210c900388def499$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        ...props,
        children: children
    });
};
const $210c900388def499$export$7b7e5a348ef9a7c1 = (messageComponents, _placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $cozmU.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), ...data })=>{
            const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $cozmU.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $4OYR1.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $o0RSX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $o0RSX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                        name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $jS1GQ.isClientTriggeredMessage)(triggerType);
                const isNarrowExposureClassicEnabled = (0, $cXtTj.default).checkGate($210c900388def499$export$7192d943ff7d5979);
                const narrowExposureConfig = isNarrowExposureClassicEnabled ? inAppNarrowExposureExperiment : undefined;
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $bP5wt.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    inAppNarrowExposureExperiment: narrowExposureConfig
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $cozmU.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId,
                    messageCategory
                ]);
                if (inAppNarrowExposureExperiment && !isNarrowExposureClassicEnabled) return null;
                const message = /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
                    fallback: loadingComponent,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gKIF0.MaybeTriggeredMessageValidator), {
                        waitForTrigger: waitForTrigger,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4B1V.MessageAnalyticsContextProvider), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $44R0O.MaybeManualMessageViewedEvent), {
                                isManual: !!waitForTrigger,
                                children: [
                                    !waitForTrigger && messageSuccessComponent,
                                    /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                                        onError: onError,
                                        messageInstanceId: messageInstanceId,
                                        ...componentProps,
                                        waitForTrigger: waitForTrigger,
                                        inAppNarrowExposureExperiment: narrowExposureConfig
                                    })
                                ]
                            })
                        })
                    })
                });
                const withMessageContext = (children)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                        value: messageContextValue,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                            value: recommendationSession ?? $210c900388def499$var$STABLE_EMPTY_OBJECT,
                            children: children
                        })
                    });
                // MaybeChoreographerWrapper sits above the lazy chunk so it can claim its slot while
                // loading; it no-ops for client-triggered messages, which handle their own
                // choreography via MaybeTriggeredMessageValidator.
                const withChoreographer = (children)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dHYE.MaybeChoreographerWrapper), {
                        ChoreographerWrapper: (0, $g7aP0.ChoreographerWrapper),
                        enabled: !waitForTrigger,
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        inAppNarrowExposureExperiment: narrowExposureConfig,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4rpM.FeatureFlaggedUfoWrapper), {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: children
                        })
                    });
                // A narrow exposure shouldClaim needs message and recommendation context above the
                // choreographer to post a dropped event for this message.
                return isNarrowExposureClassicEnabled ? withMessageContext(withChoreographer(message)) : withChoreographer(withMessageContext(message));
            };
            return (0, $8BCsI.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $210c900388def499$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $210c900388def499$export$7b7e5a348ef9a7c1;

});

parcelRegister("4OYR1", function(module, exports) {

var $jAbAo = parcelRequire("jAbAo");


var $8fXDz = parcelRequire("8fXDz");

const $baf07cb19e3d1dfe$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jAbAo.MessagePerformanceTracker,
    PlacementPerformanceTracker: $8fXDz.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $baf07cb19e3d1dfe$export$96236906ebaa7f87;

});

parcelRegister("jAbAo", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

class $01005f2678a8118a$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $01005f2678a8118a$export$ae5c73c7c4f454e6;

});

parcelRegister("8UDja", function(module, exports) {
const $21c39d458f004fb5$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $21c39d458f004fb5$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $21c39d458f004fb5$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $21c39d458f004fb5$export$6d482cfa20c9d220;

});

parcelRegister("8fXDz", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

const $e2ea1aa57de97a70$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $gZFfs.ExperienceTypes).Load,
    platform: {
        component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $e2ea1aa57de97a70$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).PLACEMENT, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).PLACEMENT}.${placementId}`, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $e2ea1aa57de97a70$export$8b48c2105ba0b35a;

});

parcelRegister("o0RSX", function(module, exports) {
//#region src/index.ts

var $ddnoW = parcelRequire("ddnoW");

let $0482ea6551d2dfec$export$b9722560029694e7 = /* @__PURE__ */ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["ConfigSetNotFoundError"] = "ConfigSetNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["MessageTemplatePackageMalformedError"] = "MessageTemplatePackageMalformedError";
    PostOfficeErrorCodes["EmptyMessageTemplateRegistryError"] = "EmptyMessageTemplateRegistryError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingDisabledError"] = "TesseractTemplateRuntimeMappingDisabledError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingValidationError"] = "TesseractTemplateRuntimeMappingValidationError";
    return PostOfficeErrorCodes;
}({});
var $0482ea6551d2dfec$export$46f86d28cd0a5d38 = class extends Error {
};
var $0482ea6551d2dfec$export$627bc00a5ef5f6ae = class extends Error {
};
/**
* @deprecated Do not use this pattern. Throwing errors from `hydrate()` to control message
* visibility is an anti-pattern that conflates hydration with filtering.
*
* **Why this is wrong:**
* Filtering decisions (e.g. experiment cohort checks, feature flag gates) belong in the
* filtering/eligibility stage, not inside `hydrate()`. Using errors as control flow here
* risks spreading a pattern that is difficult to reason about, harms observability, and
* fires experiment exposures at the wrong layer.
*
* **What to do instead:**
* - Use **message template filters** to gate visibility based on experiment or feature flag state.
* - For experiment exposure specifically, fire exposures on the Placement Frontend
*   (Narrow-Level Triggering) as described in the official guidance:
*   https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/5372727565/Where+to+fire+exposure+for+experiments+in+Post+Office
* - The long-term platform solution for narrow exposure is tracked in POST-773.
*
* This class will be removed once all existing usages have been migrated.
*/ var $0482ea6551d2dfec$export$66e065cfeb491a4d = class HydrationAbortError extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof HydrationAbortError;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d145ea5319863172 = class extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), (0, $ddnoW._)(this, "code", void 0);
        this.code = code;
    }
};
var $0482ea6551d2dfec$export$69be53c018c89481 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError"), (0, $ddnoW._)(this, "clientName", void 0), (0, $ddnoW._)(this, "operationName", void 0), (0, $ddnoW._)(this, "status", void 0), (0, $ddnoW._)(this, "graphQLErrorMessage", void 0), (0, $ddnoW._)(this, "errors", void 0), (0, $ddnoW._)(this, "sanitisedRequestHeaders", void 0), (0, $ddnoW._)(this, "sanitisedResponseHeaders", void 0), (0, $ddnoW._)(this, "responseBody", void 0);
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6452976adc01572 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(cause, code){
        super($0482ea6551d2dfec$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
};
const $0482ea6551d2dfec$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === "string") return cause;
    return "Unknown error";
};
function $0482ea6551d2dfec$export$4cb1ea6034a33155(error) {
    return typeof error === "object" && !!error && "status" in error && typeof error.status === "number";
}
function $0482ea6551d2dfec$export$aed524b0009b5631(error) {
    return typeof error === "object" && !!error && "logLevel" in error && typeof error.logLevel === "string";
}
var $0482ea6551d2dfec$export$ed601cd0dc1a1be7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(args){
        /**
		* It is expected that this error message can be not deterministic.
		* This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		* Showing the error cause helps them understand what was the problem with their payload.
		*
		* On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		* to distinguish between message makers code errors and platform errors,
		* but we don't rely on the error message itself.
		*/ const errMessage = args.cause instanceof Error ? args.cause.message : "Error in message template code";
        super(errMessage, "MessageTemplateError", args.cause), (0, $ddnoW._)(this, "function", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "triggerId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2833d4759f81601b = class extends $0482ea6551d2dfec$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = "Invalid CSS property could not be processed by Juice";
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8d39b103586e9fd4 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$f649da38897d27f7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2852c1c4d9aba3e = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4b7b4e09547e4bb3 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$360a094a97597d87 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4d068b43eb55165b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ac007ee150add337 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$19cb89dd679394cb = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$78651662ad470cc5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template not found", "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$43b3b4535703ed1b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            configSetId: this.configSetId
        };
    }
    constructor(configSetId){
        super(`Config Set with ConfigSetId ${configSetId} could not be found`, "ConfigSetNotFoundError"), (0, $ddnoW._)(this, "configSetId", void 0);
        this.configSetId = configSetId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8a5041670cdd8db2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(journeyId){
        super("Journey not found", "JourneyNotFoundError"), (0, $ddnoW._)(this, "journeyId", void 0);
        this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1240ddc25cf964e6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template action handler validation error", "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3c4884b7ae7fe517 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$913b8e68dc7ae8fe = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Placement not found", "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3dfc27a8d3942f4d = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Renderer received empty response from validator", "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e5ccdf8bbfead7a2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$823733742d803ae6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1caa32527f23acd2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(errorCause){
        super("Failed to send digest event to orchestration queue", "DigestEngineFailedSendError"), (0, $ddnoW._)(this, "errorCause", void 0);
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$a6f2aad8fa094b39 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Unable to get user details for the given account ID", "UnableToGetUserDetailsError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2296e5dc6a1bf3d2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Gateway timeout occurred", "GatewayTimeoutError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2f1e27130c2bf271 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError"), (0, $ddnoW._)(this, "payloadSize", void 0);
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d0dc094613469f2b = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message), (0, $ddnoW._)(this, "workspaceId", void 0);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5603eab37ce562f5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(fileType){
        super("The attachment file is not supported", "UnsupportedAttachmentType"), (0, $ddnoW._)(this, "fileType", void 0);
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e0e9aa0e9c6b37ff = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader"), (0, $ddnoW._)(this, "error", void 0);
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3ad818f64601e141 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$25470bb6cba4fba0 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super("messageTemplateId not supported by placement", "UnsupportedMessageAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ce14d445679448b6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? "unknown error", "HydrationFailureAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
};
var $0482ea6551d2dfec$export$c9a26a17db1045c8 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super("All messages failed at placement", "AllMessagesFailureHydrationAtPlacementError"), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8ab4fb362168b928 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Unexpected invocation of validate() function for push delivery channel", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2afd69f57fe5285f = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Recipient expander not found for mapper", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$7635d2b1a281d626 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError"), (0, $ddnoW._)(this, "errors", void 0);
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$90bef7fa95eca3fa = class extends Error {
    constructor(status){
        super("Posting Mobile Notifications message failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6d1a4929f6ff1a32 = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c19fc5e8aa4e064d = class extends Error {
    constructor(){
        super("Ingestion source is required when custom profile is specified");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2d3a68dab93b8cc4 = class extends Error {
    constructor(){
        super("A renderRedacted function is required when redactionLevel is set to a non-null value");
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$175c1dbb0d7c238a = class extends Error {
    constructor(status){
        super("Enqueueing email failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$23fab744b3076342 = class extends Error {
    constructor(message, status){
        super(message), (0, $ddnoW._)(this, "message", void 0), (0, $ddnoW._)(this, "status", void 0);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$194adecfa0265ea1 = class extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg), (0, $ddnoW._)(this, "msg", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$c504492f06c975b5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super("hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user", "HydrationDeliveryNoDataFoundError"), (0, $ddnoW._)(this, "ipmNumber", void 0), (0, $ddnoW._)(this, "variantFromStatsig", void 0), (0, $ddnoW._)(this, "contentfulLocale", void 0);
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Error thrown when an upstream service (e.g., Atlassian Mail, Mobile Notifications, TCS)
* returns a retryable error status code (e.g. 500, 502, 503, 504).
*
* An SQS message that encounters this error will be retried.
*
* Only the final retry will be counted against our reliability SLOs and canary analysis.
*/ var $0482ea6551d2dfec$export$1c932b9d1680ee0b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5d5d1885c87ef4bc = class extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Wraps an error thrown while running a recipient expander. Carries the expander key and message
* template id so they can be surfaced in logs and used to emit the recipient expander SLO metric.
*
* Co-located here with {@link UnretryableError} so a dedicated serializer can live in
* `@post-office/error-serializers` (the expander-specific fields are otherwise dropped by the
* generic error serializer).
*/ var $0482ea6551d2dfec$export$85497ede72633b85 = class extends $0482ea6551d2dfec$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Unretryable variant of {@link RecipientExpanderError}, thrown when an expander fails with a
* non-retryable error. The originating error is preserved as the `cause`.
*/ var $0482ea6551d2dfec$export$359a331da49d1ec8 = class extends $0482ea6551d2dfec$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        }), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Thrown when a message template package loads but is missing one or more exports that every
* template is required to have. In production the bundler intermittently produces module
* namespaces with re-exported bindings missing, which is decided once per process and then
* permanent. Detection uses a sentinel export rather than an exhaustive check, so `missingFields`
* reports what was inspected, not every binding the bundler actually dropped.
*
* Callers must treat this as a platform failure and let the message retry onto a healthy process;
* never as "the template has no subscriptions/config", which silently discards traffic.
*/ var $0482ea6551d2dfec$export$8506e646874f88f6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            missingFields: this.missingFields.join(",")
        };
    }
    constructor(messageTemplateId, missingFields){
        super("Message template package loaded without required exports", "MessageTemplatePackageMalformedError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "missingFields", void 0);
        this.messageTemplateId = messageTemplateId;
        this.missingFields = missingFields;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Thrown when the message template registry reports zero templates. There is no legitimate state in
* which Post Office has no templates, so callers must retry rather than read it as "nobody is
* subscribed"; the latter acks the message and discards it permanently.
*/ var $0482ea6551d2dfec$export$6a4077faeb1c609 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message template registry returned no templates", "EmptyMessageTemplateRegistryError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2cfe2317dcfcabb = class extends Error {
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
    constructor(deliveryChannel){
        super("Duplicate message detected"), (0, $ddnoW._)(this, "deliveryChannel", void 0);
        this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
const $0482ea6551d2dfec$export$fec3468114498229 = (value)=>typeof value === "object" && value !== null && Object.values(value).every((field)=>field === void 0 || field === null || typeof field === "string" || typeof field === "number" || typeof field === "boolean");
 //# sourceMappingURL=index.mjs.map
module.exports["InvalidMessageTemplateIdError"] = $0482ea6551d2dfec$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0482ea6551d2dfec$export$3dfc27a8d3942f4d;

});

parcelRegister("g7aP0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $5ydwr = parcelRequire("5ydwr");


var $khbFI = parcelRequire("khbFI");


var $9TNXZ = parcelRequire("9TNXZ");


var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");

const $2adf26225a469e82$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldClaim = (0, $5ydwr.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        shouldClaim: shouldClaim
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$var$NarrowExposureComponent = ({ children: children, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const shouldRender = (0, $khbFI.useNarrowExposureShouldRender)(inAppNarrowExposureExperiment);
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
                children: children
            });
        }
        // The choreographer won't offer this message a slot, so check its experiment here. With the
        // choreographer off, placements run the check themselves.
        if (inAppNarrowExposureExperiment) return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$NarrowExposureComponent, {
            inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $2adf26225a469e82$export$8db7ba034addcd65;

});

parcelRegister("khbFI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kEPax = parcelRequire("kEPax");


var $k4HA2 = parcelRequire("k4HA2");


var $fklDH = parcelRequire("fklDH");


var $eke7R = parcelRequire("eke7R");

const $5be779e57f4885b6$export$72c63079067610b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $bDgLe.c)(7);
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const { messageInstanceDropped: messageInstanceDropped } = (0, $kEPax.useMessageInstanceEvent)();
    let t0;
    if ($[0] !== config) {
        t0 = config ? (0, $eke7R.evaluateCohort)(config) : undefined;
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const decision = t0;
    let t1;
    if ($[2] !== config || $[3] !== decision || $[4] !== messageInstanceDropped || $[5] !== messageInstanceId) {
        t1 = ()=>{
            if (config && decision && decision.outcome !== "show") (0, $fklDH.postNarrowExposureDrop)(messageInstanceDropped, messageInstanceId, config, decision);
        };
        $[2] = config;
        $[3] = decision;
        $[4] = messageInstanceDropped;
        $[5] = messageInstanceId;
        $[6] = t1;
    } else t1 = $[6];
    (0, $cozmU.useEffect)(t1);
    return !decision || decision.outcome === "show";
} : (config)=>{
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const { messageInstanceDropped: messageInstanceDropped } = (0, $kEPax.useMessageInstanceEvent)();
    const decision = config ? (0, $eke7R.evaluateCohort)(config) : undefined;
    // The cohort can change between renders, so check each commit; the drop helper deduplicates.
    (0, $cozmU.useEffect)(()=>{
        if (config && decision && decision.outcome !== 'show') (0, $fklDH.postNarrowExposureDrop)(messageInstanceDropped, messageInstanceId, config, decision);
    });
    return !decision || decision.outcome === 'show';
};
module.exports["useNarrowExposureShouldRender"] = $5be779e57f4885b6$export$72c63079067610b3;

});

parcelRegister("5KMtM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aeEJA = parcelRequire("aeEJA");

const $1ae28466f611f1b1$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $cozmU.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $aeEJA.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $1ae28466f611f1b1$export$5523c5f3222291d0;

});

parcelRegister("aeEJA", function(module, exports) {

var $9TNXZ = parcelRequire("9TNXZ");


var $j4yZr = parcelRequire("j4yZr");


var $cozmU = parcelRequire("cozmU");


var $fRJAi = parcelRequire("fRJAi");

class $d65c3221c86fee02$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $d65c3221c86fee02$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $cozmU.useState)((0, $fRJAi.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $cozmU.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $fRJAi.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $fRJAi.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $d65c3221c86fee02$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $fRJAi.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $d65c3221c86fee02$export$8c5224d3af2f3c8b;
module.exports["useData"] = $d65c3221c86fee02$export$c1cf1cf4c5d51937;

});

parcelRegister("fRJAi", function(module, exports) {
const $b02ec9b1100b044c$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $b02ec9b1100b044c$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($b02ec9b1100b044c$export$18a0019e5439b209(res));
};
const $b02ec9b1100b044c$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $b02ec9b1100b044c$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $b02ec9b1100b044c$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });
module.exports["assertResponseIsOk"] = $b02ec9b1100b044c$export$b3732c8ff6f9c463;
module.exports["toLoading"] = $b02ec9b1100b044c$export$f9a5bd0ffba29ffc;
module.exports["toError"] = $b02ec9b1100b044c$export$cc3b967c039ed3e7;
module.exports["toData"] = $b02ec9b1100b044c$export$24a6b176bdc41ce5;

});

parcelRegister("b2eRs", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $j5DVd = parcelRequire("j5DVd");

const $632fca0b42d87e9c$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $632fca0b42d87e9c$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $632fca0b42d87e9c$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $632fca0b42d87e9c$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $632fca0b42d87e9c$export$803c53721d530406 = ()=>(hydrateExample, config)=>$632fca0b42d87e9c$var$exampleHydrator(hydrateExample, config);
const $632fca0b42d87e9c$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $632fca0b42d87e9c$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $632fca0b42d87e9c$export$62864968b8b09cdf(),
        createHydrateExample: $632fca0b42d87e9c$export$803c53721d530406(),
        createTransformMetadata: $632fca0b42d87e9c$export$b4a84c754a962eee()
    });
const $632fca0b42d87e9c$export$7d57dbe7f7617174 = ()=>({
        createValidate: $632fca0b42d87e9c$var$initializeValidate(),
        createRender: $632fca0b42d87e9c$export$7693b71d48f1bf7e()
    });
module.exports["createClientPipeline"] = $632fca0b42d87e9c$export$7d57dbe7f7617174;

});

parcelRegister("9chzr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $ikWHh = parcelRequire("ikWHh");


var $eVcJM = parcelRequire("eVcJM");

const $c64a9e97047f0043$export$6a6a5d23d75b0f62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { selectors: selectors, options: options } = t0;
    let t1;
    if ($[0] !== options || $[1] !== selectors) {
        t1 = (0, $iDrrr.fg)("platform-dst-top-layer-spotlight") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eVcJM.UNSAFE_UpdateOnChange), {
            selectors: selectors,
            options: options
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ikWHh.UNSAFE_UpdateOnChange), {
            selectors: selectors,
            options: options
        });
        $[0] = options;
        $[1] = selectors;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ selectors: selectors, options: options })=>(0, $iDrrr.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eVcJM.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ikWHh.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    });
module.exports["UNSAFE_UpdateOnChange"] = $c64a9e97047f0043$export$6a6a5d23d75b0f62;

});

parcelRegister("ikWHh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");


var $j8G8s = parcelRequire("j8G8s");

const $2507bbd5b7af8817$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $2507bbd5b7af8817$export$6a6a5d23d75b0f62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { selectors: t1, options: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [
            "body"
        ] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const selectors = t3;
    const options = t2 === undefined ? $2507bbd5b7af8817$var$defaultOptions : t2;
    const { popoverContent: popoverContent } = (0, $cozmU.useContext)((0, $j8G8s.SpotlightContext));
    const { update: update } = popoverContent;
    let t4;
    let t5;
    if ($[2] !== options || $[3] !== selectors || $[4] !== update) {
        t4 = ()=>{
            if (!update || selectors.length === 0) return;
            const doc = (0, $1hQ0e.getDocument)();
            if (!doc) return;
            const elements = new Set();
            selectors.forEach((selector)=>{
                const element = doc.querySelector(selector);
                if (!element) return;
                elements.add(element);
            });
            if (elements.size === 0) return;
            const observers = [];
            elements.forEach((element_0)=>{
                const observer = new MutationObserver((mutations)=>{
                    if (mutations.length === 0) return;
                    update();
                });
                observer.observe(element_0, options);
                observers.push(observer);
            });
            return ()=>{
                observers.forEach($2507bbd5b7af8817$var$_temp);
            };
        };
        t5 = [
            selectors,
            options,
            update
        ];
        $[2] = options;
        $[3] = selectors;
        $[4] = update;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return null;
} : ({ selectors: selectors = [
    'body'
], options: options = $2507bbd5b7af8817$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $cozmU.useContext)((0, $j8G8s.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $cozmU.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element_0)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element_0, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer_0)=>observer_0.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
function $2507bbd5b7af8817$var$_temp(observer_0) {
    return observer_0.disconnect();
}
module.exports["UNSAFE_UpdateOnChange"] = $2507bbd5b7af8817$export$6a6a5d23d75b0f62;

});

parcelRegister("eVcJM", function(module, exports) {
const $40d232a496003659$export$6a6a5d23d75b0f62 = (_props)=>null;
module.exports["UNSAFE_UpdateOnChange"] = $40d232a496003659$export$6a6a5d23d75b0f62;

});

parcelRegister("4PUA8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $4Df0x = parcelRequire("4Df0x");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1c9a1ac3a4cee6e2$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
const $1c9a1ac3a4cee6e2$export$a88b0b0da9ef63ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConfluenceLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Confluence" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
            svg: $1c9a1ac3a4cee6e2$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function ConfluenceLogoCS({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
        svg: $1c9a1ac3a4cee6e2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ConfluenceLogoCS"] = $1c9a1ac3a4cee6e2$export$a88b0b0da9ef63ce;

});

parcelRegister("4Df0x", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6cf4ce054ddb9b6b$var$styles = {
    root: "_3iDTPbvbI6 _26BoRwdnbC",
    TEMP_assets: "_0C0F9q1qiM"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $6cf4ce054ddb9b6b$var$logoTextColorMap = {
    light: "_1UtDYzRvDB",
    dark: "_1UtDYzZU00"
};
const $6cf4ce054ddb9b6b$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$textLightAppearanceMap = {
    brand: "_07PX8Iy7kJ",
    neutral: "_07PX8IBRVV",
    inverse: "_07PX8It28M",
    legacy: "_07PX8It28M"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$textDarkAppearanceMap = {
    brand: "_07PX8Iy7kJ",
    neutral: "_07PX8InrF4",
    inverse: "_07PX8ICl79",
    legacy: "_07PX8It28M"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z66PYH _05MzPYmPNR _0Yajk0kYsX _40KAGSJ5Ia",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
const $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LogoWrapper(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { appearance: t1, size: t2, svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: t3, type: t4 } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const size = t2 === undefined ? "small" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    const t5 = customIconColor === "inherit" ? customTextColor : customIconColor;
    const t6 = customTextColor || "inherit";
    let t7;
    if ($[0] !== t5 || $[1] !== t6) {
        t7 = {
            "--themed-icon-color": t5,
            "--themed-text-color": t6
        };
        $[0] = t5;
        $[1] = t6;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = t7;
    const t9 = label ? label : undefined;
    const t10 = label ? "img" : undefined;
    const t11 = label === "" ? true : undefined;
    const t12 = isCustomThemed ? customThemeSvg : svg;
    let t13;
    if ($[3] !== t12) {
        t13 = {
            __html: t12
        };
        $[3] = t12;
        $[4] = t13;
    } else t13 = $[4];
    const t14 = $6cf4ce054ddb9b6b$var$logoTextColorMap[colorMode ?? "light"];
    const t15 = $6cf4ce054ddb9b6b$var$sizeMap[size];
    const t16 = colorMode === "dark" ? $6cf4ce054ddb9b6b$var$textDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$textLightAppearanceMap[appearance];
    const t17 = colorMode === "dark" ? $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap[appearance];
    const t18 = type === "rovo" ? colorMode === "dark" ? $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap[appearance];
    let t19;
    if ($[5] !== appearance || $[6] !== isAssets || $[7] !== t14 || $[8] !== t15 || $[9] !== t16 || $[10] !== t17 || $[11] !== t18) {
        t19 = (0, $hekY6.default)([
            $6cf4ce054ddb9b6b$var$styles.root,
            t14,
            t15,
            t16,
            t17,
            t18,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $6cf4ce054ddb9b6b$var$styles.TEMP_assets
        ]);
        $[5] = appearance;
        $[6] = isAssets;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
    } else t19 = $[12];
    let t20;
    if ($[13] !== t10 || $[14] !== t11 || $[15] !== t13 || $[16] !== t19 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t20 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: t8,
            "data-testid": testId,
            "aria-label": t9,
            role: t10,
            "aria-hidden": t11,
            dangerouslySetInnerHTML: t13,
            className: t19
        });
        $[13] = t10;
        $[14] = t11;
        $[15] = t13;
        $[16] = t19;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t20;
    } else t20 = $[20];
    return t20;
} : function LogoWrapper({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $6cf4ce054ddb9b6b$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $6cf4ce054ddb9b6b$var$logoTextColorMap[colorMode ?? 'light'],
            $6cf4ce054ddb9b6b$var$sizeMap[size],
            colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$textDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $6cf4ce054ddb9b6b$var$styles.TEMP_assets
        ])
    });
};
module.exports["LogoWrapper"] = $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("5Sv3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $447a164f7d0faf6b$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $447a164f7d0faf6b$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $cozmU.useRef)(null);
    var maxWaitArgs = (0, $cozmU.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $cozmU.useRef)(false);
    var functionTimeoutHandler = (0, $cozmU.useRef)(null);
    var isComponentUnmounted = (0, $cozmU.useRef)(false);
    var debouncedFunction = (0, $cozmU.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $cozmU.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $cozmU.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $cozmU.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $cozmU.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("9V507", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00750e95c1c8f076c12fba5f79fac5d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $738d50ffcc582510$var$_react = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("cozmU")));

var $738d50ffcc582510$var$_iconNew = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $738d50ffcc582510$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-text
 * Usage guidance:
 * Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $738d50ffcc582510$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $738d50ffcc582510$var$_react.default.createElement($738d50ffcc582510$var$_iconNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$738d50ffcc582510$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $738d50ffcc582510$var$_default = module.exports.default = $738d50ffcc582510$var$AiGenerativeTextIcon;

});

parcelRegister("lBLkF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c322ca8bb35efad1$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
});
module.exports["ModalContext"] = $c322ca8bb35efad1$export$ab57792b9b6974a6;

});

parcelRegister("ghNlj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dIRsp = parcelRequire("dIRsp");

const $34284f28bf40f8ea$var$disabledTriggerSelector = ':disabled, [disabled], [aria-disabled="true"]';
function $34284f28bf40f8ea$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $dIRsp.useEntryPointPreload)(load);
    const clickListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            if (nodeRef.current?.matches($34284f28bf40f8ea$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        cancelPreload,
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            if (nodeRef.current?.matches($34284f28bf40f8ea$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            eagerLoad();
        };
    }, [
        cancelPreload,
        eagerLoad
    ]);
    const mouseEnterListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            if (nodeRef.current?.matches($34284f28bf40f8ea$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            preloadReference();
        };
    }, [
        cancelPreload,
        preloadReference
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', mouseEnterListener);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', mouseEnterListener);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        mouseEnterListener,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $34284f28bf40f8ea$export$1ff47f24e06a5d2d;

});

parcelRegister("dIRsp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $d4f85bcbe97d7b23$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $d4f85bcbe97d7b23$var$TIME_TO_INTENT = 200;
function $d4f85bcbe97d7b23$export$57effc2a5e3611f(load) {
    const actions = (0, $cozmU.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $iDrrr.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            if ((0, $iDrrr.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) request.preload?.dispose();
        };
        const cleanupPreload = ()=>{
            request.preload?.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $iDrrr.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $d4f85bcbe97d7b23$var$PRELOAD_MAX_AGE);
            }, $d4f85bcbe97d7b23$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if ((0, $iDrrr.fg)('platform_relay_persist_entrypoint_preloaded_data')) actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}
module.exports["useEntryPointPreload"] = $d4f85bcbe97d7b23$export$57effc2a5e3611f;

});

parcelRegister("jyfWY", function(module, exports) {
/* error-fallback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $cDs9S = parcelRequire("cDs9S");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");

const $b06e63904dfb0f0d$var$styles = {
    flex: "_0aFT5vf5Xk _39xV02N91d"
};
const $b06e63904dfb0f0d$export$8a7ad05c3ee0c78a = ({ error: _, closeModal: closeModal })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $b06e63904dfb0f0d$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end"
    }, closeModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: closeModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "danger"
    }, "Couldn't load dialog content"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, "Something went wrong while loading the dialog content. Dismiss to go back")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: closeModal
    }, "Close")));
};
module.exports["ErrorFallback"] = $b06e63904dfb0f0d$export$8a7ad05c3ee0c78a;

});

parcelRegister("1xDc3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3hJ5V = parcelRequire("3hJ5V");


var $izYSM = parcelRequire("izYSM");

function $71f3689a65ae7009$var$FocusInsideOnLoadInner({ autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    (0, $cozmU.useEffect)(()=>{
        // Fence for if container element doesn't exist, but this is effectively not
        // possible.
        if (!modalRef.current) return;
        // If ref provided, use that first. Else find first focusable element or
        // container if not exists
        if (autoFocusRef?.current) {
            autoFocusRef.current.focus();
            return;
        }
        const firstFocusable = (0, $3hJ5V.getFirstFocusable)({
            container: modalRef.current
        });
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }
        modalRef.current.focus();
    }, [
        autoFocusRef,
        modalRef
    ]);
    return null;
}
function $71f3689a65ae7009$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $izYSM.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71f3689a65ae7009$var$FocusInsideOnLoadInner, {
        autoFocusRef: autoFocusRef,
        modalRef: modalRef
    }));
}
module.exports["FocusInsideOnLoad"] = $71f3689a65ae7009$export$eb58c1f6b41ee511;

});

parcelRegister("izYSM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $dpsRj = parcelRequire("dpsRj");

function $a0018cd6647cf63d$var$SuspendUntilLoaded({ entryPointReference: entryPointReference, children: children }) {
    // The result is intentionally unused — this call exists purely to gate
    // the mount of children on the load completing.
    entryPointReference.getComponent();
    return children;
}
const $a0018cd6647cf63d$var$renderNothing = ()=>null;
function $a0018cd6647cf63d$export$ed96a854f3831b66({ entryPointReference: entryPointReference, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: $a0018cd6647cf63d$var$renderNothing,
        onError: (0, $dpsRj.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a0018cd6647cf63d$var$SuspendUntilLoaded, {
        entryPointReference: entryPointReference
    }, children)));
}
module.exports["WaitForEntryPointLoad"] = $a0018cd6647cf63d$export$ed96a854f3831b66;

});

parcelRegister("fweCp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $2XUAV = parcelRequire("2XUAV");

const $a403242a80e54023$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XUAV.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null));
module.exports["Loading"] = $a403242a80e54023$export$669f6ea7d267feaf;

});

parcelRegister("2XUAV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");

const $959798a9a32c7c0a$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, loadingText));
};
module.exports["LoadingContent"] = $959798a9a32c7c0a$export$4ab3512e4872e6ff;

});

parcelRegister("hLP6B", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d27efa463aaac1e4$var$skeletonItemElemSize = 20;
const $d27efa463aaac1e4$var$styles = {
    root: "_4c065UPgdg _2Y7lL4kG2W _3iDTPbQ4SZ _4kiQYAUF4f _0hPCNLDIqT _1pp6NdYbGa _2Gfj6iQEt6 _47eTBt2AF2 _3wEj0XGsB2 _0GBAIrogpp _0eSLDaHZdu",
    defaultWidth: "_1ShRFFoBHb _0jufqb715P _0KfecEygnw _1v7p3wE1Ft _0pFvyeR1Le _1n9qNYrXaT",
    customWidth: "_2v4nLRyRC6",
    beforeElement: "_3ScelFSPN1 _1lBcDcSPN1 _0tXlYZdnbC _4diMdqGsB2 _3Ku51Iogpp _3QFY1HEbN9 _4bQ7pPFQfX",
    avatar: "_1OimfuS5Zs",
    icon: "_1OimfuzXzM",
    sideNavSkeleton: "_2Y7lL42ADO _1lBcDc9DVM _3QFY1H5zaO _3ScelF9DVM"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $d27efa463aaac1e4$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $d27efa463aaac1e4$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $d27efa463aaac1e4$var$SkeletonItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: t1, isSideNavSkeleton: t2, testId: testId, width: width, xcss: xcss } = t0;
    const isShimmering = t1 === undefined ? false : t1;
    const isSideNavSkeleton = t2 === undefined ? false : t2;
    const t3 = (hasAvatar || hasIcon) && $d27efa463aaac1e4$var$styles.beforeElement;
    const t4 = hasAvatar && $d27efa463aaac1e4$var$styles.avatar;
    const t5 = hasIcon && $d27efa463aaac1e4$var$styles.icon;
    const t6 = width ? $d27efa463aaac1e4$var$styles.customWidth : $d27efa463aaac1e4$var$styles.defaultWidth;
    const t7 = isSideNavSkeleton && $d27efa463aaac1e4$var$styles.sideNavSkeleton;
    const t8 = isShimmering && "";
    const t9 = isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2";
    let t10;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8 || $[6] !== t9 || $[7] !== xcss) {
        t10 = (0, $hekY6.default)([
            $d27efa463aaac1e4$var$styles.root,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8,
            t9,
            xcss
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
        $[7] = xcss;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== width) {
        t11 = {
            "--width": width
        };
        $[9] = width;
        $[10] = t11;
    } else t11 = $[10];
    const t12 = t11;
    let t13;
    if ($[11] !== t10 || $[12] !== t12 || $[13] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t10,
            style: t12,
            "data-testid": testId
        });
        $[11] = t10;
        $[12] = t12;
        $[13] = testId;
        $[14] = t13;
    } else t13 = $[14];
    return t13;
} : ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $d27efa463aaac1e4$var$styles.root,
            (hasAvatar || hasIcon) && $d27efa463aaac1e4$var$styles.beforeElement,
            hasAvatar && $d27efa463aaac1e4$var$styles.avatar,
            hasIcon && $d27efa463aaac1e4$var$styles.icon,
            width ? $d27efa463aaac1e4$var$styles.customWidth : $d27efa463aaac1e4$var$styles.defaultWidth,
            isSideNavSkeleton && $d27efa463aaac1e4$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $d27efa463aaac1e4$export$2e2bcd8739ae039 = $d27efa463aaac1e4$var$SkeletonItem;
module.exports["default"] = $d27efa463aaac1e4$export$2e2bcd8739ae039;

});

parcelRegister("ffVxZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $4f22854d02c31273$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $4f22854d02c31273$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
const $4f22854d02c31273$export$6da5aa77c402ba0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomerServiceManagementIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Customer Service Management" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $4f22854d02c31273$var$svg,
            customThemeSvg: $4f22854d02c31273$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function CustomerServiceManagementIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $4f22854d02c31273$var$svg,
        customThemeSvg: $4f22854d02c31273$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["CustomerServiceManagementIcon"] = $4f22854d02c31273$export$6da5aa77c402ba0f;

});

parcelRegister("gtQgC", function(module, exports) {

var $62APY = parcelRequire("62APY");

const $1665c8ad23657fd1$var$getStudioHost = (env)=>env === 'staging' ? (0, $62APY.STUDIO_STAGING_URL) : (0, $62APY.STUDIO_PROD_URL);
const $1665c8ad23657fd1$export$b4a3ce4b99911063 = (env, path, email)=>{
    const studioHost = $1665c8ad23657fd1$var$getStudioHost(env);
    const normalizedPath = path ? path.startsWith('/') ? path : `/${path}` : '';
    const destination = `${studioHost}${normalizedPath}`;
    if (!email) return destination;
    // Merge login_hint into any existing query string.
    const url = new URL(destination);
    url.searchParams.set('login_hint', email);
    return url.toString();
};
module.exports["getStudioSessionSyncUrl"] = $1665c8ad23657fd1$export$b4a3ce4b99911063;

});

parcelRegister("62APY", function(module, exports) {
const $e6043006edffc91a$export$83a42cd6c4b5f72d = 'https://studio.atlassian.com';
const $e6043006edffc91a$export$1b2ea4d616a1810d = 'https://studio.stg.atlassian.com';
module.exports["STUDIO_PROD_URL"] = $e6043006edffc91a$export$83a42cd6c4b5f72d;
module.exports["STUDIO_STAGING_URL"] = $e6043006edffc91a$export$1b2ea4d616a1810d;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("fULE8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1ab2dc8fa18785f7$export$a7b0697657ed8bd0 = (0, $cozmU.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});
module.exports["ExperienceTrackerContext"] = $1ab2dc8fa18785f7$export$a7b0697657ed8bd0;

});

parcelRegister("4nIKB", function(module, exports) {

var $7ZH1D = parcelRequire("7ZH1D");


var $04KxR = parcelRequire("04KxR");

function $330c05f262f9f947$export$c9058316764c140e(refs) {
    return (0, $04KxR.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $7ZH1D.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $330c05f262f9f947$export$c9058316764c140e;

});

parcelRegister("04KxR", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $00e47aba7bcb22e2$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $00e47aba7bcb22e2$export$35a19128eb4acba4;

});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("QPvOh", function(module, exports) {
/*! @license DOMPurify 2.5.9 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.9/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.9';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
}); //# sourceMappingURL=purify.js.map

});

parcelRegister("hHL57", function(module, exports) {

var $dojlP = parcelRequire("dojlP");


var $anHcQ = parcelRequire("anHcQ");

/** Used to match HTML entities and HTML characters. */ var $ce3af93da41c9a81$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $ce3af93da41c9a81$var$reHasEscapedHtml = RegExp($ce3af93da41c9a81$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $ce3af93da41c9a81$var$unescape(string) {
    string = $dojlP(string);
    return string && $ce3af93da41c9a81$var$reHasEscapedHtml.test(string) ? string.replace($ce3af93da41c9a81$var$reEscapedHtml, $anHcQ) : string;
}
module.exports = $ce3af93da41c9a81$var$unescape;

});

parcelRegister("anHcQ", function(module, exports) {

var $aJnR3 = parcelRequire("aJnR3");

/** Used to map HTML entities to characters. */ var $78ed913858b2bf85$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $78ed913858b2bf85$var$unescapeHtmlChar = $aJnR3($78ed913858b2bf85$var$htmlUnescapes);
module.exports = $78ed913858b2bf85$var$unescapeHtmlChar;

});

parcelRegister("c8XQL", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lOiVq = parcelRequire("lOiVq");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $8d74a858e0464007$var$isDevelopment = false;
var $8d74a858e0464007$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $8d74a858e0464007$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8d74a858e0464007$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8d74a858e0464007$var$testOmitPropsOnStringTag : $8d74a858e0464007$var$testOmitPropsOnComponent;
};
var $8d74a858e0464007$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8d74a858e0464007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8d74a858e0464007$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8d74a858e0464007$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8d74a858e0464007$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $lOiVq.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $lOiVq.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8d74a858e0464007$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($8d74a858e0464007$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8d74a858e0464007$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $8d74a858e0464007$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $8d74a858e0464007$export$2e2bcd8739ae039;

});

parcelRegister("ifF9E", function(module, exports) {

var $e8eWN = parcelRequire("e8eWN");

// eslint-disable-next-line no-undef
var $d4998d3150d9a680$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4998d3150d9a680$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e8eWN.default)(function(prop) {
    return $d4998d3150d9a680$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $d4998d3150d9a680$export$2e2bcd8739ae039;

});

parcelRegister("gAlT6", function(module, exports) {

var $bsTU9 = parcelRequire("bsTU9");


var $aYr7p = parcelRequire("aYr7p");

/** Used for built-in method references. */ var $c130fc97ec35be58$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c130fc97ec35be58$var$hasOwnProperty = $c130fc97ec35be58$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $c130fc97ec35be58$var$groupBy = $aYr7p(function(result, value, key) {
    if ($c130fc97ec35be58$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $bsTU9(result, key, [
        value
    ]);
});
module.exports = $c130fc97ec35be58$var$groupBy;

});

parcelRegister("aYr7p", function(module, exports) {

var $aQVxe = parcelRequire("aQVxe");


var $gvTsE = parcelRequire("gvTsE");


var $j6gAQ = parcelRequire("j6gAQ");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $7fd48b25632d9305$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1ScXu(collection) ? $aQVxe : $gvTsE, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $j6gAQ(iteratee, 2), accumulator);
    };
}
module.exports = $7fd48b25632d9305$var$createAggregator;

});

parcelRegister("aQVxe", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7e6b63f27d697568$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $7e6b63f27d697568$var$arrayAggregator;

});

parcelRegister("gvTsE", function(module, exports) {

var $bNHBU = parcelRequire("bNHBU");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c05a9000df9c8764$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $bNHBU(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $c05a9000df9c8764$var$baseAggregator;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("6vPLm", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $83056c684d55bb4d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $83056c684d55bb4d$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
const $83056c684d55bb4d$export$d89497e7f33ca6f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AssetsIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Assets" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $83056c684d55bb4d$var$svg,
            customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            isAssets: true,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function AssetsIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $83056c684d55bb4d$var$svg,
        customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["AssetsIcon"] = $83056c684d55bb4d$export$d89497e7f33ca6f5;

});

parcelRegister("6CGVr", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a107ebb1ee65d2$export$2e2bcd8739ae039);

var $3ge84 = parcelRequire("3ge84");

var $34a107ebb1ee65d2$export$2e2bcd8739ae039 = (0, $3ge84.default);

});

parcelRegister("iGwRU", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $3011e158d8129415$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
module.exports["ANALYTICS_CHANNEL"] = $3011e158d8129415$export$85183a312807388d;

});

parcelRegister("l9F99", function(module, exports) {
const $9a048168f718fa86$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $9a048168f718fa86$export$d97c97ed77ff09e8;

});

parcelRegister("i8NpI", function(module, exports) {
const $5912f9d7fe53faa6$export$f6abe2eda5c1912f = ()=>({
        eventType: 'track',
        tags: [
            'atlaskit'
        ]
    });
module.exports["getDefaultTrackEventConfig"] = $5912f9d7fe53faa6$export$f6abe2eda5c1912f;

});

parcelRegister("8qMNj", function(module, exports) {
$parcel$export(module.exports, "default", () => $623699fd92ec4e19$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $kr6hK = parcelRequire("kr6hK");


var $3yGK6 = parcelRequire("3yGK6");


var $4m74k = parcelRequire("4m74k");

function $623699fd92ec4e19$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3yGK6.default)(1, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var weekStartsOn = (0, $kr6hK.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("2aija", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

const $97165e869498f5e6$var$hideAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$var$hideBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $97165e869498f5e6$var$hideAboveQueries[above],
            below && $97165e869498f5e6$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $97165e869498f5e6$export$bed28288a051538;

});

parcelRegister("gP9iN", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $gnKXs = parcelRequire("gnKXs");

const $43486d63aa94dbc3$export$918f8818cfbbeb2c = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $gnKXs.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $43486d63aa94dbc3$export$918f8818cfbbeb2c;

});

parcelRegister("9vEMa", function(module, exports) {
const $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5e5a55fac3e6fd2a$export$2d293d9871c38e91 = Object.keys($5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09);
const $5e5a55fac3e6fd2a$export$b7ed752a57b4177b = $5e5a55fac3e6fd2a$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_CONFIG"] = $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09;
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $5e5a55fac3e6fd2a$export$2d293d9871c38e91;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("hgbrK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $45mGg = parcelRequire("45mGg");

const $b7e4de65fa0c7921$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $45mGg.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $b7e4de65fa0c7921$export$b2a4e2b0c6417297;

});

parcelRegister("45mGg", function(module, exports) {

var $gnKXs = parcelRequire("gnKXs");

const $61f180d366254050$export$c881183ca713c214 = (0, $gnKXs.media);
module.exports["UNSAFE_media"] = $61f180d366254050$export$c881183ca713c214;

});

parcelRegister("ez9xU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $jmUhx = parcelRequire("jmUhx");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $hBYtq = parcelRequire("hBYtq");


var $eytcg = parcelRequire("eytcg");

const $c25508467e1a19ee$var$triggerStyles = {
    button: "_23rrnHyKLB _3hxITiYbGa _0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _0KLXrujOvk _0wOv4Q7zJH _39xV02N91d _1eOmH6o126",
    text: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $c25508467e1a19ee$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $c25508467e1a19ee$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c25508467e1a19ee$var$triggerStyles.text
    }, formatMessage((0, $eytcg.messages).defaultTriggerLabel))));
};

const $c25508467e1a19ee$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("fkOMD")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $c25508467e1a19ee$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $cozmU.useState)(false);
    const pendingOpenOptions = (0, $cozmU.useRef)(undefined);
    const openModalRef = (0, $cozmU.useRef)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $c25508467e1a19ee$export$f2c3f3e62df426ba;

});

parcelRegister("eytcg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2c6792bc438bfd46$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $2c6792bc438bfd46$export$defe85febe8b728c;

});

parcelRegister("fkOMD", function(module, exports) {

let $b2a01dcba7678797$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b2a01dcba7678797$var$load("kT6dz"),
    $b2a01dcba7678797$var$load("1audf"),
    $b2a01dcba7678797$var$load("bpBPu"),
    $b2a01dcba7678797$var$load("6wr18"),
    $b2a01dcba7678797$var$load("7SteV"),
    $b2a01dcba7678797$var$load("54ltV"),
    $b2a01dcba7678797$var$load("7EorR"),
    $b2a01dcba7678797$var$load("Wowvf"),
    $b2a01dcba7678797$var$load("hhss7"),
    $b2a01dcba7678797$var$load("cGkFm"),
    $b2a01dcba7678797$var$load("aqMLH"),
    $b2a01dcba7678797$var$load("ctdyb"),
    $b2a01dcba7678797$var$load("he7Ox"),
    $b2a01dcba7678797$var$load("ffEVr"),
    $b2a01dcba7678797$var$load("9XFtf"),
    $b2a01dcba7678797$var$load("jYCVY"),
    $b2a01dcba7678797$var$load("abBST"),
    $b2a01dcba7678797$var$load("cKDij")
]).then(()=>parcelRequire('7bLo5'));

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("kb3cs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $588defb4b914bf6a$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_FPS_CONNECT_APPS_BUTTON: 'search-fps-connect-apps-button'
};
const $588defb4b914bf6a$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $588defb4b914bf6a$var$rovoSettingsConfig = /*#__PURE__*/ (0, $cozmU.createContext)($588defb4b914bf6a$var$initialState);
const $588defb4b914bf6a$var$rovoSettingsModalMountedContext = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $588defb4b914bf6a$export$e6e0575f100c37ab = $588defb4b914bf6a$var$rovoSettingsConfig.Provider;
const $588defb4b914bf6a$export$c32765f1b1c62608 = $588defb4b914bf6a$var$rovoSettingsModalMountedContext.Provider;
const $588defb4b914bf6a$export$db68c798d50f727e = ()=>(0, $cozmU.useContext)($588defb4b914bf6a$var$rovoSettingsConfig);
const $588defb4b914bf6a$export$ddb548fa2ffa23a3 = ()=>(0, $cozmU.useContext)($588defb4b914bf6a$var$rovoSettingsModalMountedContext);
module.exports["RovoSettingsModalSurface"] = $588defb4b914bf6a$export$bc9ec39841ba8fd3;
module.exports["RovoSettingsConfigProvider"] = $588defb4b914bf6a$export$e6e0575f100c37ab;
module.exports["RovoSettingsModalMountedProvider"] = $588defb4b914bf6a$export$c32765f1b1c62608;
module.exports["useRovoSettingsConfig"] = $588defb4b914bf6a$export$db68c798d50f727e;
module.exports["useIsRovoSettingsModalProviderMounted"] = $588defb4b914bf6a$export$ddb548fa2ffa23a3;

});

parcelRegister("dL3KD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $b10ebbefbae983ec$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
const $b10ebbefbae983ec$export$1e02e7298035a77c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FocusIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Focus" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $b10ebbefbae983ec$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function FocusIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $b10ebbefbae983ec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["FocusIcon"] = $b10ebbefbae983ec$export$1e02e7298035a77c;

});

parcelRegister("33FWk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $9f7a3b7caba550ed$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9f7a3b7caba550ed$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
const $9f7a3b7caba550ed$export$21bfbeb62fdcce8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraProductDiscoveryIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Jira Product Discovery" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $9f7a3b7caba550ed$var$svg,
            customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function JiraProductDiscoveryIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $9f7a3b7caba550ed$var$svg,
        customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraProductDiscoveryIcon"] = $9f7a3b7caba550ed$export$21bfbeb62fdcce8d;

});

parcelRegister("hupj2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $fb0eeb73da830bbb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
const $fb0eeb73da830bbb$export$4b05688514531169 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TalentIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Talent" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $fb0eeb73da830bbb$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function TalentIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $fb0eeb73da830bbb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TalentIcon"] = $fb0eeb73da830bbb$export$4b05688514531169;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fa619d4dc0abdbd4993ef2902e26740>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_iconNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_iconNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("fgc5x", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $4Df0x = parcelRequire("4Df0x");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3550bc2b37be7afe$var$svg = `<svg height="100%" viewBox="0 0 100 32">
    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>
</svg>
`;
const $3550bc2b37be7afe$export$68d7391318cdef11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomAttributionLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom Attribution" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
            svg: $3550bc2b37be7afe$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomAttributionLogoCS({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom Attribution', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
        svg: $3550bc2b37be7afe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomAttributionLogoCS"] = $3550bc2b37be7afe$export$68d7391318cdef11;

});

parcelRegister("gm2vG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1NWCx = parcelRequire("1NWCx");


var $45mGg = parcelRequire("45mGg");

const $2eec9d500aa9cc66$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $2eec9d500aa9cc66$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $cozmU.useRef)(listener);
    (0, $cozmU.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $2eec9d500aa9cc66$var$queries[queryString];
    (0, $1NWCx.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cbY7C.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $2eec9d500aa9cc66$export$49e55ae2c03d6045;

});

parcelRegister("kawxu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

function $9278a0867c7923b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9278a0867c7923b7$var$showAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$showBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $9278a0867c7923b7$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $9278a0867c7923b7$var$defaultHiddenStyles,
            above && $9278a0867c7923b7$var$showAboveQueries[above],
            below && $9278a0867c7923b7$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $9278a0867c7923b7$export$f6a3d19be20f5819;

});

parcelRegister("dDJT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bd0b1f6d8e717040c997f247b7acc7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ee283416514adb3$var$_react = $9ee283416514adb3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ee283416514adb3$var$_iconNew = $9ee283416514adb3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9ee283416514adb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/notification
 * Usage guidance:
 * Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ee283416514adb3$var$NotificationIcon = (props)=>/*#__PURE__*/ $9ee283416514adb3$var$_react.default.createElement($9ee283416514adb3$var$_iconNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$9ee283416514adb3$var$NotificationIcon.displayName = 'NotificationIcon';
var $9ee283416514adb3$var$_default = module.exports.default = $9ee283416514adb3$var$NotificationIcon;

});

parcelRegister("hPGQU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508bd9728f54ab48d8a573901bb484ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfb870adeedce136$var$_react = $cfb870adeedce136$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cfb870adeedce136$var$_iconNew = $cfb870adeedce136$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $cfb870adeedce136$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-in
 * Usage guidance:
 * Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfb870adeedce136$var$LogInIcon = (props)=>/*#__PURE__*/ $cfb870adeedce136$var$_react.default.createElement($cfb870adeedce136$var$_iconNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$cfb870adeedce136$var$LogInIcon.displayName = 'LogInIcon';
var $cfb870adeedce136$var$_default = module.exports.default = $cfb870adeedce136$var$LogInIcon;

});

parcelRegister("vkiEA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc1e1afbeb94ec2722cc1d659728d67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05e2a47ee66e67f2$var$_react = $05e2a47ee66e67f2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $05e2a47ee66e67f2$var$_iconNew = $05e2a47ee66e67f2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $05e2a47ee66e67f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-out
 * Usage guidance:
 * Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05e2a47ee66e67f2$var$LogOutIcon = (props)=>/*#__PURE__*/ $05e2a47ee66e67f2$var$_react.default.createElement($05e2a47ee66e67f2$var$_iconNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$05e2a47ee66e67f2$var$LogOutIcon.displayName = 'LogOutIcon';
var $05e2a47ee66e67f2$var$_default = module.exports.default = $05e2a47ee66e67f2$var$LogOutIcon;

});

parcelRegister("9ib3C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::891f8b0b0e6811694a02696ff381b7b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c3e5f4485c7f9fc$var$_react = $6c3e5f4485c7f9fc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6c3e5f4485c7f9fc$var$_iconNew = $6c3e5f4485c7f9fc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $6c3e5f4485c7f9fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app-switcher
 * Usage guidance:
 * Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c3e5f4485c7f9fc$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $6c3e5f4485c7f9fc$var$_react.default.createElement($6c3e5f4485c7f9fc$var$_iconNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$6c3e5f4485c7f9fc$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $6c3e5f4485c7f9fc$var$_default = module.exports.default = $6c3e5f4485c7f9fc$var$AppSwitcherIcon;

});

parcelRegister("gzlgs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4f1367f1cd984cea139cd322f85553>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10068ea3730be40$var$_react = $c10068ea3730be40$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c10068ea3730be40$var$_iconNew = $c10068ea3730be40$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c10068ea3730be40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-collapse
 * Usage guidance:
 * Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c10068ea3730be40$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $c10068ea3730be40$var$_react.default.createElement($c10068ea3730be40$var$_iconNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$c10068ea3730be40$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $c10068ea3730be40$var$_default = module.exports.default = $c10068ea3730be40$var$SidebarCollapseIcon;

});

parcelRegister("1pYOd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a887af9d6920f2ef0ce00494c960319>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10874b9e5ca41beb$var$_react = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10874b9e5ca41beb$var$_iconNew = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $10874b9e5ca41beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-expand
 * Usage guidance:
 * Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10874b9e5ca41beb$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $10874b9e5ca41beb$var$_react.default.createElement($10874b9e5ca41beb$var$_iconNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$10874b9e5ca41beb$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $10874b9e5ca41beb$var$_default = module.exports.default = $10874b9e5ca41beb$var$SidebarExpandIcon;

});

parcelRegister("lEBcH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::315758a81f797b033fc6adebe81008e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc3a315370b5b847$var$_react = $fc3a315370b5b847$var$_interopRequireDefault((parcelRequire("cozmU")));

var $fc3a315370b5b847$var$_iconNew = $fc3a315370b5b847$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $fc3a315370b5b847$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/theme
 * Usage guidance:
 * Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc3a315370b5b847$var$ThemeIcon = (props)=>/*#__PURE__*/ $fc3a315370b5b847$var$_react.default.createElement($fc3a315370b5b847$var$_iconNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$fc3a315370b5b847$var$ThemeIcon.displayName = 'ThemeIcon';
var $fc3a315370b5b847$var$_default = module.exports.default = $fc3a315370b5b847$var$ThemeIcon;

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_iconNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("fa8WQ", function(module, exports) {

var $gtQgC = parcelRequire("gtQgC");


var $2J4Io = parcelRequire("2J4Io");

const $7a5b39f110eb7e66$var$STUDIO_PROD_URL = 'https://studio.atlassian.com';
const $7a5b39f110eb7e66$var$STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $7a5b39f110eb7e66$export$72eb188ed9591973 = ()=>{
    return (0, $2J4Io.isStaging)() ? $7a5b39f110eb7e66$var$STUDIO_STAGING_URL : $7a5b39f110eb7e66$var$STUDIO_PROD_URL;
};
const $7a5b39f110eb7e66$var$getStudioEnv = ()=>(0, $2J4Io.isStaging)() ? 'staging' : 'production';
const $7a5b39f110eb7e66$export$372c8de5c124bdc8 = (path, email)=>{
    if (email) return (0, $gtQgC.getStudioSessionSyncUrl)($7a5b39f110eb7e66$var$getStudioEnv(), path, email);
    return `${$7a5b39f110eb7e66$export$72eb188ed9591973()}${path}`;
};
const $7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl = (workspaceId, spaceId, ruleIdUuid)=>{
    const base = `/w/${workspaceId}/spaces/${spaceId}/automation#`;
    return `${base}/rule/${encodeURIComponent(ruleIdUuid)}`;
};
const $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a = (siteId, navigationSource, csid, email, starterText)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', navigationSource);
    if (csid) searchParams.set('csid', csid);
    if (starterText) searchParams.set('starterText', starterText);
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/chat${searchParams.size > 0 ? `?${searchParams}` : ''}`, email);
};
const $7a5b39f110eb7e66$export$fe475324c26e3007 = (siteId, email)=>{
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/overview`, email);
};
const $7a5b39f110eb7e66$export$ef221a159d6fa3e8 = (siteId, agentId, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`, email);
const $7a5b39f110eb7e66$export$a20abb994c34f0a4 = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/:agentId/overview')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$3da6a4b7798ba40b = (siteId, agentAri, navigationSource, email)=>{
    const sourceParam = navigationSource ? `?navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/details${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$36c11ab884b7b2cb = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/create')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$c2d162390af7b91d = (siteId, agentAri, navigationSource, email)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', encodeURIComponent(navigationSource));
    const query = searchParams.size > 0 ? `?${searchParams}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/permissions${query}`, email);
};
const $7a5b39f110eb7e66$export$bae72ef7f23dbede = (workspaceId, spaceId, ruleIdUuid, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8($7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl(workspaceId, spaceId, ruleIdUuid), email);
module.exports["getStudioHost"] = $7a5b39f110eb7e66$export$72eb188ed9591973;
module.exports["getStudioPath"] = $7a5b39f110eb7e66$export$372c8de5c124bdc8;
module.exports["getAtlassianStudioNLCreateUrl"] = $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a;
module.exports["getAtlassianStudioAgentEditUrl"] = $7a5b39f110eb7e66$export$a20abb994c34f0a4;
module.exports["getAtlassianStudioAgentEditUrlWithAri"] = $7a5b39f110eb7e66$export$3da6a4b7798ba40b;
module.exports["getAtlassianStudioAgentDuplicateUrl"] = $7a5b39f110eb7e66$export$36c11ab884b7b2cb;
module.exports["getAtlassianStudioAutomationRuleEditUrl"] = $7a5b39f110eb7e66$export$bae72ef7f23dbede;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("7dHQW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $aAQ8R = parcelRequire("aAQ8R");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $f6VI9 = parcelRequire("f6VI9");


var $1Bxlw = parcelRequire("1Bxlw");

function $5446c5acb3eaf46c$export$70de0c6012582ca5(skillsResponse) {
    if (!skillsResponse?.edges) return {};
    const metadataMap = {};
    skillsResponse.edges.forEach((edge)=>{
        const node = edge?.node;
        if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return;
        const skill = (0, $f6VI9.parseSkillNode)(node);
        if (!skill || !skill.slug) return;
        metadataMap[skill.slug] = {
            id: skill.id,
            name: skill.name,
            description: skill.description ?? '',
            iconName: skill.iconName,
            product: skill.product,
            productIconUrl: skill.productIconUrl,
            color: skill.color,
            tags: skill.tags
        };
    });
    return metadataMap;
}
/**
 * Context for skill metadata
 */ const $5446c5acb3eaf46c$var$SkillMetadataContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $5446c5acb3eaf46c$export$6c7e4f3dd3ea4213 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSkillMetadata() {
    return (0, $cozmU.useContext)($5446c5acb3eaf46c$var$SkillMetadataContext);
} : function useSkillMetadata() {
    return (0, $cozmU.useContext)($5446c5acb3eaf46c$var$SkillMetadataContext);
};
function $5446c5acb3eaf46c$export$54587e1184069f96({ children: children, siteId: siteId, tags: tagsProp, fetchWithoutTags: fetchWithoutTags = false }) {
    const config = (0, $1Bxlw.useRovoSkillsConfig)();
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    // Use tags from prop if provided, otherwise fallback to context
    const tags = tagsProp ?? config?.tags;
    const shouldFetch = !!tags?.skillRegistryTags && tags.skillRegistryTags.length > 0 || fetchWithoutTags;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by transformSkillMetadataResponse in this file */ (0, $aAQ8R.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: 100,
        relevantFor: [
            'SKILL'
        ],
        cloudId: siteId,
        surface: 'ROVO',
        shouldSkip: !shouldFetch,
        tags: fetchWithoutTags ? undefined : tags?.skillRegistryTags ?? []
    }, {
        fetchKey: skillsRevision,
        fetchPolicy: skillsRevision === 0 ? 'store-or-network' : 'network-only'
    })?.graphIntegration_componentDirectoryItems;
    const skillMetadataMap = (0, $cozmU.useMemo)(()=>{
        if (!shouldFetch) return {};
        return $5446c5acb3eaf46c$export$70de0c6012582ca5(skillsResponse);
    }, [
        shouldFetch,
        skillsResponse
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            skillMetadataMap: skillMetadataMap
        }), [
        skillMetadataMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5446c5acb3eaf46c$var$SkillMetadataContext.Provider, {
        value: value
    }, children);
}
module.exports["useSkillMetadata"] = $5446c5acb3eaf46c$export$6c7e4f3dd3ea4213;
module.exports["SkillMetadataProvider"] = $5446c5acb3eaf46c$export$54587e1184069f96;

});

parcelRegister("aAQ8R", function(module, exports) {
/**
 * @generated SignedSource<<3b4e7bcb750876a3028b7bb4678456a1>>
 * @relayHash b406175479bb55cf4fe4b97d92e97b06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 05f9b4034d96a3cce2374ad470501095628c492be615dc2a377c159a22211f03
const $442a06332da1bb4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tags"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "relevantFor",
            "variableName": "relevantFor"
        },
        {
            "kind": "Variable",
            "name": "surface",
            "variableName": "surface"
        },
        {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "slashCommand"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "color"
    }, v15 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v16 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "tags",
                                                            "plural": true,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "tags",
                                                            "plural": true,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationActionDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpServer"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpTool"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationSkillItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "05f9b4034d96a3cce2374ad470501095628c492be615dc2a377c159a22211f03",
            "metadata": {},
            "name": "skillMetadataProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$442a06332da1bb4d$var$node.hash = "2aa631b370ead175d7fac5bc4468d0a7";
var $442a06332da1bb4d$export$2e2bcd8739ae039 = $442a06332da1bb4d$var$node;
module.exports["default"] = $442a06332da1bb4d$export$2e2bcd8739ae039;

});

parcelRegister("1Bxlw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $aJNFh = parcelRequire("aJNFh");

const $350692d982fcc44a$var$RovoSkillsCloudIdContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $350692d982fcc44a$var$RovoSkillsConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $350692d982fcc44a$var$fallbackInvalidation = {
    skillsRevision: 0,
    // Outside RovoSkillsConfigProvider there is no revision state to bump, so this only clears
    // the vanilla insert-menu cache. Relay consumers need the provider to refetch by revision.
    invalidateSkillLibrary: (0, $aJNFh.clearSkillsCache)
};
const $350692d982fcc44a$var$RovoSkillsInvalidationContext = /*#__PURE__*/ (0, $cozmU.createContext)($350692d982fcc44a$var$fallbackInvalidation); /**
                                                                                                    * Hook to access Rovo Skills configuration.
                                                                                                    *
                                                                                                    * @returns The Rovo Skills configuration, or undefined if used outside of RovoSkillsConfigProvider
                                                                                                    *
                                                                                                    * @example
                                                                                                    * ```tsx
                                                                                                    * function MyComponent() {
                                                                                                    *   const config = useRovoSkillsConfig();
                                                                                                    *   const tags = config?.tags;
                                                                                                    * }
                                                                                                    * ```
                                                                                                    */ 
const $350692d982fcc44a$export$8f887a582517d0da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoSkillsConfig() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsConfigContext);
} : function useRovoSkillsConfig() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsConfigContext);
};
const $350692d982fcc44a$export$4347872345a66163 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoSkillsInvalidation() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsInvalidationContext);
} : function useRovoSkillsInvalidation() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsInvalidationContext);
};
const $350692d982fcc44a$export$4967709cc8a6f044 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoSkillsConfigProvider(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, config: config, children: children } = t0;
    const parentCloudId = (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsCloudIdContext);
    const resolvedCloudId = cloudId ?? parentCloudId;
    const value = config;
    const [skillsRevision, setSkillsRevision] = (0, $cozmU.useState)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            (0, $aJNFh.clearSkillsCache)();
            (0, $cozmU.startTransition)(()=>{
                setSkillsRevision($350692d982fcc44a$var$_temp);
            });
        };
        $[0] = t1;
    } else t1 = $[0];
    const invalidateSkillLibrary = t1;
    let t2;
    if ($[1] !== skillsRevision) {
        t2 = {
            skillsRevision: skillsRevision,
            invalidateSkillLibrary: invalidateSkillLibrary
        };
        $[1] = skillsRevision;
        $[2] = t2;
    } else t2 = $[2];
    const invalidationValue = t2;
    let t3;
    if ($[3] !== resolvedCloudId) {
        t3 = (0, $iDrrr.fg)("rovo_chat_custom_skill_actions") && /*#__PURE__*/ $cozmU.createElement((0, $hdBxM.Subscriber), {
            topic: "rovo-skills",
            onEvent: (payload)=>{
                if (payload.type === (0, $k1Pvg.CUSTOM_SKILL_DELETED_EVENT) && payload.data.cloudId === resolvedCloudId) invalidateSkillLibrary();
            }
        });
        $[3] = resolvedCloudId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== invalidationValue || $[7] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsInvalidationContext.Provider, {
            value: invalidationValue
        }, t3, children);
        $[5] = children;
        $[6] = invalidationValue;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4 || $[10] !== value) {
        t5 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsConfigContext.Provider, {
            value: value
        }, t4);
        $[9] = t4;
        $[10] = value;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== resolvedCloudId || $[13] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsCloudIdContext.Provider, {
            value: resolvedCloudId
        }, t5);
        $[12] = resolvedCloudId;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : function RovoSkillsConfigProvider({ cloudId: cloudId, config: config, children: children }) {
    const parentCloudId = (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsCloudIdContext);
    const resolvedCloudId = cloudId ?? parentCloudId;
    const value = (0, $cozmU.useMemo)(()=>config, [
        config
    ]);
    const [skillsRevision, setSkillsRevision] = (0, $cozmU.useState)(0);
    const invalidateSkillLibrary = (0, $cozmU.useCallback)(()=>{
        (0, $aJNFh.clearSkillsCache)();
        (0, $cozmU.startTransition)(()=>{
            setSkillsRevision((revision)=>revision + 1);
        });
    }, []);
    const invalidationValue = (0, $cozmU.useMemo)(()=>({
            skillsRevision: skillsRevision,
            invalidateSkillLibrary: invalidateSkillLibrary
        }), [
        invalidateSkillLibrary,
        skillsRevision
    ]);
    return /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsCloudIdContext.Provider, {
        value: resolvedCloudId
    }, /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsConfigContext.Provider, {
        value: value
    }, /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsInvalidationContext.Provider, {
        value: invalidationValue
    }, (0, $iDrrr.fg)('rovo_chat_custom_skill_actions') && /*#__PURE__*/ $cozmU.createElement((0, $hdBxM.Subscriber), {
        topic: "rovo-skills",
        onEvent: (payload)=>{
            if (payload.type === (0, $k1Pvg.CUSTOM_SKILL_DELETED_EVENT) && payload.data.cloudId === resolvedCloudId) invalidateSkillLibrary();
        }
    }), children)));
};
function $350692d982fcc44a$var$_temp(revision) {
    return revision + 1;
}
module.exports["useRovoSkillsConfig"] = $350692d982fcc44a$export$8f887a582517d0da;
module.exports["useRovoSkillsInvalidation"] = $350692d982fcc44a$export$4347872345a66163;
module.exports["RovoSkillsConfigProvider"] = $350692d982fcc44a$export$4967709cc8a6f044;

});

parcelRegister("63sT2", function(module, exports) {
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("8NccQ")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("8NccQ")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("dYn3u")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("dYn3u")).Reasons);

var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("88DFk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");


var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $kXiqf = parcelRequire("kXiqf");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $9d01a40d5c3361ba$var$DefaultActionSubject = 'rovoAgent';
const $9d01a40d5c3361ba$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $9d01a40d5c3361ba$export$b9dc0ab1bce924aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = (0, $kXiqf.useRovoAgentCSID)();
    const { csid: csid, globalCSID: globalCSID } = t0;
    const { refresh: refreshCSID } = t1;
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t2 = (event)=>{
            const referrer = typeof window !== "undefined" ? window.document.referrer : "unknown";
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                ...event.attributes,
                actionGroup: "createFlow",
                referrer: referrer
            };
            createAnalyticsEvent({
                ...$9d01a40d5c3361ba$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const fireAnalyticsEvent = t2;
    let t3;
    if ($[3] !== fireAnalyticsEvent || $[4] !== globalCSID) {
        t3 = (action, attributes_0)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: action,
                attributes: {
                    csid: globalCSID,
                    ...attributes_0
                }
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = globalCSID;
        $[5] = t3;
    } else t3 = $[5];
    const trackCreateSession = t3;
    let t4;
    if ($[6] !== csid || $[7] !== fireAnalyticsEvent || $[8] !== refreshCSID) {
        t4 = (attributes_1)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowStart",
                attributes: {
                    csid: csid,
                    ...attributes_1
                }
            });
            refreshCSID();
        };
        $[6] = csid;
        $[7] = fireAnalyticsEvent;
        $[8] = refreshCSID;
        $[9] = t4;
    } else t4 = $[9];
    const trackCreateSessionStart = t4;
    let t5;
    if ($[10] !== fireAnalyticsEvent || $[11] !== globalCSID) {
        t5 = (error, attributes_2)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowError",
                attributes: {
                    error: {
                        message: error.message
                    },
                    csid: globalCSID,
                    ...attributes_2
                }
            });
        };
        $[10] = fireAnalyticsEvent;
        $[11] = globalCSID;
        $[12] = t5;
    } else t5 = $[12];
    const trackCreateSessionError = t5;
    let t6;
    if ($[13] !== refreshCSID || $[14] !== trackCreateSession || $[15] !== trackCreateSessionError || $[16] !== trackCreateSessionStart) {
        t6 = {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        };
        $[13] = refreshCSID;
        $[14] = trackCreateSession;
        $[15] = trackCreateSessionError;
        $[16] = trackCreateSessionStart;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== csid || $[19] !== t6) {
        t7 = [
            csid,
            t6
        ];
        $[18] = csid;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : (commonAttributes)=>{
    const [{ csid: csid, globalCSID: globalCSID }, { refresh: refreshCSID }] = (0, $kXiqf.useRovoAgentCSID)();
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const referrer = typeof window !== 'undefined' ? window.document.referrer : 'unknown';
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            ...event.attributes,
            actionGroup: 'createFlow',
            referrer: referrer
        };
        createAnalyticsEvent({
            ...$9d01a40d5c3361ba$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fires an analytics event for a step in the create agent flow funnel.
   * Uses the CSID from the URL query parameter.
   */ const trackCreateSession = (0, $cozmU.useCallback)((action, attributes_0)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: action,
            attributes: {
                csid: globalCSID,
                ...attributes_0
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    /**
   * Fires `createFlowStart` with the current CSID (matching the href),
   * then refreshes the CSID for the next session.
   * The component re-renders with the new CSID, updating any href attributes.
   */ const trackCreateSessionStart = (0, $cozmU.useCallback)((attributes_1)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowStart',
            attributes: {
                csid: csid,
                ...attributes_1
            }
        });
        refreshCSID();
    }, [
        fireAnalyticsEvent,
        refreshCSID,
        csid
    ]);
    const trackCreateSessionError = (0, $cozmU.useCallback)((error, attributes_2)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowError',
            attributes: {
                error: {
                    message: error.message
                },
                csid: globalCSID,
                ...attributes_2
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    return [
        csid,
        {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        }
    ];
};
module.exports["useRovoAgentCreateAnalytics"] = $9d01a40d5c3361ba$export$b9dc0ab1bce924aa;

});

parcelRegister("kXiqf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $debAY = parcelRequire("debAY");

let $3de3d827eb32710a$var$CACHED_CSID = null;
const $3de3d827eb32710a$var$generateCSID = ()=>{
    return crypto.randomUUID();
};
const $3de3d827eb32710a$export$2e155615ea28a17b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID();
        $[0] = t0;
    } else t0 = $[0];
    const [csid, setCSID] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        const queryParams = new URLSearchParams(window.location.search);
        t1 = queryParams.get((0, $debAY.CSID_QUERY_PARAM));
        $[1] = t1;
    } else t1 = $[1];
    const globalCSID = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const actions = t2;
    let t3;
    if ($[3] !== csid) {
        t3 = [
            {
                csid: csid,
                globalCSID: globalCSID
            },
            actions
        ];
        $[3] = csid;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [csid, setCSID] = (0, $cozmU.useState)($3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID());
    const globalCSID = (0, $cozmU.useMemo)(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get((0, $debAY.CSID_QUERY_PARAM));
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        return {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
    }, []);
    return [
        {
            csid: csid,
            globalCSID: // generated CSID to be used in href and createFlowStart events
            globalCSID // CSID from the URL query parameter
        },
        actions
    ];
};
module.exports["useRovoAgentCSID"] = $3de3d827eb32710a$export$2e155615ea28a17b;

});

parcelRegister("debAY", function(module, exports) {
const $881ebb84c71795d2$export$61b85fb5d2d632d0 = 'csid';
module.exports["CSID_QUERY_PARAM"] = $881ebb84c71795d2$export$61b85fb5d2d632d0;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("4XF4G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");

const $a15908f9f8476ecd$export$d8abb7a1cfbd4b6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { withTooltip: withTooltip, content: content, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== content || $[2] !== withTooltip) {
        t1 = withTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: content
        }, children) : children;
        $[0] = children;
        $[1] = content;
        $[2] = withTooltip;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ withTooltip: withTooltip, content: content, children: children })=>{
    return withTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: content
    }, children) : children;
};
module.exports["ConditionalTooltip"] = $a15908f9f8476ecd$export$d8abb7a1cfbd4b6b;

});

parcelRegister("dftWP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $lfoFx = parcelRequire("lfoFx");

const $d2db887787c9c9b2$var$styles = {
    loader: "_0jFU0VN91d _39xV02N91d"
};
const $d2db887787c9c9b2$export$62aa48085237e36f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { testId: testId, size: t1 } = t0;
    const size = t1 === undefined ? "xlarge" : t1;
    let t2;
    if ($[0] !== size) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: size
        });
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2 || $[3] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: testId,
            alignBlock: "center",
            alignInline: "center",
            xcss: $d2db887787c9c9b2$var$styles.loader
        }, t2);
        $[2] = t2;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ testId: testId, size: size = 'xlarge' })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: testId,
        alignBlock: 'center',
        alignInline: 'center',
        xcss: $d2db887787c9c9b2$var$styles.loader
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: size
    }));
};
module.exports["LoadingState"] = $d2db887787c9c9b2$export$62aa48085237e36f;

});

parcelRegister("eTXLl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $9d7Pd = parcelRequire("9d7Pd");


var $acQiA = parcelRequire("acQiA");


var $gjkrp = parcelRequire("gjkrp");


var $1HMFz = parcelRequire("1HMFz");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $9484f74b5616b2c8$var$DropdownItemRadio = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
        $[13] = title;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
        title = $[13];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[14] !== defaultSelected || $[15] !== id || $[16] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[14] = defaultSelected;
        $[15] = id;
        $[16] = isSelected;
        $[17] = t4;
    } else t4 = $[17];
    const [selected, setSelected] = (0, $1HMFz.default)(t4);
    let t5;
    if ($[18] !== providedOnClick || $[19] !== setSelected) {
        t5 = (event)=>{
            setSelected($9484f74b5616b2c8$var$_temp);
            providedOnClick(event);
        };
        $[18] = providedOnClick;
        $[19] = setSelected;
        $[20] = t5;
    } else t5 = $[20];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    let t6;
    if ($[21] !== selected) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gjkrp.default), {
            checked: selected
        });
        $[21] = selected;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== children || $[24] !== description || $[25] !== id || $[26] !== interactionName || $[27] !== isDisabled || $[28] !== itemRef || $[29] !== onClickHandler || $[30] !== rest || $[31] !== selected || $[32] !== shouldDescriptionWrap || $[33] !== shouldTitleWrap || $[34] !== t6 || $[35] !== testId || $[36] !== title) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
                "aria-checked": selected,
                description: description,
                iconBefore: t6,
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                title: title,
                interactionName: interactionName,
                ...rest,
                "aria-current": undefined,
                children: children
            })
        });
        $[23] = children;
        $[24] = description;
        $[25] = id;
        $[26] = interactionName;
        $[27] = isDisabled;
        $[28] = itemRef;
        $[29] = onClickHandler;
        $[30] = rest;
        $[31] = selected;
        $[32] = shouldDescriptionWrap;
        $[33] = shouldTitleWrap;
        $[34] = t6;
        $[35] = testId;
        $[36] = title;
        $[37] = t7;
    } else t7 = $[37];
    return t7;
} : ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $1HMFz.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gjkrp.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemradio",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            // Thanks to spread props, this attribute are passed to ButtonItem, even though
            // it's not in the component's prop types.
            // @ts-expect-error
            title: title,
            interactionName: interactionName,
            ...rest,
            // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
            "aria-current": undefined,
            children: children
        })
    });
};
var $9484f74b5616b2c8$export$2e2bcd8739ae039 = $9484f74b5616b2c8$var$DropdownItemRadio;
function $9484f74b5616b2c8$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $9484f74b5616b2c8$export$2e2bcd8739ae039;

});

parcelRegister("gjkrp", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $94a317b8d74997c1$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $94a317b8d74997c1$var$RadioIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "7.5",
            fill: "currentColor",
            stroke: t5,
            strokeWidth: "1"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                t6,
                t7
            ]
        });
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4,
            children: t8
        });
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.5",
                    fill: "currentColor",
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $94a317b8d74997c1$export$2e2bcd8739ae039 = $94a317b8d74997c1$var$RadioIcon;
module.exports["default"] = $94a317b8d74997c1$export$2e2bcd8739ae039;

});

parcelRegister("1HMFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3SaOM = parcelRequire("3SaOM");


var $lOWpM = parcelRequire("lOWpM");

const $a4a8ae7debae1d05$var$useRadioState = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRadioState(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { id: id, isSelected: isSelected, defaultSelected: defaultSelected } = t0;
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $cozmU.useContext)((0, $3SaOM.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    let t1;
    if ($[0] !== defaultSelected || $[1] !== persistedIsSelected) {
        t1 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[0] = defaultSelected;
        $[1] = persistedIsSelected;
        $[2] = t1;
    } else t1 = $[2];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[3] !== id || $[4] !== persistedIsSelected || $[5] !== selectRadioItem) {
        t2 = (newValue)=>{
            if (!persistedIsSelected) {
                const nextValue = newValue(persistedIsSelected);
                selectRadioItem(id, nextValue);
                setLocalIsSelected(nextValue);
            }
        };
        $[3] = id;
        $[4] = persistedIsSelected;
        $[5] = selectRadioItem;
        $[6] = t2;
    } else t2 = $[6];
    const setLocalState = t2;
    let t3;
    if ($[7] !== defaultSelected || $[8] !== id || $[9] !== radioGroupState) {
        t3 = ()=>{
            setLocalIsSelected(()=>{
                const existing = radioGroupState[id];
                return existing !== undefined ? existing : defaultSelected || false;
            });
        };
        $[7] = defaultSelected;
        $[8] = id;
        $[9] = radioGroupState;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== defaultSelected || $[12] !== group || $[13] !== id || $[14] !== radioGroupState) {
        t4 = [
            radioGroupState,
            group,
            id,
            defaultSelected
        ];
        $[11] = defaultSelected;
        $[12] = group;
        $[13] = id;
        $[14] = radioGroupState;
        $[15] = t4;
    } else t4 = $[15];
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof isSelected === "boolean") {
        let t5;
        if ($[16] !== isSelected) {
            t5 = [
                isSelected,
                $a4a8ae7debae1d05$var$_temp
            ];
            $[16] = isSelected;
            $[17] = t5;
        } else t5 = $[17];
        return t5;
    }
    if (persistedIsSelected === undefined) {
        const existing_0 = getGroupState(group);
        const newGroupState = {
            ...existing_0,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    let t5;
    if ($[18] !== localIsSelected || $[19] !== setLocalState) {
        t5 = [
            localIsSelected,
            setLocalState
        ];
        $[18] = localIsSelected;
        $[19] = setLocalState;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : function useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $cozmU.useContext)((0, $3SaOM.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $cozmU.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        const existing_0 = getGroupState(group);
        const newGroupState = {
            ...existing_0,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
};
function $a4a8ae7debae1d05$var$_temp() {
    return false;
}
var $a4a8ae7debae1d05$export$2e2bcd8739ae039 = $a4a8ae7debae1d05$var$useRadioState;
module.exports["default"] = $a4a8ae7debae1d05$export$2e2bcd8739ae039;

});

parcelRegister("3SaOM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $e4fc7f756cc729c9$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $dpsRj.default)
});
module.exports["RadioGroupContext"] = $e4fc7f756cc729c9$export$a79eda4ff50e30b6;

});

parcelRegister("cMUSA", function(module, exports) {

var $ellLO = parcelRequire("ellLO");


var $3sOoJ = parcelRequire("3sOoJ");


var $eeq36 = parcelRequire("eeq36");

const $ae4e0bc872b2095a$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $ae4e0bc872b2095a$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $3sOoJ.fetchJsonWithNetworkRetries)(`${$ae4e0bc872b2095a$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $ae4e0bc872b2095a$export$7fd9c7ae7afb494c = ()=>{
    return (0, $eeq36.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $ellLO.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $ae4e0bc872b2095a$export$1096efb00c5f8afc);
};
module.exports["appSwitcherBffAvailableProductsFetch"] = $ae4e0bc872b2095a$export$1096efb00c5f8afc;
module.exports["createAppSwitcherBffAvailableProductsProvider"] = $ae4e0bc872b2095a$export$7fd9c7ae7afb494c;

});

parcelRegister("ellLO", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");


var $BNj15 = parcelRequire("BNj15");

var $c6922af21df15933$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $c6922af21df15933$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $c6922af21df15933$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $c6922af21df15933$var$allNonTestExperienceMarks = Object.values($c6922af21df15933$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $c6922af21df15933$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $c6922af21df15933$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $c6922af21df15933$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $c6922af21df15933$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $c6922af21df15933$var$allNonTestExperienceMarks
};
const $c6922af21df15933$export$805ed806e0769ee4 = (0, $BNj15.invertRecordOfArrays)($c6922af21df15933$export$755e75afbd377bc4);
var $c6922af21df15933$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $c6922af21df15933$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $c6922af21df15933$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';
module.exports["Experience"] = $c6922af21df15933$export$c90b54e658fc4d7c;
module.exports["EXPERIENCE_CONFIGS"] = $c6922af21df15933$export$d54d7a2744fdf647;
module.exports["ExperienceMark"] = $c6922af21df15933$export$cbf1e672c3e37474;
module.exports["EXPERIENCES_TO_MARKS"] = $c6922af21df15933$export$755e75afbd377bc4;
module.exports["MARKS_TO_EXPERIENCES"] = $c6922af21df15933$export$805ed806e0769ee4;
module.exports["ExperienceMarkPhase"] = $c6922af21df15933$export$ec8391a70bbdbe59;
module.exports["AbortReason"] = $c6922af21df15933$export$279d6315a97b520d;
module.exports["SWITCHER_RENDER_START_PERFORMANCE_MARK"] = $c6922af21df15933$export$86919b84f9a64054;

});

parcelRegister("BNj15", function(module, exports) {
function $601653c7aaa54218$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}
module.exports["invertRecordOfArrays"] = $601653c7aaa54218$export$c371a74fe5222b3;

});

parcelRegister("3sOoJ", function(module, exports) {

var $veDrf = parcelRequire("veDrf");


var $fb5K7 = parcelRequire("fb5K7");


var $bOMi3 = parcelRequire("bOMi3");

const $3b355d2da1ab4fe0$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $fb5K7.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $3b355d2da1ab4fe0$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $veDrf.default).packageVersion,
            ...init?.headers
        }
    }).then(!emptyResponse ? $3b355d2da1ab4fe0$var$extraJsonFromResponse : ()=>{});
const $3b355d2da1ab4fe0$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $bOMi3.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $veDrf.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($3b355d2da1ab4fe0$var$extraJsonFromResponse);
};
const $3b355d2da1ab4fe0$export$c776284ef4b1209a = (url, data, emptyResponse)=>$3b355d2da1ab4fe0$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);
module.exports["fetchJson"] = $3b355d2da1ab4fe0$export$6d71b655afe1638d;
module.exports["fetchJsonWithNetworkRetries"] = $3b355d2da1ab4fe0$export$16566b750080153d;
module.exports["postJson"] = $3b355d2da1ab4fe0$export$c776284ef4b1209a;

});

parcelRegister("veDrf", function(module, exports) {
const $8c29506b05721e02$var$packageName = "platform-pkg";
const $8c29506b05721e02$var$packageVersion = "0.0.0-use.local";
const $8c29506b05721e02$var$_default_1 = {
    packageName: $8c29506b05721e02$var$packageName,
    packageVersion: $8c29506b05721e02$var$packageVersion
};
var $8c29506b05721e02$export$2e2bcd8739ae039 = $8c29506b05721e02$var$_default_1;
module.exports["default"] = $8c29506b05721e02$export$2e2bcd8739ae039;

});

parcelRegister("fb5K7", function(module, exports) {
const $6b3668d5de18e4cb$export$83179404a61b001a = 'FetchError';
class $6b3668d5de18e4cb$export$26e841bcf1aeb894 extends Error {
    static isFetchError(value) {
        return value instanceof $6b3668d5de18e4cb$export$26e841bcf1aeb894;
    }
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.name = $6b3668d5de18e4cb$export$83179404a61b001a;
        this.status = status;
    }
}
module.exports["FETCH_ERROR_NAME"] = $6b3668d5de18e4cb$export$83179404a61b001a;
module.exports["FetchError"] = $6b3668d5de18e4cb$export$26e841bcf1aeb894;

});

parcelRegister("bOMi3", function(module, exports) {
const $1954a3f70857e57b$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $1954a3f70857e57b$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $1954a3f70857e57b$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};
module.exports["retryOnException"] = $1954a3f70857e57b$export$1d94629c94e7a17f;

});

parcelRegister("eeq36", function(module, exports) {

var $3sOoJ = parcelRequire("3sOoJ");


var $fWBfP = parcelRequire("fWBfP");


var $g0Lgx = parcelRequire("g0Lgx");

const $a8576acaeede6e4b$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $fWBfP.withCached)((param)=>(0, $3sOoJ.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $g0Lgx.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $a8576acaeede6e4b$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig, shouldUpdate)=>{
    const fetchMethod = (0, $fWBfP.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $g0Lgx.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig, shouldUpdate)
    };
};
module.exports["createProviderWithCustomFetchData"] = $a8576acaeede6e4b$export$310e48be95687c2f;

});

parcelRegister("fWBfP", function(module, exports) {
const $584a41a8a11c1a15$export$d4d4b402ab64e2f4 = 5000;
const $584a41a8a11c1a15$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $584a41a8a11c1a15$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($584a41a8a11c1a15$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $584a41a8a11c1a15$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};
module.exports["withCached"] = $584a41a8a11c1a15$export$7f51828d6b6af163;

});

parcelRegister("g0Lgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7121bf88385395b$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $bLbuQ = parcelRequire("bLbuQ");
var $852mP = parcelRequire("852mP");


var $9QZAl = parcelRequire("9QZAl");


var $gOJC3 = parcelRequire("gOJC3");


var $bOMi3 = parcelRequire("bOMi3");

const $c7121bf88385395b$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $c7121bf88385395b$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $c7121bf88385395b$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $c7121bf88385395b$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $c7121bf88385395b$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $c7121bf88385395b$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $c7121bf88385395b$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $c7121bf88385395b$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $bOMi3.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $9QZAl.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$c7121bf88385395b$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $9QZAl.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args);
            this.acceptResults = true;
            this.state = getInitialState(this.props.params);
            this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $c7121bf88385395b$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    DataProvider.displayName = `DataProvider(${name})`;
    const InnerComponent = (0, $lzgC6.default)()((0, $gOJC3.withExperienceTracker)(DataProvider));
    const OuterComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
        const $ = (0, $bDgLe.c)(6);
        let children;
        let params;
        if ($[0] !== t0) {
            ({ children: children, ...params } = t0);
            $[0] = t0;
            $[1] = children;
            $[2] = params;
        } else {
            children = $[1];
            params = $[2];
        }
        const t1 = params;
        let t2;
        if ($[3] !== children || $[4] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                params: t1
            }, children);
            $[3] = children;
            $[4] = t1;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    } : ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}
module.exports["Status"] = $c7121bf88385395b$export$96e9906d6d93a972;
module.exports["isComplete"] = $c7121bf88385395b$export$9569565a7ac14e8e;
module.exports["isError"] = $c7121bf88385395b$export$e6127cc7fe7395c3;
module.exports["isLoading"] = $c7121bf88385395b$export$20bb0d907fbbe433;
module.exports["hasLoaded"] = $c7121bf88385395b$export$5fce62f50756dbf;

});

parcelRegister("bLbuQ", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("lzgC6")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("jpjVJ")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("852mP")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("852mP")).UI_EVENT_TYPE);

var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $jpjVJ = parcelRequire("jpjVJ");


var $2iGHk = parcelRequire("2iGHk");


var $lzgC6 = parcelRequire("lzgC6");


var $g0Lgx = parcelRequire("g0Lgx");


var $9Q3kT = parcelRequire("9Q3kT");


var $5rYVO = parcelRequire("5rYVO");

const $6fcfd6478a64f762$export$515664faa1398f37 = 'navigation';
const $6fcfd6478a64f762$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $6fcfd6478a64f762$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $6fcfd6478a64f762$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $6fcfd6478a64f762$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $6fcfd6478a64f762$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $6fcfd6478a64f762$export$2b570fc112cbca = 'atlassianSwitcher';
const $6fcfd6478a64f762$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $6fcfd6478a64f762$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $6fcfd6478a64f762$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $6fcfd6478a64f762$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $6fcfd6478a64f762$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $6fcfd6478a64f762$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $6fcfd6478a64f762$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $6fcfd6478a64f762$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $6fcfd6478a64f762$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $6fcfd6478a64f762$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $6fcfd6478a64f762$var$RENDERED_ACTION = 'rendered';
const $6fcfd6478a64f762$var$NOT_RENDERED_ACTION = 'not_rendered';
const $6fcfd6478a64f762$var$VIEWED_ACTION = 'viewed';
const $6fcfd6478a64f762$export$884b1a4c7ac9dd14 = (0, $2iGHk.default)($6fcfd6478a64f762$export$515664faa1398f37);
const $6fcfd6478a64f762$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $6fcfd6478a64f762$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jpjVJ.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
    };
};
const $6fcfd6478a64f762$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $6fcfd6478a64f762$export$e09ad93c2b74b853 = (0, $lzgC6.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            action: $6fcfd6478a64f762$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$6fcfd6478a64f762$var$isValidDuration(duration) && {
                    bucket: (0, $5rYVO.getMetricBucket)(duration, (0, $5rYVO.RenderTrackerBuckets))
                }
            }
        }).fire($6fcfd6478a64f762$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $6fcfd6478a64f762$export$95b1f1a72cad0dcb = (0, $lzgC6.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            action: $6fcfd6478a64f762$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($6fcfd6478a64f762$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $6fcfd6478a64f762$export$b3fd6624b6a6d057 = (0, $lzgC6.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: $6fcfd6478a64f762$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($6fcfd6478a64f762$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $6fcfd6478a64f762$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $6fcfd6478a64f762$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $6fcfd6478a64f762$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $g0Lgx.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $6fcfd6478a64f762$var$renderTracker({
        subject: $6fcfd6478a64f762$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $6fcfd6478a64f762$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $g0Lgx.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $9Q3kT.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $6fcfd6478a64f762$var$renderTrackerWithReason({
        subject: $6fcfd6478a64f762$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $6fcfd6478a64f762$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$6fcfd6478a64f762$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });
module.exports["NAVIGATION_CHANNEL"] = $6fcfd6478a64f762$export$515664faa1398f37;
module.exports["SWITCHER_SUBJECT"] = $6fcfd6478a64f762$export$17ff9c46e41eb585;
module.exports["SWITCHER_ITEM_LOZENGES_SUBJECT"] = $6fcfd6478a64f762$export$c3c93e13b09d3ad9;
module.exports["SWITCHER_COMPONENT"] = $6fcfd6478a64f762$export$2b570fc112cbca;
module.exports["SWITCHER_SOURCE"] = $6fcfd6478a64f762$export$5ed36c4d23de5568;
module.exports["TRIGGER_COMPONENT"] = $6fcfd6478a64f762$export$8d2f933bbd9e4f09;
module.exports["TRIGGER_SUBJECT"] = $6fcfd6478a64f762$export$d7029a5dc66b0736;
module.exports["SWITCHER_PARTIAL_RESULTS"] = $6fcfd6478a64f762$export$4649adbfda1b6a66;
module.exports["SWITCHER_JOINABLE_SITES"] = $6fcfd6478a64f762$export$5724539c9b1a3a5d;
module.exports["SWITCHER_AVAILABLE_PRODUCTS"] = $6fcfd6478a64f762$export$22f5f827d9934254;
module.exports["analyticsAttributes"] = $6fcfd6478a64f762$export$a305f130b289b818;
module.exports["withAnalyticsContextData"] = $6fcfd6478a64f762$export$97ebdd8e7274f18a;
module.exports["RenderTracker"] = $6fcfd6478a64f762$export$e09ad93c2b74b853;
module.exports["NotRenderedTracker"] = $6fcfd6478a64f762$export$95b1f1a72cad0dcb;
module.exports["ViewedTracker"] = $6fcfd6478a64f762$export$b3fd6624b6a6d057;
module.exports["getCustomLinksRenderTracker"] = $6fcfd6478a64f762$export$d75a4f56d85f67ea;
module.exports["getItemAnalyticsContext"] = $6fcfd6478a64f762$export$6489efba2ca85102;

});

parcelRegister("9Q3kT", function(module, exports) {
var $5bc992ef1d353b66$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $5bc992ef1d353b66$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.reason = void 0;
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}
module.exports["UserSiteDataErrorReason"] = $5bc992ef1d353b66$export$b08600051ba52198;
module.exports["UserSiteDataError"] = $5bc992ef1d353b66$export$c460344055e97b1;

});

parcelRegister("5rYVO", function(module, exports) {
const $b2734103d0e27db2$var$INFINITY = '+Inf';
const $b2734103d0e27db2$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $b2734103d0e27db2$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $b2734103d0e27db2$var$INFINITY) : null;
};
module.exports["RenderTrackerBuckets"] = $b2734103d0e27db2$export$e59c24bc0768d568;
module.exports["getMetricBucket"] = $b2734103d0e27db2$export$b59492d26971ae92;

});

parcelRegister("9QZAl", function(module, exports) {
function $96bbfe81b96031d5$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}
module.exports["errorToReason"] = $96bbfe81b96031d5$export$a3e288208721751b;

});

parcelRegister("gOJC3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $aaf5556ace093621$var$noop = ()=>{};
const $aaf5556ace093621$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $cozmU.createContext)({
    start: $aaf5556ace093621$var$noop,
    success: $aaf5556ace093621$var$noop,
    failure: $aaf5556ace093621$var$noop,
    failureAll: $aaf5556ace093621$var$noop,
    abort: $aaf5556ace093621$var$noop,
    abortAll: $aaf5556ace093621$var$noop,
    markStart: $aaf5556ace093621$var$noop,
    markEnd: $aaf5556ace093621$var$noop
});
const $aaf5556ace093621$export$cdefb2a8b53f879f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($aaf5556ace093621$export$3f3eebb4b8116461);
} : ()=>(0, $cozmU.useContext)($aaf5556ace093621$export$3f3eebb4b8116461);
const $aaf5556ace093621$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const experienceTracker = $aaf5556ace093621$export$cdefb2a8b53f879f();
        let t0;
        if ($[0] !== experienceTracker || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...props,
                experienceTracker: experienceTracker
            });
            $[0] = experienceTracker;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const experienceTracker = $aaf5556ace093621$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};
module.exports["SwitcherExperienceTrackerContext"] = $aaf5556ace093621$export$3f3eebb4b8116461;
module.exports["useExperienceTracker"] = $aaf5556ace093621$export$cdefb2a8b53f879f;
module.exports["withExperienceTracker"] = $aaf5556ace093621$export$f88dde183f4d31cb;

});

parcelRegister("7L44N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f1G3w = parcelRequire("f1G3w");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $iQwJa = parcelRequire("iQwJa");


var $bGVJw = parcelRequire("bGVJw");


var $5h1mk = parcelRequire("5h1mk");


var $1RMKR = parcelRequire("1RMKR");


var $4OYR1 = parcelRequire("4OYR1");


var $gswTK = parcelRequire("gswTK");


var $9aSEF = parcelRequire("9aSEF");


var $4PX6o = parcelRequire("4PX6o");


var $3raeL = parcelRequire("3raeL");

const $17d7b5e1361d82f3$var$useInitialDataIfEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, context, baseUrl, path, disableInitialData)=>{
    const $ = (0, $bDgLe.c)(10);
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    let t0;
    if ($[0] !== context) {
        t0 = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const arePlacementsGloballyDisabled = t0;
    let t1;
    if ($[2] !== arePlacementsGloballyDisabled || $[3] !== baseUrl || $[4] !== context || $[5] !== disableInitialData || $[6] !== fetcher.fetch || $[7] !== path || $[8] !== placementId) {
        t1 = arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        });
        $[2] = arePlacementsGloballyDisabled;
        $[3] = baseUrl;
        $[4] = context;
        $[5] = disableInitialData;
        $[6] = fetcher.fetch;
        $[7] = path;
        $[8] = placementId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $cozmU.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $17d7b5e1361d82f3$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $17d7b5e1361d82f3$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $17d7b5e1361d82f3$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $a33Aa.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $a33Aa.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $17d7b5e1361d82f3$var$Placement = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: t1, children: children } = t0;
    const disableInitialData = t1 === undefined ? false : t1;
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    let t2;
    if ($[0] !== context || $[1] !== postOfficeRoute) {
        t2 = {
            ...context,
            postOfficeRoute: postOfficeRoute
        };
        $[0] = context;
        $[1] = postOfficeRoute;
        $[2] = t2;
    } else t2 = $[2];
    const stableContextWithRoute = (0, $1RMKR.useStableObject)(t2);
    let t3;
    if ($[3] !== consumptionType || $[4] !== placementId) {
        t3 = new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType);
        $[3] = consumptionType;
        $[4] = placementId;
        $[5] = t3;
    } else t3 = $[5];
    const ufoV1PlacementTracker = t3;
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const t4 = ufoV2InteractionContext?.labelStack;
    let t5;
    if ($[6] !== t4 || $[7] !== ufoV2InteractionId.current) {
        t5 = {
            interactionId: ufoV2InteractionId.current,
            labelStack: t4
        };
        $[6] = t4;
        $[7] = ufoV2InteractionId.current;
        $[8] = t5;
    } else t5 = $[8];
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)(t5);
    let t6;
    if ($[9] !== consumptionType || $[10] !== placementId || $[11] !== placementOnEvent || $[12] !== stableUfoV2Interaction || $[13] !== ufoV1PlacementTracker) {
        t6 = (t7)=>{
            const { type: type, error: error } = t7;
            if (consumptionType === "local") {
                switch(type){
                    case "fetch-error":
                    case "component-error":
                    case "render-error":
                        $17d7b5e1361d82f3$var$handleUfoV2Error({
                            ufoV2Interaction: stableUfoV2Interaction,
                            placementId: placementId,
                            error: error,
                            errorEventType: type
                        });
                }
                return;
            }
            if (consumptionType === "remote") {
                placementOnEvent?.({
                    type: type,
                    error: error
                });
                bb29: switch(type){
                    case "fetch-complete":
                        ufoV1PlacementTracker?.markFetchComplete();
                        break bb29;
                    case "fetch-error":
                        ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "render-complete":
                        ufoV1PlacementTracker?.markRenderComplete();
                        break bb29;
                    case "render-error":
                        ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "initial-data-complete":
                        ufoV1PlacementTracker?.markInitialDataComplete();
                        break bb29;
                    case "initial-data-error":
                        ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-error":
                        ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-ready":
                        ufoV1PlacementTracker?.markComponentReady();
                        break bb29;
                    case "unmount":
                        ufoV1PlacementTracker?.markComponentAborted();
                }
            }
        };
        $[9] = consumptionType;
        $[10] = placementId;
        $[11] = placementOnEvent;
        $[12] = stableUfoV2Interaction;
        $[13] = ufoV1PlacementTracker;
        $[14] = t6;
    } else t6 = $[14];
    const componentOnEvent = t6;
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    let t7;
    if ($[15] !== placementId) {
        t7 = {
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: "Placement",
            attributes: {
                placementId: placementId,
                channel: "in-app"
            }
        };
        $[15] = placementId;
        $[16] = t7;
    } else t7 = $[16];
    const placementAnalyticsContext = t7;
    let t8;
    if ($[17] !== children || $[18] !== componentOnEvent || $[19] !== initialData || $[20] !== stableContextWithRoute) {
        t8 = children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        });
        $[17] = children;
        $[18] = componentOnEvent;
        $[19] = initialData;
        $[20] = stableContextWithRoute;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== placementAnalyticsContext || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext
        }, t8);
        $[22] = placementAnalyticsContext;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    const stableContextWithRoute = (0, $1RMKR.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $cozmU.useMemo)(()=>isUFOEnabled ? new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $cozmU.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    $17d7b5e1361d82f3$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $cozmU.useMemo)(()=>({
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $17d7b5e1361d82f3$export$2e2bcd8739ae039 = $17d7b5e1361d82f3$var$Placement;
module.exports["default"] = $17d7b5e1361d82f3$export$2e2bcd8739ae039;

});

parcelRegister("9aSEF", function(module, exports) {
const $94018a62770928ba$export$85183a312807388d = 'postOffice';
const $94018a62770928ba$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $94018a62770928ba$export$f7109619a5e9e0d6;

});

parcelRegister("3raeL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $jdpvF = parcelRequire("jdpvF");

const $04b3f6e864eb8426$export$83d6c58b7ab7ae67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    let t0;
    if ($[0] !== postOfficeEnvironment.currentEnv || $[1] !== postOfficeEnvironment.envConfigs) {
        t0 = (0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs);
        $[0] = postOfficeEnvironment.currentEnv;
        $[1] = postOfficeEnvironment.envConfigs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    return (0, $cozmU.useMemo)(()=>(0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $04b3f6e864eb8426$export$83d6c58b7ab7ae67;

});

parcelRegister("6cyWf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $350c8455dc4e7cf5$export$d158fa15757a1890 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $350c8455dc4e7cf5$export$abfcaeeca4ae7a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
} : function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
};
module.exports["HasCustomThemeContext"] = $350c8455dc4e7cf5$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $350c8455dc4e7cf5$export$abfcaeeca4ae7a55;

});

parcelRegister("aXMFs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $25b427f2364d8f29$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $25b427f2364d8f29$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $25b427f2364d8f29$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $iDrrr.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps));
};
var $25b427f2364d8f29$export$2e2bcd8739ae039 = $25b427f2364d8f29$var$IconRenderer;
module.exports["default"] = $25b427f2364d8f29$export$2e2bcd8739ae039;

});

parcelRegister("5dijw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $hBYtq = parcelRequire("hBYtq");


var $hVZgb = parcelRequire("hVZgb");

const $33036e997e9cb956$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCjOvk _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $33036e997e9cb956$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
const $33036e997e9cb956$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $33036e997e9cb956$export$66240319f1f78d74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $hBYtq.Pressable);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    const t2 = $33036e997e9cb956$var$shapeStyles[shape];
    const t3 = hasBorder && $33036e997e9cb956$var$styles.border;
    const t4 = $33036e997e9cb956$var$appearanceStyles[appearance];
    const t5 = isSelected && $33036e997e9cb956$var$styles.selected;
    const t6 = isDisabled && $33036e997e9cb956$var$styles.disabled;
    let t7;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
        t7 = (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, t2, t3, t4, t5, t6);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== T0 || $[15] !== isDisabled || $[16] !== ref || $[17] !== t1 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            type: "button",
            xcss: t7,
            isDisabled: isDisabled
        });
        $[14] = T0;
        $[15] = isDisabled;
        $[16] = ref;
        $[17] = t1;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref)=>{
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $33036e997e9cb956$export$66240319f1f78d74;

});

parcelRegister("hVZgb", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $c03f86859c8952b6$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $c03f86859c8952b6$export$e4c95325a21f9785;

});

parcelRegister("cQUD5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");


var $14v7H = parcelRequire("14v7H");


var $fAint = parcelRequire("fAint");

function $2f8cb6b1da1c2a48$var$useUFOExperience(id, config, instanceId) {
    return (0, $cozmU.useMemo)(()=>new (0, $34VCg.UFOExperience)(id, config, instanceId), [
        id,
        config,
        instanceId
    ]);
}
function $2f8cb6b1da1c2a48$export$cdefb2a8b53f879f(key) {
    const experienceObj = (0, $fAint.NavigationExperienceId)[key];
    const experience = $2f8cb6b1da1c2a48$var$useUFOExperience(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
    (0, $14v7H.useUFOComponentExperience)(experience); // this hook starts the experience and aborts it when the component is unmounted
    return experience;
}
function $2f8cb6b1da1c2a48$export$15f9dc99109fec75(key) {
    const experienceObj = (0, $fAint.NavigationExperienceId)[key];
    return new (0, $34VCg.UFOExperience)(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
}
module.exports["useExperienceTracker"] = $2f8cb6b1da1c2a48$export$cdefb2a8b53f879f;
module.exports["createExperienceTracker"] = $2f8cb6b1da1c2a48$export$15f9dc99109fec75;

});

parcelRegister("14v7H", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4fc294785825a382$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $cozmU.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $4fc294785825a382$export$30ab340faaed55d4 = (experience)=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $4fc294785825a382$var$useConstructor(()=>experience.start());
    return null;
};
module.exports["useUFOComponentExperience"] = $4fc294785825a382$export$30ab340faaed55d4;

});

parcelRegister("aCv1y", function(module, exports) {

var $6xccU = parcelRequire("6xccU");

const $a224a4603eed6bce$export$dbcfff0b6c1cf64c = ({ knowledgeSources: knowledgeSources, connectorsErrored: connectorsErrored })=>{
    const adminAllowed3pAppCount = knowledgeSources.filter((connector)=>(0, $6xccU.is3pApp)(connector.friendlyName)).length;
    return {
        isEligible: adminAllowed3pAppCount > 0,
        adminAllowed3pAppCount: adminAllowed3pAppCount,
        knowledgeSourceCount: knowledgeSources.length,
        connectorsErrored: connectorsErrored
    };
};
module.exports["getThirdPartyEligibility"] = $a224a4603eed6bce$export$dbcfff0b6c1cf64c;

});

parcelRegister("5kbLE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $7L44N = parcelRequire("7L44N");


var $6U5eU = parcelRequire("6U5eU");


var $ll379 = parcelRequire("ll379");


var $cozmU = parcelRequire("cozmU");


var $fcLDg = parcelRequire("fcLDg");


var $jBS9T = parcelRequire("jBS9T");

const $a0d19ad2319e4e34$var$STABLE_OBJECT = {};
const $a0d19ad2319e4e34$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $cozmU.useMemo)(()=>(0, $6U5eU.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $1RMKR.useStableObject)(placementProps ?? $a0d19ad2319e4e34$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7L44N.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fcLDg.default), {
                    analyticsChannel: (0, $jBS9T.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $a0d19ad2319e4e34$var$PlacementMemoized = /*#__PURE__*/ (0, $cozmU.memo)($a0d19ad2319e4e34$var$Placement);
var $a0d19ad2319e4e34$export$2e2bcd8739ae039 = $a0d19ad2319e4e34$var$PlacementMemoized;
module.exports["default"] = $a0d19ad2319e4e34$export$2e2bcd8739ae039;

});

parcelRegister("fcLDg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $lzgC6 = parcelRequire("lzgC6");


var $cozmU = parcelRequire("cozmU");

class $45465d036124c3a6$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $45465d036124c3a6$var$ErrorBoundaryWithAnalytics = (0, $lzgC6.default)()($45465d036124c3a6$var$ErrorBoundary);
var $45465d036124c3a6$export$2e2bcd8739ae039 = $45465d036124c3a6$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $45465d036124c3a6$export$2e2bcd8739ae039;

});

parcelRegister("jBS9T", function(module, exports) {
const $27b0c301be1a67fd$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $27b0c301be1a67fd$export$85183a312807388d;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<75dc67bed6c2efce761cd8d41d39e8c1>>
 * @relayHash 509c79ed3aa65395a6739ffb9126f832
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "originTabId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "509c79ed3aa65395a6739ffb9126f832",
            "id": "c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "c37cfea9a825383fc3da89eb6b15ecfd";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $422HI = parcelRequire("422HI");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7EPz1.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        const subscriptionField = Object.keys(result?.subscriptionData?.data ?? {}).find((field)=>field !== '__typename');
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || '',
                    ...subscriptionField && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? {
                        subscriptionField: subscriptionField
                    } : {}
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $7rovI = parcelRequire("7rovI");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEdit, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage || isAccessLinkEdit && isAccessLinkEditing) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("lfBMY", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("9EemN", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("kRW4Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $kNIYN.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $204vt = parcelRequire("204vt");


var $hfrng = parcelRequire("hfrng");


var $3kI72 = parcelRequire("3kI72");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) return (0, $3kI72.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getContentIdFromCollection = (authContext)=>{
    const match = /^contentId-(\d+)$/.exec(authContext?.collectionName ?? '');
    return match?.[1];
};
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async (authContext)=>{
        const data = await dataGetter(authContext);
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter(params));
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) {
        const auth = await (0, $3kI72.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$createRenameFile = (mediaClientConfig, getCollection)=>{
    const mediaClient = new (0, $204vt.MediaClient)(mediaClientConfig);
    return async (fileId, name)=>{
        const collection = getCollection();
        if (!collection) throw new Error('Cannot rename media file without a collection');
        await mediaClient.mediaStore.request('/files/rename', {
            method: 'PUT',
            endpoint: '/files/rename',
            authContext: {
                collectionName: collection
            },
            params: {
                collection: collection
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                collection: collection,
                files: [
                    {
                        fileId: fileId,
                        fileName: name,
                        oldFileName: ''
                    }
                ]
            })
        });
    };
};
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async (authContext)=>{
        const contentIdFromCollection = options.resolveContentIdFromCollection && !options.isExternalShare && !options.mediaToken && options.contentProduct !== 'jira-work-item' && (0, $6mKj3.expValEquals)('platform_media_token_nested_macro', 'isEnabled', true) ? $17b0f8a5b73de479$var$getContentIdFromCollection(authContext) : undefined;
        const contentId = contentIdFromCollection ?? options.contentId;
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        renameFile: $17b0f8a5b73de479$var$createRenameFile(uploadMediaClientConfig, ()=>collection)
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $hfrng.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $hfrng.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async (authContext)=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)(authContext);
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    // Register the global file-added listener dynamically so that SPA navigations always
    // register the attachment callback against the current page's contentId.
    const registerDynamicFileAddedListener = ()=>{
        $17b0f8a5b73de479$var$registerGlobalFileAddedListener(getOptions());
    };
    // Track the last contentId we fetched upload data for, and the cached result.
    // This lets us detect a contentId change and eagerly re-fetch before any upload.
    let lastFetchedContentId = initialOptions.contentId;
    let latestUploadData;
    // Deduplicate concurrent calls to refreshUploadDataIfNeeded — if a refresh is already
    // in-flight (e.g. from useMediaOptions and authProvider both calling simultaneously),
    // subsequent callers share the same promise rather than racing to write latestUploadData.
    let inFlightRefresh;
    // Refresh upload data for the current options if contentId has changed since the
    // last fetch. Concurrent calls are deduplicated via inFlightRefresh.
    // Called by useMediaOptions on navigation so all uploadParams.collection read sites
    // get the correct collection without needing to do anything special themselves.
    const refreshUploadDataIfNeeded = async ()=>{
        const currentOptions = getOptions();
        if (currentOptions.contentId !== lastFetchedContentId) {
            if (inFlightRefresh) return inFlightRefresh;
            inFlightRefresh = (async ()=>{
                registerDynamicFileAddedListener();
                latestUploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                lastFetchedContentId = currentOptions.contentId;
                inFlightRefresh = undefined;
            })();
            return inFlightRefresh;
        }
    };
    // Build a fully-dynamic uploadMediaClientConfig whose authProvider always fetches
    // upload data for the CURRENT options so tokens stay correct across SPA navigations.
    // Note: we do NOT call registerDynamicFileAddedListener here — the listener is only
    // re-registered in refreshUploadDataIfNeeded (on actual navigation), not on every
    // token fetch, to avoid unnecessary teardown/rebuild of the module-level singleton.
    const dynamicUploadMediaClientConfig = {
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf(async ()=>{
            const currentOptions = getOptions();
            const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
            latestUploadData = uploadData;
            lastFetchedContentId = currentOptions.contentId;
            return uploadData;
        }),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    };
    // Fetch all async dependencies in parallel — no waterfall.
    const [viewMediaClientConfig, viewAndUploadMediaClientConfig, initialUploadData] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        $17b0f8a5b73de479$var$cachedGetUploadData.getValue(getOptions())
    ]);
    latestUploadData = initialUploadData;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        // uploadParams is resolved via a getter so SPA navigations don't leave the collection
        // frozen to the page that was active when this provider was first created.
        get uploadParams () {
            return {
                collection: latestUploadData.collectionId,
                onUploadRejection: getOptions().onUploadRejection
            };
        },
        refreshUploadDataIfNeeded: refreshUploadDataIfNeeded,
        uploadMediaClientConfig: dynamicUploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        renameFile: $17b0f8a5b73de479$var$createRenameFile(dynamicUploadMediaClientConfig, ()=>latestUploadData.collectionId)
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3kI72", function(module, exports) {

var $oWJUu = parcelRequire("oWJUu");


var $55mlV = parcelRequire("55mlV");

const $515968ab7e772985$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $515968ab7e772985$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $oWJUu.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $55mlV.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $515968ab7e772985$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $515968ab7e772985$export$9f88fc74c33fbfe;

});

parcelRegister("oWJUu", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $61ef070287c5800f$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $61ef070287c5800f$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $61ef070287c5800f$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $61ef070287c5800f$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($61ef070287c5800f$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$61ef070287c5800f$var$COMMON_HEADERS,
            ...$61ef070287c5800f$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $61ef070287c5800f$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $61ef070287c5800f$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $61ef070287c5800f$export$2b7fb70f168591f8;

});

parcelRegister("55mlV", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");


var $EBNuL = parcelRequire("EBNuL");

const $05854aa166d857a3$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $05854aa166d857a3$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $05854aa166d857a3$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $05854aa166d857a3$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($05854aa166d857a3$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$05854aa166d857a3$var$COMMON_HEADERS,
            ...$05854aa166d857a3$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $05854aa166d857a3$export$5bc7dcc953e26849 = async (sourceAri)=>{
    try {
        const issueAri = (0, $EBNuL.getJiraIssueAriFromSourceAri)({
            ari: sourceAri
        });
        const response = await $05854aa166d857a3$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $05854aa166d857a3$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("kzNtP", function(module, exports) {

var $6AroL = parcelRequire("6AroL");


var $3u5lg = parcelRequire("3u5lg");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $6AroL.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<d8493d612cba7ab67c2663a1ef2f2968>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $6IsMq = parcelRequire("6IsMq");


var $3j8TZ = parcelRequire("3j8TZ");


var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $1UWNP = parcelRequire("1UWNP");


var $6AroL = parcelRequire("6AroL");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
const $1fd47ba2b01e31e6$export$96b44174d5bb0faa = (0, $3j8TZ.default);
const $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery = (0, $6IsMq.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment') // Hard disable drag-and-drop upload functionality for comments
    return;
    // Normal uploads (file browser, copy-paste, etc.) go through the regular upload mutation.
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
let $1fd47ba2b01e31e6$var$isFirstLoadJira = true;
const $1fd47ba2b01e31e6$export$5bc7dcc953e26849 = (issueAri)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery,
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoadJira ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoadJira = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const variables = {
        action: 'ATTACHMENT_DOWNLOAD',
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> a relay-compatible replacement is available in the @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "fabric-media-support"
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<daf984ad5eaae28ba5768f141c1480ac>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<4edd735d079b37bb48067afaa74a4066>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const includeMeetingRecorderEligibility = t0;
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== activationId || $[4] !== cloudId) {
        t2 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[3] = activationId;
        $[4] = cloudId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            headers: {
                ...t2
            }
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            variables: t1,
            context: t3,
            skip: t4
        };
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t5,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== initLoomEntryPointVariant || $[5] !== loading || $[6] !== skip || $[7] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = initLoomEntryPointVariant;
        $[5] = loading;
        $[6] = skip;
        $[7] = userId;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("fu2Vq"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("fu2Vq", function(module, exports) {

let $b45bed3ed025790a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b45bed3ed025790a$var$load("6wr18"),
    $b45bed3ed025790a$var$load("dQT3c"),
    $b45bed3ed025790a$var$load("4nZ85"),
    $b45bed3ed025790a$var$load("ffEVr"),
    $b45bed3ed025790a$var$load("kHXvF"),
    $b45bed3ed025790a$var$load("iWnyc"),
    $b45bed3ed025790a$var$load("hhss7"),
    $b45bed3ed025790a$var$load("Wowvf"),
    $b45bed3ed025790a$var$load("4g6rd"),
    $b45bed3ed025790a$var$load("7EorR"),
    $b45bed3ed025790a$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined,
    onSubmitCallback: undefined,
    editorInsertionAcknowledgement: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, onSubmitCallback: onSubmitCallback, editorInsertionAcknowledgement: editorInsertionAcknowledgement, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined,
                onSubmitCallback: onSubmitCallback ?? undefined,
                editorInsertionAcknowledgement: editorInsertionAcknowledgement ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined,
                onSubmitCallback: undefined,
                editorInsertionAcknowledgement: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e8b2cdb4a7b2569268a3fe6ec068354>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_iconNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_iconNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $7joZr = parcelRequire("7joZr");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onUpFlowOpen;
        $[6] = props;
        $[7] = secondaryLink;
        $[8] = source;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onUpFlowOpen = $[5];
        props = $[6];
        secondaryLink = $[7];
        source = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        targetEdition = $[12];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const t4 = Boolean(grandfathered);
    let t5;
    if ($[13] !== isSiteAdmin || $[14] !== t4) {
        t5 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t4
        };
        $[13] = isSiteAdmin;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    const CTAAnalyticsAttributes = t5;
    let t6;
    if ($[16] !== CTAAnalyticsAttributes || $[17] !== source) {
        t6 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[16] = CTAAnalyticsAttributes;
        $[17] = source;
        $[18] = t6;
    } else t6 = $[18];
    const generateCTAAnalyticsProps = t6;
    let t7;
    if ($[19] !== CTAAnalyticsAttributes || $[20] !== createAnalyticsEvent || $[21] !== source) {
        t7 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[19] = CTAAnalyticsAttributes;
        $[20] = createAnalyticsEvent;
        $[21] = source;
        $[22] = t7;
    } else t7 = $[22];
    const triggerLinkClickAnalytics = t7;
    let t8;
    if ($[23] !== secondaryLink || $[24] !== triggerLinkClickAnalytics) {
        t8 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[23] = secondaryLink;
        $[24] = triggerLinkClickAnalytics;
        $[25] = t8;
    } else t8 = $[25];
    const handleSecondaryLinkClick = t8;
    let t10;
    let t9;
    if ($[26] !== CTAAnalyticsAttributes || $[27] !== createAnalyticsEvent || $[28] !== source) {
        t9 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t10 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[26] = CTAAnalyticsAttributes;
        $[27] = createAnalyticsEvent;
        $[28] = source;
        $[29] = t10;
        $[30] = t9;
    } else {
        t10 = $[29];
        t9 = $[30];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let T0;
    let t11;
    if ($[31] !== buttonConfig || $[32] !== canShowUpgradeButton || $[33] !== generateCTAAnalyticsProps || $[34] !== handleSecondaryLinkClick || $[35] !== isSiteAdmin || $[36] !== learnMoreLink || $[37] !== onUpFlowOpen || $[38] !== props || $[39] !== secondaryLink || $[40] !== source || $[41] !== targetEdition || $[42] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !secondaryLink
            }, (t12)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t12;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, primary, secondaries);
            });
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t13)=>{
            const { children: children, ...learnMoreProps } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t11 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, renderButtons()) : undefined;
        $[31] = buttonConfig;
        $[32] = canShowUpgradeButton;
        $[33] = generateCTAAnalyticsProps;
        $[34] = handleSecondaryLinkClick;
        $[35] = isSiteAdmin;
        $[36] = learnMoreLink;
        $[37] = onUpFlowOpen;
        $[38] = props;
        $[39] = secondaryLink;
        $[40] = source;
        $[41] = targetEdition;
        $[42] = upgradeEditionActionSubjectId;
        $[43] = T0;
        $[44] = t11;
    } else {
        T0 = $[43];
        t11 = $[44];
    }
    let t12;
    if ($[45] !== footer || $[46] !== isSiteAdmin) {
        t12 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, footer) : null;
        $[45] = footer;
        $[46] = isSiteAdmin;
        $[47] = t12;
    } else t12 = $[47];
    let t13;
    if ($[48] !== headerButton) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, headerButton);
        $[48] = headerButton;
        $[49] = t13;
    } else t13 = $[49];
    let t14;
    if ($[50] !== T0 || $[51] !== props || $[52] !== t11 || $[53] !== t12 || $[54] !== t13 || $[55] !== targetEdition) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            actions: t11,
            edition: targetEdition,
            footer: t12,
            headerButton: t13,
            ...props
        });
        $[50] = T0;
        $[51] = props;
        $[52] = t11;
        $[53] = t12;
        $[54] = t13;
        $[55] = targetEdition;
        $[56] = t14;
    } else t14 = $[56];
    return t14;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $cozmU.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !secondaryLink
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jd2pZ = parcelRequire("jd2pZ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $iMnC5 = parcelRequire("iMnC5");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonStyles = {
    withPadding: "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _2Zuz6Q2ADO _1Znuxb2ADO",
    withoutPadding: "_4FKVYEPgdg"
};
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t3;
    if ($[0] !== edition || $[1] !== isLicensed || $[2] !== isSiteAdmin) {
        t3 = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) && !(0, $9wGTI.fg)("confluence_direct_to_commerce_upgrade");
        $[0] = edition;
        $[1] = isLicensed;
        $[2] = isSiteAdmin;
        $[3] = t3;
    } else t3 = $[3];
    const showUpFlow = t3;
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t4;
    if ($[4] !== children) {
        t4 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[4] = children;
        $[5] = t4;
    } else t4 = $[5];
    const message = t4;
    const iconOnly = icon && !message;
    let t5;
    let t6;
    if ($[6] !== experienceTracker || $[7] !== showUpFlow) {
        t5 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t6 = [
            experienceTracker,
            showUpFlow
        ];
        $[6] = experienceTracker;
        $[7] = showUpFlow;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[10] !== actionSubjectId || $[11] !== analyticsProps || $[12] !== createAnalyticsEvent || $[13] !== edition || $[14] !== experienceTracker || $[15] !== isSiteAdmin || $[16] !== showUpFlow || $[17] !== source || $[18] !== targetEdition) {
        t7 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[10] = actionSubjectId;
        $[11] = analyticsProps;
        $[12] = createAnalyticsEvent;
        $[13] = edition;
        $[14] = experienceTracker;
        $[15] = isSiteAdmin;
        $[16] = showUpFlow;
        $[17] = source;
        $[18] = targetEdition;
        $[19] = t7;
    } else t7 = $[19];
    const fireClickAnalytics = t7;
    let t8;
    if ($[20] !== onUpFlowOpen) {
        t8 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jd2pZ)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[20] = onUpFlowOpen;
        $[21] = t8;
    } else t8 = $[21];
    const onUpFlowClose = t8;
    const renderLearnMoreButton = (t9)=>{
        const props = t9 === undefined ? {} : t9;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t10;
    if ($[22] !== createAnalyticsEvent || $[23] !== inProductHelpId) {
        t10 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[22] = createAnalyticsEvent;
        $[23] = inProductHelpId;
        $[24] = t10;
    } else t10 = $[24];
    const fireAnalyticsEvent = t10;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t11;
    if ($[25] !== fireClickAnalytics || $[26] !== onClick || $[27] !== showUpFlow || $[28] !== target) {
        t11 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[25] = fireClickAnalytics;
        $[26] = onClick;
        $[27] = showUpFlow;
        $[28] = target;
        $[29] = t11;
    } else t11 = $[29];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t11,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t12 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonStyles.withoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonStyles.withPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t13;
    if ($[30] !== cloudId || $[31] !== edition || $[32] !== isSiteAdmin || $[33] !== isUpFlowOpen || $[34] !== onUpFlowClose || $[35] !== onUpFlowOpen || $[36] !== showUpFlow || $[37] !== source || $[38] !== targetEdition || $[39] !== userId) {
        t13 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[30] = cloudId;
        $[31] = edition;
        $[32] = isSiteAdmin;
        $[33] = isUpFlowOpen;
        $[34] = onUpFlowClose;
        $[35] = onUpFlowOpen;
        $[36] = showUpFlow;
        $[37] = source;
        $[38] = targetEdition;
        $[39] = userId;
        $[40] = t13;
    } else t13 = $[40];
    let t14;
    if ($[41] !== t12 || $[42] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, t13);
        $[41] = t12;
        $[42] = t13;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    !(0, $9wGTI.fg)('confluence_direct_to_commerce_upgrade');
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $cozmU.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jd2pZ)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: appearance,
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
     // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonStyles.withoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonStyles.withPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("iRYGg"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("iRYGg", function(module, exports) {

let $dbcc3f2c1eb61f8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dbcc3f2c1eb61f8e$var$load("bAgF6"),
    $dbcc3f2c1eb61f8e$var$load("82QsP")
]).then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const internalData = (0, $cozmU.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $cozmU.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $cozmU.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $cozmU.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $cozmU.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $gfV78 = parcelRequire("gfV78");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($gfV78)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bhvFb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $QPvOh = parcelRequire("QPvOh");


var $9wGTI = parcelRequire("9wGTI");


var $gsZdA = parcelRequire("gsZdA");

const $1848832735763b59$var$contentContainerStyles = {
    regular: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _1EqgXlwOVE",
    isCard: "_1EqgXlN91d"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_2sNsIg1kXk _313842dnbC _1UtDYzy7kJ",
    regularNew: "_2sNsIgWSk4 _1kk5Tkf7mX _313842dnbC _1UtDYzy7kJ",
    inlineModal: "_2sNsIgWSk4 _313842Pgdg _1wydGW5zaO"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_3138422ADO",
    noTitle: "_313842dnbC"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_3iDTPbQ4SZ _37wbyuz9WS _1mT5xdWVPG _2IhTon5zaO _4ApkO2NHnM",
    default: "_2IhTonVa5s _4ApkO2p0Oa",
    isCardDefault: "_4ApkO2Va5s",
    isCard: "_4ApkO25zaO"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_3iDTPbQ4SZ _3138425zaO",
    right: "_37wbyuz9WS _2MCiIxf5Xk _0s0NnyLRg7",
    inlineModal: "_313842JgOI _3iDTPbQ4SZ"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_2bqfgd1z4g _3138425zaO _1DCdHi5zaO _0Of8r28HPE"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_0bjKvDzXzM _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _0KLXruoI2d _3iDTPbQ4SZ _2O5Vij7dHp",
    withTasteAndToneStyling: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0KLXrujOvk",
    default: "_4FKVYEADSh _2OUyjtGk8v _1EqgXl8yba",
    flat: "_4FKVYEADSh _1EqgXl8yba",
    inline: "_2sNsIgmnOE",
    inlineModal: "_1EqgXlHakr"
};
const $1848832735763b59$export$d8126cfce410377d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: t1, buttonGroupAlignment: t2 } = t0;
    const withTasteAndToneStyling = t1 === undefined ? false : t1;
    const buttonGroupAlignment = t2 === undefined ? "left" : t2;
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === "right");
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    const t3 = withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles.withTasteAndToneStyling;
    const t4 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles["default"];
    const t5 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles.flat;
    const t6 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles.inline;
    const t7 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles.inlineModal;
    let t8;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
        t8 = (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageContainerStyles.regular,
            t3,
            t4,
            t5,
            t6,
            t7
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    const t9 = isCard && $1848832735763b59$var$contentContainerStyles.isCard;
    let t10;
    if ($[6] !== t9) {
        t10 = (0, $hekY6.default)([
            $1848832735763b59$var$contentContainerStyles.regular,
            t9
        ]);
        $[6] = t9;
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== title || $[9] !== updatedAppearanceType || $[10] !== withTitle) {
        t11 = withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)("ten_active_boards_in_standard") ? "regularNew" : "regular"],
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles.inlineModal
            ])
        }, title);
        $[8] = title;
        $[9] = updatedAppearanceType;
        $[10] = withTitle;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== body || $[13] !== withTitle) {
        t12 = typeof body === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($QPvOh))).sanitize(body)
            },
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }, body);
        $[12] = body;
        $[13] = withTitle;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== headerButton || $[16] !== isCard || $[17] !== updatedAppearanceType) {
        t13 = headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageHeaderButtonStyles.regular,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles["default"],
                isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCard,
                isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCardDefault
            ])
        }, headerButton);
        $[15] = headerButton;
        $[16] = isCard;
        $[17] = updatedAppearanceType;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== actions || $[20] !== buttonGroupAlignment || $[21] !== updatedAppearanceType) {
        t14 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageActionRowStyles["default"],
                buttonGroupAlignment === "right" && $1848832735763b59$var$sectionMessageActionRowStyles.right,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles.inlineModal,
                "actionButtons"
            ])
        }, actions);
        $[19] = actions;
        $[20] = buttonGroupAlignment;
        $[21] = updatedAppearanceType;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== footer) {
        t15 = footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageFooterStyles["default"]
            ])
        }, footer);
        $[23] = footer;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t10
        }, t11, t12, t13, t14, t15);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== t16 || $[33] !== t8) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "edition-section-message",
            className: t8
        }, t16);
        $[32] = t16;
        $[33] = t8;
        $[34] = t17;
    } else t17 = $[34];
    return t17;
} : ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageTitleStyles[// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
            (0, $9wGTI.fg)('ten_active_boards_in_standard') ? 'regularNew' : 'regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($QPvOh))).sanitize(body)
        },
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};
module.exports["EditionSectionMessage"] = $1848832735763b59$export$d8126cfce410377d;

});

parcelRegister("dIDyF", function(module, exports) {

var $jO9zg = parcelRequire("jO9zg");

const $c2412d4c16af1f46$export$c43c7444da662fa1 = '1';
const $c2412d4c16af1f46$export$e99efa3985fa3c26 = 'in-product-help';
const $c2412d4c16af1f46$export$23aa6670f346c214 = 368;
const $c2412d4c16af1f46$export$dd8cabd06ab03363 = {
    summary: 'summary',
    wasThisHelpful: 'customfield_10081',
    description: 'description',
    reason: 'customfield_10082',
    title: 'customfield_10083',
    contentId: 'customfield_10084',
    contentLink: 'customfield_10088',
    feedbackContext: 'customfield_10047',
    routeGroup: 'customfield_10085',
    routeName: 'customfield_10086',
    customerName: 'customfield_10045',
    email: 'email',
    contactMe: 'customfield_10043'
};
const $c2412d4c16af1f46$export$597555bbf10f10b8 = {
    yes: {
        id: '10182',
        label: 'yes'
    },
    no: {
        id: '10183',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$cd692d959c11a1e9 = {
    noAccurate: {
        id: '10184',
        label: (0, $jO9zg.notAccurateLabel)
    },
    noClear: {
        id: '10185',
        label: (0, $jO9zg.notClearLabel)
    },
    noRelevant: {
        id: '10186',
        label: (0, $jO9zg.notRelevantLabel)
    }
};
const $c2412d4c16af1f46$export$ee3be114bf2680b4 = {
    yes: {
        id: '10109',
        label: 'yes'
    },
    no: {
        id: '10111',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$31f0ec6fc5b07a82 = 'afae180b-eb61-43c5-bc3f-5f65349a8853';
const $c2412d4c16af1f46$export$d006cfb73688051e = '279';
module.exports["HELP_PANEL_ID"] = $c2412d4c16af1f46$export$e99efa3985fa3c26;
module.exports["HELP_PANEL_WIDTH"] = $c2412d4c16af1f46$export$23aa6670f346c214;
module.exports["FEEDBACK_FIELDS_ID"] = $c2412d4c16af1f46$export$dd8cabd06ab03363;
module.exports["WAS_THIS_HELPFUL_OPTIONS"] = $c2412d4c16af1f46$export$597555bbf10f10b8;
module.exports["FEEDBACK_REASON_OPTIONS"] = $c2412d4c16af1f46$export$cd692d959c11a1e9;
module.exports["CAN_BE_CONTACTED_OPTIONS"] = $c2412d4c16af1f46$export$ee3be114bf2680b4;
module.exports["EMBEDDABLE_KEY"] = $c2412d4c16af1f46$export$31f0ec6fc5b07a82;
module.exports["REQUEST_TYPE_ID"] = $c2412d4c16af1f46$export$d006cfb73688051e;

});

parcelRegister("jO9zg", function(module, exports) {
const $136af91396913aa8$export$653b1475ad2952b = "It wasn\u2019t accurate";
const $136af91396913aa8$export$910eb5168d5e4926 = "It wasn\u2019t clear";
const $136af91396913aa8$export$7e4b37ff0a487bc2 = "It wasn\u2019t relevant";
module.exports["notAccurateLabel"] = $136af91396913aa8$export$653b1475ad2952b;
module.exports["notClearLabel"] = $136af91396913aa8$export$910eb5168d5e4926;
module.exports["notRelevantLabel"] = $136af91396913aa8$export$7e4b37ff0a487bc2;

});

parcelRegister("9uAPw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $l3KBO = parcelRequire("l3KBO");

var $398ES = parcelRequire("398ES");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$var$RECORDER_STATUS_POLL_INTERVAL_MS = 250;
const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $cozmU.useState)(false);
    const runningSDKButton = (0, $cozmU.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $cozmU.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') {
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
            switch((0, $6mKj3.expVal)('cc-loom-recorder-init-as-background-loadable', 'cohort', 'control')){
                case 'background':
                    (0, $l3KBO.getTaskManager)().push({
                        id: 'LoomRecorderSDKBackgroundInit',
                        priority: (0, $398ES.LoadingPriority).BACKGROUND,
                        task: async ()=>void initLoomSDK({
                                cloudId: cloudId,
                                environment: environment,
                                entryPointLocation: entryPointLocation
                            })
                    });
                    break;
                case 'lazy':
                    (0, $l3KBO.getTaskManager)().push({
                        id: 'LoomRecorderSDKLazyInit',
                        priority: (0, $398ES.LoadingPriority).LAZY,
                        task: async ()=>void initLoomSDK({
                                cloudId: cloudId,
                                environment: environment,
                                entryPointLocation: entryPointLocation
                            })
                    });
                    break;
                default:
                    initLoomSDK({
                        cloudId: cloudId,
                        environment: environment,
                        entryPointLocation: entryPointLocation
                    });
            }
        }
    }, [
        initLoomSDK,
        cloudId,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $cozmU.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        let recorderStatusPollId = null;
        const stopRecorderStatusFallback = ()=>{
            if (recorderStatusPollId !== null) {
                clearInterval(recorderStatusPollId);
                recorderStatusPollId = null;
            }
        };
        let hasNotifiedRecorderHidden = false;
        let recorderHiddenNotificationSucceeded = true;
        const notifyRecorderHidden = ()=>{
            stopRecorderStatusFallback();
            if (hasNotifiedRecorderHidden) return recorderHiddenNotificationSucceeded;
            hasNotifiedRecorderHidden = true;
            try {
                loomRecorderParams?.onRecorderHidden?.();
                return true;
            } catch (error) {
                recorderHiddenNotificationSucceeded = false;
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: error instanceof Error ? error : new Error(String(error))
                });
                return false;
            }
        };
        const startRecorderStatusFallback = ()=>{
            if (!loomRecorderParams?.notifyHiddenOnTerminalEvents || recorderStatusPollId !== null) return;
            recorderStatusPollId = setInterval(()=>{
                if (singletonLoomSDKRef.current.initializedLoomSDK?.status().state === 'closed') notifyRecorderHidden();
            }, $a5710166add0079d$var$RECORDER_STATUS_POLL_INTERVAL_MS);
        };
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video_0)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video_0.sharedUrl, video_0);
            if (loomRecorderParams.notifyHiddenOnTerminalEvents) notifyRecorderHidden();
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            if (loomRecorderParams?.notifyHiddenOnTerminalEvents) notifyRecorderHidden();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                hasNotifiedRecorderHidden = false;
                recorderHiddenNotificationSucceeded = true;
                startRecorderStatusFallback();
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
                // `lifecycle-update` re-enters 'pre-recording' on the SDK's
                // "Record again", so this fires on every re-record — consumers
                // tracking recorder visibility (e.g. to keep a host modal
                // hidden across re-records) need each transition. Callers that
                // want a once-per-session signal (e.g. analytics) dedupe their
                // side. Failures surface via the entry-point experience since
                // this callback is part of its contract.
                try {
                    loomRecorderParams?.onRecorderVisible?.();
                } catch (error_0) {
                    experienceTracker.fail({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        error: error_0 instanceof Error ? error_0 : new Error(String(error_0))
                    });
                }
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                if (loomRecorderParams?.notifyHiddenOnTerminalEvents) {
                    if (notifyRecorderHidden()) experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            insertFunctionDefined: loomRecorderParams !== undefined
                        }
                    });
                    return;
                }
                // Preserve the original lifecycle callback behavior for
                // consumers that have not opted into terminal-event handling.
                try {
                    loomRecorderParams?.onRecorderHidden?.();
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            insertFunctionDefined: loomRecorderParams !== undefined
                        }
                    });
                } catch (error_1) {
                    experienceTracker.fail({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        error: error_1 instanceof Error ? error_1 : new Error(String(error_1))
                    });
                }
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("iPOCX"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("iPOCX", function(module, exports) {

let $db6442fa103badb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db6442fa103badb0$var$load("hhss7"),
    $db6442fa103badb0$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("jHGaM", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $6mKj3 = parcelRequire("6mKj3");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) {
            // singleton: only want 1 Loom SDK instance
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).mark('loomSdkInitStart');
        try {
            const { isSupported: isSupported } = await (parcelRequire("a3hff"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("jwnL7"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop({
                customData: {
                    cohort: (0, $6mKj3.expVal)('cc-loom-recorder-init-as-background-loadable', 'cohort', 'control')
                }
            });
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $kBr4q.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
const $82feff28757ef801$export$96c98e0dce11493e = (0, $kBr4q.createActionsHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["store"] = $82feff28757ef801$export$6f57813fe9f31bf9;
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;
module.exports["useLoomEntryPointGlobalStateActions"] = $82feff28757ef801$export$96c98e0dce11493e;

});

parcelRegister("3d6VZ", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        const tokenQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only',
            __callerPackage__: "loom-utils"
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        const authStateQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $55UbZ.LoomAuthStateQuery),
            __callerPackage__: "loom-utils"
        });
        return authStateQuery.data.loomUserStatus ?? undefined;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $ja27m = parcelRequire("ja27m");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $ja27m.default);
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("ja27m", function(module, exports) {
/**
 * @generated SignedSource<<a767a13b18c3ec998970c2ba30768a2a>>
 * @relayHash c1b04759e5b09153deee6b2b9fb9afcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374
const $4984e0489bd92eb4$var$node = function() {
    var v0 = [
        {
            "concreteType": "LoomToken",
            "kind": "LinkedField",
            "name": "loomToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c1b04759e5b09153deee6b2b9fb9afcf",
            "id": "9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374",
            "metadata": {},
            "name": "LoomAuthTokenQuery",
            "operationKind": "query",
            "text": "query LoomAuthTokenQuery{loomToken{token}}"
        }
    };
}();
$4984e0489bd92eb4$var$node.hash = "cc249b7610e84f631da05d42ccd02363";
var $4984e0489bd92eb4$export$2e2bcd8739ae039 = $4984e0489bd92eb4$var$node;
module.exports["default"] = $4984e0489bd92eb4$export$2e2bcd8739ae039;

});

parcelRegister("55UbZ", function(module, exports) {

var $bj1zQ = parcelRequire("bj1zQ");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $bj1zQ.default);
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("bj1zQ", function(module, exports) {
/**
 * @generated SignedSource<<5d9434e7e3e0611c30d0a597a2a1e57f>>
 * @relayHash 92b5f865f5d3e169ae4c9331a8c93231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63
const $c5c9d2025b35af51$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "loomUserStatus"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "92b5f865f5d3e169ae4c9331a8c93231",
            "id": "b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63",
            "metadata": {},
            "name": "LoomAuthStateQuery",
            "operationKind": "query",
            "text": "query LoomAuthStateQuery{loomUserStatus}"
        }
    };
}();
$c5c9d2025b35af51$var$node.hash = "b0b71e4c1a4d03a9f0016476ce67cefb";
var $c5c9d2025b35af51$export$2e2bcd8739ae039 = $c5c9d2025b35af51$var$node;
module.exports["default"] = $c5c9d2025b35af51$export$2e2bcd8739ae039;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("a3hff", function(module, exports) {

let $75178fac72397c36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $75178fac72397c36$var$load("fiKv8"),
    $75178fac72397c36$var$load("lmJ8u")
]).then(()=>parcelRequire('dSNYE'));

});

parcelRegister("jwnL7", function(module, exports) {

let $e3636f85bd2c7cab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e3636f85bd2c7cab$var$load("eUsnQ"),
    $e3636f85bd2c7cab$var$load("2hPbk"),
    $e3636f85bd2c7cab$var$load("icYyL"),
    $e3636f85bd2c7cab$var$load("1audf"),
    $e3636f85bd2c7cab$var$load("bpBPu"),
    $e3636f85bd2c7cab$var$load("6wr18"),
    $e3636f85bd2c7cab$var$load("fYEgh"),
    $e3636f85bd2c7cab$var$load("83jZ2"),
    $e3636f85bd2c7cab$var$load("jfuL6"),
    $e3636f85bd2c7cab$var$load("fiKv8"),
    $e3636f85bd2c7cab$var$load("lFmKr"),
    $e3636f85bd2c7cab$var$load("eGGci"),
    $e3636f85bd2c7cab$var$load("81e2B"),
    $e3636f85bd2c7cab$var$load("aOIZj"),
    $e3636f85bd2c7cab$var$load("k0Z8C"),
    $e3636f85bd2c7cab$var$load("jV9Gs"),
    $e3636f85bd2c7cab$var$load("8GFi1"),
    $e3636f85bd2c7cab$var$load("hhss7"),
    $e3636f85bd2c7cab$var$load("Wowvf"),
    $e3636f85bd2c7cab$var$load("ffEVr"),
    $e3636f85bd2c7cab$var$load("abBST"),
    $e3636f85bd2c7cab$var$load("7EorR"),
    $e3636f85bd2c7cab$var$load("3pa1J")
]).then(()=>parcelRequire('7ogMf'));

});

parcelRegister("fk0Hw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $6cyWf = parcelRequire("6cyWf");


var $2SfBJ = parcelRequire("2SfBJ");

const $651274d8ee84c28a$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2SfBJ.ThemedButton) : (0, $ad7Ou.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2SfBJ.ThemedButton) : (0, $ad7Ou.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["Button"] = $651274d8ee84c28a$export$353f5b6fc5456de1;

});

parcelRegister("2SfBJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $aXMFs = parcelRequire("aXMFs");


var $5dijw = parcelRequire("5dijw");

const $8c55572969b08c36$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
const $8c55572969b08c36$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedButton(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let IconBefore;
    let children;
    let props;
    if ($[0] !== t0) {
        ({ iconBefore: IconBefore, children: children, ...props } = t0);
        $[0] = t0;
        $[1] = IconBefore;
        $[2] = children;
        $[3] = props;
    } else {
        IconBefore = $[1];
        children = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== IconBefore) {
        t1 = IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $8c55572969b08c36$var$textButtonStyles.iconBefore
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
            icon: IconBefore
        }));
        $[4] = IconBefore;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.text
        ]);
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t2
        }, children);
        $[7] = children;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
            ...props,
            ref: ref
        }, t1, t3);
        $[9] = props;
        $[10] = ref;
        $[11] = t1;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
        ...props,
        ref: ref
    }, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
        icon: IconBefore
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.text
        ])
    }, children));
});
module.exports["ThemedButton"] = $8c55572969b08c36$export$f67fb575035cc7d0;

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $jyA9t = parcelRequire("jyA9t");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE = 'confluence-rovo-agent-menu-create-agent';
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    // Keep the config object identity stable when its semantic inputs are stable.
    const assistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    return (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: assistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        assistanceServiceConfig,
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        userId
    ]);
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, sourceEntryPoint: sourceEntryPoint, currentConversationId: currentConversationId, traceId: traceId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            sourceEntryPoint: sourceEntryPoint,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            traceId: traceId,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        if (!(0, $6mKj3.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false)) return;
        openModal({
            entryPoint: $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE,
            initialOutcomeType: 'agent',
            lockInitialOutcomeType: true
        });
    }, [
        openModal
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    return (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                onCreateAgentClick: handleCreateAgent,
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        handleCreateAgent,
        navigateToObject,
        shouldShowGreeting
    ]);
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("ficwO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    Message[Message["PageTreeRefreshRequested"] = 3] = "PageTreeRefreshRequested";
    Message[Message["ContentRemoved"] = 4] = "ContentRemoved";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$5ecf0545a6d326d0 = (type, data)=>{
    $6c05dda517103510$var$messageBus.publish(type, data);
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["publishMessage"] = $6c05dda517103510$export$5ecf0545a6d326d0;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("ki0qk"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("ki0qk", function(module, exports) {

let $ec55d139e213cdf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec55d139e213cdf9$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("6AG3B", function(module, exports) {
const $ad71aceb64f29d5c$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$6c053e1694ef181c = {
    prod: $ad71aceb64f29d5c$export$31048cb2a0753b12,
    staging: $ad71aceb64f29d5c$export$9d8f18312db80469
};
const $ad71aceb64f29d5c$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $ad71aceb64f29d5c$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $ad71aceb64f29d5c$export$54e3fc09a2a3347a;

});

parcelRegister("b5YqG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6AG3B = parcelRequire("6AG3B");


var $hnuQ8 = parcelRequire("hnuQ8");

function $a68332960b9f5309$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $cozmU.useRef)();
    const firedViewedUIEventId = (0, $cozmU.useRef)();
    const mapToCcpProductKeys = (0, $cozmU.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $cozmU.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $a68332960b9f5309$export$c2095165ae2bdcda;

});

parcelRegister("hnuQ8", function(module, exports) {
const $a675bd78c3704abb$export$c536a7e29a0739b8 = 'crossFlow';
var $a675bd78c3704abb$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $a675bd78c3704abb$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $a675bd78c3704abb$export$285f3d0989f9023f;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html,
            panelLocation: (0, $eSLr0.ATL_GENERAL)
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html,
                panelLocation: location
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $gH1Fi = parcelRequire("gH1Fi");


var $ep3mz = parcelRequire("ep3mz");


var $eSLr0 = parcelRequire("eSLr0");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { html: html, panelId: panelId, panelLocation: panelLocation } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    const dimensionsRef = (0, $gH1Fi.useExtensionDimensions)(panelLocation === (0, $eSLr0.ATL_GENERAL) ? (0, $eSLr0.ATL_GENERAL) : undefined, panelId, contentId || spaceKey || "");
    let t2;
    if ($[0] !== dimensionsRef) {
        t2 = (element)=>{
            containerRef.current = element;
            dimensionsRef(element);
        };
        $[0] = dimensionsRef;
        $[1] = t2;
    } else t2 = $[1];
    const panelRef = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
        };
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== html || $[4] !== panelId) {
        t4 = [
            html,
            panelId
        ];
        $[3] = html;
        $[4] = panelId;
        $[5] = t4;
    } else t4 = $[5];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[6] !== html) {
        t5 = {
            __html: html
        };
        $[6] = html;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== panelRef || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: t5
        });
        $[8] = panelRef;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("gH1Fi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");


var $7W9kD = parcelRequire("7W9kD");

const $46bdebab359d4884$export$8adc0cb9461bf99f = (source, extensionId, contextKey)=>{
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const cleanup = (0, $cozmU.useRef)(undefined);
    // The observation belongs to this page context, even when React reuses its DOM node.
    const observationContext = (0, $cozmU.useMemo)(()=>({
            source: source,
            extensionId: extensionId,
            contextKey: contextKey
        }), [
        source,
        extensionId,
        contextKey
    ]);
    return (0, $cozmU.useCallback)((element)=>{
        const { source: source, extensionId: extensionId } = observationContext;
        cleanup.current?.();
        cleanup.current = undefined;
        if (!renderServerPlaceholder && element && source && extensionId) cleanup.current = (0, $7W9kD.observeExtensionDimensions)(element, source, extensionId);
    }, [
        observationContext,
        renderServerPlaceholder
    ]);
};
module.exports["useExtensionDimensions"] = $46bdebab359d4884$export$8adc0cb9461bf99f;

});

parcelRegister("6JEx2", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

const $37713e14e82d0a4d$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $37713e14e82d0a4d$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $37713e14e82d0a4d$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $37713e14e82d0a4d$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $37713e14e82d0a4d$var$getWindow = ()=>{
    if (typeof window === 'undefined') return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof window.sessionStorage === 'undefined') return null;
    return window;
};
const $37713e14e82d0a4d$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return null;
    return (0, $iDrrr.fg)('search_page_use_bsc_session_storage') ? (0, $7dBf8.AtlBrowserStorageSession).getItem(key) : $37713e14e82d0a4d$var$getWindow()?.sessionStorage.getItem(key);
};
const $37713e14e82d0a4d$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $iDrrr.fg)('search_page_use_bsc_session_storage')) (0, $7dBf8.AtlBrowserStorageSession).setItem(key, value);
        else $37713e14e82d0a4d$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $37713e14e82d0a4d$export$5896963da935fdc4 = (key)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return;
    if ((0, $iDrrr.fg)('search_page_use_bsc_session_storage')) (0, $7dBf8.AtlBrowserStorageSession).removeItem(key);
    else $37713e14e82d0a4d$var$getWindow()?.sessionStorage.removeItem(key);
};
module.exports["SEARCH_QUERY_KEY"] = $37713e14e82d0a4d$export$240cb7dc75f6cac2;
module.exports["SEARCH_FILTERS_KEY"] = $37713e14e82d0a4d$export$978fb20afa14aaa7;
module.exports["SEARCH_SHOW_AI_DIALOG_KEY"] = $37713e14e82d0a4d$export$f4dca218ecb5824a;
module.exports["getSessionItem"] = $37713e14e82d0a4d$export$fdf7104ff19cc288;
module.exports["setSessionItem"] = $37713e14e82d0a4d$export$a5376dd4adeb0fbf;
module.exports["deleteSessionItem"] = $37713e14e82d0a4d$export$5896963da935fdc4;

});

parcelRegister("7zn5c", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $2wiZs = parcelRequire("2wiZs");

const $bd707cc6f6ee43a7$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError, fireExperimentExposure: fireExperimentExposure = true })=>{
    try {
        const cohort = (0, $cXtTj.default).getExperiment(abTestId, {
            fireExperimentExposure: fireExperimentExposure
        }).get('cohort', (0, $2wiZs.Cohort).Default);
        const serveExperiment = cohort === (0, $2wiZs.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $2wiZs.Cohort).Default
    };
};
const $bd707cc6f6ee43a7$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    if (!overrides) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $bd707cc6f6ee43a7$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$var$defaultCheckGate;
    }
};
const $bd707cc6f6ee43a7$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    if (!overrides) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError, fireExperimentExposure: fireExperimentExposure })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError,
                fireExperimentExposure: fireExperimentExposure
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $2wiZs.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $bd707cc6f6ee43a7$var$defaultCheckGate = (name)=>(0, $cXtTj.default).checkGate(name);
const $bd707cc6f6ee43a7$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $cXtTj.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $bd707cc6f6ee43a7$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $bd707cc6f6ee43a7$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $bd707cc6f6ee43a7$export$b8cc3cdd046fba93;

});

parcelRegister("2wiZs", function(module, exports) {
var $695dfb69bc28d28c$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $695dfb69bc28d28c$export$b76685d1b5a37732;

});

parcelRegister("6JxPX", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $c6e5a8cbbcd4e4d4$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$c6e5a8cbbcd4e4d4$var$AkGrid(multiplier * num),
        half: ()=>$c6e5a8cbbcd4e4d4$var$AkGrid(0.5 * num),
        twice: ()=>$c6e5a8cbbcd4e4d4$var$AkGrid(2 * num)
    });
const $c6e5a8cbbcd4e4d4$export$85fc379452d91af0 = $c6e5a8cbbcd4e4d4$var$AkGrid(1);
const $c6e5a8cbbcd4e4d4$export$b9930dabfa4a3a3 = '56px';
const $c6e5a8cbbcd4e4d4$export$f6af7620e8789c39 = '200px';
const $c6e5a8cbbcd4e4d4$export$64d8573e83b64ff8 = '150px';
const $c6e5a8cbbcd4e4d4$export$a3da89b899389ed8 = '780px';
const $c6e5a8cbbcd4e4d4$export$ce4512df260a325a = 780;
const $c6e5a8cbbcd4e4d4$export$a406031ed42c8e02 = '1130px';
const $c6e5a8cbbcd4e4d4$export$e00021bea368c518 = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0.multiple(4);
const $c6e5a8cbbcd4e4d4$export$30310ee354b45eb0 = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $c6e5a8cbbcd4e4d4$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $c6e5a8cbbcd4e4d4$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $c6e5a8cbbcd4e4d4$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $c6e5a8cbbcd4e4d4$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $c6e5a8cbbcd4e4d4$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $c6e5a8cbbcd4e4d4$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $c6e5a8cbbcd4e4d4$export$30310ee354b45eb0;

});

parcelRegister("1a6Dn", function(module, exports) {

var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    // Keep watching query for home route to avoid VC90 regression
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("cfM7x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $090373eba5349880$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $cozmU.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $090373eba5349880$export$774887fcc3922763 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $090373eba5349880$export$8dcbb40932065737 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $090373eba5349880$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $090373eba5349880$export$8dcbb40932065737;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("bflGB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EemN = parcelRequire("9EemN");

parcelRequire("1syzX");


var $l65Bo = parcelRequire("l65Bo");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback = function(...[e, element, combo]) {
        // Prompt inputs such as Ask Rovo also use ProseMirror. Allow editor commands,
        // but let Mousetrap suppress shortcuts for characters being typed into them.
        const isTypingInEditor = 'isContentEditable' in element && element.isContentEditable === true && e.key?.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
        let allowedElements = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS);
        if (element.classList.contains((0, $1k6sE.PROSEMIRROR_FOCUSED_CLASS)) && isTypingInEditor && (0, $6mKj3.expVal)('cc_ai_growth_remix_prevent_shortcuts', 'isEnabled', false)) allowedElements = allowedElements.filter((className)=>className !== (0, $1k6sE.PROSEMIRROR_FOCUSED_CLASS));
        const isAllowed = allowedElements.some((className)=>element.classList.contains(className));
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("1syzX", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e = 'ProseMirror-focused';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e,
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["PROSEMIRROR_FOCUSED_CLASS"] = $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("aHr8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ca2f7f1db0386fa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7c1cJ = parcelRequire("7c1cJ");


var $4eov6 = parcelRequire("4eov6");


var $3yGK6 = parcelRequire("3yGK6");

var $7ca2f7f1db0386fa$var$MILLISECONDS_IN_WEEK = 604800000;
function $7ca2f7f1db0386fa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var diff = (0, $7c1cJ.default)(date).getTime() - (0, $4eov6.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $7ca2f7f1db0386fa$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("7c1cJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $53ca968e5cafd3ce$export$2e2bcd8739ae039);

var $8qMNj = parcelRequire("8qMNj");


var $3yGK6 = parcelRequire("3yGK6");

function $53ca968e5cafd3ce$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $8qMNj.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("4eov6", function(module, exports) {
$parcel$export(module.exports, "default", () => $314b7991eb76028c$export$2e2bcd8739ae039);

var $7LSTy = parcelRequire("7LSTy");


var $7c1cJ = parcelRequire("7c1cJ");


var $3yGK6 = parcelRequire("3yGK6");

function $314b7991eb76028c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var year = (0, $7LSTy.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $7c1cJ.default)(fourthOfJanuary);
    return date;
}

});

parcelRegister("7LSTy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a87812fe954b524$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7c1cJ = parcelRequire("7c1cJ");


var $3yGK6 = parcelRequire("3yGK6");

function $5a87812fe954b524$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7c1cJ.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7c1cJ.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("iP9x4", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $2j0AL = parcelRequire("2j0AL");


var $8fBh8 = parcelRequire("8fBh8");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = config.contentProduct === 'jira-work-item' ? (0, $4h1jl.jiraMediaConfigRecorder)?.get() : (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getInitialSsrMediaItems = (mediaItems)=>{
    if (!Array.isArray(mediaItems) || mediaItems.length === 0) return undefined;
    return mediaItems;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        },
        ssrMediaItems: $2c59df77bd212c3d$var$getInitialSsrMediaItems((0, $8fBh8.getMediaNodes)())
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: config.contentProduct === 'jira-work-item' ? window.__JIRA_MEDIA_CONFIG__ : window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        },
        ssrMediaItems: $2c59df77bd212c3d$var$getInitialSsrMediaItems(window.__MEDIA_NODE_META_DATA__)
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $dOBRD.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($2j0AL))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("8fBh8", function(module, exports) {
/**
 * A simple module-level singleton used to hand media node metadata from the
 * SSR data-preload phase to the render phase.
 *
 * During SSR, Confluence preloads media node metadata and
 * records it here via {@link setMediaNodes}. It is later read via
 * {@link getMediaNodes} both by the product's render pipeline and by platform
 * consumers such as `@atlaskit/media-file-preview`.
 *
 * This lives in `@atlaskit/media-common` (rather than a product package) so that
 * both product code and platform packages can share the exact same singleton
 * instance without platform depending on a product package.
 */ let $b78ae25b6276049e$var$mediaNodes = null;
const $b78ae25b6276049e$export$cfabe671d3a31c35 = (nodes)=>{
    $b78ae25b6276049e$var$mediaNodes = nodes;
};
const $b78ae25b6276049e$export$684919eb15443d6b = ()=>$b78ae25b6276049e$var$mediaNodes;
const $b78ae25b6276049e$export$d55d7b4fc145db9 = ()=>{
    $b78ae25b6276049e$var$mediaNodes = null;
};
module.exports["getMediaNodes"] = $b78ae25b6276049e$export$684919eb15443d6b;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$269fe681eda28e68 = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["jiraMediaConfigRecorder"] = $c75b7ce9b9db2aec$export$269fe681eda28e68;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    reset() {
        this.object = null;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("7EIq6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dd33Q = parcelRequire("dd33Q");


var $9Pmcg = parcelRequire("9Pmcg");


var $6SsN4 = parcelRequire("6SsN4");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$spaceEnabledContentTypesFragment = (0, $9Pmcg.default);
function $649b778bbd82b1bb$export$67a7293b6dfe9c76(spaceFragmentRef) {
    const $ = (0, $bDgLe.c)(2);
    const space = (0, $6SsN4.useFragment)($649b778bbd82b1bb$var$spaceEnabledContentTypesFragment, spaceFragmentRef);
    const t0 = space.spaceTypeSettings?.enabledContentTypes;
    let t1;
    if ($[0] !== t0) {
        t1 = $649b778bbd82b1bb$var$getEnabledContentTypes(t0, false);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    return $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, isDefaultSpaceKeyLoading || isAnyContentTypesLoading);
}
function $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, loading) {
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = loading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypesFragment"] = $649b778bbd82b1bb$export$67a7293b6dfe9c76;
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("9Pmcg", function(module, exports) {
/**
 * @generated SignedSource<<6a622c3ccbbe286fe0564af388855ebd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1a2866ab6e1d474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypes_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "EnabledContentTypes",
                    "kind": "LinkedField",
                    "name": "enabledContentTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isBlogsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDatabasesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEmbedsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isLivePagesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSlidesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWhiteboardsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFoldersEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$e1a2866ab6e1d474$var$node.hash = "b4c0be9fdc8089ef19cf4d9ec776f16e";
var $e1a2866ab6e1d474$export$2e2bcd8739ae039 = $e1a2866ab6e1d474$var$node;
module.exports["default"] = $e1a2866ab6e1d474$export$2e2bcd8739ae039;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("jEeDd", function(module, exports) {

var $6LNuT = parcelRequire("6LNuT");


var $jH9cM = parcelRequire("jH9cM");


var $i3S9F = parcelRequire("i3S9F");


var $9wGTI = parcelRequire("9wGTI");


var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    if (!identity && (0, $jH9cM.isFedRamp)()) {
        const isStagingFed = false;
        identity = isStagingFed ? 'id.stg.atlassian-us-gov-mod.com' : 'id.atlassian-us-gov-mod.com';
    }
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    if (!(0, $i3S9F.isIsolatedCloud)() || !(0, $9wGTI.fg)('confluence_ic_custom_domain_links')) return identity;
    // IC domains are derived from runtime perimeter context; the environment
    // argument only affects non-IC resolution.
    return (0, $6LNuT.getDomainInContext)('id', 'prod') ?? identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t3;
        if ($[4] !== color) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("1cYlh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
const $e02e634ce8a36ce5$export$de715bd2818cd084 = (0, $kSwu1.defineMessages)({
    name: {
        id: "data-classification.no-classification.content-name",
        defaultMessage: "No classification"
    },
    definition: {
        id: "data-classification.no-classification.content-definition",
        defaultMessage: "Content is not classified."
    }
});
const $e02e634ce8a36ce5$var$getDefaultMessage = (descriptor)=>typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';
const $e02e634ce8a36ce5$export$59df3feebe765454 = (formatMessage)=>({
        id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
        name: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.name),
        order: 0,
        definition: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.definition),
        color: 'GREY',
        status: (0, $kknEZ.Status).PUBLISHED
    });
const $e02e634ce8a36ce5$export$2589b5a314728bad = $e02e634ce8a36ce5$export$59df3feebe765454($e02e634ce8a36ce5$var$getDefaultMessage);
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;
module.exports["getNoClassificationForContent"] = $e02e634ce8a36ce5$export$59df3feebe765454;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $gXfti.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("kxhju", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iEfsZ = parcelRequire("iEfsZ");


var $cozmU = parcelRequire("cozmU");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $8wW9d = parcelRequire("8wW9d");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $cozmU.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            // Instrument the presence of non-content 3P connect apps so their keys
            // are folded into the page-load `connectAppKeys` telemetry.
            (0, $8wW9d.recordNonContentAppKeys)('web-item', formattedWebItems.map((webItem)=>webItem.completeKey));
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _2gHOcPzXzM _1DH08Qjg0e _20DmKqEqul _14Wx5PeKmV _2qRYQF98eZ _0oQUy6YbGa _0tUIKU6wH8 _0WfKEq2Njc _1UNQhUvbI6 _2UvIvUOLYo _1KE8vRbllS _3cgr8TQame _3uAMeFLRg7 _2LESMOvbI6 _0k3IULDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("gqypm", function(module, exports) {

var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ skip: skip, fetchPolicy: fetchPolicy })=>{
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip,
        fetchPolicy: fetchPolicy
    });
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("bFMG7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $XKAGD = parcelRequire("XKAGD");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7Sm4c = parcelRequire("7Sm4c");


var $1P7Cq = parcelRequire("1P7Cq");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");


var $kJOuS = parcelRequire("kJOuS");

const $8f8b1f599c43d665$export$13c9dac546825a9c = (0, $XKAGD.default);
// Control query: uses classificationLevel (old field)
const $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus } = t0;
    let t1;
    let t2;
    if ($[0] !== flagStatus || $[1] !== setClassification || $[2] !== setFlagStatus || $[3] !== submittedClassification) {
        t1 = ()=>{
            if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
                setClassification(submittedClassification ?? null);
                setFlagStatus((0, $in5LX.FlagStatus).NONE);
            }
        };
        t2 = [
            flagStatus,
            submittedClassification,
            setClassification,
            setFlagStatus
        ];
        $[0] = flagStatus;
        $[1] = setClassification;
        $[2] = setFlagStatus;
        $[3] = submittedClassification;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $cozmU.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
/**
 *
 * @param contentId
 * @param spaceKeyOverride
 * @param contentStatusContext
 * @param shouldSkipQueries
 * @returns
 * 1) Content's classification level by contentId & by spaceId,
 * 2) Mutation functions for updating & deleting the content's classification,
 * 3) Flag status for rendering error flag upon updating classification.
 */ const $8f8b1f599c43d665$var$useContentClassificationMetadata = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { contentId: contentId, contentStatusContext: t1, shouldReadFromQueries: t2, useClassificationLevelV2: useClassificationLevelV2, classificationLevelDetails: classificationLevelDetails, contentLevelLoading: t3, contentLevelError: contentLevelError } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldReadFromQueries = t2 === undefined ? false : t2;
    const contentLevelLoading = t3 === undefined ? false : t3;
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    let t4;
    if ($[0] !== contentStatusContext) {
        t4 = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
        $[0] = contentStatusContext;
        $[1] = t4;
    } else t4 = $[1];
    const { readContext: contentStatusReadContext } = t4;
    let t5;
    if ($[2] !== flagStatus || $[3] !== submittedClassification) {
        t5 = {
            flagStatus: flagStatus,
            submittedClassification: submittedClassification,
            setClassification: setClassification,
            setFlagStatus: setFlagStatus
        };
        $[2] = flagStatus;
        $[3] = submittedClassification;
        $[4] = t5;
    } else t5 = $[4];
    $8f8b1f599c43d665$export$160e6dbb5cf9582(t5);
    let t6;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        };
        t7 = (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    let t8;
    if ($[7] !== contentId || $[8] !== contentStatusReadContext || $[9] !== useClassificationLevelV2) {
        t8 = {
            awaitRefetchQueries: true,
            onError: t6,
            onCompleted: t7,
            refetchQueries: ()=>[
                    {
                        query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                        variables: {
                            contentId: contentId,
                            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                        }
                    }
                ]
        };
        $[7] = contentId;
        $[8] = contentStatusReadContext;
        $[9] = useClassificationLevelV2;
        $[10] = t8;
    } else t8 = $[10];
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        ...t8,
        __callerPackage__: "data-classification"
    });
    let t10;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        };
        t10 = (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    let t11;
    if ($[13] !== contentId || $[14] !== contentStatusReadContext || $[15] !== useClassificationLevelV2) {
        t11 = {
            awaitRefetchQueries: true,
            onError: t9,
            onCompleted: t10,
            refetchQueries: ()=>[
                    {
                        query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                        variables: {
                            contentId: contentId,
                            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                        }
                    }
                ]
        };
        $[13] = contentId;
        $[14] = contentStatusReadContext;
        $[15] = useClassificationLevelV2;
        $[16] = t11;
    } else t11 = $[16];
    const [deleteContentDataClassificationLevel, t12] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        ...t11,
        __callerPackage__: "data-classification"
    });
    const { loading: deleteLoading } = t12;
    const rawClassificationLevel = useClassificationLevelV2 ? classificationLevelDetails?.classificationLevelV2 : classificationLevelDetails?.classificationLevel;
    const contentClassification = rawClassificationLevel?.id === "" ? null : rawClassificationLevel ?? null;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === "CONTENT";
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    let t13;
    let t14;
    if ($[17] !== classification || $[18] !== contentId || $[19] !== updatedClassification) {
        t13 = ()=>{
            if (updatedClassification !== classification) {
                setClassification(updatedClassification ?? null);
                setCurrentContentId(contentId);
            }
        };
        t14 = [
            updatedClassification,
            classification,
            contentId
        ];
        $[17] = classification;
        $[18] = contentId;
        $[19] = updatedClassification;
        $[20] = t13;
        $[21] = t14;
    } else {
        t13 = $[20];
        t14 = $[21];
    }
    (0, $cozmU.useEffect)(t13, t14);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    let t15;
    if ($[22] !== classificationLevelDetails?.isReclassificationPermitted) {
        t15 = (classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[22] = classificationLevelDetails?.isReclassificationPermitted;
        $[23] = t15;
    } else t15 = $[23];
    const isReclassificationPermitted = t15;
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    const t16 = classificationValue ?? null;
    const t17 = classificationLevelDetails?.source;
    const t18 = classificationLevelDetails?.canManageSpaceSettings;
    const t19 = classificationLevelDetails?.classificationControlSetting;
    const t20 = classificationLevelDetails?.userOverrideSetting;
    let t21;
    if ($[24] !== classificationFeatureEnabled || $[25] !== contentLevelError || $[26] !== contentLevelLoading || $[27] !== contentStatusContext || $[28] !== deleteContentDataClassificationLevel || $[29] !== errorState || $[30] !== flagStatus || $[31] !== hasNoClassification || $[32] !== isReclassificationPermitted || $[33] !== shouldDisplayClassification || $[34] !== spaceDefaultIsOverridden || $[35] !== t16 || $[36] !== t17 || $[37] !== t18 || $[38] !== t19 || $[39] !== t20 || $[40] !== updateContentDataClassificationLevel) {
        t21 = {
            classification: t16,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: t17,
            canManageSpaceSettings: t18,
            classificationControlSetting: t19,
            userOverrideSetting: t20
        };
        $[24] = classificationFeatureEnabled;
        $[25] = contentLevelError;
        $[26] = contentLevelLoading;
        $[27] = contentStatusContext;
        $[28] = deleteContentDataClassificationLevel;
        $[29] = errorState;
        $[30] = flagStatus;
        $[31] = hasNoClassification;
        $[32] = isReclassificationPermitted;
        $[33] = shouldDisplayClassification;
        $[34] = spaceDefaultIsOverridden;
        $[35] = t16;
        $[36] = t17;
        $[37] = t18;
        $[38] = t19;
        $[39] = t20;
        $[40] = updateContentDataClassificationLevel;
        $[41] = t21;
    } else t21 = $[41];
    return t21;
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldReadFromQueries: shouldReadFromQueries = false, useClassificationLevelV2: useClassificationLevelV2, classificationLevelDetails: classificationLevelDetails, contentLevelLoading: contentLevelLoading = false, contentLevelError: contentLevelError })=>{
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two GQL write operations are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    // Branch on the gate to narrow into the correct union member without an unsafe cast.
    // classificationLevelV2 Branch 4 returns an empty shell object (id: "") when the service
    // finds no level for a given ID — treat this as "no classification" (same as null).
    const rawClassificationLevel = useClassificationLevelV2 ? classificationLevelDetails?.classificationLevelV2 : classificationLevelDetails?.classificationLevel;
    const contentClassification = rawClassificationLevel?.id === '' ? null : rawClassificationLevel ?? null;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete GQL call is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from the GQL response or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $cozmU.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $cozmU.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: classificationLevelDetails?.source,
            canManageSpaceSettings: classificationLevelDetails?.canManageSpaceSettings,
            classificationControlSetting: classificationLevelDetails?.classificationControlSetting,
            userOverrideSetting: classificationLevelDetails?.userOverrideSetting
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted,
        classificationLevelDetails
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { contentId: contentId, contentStatusContext: t1, shouldSkipQueries: t2, shouldPreloadData: t3, shouldReadFromQueries: t4 } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldSkipQueries = t2 === undefined ? false : t2;
    const shouldPreloadData = t3 === undefined ? false : t3;
    const shouldReadFromQueries = t4 === undefined ? false : t4;
    let useClassificationLevelV2 = false;
    if ((0, $6mKj3.expValEquals)("confluence_classification_level_v2", "isEnabled", true)) useClassificationLevelV2 = true;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    let shouldSkipQueriesForClassification;
    let t5;
    let t6;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== shouldSkipQueries) {
        const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
        shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
        t5 = contentId ?? "";
        t6 = (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext);
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = shouldSkipQueries;
        $[3] = shouldSkipQueriesForClassification;
        $[4] = t5;
        $[5] = t6;
    } else {
        shouldSkipQueriesForClassification = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== t5 || $[7] !== t6) {
        t7 = {
            contentId: t5,
            lowerCaseContentStatusArray: t6
        };
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    const queryVariables = t7;
    const t8 = shouldPreloadContentClassificationData ? "cache-first" : "network-only";
    let t9;
    if ($[9] !== shouldSkipQueriesForClassification || $[10] !== t8) {
        t9 = {
            skip: shouldSkipQueriesForClassification,
            errorPolicy: "all",
            fetchPolicy: t8
        };
        $[9] = shouldSkipQueriesForClassification;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    const queryOptions = t9;
    const t10 = shouldSkipQueriesForClassification || useClassificationLevelV2;
    let t11;
    if ($[12] !== queryOptions || $[13] !== queryVariables || $[14] !== t10) {
        t11 = {
            variables: queryVariables,
            ...queryOptions,
            skip: t10
        };
        $[12] = queryOptions;
        $[13] = queryVariables;
        $[14] = t10;
        $[15] = t11;
    } else t11 = $[15];
    const { data: objectLevelDataV1, loading: objectLevelLoadingV1, error: objectLevelErrorV1 } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        ...t11,
        __callerPackage__: "data-classification"
    });
    const t12 = shouldSkipQueriesForClassification || !useClassificationLevelV2;
    let t13;
    if ($[16] !== queryOptions || $[17] !== queryVariables || $[18] !== t12) {
        t13 = {
            variables: queryVariables,
            ...queryOptions,
            skip: t12
        };
        $[16] = queryOptions;
        $[17] = queryVariables;
        $[18] = t12;
        $[19] = t13;
    } else t13 = $[19];
    const { data: objectLevelDataV2, loading: objectLevelLoadingV2, error: objectLevelErrorV2 } = (0, $jMyy4.useQueryInterop)((0, $kJOuS.default), {
        ...t13,
        __callerPackage__: "data-classification"
    });
    const objectLevelData = useClassificationLevelV2 ? objectLevelDataV2 : objectLevelDataV1;
    const objectLevelLoading = useClassificationLevelV2 ? objectLevelLoadingV2 : objectLevelLoadingV1;
    const objectLevelError = useClassificationLevelV2 ? objectLevelErrorV2 : objectLevelErrorV1;
    const t14 = objectLevelData?.singleContent?.classificationLevelDetails;
    let t15;
    if ($[20] !== contentId || $[21] !== contentStatusContext || $[22] !== objectLevelError || $[23] !== objectLevelLoading || $[24] !== shouldReadFromQueries || $[25] !== t14) {
        t15 = {
            contentId: contentId,
            contentStatusContext: contentStatusContext,
            shouldReadFromQueries: shouldReadFromQueries,
            useClassificationLevelV2: useClassificationLevelV2,
            classificationLevelDetails: t14,
            contentLevelLoading: objectLevelLoading,
            contentLevelError: objectLevelError
        };
        $[20] = contentId;
        $[21] = contentStatusContext;
        $[22] = objectLevelError;
        $[23] = objectLevelLoading;
        $[24] = shouldReadFromQueries;
        $[25] = t14;
        $[26] = t15;
    } else t15 = $[26];
    return $8f8b1f599c43d665$var$useContentClassificationMetadata(t15);
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    let useClassificationLevelV2 = false;
    if ((0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true)) useClassificationLevelV2 = true;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const queryVariables = {
        contentId: contentId ?? '',
        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
    };
    const queryOptions = {
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only'
    };
    const { data: objectLevelDataV1, loading: objectLevelLoadingV1, error: objectLevelErrorV1 } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        variables: queryVariables,
        ...queryOptions,
        skip: shouldSkipQueriesForClassification || useClassificationLevelV2,
        __callerPackage__: "data-classification"
    });
    const { data: objectLevelDataV2, loading: objectLevelLoadingV2, error: objectLevelErrorV2 } = (0, $jMyy4.useQueryInterop)((0, $kJOuS.default), {
        variables: queryVariables,
        ...queryOptions,
        skip: shouldSkipQueriesForClassification || !useClassificationLevelV2,
        __callerPackage__: "data-classification"
    });
    const objectLevelData = useClassificationLevelV2 ? objectLevelDataV2 : objectLevelDataV1;
    const objectLevelLoading = useClassificationLevelV2 ? objectLevelLoadingV2 : objectLevelLoadingV1;
    const objectLevelError = useClassificationLevelV2 ? objectLevelErrorV2 : objectLevelErrorV1;
    return $8f8b1f599c43d665$var$useContentClassificationMetadata({
        contentId: contentId,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: shouldReadFromQueries,
        useClassificationLevelV2: useClassificationLevelV2,
        classificationLevelDetails: objectLevelData?.singleContent?.classificationLevelDetails,
        contentLevelLoading: objectLevelLoading,
        contentLevelError: objectLevelError
    });
};
const $8f8b1f599c43d665$export$587e979724cc80f9 = ({ contentId: contentId, contentFragmentRef: contentFragmentRef, contentStatusContext: contentStatusContext = 'current-only', shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const content = (0, $6SsN4.useFragment)($8f8b1f599c43d665$export$13c9dac546825a9c, contentFragmentRef);
    return $8f8b1f599c43d665$var$useContentClassificationMetadata({
        contentId: contentId,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: shouldReadFromQueries,
        useClassificationLevelV2: (0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true),
        classificationLevelDetails: content?.classificationLevelDetails
    });
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;
module.exports["useContentClassificationFromFragment"] = $8f8b1f599c43d665$export$587e979724cc80f9;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<20621d8c8d7d7f709ac76a84782dff9d>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<45eb54206aa80f8b681379fd99d07765>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("XKAGD", function(module, exports) {
/**
 * @generated SignedSource<<697a253c7c1f7174dbc9377eeba53eb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $162d832ed06b75d0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "guideline"
        },
        {
            "kind": "ScalarField",
            "name": "guidelineADF"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "color"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useClassificationLevelV2"
            }
        ],
        "kind": "Fragment",
        "name": "useContentClassification_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ClassificationLevelDetails",
                "kind": "LinkedField",
                "name": "classificationLevelDetails",
                "plural": false,
                "selections": [
                    {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "ContentDataClassificationLevel",
                                "kind": "LinkedField",
                                "name": "classificationLevel",
                                "plural": false,
                                "selections": v1 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "ContentDataClassificationLevel",
                                "kind": "LinkedField",
                                "name": "classificationLevelV2",
                                "plural": false,
                                "selections": v1 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "featureEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "source"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isReclassificationPermitted"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "canManageSpaceSettings"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "classificationControlSetting"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "userOverrideSetting"
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$162d832ed06b75d0$var$node.hash = "8caefc9ae5cd8ffee2bc5ea1aa65be77";
var $162d832ed06b75d0$export$2e2bcd8739ae039 = $162d832ed06b75d0$var$node;
module.exports["default"] = $162d832ed06b75d0$export$2e2bcd8739ae039;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("lwZTW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (currentClassification, spaceLevelError, contentLevelError)=>{
    const $ = (0, $bDgLe.c)(5);
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    let t0;
    let t1;
    if ($[0] !== contentLevelError || $[1] !== currentClassification || $[2] !== spaceLevelError) {
        t0 = ()=>{
            if (!currentClassification) {
                if (spaceLevelError || contentLevelError) {
                    if ((0, $aMcHK.isStatusCodeError)(contentLevelError, "404") || (0, $aMcHK.isStatusCodeError)(spaceLevelError, "404")) {
                        (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                        (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                        setErrorState((0, $79yie.ErrorState).NULL);
                    } else setErrorState((0, $79yie.ErrorState).MESSAGE);
                }
            } else {
                if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                setErrorState((0, $79yie.ErrorState).NO_ERROR);
            }
        };
        t1 = [
            currentClassification,
            spaceLevelError,
            contentLevelError
        ];
        $[0] = contentLevelError;
        $[1] = currentClassification;
        $[2] = spaceLevelError;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return errorState;
} : (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $cozmU.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("earLp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== cloudId || $[1] !== createAnalyticsEvent || $[2] !== orgId || $[3] !== spaceId) {
        t0 = {
            trackEditPopupViewed: (actionSubjectId)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                    cloudId: cloudId,
                    spaceId: spaceId,
                    orgId: orgId,
                    actionSubjectId: actionSubjectId
                })).fire();
            },
            trackRenderTagError: (errorMessage)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "failed",
                        actionSubject: "dataClassificationTagRender",
                        source: "confluence-frontend",
                        attributes: {
                            cloudId: cloudId,
                            spaceId: spaceId,
                            orgId: orgId,
                            error: errorMessage
                        }
                    }
                }).fire();
            }
        };
        $[0] = cloudId;
        $[1] = createAnalyticsEvent;
        $[2] = orgId;
        $[3] = spaceId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("40pD8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isClassificationModalOpen) {
        t1 = {
            isClassificationModalOpen: isClassificationModalOpen
        };
        $[0] = isClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchContextValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
            value: dispatchContextValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contextValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
            value: contextValue
        }, t3);
        $[5] = contextValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $cozmU.useState)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $cozmU.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$var$ClassificationModalContext);
} : ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
} : ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("4ri4I", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $kBr4q.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $kBr4q.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("gw4Bt", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("3Oija"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("3Oija", function(module, exports) {

let $2c643e358e42e420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c643e358e42e420$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});

parcelRegister("grWYF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8lt1a = parcelRequire("8lt1a");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $bDgLe.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const hasRun = (0, $cozmU.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("7d41Y", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");


var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("hzOq6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9ib3C = parcelRequire("9ib3C");


var $iDrrr = parcelRequire("iDrrr");


var $bZTfQ = parcelRequire("bZTfQ");

const $fe745d51ff14e905$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $fe745d51ff14e905$export$9923361bd43fa030 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(12);
    const { label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = t0;
    const pickedAppSwitcherIcon = (0, $iDrrr.fg)("platform_dst_ads_appswitcher_improvements") ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C))) : (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C)));
    let t1;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== interactionName || $[4] !== isSelected || $[5] !== label || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== pickedAppSwitcherIcon || $[9] !== ref || $[10] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
            ref: ref,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            icon: pickedAppSwitcherIcon,
            label: label,
            appearance: "subtle",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            interactionName: interactionName,
            isTooltipDisabled: false,
            tooltip: $fe745d51ff14e905$var$toggleButtonTooltipOptions,
            isSelected: isSelected,
            testId: testId
        });
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = interactionName;
        $[4] = isSelected;
        $[5] = label;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = pickedAppSwitcherIcon;
        $[9] = ref;
        $[10] = testId;
        $[11] = t1;
    } else t1 = $[11];
    return t1;
} : ({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const pickedAppSwitcherIcon = (0, $iDrrr.fg)('platform_dst_ads_appswitcher_improvements') ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C))) : (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: pickedAppSwitcherIcon,
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $fe745d51ff14e905$var$toggleButtonTooltipOptions,
        isSelected: isSelected,
        testId: testId
    });
});
module.exports["AppSwitcher"] = $fe745d51ff14e905$export$9923361bd43fa030;

});

parcelRegister("ehvof", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $7vK9E = parcelRequire("7vK9E");


var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $oHJVG = parcelRequire("oHJVG");

const $0587785bc5340d25$var$anchorStyles = {
    root: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl",
    customLogoBorderRadius: "_0bjKvD8fU6",
    newMargin: "_0GTcwR1Y8M",
    newInteractionStates: "_1eOmH6o126 _3gzVzLJovG",
    newInteractionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $0587785bc5340d25$var$sharedIconOrLogoContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL41Y8M _0LETLXoWWg _1PTmduOLYo _3G0Ib8gIor",
    withFullHeightSidebar: "_1EqgXlN91d _4ouGXIoWWg"
};
const $0587785bc5340d25$var$iconContainerStyles = {
    root: "_3iDTPbQ4SZ _1EqgXloWWg _24h04iPvdi _2rc81eYbGa"
};
const $0587785bc5340d25$var$logoContainerStyles = {
    root: "_3iDTPbYbGa _1EqgXlsz7G _24h04iPvdi _2rc81eQ4SZ"
}; /**
    * __Custom logo__
    *
    * Custom logo for the top navigation.
    *
    * To provide a responsive experience, it requires both a logo and an icon component.
    * The logo component will be used for large viewports, and the icon component will be used for small viewports.
    */ 
const $0587785bc5340d25$export$4156d88e9ccc616b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { href: href, logo: logo, icon: icon, onClick: onClick, label: label } = t0;
    const ref = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            return;
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const t3 = hasCustomTheme ? $0587785bc5340d25$var$anchorStyles.newInteractionStatesCustomTheming : $0587785bc5340d25$var$anchorStyles.newInteractionStates;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $k12R1.cx)($0587785bc5340d25$var$anchorStyles.root, $0587785bc5340d25$var$anchorStyles.customLogoBorderRadius, $0587785bc5340d25$var$anchorStyles.newMargin, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar;
    let t6;
    if ($[4] !== t5) {
        t6 = (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$iconContainerStyles.root,
            t5
        ]);
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== icon) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
            logoOrIcon: icon
        });
        $[6] = icon;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    const t9 = isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar;
    let t10;
    if ($[11] !== t9) {
        t10 = (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$logoContainerStyles.root,
            t9
        ]);
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== logo) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
            logoOrIcon: logo
        });
        $[13] = logo;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10 || $[16] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t10
        }, t11);
        $[15] = t10;
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== href || $[19] !== label || $[20] !== onClick || $[21] !== t12 || $[22] !== t4 || $[23] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ref: ref,
            "aria-label": label,
            href: href,
            xcss: t4,
            onClick: onClick
        }, t8, t12);
        $[18] = href;
        $[19] = label;
        $[20] = onClick;
        $[21] = t12;
        $[22] = t4;
        $[23] = t8;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($0587785bc5340d25$var$anchorStyles.root, $0587785bc5340d25$var$anchorStyles.customLogoBorderRadius, $0587785bc5340d25$var$anchorStyles.newMargin, hasCustomTheme ? $0587785bc5340d25$var$anchorStyles.newInteractionStatesCustomTheming : $0587785bc5340d25$var$anchorStyles.newInteractionStates),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$iconContainerStyles.root,
            isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$logoContainerStyles.root,
            isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
        logoOrIcon: logo
    })));
};
module.exports["CustomLogo"] = $0587785bc5340d25$export$4156d88e9ccc616b;

});

parcelRegister("oHJVG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cyWf = parcelRequire("6cyWf");

const $b21160af47e239eb$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $b21160af47e239eb$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $b21160af47e239eb$export$35e88bd9b061a3a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LogoRenderer(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { logoOrIcon: LogoOrIcon } = t0;
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    if (hasCustomTheme) {
        let t1;
        if ($[0] !== LogoOrIcon) {
            t1 = /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
                label: "",
                size: "small",
                iconColor: `var(${$b21160af47e239eb$export$24328117f1132113})`,
                textColor: `var(${$b21160af47e239eb$export$91b0830f8f4ab279})`
            });
            $[0] = LogoOrIcon;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== LogoOrIcon) {
        t1 = /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
            size: "small",
            label: "",
            appearance: "brand"
        });
        $[2] = LogoOrIcon;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function LogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
        label: "",
        size: "small",
        iconColor: `var(${$b21160af47e239eb$export$24328117f1132113})`,
        textColor: `var(${$b21160af47e239eb$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
};
module.exports["themedLogoIcon"] = $b21160af47e239eb$export$24328117f1132113;
module.exports["themedLogoText"] = $b21160af47e239eb$export$91b0830f8f4ab279;
module.exports["LogoRenderer"] = $b21160af47e239eb$export$35e88bd9b061a3a4;

});

parcelRegister("cES0U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $oHJVG = parcelRequire("oHJVG");

const $d728a4d07578a4cf$var$anchorStyles = {
    root: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl _3YEZNOdnbC _0GTcwR1Y8M _4kLJBn98eZ _0mJftuYbGa _1vb6Qj6wH8 _4vhRtvOLYo",
    interactionStates: "_1eOmH6o126 _3gzVzLJovG",
    interactionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp",
    fullHeightSidebar: "_4bt5LAnQyn _2WAcuGnQyn _3YEZNO7dHp"
};
const $d728a4d07578a4cf$var$logoWrapperStyles = {
    root: "_2Y7lL41Y8M",
    fullHeightSidebar: "_1EqgXlN91d"
};
const $d728a4d07578a4cf$var$iconContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1EqgXloWWg _0NUa3roWWg",
    fullHeightSidebar: "_3YEZNOdnbC"
};
const $d728a4d07578a4cf$var$logoTextStyles = {
    root: "_39xV02W9qI _1EqgXlsz7G _20VacPYbGa _03SyCPFQfX _3iDTPbYbGa _0aFT5vbt8w _37wbyuDIqT _2rc81eQ4SZ"
};
const $d728a4d07578a4cf$var$secondaryNameStyles = {
    root: "_43nrzTLl21"
};
function $d728a4d07578a4cf$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $d728a4d07578a4cf$export$113a612889e1565d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const ref = (0, $cozmU.useRef)(null);
    const nameRef = (0, $cozmU.useRef)(null);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    let t1;
    if ($[0] !== secondaryName) {
        t1 = Boolean(secondaryName) && (0, $iDrrr.fg)("platform_dst_ads_appswitcher_improvements");
        $[0] = secondaryName;
        $[1] = t1;
    } else t1 = $[1];
    const showSecondaryName = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const text = nameRef.current;
            return Boolean(text && $d728a4d07578a4cf$var$isTextClamped(text));
        };
        $[2] = t2;
    } else t2 = $[2];
    const canTooltipAppear = t2;
    const t3 = hasCustomTheme ? $d728a4d07578a4cf$var$anchorStyles.interactionStatesCustomTheming : $d728a4d07578a4cf$var$anchorStyles.interactionStates;
    const t4 = isFhsEnabled && $d728a4d07578a4cf$var$anchorStyles.fullHeightSidebar;
    let t5;
    if ($[3] !== t3 || $[4] !== t4) {
        t5 = (0, $k12R1.cx)($d728a4d07578a4cf$var$anchorStyles.root, t3, t4);
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const t6 = isFhsEnabled && $d728a4d07578a4cf$var$logoWrapperStyles.fullHeightSidebar;
    let t7;
    if ($[6] !== t6) {
        t7 = (0, $k12R1.cx)($d728a4d07578a4cf$var$logoWrapperStyles.root, t6);
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const t8 = isFhsEnabled && $d728a4d07578a4cf$var$iconContainerStyles.fullHeightSidebar;
    let t9;
    if ($[8] !== t8) {
        t9 = (0, $hekY6.default)([
            $d728a4d07578a4cf$var$iconContainerStyles.root,
            t8
        ]);
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== icon) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
            logoOrIcon: icon
        });
        $[10] = icon;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== t10 || $[13] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t9
        }, t10);
        $[12] = t10;
        $[13] = t9;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $hekY6.default)([
            $d728a4d07578a4cf$var$logoTextStyles.root
        ]);
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== name) {
        t13 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                "aria-hidden": true,
                color: "inherit",
                weight: "semibold",
                maxLines: 1,
                ref: nameRef
            }, name));
        $[16] = name;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== name || $[19] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: name,
            position: "bottom",
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, t13);
        $[18] = name;
        $[19] = t13;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== secondaryName || $[22] !== showSecondaryName) {
        t15 = showSecondaryName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $d728a4d07578a4cf$var$secondaryNameStyles.root
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            "aria-hidden": true,
            color: "color.text.subtlest",
            weight: "regular",
            maxLines: 1,
            size: "small"
        }, secondaryName));
        $[21] = secondaryName;
        $[22] = showSecondaryName;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t14 || $[25] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t12
        }, t14, t15);
        $[24] = t14;
        $[25] = t15;
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] !== t11 || $[28] !== t16 || $[29] !== t7) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            xcss: t7
        }, t11, t16);
        $[27] = t11;
        $[28] = t16;
        $[29] = t7;
        $[30] = t17;
    } else t17 = $[30];
    let t18;
    if ($[31] !== href || $[32] !== label || $[33] !== onClick || $[34] !== t17 || $[35] !== t5) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ref: ref,
            "aria-label": label,
            href: href,
            xcss: t5,
            onClick: onClick
        }, t17);
        $[31] = href;
        $[32] = label;
        $[33] = onClick;
        $[34] = t17;
        $[35] = t5;
        $[36] = t18;
    } else t18 = $[36];
    return t18;
} : ({ name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const ref = (0, $cozmU.useRef)(null);
    const nameRef = (0, $cozmU.useRef)(null);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const showSecondaryName = Boolean(secondaryName) && (0, $iDrrr.fg)('platform_dst_ads_appswitcher_improvements'); /**
                                                                                                        * Show the tooltip if the name is truncated
                                                                                                        */ 
    const canTooltipAppear = (0, $cozmU.useCallback)(()=>{
        const text = nameRef.current;
        return Boolean(text && $d728a4d07578a4cf$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($d728a4d07578a4cf$var$anchorStyles.root, hasCustomTheme ? $d728a4d07578a4cf$var$anchorStyles.interactionStatesCustomTheming : $d728a4d07578a4cf$var$anchorStyles.interactionStates, isFhsEnabled && $d728a4d07578a4cf$var$anchorStyles.fullHeightSidebar),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        xcss: (0, $k12R1.cx)($d728a4d07578a4cf$var$logoWrapperStyles.root, isFhsEnabled && $d728a4d07578a4cf$var$logoWrapperStyles.fullHeightSidebar)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $d728a4d07578a4cf$var$iconContainerStyles.root,
            isFhsEnabled && $d728a4d07578a4cf$var$iconContainerStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $d728a4d07578a4cf$var$logoTextStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: name,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered in the nav item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            "aria-hidden": true,
            color: "inherit",
            weight: "semibold",
            maxLines: 1,
            ref: nameRef
        }, name))), showSecondaryName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $d728a4d07578a4cf$var$secondaryNameStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        "aria-hidden": true,
        color: "color.text.subtlest",
        weight: "regular",
        maxLines: 1,
        size: "small"
    }, secondaryName)))));
};
module.exports["AppLogo"] = $d728a4d07578a4cf$export$113a612889e1565d;

});

parcelRegister("lYmLF", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $611f591f5abbf0ae$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $611f591f5abbf0ae$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $cozmU.forwardRef)($611f591f5abbf0ae$var$_ListItem);
module.exports["ListItem"] = $611f591f5abbf0ae$export$a7b06bfba60a8a78;

});

parcelRegister("c8bwf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lYmLF = parcelRequire("lYmLF");


var $bZTfQ = parcelRequire("bZTfQ");

const $18daf328df969fca$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(18);
    const { label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, isListItem: t1, shortcut: shortcut } = t0;
    const isListItem = t1 === undefined ? true : t1;
    const Wrapper = isListItem ? (0, $lYmLF.ListItem) : (0, $cozmU.Fragment);
    let t2;
    if ($[0] !== shortcut) {
        t2 = shortcut ? {
            shortcut: shortcut
        } : undefined;
        $[0] = shortcut;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== ariaControls || $[3] !== ariaExpanded || $[4] !== ariaHasPopup || $[5] !== forwardedRef || $[6] !== icon || $[7] !== interactionName || $[8] !== isSelected || $[9] !== label || $[10] !== onClick || $[11] !== onMouseEnter || $[12] !== t2 || $[13] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            tooltip: t2
        });
        $[2] = ariaControls;
        $[3] = ariaExpanded;
        $[4] = ariaHasPopup;
        $[5] = forwardedRef;
        $[6] = icon;
        $[7] = interactionName;
        $[8] = isSelected;
        $[9] = label;
        $[10] = onClick;
        $[11] = onMouseEnter;
        $[12] = t2;
        $[13] = testId;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== Wrapper || $[16] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, t3);
        $[15] = Wrapper;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $lYmLF.ListItem) : (0, $cozmU.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
        ref: forwardedRef,
        icon: icon,
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        appearance: "subtle",
        isSelected: isSelected,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        // Only creating object when shortcut is provided
        tooltip: shortcut ? {
            shortcut: shortcut
        } : undefined
    }));
});
module.exports["EndItem"] = $18daf328df969fca$export$b3477e90773be2d0;

});

parcelRegister("frwle", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dDJT6 = parcelRequire("dDJT6");


var $aZw4M = parcelRequire("aZw4M");


var $c8bwf = parcelRequire("c8bwf");

const $d9683d840faeac30$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $d9683d840faeac30$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Notifications(t0, ref) {
    const $ = (0, $bDgLe.c)(16);
    const { label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut } = t0;
    let t1;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== interactionName || $[4] !== isSelected || $[5] !== label || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== ref || $[9] !== shortcut || $[10] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
            isListItem: false,
            shortcut: shortcut
        });
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = interactionName;
        $[4] = isSelected;
        $[5] = label;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = ref;
        $[9] = shortcut;
        $[10] = testId;
        $[11] = t1;
    } else t1 = $[11];
    let t2;
    if ($[12] !== badge || $[13] !== isListItem || $[14] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZw4M.BadgeContainer), {
            id: $d9683d840faeac30$var$NOTIFICATIONS_BADGE_ID,
            badge: badge,
            isListItem: isListItem
        }, t1);
        $[12] = badge;
        $[13] = isListItem;
        $[14] = t1;
        $[15] = t2;
    } else t2 = $[15];
    return t2;
} : function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZw4M.BadgeContainer), {
        id: $d9683d840faeac30$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false,
        shortcut: shortcut
    }));
});
module.exports["Notifications"] = $d9683d840faeac30$export$36ba2f559d49a8f6;

});

parcelRegister("aZw4M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d45695ff1eab8d56$var$styles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ",
    badgeContainer: "_1mT5xdWVPG _1ANEUSLRg7 _2I62gz5UaJ _3iC0zd8HPE _1pp6NdYbGa"
};
const $d45695ff1eab8d56$export$f710265eb5a003da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, id: badgeId, badge: Badge, isListItem: t1 } = t0;
    const isListItem = t1 === undefined ? true : t1;
    const t2 = isListItem ? "listitem" : undefined;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.root
        ]);
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.badgeContainer
        ]);
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== Badge) {
        t5 = /*#__PURE__*/ $cozmU.createElement(Badge, null);
        $[2] = Badge;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== badgeId || $[5] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: badgeId,
            "aria-hidden": true,
            className: t4
        }, t5);
        $[4] = badgeId;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== children || $[8] !== t2 || $[9] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: t2,
            className: t3
        }, children, t6);
        $[7] = children;
        $[8] = t2;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
} : ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ $cozmU.createElement("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.root
        ])
    }, children, /*#__PURE__*/ $cozmU.createElement("div", {
        id: badgeId,
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.badgeContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement(Badge, null)));
module.exports["BadgeContainer"] = $d45695ff1eab8d56$export$f710265eb5a003da;

});

parcelRegister("jov8i", function(module, exports) {
/**
 * @jsxRuntime classic
 */ 
var $cozmU = parcelRequire("cozmU");


var $kyJuy = parcelRequire("kyJuy");


var $aZw4M = parcelRequire("aZw4M");


var $c8bwf = parcelRequire("c8bwf");

const $e746a36e3c15cc87$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $e746a36e3c15cc87$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref,
        shortcut: shortcut
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZw4M.BadgeContainer), {
        id: $e746a36e3c15cc87$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});
module.exports["Help"] = $e746a36e3c15cc87$export$1be7516c0280bee8;

});

parcelRegister("2kkx9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $c8bwf = parcelRequire("c8bwf");

const $854a0916fe50a452$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    let props;
    let src;
    if ($[0] !== t0) {
        ({ src: src, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = src;
    } else {
        props = $[1];
        src = $[2];
    }
    let t1;
    if ($[3] !== src) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "circle",
                src: src,
                size: "small"
            });
        $[3] = src;
        $[4] = t1;
    } else t1 = $[4];
    const ProfileAvatar = t1;
    let t2;
    if ($[5] !== ProfileAvatar || $[6] !== props || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            ...props,
            ref: ref,
            icon: ProfileAvatar
        });
        $[5] = ProfileAvatar;
        $[6] = props;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});
module.exports["Profile"] = $854a0916fe50a452$export$5120f2d0b8d4cab8;

});

parcelRegister("fmilS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $11OF7 = parcelRequire("11OF7");


var $c8bwf = parcelRequire("c8bwf");

const $1167db19a1159546$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            ...props,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7)))
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7)))
    }));
module.exports["Settings"] = $1167db19a1159546$export$c72f6eaae7b9adff;

});

parcelRegister("aDfUy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hPGQU = parcelRequire("hPGQU");


var $lYmLF = parcelRequire("lYmLF");


var $ced2k = parcelRequire("ced2k");

const $3719731e1b51205c$export$88195aaac9f90319 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label } = t0;
    let t1;
    if ($[0] !== href || $[1] !== interactionName || $[2] !== label || $[3] !== onClick || $[4] !== onMouseEnter || $[5] !== ref || $[6] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lYmLF.ListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced2k.LinkIconButton), {
            ref: ref,
            label: label,
            href: href,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId,
            interactionName: interactionName,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPGQU))),
            appearance: "subtle",
            isTooltipDisabled: false
        }));
        $[0] = href;
        $[1] = interactionName;
        $[2] = label;
        $[3] = onClick;
        $[4] = onMouseEnter;
        $[5] = ref;
        $[6] = testId;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
 * This component doesn't use `EndItem` internally because it renders a
 * `LinkIconButton` instead of an `IconButton`.
 *
 * We could make another abstraction, but this is the only top navigation item
 * that renders a link.
 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lYmLF.ListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced2k.LinkIconButton), {
        ref: ref,
        label: label,
        href: href,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        testId: testId,
        interactionName: interactionName,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPGQU))),
        appearance: "subtle",
        isTooltipDisabled: false
    })));
module.exports["LogIn"] = $3719731e1b51205c$export$88195aaac9f90319;

});

parcelRegister("ced2k", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7WEaj = parcelRequire("7WEaj");


var $6cyWf = parcelRequire("6cyWf");


var $2gbg3 = parcelRequire("2gbg3");

const $272bab02dc3bee02$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2gbg3.ThemedLinkIconButton) : (0, $7WEaj.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2gbg3.ThemedLinkIconButton) : (0, $7WEaj.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["LinkIconButton"] = $272bab02dc3bee02$export$edad7fca51b767e1;

});

parcelRegister("2gbg3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $iH8yB = parcelRequire("iH8yB");

const $af31664dceaf23c2$var$ThemedLinkIconButtonFn = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedLinkIconButtonFn(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let Icon;
    let label;
    let props;
    let tooltip;
    if ($[0] !== t0) {
        ({ icon: Icon, label: label, tooltip: tooltip, ...props } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = label;
        $[3] = props;
        $[4] = tooltip;
    } else {
        Icon = $[1];
        label = $[2];
        props = $[3];
        tooltip = $[4];
    }
    const t1 = tooltip?.content ?? label;
    let t2;
    if ($[5] !== Icon || $[6] !== label || $[7] !== props || $[8] !== ref) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iH8yB.ThemedAnchor), {
                ...props,
                shape: "square",
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e_0)=>{
                    triggerProps.onMouseOut?.(e_0);
                    props.onMouseOut?.(e_0);
                },
                onMouseMove: (e_1)=>{
                    triggerProps.onMouseMove?.(e_1);
                    props.onMouseMove?.(e_1);
                },
                onMouseDown: (e_2)=>{
                    triggerProps.onMouseDown?.(e_2);
                    props.onMouseDown?.(e_2);
                },
                onFocus: (e_3)=>{
                    triggerProps.onFocus?.(e_3);
                    props.onFocus?.(e_3);
                },
                onBlur: (e_4)=>{
                    triggerProps.onBlur?.(e_4);
                    props.onBlur?.(e_4);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                label: "",
                color: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label));
        $[5] = Icon;
        $[6] = label;
        $[7] = props;
        $[8] = ref;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2 || $[12] !== tooltip) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            ...tooltip,
            content: t1
        }, t2);
        $[10] = t1;
        $[11] = t2;
        $[12] = tooltip;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iH8yB.ThemedAnchor), {
            ...props,
            shape: "square",
            ref: (0, $lmzCg.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                props.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                props.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                props.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                props.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                props.onBlur?.(e_4);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label)));
};
const $af31664dceaf23c2$export$a1ab08e79d264ec8 = (0, $4Qc44.default)($af31664dceaf23c2$var$ThemedLinkIconButtonFn);
module.exports["ThemedLinkIconButton"] = $af31664dceaf23c2$export$a1ab08e79d264ec8;

});

parcelRegister("iH8yB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $4Qc44 = parcelRequire("4Qc44");


var $7vK9E = parcelRequire("7vK9E");


var $hVZgb = parcelRequire("hVZgb");

const $b22d7f94684fcdb0$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCjOvk _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $b22d7f94684fcdb0$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $b22d7f94684fcdb0$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
}; /**
    * Props that are common between link buttons.
    */ 
const $b22d7f94684fcdb0$var$ThemedAnchorFn = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedAnchorFn(t0, ref) {
    const $ = (0, $bDgLe.c)(19);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $7vK9E.Anchor);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    const t2 = $b22d7f94684fcdb0$var$shapeStyles[shape];
    const t3 = hasBorder && $b22d7f94684fcdb0$var$styles.border;
    const t4 = $b22d7f94684fcdb0$var$appearanceStyles[appearance];
    const t5 = isSelected && $b22d7f94684fcdb0$var$styles.selected;
    const t6 = isDisabled && $b22d7f94684fcdb0$var$styles.disabled;
    let t7;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
        t7 = (0, $k12R1.cx)($b22d7f94684fcdb0$var$styles.root, t2, t3, t4, t5, t6);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== T0 || $[15] !== ref || $[16] !== t1 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            xcss: t7
        });
        $[14] = T0;
        $[15] = ref;
        $[16] = t1;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : function ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($b22d7f94684fcdb0$var$styles.root, $b22d7f94684fcdb0$var$shapeStyles[shape], hasBorder && $b22d7f94684fcdb0$var$styles.border, $b22d7f94684fcdb0$var$appearanceStyles[appearance], isSelected && $b22d7f94684fcdb0$var$styles.selected, isDisabled && $b22d7f94684fcdb0$var$styles.disabled)
    });
};
const $b22d7f94684fcdb0$export$1b69d1a78614cc52 = (0, $4Qc44.default)($b22d7f94684fcdb0$var$ThemedAnchorFn);
module.exports["ThemedAnchor"] = $b22d7f94684fcdb0$export$1b69d1a78614cc52;

});

parcelRegister("ldb5c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cyWf = parcelRequire("6cyWf");

const $74d051d9a1974270$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _1ANEUSLRg7 _1EqgXlgZxp _39HuIbz8Lp _0LQT5E1Y8M _03SyCP2ADO _3iDTPbYbGa _2rc81eQ4SZ",
    subtleText: "_1UtDYzZpcK"
};
const $74d051d9a1974270$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomTitle(t0, ref) {
    const $ = (0, $bDgLe.c)(7);
    const { children: children, testId: testId } = t0;
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const t1 = !hasCustomTheme && $74d051d9a1974270$var$styles.subtleText;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $74d051d9a1974270$var$styles.root,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== ref || $[4] !== t2 || $[5] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = children;
        $[3] = ref;
        $[4] = t2;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $74d051d9a1974270$var$styles.root,
            !hasCustomTheme && $74d051d9a1974270$var$styles.subtleText
        ])
    }, children);
});
module.exports["CustomTitle"] = $74d051d9a1974270$export$9ccddf7ee2a0e24e;

});

parcelRegister("lBYCH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $cozmU.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), {
        ...t1,
        __callerPackage__: "create-space"
    });
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace || $[5] !== loading) {
        t3 = {
            canCreateSpace: canCreateSpace,
            loading: loading
        };
        $[4] = canCreateSpace;
        $[5] = loading;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed,
        __callerPackage__: "create-space"
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace,
        loading: loading
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("bK5Dy", function(module, exports) {
const $bedb38fd6d7a6e5d$var$LOOM_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
function $bedb38fd6d7a6e5d$var$extractLoomVideoId(url) {
    const match = url.match($bedb38fd6d7a6e5d$var$LOOM_URL_REGEX);
    return match?.groups?.videoId;
}
async function $bedb38fd6d7a6e5d$var$digestMessage(message) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    if (window?.crypto?.subtle?.digest) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
    return '';
}
async function $bedb38fd6d7a6e5d$export$495fb2ecc80ca6c0(url) {
    try {
        const videoId = $bedb38fd6d7a6e5d$var$extractLoomVideoId(url);
        if (videoId) {
            const data = atob('c2U1UTwgekZlVEYkP1MzRno1QmV5WXBoSE13SHg8RWpjM10saHJQZmhPMVVHKHM=') + videoId;
            const digestHex = await $bedb38fd6d7a6e5d$var$digestMessage(data);
            return digestHex ? `vidhash-${digestHex}` : '';
        }
        return '';
    } catch (_) {
        return '';
    }
}
module.exports["getHashedLoomVideoIdFromUrl"] = $bedb38fd6d7a6e5d$export$495fb2ecc80ca6c0;

});

parcelRegister("iCisl", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");


var $khtFq = parcelRequire("khtFq");

const $0d6a7abd934ab2be$var$i18n = (0, $kSwu1.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $0d6a7abd934ab2be$var$lozengeStyles = {
    lozenge: "_0bjKvDKxmn _2Y7lL41Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    tooltip: "_0bjKvDKxmn _2sNsIg7NXe _24h04i2Njc _1EqgXl3ScF _0KLXrugozt _1UtDYze5R3 _2I62gzPgdg _3iC0zdPgdg _3zvHkHwPeg _0xmtkoFQfX _46hvQmFQfX _03SyCPgVvo _0LQT5EgVvo _1T2N03wPeg"
};
const $0d6a7abd934ab2be$var$gradientWaveKeyframes = null;
const $0d6a7abd934ab2be$var$sampResetStyles = null;
const $0d6a7abd934ab2be$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $0d6a7abd934ab2be$var$CustomTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            $0d6a7abd934ab2be$var$lozengeStyles.tooltip
        ])
    }, children);
});
const $0d6a7abd934ab2be$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        component: $0d6a7abd934ab2be$var$CustomTooltip,
        content: formatMessage($0d6a7abd934ab2be$var$i18n.tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "ai-labs-lozenge",
        className: (0, $hekY6.default)([
            $0d6a7abd934ab2be$var$lozengeStyles.lozenge,
            "_0bjKvDKxmn _2Y7lL41Y8M _1mT5xdRAKS _0KLXru66of _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _42Yu6BdnbC _4jFnWednbC _1OimfuKxmn _2DOjOvHZdu _1F91ciHZdu _0uxO31HZdu _1UtDrQHZdu _4eDJc6ftom _2OUbymteVz _3Ku51Iogpp _3dCYwDWVPG _34UJl7zGaF _2wDIRleai3 _2bDXQqstGY _2COm2lk2L1 _0UsFEzYbGa _3qT6l0vQQr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        grow: "hug",
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $khtFq.LabsIcon), {
        darkMode: colorMode === 'dark'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "semibold",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("samp", {
        className: (0, $hekY6.default)([
            "_2sNsIgOLYo"
        ])
    }, "LABS"))))));
};
module.exports["AILabsLozenge"] = $0d6a7abd934ab2be$export$48aba4499a97f6bf;

});

parcelRegister("khtFq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $64351f65bd133f46$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1466_13761)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1466_13761"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1352_45568)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "#1E1F21"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1352_45568"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    }))));
};
module.exports["LabsIcon"] = $64351f65bd133f46$export$36be37b392de5213;

});

parcelRegister("evORK", function(module, exports) {

var $mr7nI = parcelRequire("mr7nI");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $mr7nI.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("kAcNG", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $8Lx5S = parcelRequire("8Lx5S");


var $kOUwv = parcelRequire("kOUwv");

const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ skip: skip })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const siteTraits = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skipOptions
    });
    if (skipOptions) return {
        loading: false,
        error: undefined,
        attributes: []
    };
    const attributes = siteTraits.data?.attributes || [];
    return {
        loading: siteTraits.loading,
        error: siteTraits.error ?? undefined,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $cozmU = parcelRequire("cozmU");


var $lvOsp = parcelRequire("lvOsp");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default), {
        __callerPackage__: "smart-create"
    });
    return (0, $cozmU.useCallback)(()=>{
        if (!isRovoLLMEnabled && (0, $6mKj3.expVal)('remove_aifc_modal_preloading_non_rovo_tenants_exp', 'isEnabled', false)) return false;
        preloadSmartCreationModalQuery();
        (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        return true;
    }, [
        isRovoLLMEnabled,
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("h6yXF"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("h6yXF", function(module, exports) {

let $c73e1dd118838754$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c73e1dd118838754$var$load("g8ky2"),
    $c73e1dd118838754$var$load("6CRIa"),
    $c73e1dd118838754$var$load("ktZlp"),
    $c73e1dd118838754$var$load("hUbK8"),
    $c73e1dd118838754$var$load("8eGGc"),
    $c73e1dd118838754$var$load("RHpNJ"),
    $c73e1dd118838754$var$load("9Pwou"),
    $c73e1dd118838754$var$load("7m881"),
    $c73e1dd118838754$var$load("4Z4Q1"),
    $c73e1dd118838754$var$load("dWlbi"),
    $c73e1dd118838754$var$load("bjJQE"),
    $c73e1dd118838754$var$load("aVpwX"),
    $c73e1dd118838754$var$load("7zFX6"),
    $c73e1dd118838754$var$load("fRPBy"),
    $c73e1dd118838754$var$load("1KLtr"),
    $c73e1dd118838754$var$load("aJ6Bp"),
    $c73e1dd118838754$var$load("h4jve"),
    $c73e1dd118838754$var$load("belsr"),
    $c73e1dd118838754$var$load("dxUjO"),
    $c73e1dd118838754$var$load("951bc"),
    $c73e1dd118838754$var$load("5ZbCn"),
    $c73e1dd118838754$var$load("k77Km"),
    $c73e1dd118838754$var$load("3zwpG"),
    $c73e1dd118838754$var$load("6dLts"),
    $c73e1dd118838754$var$load("jdPbE"),
    $c73e1dd118838754$var$load("8dKKv"),
    $c73e1dd118838754$var$load("5wjYh"),
    $c73e1dd118838754$var$load("kfGHh"),
    $c73e1dd118838754$var$load("lIiD7"),
    $c73e1dd118838754$var$load("iqLRv"),
    $c73e1dd118838754$var$load("6vufR"),
    $c73e1dd118838754$var$load("zT8YI"),
    $c73e1dd118838754$var$load("bIOK4"),
    $c73e1dd118838754$var$load("5ns6c"),
    $c73e1dd118838754$var$load("6TLS9"),
    $c73e1dd118838754$var$load("dxcsb"),
    $c73e1dd118838754$var$load("3WmaY"),
    $c73e1dd118838754$var$load("2hPbk"),
    $c73e1dd118838754$var$load("icYyL"),
    $c73e1dd118838754$var$load("e9A8Q"),
    $c73e1dd118838754$var$load("8exG0"),
    $c73e1dd118838754$var$load("gnocL"),
    $c73e1dd118838754$var$load("4g6rd"),
    $c73e1dd118838754$var$load("kT6dz"),
    $c73e1dd118838754$var$load("aqMLH"),
    $c73e1dd118838754$var$load("ctdyb"),
    $c73e1dd118838754$var$load("he7Ox"),
    $c73e1dd118838754$var$load("cKDij"),
    $c73e1dd118838754$var$load("9XFtf"),
    $c73e1dd118838754$var$load("jYCVY"),
    $c73e1dd118838754$var$load("abBST"),
    $c73e1dd118838754$var$load("6wr18"),
    $c73e1dd118838754$var$load("7SteV"),
    $c73e1dd118838754$var$load("54ltV"),
    $c73e1dd118838754$var$load("ffEVr"),
    $c73e1dd118838754$var$load("Wowvf"),
    $c73e1dd118838754$var$load("cGkFm"),
    $c73e1dd118838754$var$load("1audf"),
    $c73e1dd118838754$var$load("bpBPu"),
    $c73e1dd118838754$var$load("hhss7"),
    $c73e1dd118838754$var$load("ce05o"),
    $c73e1dd118838754$var$load("7EorR"),
    $c73e1dd118838754$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<aed928c86f10a4e4f6955f6a921227cd>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("fPTGf", function(module, exports) {

var $8EdIy = parcelRequire("8EdIy");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $ficwO = parcelRequire("ficwO");




const $ad18477d67abe91f$export$d0da2224ce3d22b8 = ()=>{
    const writeContentSubType = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $8EdIy.default),
        fragmentSpec: (0, $8EdIy.default),
        __callerPackage__: "smart-folder"
    });
    const publishSyncStateChange = (0, $ficwO.useMessagePublisher)((0, $ficwO.Message).SmartFolderSyncStateChanged);
    return (0, $cozmU.useCallback)(({ folderId: folderId, subType: subType })=>{
        writeContentSubType({
            fragmentId: `Content:${folderId}`,
            data: {
                id: folderId,
                subType: subType,
                __typename: 'Content'
            }
        });
        publishSyncStateChange({
            contentId: folderId,
            subType: subType
        });
    }, [
        writeContentSubType,
        publishSyncStateChange
    ]);
};
module.exports["useApplySmartFolderSubTypeChange"] = $ad18477d67abe91f$export$d0da2224ce3d22b8;

});

parcelRegister("8EdIy", function(module, exports) {
/**
 * @generated SignedSource<<c12a07177dc0008a71c9fab7207e5c95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ae4c44658947c5d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useApplySmartFolderSubTypeChangeContentWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$4ae4c44658947c5d$var$node.hash = "7b1e91c800d1490b419afc4c6e95fb79";
var $4ae4c44658947c5d$export$2e2bcd8739ae039 = $4ae4c44658947c5d$var$node;
module.exports["default"] = $4ae4c44658947c5d$export$2e2bcd8739ae039;

});

parcelRegister("sD2Tz", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9Vkdl = parcelRequire("9Vkdl");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// predictive prefetch only runs in browser environments that expose the API.
// Evaluated lazily (as a function) so that test environments can mock window.matchMedia before it is checked.
const $f75716c2560aeeb6$var$getHasMatchMedia = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function'; // Copied from https://foresightjs.com/docs/react/hook
function $f75716c2560aeeb6$var$useForesight(options, enabled) {
    const $ = (0, $bDgLe.c)(5);
    const elementRef = (0, $cozmU.useRef)(null);
    const registerResults = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== enabled || $[1] !== options) {
        t0 = ()=>{
            if (!elementRef.current || !enabled) return;
            if (!$f75716c2560aeeb6$var$getHasMatchMedia()) return;
            (0, $9Vkdl.ForesightManager).initialize({
                enableMousePrediction: true,
                trajectoryPredictionTime: (0, $6mKj3.expVal)("platform_editor_predictive_collabdraft_prefetch", "trajectoryPredictionTime", 120),
                positionHistorySize: 8
            });
            const currentElement = elementRef.current;
            registerResults.current = (0, $9Vkdl.ForesightManager).instance.register({
                element: currentElement,
                ...options
            });
            return ()=>{
                (0, $9Vkdl.ForesightManager).instance?.unregister(currentElement, "useEffect");
            };
        };
        t1 = [
            options,
            enabled
        ];
        $[0] = enabled;
        $[1] = options;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            elementRef: elementRef,
            registerResults: registerResults
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
}
const $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS = 15000;
const $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents = new Map();
const $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics = (contentId)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (pendingPrefetch) {
        clearTimeout(pendingPrefetch.timeoutId);
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    }
};
const $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics = ({ contentId: contentId, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent })=>{
    // If there's an existing pending prefetch event for this content that hasn't
    // resolved or timed out yet, fire a prefetchUnused event for it before
    // replacing it with the new one.
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
    if (pendingPrefetch) sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs'
    });
    const firedAt = Date.now();
    const timeoutId = setTimeout(()=>{
        const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
        if (!pendingPrefetch || pendingPrefetch.firedAt !== firedAt) return;
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
        sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
            clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
            prefetchSource: 'foresightjs'
        });
    }, $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.set(contentId, {
        firedAt: firedAt,
        timeoutId: timeoutId
    });
};
const $f75716c2560aeeb6$export$545c7ef2fbcc68a6 = (contentId, sendPrefetchAnalyticsEvent)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (!pendingPrefetch) return;
    const timeToClickMs = Date.now() - pendingPrefetch.firedAt;
    clearTimeout(pendingPrefetch.timeoutId);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    sendPrefetchAnalyticsEvent('prefetchAndClick', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs',
        timeToClickMs: timeToClickMs
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _4jFnWevLYW _3Ku51Iogpp _3dCYwDWVPG",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent, predictivelyPrefetch: predictivelyPrefetch })=>{
    const preloader = (0, $cozmU.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $cozmU.useState)(false);
    const doPreloadRef = (0, $cozmU.useRef)(doPreload);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    (0, $cozmU.useEffect)(()=>{
        // Keep the ref in sync with the latest doPreload value so that the function returned by
        // cleanup editorPreloadManager always uses the current doPreload value instead of the one before.
        doPreloadRef.current = doPreload;
    }, [
        doPreload
    ]); // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
            if (doPreloadRef.current) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        contentId
    ]); // Register edit-button element with ForesightJS for mouse trajectory prediction
    // Only call useForesight when predictive prefetch is enabled
    const foresightOptions = (0, $cozmU.useMemo)(()=>({
            callback: async ()=>{
                if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId) && predictivelyPrefetch) {
                    setDoPreload(true);
                    setEditSource(editSource);
                    $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics({
                        contentId: contentId,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent
                    });
                }
            },
            name: `edit-button-${contentId}`,
            reactivateAfter: 15000
        }), [
        contentId,
        editSource,
        setEditSource,
        setDoPreload,
        predictivelyPrefetch,
        sendPrefetchAnalyticsEvent
    ]);
    const { elementRef: elementRef } = $f75716c2560aeeb6$var$useForesight(foresightOptions, predictivelyPrefetch); // On hover callback
    const onHover = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        ref: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? elementRef : null,
        onMouseEnter: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? undefined : onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["resolvePendingPrefetchAnalytics"] = $f75716c2560aeeb6$export$545c7ef2fbcc68a6;
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("9Vkdl", function(module, exports) {

var $akD6a = parcelRequire("akD6a");

function $73991e0e121001da$var$k() {
    let n = $73991e0e121001da$var$E(), e = $73991e0e121001da$var$L();
    return {
        isTouchDevice: n,
        isLimitedConnection: e,
        shouldRegister: !e
    };
}
function $73991e0e121001da$var$E() {
    return typeof window > "u" || typeof navigator > "u" ? !1 : window.matchMedia("(pointer: coarse)").matches && navigator.maxTouchPoints > 0;
}
function $73991e0e121001da$var$L() {
    let n = navigator.connection;
    if (!n) return !1;
    let e = $73991e0e121001da$export$1435e6a4c843d234.instance.getManagerData.globalSettings.minimumConnectionType, t = [
        "slow-2g",
        "2g",
        "3g",
        "4g"
    ], i = t.indexOf(n.effectiveType), r = t.indexOf(e);
    return i < r || n.saveData;
}
function $73991e0e121001da$var$F(n) {
    if (typeof window > "u" || typeof document > "u") return !1;
    let e = window.innerWidth || document.documentElement.clientWidth, t = window.innerHeight || document.documentElement.clientHeight;
    return n.top < t && n.bottom > 0 && n.left < e && n.right > 0;
}
function $73991e0e121001da$var$T() {
    return {
        mouse: {
            hover: 0,
            trajectory: 0
        },
        tab: {
            forwards: 0,
            reverse: 0
        },
        scroll: {
            down: 0,
            left: 0,
            right: 0,
            up: 0
        },
        touch: 0,
        viewport: 0,
        total: 0
    };
}
function $73991e0e121001da$var$H() {
    return {
        debug: !1,
        enableManagerLogging: !1,
        enableMousePrediction: !0,
        enableScrollPrediction: !0,
        positionHistorySize: 8,
        trajectoryPredictionTime: 120,
        scrollMargin: 150,
        defaultHitSlop: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        enableTabPrediction: !0,
        tabOffset: 2,
        touchDeviceStrategy: "onTouchStart",
        minimumConnectionType: "3g"
    };
}
function $73991e0e121001da$var$R(n, e, t) {
    let { element: i, callback: r, hitSlop: o, name: s, meta: c, reactivateAfter: b } = n, d = i.getBoundingClientRect(), a = o ? (0, $akD6a.b)(o) : t;
    return {
        id: e,
        element: i,
        callback: r,
        elementBounds: {
            originalRect: d,
            expandedRect: (0, $akD6a.c)(d, a),
            hitSlop: a
        },
        name: s || i.id || "unnamed",
        isIntersectingWithViewport: $73991e0e121001da$var$F(d),
        registerCount: 1,
        meta: c ?? {},
        callbackInfo: {
            callbackFiredCount: 0,
            lastCallbackInvokedAt: void 0,
            lastCallbackCompletedAt: void 0,
            lastCallbackRuntime: void 0,
            lastCallbackStatus: void 0,
            lastCallbackErrorMessage: void 0,
            reactivateAfter: b ?? 1 / 0,
            isCallbackActive: !0,
            isRunningCallback: !1,
            reactivateTimeoutId: void 0
        }
    };
}
var $73991e0e121001da$var$f = class {
    addEventListener(e, t, i) {
        if (i?.signal?.aborted) return;
        let r = this.eventListeners.get(e) ?? [];
        r.push(t), this.eventListeners.set(e, r), i?.signal?.addEventListener("abort", ()=>this.removeEventListener(e, t));
    }
    removeEventListener(e, t) {
        let i = this.eventListeners.get(e);
        if (!i) return;
        let r = i.indexOf(t);
        r > -1 && i.splice(r, 1);
    }
    emit(e) {
        let t = this.eventListeners.get(e.type);
        if (!(!t || t.length === 0)) for(let i = 0; i < t.length; i++)try {
            let r = t[i];
            r && r(e);
        } catch (r) {
            console.error(`Error in ForesightManager event listener ${i} for ${e.type}:`, r);
        }
    }
    hasListeners(e) {
        let t = this.eventListeners.get(e);
        return t !== void 0 && t.length > 0;
    }
    getEventListeners() {
        return this.eventListeners;
    }
    constructor(){
        this.eventListeners = new Map;
    }
};
function $73991e0e121001da$var$y(n, e) {
    return n !== void 0 && e !== n;
}
var $73991e0e121001da$var$I = {
    trajectoryPredictionTime: {
        min: 10,
        max: 200
    },
    positionHistorySize: {
        min: 2,
        max: 30
    },
    scrollMargin: {
        min: 30,
        max: 300
    },
    tabOffset: {
        min: 0,
        max: 20
    }
};
function $73991e0e121001da$var$h(n, e, t) {
    if (!$73991e0e121001da$var$y(t, n[e])) return !1;
    let { min: i, max: r } = $73991e0e121001da$var$I[e];
    return n[e] = (0, $akD6a.a)(t, i, r, e), !0;
}
function $73991e0e121001da$var$m(n, e, t) {
    return $73991e0e121001da$var$y(t, n[e]) ? (n[e] = t, !0) : !1;
}
function $73991e0e121001da$var$M(n, e) {
    $73991e0e121001da$var$h(n, "trajectoryPredictionTime", e.trajectoryPredictionTime), $73991e0e121001da$var$h(n, "positionHistorySize", e.positionHistorySize), $73991e0e121001da$var$h(n, "scrollMargin", e.scrollMargin), $73991e0e121001da$var$h(n, "tabOffset", e.tabOffset), $73991e0e121001da$var$m(n, "enableMousePrediction", e.enableMousePrediction), $73991e0e121001da$var$m(n, "enableScrollPrediction", e.enableScrollPrediction), $73991e0e121001da$var$m(n, "enableTabPrediction", e.enableTabPrediction), $73991e0e121001da$var$m(n, "enableManagerLogging", e.enableManagerLogging), e.defaultHitSlop !== void 0 && (n.defaultHitSlop = (0, $akD6a.b)(e.defaultHitSlop)), e.touchDeviceStrategy !== void 0 && (n.touchDeviceStrategy = e.touchDeviceStrategy), e.minimumConnectionType !== void 0 && (n.minimumConnectionType = e.minimumConnectionType), e.debug !== void 0 && (n.debug = e.debug);
}
function $73991e0e121001da$var$D(n, e) {
    let t = [], i = !1, r = !1, o = !1, s = !1, c = !1;
    if (!e) return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
    let b = [
        "trajectoryPredictionTime",
        "positionHistorySize",
        "scrollMargin",
        "tabOffset"
    ];
    for (let a of b){
        let l = n[a];
        $73991e0e121001da$var$h(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "positionHistorySize" && (i = !0));
    }
    let d = [
        "enableMousePrediction",
        "enableScrollPrediction",
        "enableTabPrediction"
    ];
    for (let a of d){
        let l = n[a];
        $73991e0e121001da$var$m(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "enableScrollPrediction" && (r = !0), a === "enableTabPrediction" && (o = !0));
    }
    if (e.defaultHitSlop !== void 0) {
        let a = n.defaultHitSlop, l = (0, $akD6a.b)(e.defaultHitSlop);
        (0, $akD6a.d)(a, l) || (n.defaultHitSlop = l, t.push({
            setting: "defaultHitSlop",
            oldValue: a,
            newValue: l
        }), s = !0);
    }
    if (e.touchDeviceStrategy !== void 0) {
        let a = n.touchDeviceStrategy;
        n.touchDeviceStrategy = e.touchDeviceStrategy, t.push({
            setting: "touchDeviceStrategy",
            oldValue: a,
            newValue: e.touchDeviceStrategy
        }), c = !0;
    }
    if (e.minimumConnectionType !== void 0) {
        let a = n.minimumConnectionType;
        n.minimumConnectionType = e.minimumConnectionType, t.push({
            setting: "minimumConnectionType",
            oldValue: a,
            newValue: e.minimumConnectionType
        });
    }
    return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
}


var $73991e0e121001da$export$1435e6a4c843d234 = class n {
    async getOrCreateDesktopHandler() {
        if (!this.desktopHandler) {
            let { DesktopHandler: e } = await (parcelRequire("2GQEm"));
            this.desktopHandler = new e(this.handlerDependencies), this.devLog("DesktopHandler lazy loaded");
        }
        return this.desktopHandler;
    }
    async getOrCreateTouchHandler() {
        if (!this.touchDeviceHandler) {
            let { TouchDeviceHandler: e } = await (parcelRequire("4mSfC"));
            this.touchDeviceHandler = new e(this.handlerDependencies), this.devLog("TouchDeviceHandler lazy loaded");
        }
        return this.touchDeviceHandler;
    }
    static initialize(e) {
        return this.isInitiated || (n.manager = new n(e)), n.manager;
    }
    static get isInitiated() {
        return !!n.manager;
    }
    static get instance() {
        return this.initialize();
    }
    generateId() {
        return `foresight-${++this.idCounter}`;
    }
    get isUsingDesktopHandler() {
        return this.currentDeviceStrategy === "mouse" || this.currentDeviceStrategy === "pen";
    }
    addEventListener(e, t, i) {
        this.eventEmitter.addEventListener(e, t, i);
    }
    removeEventListener(e, t) {
        this.eventEmitter.removeEventListener(e, t);
    }
    hasListeners(e) {
        return this.eventEmitter.hasListeners(e);
    }
    get getManagerData() {
        let e = this.desktopHandler?.loadedPredictors, t = this.touchDeviceHandler?.loadedPredictors;
        return {
            registeredElements: this.elements,
            globalSettings: this._globalSettings,
            globalCallbackHits: this._globalCallbackHits,
            eventListeners: this.eventEmitter.getEventListeners(),
            currentDeviceStrategy: this.currentDeviceStrategy,
            activeElementCount: this.activeElementCount,
            loadedModules: {
                desktopHandler: this.desktopHandler !== null,
                touchHandler: this.touchDeviceHandler !== null,
                predictors: {
                    mouse: e?.mouse ?? !1,
                    tab: e?.tab ?? !1,
                    scroll: e?.scroll ?? !1,
                    viewport: t?.viewport ?? !1,
                    touchStart: t?.touchStart ?? !1
                }
            }
        };
    }
    get registeredElements() {
        return this.elements;
    }
    register(e) {
        let { element: t, ...i } = e;
        return t instanceof NodeList ? Array.from(t, (r)=>this.registerElement({
                ...i,
                element: r
            })) : this.registerElement({
            ...i,
            element: t
        });
    }
    registerElement(e) {
        let { isTouchDevice: t, isLimitedConnection: i, shouldRegister: r } = $73991e0e121001da$var$k();
        if (!r) return {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        let o = this.elements.get(e.element);
        if (o) return o.registerCount++, {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        this.isSetup || this.initializeGlobalListeners();
        let s = $73991e0e121001da$var$R(e, this.generateId(), this._globalSettings.defaultHitSlop);
        return this.elements.set(e.element, s), this.activeElementCount++, this.updateCheckableStatus(s), this.currentlyActiveHandler?.observeElement(e.element), this.eventEmitter.emit({
            type: "elementRegistered",
            timestamp: Date.now(),
            elementData: s
        }), {
            isTouchDevice: t,
            isLimitedConnection: i,
            isRegistered: !0,
            unregister: ()=>{
                this.unregister(e.element);
            },
            elementData: s
        };
    }
    unregister(e, t) {
        e instanceof NodeList ? e.forEach((i)=>this.unregisterElement(i, t)) : this.unregisterElement(e, t);
    }
    unregisterElement(e, t) {
        let i = this.elements.get(e);
        if (!i) return;
        this.clearReactivateTimeout(i), this.currentlyActiveHandler?.unobserveElement(e), this.elements.delete(e), this.checkableElements.delete(i), i.callbackInfo.isCallbackActive && this.activeElementCount--;
        let r = this.elements.size === 0 && this.isSetup;
        r && (this.devLog("All elements unregistered, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "elementUnregistered",
            elementData: i,
            timestamp: Date.now(),
            unregisterReason: t ?? "by user",
            wasLastRegisteredElement: r
        });
    }
    reactivate(e) {
        e instanceof NodeList ? e.forEach((t)=>this.reactivateElement(t)) : this.reactivateElement(e);
    }
    reactivateElement(e) {
        let t = this.elements.get(e);
        t && (this.isSetup || this.initializeGlobalListeners(), this.clearReactivateTimeout(t), t.callbackInfo.isRunningCallback || (t.callbackInfo.isCallbackActive = !0, this.activeElementCount++, this.updateCheckableStatus(t), this.currentlyActiveHandler?.observeElement(e), this.eventEmitter.emit({
            type: "elementReactivated",
            elementData: t,
            timestamp: Date.now()
        })));
    }
    clearReactivateTimeout(e) {
        clearTimeout(e.callbackInfo.reactivateTimeoutId), e.callbackInfo.reactivateTimeoutId = void 0;
    }
    updateCheckableStatus(e) {
        e.isIntersectingWithViewport && e.callbackInfo.isCallbackActive && !e.callbackInfo.isRunningCallback ? this.checkableElements.add(e) : this.checkableElements.delete(e);
    }
    callCallback(e, t) {
        e.callbackInfo.isRunningCallback || !e.callbackInfo.isCallbackActive || (this.markElementAsRunning(e), this.executeCallbackAsync(e, t));
    }
    markElementAsRunning(e) {
        e.callbackInfo.callbackFiredCount++, e.callbackInfo.lastCallbackInvokedAt = Date.now(), e.callbackInfo.isRunningCallback = !0, this.clearReactivateTimeout(e), this.checkableElements.delete(e);
    }
    async executeCallbackAsync(e, t) {
        this.updateHitCounters(t), this.eventEmitter.emit({
            type: "callbackInvoked",
            timestamp: Date.now(),
            elementData: e,
            hitType: t
        });
        let i = performance.now(), r, o = null;
        try {
            await e.callback(e), r = "success";
        } catch (s) {
            o = s instanceof Error ? s.message : String(s), r = "error", console.error(`Error in callback for element ${e.name}:`, s);
        }
        this.finalizeCallback(e, t, i, r, o);
    }
    finalizeCallback(e, t, i, r, o) {
        e.callbackInfo.lastCallbackCompletedAt = Date.now(), e.callbackInfo.isRunningCallback = !1, e.callbackInfo.isCallbackActive = !1, this.activeElementCount--, this.currentlyActiveHandler?.unobserveElement(e.element), e.callbackInfo.reactivateAfter !== 1 / 0 && (e.callbackInfo.reactivateTimeoutId = setTimeout(()=>{
            this.reactivate(e.element);
        }, e.callbackInfo.reactivateAfter));
        let s = this.activeElementCount === 0;
        s && (this.devLog("All elements unactivated, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "callbackCompleted",
            timestamp: Date.now(),
            elementData: e,
            hitType: t,
            elapsed: e.callbackInfo.lastCallbackRuntime = performance.now() - i,
            status: e.callbackInfo.lastCallbackStatus = r,
            errorMessage: e.callbackInfo.lastCallbackErrorMessage = o,
            wasLastActiveElement: s
        });
    }
    updateHitCounters(e) {
        switch(e.kind){
            case "mouse":
                this._globalCallbackHits.mouse[e.subType]++;
                break;
            case "tab":
                this._globalCallbackHits.tab[e.subType]++;
                break;
            case "scroll":
                this._globalCallbackHits.scroll[e.subType]++;
                break;
            case "touch":
                this._globalCallbackHits.touch++;
                break;
            case "viewport":
                this._globalCallbackHits.viewport++;
                break;
            default:
        }
        this._globalCallbackHits.total++;
    }
    async setDeviceStrategy(e) {
        let t = this.currentDeviceStrategy;
        t !== e && this.devLog(`Switching device strategy from ${t} to ${e}`), this.currentlyActiveHandler?.disconnect(), this.currentlyActiveHandler = e === "mouse" || e === "pen" ? await this.getOrCreateDesktopHandler() : await this.getOrCreateTouchHandler(), this.currentlyActiveHandler.connect();
    }
    initializeGlobalListeners() {
        this.isSetup || typeof document > "u" || (this.devLog("Initializing global listeners (pointermove, MutationObserver)"), this.setDeviceStrategy(this.currentDeviceStrategy), document.addEventListener("pointermove", this.handlePointerMove), this.domObserver = new MutationObserver(this.handleDomMutations), this.domObserver.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !1
        }), this.isSetup = !0);
    }
    removeGlobalListeners() {
        typeof document > "u" || (this.isSetup = !1, this.domObserver?.disconnect(), this.domObserver = null, document.removeEventListener("pointermove", this.handlePointerMove), this.currentlyActiveHandler?.disconnect(), this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.pendingPointerEvent = null);
    }
    alterGlobalSettings(e) {
        let t = $73991e0e121001da$var$D(this._globalSettings, e);
        t.positionHistorySizeChanged && this.desktopHandler && this.desktopHandler.trajectoryPositions.positions.resize(this._globalSettings.positionHistorySize), t.scrollPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableScrollPrediction ? this.desktopHandler.connectScrollPredictor() : this.desktopHandler.disconnectScrollPredictor()), t.tabPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableTabPrediction ? this.desktopHandler.connectTabPredictor() : this.desktopHandler.disconnectTabPredictor()), t.hitSlopChanged && this.forceUpdateAllElementBounds(), t.touchStrategyChanged && !this.isUsingDesktopHandler && this.touchDeviceHandler && this.touchDeviceHandler.setTouchPredictor(), t.changedSettings.length > 0 && this.eventEmitter.emit({
            type: "managerSettingsChanged",
            timestamp: Date.now(),
            managerData: this.getManagerData,
            updatedSettings: t.changedSettings
        });
    }
    forceUpdateAllElementBounds() {
        for (let e of this.elements.values())e.isIntersectingWithViewport && this.forceUpdateElementBounds(e);
    }
    forceUpdateElementBounds(e) {
        let t = e.element.getBoundingClientRect(), i = (0, $akD6a.c)(t, e.elementBounds.hitSlop);
        if (!(0, $akD6a.d)(i, e.elementBounds.expandedRect)) {
            let r = {
                ...e,
                elementBounds: {
                    ...e.elementBounds,
                    originalRect: t,
                    expandedRect: i
                }
            };
            this.elements.set(e.element, r), this.eventEmitter.emit({
                type: "elementDataUpdated",
                elementData: r,
                updatedProps: [
                    "bounds"
                ]
            });
        }
    }
    devLog(e) {
        this._globalSettings.enableManagerLogging && console.log(`%c\u{1F6E0}\uFE0F ForesightManager: ${e}`, "color: #16a34a; font-weight: bold;");
    }
    constructor(e){
        this.elements = new Map;
        this.checkableElements = new Set;
        this.idCounter = 0;
        this.activeElementCount = 0;
        this.desktopHandler = null;
        this.touchDeviceHandler = null;
        this.currentlyActiveHandler = null;
        this.isSetup = !1;
        this.pendingPointerEvent = null;
        this.rafId = null;
        this.domObserver = null;
        this.currentDeviceStrategy = $73991e0e121001da$var$E() ? "touch" : "mouse";
        this.eventEmitter = new $73991e0e121001da$var$f;
        this._globalCallbackHits = $73991e0e121001da$var$T();
        this._globalSettings = $73991e0e121001da$var$H();
        this.handlePointerMove = (e)=>{
            this.pendingPointerEvent = e, e.pointerType !== this.currentDeviceStrategy && (this.eventEmitter.emit({
                type: "deviceStrategyChanged",
                timestamp: Date.now(),
                newStrategy: e.pointerType,
                oldStrategy: this.currentDeviceStrategy
            }), this.currentDeviceStrategy = e.pointerType, this.setDeviceStrategy(this.currentDeviceStrategy)), !this.rafId && (this.rafId = requestAnimationFrame(()=>{
                if (!this.isUsingDesktopHandler) {
                    this.rafId = null;
                    return;
                }
                this.pendingPointerEvent && this.desktopHandler?.processMouseMovement(this.pendingPointerEvent), this.rafId = null;
            }));
        };
        this.handleDomMutations = (e)=>{
            if (!e.length) return;
            this.desktopHandler?.invalidateTabCache();
            let t = !1;
            for(let i = 0; i < e.length; i++){
                let r = e[i];
                if (r && r.type === "childList" && r.removedNodes.length > 0) {
                    t = !0;
                    break;
                }
            }
            if (t) for (let i of this.elements.keys())i.isConnected || this.unregister(i, "disconnected");
        };
        e !== void 0 && $73991e0e121001da$var$M(this._globalSettings, e), this.handlerDependencies = {
            elements: this.elements,
            callCallback: this.callCallback.bind(this),
            emit: this.eventEmitter.emit.bind(this.eventEmitter),
            hasListeners: this.eventEmitter.hasListeners.bind(this.eventEmitter),
            settings: this._globalSettings
        }, this.devLog(`ForesightManager initialized with device strategy: ${this.currentDeviceStrategy}`), this.initializeGlobalListeners();
    }
};
module.exports["ForesightManager"] = $73991e0e121001da$export$1435e6a4c843d234;

});

parcelRegister("akD6a", function(module, exports) {
function $785a19cc58757094$export$407448d2b89b1813(t, o, e, r) {
    return t < o ? console.warn(`ForesightJS: "${r}" value ${t} is below minimum bound ${o}, clamping to ${o}`) : t > e && console.warn(`ForesightJS: "${r}" value ${t} is above maximum bound ${e}, clamping to ${e}`), Math.min(Math.max(t, o), e);
}
function $785a19cc58757094$export$8b22cf2602fb60ce(t) {
    if (typeof t == "number") {
        let o = $785a19cc58757094$export$407448d2b89b1813(t, 0, 2e3, "hitslop");
        return {
            top: o,
            left: o,
            right: o,
            bottom: o
        };
    }
    return {
        top: $785a19cc58757094$export$407448d2b89b1813(t.top, 0, 2e3, "hitslop - top"),
        left: $785a19cc58757094$export$407448d2b89b1813(t.left, 0, 2e3, "hitslop - left"),
        right: $785a19cc58757094$export$407448d2b89b1813(t.right, 0, 2e3, "hitslop - right"),
        bottom: $785a19cc58757094$export$407448d2b89b1813(t.bottom, 0, 2e3, "hitslop - bottom")
    };
}
function $785a19cc58757094$export$db3b6bfb95261072(t, o) {
    return {
        left: t.left - o.left,
        right: t.right + o.right,
        top: t.top - o.top,
        bottom: t.bottom + o.bottom
    };
}
function $785a19cc58757094$export$4368d992c4eafac0(t, o) {
    return !t || !o ? t === o : t.left === o.left && t.right === o.right && t.top === o.top && t.bottom === o.bottom;
}
function $785a19cc58757094$export$f1e1789686576879(t, o) {
    return t.x >= o.left && t.x <= o.right && t.y >= o.top && t.y <= o.bottom;
}
module.exports["a"] = $785a19cc58757094$export$407448d2b89b1813;
module.exports["b"] = $785a19cc58757094$export$8b22cf2602fb60ce;
module.exports["c"] = $785a19cc58757094$export$db3b6bfb95261072;
module.exports["d"] = $785a19cc58757094$export$4368d992c4eafac0;
module.exports["e"] = $785a19cc58757094$export$f1e1789686576879;

});

parcelRegister("2GQEm", function(module, exports) {

let $1f58583a48d142e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f58583a48d142e6$var$load("1gINj").then(()=>parcelRequire('11JE0'));

});

parcelRegister("4mSfC", function(module, exports) {

let $32e34c97c7dd1cf5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32e34c97c7dd1cf5$var$load("1GVLI").then(()=>parcelRequire('5CVfh'));

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId.
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("2cKGu", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
    if (contentMode === 'draft') return false;
    return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("kCXmK", function(module, exports) {

var $eY1jG = parcelRequire("eY1jG");


var $cozmU = parcelRequire("cozmU");


var $bAV6O = parcelRequire("bAV6O");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $4mPZy = parcelRequire("4mPZy");


var $fPTGf = parcelRequire("fPTGf");

const $a02f9f88b53bbb7f$export$87c3186b73dccb39 = (payload)=>Boolean(payload?.success && !payload.errors?.length);
const $a02f9f88b53bbb7f$export$f99b955ffb3c1231 = ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [syncSmartFolderMutation, { called: called, data: data, error: error, loading: loading }] = (0, $308Wd.useMutationInterop)((0, $eY1jG.default), {
        __callerPackage__: "smart-folder"
    });
    const applySmartFolderSubTypeChange = (0, $fPTGf.useApplySmartFolderSubTypeChange)();
    const syncSmartFolder = (0, $cozmU.useCallback)(async ({ folderId: folderId, force: force, syncTrigger: syncTrigger })=>{
        const folderAri = (0, $bAV6O.ConfluenceFolderAri).create({
            activationId: activationId,
            folderId: folderId,
            siteId: cloudId
        }).toString();
        const input = {
            folderId: folderAri,
            ...force !== undefined ? {
                force: force
            } : {},
            syncTrigger: syncTrigger
        };
        const result = await syncSmartFolderMutation({
            variables: {
                cloudId: cloudId,
                input: input
            }
        });
        const payload = result.data?.confluence_syncSmartFolder;
        if (payload?.success) (0, $4mPZy.rememberSmartFolderAutoSync)(folderId);
        if ($a02f9f88b53bbb7f$export$87c3186b73dccb39(payload)) applySmartFolderSubTypeChange({
            folderId: folderId,
            subType: 'managed'
        });
        return result;
    }, [
        activationId,
        cloudId,
        syncSmartFolderMutation,
        applySmartFolderSubTypeChange
    ]);
    return {
        syncSmartFolder: syncSmartFolder,
        called: called,
        data: data,
        error: error,
        loading: loading
    };
};
module.exports["isSuccessfulSmartFolderSyncPayload"] = $a02f9f88b53bbb7f$export$87c3186b73dccb39;
module.exports["useSyncSmartFolder"] = $a02f9f88b53bbb7f$export$f99b955ffb3c1231;

});

parcelRegister("eY1jG", function(module, exports) {
/**
 * @generated SignedSource<<8cfdc4e180f77cde4fc3cf487dbc73d3>>
 * @relayHash 6ef31550f1a84f52975ad108912b1bc5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55c51a3d63ff16775569e2936a90afe4aa4aa392c08de3ea8c4c25d05adf75fc
const $394869d03facb960$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "message"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "success"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSyncSmartFolderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSyncSmartFolderPayload",
                    "kind": "LinkedField",
                    "name": "confluence_syncSmartFolder",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSyncSmartFolderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSyncSmartFolderPayload",
                    "kind": "LinkedField",
                    "name": "confluence_syncSmartFolder",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6ef31550f1a84f52975ad108912b1bc5",
            "id": "55c51a3d63ff16775569e2936a90afe4aa4aa392c08de3ea8c4c25d05adf75fc",
            "metadata": {},
            "name": "useSyncSmartFolderMutation",
            "operationKind": "mutation",
            "text": "mutation useSyncSmartFolderMutation($cloudId:ID!,$input:ConfluenceSyncSmartFolderInput!){confluence_syncSmartFolder(cloudId:$cloudId,input:$input){errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}},success}}"
        }
    };
}();
$394869d03facb960$var$node.hash = "dec225cf1fdd258fa67d70013e7073ba";
var $394869d03facb960$export$2e2bcd8739ae039 = $394869d03facb960$var$node;
module.exports["default"] = $394869d03facb960$export$2e2bcd8739ae039;

});

parcelRegister("4mPZy", function(module, exports) {
const $c42d987119ed36a9$export$80aef25a279f0549 = 900000;
const $c42d987119ed36a9$var$lastAutoSyncAtByFolderId = new Map();
const $c42d987119ed36a9$var$isFreshTimestamp = (timestampMs, now)=>{
    const ageMs = now - timestampMs;
    return ageMs >= 0 && ageMs < $c42d987119ed36a9$export$80aef25a279f0549;
};
const $c42d987119ed36a9$var$pruneStaleRememberedSyncs = (now)=>{
    for (const [folderId, rememberedAt] of $c42d987119ed36a9$var$lastAutoSyncAtByFolderId)if (!$c42d987119ed36a9$var$isFreshTimestamp(rememberedAt, now)) $c42d987119ed36a9$var$lastAutoSyncAtByFolderId.delete(folderId);
};
const $c42d987119ed36a9$export$b5d9adcb9906e7c5 = (folderId, at = Date.now())=>{
    $c42d987119ed36a9$var$pruneStaleRememberedSyncs(at);
    $c42d987119ed36a9$var$lastAutoSyncAtByFolderId.set(folderId, at);
};
const $c42d987119ed36a9$export$f67b52ca3244ccf6 = ()=>{
    $c42d987119ed36a9$var$lastAutoSyncAtByFolderId.clear();
};
const $c42d987119ed36a9$export$ca3cda0f17cf3601 = ({ folderId: folderId, lastSynced: lastSynced, now: now = Date.now() })=>{
    const rememberedAt = $c42d987119ed36a9$var$lastAutoSyncAtByFolderId.get(folderId);
    if (rememberedAt !== undefined && $c42d987119ed36a9$var$isFreshTimestamp(rememberedAt, now)) return true;
    if (!lastSynced) return false;
    const lastSyncedMs = Date.parse(lastSynced);
    if (Number.isNaN(lastSyncedMs)) return false;
    return $c42d987119ed36a9$var$isFreshTimestamp(lastSyncedMs, now);
};
module.exports["rememberSmartFolderAutoSync"] = $c42d987119ed36a9$export$b5d9adcb9906e7c5;
module.exports["shouldSkipSmartFolderAutoSync"] = $c42d987119ed36a9$export$ca3cda0f17cf3601;

});

parcelRegister("4hvYT", function(module, exports) {
const $e319ea8b43ff5ed1$var$waitingForTWGStartedAtByFolderId = new Map();
const $e319ea8b43ff5ed1$var$RECOVERABLE_SYNC_OBSERVATION_WINDOW_MS = 900000;
const $e319ea8b43ff5ed1$export$a2dc1100412a5db6 = (errors)=>errors?.find((error)=>typeof error.extensions?.errorType === 'string')?.extensions?.errorType ?? undefined;
const $e319ea8b43ff5ed1$var$getRecoverableSyncState = (syncErrorType)=>{
    switch(syncErrorType){
        case 'SYNC_EXTERNAL_FOLDER_EMPTY':
        case 'SYNC_SOURCE_FOLDER_EMPTY':
            return 'emptyFolder';
        case 'SYNC_TWG_NOT_READY':
            return 'waitingForTWG';
        default:
            return undefined;
    }
};
const $e319ea8b43ff5ed1$var$getRecoverableSyncRetryResult = ({ success: success, syncErrorType: syncErrorType })=>{
    if (success) return 'success';
    switch($e319ea8b43ff5ed1$var$getRecoverableSyncState(syncErrorType)){
        case 'emptyFolder':
            return 'stillEmpty';
        case 'waitingForTWG':
            return 'stillWaitingForTWG';
        default:
            return 'failed';
    }
};
const $e319ea8b43ff5ed1$var$getWaitingForTWGDurationAttributes = ({ folderId: folderId, now: now, retryResult: retryResult, syncErrorType: syncErrorType })=>{
    if ($e319ea8b43ff5ed1$var$getRecoverableSyncState(syncErrorType) === 'waitingForTWG') {
        if (!$e319ea8b43ff5ed1$var$waitingForTWGStartedAtByFolderId.has(folderId)) $e319ea8b43ff5ed1$var$waitingForTWGStartedAtByFolderId.set(folderId, now);
    }
    const waitingForTWGStartedAt = $e319ea8b43ff5ed1$var$waitingForTWGStartedAtByFolderId.get(folderId);
    if (waitingForTWGStartedAt === undefined) return {};
    if (retryResult === 'success') {
        $e319ea8b43ff5ed1$var$waitingForTWGStartedAtByFolderId.delete(folderId);
        return {
            timeFromFirstWaitingForTWGToSuccessfulSyncMs: now - waitingForTWGStartedAt
        };
    }
    return now - waitingForTWGStartedAt >= $e319ea8b43ff5ed1$var$RECOVERABLE_SYNC_OBSERVATION_WINDOW_MS ? {
        noSuccessfulRetryWithinObservationWindow: true
    } : {};
};
const $e319ea8b43ff5ed1$export$9c1256ec02b40d23 = ({ containerApp: containerApp, durationMs: durationMs, folderId: folderId, isRetry: isRetry, now: now, provider: provider, retryCount: retryCount, sourceSurface: sourceSurface, success: success, syncErrorType: syncErrorType })=>{
    const retryResult = $e319ea8b43ff5ed1$var$getRecoverableSyncRetryResult({
        success: success,
        syncErrorType: syncErrorType
    });
    const recoverableState = $e319ea8b43ff5ed1$var$getRecoverableSyncState(syncErrorType);
    return {
        folderId: folderId,
        provider: provider,
        containerApp: containerApp ?? 'unknown',
        sourceSurface: sourceSurface,
        isRetry: isRetry,
        retryResult: retryResult,
        observationWindowMs: $e319ea8b43ff5ed1$var$RECOVERABLE_SYNC_OBSERVATION_WINDOW_MS,
        ...durationMs !== undefined ? {
            durationMs: durationMs
        } : {},
        ...retryCount !== undefined ? {
            retryCount: retryCount
        } : {},
        ...syncErrorType !== undefined ? {
            syncErrorType: syncErrorType
        } : {},
        ...recoverableState !== undefined ? {
            recoverableState: recoverableState
        } : {},
        ...$e319ea8b43ff5ed1$var$getWaitingForTWGDurationAttributes({
            folderId: folderId,
            now: now,
            retryResult: retryResult,
            syncErrorType: syncErrorType
        })
    };
};
module.exports["getSyncErrorType"] = $e319ea8b43ff5ed1$export$a2dc1100412a5db6;
module.exports["getRecoverableSyncAnalyticsAttributes"] = $e319ea8b43ff5ed1$export$9c1256ec02b40d23;

});

parcelRegister("6ld6a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $jtuBN = parcelRequire("jtuBN");


var $8wW9d = parcelRequire("8wW9d");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), {
        ...baseQueryOptions,
        __callerPackage__: "web-item-location"
    });
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        (0, $8wW9d.recordNonContentAppKeys)("web-item", webItems.map($f64809aa9d8f3ca2$var$_temp2));
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
function $f64809aa9d8f3ca2$var$_temp2(webItem_0) {
    return webItem_0.completeKey;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("14SPd", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $1j3IV = parcelRequire("1j3IV");


var $4R0nV = parcelRequire("4R0nV");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $kSwu1.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("1j3IV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("4R0nV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $8s9DV.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $kBr4q.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $kBr4q.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("hL4RO", function(module, exports) {
// Slack Connect web-item ids are `<addonKey>__<moduleKey>`. The addon key is bare in prod but
// suffixed on non-prod installs (e.g. `-ddev`, `-stg-east`), so match on prefix + module suffix.
const $655d13c70191fa8e$var$SLACK_CONNECT_APP_ID_PREFIX = 'confluence-chats-integration';
// Module suffixes being deprecated as part of the Connect deprecation. Add future modules here.
const $655d13c70191fa8e$var$DEPRECATED_CONNECT_MODULE_SUFFIXES = [
    '__page-config-dialog-trigger',
    '__profile'
];
const $655d13c70191fa8e$export$66793f50054894c5 = [
    '__space-config-link'
];
const $655d13c70191fa8e$export$2855598082f8f510 = (webItemId, moduleSuffixes = $655d13c70191fa8e$var$DEPRECATED_CONNECT_MODULE_SUFFIXES)=>Boolean(webItemId?.startsWith($655d13c70191fa8e$var$SLACK_CONNECT_APP_ID_PREFIX) && moduleSuffixes.some((suffix)=>webItemId.endsWith(suffix)));
module.exports["DEPRECATED_SPACE_SETTINGS_MODULE_SUFFIXES"] = $655d13c70191fa8e$export$66793f50054894c5;
module.exports["isDeprecatedConnectWebItem"] = $655d13c70191fa8e$export$2855598082f8f510;

});

parcelRegister("9dHNS", function(module, exports) {
const $6b674e69a79b1327$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $6b674e69a79b1327$var$idbProxyableTypes;
let $6b674e69a79b1327$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $6b674e69a79b1327$var$getIdbProxyableTypes() {
    return $6b674e69a79b1327$var$idbProxyableTypes || ($6b674e69a79b1327$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $6b674e69a79b1327$var$getCursorAdvanceMethods() {
    return $6b674e69a79b1327$var$cursorAdvanceMethods || ($6b674e69a79b1327$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $6b674e69a79b1327$var$transactionDoneMap = new WeakMap();
const $6b674e69a79b1327$var$transformCache = new WeakMap();
const $6b674e69a79b1327$var$reverseTransformCache = new WeakMap();
function $6b674e69a79b1327$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($6b674e69a79b1327$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $6b674e69a79b1327$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $6b674e69a79b1327$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($6b674e69a79b1327$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $6b674e69a79b1327$var$transactionDoneMap.set(tx, done);
}
let $6b674e69a79b1327$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $6b674e69a79b1327$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $6b674e69a79b1327$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $6b674e69a79b1327$var$replaceTraps(callback) {
    $6b674e69a79b1327$var$idbProxyTraps = callback($6b674e69a79b1327$var$idbProxyTraps);
}
function $6b674e69a79b1327$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($6b674e69a79b1327$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($6b674e69a79b1327$export$debb760848ca95a(this), args);
        return $6b674e69a79b1327$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $6b674e69a79b1327$export$4997ffc0176396a6(func.apply($6b674e69a79b1327$export$debb760848ca95a(this), args));
    };
}
function $6b674e69a79b1327$var$transformCachableValue(value) {
    if (typeof value === 'function') return $6b674e69a79b1327$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $6b674e69a79b1327$var$cacheDonePromiseForTransaction(value);
    if ($6b674e69a79b1327$var$instanceOfAny(value, $6b674e69a79b1327$var$getIdbProxyableTypes())) return new Proxy(value, $6b674e69a79b1327$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $6b674e69a79b1327$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $6b674e69a79b1327$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($6b674e69a79b1327$var$transformCache.has(value)) return $6b674e69a79b1327$var$transformCache.get(value);
    const newValue = $6b674e69a79b1327$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $6b674e69a79b1327$var$transformCache.set(value, newValue);
        $6b674e69a79b1327$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $6b674e69a79b1327$export$debb760848ca95a = (value)=>$6b674e69a79b1327$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $6b674e69a79b1327$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $6b674e69a79b1327$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($6b674e69a79b1327$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $6b674e69a79b1327$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $6b674e69a79b1327$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $6b674e69a79b1327$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $6b674e69a79b1327$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $6b674e69a79b1327$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $6b674e69a79b1327$var$cachedMethods = new Map();
function $6b674e69a79b1327$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($6b674e69a79b1327$var$cachedMethods.get(prop)) return $6b674e69a79b1327$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $6b674e69a79b1327$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $6b674e69a79b1327$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $6b674e69a79b1327$var$cachedMethods.set(prop, method);
    return method;
}
$6b674e69a79b1327$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$6b674e69a79b1327$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$6b674e69a79b1327$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $6b674e69a79b1327$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $6b674e69a79b1327$var$methodMap = {};
const $6b674e69a79b1327$var$advanceResults = new WeakMap();
const $6b674e69a79b1327$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $6b674e69a79b1327$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$6b674e69a79b1327$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $6b674e69a79b1327$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $6b674e69a79b1327$var$methodMap[prop] = function(...args) {
            $6b674e69a79b1327$var$advanceResults.set(this, $6b674e69a79b1327$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $6b674e69a79b1327$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $6b674e69a79b1327$var$cursorIteratorTraps);
    $6b674e69a79b1327$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $6b674e69a79b1327$var$reverseTransformCache.set(proxiedCursor, $6b674e69a79b1327$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($6b674e69a79b1327$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $6b674e69a79b1327$var$advanceResults.delete(proxiedCursor);
    }
}
function $6b674e69a79b1327$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $6b674e69a79b1327$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $6b674e69a79b1327$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$6b674e69a79b1327$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($6b674e69a79b1327$var$isIteratorProp(target, prop)) return $6b674e69a79b1327$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $6b674e69a79b1327$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));
module.exports["wrap"] = $6b674e69a79b1327$export$4997ffc0176396a6;
module.exports["unwrap"] = $6b674e69a79b1327$export$debb760848ca95a;

});

parcelRegister("awSMG", function(module, exports) {
const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
const $4ce470d2dd3584e9$export$9fd1ded1027f9ea2 = 2;
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;
module.exports["OFFLINE_STEPS_DATABASE_VERSION"] = $4ce470d2dd3584e9$export$9fd1ded1027f9ea2;

});

parcelRegister("2gcb7", function(module, exports) {

var $9dHNS = parcelRequire("9dHNS");


var $8UEfo = parcelRequire("8UEfo");

function $c0ef40f69113b424$export$816fcf16ba452840(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = (0, $8UEfo.atlIndexedDb).openStrictlyNecessary(name, version);
    const openPromise = new Promise((resolve, reject)=>{
        request.addEventListener('success', ()=>{
            resolve((0, $9dHNS.wrap)(request.result));
        });
        request.addEventListener('error', ()=>{
            reject(request.error ?? new Error(`Unable to open IndexedDB database "${name}"`));
        });
    });
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        const versionChangeEvent = event;
        upgrade((0, $9dHNS.wrap)(request.result), versionChangeEvent.oldVersion, versionChangeEvent.newVersion, (0, $9dHNS.wrap)(request.transaction), versionChangeEvent);
    });
    if (blocked) request.addEventListener('blocked', (event)=>{
        const versionChangeEvent = event;
        blocked(versionChangeEvent.oldVersion, versionChangeEvent.newVersion, versionChangeEvent);
    });
    openPromise.then((database)=>{
        if (terminated) database.addEventListener('close', terminated);
        if (blocking) database.addEventListener('versionchange', (event)=>{
            const versionChangeEvent = event;
            blocking(versionChangeEvent.oldVersion, versionChangeEvent.newVersion, versionChangeEvent);
        });
    }).catch(()=>{});
    return openPromise;
}
function $c0ef40f69113b424$export$dc8e7b7934327bba() {
    return (0, $8UEfo.atlIndexedDb).databases();
}
function $c0ef40f69113b424$export$eab974551289fcd2(databaseName) {
    return (0, $8UEfo.atlIndexedDb).openStrictlyNecessary(databaseName);
}
function $c0ef40f69113b424$export$ddd7719b086dc6f7(databaseName) {
    return new Promise((resolve, reject)=>{
        const request = (0, $8UEfo.atlIndexedDb).deleteDatabase(databaseName);
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
        request.onblocked = ()=>resolve();
    });
}
module.exports["UNSAFE_openStrictlyNecessaryIndexedDb"] = $c0ef40f69113b424$export$816fcf16ba452840;
module.exports["getIndexedDbDatabases"] = $c0ef40f69113b424$export$dc8e7b7934327bba;
module.exports["UNSAFE_openStrictlyNecessaryIndexedDbRequest"] = $c0ef40f69113b424$export$eab974551289fcd2;
module.exports["deleteIndexedDbDatabase"] = $c0ef40f69113b424$export$ddd7719b086dc6f7;

});

parcelRegister("8w1c1", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("gplrY"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("gplrY"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("gsBOn"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("gplrY", function(module, exports) {

let $bf1f9eae5f7e8b1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bf1f9eae5f7e8b1a$var$load("eUsnQ"),
    $bf1f9eae5f7e8b1a$var$load("ea3NB"),
    $bf1f9eae5f7e8b1a$var$load("6wr18"),
    $bf1f9eae5f7e8b1a$var$load("efUj2"),
    $bf1f9eae5f7e8b1a$var$load("iWnyc"),
    $bf1f9eae5f7e8b1a$var$load("hhss7"),
    $bf1f9eae5f7e8b1a$var$load("ffEVr"),
    $bf1f9eae5f7e8b1a$var$load("Wowvf"),
    $bf1f9eae5f7e8b1a$var$load("4g6rd"),
    $bf1f9eae5f7e8b1a$var$load("7EorR"),
    $bf1f9eae5f7e8b1a$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("gsBOn", function(module, exports) {

let $bfbc976fa724bf2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfbc976fa724bf2c$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("8gF2o", function(module, exports) {
/**
 * Utilities for talking to the Atlassian outbound-auth gateway, which is the
 * canonical source of truth for whether a user has a working OAuth connection
 * to a given Smart Link connector.
 *
 * Why this exists
 * ---------------
 * Previously we relied on the CDS endpoint
 *   GET /gateway/api/third-party-configuration/connected-data-sources/{cloudId}
 * (via `get3pSearchConfig`) to determine both the OAuth start URL and whether
 * the user was already connected. That endpoint has four well-known problems
 * for the Confluence onboarding "Connect your 3P tools" experience:
 *
 *   1. Edition-gated: CDS only works on Standard+ tenants with Rovo
 *      provisioned. Free tier tenants return 403.
 *   2. Lazy-init: the registry behind CDS (ERS) does not have a
 *      `smartlinks-connector-{provider}` row until a Smart Link resolve event
 *      for that provider has fired on the tenant. Brand-new tenants are
 *      effectively empty.
 *   3. Not a definitive provider universe: CDS only enumerates what's already
 *      been touched on this tenant, not what's available to connect.
 *   4. No back-population: even after a user connects via a fallback path,
 *      CDS does not see it (until/unless ERS gets the event), so downstream
 *      surfaces like the post-office banner keep re-prompting.
 *
 * The outbound-auth gateway endpoint
 *   GET /gateway/api/outbound-auth/aaId/{aaId}
 * powers id.atlassian.com/manage-profile/apps. It is cookie-authed (no ASAP
 * needed), works cross-origin from *.atlassian.net, and returns the user's
 * full OAuth-grant list with a per-account `status` field. This is the same
 * data the Atlassian ID Manage Profile UI uses.
 *
 * Canonical container UUIDs come from
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application-prod.yml
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application.yml      (staging)
 * under `linking-platform.providers[]`. The `containerId` + `serviceKey`
 * tuples in the outbound-auth response match those values exactly.
 *
 * Backwards-compat / defensive design
 * -----------------------------------
 *  - All network/parse failures return `null` and let callers fall back to
 *    whatever they were doing before. This module never throws.
 *  - The container maps are `Partial<Record<...>>` and helpers return `null`
 *    when a product has no mapping. Callers are expected to filter such
 *    providers out rather than render broken Connect buttons.
 */ 
var $fR63l = parcelRequire("fR63l");


var $bNe5y = parcelRequire("bNe5y");

// Verified identical in prod and staging gdrive CDS URLs.
const $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES = [
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
];
const $ee8d2d572fb3c0d4$export$860f54a43e361c13 = {
    [(0, $fR63l.ProductKeys3P).GoogleDrive]: {
        containerId: 'ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7_c50f3d56-68fc-4c3c-8191-6717f173dc54',
        serviceKey: 'gdrive',
        defaultScopes: $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $fR63l.ProductKeys3P).Slack]: {
        containerId: '25ab8ceb-e2e9-4b3a-b4ef-902049561d3a_74232f16-3f89-4bc8-9dcb-b5481bca783e',
        serviceKey: 'slack'
    },
    [(0, $fR63l.ProductKeys3P).OneDrive]: {
        containerId: '00f40f12-faac-4ac8-8d6d-310f96ac97f5_f039c3c2-7e00-41c4-b1cf-70743efbf91a',
        serviceKey: 'onedrive'
    },
    [(0, $fR63l.ProductKeys3P).Sharepoint]: {
        containerId: '7289b5af-9aa4-4977-bb8b-6876502a6466_e7e24a0a-0b03-4ef8-9a83-642e6ef97dbc',
        serviceKey: 'sharepoint'
    },
    [(0, $fR63l.ProductKeys3P).Github]: {
        containerId: 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7',
        serviceKey: 'github'
    },
    [(0, $fR63l.ProductKeys3P).Figma]: {
        containerId: '7f89dc0c-5c1e-4b71-997f-220bf92361aa_73fbf758-c657-4f06-8edd-f721911f7f53',
        serviceKey: 'figma'
    },
    [(0, $fR63l.ProductKeys3P).Teams]: {
        containerId: 'fe8ece6c-97b6-45ac-959d-865da9a33409_61030824-303b-4751-bca5-1def33b6b0d0',
        serviceKey: 'ms-teams'
    },
    [(0, $fR63l.ProductKeys3P).Dropbox]: {
        containerId: 'd4d6a241-1008-42cf-b2d6-d0b380c096d6_b6796989-c34a-4e19-a4e1-ccc7655f8fd6',
        serviceKey: 'dropbox'
    },
    [(0, $fR63l.ProductKeys3P).Airtable]: {
        containerId: 'c5805f5a-3e9a-48a5-a8f5-7b04aac4ad16_572b2748-e9b1-4161-b36d-19f962646d1a',
        serviceKey: 'airtable'
    },
    [(0, $fR63l.ProductKeys3P).LaunchDarkly]: {
        containerId: '30ba2eba-6d3f-4124-8060-0ea9a9c9e990_d28912a6-171c-41a2-9adb-1426eccbc767',
        serviceKey: 'launchdarkly'
    },
    [(0, $fR63l.ProductKeys3P).ClickUp]: {
        containerId: '12967bc2-803e-4f8d-9e66-1aa48773a5a4_13a589a5-f514-4b63-a104-7d454b8dc676',
        serviceKey: 'clickup'
    },
    [(0, $fR63l.ProductKeys3P).Pipedrive]: {
        containerId: '1edf2d8e-c159-4ffe-8be0-165821a0ecf1_743950e9-2685-4558-a5b0-ae5d3b47853c',
        serviceKey: 'pipedrive'
    },
    [(0, $fR63l.ProductKeys3P).Gitlab]: {
        containerId: '790bd6ce-7ef8-404a-a9dc-798feb10b12b_049b63cb-90b1-4bfa-aa02-f3fdd9298b03',
        serviceKey: 'gitlab'
    },
    [(0, $fR63l.ProductKeys3P).Docusign]: {
        containerId: '35cd5415-c24c-457e-af7c-ac84df8c8628_0a7329e4-b658-41a1-89c2-419514a5ca08',
        serviceKey: 'docusign'
    },
    [(0, $fR63l.ProductKeys3P).Dovetail]: {
        containerId: 'b51f1664-8705-4938-a9a5-02a7eb3395cb_cba4f674-8eea-43aa-874f-8f16af6b75cb',
        serviceKey: 'dovetail'
    },
    [(0, $fR63l.ProductKeys3P).Box]: {
        containerId: '3a79e004-2e3e-45fe-8a21-84f53568a8ee_35421d47-ad3e-44f5-9cde-60bfa869e0b0',
        serviceKey: 'box'
    },
    [(0, $fR63l.ProductKeys3P).AdobeXD]: {
        containerId: '80c22a47-9ca7-4690-88db-65b375f402a7_ad251cf5-828d-494d-b555-4294d9654173',
        serviceKey: 'adobexd'
    },
    [(0, $fR63l.ProductKeys3P).Asana]: {
        containerId: '2487d697-ed1e-4cf5-9655-f1fb1355c341_a927cae4-3500-4386-9ac3-28e87671c2c8',
        serviceKey: 'asana'
    },
    [(0, $fR63l.ProductKeys3P).Smartsheet]: {
        containerId: '101a27da-d409-4f8c-9c75-326eec4fd5d4_fe89f892-8c94-4574-88f7-5898c05be186',
        serviceKey: 'smartsheet'
    },
    [(0, $fR63l.ProductKeys3P).Mural]: {
        containerId: 'cc21faf3-19fc-4522-af92-295866ef82e7_373f2501-6f74-4c0f-9bfa-c54cdea00066',
        serviceKey: 'mural'
    },
    [(0, $fR63l.ProductKeys3P).PowerBI]: {
        containerId: '9c59191f-63ab-44b2-a2cb-2f20adc75365_556e62ba-588b-494d-8c6c-b672e50537f6',
        serviceKey: 'power-bi'
    },
    [(0, $fR63l.ProductKeys3P).Miro]: {
        containerId: 'd01d8332-4637-4ea4-8b14-17a9d1a61504_a894175f-cb17-4e45-88fa-c348967f379c',
        serviceKey: 'miro'
    },
    [(0, $fR63l.ProductKeys3P).Hubspot]: {
        containerId: 'da0f0482-f78f-4eec-b7e6-0bc98ca5a54c_707406e8-d607-427a-b32e-e1d4710c0f2d',
        serviceKey: 'hubspot'
    },
    [(0, $fR63l.ProductKeys3P).Notion]: {
        containerId: '2bc172f6-c553-4fe1-85d4-3e2e087f84f6_be0969ca-ea7e-4685-abaa-7de142c01b36',
        serviceKey: 'notion'
    },
    [(0, $fR63l.ProductKeys3P).Sentry]: {
        containerId: '977cb3af-b6e9-4450-9ce5-bf40f9c73dff_3a8bcf5e-44ab-4f5b-b18d-340027b6a97e',
        serviceKey: 'sentry'
    },
    [(0, $fR63l.ProductKeys3P).PagerDuty]: {
        containerId: '49cdc160-0ad5-4dbf-adad-6a57fb082774_5cef1b1a-44aa-409e-97b3-b90065cbb39e',
        serviceKey: 'pagerduty'
    },
    [(0, $fR63l.ProductKeys3P).Salesforce]: {
        containerId: '2b45cadc-67a2-4902-8148-03e4de5ba747_db858b85-c098-45e7-96c8-9ccc9caf72da',
        serviceKey: 'salesforce'
    },
    [(0, $fR63l.ProductKeys3P).Amplitude]: {
        containerId: '1e30cfdf-cceb-43f4-b34a-dde94e1f9b21_939acc6f-274a-42da-acdc-8af5a14fe698',
        serviceKey: 'amplitude'
    },
    [(0, $fR63l.ProductKeys3P).Lucid]: {
        containerId: '9262005e-5c1a-49af-9ec0-4a354f581c73_80f25935-3f1f-40e1-9b2a-35db54297ebf',
        serviceKey: 'lucid'
    },
    [(0, $fR63l.ProductKeys3P).Zeplin]: {
        containerId: 'a401d4f0-b3d1-4b64-a85d-3952bd42d9a7_3da3c5e7-89db-4330-878f-dff1fe878556',
        serviceKey: 'zeplin'
    },
    [(0, $fR63l.ProductKeys3P).Todoist]: {
        containerId: '0202ace9-65df-40e3-b539-d831b446dad9_c7809c53-31e9-4fc0-8df9-8b8dcb418bb8',
        serviceKey: 'todoist'
    },
    [(0, $fR63l.ProductKeys3P).Stripe]: {
        containerId: 'bb81e8b8-7d0d-4a24-bb5b-acf31ab97bbc_f38b2a60-30a9-4abd-9086-efb78f6986ce',
        serviceKey: 'stripe'
    },
    [(0, $fR63l.ProductKeys3P).AzureDevops]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=6b34a992…]).
        containerId: '6b34a992-af2a-4a16-8a4d-89038c48a355_719d2d91-a89a-46f5-bacc-e3baf87d21c8',
        serviceKey: 'azuredevops'
    },
    [(0, $fR63l.ProductKeys3P).Webex]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=18025f11…]).
        containerId: '18025f11-aafe-49ca-ad45-d48f7005e459_19846c70-0c88-44f6-a7c1-d5bdd77c606c',
        serviceKey: 'webex'
    }
};
const $ee8d2d572fb3c0d4$export$e25d6f2386134a66 = {
    [(0, $fR63l.ProductKeys3P).GoogleDrive]: {
        containerId: '2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1_3b53863d-a6bb-4818-91da-4de04f975f48',
        serviceKey: 'gdrive',
        defaultScopes: $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $fR63l.ProductKeys3P).Slack]: {
        containerId: '32a368b4-220e-45a9-b65f-df104dc2e559_7ab21f60-b89a-44c1-bed3-00282c3e7b9e',
        serviceKey: 'slack'
    },
    [(0, $fR63l.ProductKeys3P).OneDrive]: {
        containerId: '6b74c0f8-ce5e-43b0-a68e-eba0fed27cea_4254f605-625b-4026-904a-bdf8ee6de413',
        serviceKey: 'onedrive'
    },
    [(0, $fR63l.ProductKeys3P).Sharepoint]: {
        containerId: '03d0881e-f10f-4751-ab11-27592812060e_b269c883-58b9-463a-9b77-50b6cd8da5fc',
        serviceKey: 'sharepoint'
    },
    [(0, $fR63l.ProductKeys3P).Github]: {
        containerId: '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f',
        serviceKey: 'github'
    },
    [(0, $fR63l.ProductKeys3P).Figma]: {
        containerId: '652e701c-09ac-4e05-bd96-4c95b5c8cac5_ccaebdc1-68e5-406a-b1f4-efcc5962aa40',
        serviceKey: 'figma'
    },
    [(0, $fR63l.ProductKeys3P).Teams]: {
        containerId: 'd27ee9f8-f60b-4076-910b-f16da23b7df4_b3763282-4b2e-4b4b-b924-3c8ba8f6e218',
        serviceKey: 'ms-teams'
    },
    [(0, $fR63l.ProductKeys3P).Dropbox]: {
        containerId: 'd7a3169c-13c8-4b76-96b6-e8f9f849313d_d73e8370-9035-494d-ae16-20854375cb6f',
        serviceKey: 'dropbox'
    },
    [(0, $fR63l.ProductKeys3P).Airtable]: {
        containerId: '070278f6-260c-420f-be4f-a7942a712c23_c2fe283b-51d2-4a0a-8e7f-4ce1199e0a10',
        serviceKey: 'airtable'
    },
    [(0, $fR63l.ProductKeys3P).LaunchDarkly]: {
        containerId: 'd63e3423-0a85-461f-9650-7f26342c62bf_49e197a6-c428-442e-a5ca-f9d4889c82d8',
        serviceKey: 'launchdarkly'
    },
    [(0, $fR63l.ProductKeys3P).ClickUp]: {
        containerId: 'fe20ccd3-b054-4139-aacb-8d98e086c16d_0b40b3c7-4c18-40e3-a030-101c94347723',
        serviceKey: 'clickup'
    },
    [(0, $fR63l.ProductKeys3P).Pipedrive]: {
        containerId: '6012b82a-da48-44ff-af6e-da1c73b279f6_e6a2cefa-c9fe-4d50-b8ea-36391a2d41e6',
        serviceKey: 'pipedrive'
    },
    [(0, $fR63l.ProductKeys3P).Gitlab]: {
        containerId: 'a7b83eeb-482d-402d-b87d-21ede67e73ed_3082dfec-249f-45d9-b84d-b49d256874e9',
        serviceKey: 'gitlab'
    },
    [(0, $fR63l.ProductKeys3P).Docusign]: {
        containerId: 'ec9d65b4-72ee-4030-8dd1-e393026cf335_f4f50986-99a8-4f96-8b52-917d4c6bbbb7',
        serviceKey: 'docusign'
    },
    [(0, $fR63l.ProductKeys3P).Dovetail]: {
        containerId: 'f9a3bf31-88d5-4b5a-80c2-cc32670259a2_c0c8e23b-ec93-45bb-928c-91b9671f0041',
        serviceKey: 'dovetail'
    },
    [(0, $fR63l.ProductKeys3P).Box]: {
        containerId: '43cd20d8-11a7-4910-8789-06523fb2e6db_957783c9-4448-4d91-93dc-0ad7b24a327a',
        serviceKey: 'box'
    },
    [(0, $fR63l.ProductKeys3P).AdobeXD]: {
        containerId: 'c1225a08-acd6-4908-84a7-d5b573f14cc1_e701a1e0-b819-4077-99ac-0b3525510c66',
        serviceKey: 'adobexd'
    },
    [(0, $fR63l.ProductKeys3P).Asana]: {
        containerId: '35462eee-abe5-4873-ba7a-610d4c85f640_cb8525b3-26b3-467d-b42c-cb944e912311',
        serviceKey: 'asana'
    },
    [(0, $fR63l.ProductKeys3P).Smartsheet]: {
        containerId: '48cb55a0-db03-4ce4-8f76-1f986f734652_e6b58d0f-fa9f-4543-9b67-5957b73dee6f',
        serviceKey: 'smartsheet'
    },
    [(0, $fR63l.ProductKeys3P).Mural]: {
        containerId: '95d1bad0-96d7-40a8-996f-b8226dfd8fa1_d6095215-c4a5-4be1-bdd9-7065ed65ae37',
        serviceKey: 'mural'
    },
    [(0, $fR63l.ProductKeys3P).PowerBI]: {
        containerId: 'ea3c5a46-228c-47ea-8c4b-f18e0f17fe8c_abc5ee35-a08c-4481-aa26-0439ce58b4c4',
        serviceKey: 'power-bi'
    },
    [(0, $fR63l.ProductKeys3P).Miro]: {
        containerId: 'e37bcd89-df89-4e65-90f9-98a92fa2dbd0_7c1ec941-d9e7-40be-96fb-69fae6b6bfd2',
        serviceKey: 'miro'
    },
    [(0, $fR63l.ProductKeys3P).Hubspot]: {
        containerId: 'aca58c62-2fb0-4abc-93f0-08bc704ab82a_c39eff84-66f8-4fa9-bb75-768ac83b5f6d',
        serviceKey: 'hubspot'
    },
    [(0, $fR63l.ProductKeys3P).Notion]: {
        containerId: '60913f14-f7e5-465a-9df7-a5f7974caad6_80617f98-fa46-4b5e-9c8e-a54bc42b7c3e',
        serviceKey: 'notion'
    },
    [(0, $fR63l.ProductKeys3P).Sentry]: {
        containerId: '59ec4558-3649-433e-a6b9-7964ae040b78_39660d3a-f2c9-446a-9a53-db433bbc7c2d',
        serviceKey: 'sentry'
    },
    [(0, $fR63l.ProductKeys3P).PagerDuty]: {
        containerId: '2db77a65-0037-45ea-9f57-642051d86ff5_dd18e9a6-e52a-4b80-9a2f-1aa487c9f747',
        serviceKey: 'pagerduty'
    },
    [(0, $fR63l.ProductKeys3P).Salesforce]: {
        containerId: 'd62184e4-87e4-41b2-9321-8b3c1dede9d7_433a0c54-84d5-41ee-9c21-684887b34330',
        serviceKey: 'salesforce'
    },
    [(0, $fR63l.ProductKeys3P).Amplitude]: {
        containerId: '953d4aed-a528-4a5e-9f84-fe42741063f5_eed898af-fb54-4a76-ba73-8d6261639a1a',
        serviceKey: 'amplitude'
    },
    [(0, $fR63l.ProductKeys3P).Lucid]: {
        containerId: 'd188e82f-311c-429d-a17f-bde97037890e_937a3756-c797-4f04-bde1-3eba582b91cf',
        serviceKey: 'lucid'
    },
    [(0, $fR63l.ProductKeys3P).Zeplin]: {
        containerId: '2e14b294-385f-4d3c-a0a0-3e29e1f3a30b_f156da1b-5880-4fc1-ae67-2581ab8fda87',
        serviceKey: 'zeplin'
    },
    [(0, $fR63l.ProductKeys3P).Todoist]: {
        containerId: '6ff1e497-21ac-4f8e-ac74-b869e2c3f274_0f5c1a58-fdae-41ae-841d-2bc5a2875c38',
        serviceKey: 'todoist'
    },
    [(0, $fR63l.ProductKeys3P).Stripe]: {
        containerId: '48824814-f7d3-465a-9535-f589940c8e5a_8a330cd4-3af2-4c32-8c8e-8e751a3fad8a',
        serviceKey: 'stripe'
    },
    [(0, $fR63l.ProductKeys3P).AzureDevops]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod —
        // ai-3p-connector's application-staging.yml does NOT declare a
        // per-provider serviceKey for Azure DevOps, but every other
        // provider in this file uses the same serviceKey across both
        // environments, so the prod value is the safe assumption.
        containerId: '784f3542-1a1d-4f49-8769-f3c2cb1e83b3_b91efd28-4d10-43d4-bcae-a5b0fef72bb1',
        serviceKey: 'azuredevops'
    },
    [(0, $fR63l.ProductKeys3P).Webex]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod
        // (see note on AzureDevops above).
        containerId: 'ead13644-c3c5-4f8d-8d31-58be86dc7c8e_cedff546-1b81-4f3c-b65d-30c4cb2d8c61',
        serviceKey: 'webex'
    }
};
const $ee8d2d572fb3c0d4$var$ATLASSIAN_ID_BASE_URLS = {
    prod: 'https://id.atlassian.com',
    staging: 'https://id.stg.internal.atlassian.com'
};
const $ee8d2d572fb3c0d4$var$CONTAINER_MAPS = {
    prod: $ee8d2d572fb3c0d4$export$860f54a43e361c13,
    staging: $ee8d2d572fb3c0d4$export$e25d6f2386134a66
};
const $ee8d2d572fb3c0d4$var$isProdHostname = ()=>{
    if (typeof window === 'undefined' || !window.location) return true;
    return window.location.hostname.endsWith('.atlassian.net');
};
const $ee8d2d572fb3c0d4$var$getEnvFromHostname = ()=>$ee8d2d572fb3c0d4$var$isProdHostname() ? 'prod' : 'staging';
const $ee8d2d572fb3c0d4$export$d73c6d475285293 = (payload)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return null;
    const prodUuids = new Set(Object.values($ee8d2d572fb3c0d4$export$860f54a43e361c13).map((m)=>m?.containerId));
    const stagingUuids = new Set(Object.values($ee8d2d572fb3c0d4$export$e25d6f2386134a66).map((m)=>m?.containerId));
    let prodHits = 0;
    let stagingHits = 0;
    for (const c of payload.containers){
        const id = c.container?.containerId;
        if (!id) continue;
        if (prodUuids.has(id)) prodHits++;
        if (stagingUuids.has(id)) stagingHits++;
    }
    if (prodHits === 0 && stagingHits === 0) return null;
    return prodHits >= stagingHits ? 'prod' : 'staging';
};
const $ee8d2d572fb3c0d4$var$getAtlassianIdBaseUrl = (env)=>$ee8d2d572fb3c0d4$var$ATLASSIAN_ID_BASE_URLS[env];
const $ee8d2d572fb3c0d4$var$getContainerMap = (env)=>$ee8d2d572fb3c0d4$var$CONTAINER_MAPS[env];
const $ee8d2d572fb3c0d4$export$50ff30f26c11fe5f = async (aaId, { forceRefresh: forceRefresh = false } = {})=>{
    if (!aaId) return null;
    try {
        const response = await (0, $bNe5y.fetchAccountsByAaId)({
            aaid: aaId,
            // When `forceRefresh` is true, bypass the cache (always hit the
            // gateway). Otherwise, prefer cached values over the network when
            // they are still warm — the post-office banner re-mounts on most
            // navigation events and we don't want to thrash the gateway.
            onlyRefreshIfExpired: !forceRefresh,
            returnExpired: true
        });
        if (!response || !Array.isArray(response.containers)) return null;
        return response;
    } catch  {
        return null;
    }
};
const $ee8d2d572fb3c0d4$export$6d3a2e8837b79055 = (payload, productKey, env)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return false;
    // Prefer the env we detect from the payload itself (deterministic — the
    // gateway can only return UUIDs from one env at a time). Fall back to
    // hostname-based detection only if the payload contains no recognised
    // UUIDs in either map (defensive — should be unreachable since the
    // gateway always returns at least the user's atlassian-token-service-key
    // container, plus any Smart Link grants).
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$export$d73c6d475285293(payload) ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    const mapping = $ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return false;
    const matchingContainer = payload.containers.find((c)=>c.container?.containerId === mapping.containerId);
    if (!matchingContainer) return false;
    const services = Array.isArray(matchingContainer.services) ? matchingContainer.services : [];
    // Filter services by the expected serviceKey. For unique-container
    // providers this is a no-op (one service per container). For shared
    // containers it ensures we only look at accounts owned by the right
    // service.
    const matchingServices = services.filter((s)=>s.service?.serviceKey === mapping.serviceKey);
    return matchingServices.some((s)=>(Array.isArray(s.accounts) ? s.accounts : []).some((account)=>account.status === 'available'));
};
const $ee8d2d572fb3c0d4$export$8acaf25597d6f4b9 = (productKey, env)=>{
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    const mapping = $ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return null;
    const baseUrl = $ee8d2d572fb3c0d4$var$getAtlassianIdBaseUrl(resolvedEnv);
    const params = new URLSearchParams({
        serviceKey: mapping.serviceKey,
        containerId: mapping.containerId
    });
    if (mapping.defaultScopes?.length) params.set('scopes', mapping.defaultScopes.join(' '));
    // URLSearchParams encodes spaces as '+'; gateway expects RFC 3986 '%20'.
    return `${baseUrl}/outboundAuth/start?${params.toString().replace(/\+/g, '%20')}`;
};
const $ee8d2d572fb3c0d4$export$27e6019a895f8241 = (productKey, env)=>{
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    return Boolean($ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey]);
};
module.exports["detectEnvFromPayload"] = $ee8d2d572fb3c0d4$export$d73c6d475285293;
module.exports["fetchOutboundAuthAccounts"] = $ee8d2d572fb3c0d4$export$50ff30f26c11fe5f;
module.exports["isAuthenticatedForProduct"] = $ee8d2d572fb3c0d4$export$6d3a2e8837b79055;
module.exports["buildSmartLinkAuthUrl"] = $ee8d2d572fb3c0d4$export$8acaf25597d6f4b9;
module.exports["hasSmartLinkContainerMapping"] = $ee8d2d572fb3c0d4$export$27e6019a895f8241;

});

parcelRegister("bNe5y", function(module, exports) {

var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $feBoR = parcelRequire("feBoR");

const $4fb07153bd78bc9f$var$accountsByAaIdCache = (0, $fyjce.promiseCache)({
    name: 'accounts-by-aaid-cache',
    expiration: 1800000 // 30 minutes
});
const $4fb07153bd78bc9f$export$75264ee4f9af0fe1 = async ({ aaid: aaid, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const accountsPromise = (0, $feBoR.fetchAccountsByAaIdInternal)(aaid);
        const degrader = new (0, $9C63M.DegradablePromise)(accountsPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = aaid;
    return $4fb07153bd78bc9f$var$accountsByAaIdCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchAccountsByAaId"] = $4fb07153bd78bc9f$export$75264ee4f9af0fe1;

});

parcelRegister("feBoR", function(module, exports) {

var $kKR0X = parcelRequire("kKR0X");

const $bc7e7cf1bc3ed88d$export$8fc8913ba4f36c51 = async (aaid)=>{
    const url = `/gateway/api/outbound-auth/aaId/${aaid}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $kKR0X.OutboundAuthApiError)('Failed to fetch accounts by aaId');
    return await response.json();
};
module.exports["fetchAccountsByAaIdInternal"] = $bc7e7cf1bc3ed88d$export$8fc8913ba4f36c51;

});

parcelRegister("kKR0X", function(module, exports) {
/**
 * Type definitions for Outbound Auth service responses
 *
 * These types mirror the response models from the outbound-auth service.
 * Source of truth: https://bitbucket.org/atlassian/outbound-auth/
 * Reference implementation: /src/service/accountManagement.ts
 * API Spec: /docs/content/platform/outbound-auth/swagger.yaml
 */ /**
 * Include fields for controlling what data is returned in account responses
 * Mirrors AtlassianAuthAccount.IncludeFields from outbound-auth service
 */ var $e9dc573f98a366a7$export$9e1d8c9863da0d81 = /*#__PURE__*/ function(IncludeFields) {
    IncludeFields["AccessToken"] = "accessToken";
    IncludeFields["DisplayName"] = "displayName";
    IncludeFields["AaId"] = "aaId";
    IncludeFields["AvatarUrl"] = "avatarUrl";
    IncludeFields["ExternalAccountId"] = "externalAccountId";
    IncludeFields["Expiry"] = "expiry";
    return IncludeFields;
}({});
class $e9dc573f98a366a7$export$7f02dcf7cf9277d8 extends Error {
    constructor(message){
        super(message);
        this.name = 'OutboundAuthApiError';
    }
}
module.exports["OutboundAuthApiError"] = $e9dc573f98a366a7$export$7f02dcf7cf9277d8;

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("7yn0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4ri4I = parcelRequire("4ri4I");


var $58PBI = parcelRequire("58PBI");

const $41894bf31b7b5c77$export$c6419170331da813 = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, editSource: t1 } = t0;
    const editSource = t1 === undefined ? "" : t1;
    const preloader = (0, $cozmU.useContext)((0, $58PBI.EditContentButtonPreloaderContext));
    const [doPreload, setDoPreload] = (0, $cozmU.useState)(false);
    const [t2, t3] = (0, $4ri4I.useEditSource)();
    const { editSource: contextEditSource } = t2;
    const { setEditSource: setEditSource } = t3;
    let t4;
    if ($[0] !== editSource || $[1] !== setEditSource) {
        t4 = ()=>{
            setEditSource(editSource);
            setDoPreload(true);
        };
        $[0] = editSource;
        $[1] = setEditSource;
        $[2] = t4;
    } else t4 = $[2];
    const onHover = t4;
    let t5;
    if ($[3] !== children || $[4] !== onHover) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, children);
        $[3] = children;
        $[4] = onHover;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contextEditSource || $[7] !== doPreload || $[8] !== editSource || $[9] !== preloader) {
        t6 = editSource === contextEditSource && doPreload && preloader ? preloader({}) : null;
        $[6] = contextEditSource;
        $[7] = doPreload;
        $[8] = editSource;
        $[9] = preloader;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t5, t6);
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
module.exports["CreateContentButtonPreloader"] = $41894bf31b7b5c77$export$c6419170331da813;

});

parcelRegister("3vzuQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");


var $3Lgno = parcelRequire("3Lgno");


var $eh6Ml = parcelRequire("eh6Ml");


var $aCJyI = parcelRequire("aCJyI");


var $eEPSE = parcelRequire("eEPSE");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");


var $l6ne5 = parcelRequire("l6ne5");

const $fc14e136f8b50026$var$messages = (0, $kSwu1.defineMessages)({
    connect: {
        id: "confluence-account-setup.third-party-connection-item.connect",
        defaultMessage: "Connect"
    },
    tryAgain: {
        id: "confluence-account-setup.third-party-connection-item.try-again",
        defaultMessage: "Try again"
    },
    failedToConnect: {
        id: "confluence-account-setup.third-party-connection-item.failed-to-connect",
        defaultMessage: "Failed to connect"
    },
    connected: {
        id: "confluence-account-setup.third-party-connection-item.connected",
        defaultMessage: "Connected"
    }
});
const $fc14e136f8b50026$var$styles = {
    errorRow: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    iconTile: "_0bjKvDKTcp _0hPCNLDIqT _0KLXruDMqu _3iDTPbQ4SZ _3YEZNOdnbC _0jFU0VUF4f _37wbyuDIqT _39xV02UF4f",
    marginAuto: "_2XsHFMIZbP"
};
const $fc14e136f8b50026$export$e4993e229030740d = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { connectorInfo: connectorInfo, isPrimaryButton: isPrimaryButton = false, onConnect: onConnect, onConnected: onConnected, screenName: screenName = 'thirdPartyConnector', showIconTile: showIconTile = false, touchpoint: touchpoint } = props;
    const { fireUIAnalyticEvent: fireUIAnalyticEvent, fireTrackAnalyticEvent: fireTrackAnalyticEvent, fireOperationalAnalyticEvent: fireOperationalAnalyticEvent } = (0, $l6ne5.useFireAnalyticsEvent)(screenName); // Initialise from ground-truth `isAuthenticated` so providers the user is
    // already connected to render the "Connected" lozenge on first paint,
    // instead of a misleading "Connect" CTA. The full fix (hiding already-
    // connected providers from the list entirely) is tracked in CCCEMAU-2984.
    const [status, setStatus] = (0, $cozmU.useState)(connectorInfo.isAuthenticated ? 'success' : 'idle');
    const iconElement = connectorInfo.icon?.({
        label: connectorInfo.displayName,
        size: 'medium'
    });
    const displayName = connectorInfo.displayName;
    const toolType = connectorInfo.productKey;
    const connectButtonStyle = (0, $cozmU.useMemo)(()=>status === 'error' || isPrimaryButton ? undefined : {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            '--ds-background-brand-bold': "var(--ds-background-success-bold, #5B7F24)",
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            '--ds-background-brand-bold-hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            '--ds-background-brand-bold-pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
            backgroundColor: "var(--ds-background-success-bold, #5B7F24)",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }, [
        isPrimaryButton,
        status
    ]);
    const handleConnect = async ()=>{
        const ctaType = status === 'error' ? 'tryAgain' : 'connect';
        fireUIAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartlinkConnect',
            attributes: {
                ctaType: ctaType,
                touchpoint: touchpoint,
                toolType: toolType
            }
        });
        fireTrackAnalyticEvent({
            action: 'authStarted',
            actionSubject: 'applicationAccount'
        });
        setStatus('loading');
        try {
            if (onConnect) await onConnect();
            else {
                const authUrl = connectorInfo.authUrl;
                if (!authUrl) throw new Error('No authUrl');
                const width = 600;
                const height = 800;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;
                const features = `width=${width},height=${height},left=${left},top=${top},status=no,resizable=yes,scrollbars=yes`;
                await (0, $eEPSE.auth)(authUrl, features);
            }
            setStatus('success');
            fireTrackAnalyticEvent({
                action: 'connected',
                actionSubject: 'smartLinkConnectButton',
                attributes: {
                    touchpoint: touchpoint,
                    toolType: toolType
                }
            });
            fireOperationalAnalyticEvent({
                action: 'connectSucceeded',
                actionSubject: 'smartLink'
            });
            onConnected?.();
        } catch (error) {
            setStatus('error');
            fireTrackAnalyticEvent({
                action: 'failed',
                actionSubject: 'smartLinkConnectButton',
                attributes: {
                    touchpoint: touchpoint,
                    toolType: toolType
                }
            });
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.150"
    }, showIconTile && iconElement ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $fc14e136f8b50026$var$styles.iconTile
    }, iconElement) : iconElement, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, displayName)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fc14e136f8b50026$var$styles.marginAuto)
    }, status === 'success' ? /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
        appearance: "success",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml)))
    }, formatMessage($fc14e136f8b50026$var$messages.connected)) : /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, status === 'error' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fc14e136f8b50026$var$styles.errorRow)
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Lgno))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.danger"
    }, formatMessage($fc14e136f8b50026$var$messages.failedToConnect))), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: isPrimaryButton ? 'primary' : 'default',
        isLoading: status === 'loading',
        onClick: handleConnect,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        UNSAFE_style: connectButtonStyle
    }, status === 'error' ? formatMessage($fc14e136f8b50026$var$messages.tryAgain) : formatMessage($fc14e136f8b50026$var$messages.connect)))));
};
module.exports["ThirdPartyConnector"] = $fc14e136f8b50026$export$e4993e229030740d;

});

parcelRegister("3Lgno", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0a03a6bc639cf3b22e27ee58ba17af6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bd276e390ee881b$var$_react = $2bd276e390ee881b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2bd276e390ee881b$var$_iconNew = $2bd276e390ee881b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2bd276e390ee881b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowDanger".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/status-workflow-danger
 * Usage guidance:
 * Reserved for representing statuses that signal critical issues that demand attention
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bd276e390ee881b$var$StatusWorkflowDangerIcon = (props)=>/*#__PURE__*/ $2bd276e390ee881b$var$_react.default.createElement($2bd276e390ee881b$var$_iconNew.default, Object.assign({
        name: "StatusWorkflowDangerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-7V9h1.5V3.5z" clip-rule="evenodd"/>`
    }, props));
$2bd276e390ee881b$var$StatusWorkflowDangerIcon.displayName = 'StatusWorkflowDangerIcon';
var $2bd276e390ee881b$var$_default = module.exports.default = $2bd276e390ee881b$var$StatusWorkflowDangerIcon;

});

parcelRegister("l6ne5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $dEZ8Q = parcelRequire("dEZ8Q");


var $a2puN = parcelRequire("a2puN");

const $6088849a8d369ddc$export$eed8c476984ddfad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (source)=>{
    const $ = (0, $bDgLe.c)(5);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = (eventType)=>(payload)=>{
                const analyticsEvent = createAnalyticsEvent({
                    ...payload,
                    eventType: eventType,
                    source: source
                });
                analyticsEvent.fire((0, $dEZ8Q.ANALYTICS_CHANNEL));
            };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
    } else t0 = $[2];
    const fireAnalyticEvent = t0;
    let t1;
    if ($[3] !== fireAnalyticEvent) {
        t1 = {
            fireUIAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).UI),
            fireTrackAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).TRACK),
            fireOperationalAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).OPERATIONAL),
            fireScreenAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).SCREEN)
        };
        $[3] = fireAnalyticEvent;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticEvent = (eventType)=>(payload)=>{
            const analyticsEvent = createAnalyticsEvent({
                ...payload,
                eventType: eventType,
                source: source
            });
            analyticsEvent.fire((0, $dEZ8Q.ANALYTICS_CHANNEL));
        };
    return {
        fireUIAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).UI),
        fireTrackAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).TRACK),
        fireOperationalAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).OPERATIONAL),
        fireScreenAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).SCREEN)
    };
};
module.exports["useFireAnalyticsEvent"] = $6088849a8d369ddc$export$eed8c476984ddfad;

});

parcelRegister("dEZ8Q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l7jo6 = parcelRequire("l7jo6");


var $NF6kd = parcelRequire("NF6kd");


var $3d3WW = parcelRequire("3d3WW");

const $1ae0090018311f9c$export$85183a312807388d = 'accountSetup';
const $1ae0090018311f9c$var$isSSR = ()=>typeof window === 'undefined' || typeof document === 'undefined';
const $1ae0090018311f9c$export$1b581a2ec13e37f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, analyticsData: analyticsData, analyticsClient: t1 } = t0;
    const providedAnalyticsClient = t1 === undefined ? null : t1;
    const { product: product, cloudId: cloudId, userId: userId, additionalAttributes: additionalAttributes } = analyticsData;
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(null);
    let t2;
    if ($[0] !== additionalAttributes || $[1] !== analyticsClient || $[2] !== product) {
        t2 = (t3)=>{
            const { payload: payload } = t3;
            analyticsClient?.onEvent?.($1ae0090018311f9c$export$85183a312807388d, {
                ...payload,
                attributes: {
                    ...additionalAttributes,
                    ...payload?.attributes,
                    product: product
                }
            });
        };
        $[0] = additionalAttributes;
        $[1] = analyticsClient;
        $[2] = product;
        $[3] = t2;
    } else t2 = $[3];
    const defaultOnEvent = t2;
    let t3;
    if ($[4] !== additionalAttributes || $[5] !== product) {
        t3 = (event)=>{
            event.update((payload_0)=>({
                    ...payload_0,
                    attributes: {
                        ...additionalAttributes,
                        ...payload_0?.attributes,
                        product: product
                    }
                }));
        };
        $[4] = additionalAttributes;
        $[5] = product;
        $[6] = t3;
    } else t3 = $[6];
    const wacUpdateEvent = t3;
    const onEvent = product === "marketing" ? wacUpdateEvent : defaultOnEvent;
    let t4;
    let t5;
    if ($[7] !== cloudId || $[8] !== product || $[9] !== providedAnalyticsClient || $[10] !== userId) {
        t4 = ()=>{
            if (!$1ae0090018311f9c$var$isSSR()) setAnalyticsClient($1ae0090018311f9c$export$e9ba7ef9458d1a4a({
                product: product,
                cloudId: cloudId,
                userId: userId,
                analyticsClient: providedAnalyticsClient
            }));
        };
        t5 = [
            product,
            cloudId,
            userId,
            setAnalyticsClient,
            providedAnalyticsClient
        ];
        $[7] = cloudId;
        $[8] = product;
        $[9] = providedAnalyticsClient;
        $[10] = userId;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if ($1ae0090018311f9c$var$isSSR() || !analyticsClient) {
        let t6;
        if ($[13] !== children) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[13] = children;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    let t6;
    if ($[15] !== children || $[16] !== onEvent) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: $1ae0090018311f9c$export$85183a312807388d,
            onEvent: onEvent
        }, children);
        $[15] = children;
        $[16] = onEvent;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ children: children, analyticsData: analyticsData, analyticsClient: providedAnalyticsClient = null })=>{
    const { product: product, cloudId: cloudId, userId: userId, additionalAttributes: additionalAttributes } = analyticsData;
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(null);
    const defaultOnEvent = (0, $cozmU.useCallback)(({ payload: payload })=>{
        analyticsClient?.onEvent?.($1ae0090018311f9c$export$85183a312807388d, {
            ...payload,
            attributes: {
                ...additionalAttributes,
                ...payload?.attributes,
                product: product
            }
        });
    }, [
        analyticsClient,
        additionalAttributes,
        product
    ]);
    const wacUpdateEvent = (0, $cozmU.useCallback)((event)=>{
        event.update((payload_0)=>({
                ...payload_0,
                attributes: {
                    ...additionalAttributes,
                    ...payload_0?.attributes,
                    product: product
                }
            }));
    }, [
        product,
        additionalAttributes
    ]);
    //When calling this from WAC, we see the event is fired twice.
    //Therefore, we are checking if the product is marketing to call the updateEvent,
    //which does not seem to be working in AFM when used.
    const onEvent = product === 'marketing' ? wacUpdateEvent : defaultOnEvent;
    (0, $cozmU.useEffect)(()=>{
        //  Only setup analytics client for SPA rendering since analytics requires window to be defined
        if (!$1ae0090018311f9c$var$isSSR()) setAnalyticsClient($1ae0090018311f9c$export$e9ba7ef9458d1a4a({
            product: product,
            cloudId: cloudId,
            userId: userId,
            analyticsClient: providedAnalyticsClient
        }));
    }, [
        product,
        cloudId,
        userId,
        setAnalyticsClient,
        providedAnalyticsClient
    ]);
    if ($1ae0090018311f9c$var$isSSR() || !analyticsClient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: $1ae0090018311f9c$export$85183a312807388d,
        onEvent: onEvent
    }, children);
};
// Define default analytic-web-client environment config for now
const $1ae0090018311f9c$var$getAnalyticsEnv = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $l7jo6.envType).LOCAL;
    //  Confluence staging has jira-dev, WAC staging has stg
    if (hostname.includes('jira-dev') || hostname.includes('stg')) return (0, $l7jo6.envType).STAGING;
    return (0, $l7jo6.envType).PROD;
};
const $1ae0090018311f9c$export$e9ba7ef9458d1a4a = ({ product: product, cloudId: cloudId, userId: userId, analyticsClient: analyticsClient })=>{
    const client = analyticsClient ?? new (0, $NF6kd.default)({
        product: product,
        env: $1ae0090018311f9c$var$getAnalyticsEnv(window.location.hostname),
        origin: (0, $l7jo6.originType).WEB
    });
    if (cloudId) client.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
    if (userId) client.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, userId);
    return client;
};
module.exports["ANALYTICS_CHANNEL"] = $1ae0090018311f9c$export$85183a312807388d;
module.exports["AnalyticsProvider"] = $1ae0090018311f9c$export$1b581a2ec13e37f1;

});

parcelRegister("a2puN", function(module, exports) {
var $ec7536ddbfdf8034$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
module.exports["EVENT_TYPE"] = $ec7536ddbfdf8034$export$76a2e4c433c23bb9;

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("5HIxb"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("5HIxb", function(module, exports) {

let $42738378740a654a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $42738378740a654a$var$load("1audf"),
    $42738378740a654a$var$load("bpBPu"),
    $42738378740a654a$var$load("1cQg7"),
    $42738378740a654a$var$load("4aKct"),
    $42738378740a654a$var$load("hhss7"),
    $42738378740a654a$var$load("5gsbh"),
    $42738378740a654a$var$load("gs8si")
]).then(()=>parcelRequire('iaA9H'));

});

parcelRegister("BHGIm", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2d7c1ebdd99982dc$var$initialState = {
    isOpen: false
};
const $2d7c1ebdd99982dc$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
const $2d7c1ebdd99982dc$var$store = (0, $8s9DV.createStore)({
    initialState: $2d7c1ebdd99982dc$var$initialState,
    actions: $2d7c1ebdd99982dc$var$actions,
    name: 'trialPlanComparisonModalStore'
});
const $2d7c1ebdd99982dc$export$9babf328a7e7b769 = (0, $kBr4q.createActionsHook)($2d7c1ebdd99982dc$var$store);
const $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e = (0, $kBr4q.createHook)($2d7c1ebdd99982dc$var$store);
module.exports["useTrialPlanComparisonModalActions"] = $2d7c1ebdd99982dc$export$9babf328a7e7b769;
module.exports["useTrialPlanComparisonModal"] = $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e;

});

parcelRegister("9B4kz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");


var $kCXmK = parcelRequire("kCXmK");


var $4hvYT = parcelRequire("4hvYT");


var $jAOzg = parcelRequire("jAOzg");


var $7TqMU = parcelRequire("7TqMU");

const $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SUCCESS = 'success';
const $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_FAILED = 'failed';
const $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SKIPPED_TTL = 'skippedTtl';
const $5a800d6d1cd2f48a$var$SMART_FOLDER_ANALYTICS_SOURCE = 'smartFolder';
const $5a800d6d1cd2f48a$var$getAutoSyncResult = ({ errors: errors, success: success })=>{
    const wasSkippedDueToTtl = errors?.some(({ message: message })=>message?.toLowerCase().includes('ttl')) ?? false;
    if (success && wasSkippedDueToTtl) return $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SKIPPED_TTL;
    return success ? $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SUCCESS : $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_FAILED;
};
const $5a800d6d1cd2f48a$export$f90756b916c77239 = (options)=>{
    const { onSyncComplete: onSyncComplete, triggerSurface: triggerSurface = 'folderView', journeyId: journeyId, provider: provider = 'unknown', containerApp: containerApp, isSyncPaused: isSyncPaused = false } = options ?? {};
    const { syncSmartFolder: syncSmartFolder, loading: loading } = (0, $kCXmK.useSyncSmartFolder)();
    const { addSyncingFolder: addSyncingFolder, removeSyncingFolder: removeSyncingFolder } = (0, $jAOzg.useFolderSyncActions)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const syncingFolderRef = (0, $cozmU.useRef)(null);
    const statusRef = (0, $cozmU.useRef)('idle');
    const retryCountByFolderRef = (0, $cozmU.useRef)(new Map());
    const [syncErrorState, setSyncErrorState] = (0, $cozmU.useState)(null);
    // Derive a simple status from the mutation state + our local tracking
    const status = loading ? 'syncing' : statusRef.current;
    const fireAutoSyncAnalytics = (0, $cozmU.useCallback)(({ durationMs: durationMs, folderId: folderId, isRetry: isRetry, result: result, retryCount: retryCount, sourceSurface: sourceSurface, success: success, syncErrorType: syncErrorType })=>{
        const now = Date.now();
        const journeyAttribute = journeyId ? {
            journeyId: journeyId
        } : {};
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: $5a800d6d1cd2f48a$var$SMART_FOLDER_ANALYTICS_SOURCE,
                action: 'completed',
                actionSubject: 'smartFolderAutoSync',
                attributes: {
                    folderId: folderId,
                    provider: provider,
                    containerApp: containerApp ?? 'unknown',
                    triggerSurface: triggerSurface,
                    sourceSurface: sourceSurface,
                    result: result,
                    durationMs: durationMs,
                    ...journeyAttribute
                }
            }
        }).fire();
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: $5a800d6d1cd2f48a$var$SMART_FOLDER_ANALYTICS_SOURCE,
                action: 'completed',
                actionSubject: 'smartFolderRecoverableSync',
                attributes: {
                    ...(0, $4hvYT.getRecoverableSyncAnalyticsAttributes)({
                        containerApp: containerApp,
                        durationMs: durationMs,
                        folderId: folderId,
                        isRetry: isRetry,
                        now: now,
                        provider: provider,
                        retryCount: retryCount,
                        sourceSurface: sourceSurface,
                        success: success,
                        syncErrorType: syncErrorType
                    }),
                    ...journeyAttribute
                }
            }
        }).fire();
    }, [
        createEvent,
        journeyId,
        provider,
        triggerSurface,
        containerApp
    ]);
    const triggerSync = (0, $cozmU.useCallback)((folderId, triggerOptions)=>{
        if (isSyncPaused) return;
        // De-duplicate: don't fire another request if we're already syncing this folder
        if (syncingFolderRef.current === folderId) return;
        const startedAt = Date.now();
        syncingFolderRef.current = folderId;
        statusRef.current = 'syncing';
        setSyncErrorState(null);
        addSyncingFolder(folderId);
        const { force: force, sourceSurface: sourceSurface = force ? 'manual-retry' : 'folder-view-auto-sync' } = triggerOptions ?? {};
        const isRetry = Boolean(force);
        const retryCount = isRetry ? (retryCountByFolderRef.current.get(folderId) ?? 0) + 1 : undefined;
        if (retryCount !== undefined) retryCountByFolderRef.current.set(folderId, retryCount);
        syncSmartFolder({
            folderId: folderId,
            ...force !== undefined ? {
                force: force
            } : {},
            syncTrigger: force ? 'MANUAL' : 'AUTO'
        }).then((result)=>{
            const payload = result?.data?.confluence_syncSmartFolder;
            const success = payload?.success ?? false;
            const syncResult = $5a800d6d1cd2f48a$var$getAutoSyncResult({
                errors: payload?.errors,
                success: success
            });
            const syncErrorType = (0, $4hvYT.getSyncErrorType)(payload?.errors);
            statusRef.current = syncResult === 'success' ? 'success' : 'error';
            fireAutoSyncAnalytics({
                durationMs: Date.now() - startedAt,
                folderId: folderId,
                isRetry: isRetry,
                result: syncResult,
                retryCount: retryCount,
                sourceSurface: sourceSurface,
                success: success,
                syncErrorType: syncErrorType
            });
            if (syncResult === $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SUCCESS) onSyncComplete?.();
            else {
                // Prefer a mapped BE error state, but show generic retry UI for failed
                // mutation responses that do not include a FE-known errorType.
                const structuredErrorState = typeof syncErrorType === 'string' ? (0, $7TqMU.getSyncErrorState)(syncErrorType) : null;
                const fallbackErrorState = syncResult === $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_FAILED ? (0, $7TqMU.SmartFolderErrorState).SyncTransientError : null;
                setSyncErrorState(structuredErrorState ?? fallbackErrorState);
            }
        }).catch(()=>{
            statusRef.current = 'error';
            fireAutoSyncAnalytics({
                durationMs: Date.now() - startedAt,
                folderId: folderId,
                isRetry: isRetry,
                result: 'failed',
                retryCount: retryCount,
                sourceSurface: sourceSurface,
                success: false
            });
        }).finally(()=>{
            const finishedId = syncingFolderRef.current;
            syncingFolderRef.current = null;
            if (finishedId) removeSyncingFolder(finishedId);
            statusRef.current = 'idle';
        });
    }, [
        syncSmartFolder,
        addSyncingFolder,
        fireAutoSyncAnalytics,
        isSyncPaused,
        onSyncComplete,
        removeSyncingFolder
    ]);
    return {
        triggerSync: triggerSync,
        status: status,
        syncErrorState: syncErrorState
    };
};
module.exports["useSmartFolderSync"] = $5a800d6d1cd2f48a$export$f90756b916c77239;

});

parcelRegister("3fBqY", function(module, exports) {
const $13dafddd01cc0e12$export$c447f2d04f7089f6 = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
module.exports["isAtlassianStaff"] = $13dafddd01cc0e12$export$c447f2d04f7089f6;

});

parcelRegister("hnPRk", function(module, exports) {

var $46Ns8 = parcelRequire("46Ns8");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/long-running-task/manifest.ts
var $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $46Ns8.ConfluenceLongRunningTaskAriResourceOwner),
    resourceType: (0, $46Ns8.ConfluenceLongRunningTaskAriResourceType),
    resourceIdSlug: "activation/{activationId}/{taskId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        taskId: /[0-9]+/
    }
};
// src/confluence/long-running-task/index.ts
var $ca7ccfc549c7b37a$export$ebd9af01759f4a9a = class _ConfluenceLongRunningTaskAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get taskId() {
        return this._taskId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts.qualifier,
            platformQualifier: $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts.resourceOwner,
            resourceType: $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.taskId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                taskId: opts.taskId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $ca7ccfc549c7b37a$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            taskId: this.taskId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._taskId = opts.resourceIdSegmentValues.taskId;
    }
};
module.exports["ConfluenceLongRunningTaskAri"] = $ca7ccfc549c7b37a$export$ebd9af01759f4a9a;

});

parcelRegister("46Ns8", function(module, exports) {
// src/confluence/long-running-task/types.ts
var $2fde1544dc20178b$export$c3f2be88215e7f96 = "confluence", $2fde1544dc20178b$export$d803f499be36f7e2 = "long-running-task";
module.exports["ConfluenceLongRunningTaskAriResourceOwner"] = $2fde1544dc20178b$export$c3f2be88215e7f96;
module.exports["ConfluenceLongRunningTaskAriResourceType"] = $2fde1544dc20178b$export$d803f499be36f7e2;

});

parcelRegister("bnxm6", function(module, exports) {
/**
 * @generated SignedSource<<815a7eec5b335100e928f1957d431d68>>
 * @relayHash 50ebcdd0474c653398920de0204e0d3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b43ca842fc02bd31386938e87cdca2d5726a7e55f51bece2c77eb96a4972c339
const $0598d1e099a39fc5$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "HelpPanelQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "HelpPanelQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "50ebcdd0474c653398920de0204e0d3d",
            "id": "b43ca842fc02bd31386938e87cdca2d5726a7e55f51bece2c77eb96a4972c339",
            "metadata": {},
            "name": "HelpPanelQuery",
            "operationKind": "query",
            "text": "query HelpPanelQuery{user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary}}}"
        }
    };
}();
$0598d1e099a39fc5$var$node.hash = "0ed6e0fbff1bd8304e19c670d1c755dc";
var $0598d1e099a39fc5$export$2e2bcd8739ae039 = $0598d1e099a39fc5$var$node;
module.exports["default"] = $0598d1e099a39fc5$export$2e2bcd8739ae039;

});

parcelRegister("14QAi", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $jH9cM.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

parcelRegister("bQIml", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $3dacbbeae0d408d7$export$dc5d1c021e0a8741 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "oTpkC",
    name: "KeyboardShortcutsDialog",
    loader: async ()=>{
        return (await (parcelRequire("h33IR"))).KeyboardShortcutsDialog;
    }
});
module.exports["KeyboardShortcutsDialog"] = $3dacbbeae0d408d7$export$dc5d1c021e0a8741;

});

parcelRegister("h33IR", function(module, exports) {

let $c6959ab8b4f774dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c6959ab8b4f774dd$var$load("kHXvF"),
    $c6959ab8b4f774dd$var$load("7EorR"),
    $c6959ab8b4f774dd$var$load("3WCRn")
]).then(()=>parcelRequire('cIjy3'));

});

parcelRegister("hjhCz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4367945ac32e8223$export$b878bc0015f3472e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LVIQc",
    name: "LazyAddPersonalSpaceDialog",
    loader: async ()=>(await (parcelRequire("b8Gga"))).AddPersonalSpaceDialog
});
module.exports["LazyAddPersonalSpaceDialog"] = $4367945ac32e8223$export$b878bc0015f3472e;

});

parcelRegister("b8Gga", function(module, exports) {

let $81c138f923859a59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $81c138f923859a59$var$load("iWnyc"),
    $81c138f923859a59$var$load("hhss7"),
    $81c138f923859a59$var$load("Wowvf"),
    $81c138f923859a59$var$load("4AAsh")
]).then(()=>parcelRequire('YvPDh'));

});

parcelRegister("3Ydx7", function(module, exports) {
const $060ced86ed2d012d$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Loom: 'loom'
};
module.exports["PrimaryProductKeys"] = $060ced86ed2d012d$export$15d12effc8830544;

});

parcelRegister("l4LD3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hAgam = parcelRequire("hAgam");

const $c4e2abd0d3e7769c$export$82eafebb825fc23f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { isExpanded: isExpanded, theme: theme, primaryColor: t1, label: t2 } = t0;
    const primaryColor = t1 === undefined ? "var(--ds-text, #292A2E)" : t1;
    const label = t2 === undefined ? "" : t2;
    const t3 = isExpanded ? primaryColor : theme.default.color;
    let t4;
    if ($[0] !== label || $[1] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: label,
            color: t3
        });
        $[0] = label;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    return t4;
} : ({ isExpanded: isExpanded, theme: theme, primaryColor: primaryColor = "var(--ds-text, #292A2E)", label: label = '' })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });
module.exports["SearchIcon"] = $c4e2abd0d3e7769c$export$82eafebb825fc23f;

});

parcelRegister("e9sgo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lYpJw = parcelRequire("lYpJw");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $51e9fb97eafda91b$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)",
            borderColor: "var(--ds-border-input, #8C8F97)",
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: "var(--ds-icon-subtle, #505258)"
        },
        focus: {
            borderColor: "var(--ds-border-focused, #4688EC)",
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-input, #8C8F97)"}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
        }
    }
};
const $51e9fb97eafda91b$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $51e9fb97eafda91b$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))({}, $51e9fb97eafda91b$export$e6c62eb05a8288ed.default, searchCSS);
};
const $51e9fb97eafda91b$var$ctx = /*#__PURE__*/ (0, $cozmU.createContext)($51e9fb97eafda91b$export$e6c62eb05a8288ed.default);
const $51e9fb97eafda91b$export$d8964aec282183a3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { value: value, partialSearchCSS: partialSearchCSS, children: children } = t0;
    const t1 = partialSearchCSS || value;
    let t2;
    if ($[0] !== t1) {
        t2 = $51e9fb97eafda91b$var$getTheme(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const theme = t2;
    let t3;
    if ($[2] !== children || $[3] !== theme) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)($51e9fb97eafda91b$var$ctx.Provider, {
            value: theme,
            children: children
        });
        $[2] = children;
        $[3] = theme;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $51e9fb97eafda91b$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($51e9fb97eafda91b$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $51e9fb97eafda91b$export$93d4e7f90805808f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($51e9fb97eafda91b$var$ctx);
} : ()=>{
    return (0, $cozmU.useContext)($51e9fb97eafda91b$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $51e9fb97eafda91b$export$f9bb738f552c610d = $51e9fb97eafda91b$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $51e9fb97eafda91b$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};
module.exports["ThemeProvider"] = $51e9fb97eafda91b$export$d8964aec282183a3;
module.exports["useTheme"] = $51e9fb97eafda91b$export$93d4e7f90805808f;

});

parcelRegister("dvVWp", function(module, exports) {
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $iDrrr = parcelRequire("iDrrr");


var $hGRCq = parcelRequire("hGRCq");


var $fR63l = parcelRequire("fR63l");


var $cEDkb = parcelRequire("cEDkb");


// oxlint-disable-next-line eslint/no-redeclare
const $dfd1fdff8b6b356e$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    CustomerServiceManagement: 'jira-customer-service',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $dfd1fdff8b6b356e$export$252aae15ddb3591c = {
    ...$dfd1fdff8b6b356e$var$ProductKeys1P,
    Loom: 'loom',
    AtlasGoals: 'goals',
    AtlasProjects: 'projects',
    AtlasTeams: 'teams'
};
const $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c = {
    ...$dfd1fdff8b6b356e$var$ProductKeys1P,
    ...(0, $fR63l.ProductKeys3P)
};
const $dfd1fdff8b6b356e$var$localAllProductKeys = Object.values($dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c);
const $dfd1fdff8b6b356e$export$57043b2770b3924d = Object.values((0, $fR63l.ProductKeys3P));
const $dfd1fdff8b6b356e$export$225f36a2f261b1e7 = Object.values($dfd1fdff8b6b356e$var$ProductKeys1P);
const $dfd1fdff8b6b356e$export$297680dde4e8aef1 = ()=>{
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return 0, $hGRCq.allProductKeys;
    return $dfd1fdff8b6b356e$var$localAllProductKeys;
};
const $dfd1fdff8b6b356e$export$73be91b73ebbdb05 = $dfd1fdff8b6b356e$var$localAllProductKeys;
const $dfd1fdff8b6b356e$export$65f9ab1ba49d5e68 = (key)=>$dfd1fdff8b6b356e$export$225f36a2f261b1e7.includes(key);
const $dfd1fdff8b6b356e$export$ae4856d6227d0649 = (key)=>$dfd1fdff8b6b356e$export$57043b2770b3924d.includes(key);
const $dfd1fdff8b6b356e$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($dfd1fdff8b6b356e$export$297680dde4e8aef1().includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $dfd1fdff8b6b356e$export$ba4f56e768ae6f1e = [
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Confluence,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Jira
];
const $dfd1fdff8b6b356e$export$64c23f2d9ef43822 = [
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Confluence,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Jira,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.CustomerServiceManagement,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Atlas,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Trello,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Bitbucket,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Compass,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Focus,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Assets,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $cEDkb.ProductsOrder3P)
];
const $dfd1fdff8b6b356e$export$1d911f164123ed26 = [
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Github
];
const $dfd1fdff8b6b356e$export$29110d064e1087dd = [
    ...$dfd1fdff8b6b356e$export$1d911f164123ed26,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Bitbucket
];
const $dfd1fdff8b6b356e$export$41ecd101a1ccdccc = [
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Confluence,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Jira,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.CustomerServiceManagement,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Atlas,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Trello,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Bitbucket,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Compass,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Focus,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Talent,
    $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $cEDkb.NewProductsOrder3P)
];
module.exports["ProductKeys1PForAnalytics"] = $dfd1fdff8b6b356e$export$252aae15ddb3591c;
module.exports["ProductKeys"] = $dfd1fdff8b6b356e$export$ef2c0ffddaaaf76c;
module.exports["all3pProductKeys"] = $dfd1fdff8b6b356e$export$57043b2770b3924d;
module.exports["all1pProductKeys"] = $dfd1fdff8b6b356e$export$225f36a2f261b1e7;
module.exports["getAllProductKeys"] = $dfd1fdff8b6b356e$export$297680dde4e8aef1;
module.exports["allProductKeys"] = $dfd1fdff8b6b356e$export$73be91b73ebbdb05;
module.exports["is1pProductKey"] = $dfd1fdff8b6b356e$export$65f9ab1ba49d5e68;
module.exports["is3pProductKey"] = $dfd1fdff8b6b356e$export$ae4856d6227d0649;
module.exports["isProductKey"] = $dfd1fdff8b6b356e$export$2a41a819c1db85b1;
module.exports["productsSupportingEmptyQuery"] = $dfd1fdff8b6b356e$export$ba4f56e768ae6f1e;
module.exports["PRODUCTS_ORDER"] = $dfd1fdff8b6b356e$export$64c23f2d9ef43822;
module.exports["GITHUB_PRODUCT_KEYS"] = $dfd1fdff8b6b356e$export$1d911f164123ed26;
module.exports["CODE_HOST_PRODUCT_KEYS"] = $dfd1fdff8b6b356e$export$29110d064e1087dd;
module.exports["PRODUCTS_ORDER_WITH_3P_BY_POPULARITY"] = $dfd1fdff8b6b356e$export$41ecd101a1ccdccc;

});

parcelRegister("cEDkb", function(module, exports) {
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ 
var $fR63l = parcelRequire("fR63l");

const $6b20b19bc85a48d0$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    (0, $fR63l.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $fR63l.ProductKeys3P).GoogleDrive,
    (0, $fR63l.ProductKeys3P).Sharepoint,
    (0, $fR63l.ProductKeys3P).OneDrive,
    (0, $fR63l.ProductKeys3P).Dropbox,
    (0, $fR63l.ProductKeys3P).Slack,
    (0, $fR63l.ProductKeys3P).Teams,
    (0, $fR63l.ProductKeys3P).Github,
    (0, $fR63l.ProductKeys3P).Figma,
    (0, $fR63l.ProductKeys3P).GoogleCalendar,
    (0, $fR63l.ProductKeys3P).Gmail,
    (0, $fR63l.ProductKeys3P).OutlookCalendar,
    (0, $fR63l.ProductKeys3P).OutlookMail,
    (0, $fR63l.ProductKeys3P).Airtable,
    (0, $fR63l.ProductKeys3P).Smartsheet,
    (0, $fR63l.ProductKeys3P).Asana,
    (0, $fR63l.ProductKeys3P).Zendesk,
    (0, $fR63l.ProductKeys3P).Miro,
    (0, $fR63l.ProductKeys3P).Docusign,
    (0, $fR63l.ProductKeys3P).Lucid,
    (0, $fR63l.ProductKeys3P).Monday,
    (0, $fR63l.ProductKeys3P).AzureDevops,
    (0, $fR63l.ProductKeys3P).Gitlab,
    (0, $fR63l.ProductKeys3P).ConfluenceDC,
    (0, $fR63l.ProductKeys3P).Canva,
    (0, $fR63l.ProductKeys3P).Box,
    (0, $fR63l.ProductKeys3P).Zeplin,
    (0, $fR63l.ProductKeys3P).ServiceNow,
    (0, $fR63l.ProductKeys3P).Freshservice,
    (0, $fR63l.ProductKeys3P).PowerBI,
    (0, $fR63l.ProductKeys3P).ClickUp,
    (0, $fR63l.ProductKeys3P).Amplitude,
    (0, $fR63l.ProductKeys3P).Stripe,
    (0, $fR63l.ProductKeys3P).AdobeXD,
    (0, $fR63l.ProductKeys3P).Aha,
    (0, $fR63l.ProductKeys3P).AdobeSign,
    (0, $fR63l.ProductKeys3P).Mural,
    (0, $fR63l.ProductKeys3P).Webex,
    (0, $fR63l.ProductKeys3P).PagerDuty,
    (0, $fR63l.ProductKeys3P).Pipedrive,
    (0, $fR63l.ProductKeys3P).Dovetail,
    (0, $fR63l.ProductKeys3P).LaunchDarkly,
    (0, $fR63l.ProductKeys3P).Salesforce,
    (0, $fR63l.ProductKeys3P).Sentry,
    (0, $fR63l.ProductKeys3P).Gitbook,
    (0, $fR63l.ProductKeys3P).AWSS3,
    (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
    (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
    (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
    (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
    (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
    (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
    (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
    (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
    (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
    (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
    (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
    (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
    (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
    (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
    (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
    (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
    (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
    (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
    (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
    // New 3P? Add it here
    (0, $fR63l.ProductKeys3P).Databricks,
    (0, $fR63l.ProductKeys3P).Notion,
    (0, $fR63l.ProductKeys3P).Todoist,
    (0, $fR63l.ProductKeys3P).Hubspot,
    (0, $fR63l.ProductKeys3P).Gong,
    (0, $fR63l.ProductKeys3P).Zoom,
    (0, $fR63l.ProductKeys3P).JiraDC,
    (0, $fR63l.ProductKeys3P).JsmDC,
    // Always last
    (0, $fR63l.ProductKeys3P).AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $6b20b19bc85a48d0$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    (0, $fR63l.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $fR63l.ProductKeys3P).GoogleDrive,
    (0, $fR63l.ProductKeys3P).Sharepoint,
    (0, $fR63l.ProductKeys3P).Slack,
    (0, $fR63l.ProductKeys3P).Teams,
    (0, $fR63l.ProductKeys3P).Figma,
    (0, $fR63l.ProductKeys3P).Miro,
    (0, $fR63l.ProductKeys3P).Salesforce,
    (0, $fR63l.ProductKeys3P).Github,
    (0, $fR63l.ProductKeys3P).Gmail,
    (0, $fR63l.ProductKeys3P).Gitlab,
    (0, $fR63l.ProductKeys3P).Lucid,
    (0, $fR63l.ProductKeys3P).Asana,
    (0, $fR63l.ProductKeys3P).AzureDevops,
    (0, $fR63l.ProductKeys3P).GoogleCalendar,
    (0, $fR63l.ProductKeys3P).OneDrive,
    (0, $fR63l.ProductKeys3P).Dropbox,
    (0, $fR63l.ProductKeys3P).OutlookCalendar,
    (0, $fR63l.ProductKeys3P).OutlookMail,
    (0, $fR63l.ProductKeys3P).Airtable,
    (0, $fR63l.ProductKeys3P).Smartsheet,
    (0, $fR63l.ProductKeys3P).Zendesk,
    (0, $fR63l.ProductKeys3P).Docusign,
    (0, $fR63l.ProductKeys3P).Databricks,
    (0, $fR63l.ProductKeys3P).Monday,
    (0, $fR63l.ProductKeys3P).ConfluenceDC,
    (0, $fR63l.ProductKeys3P).Canva,
    (0, $fR63l.ProductKeys3P).Box,
    (0, $fR63l.ProductKeys3P).Zeplin,
    (0, $fR63l.ProductKeys3P).ServiceNow,
    (0, $fR63l.ProductKeys3P).Freshservice,
    (0, $fR63l.ProductKeys3P).PowerBI,
    (0, $fR63l.ProductKeys3P).ClickUp,
    (0, $fR63l.ProductKeys3P).Amplitude,
    (0, $fR63l.ProductKeys3P).Stripe,
    (0, $fR63l.ProductKeys3P).AdobeXD,
    (0, $fR63l.ProductKeys3P).Aha,
    (0, $fR63l.ProductKeys3P).AdobeSign,
    (0, $fR63l.ProductKeys3P).Mural,
    (0, $fR63l.ProductKeys3P).Webex,
    (0, $fR63l.ProductKeys3P).PagerDuty,
    (0, $fR63l.ProductKeys3P).Pipedrive,
    (0, $fR63l.ProductKeys3P).Dovetail,
    (0, $fR63l.ProductKeys3P).LaunchDarkly,
    (0, $fR63l.ProductKeys3P).Sentry,
    (0, $fR63l.ProductKeys3P).Gitbook,
    (0, $fR63l.ProductKeys3P).AWSS3,
    (0, $fR63l.ProductKeys3P).Notion,
    (0, $fR63l.ProductKeys3P).Todoist,
    (0, $fR63l.ProductKeys3P).Hubspot,
    (0, $fR63l.ProductKeys3P).JiraDC,
    (0, $fR63l.ProductKeys3P).JsmDC,
    // New 3P? Add it here
    (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
    (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
    (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
    (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
    (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
    (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
    (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
    (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
    (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
    (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
    (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
    (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
    (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
    (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
    (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
    (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
    (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
    (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
    (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
    (0, $fR63l.ProductKeys3P).Gong,
    (0, $fR63l.ProductKeys3P).Zoom,
    // Always last
    (0, $fR63l.ProductKeys3P).AtlassianWebCrawler
];
const $6b20b19bc85a48d0$export$c36c249aaac5cad0 = {
    assignee: [
        (0, $fR63l.ProductKeys3P).JiraDC,
        (0, $fR63l.ProductKeys3P).JsmDC,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd
    ],
    campaignStatus: [
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    caseStatus: [
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    closeDate: [
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    // TODO: when cleaning up `rovo_fps_enable_sharepoint_content_filter`, add Sharepoint here.
    content: [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).GoogleDrive
    ],
    createdBy: [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    label: [
        (0, $fR63l.ProductKeys3P).ConfluenceDC
    ],
    lastUpdated: [
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $fR63l.ProductKeys3P).Asana,
        (0, $fR63l.ProductKeys3P).AzureDevops,
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).Databricks,
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Gmail,
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $fR63l.ProductKeys3P).JiraDC,
        (0, $fR63l.ProductKeys3P).JsmDC,
        (0, $fR63l.ProductKeys3P).Loom,
        (0, $fR63l.ProductKeys3P).Lucid,
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $fR63l.ProductKeys3P).OutlookMail,
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $fR63l.ProductKeys3P).ServiceNow,
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $fR63l.ProductKeys3P).Zendesk,
        (0, $fR63l.ProductKeys3P).Gong,
        (0, $fR63l.ProductKeys3P).Zoom
    ],
    lastUpdatedBy: [
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    opportunityStatus: [
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    onlyTitleMatch: [
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $fR63l.ProductKeys3P).Asana,
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).Databricks,
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $fR63l.ProductKeys3P).OutlookMail,
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $fR63l.ProductKeys3P).ServiceNow,
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Zendesk,
        (0, $fR63l.ProductKeys3P).Gong,
        (0, $fR63l.ProductKeys3P).Zoom
    ],
    owner: [
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    project: [
        (0, $fR63l.ProductKeys3P).JiraDC,
        (0, $fR63l.ProductKeys3P).JsmDC
    ],
    pullRequestStatus: [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Gitlab
    ],
    repository: [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).Github
    ],
    reviewer: [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).Github
    ],
    slackChannel: [
        (0, $fR63l.ProductKeys3P).Slack
    ],
    space: [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ],
    hasAttachment: [
        (0, $fR63l.ProductKeys3P).Teams
    ],
    // workspaceName is always in ThirdPartyConfigs.filters for Teams (gate controls filterIdOrdering only)
    workspaceName: [
        (0, $fR63l.ProductKeys3P).Teams
    ]
};
module.exports["ProductsOrder3P"] = $6b20b19bc85a48d0$export$cc64d659abc3d135;
module.exports["NewProductsOrder3P"] = $6b20b19bc85a48d0$export$915acbd1d0c0550d;
module.exports["thirdPartyFilterProducts"] = $6b20b19bc85a48d0$export$c36c249aaac5cad0;

});

parcelRegister("lj9HS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aHr8q = parcelRequire("aHr8q");


var $7LSTy = parcelRequire("7LSTy");


var $6dPGs = parcelRequire("6dPGs");

const $1a84df755bb09701$var$COOLDOWN_STORAGE_KEY = 'quick_find_connect_apps_cooldown';
const $1a84df755bb09701$var$MAX_ANIMATIONS_PER_WEEK = 10;
const $1a84df755bb09701$var$DISMISSED_VALUE = 'dismissed';
const $1a84df755bb09701$var$getCurrentWeekKey = ()=>{
    const now = new Date();
    // ISO week-year + ISO week so we don't get an off-by-one across a year boundary
    // (e.g. Jan 1 can fall in the previous year's last ISO week).
    return `${(0, $7LSTy.default)(now)}_w${(0, $aHr8q.default)(now)}`;
};
const $1a84df755bb09701$var$readStore = ()=>{
    const raw = (0, $6dPGs.getLocalStorageItemAsString)($1a84df755bb09701$var$COOLDOWN_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && 'count' in parsed && 'weekKey' in parsed && typeof parsed.count === 'number' && typeof parsed.weekKey === 'string') return parsed;
        return null;
    } catch  {
        // JSON parse error — degrade gracefully.
        return null;
    }
};
const $1a84df755bb09701$var$isDismissed = ()=>{
    return (0, $6dPGs.getLocalStorageItemAsString)($1a84df755bb09701$var$COOLDOWN_STORAGE_KEY) === $1a84df755bb09701$var$DISMISSED_VALUE;
};
const $1a84df755bb09701$var$writeStore = (store)=>{
    try {
        (0, $6dPGs.setLocalStorageItem)($1a84df755bb09701$var$COOLDOWN_STORAGE_KEY, JSON.stringify(store));
    } catch  {
    // Private browsing / storage full / quota exceeded — degrade gracefully
    // (the animation plays anyway; we just lose the count for this attempt).
    }
};
const $1a84df755bb09701$export$92cbac270a4be2e0 = (maxPerWeek = $1a84df755bb09701$var$MAX_ANIMATIONS_PER_WEEK)=>{
    const canAnimate = (0, $cozmU.useCallback)(()=>{
        if ($1a84df755bb09701$var$isDismissed()) return false;
        const weekKey = $1a84df755bb09701$var$getCurrentWeekKey();
        const stored = $1a84df755bb09701$var$readStore();
        if (stored?.weekKey === weekKey && stored.count >= maxPerWeek) return false;
        return true;
    }, [
        maxPerWeek
    ]);
    const recordAnimation = (0, $cozmU.useCallback)(()=>{
        const weekKey = $1a84df755bb09701$var$getCurrentWeekKey();
        const stored = $1a84df755bb09701$var$readStore();
        const count = stored?.weekKey === weekKey ? stored.count + 1 : 1;
        $1a84df755bb09701$var$writeStore({
            weekKey: weekKey,
            count: count
        });
    }, []);
    const dismissPermanently = (0, $cozmU.useCallback)(()=>{
        try {
            (0, $6dPGs.setLocalStorageItem)($1a84df755bb09701$var$COOLDOWN_STORAGE_KEY, $1a84df755bb09701$var$DISMISSED_VALUE);
        } catch  {
        // degrade gracefully
        }
    }, []);
    return {
        canAnimate: canAnimate,
        recordAnimation: recordAnimation,
        dismissPermanently: dismissPermanently
    };
};
module.exports["useConnectAppsCooldown"] = $1a84df755bb09701$export$92cbac270a4be2e0;

});

parcelRegister("blg7q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $af81f9ffe316c2e0$export$69cf3fc83b854da4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AEfs",
    name: "ConversationAssistantNavBarButton",
    loader: async ()=>(await (parcelRequire("3ModZ"))).ConversationAssistantNavBarButton
});
module.exports["ConversationAssistantNavBarButton"] = $af81f9ffe316c2e0$export$69cf3fc83b854da4;

});

parcelRegister("3ModZ", function(module, exports) {

let $2c08a54ee7c01d8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c08a54ee7c01d8c$var$load("hhu66"),
    $2c08a54ee7c01d8c$var$load("54ltV"),
    $2c08a54ee7c01d8c$var$load("2hPbk"),
    $2c08a54ee7c01d8c$var$load("icYyL"),
    $2c08a54ee7c01d8c$var$load("9XFtf"),
    $2c08a54ee7c01d8c$var$load("jYCVY"),
    $2c08a54ee7c01d8c$var$load("1audf"),
    $2c08a54ee7c01d8c$var$load("bpBPu"),
    $2c08a54ee7c01d8c$var$load("bAgF6"),
    $2c08a54ee7c01d8c$var$load("6s3kH"),
    $2c08a54ee7c01d8c$var$load("1lfcO"),
    $2c08a54ee7c01d8c$var$load("a4eWT"),
    $2c08a54ee7c01d8c$var$load("1cQg7"),
    $2c08a54ee7c01d8c$var$load("VXbA1"),
    $2c08a54ee7c01d8c$var$load("aLbuU"),
    $2c08a54ee7c01d8c$var$load("5gsbh"),
    $2c08a54ee7c01d8c$var$load("gM13h")
]).then(()=>parcelRequire('1RPPn'));

});

parcelRegister("4h58X", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cfc94af282513225$export$30b6f3119e1efb3a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CTxwk",
    name: "ConversationAssistantNavBarControllers",
    loader: async ()=>(await (parcelRequire("5OaoH"))).ConversationAssistantNavBarControllers
});
module.exports["ConversationAssistantNavBarControllers"] = $cfc94af282513225$export$30b6f3119e1efb3a;

});

parcelRegister("5OaoH", function(module, exports) {

let $43a9aff8d6219798$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $43a9aff8d6219798$var$load("hhu66"),
    $43a9aff8d6219798$var$load("54ltV"),
    $43a9aff8d6219798$var$load("9XFtf"),
    $43a9aff8d6219798$var$load("jYCVY"),
    $43a9aff8d6219798$var$load("1audf"),
    $43a9aff8d6219798$var$load("bpBPu"),
    $43a9aff8d6219798$var$load("bAgF6"),
    $43a9aff8d6219798$var$load("1lfcO"),
    $43a9aff8d6219798$var$load("1cQg7"),
    $43a9aff8d6219798$var$load("4aKct"),
    $43a9aff8d6219798$var$load("aLbuU"),
    $43a9aff8d6219798$var$load("5gsbh"),
    $43a9aff8d6219798$var$load("gDNld")
]).then(()=>parcelRequire('j3NyU'));

});

parcelRegister("i834V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5nuFe = parcelRequire("5nuFe");


var $ibHYv = parcelRequire("ibHYv");

// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================
/* frontend.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");





var $hekY6 = parcelRequire("hekY6");


var $3EQfi = parcelRequire("3EQfi");


var $enlIM = parcelRequire("enlIM");





var $cXtTj = parcelRequire("cXtTj");

const $20a1e3dd683356f0$export$8ea6555e3e46f620 = 'not-enrolled';
const $20a1e3dd683356f0$var$NON_VARIANT_COHORTS = new Set([
    'control',
    $20a1e3dd683356f0$export$8ea6555e3e46f620
]);
const $20a1e3dd683356f0$export$963cdca6c7580c53 = [
    {
        // https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
        messageTemplateId: 'rovo-extension-install-cta-left-nav',
        statsigExperiment: 'rovo-ext_left_nav_rovo_extension_cta',
        statsigParameterName: 'cohort',
        statsigTestCohortPredicate: (experimentValue)=>!$20a1e3dd683356f0$var$NON_VARIANT_COHORTS.has(experimentValue),
        shouldProceedToStatsigEvaluation: ()=>{
            if (typeof navigator === 'undefined') return false;
            const userAgent = navigator.userAgent || '';
            return userAgent.indexOf('Chrome') >= 0;
        }
    }
];


const $a2042fb57734ba2e$var$placementConfig = {
    placementId: 'confluence-side-nav',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
};
const $a2042fb57734ba2e$var$createFrontend = (0, $3EQfi.createPlacementFrontend)($a2042fb57734ba2e$var$placementConfig); // Props passed from Product to Placement
const $a2042fb57734ba2e$var$confluenceSideNavStyles = null;
const $a2042fb57734ba2e$var$SORTED_MESSAGE_KEYS = [
    'MCP_SETUP_NUDGE',
    'CONNECT_3P_TOOLS_NUDGE',
    'CREATE_WITH_ROVO_NUDGE',
    'CREATE_SPACE',
    'CREATE_PAGE',
    'CREATE_WHITEBOARD',
    '1_ON_1_LOOM_NUDGE',
    'LOOM_AI_MEETING_NOTES',
    (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY),
    'RESURRECTED_USER_NUDGE',
    'ROVO_EXTENSION_CTA'
];
const $a2042fb57734ba2e$var$TEMPLATE_XFLOW_GATE = 'twcg-2112-twc-xflow-conf-pages-templates-gate'; // https://switcheroo.atlassian.com/ui/experiments/f8662096-126f-4459-99cf-434e40634bfa/key/recent-churn-discount-experiment
// Checked when choosing the displayed message rather than via EXPERIMENTAL_MESSAGES, so control
// users never see the offer even when po_enable_confluence-side-nav-exp-messages is off.
// TODO: temporary until the experiment ends
const $a2042fb57734ba2e$var$RECENT_DOWNGRADE_DISCOUNT_TEMPLATE_ID = 'recent-downgrade-discount';
const $a2042fb57734ba2e$var$RECENT_DOWNGRADE_DISCOUNT_EXPERIMENT = 'recent-churn-discount-experiment';
const $a2042fb57734ba2e$var$getMessageSortKey = (message)=>{
    // @ts-expect-error Property 'experimentKey' does not exist on type 'BackendMessageBody<SerializableRecord>'
    if (message.experimentKey === (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY)) return 0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY;
     // @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
    return message.nextBestActionType;
}; // todo: Resolve backend ordering incorrectly
const $a2042fb57734ba2e$var$sortMessages = (messages = [])=>{
    return [
        ...messages
    ].sort((a, b)=>{
        return $a2042fb57734ba2e$var$SORTED_MESSAGE_KEYS.indexOf($a2042fb57734ba2e$var$getMessageSortKey(a)) - $a2042fb57734ba2e$var$SORTED_MESSAGE_KEYS.indexOf($a2042fb57734ba2e$var$getMessageSortKey(b));
    });
};
const $a2042fb57734ba2e$export$55486c2b6964dcf2 = $a2042fb57734ba2e$var$createFrontend((Messages)=>({ preloadedInitialData: preloadedInitialData, onDismiss: onDismiss, onSideNavClick: onSideNavClick, onCallback: onCallback, flags: flags, currentRoute: currentRoute })=>{
        const [{ messages: messages, status: status }, setMessageState] = (0, $cozmU.useState)(()=>{
            if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
                status: 'done',
                messages: $a2042fb57734ba2e$var$getMessages(preloadedInitialData?.messages)
            } : {
                messages: undefined,
                status: 'done'
            };
            return {
                messages: undefined,
                status: 'loading'
            };
        });
        const context = (0, $ibHYv.usePostOfficeSideNavMessages)();
        const isDone = status === 'done';
        const { data: data, error: error, isLoading: isLoading } = (0, $enlIM.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !isDone,
                updateKey: 'confluence-side-nav'
            }
        });
        const handleOnDismissed = (0, $cozmU.useCallback)(()=>{
            // no more messages until the next fetch
            onDismiss({
                messages: []
            });
            setMessageState({
                messages: undefined,
                status: 'done'
            });
        }, [
            onDismiss
        ]);
        const handleOnSideNavClick = (0, $cozmU.useCallback)((nextBestActionType)=>{
            // display the next message
            setMessageState((prevState)=>{
                if (prevState.messages) {
                    const newMessages = prevState.messages.slice(1);
                    onSideNavClick(nextBestActionType, {
                        messages: newMessages
                    });
                    return {
                        messages: newMessages,
                        status: 'done'
                    };
                }
                onSideNavClick(nextBestActionType, {
                    messages: []
                });
                return prevState;
            });
        }, [
            onSideNavClick
        ]);
        (0, $cozmU.useEffect)(()=>{
            if (!isLoading && !isDone) setMessageState({
                messages: $a2042fb57734ba2e$var$getMessages(data?.messages),
                status: 'done'
            });
        }, [
            isLoading,
            isDone,
            data
        ]);
        const displayedMessage = (0, $cozmU.useMemo)(()=>{
            if (!messages?.length) return;
            const filteredMessages = messages.filter((message)=>{
                // @ts-expect-error Property 'explicitEnableRequired' does not exist on type 'BackendMessageBody<SerializableRecord>'
                if (message.explicitEnableRequired) {
                    const isTemplateXflowMessage = // @ts-expect-error Property 'experimentKey' does not exist on type 'BackendMessageBody<SerializableRecord>'
                    message.experimentKey === (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY);
                    const explicitMessageKey = isTemplateXflowMessage ? (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY) : // @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
                    message.nextBestActionType;
                    const isExplicitlyEnabled = context?.enabledMessages.includes(explicitMessageKey);
                    if (isTemplateXflowMessage) {
                        // @ts-expect-error Property 'tapReminderTrait' does not exist on type 'BackendMessageBody<SerializableRecord>'
                        const hasReminderTrait = message.tapReminderTrait === 'remind';
                        return (0, $cXtTj.default).checkGate($a2042fb57734ba2e$var$TEMPLATE_XFLOW_GATE) && (hasReminderTrait || isExplicitlyEnabled);
                    }
                    return isExplicitlyEnabled;
                }
                if (message.messageTemplateId === 'rovo-extension-install-cta-left-nav') {
                    // Don't show on FPS to avoid collision with existing install CTA (built outside of PO)
                    if (currentRoute?.includes('/search')) return false;
                }
                return true;
            });
            if (!filteredMessages.length) return;
            const explicitlyEnabledTemplateXflowMessage = context?.enabledMessages.includes((0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY)) ? filteredMessages.find((message)=>// @ts-expect-error Property 'experimentKey' does not exist on type 'BackendMessageBody<SerializableRecord>'
                message.experimentKey === (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY)) : undefined;
            if (explicitlyEnabledTemplateXflowMessage) return {
                message: explicitlyEnabledTemplateXflowMessage
            };
             // The recent downgrade discount is only shown when it's the top message and the site is in
            // the variation cohort, so the experiment exposure is only logged when it would be shown.
            // Otherwise it's dropped and the remaining messages are chosen as usual; it's also dropped
            // when it isn't first, so it can't be shown later without its cohort being checked.
            const [topMessage] = filteredMessages;
            if (topMessage?.messageTemplateId === $a2042fb57734ba2e$var$RECENT_DOWNGRADE_DISCOUNT_TEMPLATE_ID) {
                const recentDowngradeDiscountCohort = (0, $cXtTj.default).getExperimentValue($a2042fb57734ba2e$var$RECENT_DOWNGRADE_DISCOUNT_EXPERIMENT, 'cohort', (0, $20a1e3dd683356f0$export$8ea6555e3e46f620));
                if (recentDowngradeDiscountCohort === 'variation') return {
                    message: topMessage
                };
            }
            const candidateMessages = filteredMessages.filter((message)=>message.messageTemplateId !== $a2042fb57734ba2e$var$RECENT_DOWNGRADE_DISCOUNT_TEMPLATE_ID); // https://switcheroo.atlassian.com/ui/gates/f775d661-abc2-488d-b58c-c28fab9bd58f/key/po_enable_confluence-side-nav-exp-messages
            if ((0, $cXtTj.default).checkGate('po_enable_confluence-side-nav-exp-messages')) {
                for (const message of candidateMessages){
                    const experimentalMessage = (0, $20a1e3dd683356f0$export$963cdca6c7580c53).find((msg)=>msg.messageTemplateId === message.messageTemplateId); // Non-experimental messages are always eligible and should not be overridden by
                    // later experimental messages in the order they are defined.
                    if (!experimentalMessage) return {
                        message: message
                    };
                    if (experimentalMessage.shouldProceedToStatsigEvaluation && !experimentalMessage.shouldProceedToStatsigEvaluation()) continue;
                    const experimentCohort = (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, (0, $20a1e3dd683356f0$export$8ea6555e3e46f620));
                    if (experimentalMessage.statsigTestCohortPredicate(experimentCohort)) return {
                        message: message,
                        experimentCohort: experimentCohort
                    };
                }
                return undefined;
            }
            return candidateMessages[0] ? {
                message: candidateMessages[0]
            } : undefined;
        }, [
            messages,
            context,
            currentRoute
        ]);
        if (error) return null;
        if (status === 'loading') return null;
        if (!displayedMessage) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-empty-side-nav-placement": true
        });
        const { message: message, experimentCohort: experimentCohort } = displayedMessage;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                !(0, $cXtTj.default).checkGate('navx-global-side-nav-confluence') && "_2XghbE8HPE _3iDTPbQ4SZ"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Messages.render, {
                ...message,
                experimentCohort: experimentCohort,
                onSideNavClick: handleOnSideNavClick,
                handleOnDismissed: handleOnDismissed,
                onCallback: onCallback,
                flags: flags
            })
        });
    });
// Trust the result of backend ranking, not a frontend gate or another experiment read.
// Missing metadata (control, fallback or an older response) keeps today's heuristic.
const $a2042fb57734ba2e$var$getMessages = (messages = [])=>{
    if (messages.every((message)=>'rankingMode' in message && message.rankingMode === 'server')) return messages;
    return $a2042fb57734ba2e$var$sortMessages(messages);
};









/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $k4HA2 = parcelRequire("k4HA2");


var $kSwu1 = parcelRequire("kSwu1");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $c25Cq = parcelRequire("c25Cq");

const $c3609b66b755a7b8$var$actionsStyles = null;
const $c3609b66b755a7b8$export$b52183d5cfb26dc9 = ({ whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, handleOnDismissed: handleOnDismissed })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_4FKVYEkIJP _1mT5xdWVPG _3iDTPbQ4SZ _2IhTondnbC _4ApkO2dnbC"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
            iconSize: "small",
            showWhyAmISeeingThis: true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            onDismissed: handleOnDismissed
        })
    });
};






var $buxP3 = parcelRequire("buxP3");





var $kh0hi = parcelRequire("kh0hi");

const $52103e305e573c0c$export$183b689fd14b3c3e = ({ ctaText: ctaText, onCTAClick: onCTAClick, pressableStyle: pressableStyle })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
        onClick: onCTAClick,
        xcss: pressableStyle,
        children: ctaText
    });
};



var $3jNKT = parcelRequire("3jNKT");


var $baFbJ = parcelRequire("baFbJ");




const $11c42c750f5f3216$export$a5eee42871f883eb = (onMessageClick, interactionIdentifier)=>{
    const { messageClicked: messageClicked, messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
    const { onCtaActioned: onCtaActioned } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        messageClicked().catch(()=>{});
        onCtaActioned({
            interactionIdentifier: interactionIdentifier,
            additionalMetadata: {}
        });
        onMessageClick(e);
        // Dismiss Create Whiteboard and Create Page message instances after the user clicks on the action
        // This is so that if the user reloads the page, the message is not shown again.
        // Otherwise, there is a delay of 5 mins due to us using cached tap-sidecar with a 5-min TTL so the latest TAP trait info won't be retrieved till then
        if (interactionIdentifier.includes('CREATE_WHITEBOARD') || interactionIdentifier.includes('CREATE_PAGE')) messageDismissed().catch(()=>{});
    }, [
        interactionIdentifier,
        messageClicked,
        messageDismissed,
        onCtaActioned,
        onMessageClick
    ]);
    return {
        handleClick: handleClick
    };
};


const $ebbd83b20bdf93f8$var$nextBestActionButtonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    width: '120px',
    paddingLeft: '0',
    paddingRight: '0',
    whiteSpace: 'nowrap',
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $ebbd83b20bdf93f8$export$2f350203e9a62d5 = ({ ctaMessage: ctaMessage, onCTAClick: onCTAClick, nextBestActionType: nextBestActionType })=>{
    const interactionIdentifier = `next-best-action-message-${nextBestActionType}`;
    const { handleClick: handleClick } = (0, $11c42c750f5f3216$export$a5eee42871f883eb)(onCTAClick, interactionIdentifier);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $52103e305e573c0c$export$183b689fd14b3c3e), {
        ctaText: ctaMessage,
        onCTAClick: handleClick,
        pressableStyle: $ebbd83b20bdf93f8$var$nextBestActionButtonStyles
    });
};



/*--Banner Content--*/ const $259383f4bd8868ab$var$confluenceNbaMessageStylesCss = null;
const $259383f4bd8868ab$var$iconContainerStyles = null;
const $259383f4bd8868ab$var$bodyContentStyles = null;
const $259383f4bd8868ab$var$headerStyles = null;
const $259383f4bd8868ab$var$BodyContent = ({ header: header, ctaMessage: ctaMessage, onMessageClick: onMessageClick, nextBestActionType: nextBestActionType })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2XsHFMUF4f _2Zuz6Q2ADO _0adFHsUofl _39xV02N91d"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                role: "presentation",
                className: (0, $hekY6.default)([
                    "_2sNsIgEqul _39xV02N91d _1wydGW2ADO"
                ]),
                children: header
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ebbd83b20bdf93f8$export$2f350203e9a62d5), {
                ctaMessage: ctaMessage,
                onCTAClick: onMessageClick,
                nextBestActionType: nextBestActionType
            })
        ]
    });
};
const $259383f4bd8868ab$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "post-office.ad-controls.next-best-action-title.why-am-i-seeing-this",
        defaultMessage: "Why am I seeing this?"
    }),
    message: /*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-message.recommendation-basis",
            defaultMessage: "This recommendation is based on:"
        })
    }),
    reasons: [
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-reason.actions-done-so-far",
            defaultMessage: "What you\u2019ve done so far in the product"
        }),
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-reason.suggestions",
            defaultMessage: "What we suggest to help you get the most value from Atlassian"
        })
    ]
};
const $259383f4bd8868ab$export$7e6be280c02f2a40 = ({ icon: icon, header: header, ctaMessage: ctaMessage, onMessageClick: onMessageClick, handleOnDismissed: handleOnDismissed, nextBestActionType: nextBestActionType })=>{
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const interactionIdentifier = `next-best-action-message-${nextBestActionType}`;
    const { handleClick: handleClick } = (0, $11c42c750f5f3216$export$a5eee42871f883eb)(onMessageClick, interactionIdentifier);
    const handleMessageClick = (e)=>{
        const currentTarget = e.currentTarget;
        let target = e.target;
        while(target.parentNode){
            if (target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'html' // this is for the modal & its transparent background
            ) // Don't open action since these child elements should've already handled the click
            return;
             // Open action if the click is on the banner message itself
            if (target === currentTarget) {
                handleClick(e);
                return;
            } // Keep traversing up the DOM tree
            target = target.parentNode;
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": "confluence-next-best-action-message",
        onClick: handleMessageClick,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _4FKVYEqlrR _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _0KLXruVva3 _39xV02N91d _4nqctAkRPw _0ReiIH7zJH"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _1mT5xdWVPG _2IhTonxpxF _39xV02UF4f _0jFU0VUF4f"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($259383f4bd8868ab$var$BodyContent, {
                header: header,
                ctaMessage: ctaMessage,
                onMessageClick: onMessageClick,
                nextBestActionType: nextBestActionType
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c3609b66b755a7b8$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: $259383f4bd8868ab$var$whyAmISeeingThisModalContent,
                handleOnDismissed: handleOnDismissed
            })
        ]
    });
};









var $8j5U7 = parcelRequire("8j5U7");

const $bc7f845dcf6a18b5$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    // `default` is required by the content contract. This placement selects copy at runtime by
    // next-best-action type, so `default` mirrors the primary create-space copy as a fallback.
    default: {
        header: {
            id: 'post-office.confluence-side-nav.next-best-action.craete-space-header',
            defaultMessage: "Centralize your team's projects, and docs.",
            description: 'Header text for confluence side nav next best action banner',
            role: 'title'
        },
        cta: {
            id: 'post-office.confluence-side-nav.next-best-action.create-space-cta-message',
            defaultMessage: 'Create space',
            description: 'Call to action text for confluence side nav next best action banner',
            role: 'description'
        }
    },
    createSpace: {
        header: {
            id: 'post-office.confluence-side-nav.next-best-action.craete-space-header',
            defaultMessage: "Centralize your team's projects, and docs.",
            description: 'Header text for confluence side nav next best action banner',
            role: 'title'
        },
        cta: {
            id: 'post-office.confluence-side-nav.next-best-action.create-space-cta-message',
            defaultMessage: 'Create space',
            description: 'Call to action text for confluence side nav next best action banner',
            role: 'description'
        }
    },
    createPage: {
        header: {
            id: 'post-office.confluence-side-nav.next-best-action.create-page-header',
            defaultMessage: 'Plan projects, take notes, and track tasks.',
            description: 'Header text for confluence side nav next best action banner',
            role: 'title'
        },
        cta: {
            id: 'post-office.confluence-side-nav.next-best-action.create-page-cta-message',
            defaultMessage: 'Create page',
            description: 'Call to action text for confluence side nav next best action banner',
            role: 'description'
        }
    },
    createWhiteboard: {
        header: {
            id: 'post-office.confluence-side-nav.next-best-action.create-whiteboard-header',
            defaultMessage: 'Dream up new ideas, and visualize your work.',
            description: 'Header text for confluence side nav next best action banner',
            role: 'title'
        },
        cta: {
            id: 'post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message',
            defaultMessage: 'Create whiteboard',
            description: 'Call to action text for confluence side nav next best action banner',
            role: 'description'
        }
    }
});


const $30a5e9704d178abc$var$NBAIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M33.2748 18.1208H12.979V28.0375H33.2748V18.1208Z",
                    fill: "#BF63F3"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M26.9667 11.9624H6.6709V21.8791H26.9667V11.9624Z",
                    fill: "#FCA700"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M26.9665 18.1208H12.979V21.8792H26.9665V18.1208Z",
                    fill: "#AE2A19"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M32.0125 21.7042L27.6416 26.075L25.3833 23.7542L26.3583 22.8084L27.6583 24.1417L31.0541 20.7458L32.0166 21.7083L32.0125 21.7042Z",
                    fill: "white"
                })
            ]
        })
    });
const $30a5e9704d178abc$export$e080ae79c37ff1d1 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const headerText = intl.formatMessage((0, $bc7f845dcf6a18b5$export$e1c3efc64f2d806f).createSpace.header);
    const ctaMessage = intl.formatMessage((0, $bc7f845dcf6a18b5$export$e1c3efc64f2d806f).createSpace.cta);
    const onMessageClick = (0, $cozmU.useCallback)(()=>{
        onSideNavClick('CREATE_SPACE');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $259383f4bd8868ab$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)($30a5e9704d178abc$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_SPACE"
    });
};













const $abf03b4cdb50e8f5$var$NBAIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.0876 12.9458H10.0293V30H27.0835V12.9458H27.0876ZM13.6876 18.4291H23.4335V16.6H13.6876V18.4291ZM13.6876 22.3875H23.4335V20.5583H13.6876V22.3875ZM19.7793 26.3458H13.6876V24.5166H19.7793V26.3458Z",
                    fill: "#BF63F3"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M23.7292 18.954L20 19.9999L21.0458 16.2707L30.3458 6.9707L33.0292 9.65404L23.7292 18.954Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3708 12.9458L21.0458 16.2708L20.9542 16.6H23.4333V18.4291H20.4417L20 20L23.7292 18.9541L27.0875 15.5958V12.9458H24.3708Z",
                    fill: "#09326C"
                })
            ]
        })
    });
const $abf03b4cdb50e8f5$export$5688887910bb9e45 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const headerText = intl.formatMessage((0, $bc7f845dcf6a18b5$export$e1c3efc64f2d806f).createPage.header);
    const ctaMessage = intl.formatMessage((0, $bc7f845dcf6a18b5$export$e1c3efc64f2d806f).createPage.cta);
    const onMessageClick = (0, $cozmU.useCallback)(()=>{
        onSideNavClick('CREATE_PAGE');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $259383f4bd8868ab$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)($abf03b4cdb50e8f5$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_PAGE"
    });
};













const $c1d010230e31513a$var$NBAIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M25.4297 21.0963C25.4963 20.7255 25.5297 20.3255 25.5297 19.9088C25.5297 19.4922 25.4963 19.0838 25.4255 18.7047C25.0213 16.4588 23.463 15.0755 21.2713 14.7172C20.8963 14.6547 20.5047 14.6255 20.1005 14.6255C19.6963 14.6255 19.2672 14.6588 18.8797 14.7255C16.6922 15.0922 15.1338 16.4713 14.7297 18.7047C14.663 19.0838 14.6255 19.4838 14.6255 19.9088C14.6255 20.3338 14.6588 20.7255 14.7255 21.0963C15.1255 23.3255 16.6838 24.7088 18.8797 25.0755C19.2672 25.1422 19.6755 25.1755 20.1005 25.1755C20.5255 25.1755 20.9005 25.1463 21.2713 25.0838C23.463 24.7255 25.0255 23.3422 25.4255 21.0963H25.4297Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.37109 19.317L13.8711 8.17529L20.3711 19.317H7.37109Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M17.846 14.9922C16.2043 15.5672 15.0627 16.838 14.7293 18.7047C14.6918 18.9047 14.6668 19.1047 14.646 19.3172H20.3668L17.846 14.9922Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M29.917 20.8838H20.7837V30.0171H29.917V20.8838Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M20.7837 20.8877V25.146C20.9504 25.1294 21.1129 25.1085 21.2754 25.0835C23.467 24.7294 25.0254 23.3419 25.4295 21.096C25.442 21.0294 25.4545 20.9585 25.4629 20.8877H20.7837Z",
                fill: "#AE2A19"
            })
        ]
    });
const $c1d010230e31513a$export$aafbf2fddacf0f4f = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const headerText = intl.formatMessage((0, $bc7f845dcf6a18b5$export$e1c3efc64f2d806f).createWhiteboard.header);
    const ctaMessage = intl.formatMessage((0, $bc7f845dcf6a18b5$export$e1c3efc64f2d806f).createWhiteboard.cta);
    const onMessageClick = (0, $cozmU.useCallback)(()=>{
        onSideNavClick('CREATE_WHITEBOARD');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $259383f4bd8868ab$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)($c1d010230e31513a$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_WHITEBOARD"
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $c2h0x = parcelRequire("c2h0x");

function $bf06c9006200784d$export$a7a9523472993e97(value) {
    const result = $bf06c9006200784d$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $bf06c9006200784d$export$226b3eccf92c9ed9(value) {
    const result = $bf06c9006200784d$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $bf06c9006200784d$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "MCP_SETUP_NUDGE") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "MCP_SETUP_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_9 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_9.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_9.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $6ea7ffe375aacf42$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $bf06c9006200784d$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            switch(nextBestActionType){
                case 'CREATE_SPACE':
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $30a5e9704d178abc$export$e080ae79c37ff1d1), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                case 'CREATE_PAGE':
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $abf03b4cdb50e8f5$export$5688887910bb9e45), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                case 'CREATE_WHITEBOARD':
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1d010230e31513a$export$aafbf2fddacf0f4f), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                default:
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {});
            }
        }
    }
});






/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $gBjHb = parcelRequire("gBjHb");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $cJ0FD = parcelRequire("cJ0FD");


var $1l0kj = parcelRequire("1l0kj");


var $hBYtq = parcelRequire("hBYtq");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $4ez2K = parcelRequire("4ez2K");


var $7NHN3 = parcelRequire("7NHN3");








var $9TNXZ = parcelRequire("9TNXZ");




const $35078225e8e333e2$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        headerText: {
            id: 'post-office.confluence-resurrected-user-welcome-back.next-best-action.header',
            defaultMessage: 'Welcome back',
            description: 'Title shown when displaying the welcome back nudge for resurrected users.',
            role: 'title'
        },
        bodyText: {
            id: 'post-office.confluence-resurrected-user-welcome-back.body',
            defaultMessage: 'Catch up on the top discussions and highlights from your team.',
            description: 'Body for confluence side nav welcome back nudge for resurrected users.',
            role: 'description'
        },
        ctaMessage: {
            id: 'post-office.confluence-resurrected-user-welcome-back.cta',
            defaultMessage: "See what's popular",
            description: 'CTA button text for the welcome back nudge for resurrected users.'
        },
        closeLabel: {
            id: 'post-office.confluence-resurrected-user-welcome-back.close',
            defaultMessage: 'Close',
            description: 'Label for the close icon that is represented by an X'
        },
        imageAltText: {
            id: 'post-office.confluence-resurrected-user-welcome-back.image-alt',
            defaultMessage: 'Two hearts overlapped with each other',
            description: 'Alternate text for picture of two hearts'
        }
    }
});


var $dfd4467bfd4cb536$exports = {};
$dfd4467bfd4cb536$exports = new URL("heart.91f6fb22.svg", import.meta.url).toString();


const $2bd8ff0efe8a8369$var$i18n = (0, $35078225e8e333e2$export$e1c3efc64f2d806f).default;
const $2bd8ff0efe8a8369$var$styles = {
    container: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8 _4c065U8HPE _1mT5xdRAKS _2O5Vij7dHp _0KLXruVva3 _03SyCP8HPE _0LQT5EgVvo",
    link: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1UtDYzAwSC _1kk5Tkf7mX _0wOv4Q7zJH _0KLXrujOvk _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0CMRbkAwSC",
    headerRow: "_37wbyuI7V3 _0hPCNLchRC _39xV02N91d",
    inlineStack: "_39xV02N91d"
};
const $2bd8ff0efe8a8369$export$1a9faf036da14396 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed, nextBestActionType: nextBestActionType })=>{
    const intl = (0, $kSwu1.useIntl)();
    const imageAltText = intl.formatMessage($2bd8ff0efe8a8369$var$i18n.imageAltText); // For PO events
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onClosed: onClosed, onCtaActioned: onCtaActioned } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'confluenceResurrectedUserWelcomeSidebarNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismissClicked = ()=>{
        onClosed({
            interactionIdentifier: 'resurrected-user-welcome-back-dismiss'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'resurrectedUserWelcomeBackDismiss'
        }); // moves to the next message in queue
        handleOnDismissed();
    };
    const handleCtaClicked = ()=>{
        onCtaActioned({
            interactionIdentifier: 'resurrected-user-welcome-back-cta'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'resurrectedUserWelcomeBackCta'
        }); // moves to the next message in queue and also calls necessary action in confluence
        onSideNavClick(nextBestActionType);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-resurrected-user-welcome-back-message'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2bd8ff0efe8a8369$var$styles.container,
            testId: "confluence-resurrected-user-welcome-back-message",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                xcss: $2bd8ff0efe8a8369$var$styles.inlineStack,
                shouldWrap: false,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dfd4467bfd4cb536$exports))),
                        alt: imageAltText
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        alignInline: "start",
                        grow: "fill",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                xcss: $2bd8ff0efe8a8369$var$styles.headerRow,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                                        shouldWrap: false,
                                        alignBlock: "center",
                                        grow: "fill",
                                        spread: "space-between",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                            size: "xsmall",
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                ...$2bd8ff0efe8a8369$var$i18n.headerText
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                        appearance: "subtle",
                                        label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$2bd8ff0efe8a8369$var$i18n.closeLabel
                                        }),
                                        isTooltipDisabled: false,
                                        onClick: handleDismissClicked,
                                        spacing: "compact"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$2bd8ff0efe8a8369$var$i18n.bodyText
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                xcss: $2bd8ff0efe8a8369$var$styles.link,
                                testId: "cta-link",
                                onClick: handleCtaClicked,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$2bd8ff0efe8a8369$var$i18n.ctaMessage
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $58b5b3cb06c5e457$export$a7a9523472993e97(value) {
    const result = $58b5b3cb06c5e457$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $58b5b3cb06c5e457$export$226b3eccf92c9ed9(value) {
    const result = $58b5b3cb06c5e457$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $58b5b3cb06c5e457$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"RESURRECTED_USER_NUDGE"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "RESURRECTED_USER_NUDGE",
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $7188179b528a7f61$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $58b5b3cb06c5e457$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2bd8ff0efe8a8369$export$1a9faf036da14396), {
                onSideNavClick: onSideNavClick,
                handleOnDismissed: handleOnDismissed,
                nextBestActionType: nextBestActionType
            });
        }
    }
});


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");











var $eKMV3 = parcelRequire("eKMV3");


























var $f872b8a547477c91$exports = {};
$f872b8a547477c91$exports = new URL("notes.c9738615.png", import.meta.url).toString();





const $2d424d0e221c3217$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        header: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header',
            defaultMessage: 'Automate meeting notes',
            description: 'Header text for confluence side nav next best action banner',
            role: 'title'
        },
        body: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body',
            defaultMessage: 'Instead of manually typing meeting notes, why not try Loom to record meetings?',
            description: 'Body for confluence side nav next best action banner',
            role: 'description'
        },
        cta: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta',
            defaultMessage: 'Try now',
            description: 'Call to action text for confluence side nav next best action banner'
        },
        close: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close',
            defaultMessage: 'Close',
            description: 'Label for the close icon that is represented by an X'
        },
        imageAlt: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt',
            defaultMessage: 'Notepad with sparkling background',
            description: 'Alternate text for picture of notepad with sparkles behind it'
        },
        whyAmISeeingThisTitle: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this',
            defaultMessage: 'Why am I seeing this?',
            description: 'the title to the modal'
        },
        whyAmISeeingThisMessage: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis',
            defaultMessage: 'This recommendation is based on:',
            description: 'the main message of the modal'
        },
        whyAmISeeingThisReasonActions: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far',
            defaultMessage: 'What you\u2019ve done so far in the product',
            description: 'the first reason for displaying the message to the customer: what actions the customer has actioned so far in the product'
        },
        whyAmISeeingThisReasonSuggestions: {
            id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions',
            defaultMessage: 'What we suggest to help you get the most value from Atlassian',
            description: 'the second reason for displaying the message to the customer: what we suggest to help the customer'
        }
    }
});


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $85d1dd15bf916fef$export$a7a9523472993e97(value) {
    const result = $85d1dd15bf916fef$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $85d1dd15bf916fef$export$226b3eccf92c9ed9(value) {
    const result = $85d1dd15bf916fef$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $85d1dd15bf916fef$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"1_ON_1_LOOM_NUDGE"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "1_ON_1_LOOM_NUDGE",
            value: value["nextBestActionType"]
        });
        if (!('explicitEnableRequired' in value)) errors.push({
            path: 'value["explicitEnableRequired"]',
            expected: 'true',
            value: undefined
        });
        else if (value["explicitEnableRequired"] !== true) errors.push({
            path: 'value["explicitEnableRequired"]',
            expected: true,
            value: value["explicitEnableRequired"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $cc3d520df71c5cda$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        ...(0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.whyAmISeeingThisTitle
    }),
    message: /*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            ...(0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.whyAmISeeingThisMessage
        })
    }),
    reasons: [
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            ...(0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.whyAmISeeingThisReasonActions
        }, "actions"),
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            ...(0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.whyAmISeeingThisReasonSuggestions
        }, "suggestions")
    ]
};
const $cc3d520df71c5cda$var$styles = {
    container: "_0bjKvD8fU6 _4FKVYE8HPE _0KLXrunmFW _39xV02N91d",
    body: "_3138422ADO",
    ctaWrapper: "_3138428HPE"
};
const $cc3d520df71c5cda$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $85d1dd15bf916fef$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            const { onClosed: onClosed, onCtaActioned: onCtaActioned, onDeclined: onDeclined } = (0, $3jNKT.usePostOfficeUserInteractions)();
            const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
            const intl = (0, $kSwu1.useIntl)();
            const headerText = intl.formatMessage((0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.header);
            const bodyText = intl.formatMessage((0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.body);
            const ctaText = intl.formatMessage((0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.cta);
            const closeLabel = intl.formatMessage((0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.close);
            const imageAltText = intl.formatMessage((0, $2d424d0e221c3217$export$e1c3efc64f2d806f).default.imageAlt);
            const handleDismiss = ()=>{
                // AdControls' "Not interested" menu item — an explicit refusal, not a plain close.
                onDeclined({
                    interactionIdentifier: 'dismiss'
                });
                messageDismissed();
                handleOnDismissed();
            };
            const handleCloseClicked = ()=>{
                onClosed({
                    interactionIdentifier: '1on1-loom-close'
                });
                messageDismissed();
                onSideNavClick(nextBestActionType);
            };
            const handleCtaClicked = ()=>{
                onCtaActioned({
                    interactionIdentifier: '1on1-loom-cta'
                });
                messageDismissed();
                onSideNavClick(nextBestActionType);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                data: {
                    source: 'confluence-side-nav-1-on-1-loom-nudge-message'
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        $cc3d520df71c5cda$var$styles.container
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f872b8a547477c91$exports))),
                                    alt: imageAltText,
                                    height: "56",
                                    width: "56"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                                            iconSize: "small",
                                            showWhyAmISeeingThis: true,
                                            whyAmISeeingThisModalContent: $cc3d520df71c5cda$var$whyAmISeeingThisModalContent,
                                            onDismissed: handleDismiss
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                            onClick: handleCloseClicked,
                                            appearance: "subtle",
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                            label: closeLabel
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            size: "small",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                $cc3d520df71c5cda$var$styles.body
                            ]),
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                $cc3d520df71c5cda$var$styles.ctaWrapper
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                                onClick: handleCtaClicked,
                                href: "https://www.loom.com/welcome",
                                spacing: "compact",
                                target: "_blank",
                                children: ctaText
                            })
                        })
                    ]
                })
            });
        }
    }
});















// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $7fb0160cf62877a2$export$a7a9523472993e97(value) {
    const result = $7fb0160cf62877a2$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $7fb0160cf62877a2$export$226b3eccf92c9ed9(value) {
    const result = $7fb0160cf62877a2$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $7fb0160cf62877a2$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('testProp' in value)) errors.push({
            path: 'value["testProp"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["testProp"] !== 'string') errors.push({
            path: 'value["testProp"]',
            expected: 'string',
            value: value["testProp"]
        });
        if (!('testObjProp' in value)) errors.push({
            path: 'value["testObjProp"]',
            expected: 'object',
            value: undefined
        });
        else if (typeof value["testObjProp"] !== 'object' || value["testObjProp"] === null || Array.isArray(value["testObjProp"])) errors.push({
            path: 'value["testObjProp"]',
            expected: 'object',
            value: value["testObjProp"]
        });
        else {
            if (!('testObjPropKey' in value["testObjProp"])) errors.push({
                path: 'value["testObjProp"]["testObjPropKey"]',
                expected: 'string',
                value: undefined
            });
            else if (typeof value["testObjProp"]["testObjPropKey"] !== 'string') errors.push({
                path: 'value["testObjProp"]["testObjPropKey"]',
                expected: 'string',
                value: value["testObjProp"]["testObjPropKey"]
            });
        }
        if (!('testArrayProp' in value)) errors.push({
            path: 'value["testArrayProp"]',
            expected: 'number[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["testArrayProp"])) errors.push({
                path: 'value["testArrayProp"]',
                expected: 'array',
                value: value["testArrayProp"]
            });
            if (Array.isArray(value["testArrayProp"])) value["testArrayProp"].forEach((element, index)=>{
                if (typeof element !== 'number') errors.push({
                    path: 'element',
                    expected: 'number',
                    value: element
                });
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $789eae1659236b56$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $7fb0160cf62877a2$export$a7a9523472993e97),
        Component: ({ handleOnDismissed: handleOnDismissed })=>{
            const { onClosed: onClosed } = (0, $3jNKT.usePostOfficeUserInteractions)();
            const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
            const onDismissed = ()=>{
                onClosed({
                    interactionIdentifier: 'confluence-side-nav-create-a-space-dismiss'
                });
                messageDismissed();
                handleOnDismissed();
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                onClick: onDismissed,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    id: "post-office.confluence-side-nav-create-a-space.dismiss",
                    defaultMessage: "Dismiss"
                })
            });
        }
    }
});






/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $iMnC5 = parcelRequire("iMnC5");

























const $0d3df3f4dff2d0f4$export$75019b1a004a783d = ()=>// eslint-disable-next-line @atlassian/a11y/role-img-alt
    /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        role: "img",
        width: "80",
        height: "92",
        viewBox: "0 0 80 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                "clip-path": "url(#clip0_2327_84459)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M3.01494 50.2585C1.34983 44.4516 4.70743 38.3943 10.5143 36.7292L31.543 30.6993C37.3499 29.0342 43.4072 32.3918 45.0723 38.1987L51.1021 59.2274C52.7672 65.0343 49.4096 71.0916 43.6027 72.7567L22.5741 78.7865C16.7672 80.4516 10.7099 77.094 9.04481 71.2871L3.01494 50.2585Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                        "clip-path": "url(#clip1_2327_84459)",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                            "clip-path": "url(#clip2_2327_84459)",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.6067 56.0157C30.2172 54.7386 28.1868 54.8133 25.4524 55.5974C22.244 56.5174 19.8923 58.636 18.5252 63.0876L18.2999 63.8158C18.1166 64.4149 18.0954 64.6161 18.1575 64.8325C18.2195 65.0489 18.3806 65.1979 18.854 65.3354L23.7082 66.7149C23.9684 66.7965 24.1713 66.8163 24.3536 66.7641C24.5724 66.7013 24.6872 66.5513 24.8129 66.164L25.1795 64.9659C25.7556 63.1222 26.5223 62.3559 27.689 62.0213C28.7099 61.7286 29.9957 61.6722 31.6974 61.9649L36.5788 62.7511C37.0783 62.8421 37.5213 62.598 37.5952 62.0303L38.3544 56.9723C38.4284 56.4046 38.1895 56.1218 37.6067 56.0157ZM16.4195 53.5425C23.8089 54.8196 25.8393 54.7449 28.5737 53.9608C31.7821 53.0408 34.1338 50.9222 35.5009 46.4706L35.7262 45.7424C35.9095 45.1433 35.9307 44.9421 35.8686 44.7257C35.8066 44.5093 35.6455 44.3603 35.1721 44.2228L30.3179 42.8433C30.0577 42.7617 29.8548 42.7419 29.6725 42.7941C29.4537 42.8569 29.3389 43.0069 29.2132 43.3942L28.8466 44.5923C28.2705 46.436 27.5038 47.2023 26.3371 47.5369C25.3162 47.8296 24.0304 47.886 22.3287 47.5933L17.4474 46.8071C16.9478 46.7161 16.5049 46.9602 16.4309 47.5279L15.6717 52.5859C15.5977 53.1536 15.8366 53.4364 16.4195 53.5425Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                id: "mask0_2327_84459",
                style: {
                    maskType: 'alpha'
                },
                maskUnits: "userSpaceOnUse",
                x: "42",
                y: "34",
                width: "47",
                height: "46",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M84.5407 70.1354C85.399 68.8074 86.1676 67.3446 86.8433 65.7294C87.5189 64.1142 88.0399 62.4937 88.382 60.9391C90.4423 51.6574 86.6686 43.8231 78.8282 38.9377C77.4887 38.1071 76.0405 37.3553 74.4713 36.6989C72.9021 36.0425 71.2192 35.49 69.6242 35.1148C60.6205 32.9978 52.4142 35.7994 47.265 43.7403C46.3964 45.0801 45.6116 46.5686 44.9302 48.1976C44.2488 49.8267 43.7528 51.3873 43.4099 52.9308C41.3701 62.1507 45.1318 69.9746 52.9733 74.9092C54.3603 75.7813 55.8756 76.5666 57.5047 77.248C59.1337 77.9294 60.6241 78.4122 62.158 78.7781C71.1529 80.9293 79.3919 78.1143 84.5361 70.1334L84.5407 70.1354Z",
                    fill: "#E2E3E4"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                mask: "url(#mask0_2327_84459)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M65.4465 54.2364C48.7381 38.7562 43.5093 13.5402 54.257 -7.8265C56.8701 -13.0214 60.2302 -17.5913 64.1386 -21.4774L21.9822 -42.6824L-33.085 66.7933L44.6016 105.87C46.0277 93.9323 49.5157 82.0341 55.2309 70.6721C58.1886 64.7921 61.6171 59.3074 65.448 54.2371L65.4465 54.2364Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M65.4458 54.2338C82.2906 31.934 106.91 17.6731 133.454 13.3867L64.1379 -21.48C60.2294 -17.5938 56.8694 -13.024 54.2563 -7.82904C43.5086 13.5377 48.7381 38.7558 65.4458 54.2338Z",
                        fill: "#AF59E0"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M191.971 42.8203L153.078 23.2568C152.288 28.7116 150.622 34.1336 148.009 39.3286C134.987 65.2179 103.443 75.6484 77.5534 62.6258C73.0307 60.3509 68.9819 57.5093 65.4457 54.2328C61.6162 59.3039 58.1856 64.7893 55.2286 70.6678C49.5142 82.0285 46.0276 93.9273 44.5993 105.866L136.904 152.296L191.971 42.8203Z",
                        fill: "#6A9A23"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M65.4459 54.2343C68.9821 57.5108 73.0309 60.3524 77.5536 62.6273C103.443 75.6499 134.987 65.2194 148.009 39.3301C150.623 34.1351 152.288 28.7131 153.079 23.2584L133.454 13.3872C106.91 17.6737 82.2906 31.9345 65.4459 54.2343Z",
                        fill: "#1868DB"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M50.8357 59.1709C52.0329 63.3459 50.6336 67.65 47.5945 70.3584C43.5378 65.6894 41.9154 59.6856 43.4099 52.9307C43.7528 51.3873 44.2491 49.8271 44.9304 48.1982C45.4556 46.9426 46.0423 45.7704 46.6814 44.6855L50.8357 59.1709Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M77.573 60.512L56.5132 56.8549L57.1141 53.3945L78.1739 57.0517L77.573 60.512Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M63.7844 67.1848L67.4416 46.125L70.9019 46.7259L67.2448 67.7857L63.7844 67.1848Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip0_2327_84459",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M3.01494 50.2585C1.34983 44.4516 4.70743 38.3943 10.5143 36.7292L31.543 30.6993C37.3499 29.0342 43.4072 32.3918 45.0723 38.1987L51.1021 59.2274C52.7672 65.0343 49.4096 71.0916 43.6027 72.7567L22.5741 78.7865C16.7672 80.4516 10.7099 77.094 9.04481 71.2871L3.01494 50.2585Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip1_2327_84459",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "32.8142",
                            height: "32.8142",
                            fill: "white",
                            transform: "translate(6.54558 43.5566) rotate(-16)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip2_2327_84459",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "22.5673",
                            height: "21.5753",
                            fill: "white",
                            transform: "translate(13.193 47.5195) rotate(-16)"
                        })
                    })
                ]
            })
        ]
    });





const $dca8d33884805443$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        headingLabel: {
            id: 'post-office.confluence-create-with-rovo-side-nav-nudge.heading',
            defaultMessage: 'You describe, Rovo creates',
            description: 'Heading for the Create with Rovo side nav nudge.',
            role: 'title'
        },
        bodyLabel: {
            id: 'post-office.confluence-create-with-rovo-side-nav-nudge.body',
            defaultMessage: 'With a simple prompt, Rovo can draft a page or whiteboard.',
            description: 'Body text for the Create with Rovo side nav nudge.',
            role: 'description'
        },
        callToActionLabel: {
            id: 'post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action',
            defaultMessage: 'Show me how',
            description: 'Call to action button on the Create with Rovo side nav nudge.'
        },
        dismissLabel: {
            id: 'post-office.confluence-create-with-rovo-side-nav-nudge.dismiss',
            defaultMessage: 'Dismiss',
            description: 'Dismiss button on the Create with Rovo side nav nudge.'
        }
    }
});


const $41f54755afaf56c0$var$i18n = (0, $dca8d33884805443$export$e1c3efc64f2d806f).default;
const $41f54755afaf56c0$var$styles = {
    root: "_0bjKvD8fU6 _1mT5xdRAKS _2O5Vij7dHp _0KLXruVva3",
    primaryContentContainer: "_4FKVYE5zaO _2O5Vij7dHp",
    callToActionContainer: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0wOv4Q7zJH _0KLXrujOvk _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0CMRbkAwSC",
    imageContainer: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP",
    closeButtonContainer: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO"
};
const $41f54755afaf56c0$export$73f0a7caafa5e72e = ({ action: action, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onCtaActioned: onCtaActioned, onClosed: onClosed } = (0, $3jNKT.usePostOfficeUserInteractions)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceCreateWithRovoSideNavNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOnPrimaryActionClick = ()=>{
        onCtaActioned({
            interactionIdentifier: 'showMeHow'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoSideNavNudgeCta'
        });
        onPrimaryActionClick?.(action);
    };
    const handleOnDismissClick = ()=>{
        onClosed({
            interactionIdentifier: 'dismiss'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoSideNavNudgeDismiss'
        });
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-create-with-rovo-side-nav-nudge'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            xcss: $41f54755afaf56c0$var$styles.root,
            testId: "confluence-create-with-rovo-side-nav-nudge",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                    xcss: $41f54755afaf56c0$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$41f54755afaf56c0$var$i18n.headingLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$41f54755afaf56c0$var$i18n.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                xcss: $41f54755afaf56c0$var$styles.callToActionContainer,
                                onClick: handleOnPrimaryActionClick,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    color: "color.link",
                                    size: "medium",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...$41f54755afaf56c0$var$i18n.callToActionLabel
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                    xcss: $41f54755afaf56c0$var$styles.imageContainer,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0d3df3f4dff2d0f4$export$75019b1a004a783d), {})
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $41f54755afaf56c0$var$styles.closeButtonContainer,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        icon: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                ...props,
                                size: "small"
                            }),
                        label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...$41f54755afaf56c0$var$i18n.dismissLabel
                        }),
                        isTooltipDisabled: false,
                        onClick: handleOnDismissClick
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $43ede0adcc5ecd53$export$a7a9523472993e97(value) {
    const result = $43ede0adcc5ecd53$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $43ede0adcc5ecd53$export$226b3eccf92c9ed9(value) {
    const result = $43ede0adcc5ecd53$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $43ede0adcc5ecd53$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "MCP_SETUP_NUDGE") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "MCP_SETUP_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_9 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_9.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_9.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $cb9f44e7a7a4173f$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $43ede0adcc5ecd53$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $41f54755afaf56c0$export$73f0a7caafa5e72e), {
                action: nextBestActionType,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});






var $iqz3m = parcelRequire("iqz3m");


/* LeftNavCtaMessage.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $w6R6I = parcelRequire("w6R6I");











var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");







var $c0edc3795d3ac122$exports = {};
$c0edc3795d3ac122$exports = new URL("chrome-icon.40414d4b.svg", import.meta.url).toString();


var $b3436f676e5afb95$exports = {};
$b3436f676e5afb95$exports = new URL("rovo-icon.a638efdd.svg", import.meta.url).toString();








const $75fd4393b38b5954$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
            defaultMessage: 'Get answers for work, anywhere',
            description: 'Heading text for rovo extension install cta left nav',
            role: 'title'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
            defaultMessage: 'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
            description: 'Description text for rovo extension install cta left nav',
            role: 'description'
        },
        linkText: {
            id: 'rovo-extension-install-cta-left-nav.link',
            defaultMessage: 'Get the browser extension',
            description: 'Text for rovo extension install cta link left nav'
        },
        jiraLinkText: {
            id: 'rovo-extension-install-cta-left-nav.jira-link',
            defaultMessage: 'Get the browser extension',
            description: 'Text for Jira left nav extension install CTA link'
        },
        jiraRovoLinkText: {
            id: 'rovo-extension-install-cta-left-nav.jira-rovo-link',
            defaultMessage: 'Get the Rovo extension',
            description: 'Text for Jira left nav extension install CTA link (Rovo variant)'
        },
        rovoIconAlt: {
            id: 'rovo-extension-install-cta-left-nav.rovo-icon-alt',
            defaultMessage: 'Rovo Icon',
            description: 'Alt text for Rovo icon image'
        },
        chromeIconAlt: {
            id: 'rovo-extension-install-cta-left-nav.chrome-icon-alt',
            defaultMessage: 'Google Chrome Icon',
            description: 'Alt text for Google Chrome icon image'
        },
        jiraIconAlt: {
            id: 'rovo-extension-install-cta-left-nav.jira-icon-alt',
            defaultMessage: 'Jira Icon',
            description: 'Alt text for Jira icon image'
        },
        dismissLabel: {
            id: 'rovo-extension-install-cta-left-nav.dismiss-label',
            defaultMessage: 'Dismiss message',
            description: 'Label for dismiss button'
        }
    },
    'copy-version-b': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
            defaultMessage: 'Get answers for work, anywhere',
            description: 'Heading text for rovo extension install cta left nav',
            role: 'title'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
            defaultMessage: 'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
            description: 'Description text for rovo extension install cta left nav',
            role: 'description'
        }
    },
    'copy-version-c': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
            defaultMessage: 'Unlock Rovo in every tab',
            description: 'Heading text for rovo extension install cta left nav',
            role: 'title'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
            defaultMessage: '50K+ workers use it to chat with AI that understands their company.',
            description: 'Description text for rovo extension install cta left nav',
            role: 'description'
        }
    },
    'jira-take-anywhere': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.jira-take-anywhere',
            defaultMessage: 'Jira. Anywhere.',
            description: 'Heading text for Jira left nav extension install CTA',
            role: 'title'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.jira-take-anywhere',
            defaultMessage: 'Manage work items, get instant insights, and act on Jira from any tab in your browser.',
            description: 'Description text for Jira left nav extension install CTA',
            role: 'description'
        }
    },
    'jira-rovo': {
        heading: {
            id: 'rovo-extension-install-cta-left-nav.heading.jira-rovo',
            defaultMessage: 'Jira. Anywhere.',
            description: 'Heading text for Jira left nav Rovo extension variant CTA',
            role: 'title'
        },
        description: {
            id: 'rovo-extension-install-cta-left-nav.description.jira-rovo',
            defaultMessage: 'Manage work items, get instant insights, and act on Jira from any tab in your browser.',
            description: 'Description text for Jira left nav Rovo extension variant CTA',
            role: 'description'
        }
    }
});
const $75fd4393b38b5954$export$1d02164cdbd97674 = {
    'copy-version-b': $75fd4393b38b5954$export$e1c3efc64f2d806f['copy-version-b'],
    'copy-version-c': $75fd4393b38b5954$export$e1c3efc64f2d806f['copy-version-c'],
    'jira-take-anywhere': $75fd4393b38b5954$export$e1c3efc64f2d806f['jira-take-anywhere'],
    'jira-rovo': $75fd4393b38b5954$export$e1c3efc64f2d806f['jira-rovo']
};


const $5ff7c4876e92395f$var$styles = {
    boxContainer: "_4FKVYE8HPE _2mHwu82ADO _0bjKvDKxmn _0GwItXDIqT _37wbyuDIqT _3iDTPbQ4SZ _39xV02N91d _0hPCNLchRC _0KLXruVva3",
    contentStack: "_2mHwu82ADO _39xV02N91d",
    headerRow: "_37wbyuI7V3 _0hPCNLchRC _39xV02N91d",
    iconAndTitle: "_2mHwu82ADO",
    iconContainer: "_3iDTPbQ4SZ _0hPCNLDIqT"
};
const $5ff7c4876e92395f$var$getLinkUrl = (cohort)=>{
    const UTM_CONTENT = `side_nav_install_cta_${cohort}`;
    return `https://chromewebstore.google.com/detail/rovo-search-chat-and-more/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=confluence-side-nav&utm_medium=banner&utm_campaign=rovo_extension_side_nav_install_cta&utm_content=${UTM_CONTENT}`;
};
const $5ff7c4876e92395f$var$selectCopyForCohort = (cohort)=>{
    return (0, $75fd4393b38b5954$export$1d02164cdbd97674)[cohort] || (0, $75fd4393b38b5954$export$1d02164cdbd97674)['copy-version-b'];
};
const $5ff7c4876e92395f$export$217ec4c85bc42809 = ({ context: context, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
    const { experimentCohort: experimentCohort } = context;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { heading: heading, description: description } = $5ff7c4876e92395f$var$selectCopyForCohort(experimentCohort);
    const { messageClicked: messageClicked } = (0, $baFbJ.useMessageEvent)();
    const { onClosed: onClosed, onCtaActioned: onCtaActioned } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const headingText = formatMessage(heading);
    const descriptionText = formatMessage(description);
    const linkText = formatMessage((0, $75fd4393b38b5954$export$e1c3efc64f2d806f).default.linkText);
    const rovoIconAlt = formatMessage((0, $75fd4393b38b5954$export$e1c3efc64f2d806f).default.rovoIconAlt);
    const chromeIconAlt = formatMessage((0, $75fd4393b38b5954$export$e1c3efc64f2d806f).default.chromeIconAlt);
    const dismissLabel = formatMessage((0, $75fd4393b38b5954$export$e1c3efc64f2d806f).default.dismissLabel);
    const linkUrl = $5ff7c4876e92395f$var$getLinkUrl(experimentCohort);
    const handleDismiss = ()=>{
        messageClicked();
        onClosed({
            interactionIdentifier: 'dismiss',
            additionalMetadata: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        handleOnDismissed();
    };
    const handleLinkClick = ()=>{
        messageClicked();
        onCtaActioned({
            interactionIdentifier: 'installLink',
            destinationUrl: linkUrl,
            additionalMetadata: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        onSideNavClick('ROVO_EXTENSION_CTA');
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: (0, $w6R6I.cx)($5ff7c4876e92395f$var$styles.boxContainer),
        style: {
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2wCqQ.Stack), {
            xcss: (0, $w6R6I.cx)($5ff7c4876e92395f$var$styles.contentStack),
            testId: "rovo-left-nav-content",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
                    xcss: (0, $w6R6I.cx)($5ff7c4876e92395f$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
                            xcss: (0, $w6R6I.cx)($5ff7c4876e92395f$var$styles.iconAndTitle),
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
                                    xcss: (0, $w6R6I.cx)($5ff7c4876e92395f$var$styles.iconContainer),
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b3436f676e5afb95$exports))),
                                            alt: rovoIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                flexShrink: 0,
                                                zIndex: 2
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c0edc3795d3ac122$exports))),
                                            alt: chromeIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                marginLeft: '-8px',
                                                flexShrink: 0,
                                                zIndex: 1
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                    size: "xsmall",
                                    children: headingText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                            label: dismissLabel,
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: handleDismiss
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
                    size: "small",
                    children: descriptionText
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                    href: linkUrl,
                    target: "blank",
                    onClick: handleLinkClick,
                    children: linkText
                })
            ]
        })
    });
};


const $bc4239413241ab3e$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $iqz3m.noValidation)(),
        Component: (props)=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5ff7c4876e92395f$export$217ec4c85bc42809), {
                ...props,
                context: {
                    experimentCohort: props.experimentCohort,
                    source: 'confluence-side-nav'
                }
            });
        }
    }
});












var $iDrrr = parcelRequire("iDrrr");


var $6m3nS = parcelRequire("6m3nS");


var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");







const $530dc45a2cd6a79e$export$1db5857ce669e9b7 = {
    MEETING_NOTES: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    PROJECT_PLAN: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    EOW_STATUS_REPORT: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
    DECISIONS: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
    REQUIREMENTS_RACI: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
    RETROSPECTIVES: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
    BUSINESS_STATUS_UPDATE: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    ONE_ON_ONE_MEETING: 'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
    RECURRING_MEETING_MINUTES: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
    PROJECT_STATUS: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint'
};









var $1NVwf = parcelRequire("1NVwf");


var $8BCsI = parcelRequire("8BCsI");





/* personalized-banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $9DHhW = parcelRequire("9DHhW");














var $60Yxm = parcelRequire("60Yxm");

















var $7vK9E = parcelRequire("7vK9E");







const $1550d239ccf2eadc$export$ad2f6cca3fea287 = (0, $8j5U7.defineContent)({
    default: {
        heading: {
            id: 'twc.sidenav.banner.generic.heading',
            defaultMessage: 'Explore Teamwork Collection',
            description: 'Main heading for the generic TWC activation banner in the product sidenav.',
            role: 'title'
        },
        subheadingJira: {
            id: 'twc.sidenav.banner.generic.subheading.jira',
            defaultMessage: 'Discover how the other apps can accelerate your workflows in Jira.',
            description: 'Subheading for the generic banner when shown in Jira.',
            role: 'description'
        },
        subheadingConfluence: {
            id: 'twc.sidenav.banner.generic.subheading.confluence',
            defaultMessage: 'Discover how the other apps can accelerate your workflows in Confluence.',
            description: 'Subheading for the generic banner when shown in Confluence.'
        },
        appTilesAlt: {
            id: 'twc.sidenav.banner.generic.app.tiles.alt',
            defaultMessage: 'App tiles illustration',
            description: 'Alt text for the app tiles illustration in the generic banner.'
        },
        ctaButton: {
            id: 'twc.sidenav.banner.generic.cta',
            defaultMessage: 'Try now',
            description: 'CTA button text for the generic TWC activation banner in the product sidenav.'
        },
        closeLabel: {
            id: 'twc.sidenav.banner.generic.close',
            defaultMessage: 'Close',
            description: 'Accessible label for the close button on the generic TWC activation banner.'
        }
    },
    personalized: {
        heading: {
            id: 'twc.sidenav.banner.personalized.heading',
            defaultMessage: 'Explore Teamwork Collection',
            description: 'Main heading for the personalized missing-app activation banner in the product sidenav.',
            role: 'title'
        },
        subheadingJira: {
            id: 'twc.sidenav.banner.personalized.subheading.jira',
            defaultMessage: 'Plan your next team project in Jira',
            description: 'Personalized banner subheading when the recommended app is Jira. Shown in the product sidenav.',
            role: 'description'
        },
        subheadingConfluence: {
            id: 'twc.sidenav.banner.personalized.subheading.confluence',
            defaultMessage: 'Create with Rovo in Confluence',
            description: 'Personalized banner subheading when the recommended app is Confluence. Shown in the product sidenav.'
        },
        subheadingLoom: {
            id: 'twc.sidenav.banner.personalized.subheading.loom',
            defaultMessage: 'Record meetings with Loom, get instant notes and actions.',
            description: 'Personalized banner subheading when the recommended app is Loom. Shown in the product sidenav.'
        },
        ctaButton: {
            id: 'twc.sidenav.banner.personalized.cta',
            defaultMessage: 'Get started',
            description: 'CTA button text for the personalized missing-app activation banner in the product sidenav.'
        },
        closeLabel: {
            id: 'twc.sidenav.banner.personalized.close',
            defaultMessage: 'Close',
            description: 'Accessible label for the close button on the personalized missing-app activation banner.'
        }
    }
});
const $1550d239ccf2eadc$export$5f267215e0242e30 = (0, $8j5U7.defineContent)({
    default: {
        meetingNotesHeading: {
            id: 'twc.sidenav.banner.template.xflow.meeting.notes.heading',
            defaultMessage: 'Automate meeting notes',
            description: 'Heading for the Loom cross-flow banner on a Confluence page created from the Meeting Notes template.'
        },
        projectPlanHeading: {
            id: 'twc.sidenav.banner.template.xflow.project.plan.heading',
            defaultMessage: 'Instantly create a project plan',
            description: 'Heading for the Loom cross-flow banner on a Confluence page created from the Project Plan template.'
        },
        eowStatusReportHeading: {
            id: 'twc.sidenav.banner.template.xflow.eow.status.report.heading',
            defaultMessage: 'Instantly create reports',
            description: 'Heading for the Loom cross-flow banner on a Confluence page created from the End of Week Status Report template.'
        },
        decisionsHeading: {
            id: 'twc.sidenav.banner.template.xflow.decisions.heading',
            defaultMessage: 'Instantly capture decisions',
            description: 'Heading for the Loom cross-flow banner on a Confluence page created from the Decisions template.'
        },
        requirementsRaciHeading: {
            id: 'twc.sidenav.banner.template.xflow.requirements.raci.heading',
            defaultMessage: 'Instantly capture requirements',
            description: 'Heading for the Loom cross-flow banner on a Confluence page created from the Requirements RACI template.'
        },
        genericHeading: {
            id: 'twc.sidenav.banner.template.xflow.generic.heading',
            defaultMessage: 'Don\u2019t start from scratch',
            description: 'Heading for the Loom cross-flow banner on a supported Confluence template without dedicated copy.',
            role: 'title'
        },
        subheadingLoom: {
            id: 'twc.sidenav.banner.personalized.subheading.loom',
            defaultMessage: 'Record meetings with Loom, get instant notes and actions.',
            description: 'Personalized banner subheading when the recommended app is Loom. Shown in the product sidenav.'
        },
        subheadingConfluence: {
            id: 'twc.sidenav.banner.generic.subheading.confluence',
            defaultMessage: 'Discover how the other apps can accelerate your workflows in Confluence.',
            description: 'Subheading for the generic banner when shown in Confluence.',
            role: 'description'
        },
        personalizedSubheadingConfluence: {
            id: 'twc.sidenav.banner.personalized.subheading.confluence',
            defaultMessage: 'Create with Rovo in Confluence',
            description: 'Personalized banner subheading when the recommended app is Confluence. Shown in the product sidenav.'
        },
        tryItFree: {
            id: 'twc.sidenav.banner.template.xflow.try.it.free',
            defaultMessage: 'Try it free',
            description: 'CTA text for opening the Teamwork Collection cross-flow modal.'
        },
        remindMeLater: {
            id: 'twc.sidenav.banner.template.xflow.remind.me.later',
            defaultMessage: 'Remind me later',
            description: 'Action text for snoozing the Teamwork Collection cross-flow banner.'
        },
        closeLabel: {
            id: 'twc.sidenav.banner.personalized.close',
            defaultMessage: 'Close',
            description: 'Accessible label for the close button on the personalized missing-app activation banner.'
        }
    }
});


var $7c34c0b333c4df3a$exports = {};
$7c34c0b333c4df3a$exports = new URL("ai-notes.ebf93360.svg", import.meta.url).toString();


const $5246e19e673353ed$var$styles = {
    root: "_0bjKvD8fU6 _2YLqiKdnbC _3SamIH1Y8M _39xV02N91d _0KLXruVva3 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    layout: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLchRC",
    logoWrapper: "_3YEZNOdnbC",
    content: "_2O5Vij7dHp _4ouGXIdnbC",
    dismiss: "_3YEZNOdnbC",
    action: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0hPCNLDIqT _0KLXrujOvk _1UtDYzM7Tp _17lj8pgVvo _3iDTPbccYA _1kk5Tkf7mX _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2nTuUYM7Tp _10n1R5M7Tp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _0CMRbkAwSC"
};
const $5246e19e673353ed$var$subheadingByApp = {
    confluence: (0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.subheadingConfluence,
    jira: (0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.subheadingJira,
    loom: (0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.subheadingLoom
};
const $5246e19e673353ed$var$destinationTypeByApp = {
    confluence: 'create_with_rovo',
    jira: 'jira_onboarding',
    loom: 'loom_meetings'
};
const $5246e19e673353ed$export$44c5a4ad6d35d2bf = ({ heading: heading, href: href, locale: locale, recommendedApp: recommendedApp, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick, ctaLabel: ctaLabel, secondaryActionLabel: secondaryActionLabel, onSecondaryAction: onSecondaryAction, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId, surfaceProduct: surfaceProduct, blueprintModuleCompleteKey: blueprintModuleCompleteKey, messageTemplateId: messageTemplateId, placementId: placementId, promptSurface: promptSurface, reminderState: reminderState })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            recommendedApp: recommendedApp,
            messageInstanceId: messageInstanceId,
            locale: locale,
            experimentKey: experimentKey,
            actionTier: actionTier,
            targetTenantId: targetTenantId,
            collectionEntitlementId: collectionEntitlementId,
            surfaceProduct: surfaceProduct,
            destinationType: $5246e19e673353ed$var$destinationTypeByApp[recommendedApp],
            arm: 'personalized',
            blueprintModuleCompleteKey: blueprintModuleCompleteKey,
            messageTemplateId: messageTemplateId,
            placementId: placementId,
            promptSurface: promptSurface,
            reminderState: reminderState
        }), [
        recommendedApp,
        messageInstanceId,
        locale,
        experimentKey,
        actionTier,
        targetTenantId,
        collectionEntitlementId,
        surfaceProduct,
        blueprintModuleCompleteKey,
        messageTemplateId,
        placementId,
        promptSurface,
        reminderState
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcPersonalizedBanner',
            attributes: analyticsAttributes
        }).fire('growth');
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerClose',
            attributes: analyticsAttributes
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = (clickEvent)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerCta',
            attributes: analyticsAttributes
        }).fire('growth');
        onCtaClick?.(clickEvent);
    };
    const handleSecondaryAction = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerSecondaryAction',
            attributes: analyticsAttributes
        }).fire('growth');
        onSecondaryAction?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $5246e19e673353ed$var$styles.root,
        testId: "twc-personalized-banner",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: $5246e19e673353ed$var$styles.layout,
            testId: "twc-personalized-banner-layout",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $5246e19e673353ed$var$styles.logoWrapper,
                    testId: "twc-personalized-banner-logo",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7c34c0b333c4df3a$exports))),
                        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7c34c0b333c4df3a$exports))),
                        alt: "",
                        testId: "twc-personalized-banner-ai-notes-icon",
                        width: 40,
                        height: 40
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    xcss: $5246e19e673353ed$var$styles.content,
                    space: "space.100",
                    testId: "twc-personalized-banner-content",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                    as: "h3",
                                    size: "xsmall",
                                    testId: "twc-personalized-banner-heading",
                                    children: heading ?? formatMessage((0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.heading)
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    as: "p",
                                    size: "medium",
                                    color: "color.text.subtle",
                                    maxLines: 2,
                                    testId: "twc-personalized-banner-subheading",
                                    children: formatMessage($5246e19e673353ed$var$subheadingByApp[recommendedApp])
                                })
                            ]
                        }),
                        secondaryActionLabel ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            alignBlock: "center",
                            space: "space.100",
                            shouldWrap: true,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
                                    href: href,
                                    onClick: handleCtaClick,
                                    target: "_blank",
                                    testId: "twc-personalized-banner-cta",
                                    xcss: $5246e19e673353ed$var$styles.action,
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                                            label: ""
                                        }),
                                        ctaLabel ?? formatMessage((0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.ctaButton)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                    alignBlock: "center",
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                            "aria-hidden": true,
                                            children: "\xb7"
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                            onClick: handleSecondaryAction,
                                            testId: "twc-personalized-banner-secondary-action",
                                            xcss: $5246e19e673353ed$var$styles.action,
                                            children: secondaryActionLabel
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                            shouldFitContainer: true,
                            href: href,
                            testId: "twc-personalized-banner-cta",
                            onClick: handleCtaClick,
                            target: "_blank",
                            children: ctaLabel ?? formatMessage((0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.ctaButton)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $5246e19e673353ed$var$styles.dismiss,
                    testId: "twc-personalized-banner-dismiss",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                ...iconProps,
                                size: "medium"
                            }),
                        onClick: handleClose,
                        label: formatMessage((0, $1550d239ccf2eadc$export$ad2f6cca3fea287).personalized.closeLabel),
                        testId: "twc-personalized-banner-close",
                        appearance: "subtle"
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $fa1fb38180191a7e$export$a7a9523472993e97(value) {
    const result = $fa1fb38180191a7e$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $fa1fb38180191a7e$export$226b3eccf92c9ed9(value) {
    const result = $fa1fb38180191a7e$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $fa1fb38180191a7e$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('product' in value)) errors.push({
            path: 'value["product"]',
            expected: '"jira" | "confluence" | "jira-confluence"',
            value: undefined
        });
        else {
            let value__product___valid = false;
            if (!value__product___valid) {
                const value__product___errors_0 = [];
                if (value["product"] !== "jira") value__product___errors_0.push({
                    path: 'value["product"]',
                    expected: "jira",
                    value: value["product"]
                });
                if (value__product___errors_0.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_1 = [];
                if (value["product"] !== "confluence") value__product___errors_1.push({
                    path: 'value["product"]',
                    expected: "confluence",
                    value: value["product"]
                });
                if (value__product___errors_1.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_2 = [];
                if (value["product"] !== "jira-confluence") value__product___errors_2.push({
                    path: 'value["product"]',
                    expected: "jira-confluence",
                    value: value["product"]
                });
                if (value__product___errors_2.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) errors.push({
                path: 'value["product"]',
                expected: '"jira" | "confluence" | "jira-confluence"',
                value: value["product"]
            });
        }
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if ('orgId' in value && value['orgId'] !== undefined) {
            if (typeof value["orgId"] !== 'string') errors.push({
                path: 'value["orgId"]',
                expected: 'string',
                value: value["orgId"]
            });
        }
        if ('twcEntitlementId' in value && value['twcEntitlementId'] !== undefined) {
            if (typeof value["twcEntitlementId"] !== 'string') errors.push({
                path: 'value["twcEntitlementId"]',
                expected: 'string',
                value: value["twcEntitlementId"]
            });
        }
        if ('redirectTo' in value && value['redirectTo'] !== undefined) {
            let value__redirectTo___valid = false;
            if (!value__redirectTo___valid) {
                const value__redirectTo___errors_0 = [];
                if (value["redirectTo"] !== "jira") value__redirectTo___errors_0.push({
                    path: 'value["redirectTo"]',
                    expected: "jira",
                    value: value["redirectTo"]
                });
                if (value__redirectTo___errors_0.length === 0) value__redirectTo___valid = true;
            }
            if (!value__redirectTo___valid) {
                const value__redirectTo___errors_1 = [];
                if (value["redirectTo"] !== "confluence") value__redirectTo___errors_1.push({
                    path: 'value["redirectTo"]',
                    expected: "confluence",
                    value: value["redirectTo"]
                });
                if (value__redirectTo___errors_1.length === 0) value__redirectTo___valid = true;
            }
            if (!value__redirectTo___valid) errors.push({
                path: 'value["redirectTo"]',
                expected: '"jira" | "confluence"',
                value: value["redirectTo"]
            });
        }
        if (!('recommendedApp' in value)) errors.push({
            path: 'value["recommendedApp"]',
            expected: '"confluence" | "jira" | "loom"',
            value: undefined
        });
        else {
            let value__recommendedApp___valid = false;
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_0 = [];
                if (value["recommendedApp"] !== "confluence") value__recommendedApp___errors_0.push({
                    path: 'value["recommendedApp"]',
                    expected: "confluence",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_0.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_1 = [];
                if (value["recommendedApp"] !== "jira") value__recommendedApp___errors_1.push({
                    path: 'value["recommendedApp"]',
                    expected: "jira",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_1.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_2 = [];
                if (value["recommendedApp"] !== "loom") value__recommendedApp___errors_2.push({
                    path: 'value["recommendedApp"]',
                    expected: "loom",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_2.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) errors.push({
                path: 'value["recommendedApp"]',
                expected: '"confluence" | "jira" | "loom"',
                value: value["recommendedApp"]
            });
        }
        if (!('actionTier' in value)) errors.push({
            path: 'value["actionTier"]',
            expected: '"high" | "medium" | "low"',
            value: undefined
        });
        else {
            let value__actionTier___valid = false;
            if (!value__actionTier___valid) {
                const value__actionTier___errors_0 = [];
                if (value["actionTier"] !== "high") value__actionTier___errors_0.push({
                    path: 'value["actionTier"]',
                    expected: "high",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_0.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) {
                const value__actionTier___errors_1 = [];
                if (value["actionTier"] !== "medium") value__actionTier___errors_1.push({
                    path: 'value["actionTier"]',
                    expected: "medium",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_1.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) {
                const value__actionTier___errors_2 = [];
                if (value["actionTier"] !== "low") value__actionTier___errors_2.push({
                    path: 'value["actionTier"]',
                    expected: "low",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_2.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) errors.push({
                path: 'value["actionTier"]',
                expected: '"high" | "medium" | "low"',
                value: value["actionTier"]
            });
        }
        if ('targetTenantId' in value && value['targetTenantId'] !== undefined) {
            if (typeof value["targetTenantId"] !== 'string') errors.push({
                path: 'value["targetTenantId"]',
                expected: 'string',
                value: value["targetTenantId"]
            });
        }
        if ('collectionEntitlementId' in value && value['collectionEntitlementId'] !== undefined) {
            if (typeof value["collectionEntitlementId"] !== 'string') errors.push({
                path: 'value["collectionEntitlementId"]',
                expected: 'string',
                value: value["collectionEntitlementId"]
            });
        }
        if ('experimentKey' in value && value['experimentKey'] !== undefined) {
            if (typeof value["experimentKey"] !== 'string') errors.push({
                path: 'value["experimentKey"]',
                expected: 'string',
                value: value["experimentKey"]
            });
        }
        if ('explicitEnableRequired' in value && value['explicitEnableRequired'] !== undefined) {
            if (value["explicitEnableRequired"] !== true) errors.push({
                path: 'value["explicitEnableRequired"]',
                expected: true,
                value: value["explicitEnableRequired"]
            });
        }
        if ('tapReminderTrait' in value && value['tapReminderTrait'] !== undefined) {
            let value__tapReminderTrait___valid = false;
            if (!value__tapReminderTrait___valid) {
                const value__tapReminderTrait___errors_0 = [];
                if (value["tapReminderTrait"] !== "remind") value__tapReminderTrait___errors_0.push({
                    path: 'value["tapReminderTrait"]',
                    expected: "remind",
                    value: value["tapReminderTrait"]
                });
                if (value__tapReminderTrait___errors_0.length === 0) value__tapReminderTrait___valid = true;
            }
            if (!value__tapReminderTrait___valid) {
                const value__tapReminderTrait___errors_1 = [];
                if (value["tapReminderTrait"] !== "dismissed") value__tapReminderTrait___errors_1.push({
                    path: 'value["tapReminderTrait"]',
                    expected: "dismissed",
                    value: value["tapReminderTrait"]
                });
                if (value__tapReminderTrait___errors_1.length === 0) value__tapReminderTrait___valid = true;
            }
            if (!value__tapReminderTrait___valid) errors.push({
                path: 'value["tapReminderTrait"]',
                expected: '"remind" | "dismissed"',
                value: value["tapReminderTrait"]
            });
        }
        if ('triggerType' in value && value['triggerType'] !== undefined) {
            let value__triggerType___valid = false;
            if (!value__triggerType___valid) {
                const value__triggerType___errors_0 = [];
                if (value["triggerType"] !== "onPageLoad") value__triggerType___errors_0.push({
                    path: 'value["triggerType"]',
                    expected: "onPageLoad",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_0.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) {
                const value__triggerType___errors_1 = [];
                if (value["triggerType"] !== "gasV3") value__triggerType___errors_1.push({
                    path: 'value["triggerType"]',
                    expected: "gasV3",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_1.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) {
                const value__triggerType___errors_2 = [];
                if (value["triggerType"] !== "poTrigger") value__triggerType___errors_2.push({
                    path: 'value["triggerType"]',
                    expected: "poTrigger",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_2.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) {
                const value__triggerType___errors_3 = [];
                if (value["triggerType"] !== "subscription") value__triggerType___errors_3.push({
                    path: 'value["triggerType"]',
                    expected: "subscription",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_3.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) errors.push({
                path: 'value["triggerType"]',
                expected: '"onPageLoad" | "gasV3" | "poTrigger" | "subscription"',
                value: value["triggerType"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $4d565ea55fdf3dde$export$651f5f7d95040eeb = 'twc-sidenav-banner';
const $4d565ea55fdf3dde$export$21a6d97c5ae1b251 = 'confluence-side-nav';
const $4d565ea55fdf3dde$export$f3e581e8aaf5e6a0 = 'twcg-2112-confluence-template-xflow-banner-render';
const $4d565ea55fdf3dde$export$85d98a7b4ecdfc88 = 'renderer-error';
const $4d565ea55fdf3dde$export$f4df7bbb8ab89006 = {
    DELIVERY_CANCELLED: 'delivery-cancelled',
    POST_OFFICE_TEARDOWN: 'post-office-teardown',
    COMPONENT_UNMOUNTED: 'component-unmounted'
};



const $b18ab7fb83d8776b$var$TEMPLATE_XFLOW_GATE = 'twcg-2112-twc-xflow-conf-pages-templates-gate';
const $b18ab7fb83d8776b$var$TEMPLATE_VIEW_TRIGGER_ID = 'twcg-2112-template-view-trigger';
const $b18ab7fb83d8776b$var$TEMPLATE_APPLIED_TRIGGER_ID = 'twcg-2112-template-applied-trigger';
const $b18ab7fb83d8776b$var$TEMPLATE_XFLOW_DELAY_MS = 3000;
const $b18ab7fb83d8776b$var$templateXflowHeadingByBlueprintModuleCompleteKey = {
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).MEETING_NOTES]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.meetingNotesHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).PROJECT_PLAN]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.projectPlanHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).EOW_STATUS_REPORT]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.eowStatusReportHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).DECISIONS]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.decisionsHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).REQUIREMENTS_RACI]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.requirementsRaciHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).RETROSPECTIVES]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.genericHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).BUSINESS_STATUS_UPDATE]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.genericHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).ONE_ON_ONE_MEETING]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.genericHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).RECURRING_MEETING_MINUTES]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.genericHeading,
    [(0, $530dc45a2cd6a79e$export$1db5857ce669e9b7).PROJECT_STATUS]: (0, $1550d239ccf2eadc$export$5f267215e0242e30).default.genericHeading
};
const $b18ab7fb83d8776b$var$templateXflowRenderMetadata = {
    messageTemplateId: (0, $4d565ea55fdf3dde$export$651f5f7d95040eeb),
    placementId: (0, $4d565ea55fdf3dde$export$21a6d97c5ae1b251),
    owner: 'growth-starburst'
};
const $b18ab7fb83d8776b$var$useTemplateXflowRenderLifecycle = ()=>{
    const experienceRef = (0, $cozmU.useRef)(null);
    const stateRef = (0, $cozmU.useRef)('idle');
    const start = (0, $cozmU.useCallback)(()=>{
        if (stateRef.current !== 'idle') return;
        const experience = new (0, $34VCg.UFOExperience)((0, $4d565ea55fdf3dde$export$f3e581e8aaf5e6a0), {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load
        });
        experienceRef.current = experience;
        stateRef.current = 'running';
        experience.start();
    }, []);
    const complete = (0, $cozmU.useCallback)(()=>{
        if (stateRef.current !== 'running' || !experienceRef.current) return;
        stateRef.current = 'terminal';
        experienceRef.current.success({
            metadata: $b18ab7fb83d8776b$var$templateXflowRenderMetadata
        });
    }, []);
    const fail = (0, $cozmU.useCallback)((_error)=>{
        if (stateRef.current !== 'running' || !experienceRef.current) return;
        stateRef.current = 'terminal';
        experienceRef.current.failure({
            metadata: {
                ...$b18ab7fb83d8776b$var$templateXflowRenderMetadata,
                reason: (0, $4d565ea55fdf3dde$export$85d98a7b4ecdfc88)
            }
        });
    }, []);
    const abort = (0, $cozmU.useCallback)((reason)=>{
        if (stateRef.current !== 'running' || !experienceRef.current) return;
        stateRef.current = 'terminal';
        experienceRef.current.abort({
            metadata: {
                ...$b18ab7fb83d8776b$var$templateXflowRenderMetadata,
                reason: reason
            }
        });
    }, []);
    (0, $cozmU.useEffect)(()=>()=>{
            abort((0, $4d565ea55fdf3dde$export$f4df7bbb8ab89006).COMPONENT_UNMOUNTED);
        }, [
        abort
    ]);
    return (0, $cozmU.useMemo)(()=>({
            start: start,
            complete: complete,
            fail: fail,
            abort: abort
        }), [
        abort,
        complete,
        fail,
        start
    ]);
};
const $b18ab7fb83d8776b$var$TemplateXflowRenderStart = ({ renderLifecycle: renderLifecycle, children: children })=>{
    const [hasStarted, setHasStarted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        renderLifecycle.start();
        setHasStarted(true);
    }, [
        renderLifecycle
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            renderLifecycle.abort((0, $4d565ea55fdf3dde$export$f4df7bbb8ab89006).DELIVERY_CANCELLED);
        }, [
        renderLifecycle
    ]);
    return hasStarted ? children : null;
};
const $b18ab7fb83d8776b$var$TemplateXflowBannerContent = ({ heading: heading, blueprintModuleCompleteKey: blueprintModuleCompleteKey, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { templateXflow: templateXflow } = (0, $cozmU.useContext)((0, $5nuFe.ConfluenceExperimentsContext));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageDismissed: messageDismissed, messageSnoozed: messageSnoozed } = (0, $baFbJ.useMessageEvent)();
    const { onClosed: onClosed, onCtaActioned: onCtaActioned, onSnoozed: onSnoozed } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const reminderState = props.tapReminderTrait ?? templateXflow?.reminderState ?? 'absent';
    const additionalMetadataFromFrontend = {
        promptSurface: 'sideNavBanner',
        blueprintModuleCompleteKey: blueprintModuleCompleteKey,
        experimentKey: (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY),
        messageTemplateId: (0, $4d565ea55fdf3dde$export$651f5f7d95040eeb),
        placementId: (0, $4d565ea55fdf3dde$export$21a6d97c5ae1b251),
        reminderState: reminderState
    };
    const fireTemplateXflowReminderChanged = (reminderState, sourceAction)=>{
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'changed',
            actionSubject: 'twcTemplateXflowReminder',
            attributes: {
                blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                experimentKey: (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY),
                reminderState: reminderState,
                source: 'sideNavBanner',
                sourceAction: sourceAction
            }
        });
    };
    const handleDismiss = ()=>{
        templateXflow?.dismissForSession();
        fireTemplateXflowReminderChanged('dismissed', 'explicitDismiss');
        onClosed({
            interactionIdentifier: 'twcg2112Dismiss',
            additionalMetadata: additionalMetadataFromFrontend
        });
        messageDismissed();
        props.handleOnDismissed();
    };
    const handleTryItFree = (clickEvent)=>{
        clickEvent.preventDefault();
        templateXflow?.dismissForSession();
        fireTemplateXflowReminderChanged('dismissed', 'tryItFree');
        onCtaActioned({
            interactionIdentifier: 'twcg2112TryItFree',
            destinationUrl: props.onboardingUrl,
            additionalMetadata: additionalMetadataFromFrontend
        });
        templateXflow?.openTwcXflowModal?.('confluence-xflow-sidenav');
        messageDismissed();
        props.handleOnDismissed();
    };
    const handleRemindMeLater = ()=>{
        fireTemplateXflowReminderChanged('remind', 'remindMeLater');
        onSnoozed({
            interactionIdentifier: 'twcg2112RemindMeLater',
            durationDays: 1,
            additionalMetadata: additionalMetadataFromFrontend
        });
        messageSnoozed(1);
        props.handleOnDismissed();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5246e19e673353ed$export$44c5a4ad6d35d2bf), {
        heading: heading,
        locale: props.locale,
        recommendedApp: "loom",
        onClose: handleDismiss,
        onCtaClick: handleTryItFree,
        ctaLabel: formatMessage((0, $1550d239ccf2eadc$export$5f267215e0242e30).default.tryItFree),
        secondaryActionLabel: formatMessage((0, $1550d239ccf2eadc$export$5f267215e0242e30).default.remindMeLater),
        onSecondaryAction: handleRemindMeLater,
        href: props.onboardingUrl,
        messageInstanceId: props.messageInstanceId,
        experimentKey: props.experimentKey,
        actionTier: props.actionTier,
        targetTenantId: props.targetTenantId,
        collectionEntitlementId: props.collectionEntitlementId,
        surfaceProduct: "confluence",
        blueprintModuleCompleteKey: blueprintModuleCompleteKey,
        messageTemplateId: (0, $4d565ea55fdf3dde$export$651f5f7d95040eeb),
        placementId: (0, $4d565ea55fdf3dde$export$21a6d97c5ae1b251),
        promptSurface: "sideNavBanner",
        reminderState: reminderState
    });
};
const $b18ab7fb83d8776b$var$TemplateXflowBannerCore = ({ renderLifecycle: renderLifecycle, ...props })=>{
    const { tapReminderTrait: tapReminderTrait, waitForTrigger: waitForTrigger } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isActive: isTemplateViewTriggerActive } = (0, $6m3nS.useTrigger)($b18ab7fb83d8776b$var$TEMPLATE_VIEW_TRIGGER_ID);
    const { isActive: isTemplateAppliedTriggerActive } = (0, $6m3nS.useTrigger)($b18ab7fb83d8776b$var$TEMPLATE_APPLIED_TRIGGER_ID);
    const { fireTrigger: fireTemplateViewTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $b18ab7fb83d8776b$var$TEMPLATE_VIEW_TRIGGER_ID
    });
    const { fireTrigger: fireTemplateAppliedTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $b18ab7fb83d8776b$var$TEMPLATE_APPLIED_TRIGGER_ID
    });
    const { templateXflow: templateXflow } = (0, $cozmU.useContext)((0, $5nuFe.ConfluenceExperimentsContext));
    const currentPageTemplateData = templateXflow?.currentPageTemplateData;
    const blueprintModuleCompleteKey = currentPageTemplateData?.blueprintModuleCompleteKey;
    const templateHeadingDescriptor = blueprintModuleCompleteKey ? $b18ab7fb83d8776b$var$templateXflowHeadingByBlueprintModuleCompleteKey[blueprintModuleCompleteKey] : undefined;
    const templateHeading = templateHeadingDescriptor ? formatMessage(templateHeadingDescriptor) : undefined;
    const isTemplateXflowCohortEligible = currentPageTemplateData?.isEligible === true || tapReminderTrait === 'remind';
    const isTemplateXflowDismissed = tapReminderTrait === 'dismissed' || templateXflow?.reminderState === 'dismissed' || templateXflow?.isTerminallyDismissed === true;
    const isTemplateTriggerActive = Boolean(isTemplateViewTriggerActive) || Boolean(isTemplateAppliedTriggerActive);
    const isTemplateXflowGateEnabled = (0, $iDrrr.fg)($b18ab7fb83d8776b$var$TEMPLATE_XFLOW_GATE);
    const shouldStartTemplateXflowDelay = isTemplateXflowGateEnabled && !isTemplateXflowDismissed && isTemplateXflowCohortEligible && isTemplateTriggerActive && Boolean(currentPageTemplateData?.contentId) && Boolean(templateHeadingDescriptor);
    const [hasTemplateXflowDelayElapsed, setHasTemplateXflowDelayElapsed] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setHasTemplateXflowDelayElapsed(false);
        if (!shouldStartTemplateXflowDelay) return;
        const timeoutId = setTimeout(()=>{
            setHasTemplateXflowDelayElapsed(true);
        }, $b18ab7fb83d8776b$var$TEMPLATE_XFLOW_DELAY_MS);
        return ()=>clearTimeout(timeoutId);
    }, [
        blueprintModuleCompleteKey,
        currentPageTemplateData?.contentId,
        shouldStartTemplateXflowDelay
    ]);
    const resetTemplateTriggers = (0, $cozmU.useCallback)(()=>{
        renderLifecycle.abort((0, $4d565ea55fdf3dde$export$f4df7bbb8ab89006).POST_OFFICE_TEARDOWN);
        fireTemplateViewTrigger({
            isActive: false
        });
        fireTemplateAppliedTrigger({
            isActive: false
        });
    }, [
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger,
        renderLifecycle
    ]);
    if (isTemplateXflowDismissed || !templateHeading || !blueprintModuleCompleteKey || !waitForTrigger) return null;
    return waitForTrigger({
        isTriggerActive: hasTemplateXflowDelayElapsed,
        messageContent: /*#__PURE__*/ (0, $8aG6j.jsx)($b18ab7fb83d8776b$var$TemplateXflowRenderStart, {
            renderLifecycle: renderLifecycle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                onMount: renderLifecycle.complete,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($b18ab7fb83d8776b$var$TemplateXflowBannerContent, {
                    ...props,
                    heading: templateHeading,
                    blueprintModuleCompleteKey: blueprintModuleCompleteKey
                })
            })
        }),
        onTeardown: resetTemplateTriggers
    });
};
const $b18ab7fb83d8776b$var$TemplateXflowBannerWithErrorBoundary = (0, $8BCsI.withErrorBoundary)($b18ab7fb83d8776b$var$TemplateXflowBannerCore);
const $b18ab7fb83d8776b$var$TemplateXflowBanner = (props)=>{
    const renderLifecycle = $b18ab7fb83d8776b$var$useTemplateXflowRenderLifecycle();
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b18ab7fb83d8776b$var$TemplateXflowBannerWithErrorBoundary, {
        ...props,
        renderLifecycle: renderLifecycle,
        errorBoundaryLocation: (0, $4d565ea55fdf3dde$export$f3e581e8aaf5e6a0),
        placementId: (0, $4d565ea55fdf3dde$export$21a6d97c5ae1b251),
        messageTemplateId: (0, $4d565ea55fdf3dde$export$651f5f7d95040eeb),
        onError: renderLifecycle.fail,
        fallbackRender: ()=>null
    });
};
const $b18ab7fb83d8776b$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $fa1fb38180191a7e$export$a7a9523472993e97),
        Component: (props)=>{
            const { experimentKey: experimentKey, explicitEnableRequired: explicitEnableRequired } = props;
            const isTemplateXflowMessage = experimentKey === (0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY) && explicitEnableRequired === true;
            if (isTemplateXflowMessage) return /*#__PURE__*/ (0, $8aG6j.jsx)($b18ab7fb83d8776b$var$TemplateXflowBanner, {
                ...props
            });
            return null;
        }
    }
});



// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $8621e111a73e005f$export$a7a9523472993e97(value) {
    const result = $8621e111a73e005f$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $8621e111a73e005f$export$226b3eccf92c9ed9(value) {
    const result = $8621e111a73e005f$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $8621e111a73e005f$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('product' in value)) errors.push({
            path: 'value["product"]',
            expected: '"jira" | "confluence"',
            value: undefined
        });
        else {
            let value__product___valid = false;
            if (!value__product___valid) {
                const value__product___errors_0 = [];
                if (value["product"] !== "jira") value__product___errors_0.push({
                    path: 'value["product"]',
                    expected: "jira",
                    value: value["product"]
                });
                if (value__product___errors_0.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_1 = [];
                if (value["product"] !== "confluence") value__product___errors_1.push({
                    path: 'value["product"]',
                    expected: "confluence",
                    value: value["product"]
                });
                if (value__product___errors_1.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) errors.push({
                path: 'value["product"]',
                expected: '"jira" | "confluence"',
                value: value["product"]
            });
        }
        if (!('orgId' in value)) errors.push({
            path: 'value["orgId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["orgId"] !== 'string') errors.push({
            path: 'value["orgId"]',
            expected: 'string',
            value: value["orgId"]
        });
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('twcEntitlementId' in value)) errors.push({
            path: 'value["twcEntitlementId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["twcEntitlementId"] !== 'string') errors.push({
            path: 'value["twcEntitlementId"]',
            expected: 'string',
            value: value["twcEntitlementId"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $22a65248c86e7a72$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $8621e111a73e005f$export$a7a9523472993e97),
        Component: ()=>null
    }
});






/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $bGVJw = parcelRequire("bGVJw");


































/**
 * Derives environment type from the current hostname (for use in browser).
 * Prod -> admin.atlassian.com; staging/dev/other -> admin.stg.atlassian.com (org path appended when building URLs).
 */ function $a40419a76c3eca50$export$469d38ee9e6df4c6(hostname) {
    if (typeof hostname !== 'string') return 'prod';
    const h = hostname.toLowerCase();
    if (h.includes('dev.') || h.includes('.dev')) return 'dev';
    if (h.includes('stg') || h.includes('staging')) return 'staging';
    return 'prod';
}
function $a40419a76c3eca50$export$76bb37a926058cca(envType) {
    return envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
}
function $a40419a76c3eca50$export$1f35d872aef2b7bd(orgId, envType) {
    const base = envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    return `${base}/o/${orgId}/rovo`;
}
function $a40419a76c3eca50$export$d3d28c6fd94dcc27(orgId, envType) {
    if (orgId && orgId.trim() !== '') return $a40419a76c3eca50$export$1f35d872aef2b7bd(orgId, envType);
    return $a40419a76c3eca50$export$76bb37a926058cca(envType);
}





const $b8943d103cc5978e$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        headingLabel: {
            id: 'post-office.confluence-rovo-onboarding-banner.heading',
            defaultMessage: 'Rovo is ready for you',
            description: 'Heading for the Rovo onboarding banner.',
            role: 'title'
        },
        bodyLabel: {
            id: 'post-office.confluence-rovo-onboarding-banner.body',
            defaultMessage: "Power up your workspace. Set up and configure connectors to unlock all Rovo's potential.",
            description: 'Body text for the Rovo onboarding banner.',
            role: 'description'
        },
        callToActionLabel: {
            id: 'post-office.confluence-rovo-onboarding-banner.call.to.action',
            defaultMessage: 'Get started',
            description: 'Call to action button on the Rovo onboarding banner.'
        },
        whyAmISeeingThisModalMessage: {
            id: 'post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message',
            defaultMessage: "We think setting up Rovo and connecting apps will improve your team's productivity. You're seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo's features by configuring connectors.",
            description: 'Message explaining why the user is seeing this banner.'
        },
        whyAmISeeingThisModalReason: {
            id: 'post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason',
            defaultMessage: 'Rovo is available to your team and you are an organizational admin',
            description: 'Reason for showing the banner.'
        }
    }
});





var $9782409b1e49ac55$exports = {};
$9782409b1e49ac55$exports = new URL("rovo-icon.999e8c7b.png", import.meta.url).toString();


const $a2f96def754bf75d$export$5b537697406f44db = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9782409b1e49ac55$exports))),
        alt: "Rovo",
        width: 32,
        height: 32
    });


const $61828417889953d1$var$styles = {
    root: "_0bjKvD8fU6 _1mT5xdRAKS _2O5Vij7dHp _0KLXruVva3",
    primaryContentContainer: "_4FKVYE5zaO _2O5Vij7dHp",
    headingContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    iconContainer: "_3YEZNOdnbC _39xV02Uofl _0jFU0VUofl",
    ctaWrapper: "_3138421Y8M",
    adControlsContainer: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO"
};
const $61828417889953d1$export$badffec00386b3b8 = ({ action: action, orgId: orgIdFromMessage, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)(); // Use orgId from message context first; fallback to product/placement context (e.g. when message payload omits it but event context has it)
    const orgId = orgIdFromMessage ?? (typeof postOfficeContext?.orgId === 'string' ? postOfficeContext.orgId : undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onCtaActioned: onCtaActioned, onClosed: onClosed } = (0, $3jNKT.usePostOfficeUserInteractions)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceRovoOnboardingBanner'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rovoAdminUrl = (0, $cozmU.useMemo)(()=>{
        if (!globalThis.location) return '#';
        const envType = (0, $a40419a76c3eca50$export$469d38ee9e6df4c6)(globalThis.location.hostname);
        return (0, $a40419a76c3eca50$export$d3d28c6fd94dcc27)(orgId, envType);
    }, [
        orgId
    ]);
    const handleOnPrimaryActionClick = ()=>{
        onCtaActioned({
            interactionIdentifier: 'getStarted'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoOnboardingBannerCta'
        });
        onPrimaryActionClick?.(action);
        if (rovoAdminUrl && rovoAdminUrl !== '#' && globalThis.location) globalThis.location.href = rovoAdminUrl;
    };
    const handleOnDismissed = (_dismissedMessageInstanceId)=>{
        onClosed({
            interactionIdentifier: 'dismiss'
        });
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-rovo-onboarding-banner'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            xcss: $61828417889953d1$var$styles.root,
            testId: "confluence-rovo-onboarding-banner",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                    xcss: $61828417889953d1$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                            xcss: $61828417889953d1$var$styles.headingContainer,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: $61828417889953d1$var$styles.iconContainer,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2f96def754bf75d$export$5b537697406f44db), {})
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...(0, $b8943d103cc5978e$export$e1c3efc64f2d806f).default.headingLabel
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...(0, $b8943d103cc5978e$export$e1c3efc64f2d806f).default.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $61828417889953d1$var$styles.ctaWrapper,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                                href: rovoAdminUrl,
                                onClick: handleOnPrimaryActionClick,
                                spacing: "compact",
                                target: "_self",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...(0, $b8943d103cc5978e$export$e1c3efc64f2d806f).default.callToActionLabel
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $61828417889953d1$var$styles.adControlsContainer,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                        iconSize: "small",
                        spacing: "compact",
                        onDismissed: handleOnDismissed,
                        showWhyAmISeeingThis: true,
                        whyAmISeeingThisModalContent: {
                            message: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...(0, $b8943d103cc5978e$export$e1c3efc64f2d806f).default.whyAmISeeingThisModalMessage
                            }),
                            reasons: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...(0, $b8943d103cc5978e$export$e1c3efc64f2d806f).default.whyAmISeeingThisModalReason
                                }, "reason")
                            ]
                        }
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $bf79ba73913f19cc$export$a7a9523472993e97(value) {
    const result = $bf79ba73913f19cc$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $bf79ba73913f19cc$export$226b3eccf92c9ed9(value) {
    const result = $bf79ba73913f19cc$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $bf79ba73913f19cc$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: undefined
        });
        else {
            let value__nextBestActionType___valid = false;
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_0 = [];
                if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_SPACE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_1 = [];
                if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_PAGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_2 = [];
                if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WHITEBOARD",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_3 = [];
                if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                    path: 'value["nextBestActionType"]',
                    expected: "1_ON_1_LOOM_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_4 = [];
                if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                    path: 'value["nextBestActionType"]',
                    expected: "LOOM_AI_MEETING_NOTES",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_5 = [];
                if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                    path: 'value["nextBestActionType"]',
                    expected: "RESURRECTED_USER_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_6 = [];
                if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WITH_ROVO_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_7 = [];
                if (value["nextBestActionType"] !== "MCP_SETUP_NUDGE") value__nextBestActionType___errors_7.push({
                    path: 'value["nextBestActionType"]',
                    expected: "MCP_SETUP_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_8 = [];
                if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_8.push({
                    path: 'value["nextBestActionType"]',
                    expected: "ROVO_EXTENSION_CTA",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_9 = [];
                if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_9.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CONNECT_3P_TOOLS_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_9.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) errors.push({
                path: 'value["nextBestActionType"]',
                expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
                value: value["nextBestActionType"]
            });
        }
        if ('tenantId' in value && value['tenantId'] !== undefined) {
            if (typeof value["tenantId"] !== 'string') errors.push({
                path: 'value["tenantId"]',
                expected: 'string',
                value: value["tenantId"]
            });
        }
        if ('orgId' in value && value['orgId'] !== undefined) {
            if (typeof value["orgId"] !== 'string') errors.push({
                path: 'value["orgId"]',
                expected: 'string',
                value: value["orgId"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $e4c6014e88ba8d6e$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $bf79ba73913f19cc$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, orgId: orgId, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $61828417889953d1$export$badffec00386b3b8), {
                action: nextBestActionType,
                orgId: orgId,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});









// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $e184676353c1fc93$export$a7a9523472993e97(value) {
    const result = $e184676353c1fc93$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $e184676353c1fc93$export$226b3eccf92c9ed9(value) {
    const result = $e184676353c1fc93$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $e184676353c1fc93$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: undefined
        });
        else {
            let value__nextBestActionType___valid = false;
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_0 = [];
                if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_SPACE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_1 = [];
                if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_PAGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_2 = [];
                if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WHITEBOARD",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_3 = [];
                if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                    path: 'value["nextBestActionType"]',
                    expected: "1_ON_1_LOOM_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_4 = [];
                if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                    path: 'value["nextBestActionType"]',
                    expected: "LOOM_AI_MEETING_NOTES",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_5 = [];
                if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                    path: 'value["nextBestActionType"]',
                    expected: "RESURRECTED_USER_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_6 = [];
                if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WITH_ROVO_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_7 = [];
                if (value["nextBestActionType"] !== "MCP_SETUP_NUDGE") value__nextBestActionType___errors_7.push({
                    path: 'value["nextBestActionType"]',
                    expected: "MCP_SETUP_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_8 = [];
                if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_8.push({
                    path: 'value["nextBestActionType"]',
                    expected: "ROVO_EXTENSION_CTA",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_9 = [];
                if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_9.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CONNECT_3P_TOOLS_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_9.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) errors.push({
                path: 'value["nextBestActionType"]',
                expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
                value: value["nextBestActionType"]
            });
        }
        if (!('cohort' in value)) errors.push({
            path: 'value["cohort"]',
            expected: '"single-connect-in-onboarding" | "multi-connect-in-onboarding" | "control"',
            value: undefined
        });
        else {
            let value__cohort___valid = false;
            if (!value__cohort___valid) {
                const value__cohort___errors_0 = [];
                if (value["cohort"] !== "single-connect-in-onboarding") value__cohort___errors_0.push({
                    path: 'value["cohort"]',
                    expected: "single-connect-in-onboarding",
                    value: value["cohort"]
                });
                if (value__cohort___errors_0.length === 0) value__cohort___valid = true;
            }
            if (!value__cohort___valid) {
                const value__cohort___errors_1 = [];
                if (value["cohort"] !== "multi-connect-in-onboarding") value__cohort___errors_1.push({
                    path: 'value["cohort"]',
                    expected: "multi-connect-in-onboarding",
                    value: value["cohort"]
                });
                if (value__cohort___errors_1.length === 0) value__cohort___valid = true;
            }
            if (!value__cohort___valid) {
                const value__cohort___errors_2 = [];
                if (value["cohort"] !== "control") value__cohort___errors_2.push({
                    path: 'value["cohort"]',
                    expected: "control",
                    value: value["cohort"]
                });
                if (value__cohort___errors_2.length === 0) value__cohort___valid = true;
            }
            if (!value__cohort___valid) errors.push({
                path: 'value["cohort"]',
                expected: '"single-connect-in-onboarding" | "multi-connect-in-onboarding" | "control"',
                value: value["cohort"]
            });
        }
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('userId' in value)) errors.push({
            path: 'value["userId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["userId"] !== 'string') errors.push({
            path: 'value["userId"]',
            expected: 'string',
            value: value["userId"]
        });
        if (!('unconnectedApps' in value)) errors.push({
            path: 'value["unconnectedApps"]',
            expected: '("google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint")[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["unconnectedApps"])) errors.push({
                path: 'value["unconnectedApps"]',
                expected: 'array',
                value: value["unconnectedApps"]
            });
            if (Array.isArray(value["unconnectedApps"])) value["unconnectedApps"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (element !== "google-drive") element_errors_0.push({
                            path: 'element',
                            expected: "google-drive",
                            value: element
                        });
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (element !== "slack") element_errors_1.push({
                            path: 'element',
                            expected: "slack",
                            value: element
                        });
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_2 = [];
                        if (element !== "figma") element_errors_2.push({
                            path: 'element',
                            expected: "figma",
                            value: element
                        });
                        if (element_errors_2.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_3 = [];
                        if (element !== "github") element_errors_3.push({
                            path: 'element',
                            expected: "github",
                            value: element
                        });
                        if (element_errors_3.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_4 = [];
                        if (element !== "onedrive") element_errors_4.push({
                            path: 'element',
                            expected: "onedrive",
                            value: element
                        });
                        if (element_errors_4.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_5 = [];
                        if (element !== "sharepoint") element_errors_5.push({
                            path: 'element',
                            expected: "sharepoint",
                            value: element
                        });
                        if (element_errors_5.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"',
                        value: element
                    });
                }
            });
        }
        if (!('topApps' in value)) errors.push({
            path: 'value["topApps"]',
            expected: '("google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint")[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["topApps"])) errors.push({
                path: 'value["topApps"]',
                expected: 'array',
                value: value["topApps"]
            });
            if (Array.isArray(value["topApps"])) value["topApps"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (element !== "google-drive") element_errors_0.push({
                            path: 'element',
                            expected: "google-drive",
                            value: element
                        });
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (element !== "slack") element_errors_1.push({
                            path: 'element',
                            expected: "slack",
                            value: element
                        });
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_2 = [];
                        if (element !== "figma") element_errors_2.push({
                            path: 'element',
                            expected: "figma",
                            value: element
                        });
                        if (element_errors_2.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_3 = [];
                        if (element !== "github") element_errors_3.push({
                            path: 'element',
                            expected: "github",
                            value: element
                        });
                        if (element_errors_3.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_4 = [];
                        if (element !== "onedrive") element_errors_4.push({
                            path: 'element',
                            expected: "onedrive",
                            value: element
                        });
                        if (element_errors_4.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_5 = [];
                        if (element !== "sharepoint") element_errors_5.push({
                            path: 'element',
                            expected: "sharepoint",
                            value: element
                        });
                        if (element_errors_5.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"',
                        value: element
                    });
                }
            });
        }
        if (!('department' in value)) errors.push({
            path: 'value["department"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["department"] !== 'string') errors.push({
            path: 'value["department"]',
            expected: 'string',
            value: value["department"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 










































var $dZ3U4 = parcelRequire("dZ3U4");


var $dAuCI = parcelRequire("dAuCI");


var $fR63l = parcelRequire("fR63l");


var $8dynS = parcelRequire("8dynS");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $3d3WW = parcelRequire("3d3WW");


var $ad7Ou = parcelRequire("ad7Ou");







var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");












var $4YcXR = parcelRequire("4YcXR");


var $g9AoR = parcelRequire("g9AoR");


var $f7AuD = parcelRequire("f7AuD");


var $9VQ5f = parcelRequire("9VQ5f");







const $14a0142c560cd56e$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    // `default` holds the side-nav banner copy; `role: 'title'` / `role: 'description'`
    // mark the two descriptors the offline content loader / reranker reads.
    default: {
        headingLabel: {
            id: 'post-office.confluence-connect-3p-tools-nudge.heading',
            defaultMessage: 'See more at a glance',
            description: 'Heading for the Confluence 3p connect your tools side nav nudge.',
            role: 'title'
        },
        multiAppBodyLabel: {
            id: 'post-office.confluence-connect-3p-tools-nudge.multi-app-body',
            defaultMessage: 'Connect your apps to embed rich links in this space.',
            description: 'Body text for the Confluence 3p connect your tools side nav nudge.',
            role: 'description'
        },
        singleAppBodyLabel: {
            id: 'post-office.confluence-connect-3p-tools-nudge.single-app-body',
            defaultMessage: 'Connect {appName} to embed rich links in this space.',
            description: 'Body text for the Confluence 3p connect your tools side nav nudge.'
        },
        callToActionForMultiAppLabel: {
            id: 'post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action',
            defaultMessage: 'Connect apps',
            description: 'Call to action button on the Confluence 3p connect your tools side nav nudge.'
        },
        callToActionForSingleAppLabel: {
            id: 'post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action',
            defaultMessage: 'Connect {appName}',
            description: 'Call to action button on the Confluence 3p connect your tools side nav nudge.'
        },
        dismissLabel: {
            id: 'post-office.confluence-connect-3p-tools-nudge.dismiss',
            defaultMessage: 'Dismiss',
            description: 'Dismiss button on the Confluence 3p connect your tools side nav nudge.'
        }
    },
    // `modal` holds the "connect your most-used apps" modal copy.
    modal: {
        modalTitle: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.title',
            defaultMessage: 'Connect your most-used apps',
            description: 'Title of the modal that allows users to connect 3rd party tools.',
            role: 'title'
        },
        modalSubtitle: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.subtitle',
            defaultMessage: '<strong>Bring your team\u2019s work</strong> into Confluence pages with rich, interactive previews \u2013 no tab-switching needed.',
            description: 'Subtitle of the modal that allows users to connect 3rd party tools.',
            role: 'description'
        },
        modalTeammatesEmpty: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty',
            defaultMessage: 'Teams stay in sync by seeing live updates directly in Confluence.',
            description: 'Shown below the connector list when no teammates have connected an app (0 teammates).'
        },
        modalTeammatesFew: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.few',
            defaultMessage: 'Your team is already using {appName} to work smarter.',
            description: 'Shown below the connector list when 1-20 teammates have connected the app.'
        },
        modalTeammatesMany: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.many',
            defaultMessage: '\uD83D\uDE4C <strong>{numTeammates} teammates</strong> already connected {appName} to Confluence.',
            description: 'Shown below the connector list when 21-50 teammates have connected the app.'
        },
        modalTeammatesLots: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots',
            defaultMessage: '\uD83D\uDE4C <strong>50+ teammates</strong> already connected {appName} to Confluence.',
            description: 'Shown below the connector list when more than 50 teammates have connected the app.'
        },
        modalClose: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.close',
            defaultMessage: 'Close',
            description: 'Close button in the 3p tools modal.'
        },
        modalDismiss: {
            id: 'post-office.confluence-connect-3p-tools-nudge.modal.dismiss',
            defaultMessage: 'Dismiss',
            description: 'Dismiss button in the 3p tools modal footer.'
        }
    }
});


// split-screen modal experience is based on.
const $f4b0dbc0e11852da$var$ACCOUNT_SETUP_MODAL_DESKTOP_HEIGHT = '665px';
const $f4b0dbc0e11852da$var$styles = {
    closeButtonContainer: "_1mT5xdWVPG _4ApkO25zaO _2IhTon5zaO",
    modalBody: "_0bjKvDOLYo _4bt5LAnQyn _2WAcuGnQyn _4AOKIspahA",
    dynamicComponentContainer: "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _0KLXrup9dS _0mcu6jOLYo _3kIZMxOLYo _24h04i2Njc _3iDTPbQ4SZ _0jFU0VN91d _37wbyuDIqT _1wydGWyFLW _1mT5xdRAKS _39xV02N91d"
};
const $f4b0dbc0e11852da$var$ACCOUNT_SETUP_CHANNEL = 'accountSetup';
const $f4b0dbc0e11852da$var$VALID_EVENT_TYPES = [
    'ui',
    'track',
    'operational'
];
const $f4b0dbc0e11852da$export$2586b970714caf78 = ({ isOpen: isOpen, onClose: onClose, connectorResources: connectorResources, onConnectorConnected: onConnectorConnected, numTeammates: numTeammates, appName: appName, topApps: topApps, department: department })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const onAnalyticsEvent = (0, $cozmU.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (analyticsEvent)=>{
        const { eventType: eventType, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, ...attributes } = analyticsEvent.payload;
        if (typeof eventType === 'string' && $f4b0dbc0e11852da$var$VALID_EVENT_TYPES.includes(eventType) && typeof action === 'string' && typeof actionSubject === 'string') fireAnalyticsEvent({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            ...typeof actionSubjectId === 'string' ? {
                actionSubjectId: actionSubjectId
            } : {},
            ...attributes
        }, {
            product: 'confluence'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const AnimationSvg = (0, $cozmU.useMemo)(()=>(0, $g9AoR.getAnimationSvg)({
            topApps: topApps,
            department: department
        }), [
        topApps,
        department
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && // eslint-disable-next-line @atlaskit/design-system/no-modal-label
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: onClose,
            testId: "confluence-connect-3p-tools-modal",
            width: "x-large",
            label: intl.formatMessage((0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalTitle),
            shouldCloseOnOverlayClick: false,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $f4b0dbc0e11852da$var$styles.modalBody,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f7AuD.SplitScreen), {
                    screen: "confluence-connect-3p-tools-modal",
                    title: intl.formatMessage((0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalTitle),
                    subtitle: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalSubtitle,
                        values: {
                            strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                                    children: chunks
                                })
                        }
                    }),
                    isDynamicComponentEdgeToEdge: true,
                    logoVariant: "icon",
                    dynamicComponent: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                        xcss: $f4b0dbc0e11852da$var$styles.dynamicComponentContainer,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $f4b0dbc0e11852da$var$styles.closeButtonContainer,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                    appearance: "subtle",
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                    label: intl.formatMessage((0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalClose),
                                    onClick: onClose,
                                    spacing: "compact",
                                    testId: "confluence-connect-3p-tools-modal-close-button"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                                fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {}),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AnimationSvg, {})
                            })
                        ]
                    }),
                    imageAlt: "",
                    footer: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                        justifyContent: "start",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalDismiss
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3d3WW.default), {
                                channel: $f4b0dbc0e11852da$var$ACCOUNT_SETUP_CHANNEL,
                                onEvent: onAnalyticsEvent,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9VQ5f.ThirdPartyConnectorList), {
                                    connectorResources: connectorResources,
                                    onConnectorConnected: onConnectorConnected,
                                    showIconTile: true,
                                    touchpoint: (0, $4YcXR.SMARTLINK_CONNECTION_TOUCHPOINTS).sideNav,
                                    screenName: "confluence-connect-3p-tools-modal"
                                })
                            }),
                            numTeammates !== undefined && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                paddingBlockStart: "space.200",
                                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: [
                                        numTeammates === 0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalTeammatesEmpty
                                        }),
                                        numTeammates >= 1 && numTeammates <= 20 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalTeammatesFew,
                                            values: {
                                                appName: appName
                                            }
                                        }),
                                        numTeammates >= 21 && numTeammates <= 50 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalTeammatesMany,
                                            values: {
                                                numTeammates: numTeammates,
                                                appName: appName,
                                                strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                                                        children: chunks
                                                    })
                                            }
                                        }),
                                        numTeammates > 50 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).modal.modalTeammatesLots,
                                            values: {
                                                appName: appName,
                                                strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};



const $fcbeac7297c9a5b3$var$APP_CONFIG = {
    'google-drive': {
        displayName: 'Google Drive',
        productKey: (0, $fR63l.ProductKeys3P).GoogleDrive
    },
    slack: {
        displayName: 'Slack',
        productKey: (0, $fR63l.ProductKeys3P).Slack
    },
    figma: {
        displayName: 'Figma',
        productKey: (0, $fR63l.ProductKeys3P).Figma
    },
    github: {
        displayName: 'GitHub',
        productKey: (0, $fR63l.ProductKeys3P).Github
    },
    onedrive: {
        displayName: 'OneDrive',
        productKey: (0, $fR63l.ProductKeys3P).OneDrive
    },
    sharepoint: {
        displayName: 'SharePoint',
        productKey: (0, $fR63l.ProductKeys3P).Sharepoint
    }
};
const $fcbeac7297c9a5b3$var$styles = {
    root: "_0bjKvD8fU6 _1mT5xdRAKS _2O5Vij7dHp _0KLXruVva3",
    primaryContentContainer: "_4FKVYE5zaO _2O5Vij7dHp",
    callToActionContainer: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0wOv4Q7zJH _0KLXrujOvk _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0CMRbkAwSC",
    iconsColumn: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _2Zuz6Q5zaO _0Of8r25zaO",
    iconWrapper: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg",
    iconWrapperOverlap: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _2XsHFM4F84",
    closeButtonContainer: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO"
};
// `defaults.ts`. Used only when the component is rendered without
// `unconnectedApps` (Storybook / standalone usage). In production the creator
// always emits a non-empty list, so this default rarely fires.
const $fcbeac7297c9a5b3$var$FALLBACK_APPS = (0, $8dynS.DEFAULT_FALLBACK_APPS); /**
                                                                                    * Recognised cohort values for the `cc-connect-your-3p-tools-in-onboarding`
                                                                                    * experiment. Any other value (including `undefined`, `''`, `'control'`,
                                                                                    * `'not-enrolled'`, or unknown strings) is treated as a Statsig anomaly and
                                                                                    * suppresses the banner.
                                                                                    */ 
const $fcbeac7297c9a5b3$var$COHORT_SINGLE = 'single-connect-in-onboarding';
const $fcbeac7297c9a5b3$var$COHORT_MULTI = 'multi-connect-in-onboarding';
function $fcbeac7297c9a5b3$var$cohortToLimit(cohort) {
    switch(cohort){
        case $fcbeac7297c9a5b3$var$COHORT_SINGLE:
            return 1;
        case $fcbeac7297c9a5b3$var$COHORT_MULTI:
            return 3;
        default:
            return null;
    }
} // Matches the largest cohort limit; one hook call serves every cohort.
const $fcbeac7297c9a5b3$var$MAX_CONNECTORS = 3;
const $fcbeac7297c9a5b3$export$6cced77b2ab4e73e = ({ // `action` + `onPrimaryActionClick` are part of the placement contract
// but intentionally unused here (invoking the latter unmounts us via
// `messages.slice(1)` — see `handleOnPrimaryActionClick`).
action: _action, unconnectedApps: unconnectedApps = $fcbeac7297c9a5b3$var$FALLBACK_APPS, cohort: cohort, cloudId: cloudId, userId: userId, topApps: topApps, department: department, numTeammates: numTeammates, appName: appName, onPrimaryActionClick: _onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onCtaActioned: onCtaActioned, onClosed: onClosed } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const [appIcons, setAppIcons] = (0, $cozmU.useState)(new Map());
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)(); // Suppression check runs against the top-3 (not the cohort slice) so
    // eligibility is identical across single- and multi-connect cohorts.
    const top3RecommendedApps = unconnectedApps.slice(0, $fcbeac7297c9a5b3$var$MAX_CONNECTORS); // Pin the connector hook to the banner's resolved recommendation so the
    // icons and modal rows can't diverge. Without this, the hook's internal
    // cascade (which has no team-type signal here) may return a different
    // top-3 and the modal silently drops any non-matching apps.
    const productKeysFromBanner = top3RecommendedApps.map((app)=>$fcbeac7297c9a5b3$var$APP_CONFIG[app].productKey); // `cloudId ?? ''` keeps Storybook working (renders `null` initially).
    const { connectorResources: connectorResources, onConnectorConnected: onConnectorConnected } = (0, $dZ3U4.use3pConnectorResources)({
        cloudId: cloudId ?? '',
        userId: userId,
        // In Confluence session-data, `userId` is the Atlassian Account ID —
        // the same value the outbound-auth gateway expects.
        aaId: userId,
        maxConnectors: $fcbeac7297c9a5b3$var$MAX_CONNECTORS,
        productKeys: productKeysFromBanner
    });
    const cohortLimit = $fcbeac7297c9a5b3$var$cohortToLimit(cohort);
    const appsToRender = cohortLimit !== null ? unconnectedApps.slice(0, cohortLimit) : []; // Gates `messageInstanceViewed` so exposure fires only for eligible
    // mounts. Omits `isModalOpen` on purpose — the viewed event should
    // fire once per fresh mount, not re-fire when the modal closes.
    const willRender = cohortLimit !== null && unconnectedApps.length >= cohortLimit;
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!willRender || hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        if (messageInstanceViewed) messageInstanceViewed({
            ...cohort !== undefined && {
                cohort: cohort
            }
        });
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceConnect3pToolsSideNavNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally only re-runs when `willRender` flips
    }, [
        willRender
    ]); // Load icons from ThirdPartyConfigs on mount / when unconnectedApps changes
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        const loadIcons = async ()=>{
            const iconMap = new Map();
            for (const app of appsToRender){
                const config = await (0, $dAuCI.ThirdPartyConfigs).get($fcbeac7297c9a5b3$var$APP_CONFIG[app].productKey);
                if (config && !cancelled) iconMap.set(app, config.icon);
            }
            if (!cancelled) setAppIcons(iconMap);
        };
        loadIcons();
        return ()=>{
            cancelled = true;
        }; // eslint-disable-next-line react-hooks/exhaustive-deps -- appsToRender identity is derived; we want to re-run only when its membership changes
    }, [
        appsToRender.join(',')
    ]);
    const handleOnPrimaryActionClick = ()=>{
        onCtaActioned({
            interactionIdentifier: 'showMeHow',
            ...cohort !== undefined && {
                additionalMetadata: {
                    cohort: cohort
                }
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connect3pToolsSideNavNudgeCta'
        }); // NOTE: do not call `onPrimaryActionClick?.(action)` here. The
        // `confluence-side-nav` placement reacts to it by slicing this
        // message out of its `messages` state (see `placement-v2/src/
        // confluence-side-nav/index.tsx` → `handleOnSideNavClick`), which
        // unmounts this component before React can flush the
        // `setIsModalOpen(true)` update — so the modal never renders.
        // The placement notification is instead deferred to
        // `handleOnModalClose`, which fires `onDismissClick?.()` once the
        // user has actually finished with the modal.
        setIsModalOpen(true);
    };
    const handleOnConnectorConnected = (productKey)=>{
        onClosed({
            interactionIdentifier: 'connectAppDismiss',
            additionalMetadata: {
                ...cohort !== undefined && {
                    cohort: cohort
                }
            }
        });
        onConnectorConnected?.(productKey);
    }; // Shared dismiss: records the closed interaction, then unmounts via the placement callback.
    const dismissBanner = (interactionIdentifier)=>{
        onClosed({
            interactionIdentifier: interactionIdentifier,
            ...cohort !== undefined && {
                additionalMetadata: {
                    cohort: cohort
                }
            }
        });
        onDismissClick?.();
    };
    const handleOnModalClose = ()=>{
        setIsModalOpen(false);
        dismissBanner('modalClose');
    };
    const handleOnDismissClick = ()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connect3pToolsSideNavNudgeDismiss'
        });
        dismissBanner('dismiss');
    }; // Invalid cohort always suppresses, even mid-modal — a flipped cohort
    // would otherwise render a banner/modal with no apps.
    if (cohortLimit === null) return null;
     // Other guards are skipped while the modal is open so an in-flight
    // OAuth success doesn't unmount before the user sees it.
    if (!isModalOpen && unconnectedApps.length < cohortLimit) return null;
    const isSingleApp = appsToRender.length === 1;
    const bodyMessage = isSingleApp ? (0, $14a0142c560cd56e$export$e1c3efc64f2d806f).default.singleAppBodyLabel : (0, $14a0142c560cd56e$export$e1c3efc64f2d806f).default.multiAppBodyLabel;
    const ctaMessage = isSingleApp ? (0, $14a0142c560cd56e$export$e1c3efc64f2d806f).default.callToActionForSingleAppLabel : (0, $14a0142c560cd56e$export$e1c3efc64f2d806f).default.callToActionForMultiAppLabel;
    const firstApp = appsToRender[0];
    const messageValues = isSingleApp && firstApp ? {
        appName: $fcbeac7297c9a5b3$var$APP_CONFIG[firstApp].displayName
    } : undefined;
    const modalConnectorResources = appsToRender.flatMap((app)=>{
        const productKey = $fcbeac7297c9a5b3$var$APP_CONFIG[app].productKey;
        const connectorResource = connectorResources.find((resource)=>resource.productKey === productKey);
        return connectorResource ? [
            connectorResource
        ] : [];
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $gBjHb.default), {
        data: {
            source: 'confluence-connect-3p-tools-nudge'
        },
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                xcss: $fcbeac7297c9a5b3$var$styles.root,
                testId: "confluence-connect-3p-tools-nudge",
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                        xcss: $fcbeac7297c9a5b3$var$styles.iconsColumn,
                        alignItems: "start",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                            direction: "row",
                            alignItems: "center",
                            children: appsToRender.map((app, index)=>{
                                const Icon = appIcons.get(app);
                                if (!Icon) return null;
                                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: index === 0 ? $fcbeac7297c9a5b3$var$styles.iconWrapper : $fcbeac7297c9a5b3$var$styles.iconWrapperOverlap,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                                        label: "",
                                        size: "small"
                                    })
                                }, app);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                        xcss: $fcbeac7297c9a5b3$var$styles.primaryContentContainer,
                        gap: "space.100",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...(0, $14a0142c560cd56e$export$e1c3efc64f2d806f).default.headingLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...bodyMessage,
                                    values: messageValues
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                    xcss: $fcbeac7297c9a5b3$var$styles.callToActionContainer,
                                    onClick: handleOnPrimaryActionClick,
                                    testId: "connect-3p-tools-cta-button",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        color: "color.link",
                                        size: "medium",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...ctaMessage,
                                            values: messageValues
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $fcbeac7297c9a5b3$var$styles.closeButtonContainer,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            icon: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                    ...props,
                                    size: "small"
                                }),
                            label: intl.formatMessage((0, $14a0142c560cd56e$export$e1c3efc64f2d806f).default.dismissLabel),
                            isTooltipDisabled: false,
                            onClick: handleOnDismissClick
                        })
                    })
                ]
            }),
            numTeammates !== undefined && appName !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4b0dbc0e11852da$export$2586b970714caf78), {
                isOpen: isModalOpen,
                onClose: handleOnModalClose,
                connectorResources: modalConnectorResources,
                onConnectorConnected: handleOnConnectorConnected,
                numTeammates: numTeammates,
                appName: appName,
                topApps: topApps,
                department: department
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4b0dbc0e11852da$export$2586b970714caf78), {
                isOpen: isModalOpen,
                onClose: handleOnModalClose,
                connectorResources: modalConnectorResources,
                onConnectorConnected: handleOnConnectorConnected,
                topApps: topApps,
                department: department
            })
        ]
    });
};





const $51e17eb8c89c6db3$var$ANIMATION_APPS = new Set((0, $g9AoR.ANIMATION_APP_KEYS));
const $51e17eb8c89c6db3$var$DEPARTMENTS = new Set((0, $g9AoR.DEPARTMENT_KEYS));
const $51e17eb8c89c6db3$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $e184676353c1fc93$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, cohort: cohort, cloudId: cloudId, userId: userId, unconnectedApps: unconnectedApps, topApps: topApps, department: department, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            const narrowedTopApps = (0, $cozmU.useMemo)(()=>topApps.filter((app)=>$51e17eb8c89c6db3$var$ANIMATION_APPS.has(app)), [
                topApps
            ]);
            const narrowedDepartment = (0, $cozmU.useMemo)(()=>$51e17eb8c89c6db3$var$DEPARTMENTS.has(department) ? department : undefined, [
                department
            ]);
            // `unconnectedApps` is populated server-side by the implicit-message-creator
            // via a 3-tier cascade (team-type TAP trait → site-wide TAP trait → hardcoded
            // defaults). On total creator failure the message is suppressed entirely
            // (see implicit-message/index.ts outer catch), so this prop is always
            // non-empty in production.
            // `cloudId` and `userId` are required and used by Connect3pTools to call
            // `use3pConnectorResources` and suppress the nudge when the user is
            // already connected to enough of the recommended apps.
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fcbeac7297c9a5b3$export$6cced77b2ab4e73e), {
                action: nextBestActionType,
                cohort: cohort,
                cloudId: cloudId,
                userId: userId,
                unconnectedApps: unconnectedApps,
                topApps: narrowedTopApps,
                department: narrowedDepartment,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});









/* NonMauChatCtaMessage.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $etoPX = parcelRequire("etoPX");

















var $hdBxM = parcelRequire("hdBxM");
















const $ecd2a36fc7614690$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        ctaLinkText: {
            id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.cta-link-text',
            defaultMessage: 'Try Rovo now',
            description: 'CTA link text for the non-MAU Rovo Chat CTA banner'
        },
        chatPrompt: {
            id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.chat-prompt',
            defaultMessage: 'Hi Rovo, list three things you can do right now for me based on my recent work',
            description: 'Auto-run prompt sent to Rovo Chat when the user clicks the CTA on the non-MAU chat CTA banner'
        },
        whyAmISeeingThisReason1: {
            id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-1',
            defaultMessage: 'your existing Atlassian products',
            description: 'First reason for showing the Rovo Chat CTA to the user'
        },
        whyAmISeeingThisReason2: {
            id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-2',
            defaultMessage: 'your organization having AI enabled',
            description: 'Second reason for showing the Rovo Chat CTA to the user'
        },
        heading: {
            id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.heading.v1',
            defaultMessage: 'Unlock your AI teammate',
            description: 'Heading text for non-MAU Rovo Chat CTA banner - variant v1',
            role: 'title'
        },
        description: {
            id: 'rovo-non-mau-chat-cta-jira-confluence-left-nav.description.v1',
            defaultMessage: 'Rovo connects your tools and knowledge so work gets done for you.',
            description: 'Description text for non-MAU Rovo Chat CTA banner - variant v1',
            role: 'description'
        }
    }
});


// variant. Retained as a static analytics attribute so downstream dashboards
// keep receiving the `variant` field.
const $11556e8ac9e65661$var$VARIANT = 'v1';
const $11556e8ac9e65661$var$styles = {
    boxContainer: "_2mHwu82ADO _0bjKvD8fU6 _0GwItXDIqT _37wbyuDIqT _3iDTPbQ4SZ _39xV02N91d _0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0hPCNLchRC _0KLXrugNg3",
    contentStack: "_2mHwu82ADO _39xV02N91d",
    headerRow: "_37wbyuI7V3 _0hPCNLDIqT _39xV02N91d",
    ctaLink: "_4FKVYEPgdg _0bjKvDcjp5 _2sNsIg7NXe _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0KLXru66of _1UtDYzM7Tp _0wOv4Q7zJH _2fwxA5ecOK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0CMRbkAwSC"
};
const $11556e8ac9e65661$var$ACTION_SUBJECT = 'rovoNonMauChatCta';
const $11556e8ac9e65661$export$e6a613b0fe78a30b = ({ context: context, handleOnDismissed: handleOnDismissed })=>{
    const { source: source } = context;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { messageClicked: messageClicked } = (0, $baFbJ.useMessageEvent)();
    const { onCtaActioned: onCtaActioned, onDeclined: onDeclined } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const chatEventPublish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: $11556e8ac9e65661$var$ACTION_SUBJECT,
            attributes: {
                variant: $11556e8ac9e65661$var$VARIANT,
                source: source
            }
        });
    }, [
        fireAnalyticsEvent,
        source
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissed',
            actionSubject: $11556e8ac9e65661$var$ACTION_SUBJECT,
            attributes: {
                variant: $11556e8ac9e65661$var$VARIANT,
                source: source
            }
        });
        messageClicked();
        onDeclined({
            interactionIdentifier: 'dismiss',
            additionalMetadata: {
                experimentCohort: $11556e8ac9e65661$var$VARIANT,
                source: source
            }
        });
        handleOnDismissed();
    }, [
        fireAnalyticsEvent,
        source,
        messageClicked,
        onDeclined,
        handleOnDismissed
    ]);
    const handleCtaClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $11556e8ac9e65661$var$ACTION_SUBJECT,
            attributes: {
                variant: $11556e8ac9e65661$var$VARIANT,
                source: source
            }
        });
        messageClicked();
        onCtaActioned({
            interactionIdentifier: 'openRovoChat',
            additionalMetadata: {
                experimentCohort: $11556e8ac9e65661$var$VARIANT,
                source: source
            }
        });
        chatEventPublish({
            type: 'chat-new',
            source: 'rovoNonMauChatCta',
            data: {
                prompt: formatMessage((0, $ecd2a36fc7614690$export$e1c3efc64f2d806f).default.chatPrompt),
                dialogues: []
            }
        });
    }, [
        fireAnalyticsEvent,
        source,
        messageClicked,
        onCtaActioned,
        chatEventPublish
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($11556e8ac9e65661$var$styles.boxContainer),
        testId: "rovo-non-mau-chat-cta",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            xcss: (0, $w6R6I.cx)($11556e8ac9e65661$var$styles.contentStack),
            testId: "rovo-non-mau-chat-cta-content",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    xcss: (0, $w6R6I.cx)($11556e8ac9e65661$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $etoPX.RovoIcon), {
                            appearance: "brand",
                            size: "xsmall"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                            showWhyAmISeeingThis: true,
                            whyAmISeeingThisModalContent: {
                                reasons: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...(0, $ecd2a36fc7614690$export$e1c3efc64f2d806f).default.whyAmISeeingThisReason1
                                    }, "reason-1"),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...(0, $ecd2a36fc7614690$export$e1c3efc64f2d806f).default.whyAmISeeingThisReason2
                                    }, "reason-2")
                                ]
                            },
                            onDismissed: handleDismiss,
                            spacing: "compact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                    size: "xsmall",
                    children: formatMessage((0, $ecd2a36fc7614690$export$e1c3efc64f2d806f).default.heading)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: formatMessage((0, $ecd2a36fc7614690$export$e1c3efc64f2d806f).default.description)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    onClick: handleCtaClick,
                    testId: "rovo-non-mau-chat-cta-link",
                    xcss: (0, $w6R6I.cx)($11556e8ac9e65661$var$styles.ctaLink),
                    children: formatMessage((0, $ecd2a36fc7614690$export$e1c3efc64f2d806f).default.ctaLinkText)
                })
            ]
        })
    });
};


const $b9098d3ce6e94275$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $iqz3m.noValidation)(),
        Component: ({ handleOnDismissed: handleOnDismissed })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $11556e8ac9e65661$export$e6a613b0fe78a30b), {
                handleOnDismissed: handleOnDismissed,
                context: {
                    source: 'confluence-side-nav'
                }
            });
        }
    }
});






// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $8aeaa60316995e65$export$a7a9523472993e97(value) {
    const result = $8aeaa60316995e65$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $8aeaa60316995e65$export$226b3eccf92c9ed9(value) {
    const result = $8aeaa60316995e65$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $8aeaa60316995e65$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "MCP_SETUP_NUDGE") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "MCP_SETUP_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_9 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_9.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_9.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
































var $4H55s = parcelRequire("4H55s");


var $jh2Zn = parcelRequire("jh2Zn");


var $kHdfP = parcelRequire("kHdfP");



















const $aa00393d476c6571$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    default: {
        heading: {
            id: 'post-office.confluence-agents-mcp-nudge-banner.heading',
            defaultMessage: 'Use Confluence from your AI tools',
            description: 'Heading on a Confluence side navigation card that introduces using Confluence from AI tools.',
            role: 'title'
        },
        body: {
            id: 'post-office.confluence-agents-mcp-nudge-banner.body',
            defaultMessage: 'Ask questions, update docs, and set space instructions without leaving your tools.',
            description: 'Body text on a Confluence side navigation card that summarizes what users can do after setting up MCP.',
            role: 'description'
        },
        callToAction: {
            id: 'post-office.confluence-agents-mcp-nudge-banner.call-to-action',
            defaultMessage: 'Set up MCP',
            description: 'Button label on a Confluence side navigation card that opens the Atlassian MCP setup modal.'
        },
        dismiss: {
            id: 'post-office.confluence-agents-mcp-nudge-banner.dismiss',
            defaultMessage: 'Dismiss',
            description: 'Accessible label for the icon button that dismisses the Confluence MCP setup nudge.'
        }
    }
});


const $3aeeb2afb5667cc0$var$styles = {
    root: "_0bjKvD8fU6 _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _1mT5xdRAKS _39xV02N91d _0KLXruVva3",
    content: "_46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO",
    closeButton: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO",
    callToAction: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0wOv4Q7zJH _0KLXrujOvk _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0DCa9DM7Tp _0CMRbkAwSC",
    logos: "_39xV02E6Kk",
    logo: "_3iDTPbQ4SZ _1mT5xdRAKS _0adFHsTUhv",
    logoLast: "_0adFHsPgdg",
    logoTiltLeft: "_1VJPcacVF3",
    logoTiltRight: "_1VJPcarnNt"
};
const $3aeeb2afb5667cc0$export$5f5c3c36f6aab0a3 = ({ onDismiss: onDismiss, onSetupClick: onSetupClick })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $3aeeb2afb5667cc0$var$styles.root,
        testId: "confluence-agents-mcp-nudge-banner",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                xcss: $3aeeb2afb5667cc0$var$styles.content,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $3aeeb2afb5667cc0$var$styles.logos,
                        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            alignBlock: "center",
                            space: "space.0",
                            "aria-hidden": true,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: (0, $w6R6I.cx)($3aeeb2afb5667cc0$var$styles.logo, $3aeeb2afb5667cc0$var$styles.logoTiltLeft),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4H55s.ClaudeIcon), {
                                        size: "xsmall",
                                        label: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: (0, $w6R6I.cx)($3aeeb2afb5667cc0$var$styles.logo, $3aeeb2afb5667cc0$var$styles.logoTiltRight),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kHdfP.OpenAIIcon), {
                                        size: "xsmall",
                                        label: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: (0, $w6R6I.cx)($3aeeb2afb5667cc0$var$styles.logo, $3aeeb2afb5667cc0$var$styles.logoLast, $3aeeb2afb5667cc0$var$styles.logoTiltLeft),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jh2Zn.CursorIcon), {
                                        size: "xsmall",
                                        label: ""
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $aa00393d476c6571$export$e1c3efc64f2d806f).default.heading
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.subtle",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $aa00393d476c6571$export$e1c3efc64f2d806f).default.body
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                            xcss: $3aeeb2afb5667cc0$var$styles.callToAction,
                            "aria-haspopup": "dialog",
                            onClick: onSetupClick,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.link",
                                size: "medium",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...(0, $aa00393d476c6571$export$e1c3efc64f2d806f).default.callToAction
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $3aeeb2afb5667cc0$var$styles.closeButton,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    appearance: "subtle",
                    spacing: "compact",
                    icon: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                            ...props,
                            size: "small"
                        }),
                    label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $aa00393d476c6571$export$e1c3efc64f2d806f).default.dismiss
                    }),
                    isTooltipDisabled: false,
                    onClick: onDismiss
                })
            })
        ]
    });
const $3aeeb2afb5667cc0$export$6f3915189bf35e43 = ({ onDismiss: onDismiss, onSetup: onSetup })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { onCtaActioned: onCtaActioned, onClosed: onClosed } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (messageInstanceViewed) messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceAgentsMcpNudgeBanner'
        }); // The viewed event is intentionally emitted once for each fresh message mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismiss = ()=>{
        onClosed({
            interactionIdentifier: 'dismiss',
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'confluenceAgentsMcpNudgeBannerDismiss'
        });
        messageDismissed();
        onDismiss?.();
    };
    const handleSetupClick = ()=>{
        onCtaActioned({
            interactionIdentifier: 'setUpMcp'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'confluenceAgentsMcpNudgeBannerSetUpMcp'
        });
        messageDismissed();
        onSetup('MCP_SETUP_NUDGE');
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-agents-mcp-nudge-banner'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($3aeeb2afb5667cc0$export$5f5c3c36f6aab0a3, {
            onDismiss: handleDismiss,
            onSetupClick: handleSetupClick
        })
    });
};


const $4d419829100a6c6e$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $8aeaa60316995e65$export$a7a9523472993e97),
        Component: ({ handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3aeeb2afb5667cc0$export$6f3915189bf35e43), {
                onDismiss: handleOnDismissed,
                onSetup: onSideNavClick
            })
    }
});













var $7ongw = parcelRequire("7ongw");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $ed0bda36e1957259$export$a7a9523472993e97(value) {
    const result = $ed0bda36e1957259$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $ed0bda36e1957259$export$226b3eccf92c9ed9(value) {
    const result = $ed0bda36e1957259$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $ed0bda36e1957259$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('triggerType' in value)) errors.push({
            path: 'value["triggerType"]',
            expected: '"onPageLoad" | "gasV3" | "poTrigger" | "subscription"',
            value: undefined
        });
        else {
            let value__triggerType___valid = false;
            if (!value__triggerType___valid) {
                const value__triggerType___errors_0 = [];
                if (value["triggerType"] !== "onPageLoad") value__triggerType___errors_0.push({
                    path: 'value["triggerType"]',
                    expected: "onPageLoad",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_0.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) {
                const value__triggerType___errors_1 = [];
                if (value["triggerType"] !== "gasV3") value__triggerType___errors_1.push({
                    path: 'value["triggerType"]',
                    expected: "gasV3",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_1.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) {
                const value__triggerType___errors_2 = [];
                if (value["triggerType"] !== "poTrigger") value__triggerType___errors_2.push({
                    path: 'value["triggerType"]',
                    expected: "poTrigger",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_2.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) {
                const value__triggerType___errors_3 = [];
                if (value["triggerType"] !== "subscription") value__triggerType___errors_3.push({
                    path: 'value["triggerType"]',
                    expected: "subscription",
                    value: value["triggerType"]
                });
                if (value__triggerType___errors_3.length === 0) value__triggerType___valid = true;
            }
            if (!value__triggerType___valid) errors.push({
                path: 'value["triggerType"]',
                expected: '"onPageLoad" | "gasV3" | "poTrigger" | "subscription"',
                value: value["triggerType"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}



var $4aZ6c = parcelRequire("4aZ6c");

/* MeetingNudgeBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 











var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $a2foB = parcelRequire("a2foB");





var $6TaGl = parcelRequire("6TaGl");








var $fEPJS = parcelRequire("fEPJS");





var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");

















var $juGf9 = parcelRequire("juGf9");













var $9a492e0713998829$exports = {};
$9a492e0713998829$exports = new URL("ai-notes.ebf93360.svg", import.meta.url).toString();





const $0fc2eb809e141264$export$e1c3efc64f2d806f = (0, $8j5U7.defineContent)({
    // `default` holds the side-nav banner copy; `role: 'title'` / `role: 'description'`
    // mark the two descriptors the offline content loader / reranker reads.
    default: {
        heading: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.heading',
            defaultMessage: 'Turn meetings into action',
            description: 'Heading for a side navigation banner promoting Loom meeting recordings',
            role: 'title'
        },
        body: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.body',
            defaultMessage: 'Loom captures action items in Confluence and Jira so you don\u2019t have to.',
            description: 'Body copy for a side navigation banner promoting Loom meeting recordings',
            role: 'description'
        },
        connectCalendar: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.connect-calendar',
            defaultMessage: 'Connect calendar',
            description: "Action to open Loom's calendar connection flow"
        },
        remindMe: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.remind-me',
            defaultMessage: 'Remind me',
            description: 'Action to defer the Loom calendar reminder until the next publish or live-page load'
        },
        moreActions: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.more-actions',
            defaultMessage: 'More actions',
            description: 'Label for the Loom meeting nudge options menu'
        },
        notInterested: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested',
            defaultMessage: 'Not interested',
            description: 'Action to permanently turn off Loom meeting recording suggestions'
        },
        whyAmISeeingThis: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-am-i-seeing-this',
            defaultMessage: 'Why am I seeing this?',
            description: 'Action to explain why the Loom meeting nudge was shown'
        }
    },
    // `whyModal` holds the "Why am I seeing this?" explanation modal copy.
    whyModal: {
        title: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.title',
            defaultMessage: 'Why am I seeing this?',
            description: 'Title for an explanation of why the Loom meeting nudge was shown',
            role: 'title'
        },
        introduction: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.introduction.ai-non-final',
            defaultMessage: 'We think <strong>Loom</strong> will improve your team\u2019s productivity. The recommendation is based on:',
            description: 'Introduction in the Loom meeting nudge explanation modal describing why Atlassian recommends Loom to the user',
            role: 'description'
        },
        teamworkCollection: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.teamwork-collection.ai-non-final',
            defaultMessage: 'your access to the Teamwork Collection (which includes Loom)',
            description: 'First reason in the Loom meeting nudge explanation modal, describing the user\u2019s access to the Teamwork Collection'
        },
        atlassianTools: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.atlassian-tools.ai-non-final',
            defaultMessage: 'the tools you use (Confluence and Jira)',
            description: 'Second reason in the Loom meeting nudge explanation modal, identifying the Atlassian tools the user already uses'
        },
        meetingWorkflow: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.meeting-workflow.ai-non-final',
            defaultMessage: 'the way you manage meetings and documentation in your existing workflow',
            description: 'Third reason in the Loom meeting nudge explanation modal, describing how the recommendation relates to the user\u2019s workflow'
        },
        privacyLink: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.privacy-link.ai-non-final',
            defaultMessage: 'Learn more about your data privacy with Atlassian',
            description: 'Link in the Loom meeting nudge explanation modal that opens Atlassian\u2019s privacy policy in a new browser tab'
        },
        close: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.why-modal.close.ai-non-final',
            defaultMessage: 'OK',
            description: 'Confirmation button that closes the Loom meeting nudge explanation modal'
        }
    },
    // `confirmations` holds the copy for the success flags shown after a user action.
    confirmations: {
        reminderTitle: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.reminder-confirmation.title',
            defaultMessage: 'We\u2019ll remind you again later',
            description: 'Title confirming that the Loom calendar connection reminder was deferred',
            role: 'title'
        },
        reminderDescription: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.reminder-confirmation.description',
            defaultMessage: 'After you finish your doc, we\u2019ll remind you to connect your calendar to Loom.',
            description: 'Description explaining when the deferred Loom reminder will return',
            role: 'description'
        },
        notInterestedTitle: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.title',
            defaultMessage: 'Meeting recording suggestions turned off',
            description: 'Title confirming that Loom meeting recording suggestions were turned off'
        },
        notInterestedDescription: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.description',
            defaultMessage: 'You won\u2019t see meeting recording suggestions anymore.',
            description: 'Description confirming that Loom meeting recording suggestions will no longer appear'
        },
        notInterestedUndo: {
            id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.undo',
            defaultMessage: 'Undo',
            description: 'Action to keep showing Loom meeting recording suggestions'
        }
    }
});


const $bfb9bc5a8a856bae$var$DATA_PRIVACY_URL = 'https://www.atlassian.com/legal/privacy-policy';
const $bfb9bc5a8a856bae$var$NOT_INTERESTED_FLAG_ID = 'loom-meeting-nudge-not-interested';
const $bfb9bc5a8a856bae$var$getPostOfficeDismissEvent = (clickIdentifier, buttonType = 'secondary')=>({
        messageEventType: 'clicked',
        clickedElement: {
            clickIdentifier: clickIdentifier,
            clickedElement: 'button',
            buttonType: buttonType
        },
        action: {
            actionType: 'dismiss'
        },
        additionalMetadataFromFrontend: {}
    });
const $bfb9bc5a8a856bae$var$styles = {
    container: "_0bjKvD8fU6 _0KLXruVva3 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _39xV02N91d",
    action: "_0hPCNLDIqT _0KLXrujOvk _3iDTPbccYA _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1UtDYzM7Tp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0CMRbkAwSC",
    aiNotesIcon: "_0jFU0VUF4f _39xV02UF4f",
    privacyLinkContainer: "_3138428HPE"
};
const $bfb9bc5a8a856bae$export$94e8b357dbd6604c = ({ cloudId: cloudId, handleOnDismissed: handleOnDismissed, flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isNotInterestedFlagOpen, setIsNotInterestedFlagOpen] = (0, $cozmU.useState)(false);
    const [isWhyModalOpen, setIsWhyModalOpen] = (0, $cozmU.useState)(false);
    const { messageInstanceClicked: messageInstanceClicked } = (0, $7NHN3.useMessageInstanceEvent)();
    const { fireCtaClicked: fireCtaClicked, fireScreenSeen: fireScreenSeen, fireFlagDismissed: fireFlagDismissed } = (0, $4aZ6c.useLoomMeetingNudgeAnalytics)('sidenav');
    const reminderConfirmation = {
        title: intl.formatMessage((0, $0fc2eb809e141264$export$e1c3efc64f2d806f).confirmations.reminderTitle),
        description: intl.formatMessage((0, $0fc2eb809e141264$export$e1c3efc64f2d806f).confirmations.reminderDescription)
    };
    const notInterestedConfirmation = {
        title: intl.formatMessage((0, $0fc2eb809e141264$export$e1c3efc64f2d806f).confirmations.notInterestedTitle),
        description: intl.formatMessage((0, $0fc2eb809e141264$export$e1c3efc64f2d806f).confirmations.notInterestedDescription),
        undo: intl.formatMessage((0, $0fc2eb809e141264$export$e1c3efc64f2d806f).confirmations.notInterestedUndo)
    };
    (0, $cozmU.useEffect)(()=>{
        if (isWhyModalOpen) fireScreenSeen('whyAmISeeingThis');
    }, [
        fireScreenSeen,
        isWhyModalOpen
    ]);
    const finishNudgeFlow = ()=>{
        setIsNotInterestedFlagOpen(false);
        handleOnDismissed();
    };
    const handleConnectCalendar = ()=>{
        fireCtaClicked('connectCalendar');
        messageInstanceClicked($bfb9bc5a8a856bae$var$getPostOfficeDismissEvent('connect-calendar', 'primary'));
        (0, $juGf9.openLoomMeetingRecordings)({
            bridge: 'loom-meeting-nudge-sidenav',
            cloudId: cloudId,
            interactionSource: 'confluence',
            loomSource: 'confluence-nudge-sidenav'
        });
        finishNudgeFlow();
    };
    const handleRemindMe = ()=>{
        fireCtaClicked('remindMe');
        messageInstanceClicked($bfb9bc5a8a856bae$var$getPostOfficeDismissEvent('remind-me'));
        (0, $7ongw.requestLoomMeetingNudgeReminder)();
        flags.showFlag({
            id: 'loom-meeting-nudge-reminder-confirmation',
            type: 'success-circle',
            title: reminderConfirmation.title,
            description: reminderConfirmation.description,
            customComponent: (0, $a2foB.default),
            close: 'never',
            onShown: ()=>fireScreenSeen('remindMe'),
            onClose: ()=>fireFlagDismissed('flagRemindMe')
        });
        finishNudgeFlow();
    };
    const handleNotInterestedConfirmationDismissed = ()=>{
        messageInstanceClicked($bfb9bc5a8a856bae$var$getPostOfficeDismissEvent('not-interested'));
        fireFlagDismissed('flagNotInterested');
        finishNudgeFlow();
    };
    const handleNotInterestedUndo = ()=>{
        flags.hideFlag($bfb9bc5a8a856bae$var$NOT_INTERESTED_FLAG_ID);
        fireCtaClicked('undo');
        finishNudgeFlow();
    };
    const handleNotInterested = ()=>{
        fireCtaClicked('notInterested');
        setIsNotInterestedFlagOpen(true);
        flags.showFlag({
            id: $bfb9bc5a8a856bae$var$NOT_INTERESTED_FLAG_ID,
            type: 'success-circle',
            title: notInterestedConfirmation.title,
            description: notInterestedConfirmation.description,
            actions: [
                {
                    content: notInterestedConfirmation.undo,
                    onClick: handleNotInterestedUndo
                }
            ],
            customComponent: (0, $a2foB.default),
            close: 'never',
            onShown: ()=>fireScreenSeen('notInterested'),
            onClose: handleNotInterestedConfirmationDismissed
        });
    };
    const handleWhyAmISeeingThis = ()=>{
        fireCtaClicked('whyAmISeeingThis');
        setIsWhyModalOpen(true);
    };
    const handleCloseWhyAmISeeingThis = ()=>{
        setIsWhyModalOpen(false);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            !isNotInterestedFlagOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $bfb9bc5a8a856bae$var$styles.container,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            alignBlock: "start",
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: $bfb9bc5a8a856bae$var$styles.aiNotesIcon,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9a492e0713998829$exports))),
                                        alt: "",
                                        width: "40",
                                        height: "40",
                                        testId: "loom-meeting-nudge-ai-notes-icon"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                                    trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>// eslint-disable-next-line @post-office/message-linting/require-instrumented-interactions
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                            ...triggerProps,
                                            appearance: "subtle",
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                                            label: intl.formatMessage((0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.moreActions),
                                            onClick: (event)=>{
                                                fireCtaClicked('more');
                                                onClick?.(event);
                                            },
                                            ref: triggerRef,
                                            spacing: "compact"
                                        }),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                                onClick: handleNotInterested,
                                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                    ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.notInterested
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                                onClick: handleWhyAmISeeingThis,
                                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                    ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.whyAmISeeingThis
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            color: "color.text",
                            size: "xsmall",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.heading
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            as: "p",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.body
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            alignBlock: "center",
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                    onClick: handleConnectCalendar,
                                    xcss: $bfb9bc5a8a856bae$var$styles.action,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        as: "p",
                                        color: "color.link",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.connectCalendar
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\xb7"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                                    onClick: handleRemindMe,
                                    xcss: $bfb9bc5a8a856bae$var$styles.action,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        as: "p",
                                        color: "color.link",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).default.remindMe
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
                children: isWhyModalOpen && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7aRdF.default), {
                    onClose: handleCloseWhyAmISeeingThis,
                    width: "large",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $fEPJS.default), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    as: "p",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.introduction,
                                        values: {
                                            strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                    weight: "bold",
                                                    children: chunks
                                                })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.teamworkCollection
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.atlassianTools
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.meetingWorkflow
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: $bfb9bc5a8a856bae$var$styles.privacyLinkContainer,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                                        href: $bfb9bc5a8a856bae$var$DATA_PRIVACY_URL,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.privacyLink
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eQiT1.default), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                appearance: "primary",
                                onClick: handleCloseWhyAmISeeingThis,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...(0, $0fc2eb809e141264$export$e1c3efc64f2d806f).whyModal.close
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};


const $2278b8786009bca6$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $ed0bda36e1957259$export$a7a9523472993e97),
        Component: ({ cloudId: cloudId, handleOnDismissed: handleOnDismissed, flags: flags, waitForTrigger: waitForTrigger })=>{
            const { fireNudgeSeen: fireNudgeSeen } = (0, $4aZ6c.useLoomMeetingNudgeAnalytics)('sidenav');
            // Confluence flips this active via useFirePostOfficeTrigger; a React state
            // update on the shared TriggerContext, so the banner shows without a reload.
            const { isActive: isActive } = (0, $6m3nS.useTrigger)((0, $7ongw.LOOM_MEETING_NUDGE_SIDENAV_TRIGGER_ID));
            const { isActive: hasTitleNudgeShown } = (0, $6m3nS.useTrigger)((0, $7ongw.LOOM_MEETING_NUDGE_TITLE_SHOWN));
            // Handle to the same trigger so we can reset it on teardown.
            const { fireTrigger: fireTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
                triggerId: (0, $7ongw.LOOM_MEETING_NUDGE_SIDENAV_TRIGGER_ID)
            });
            const resetTrigger = (0, $cozmU.useCallback)(()=>{
                fireTrigger({
                    isActive: false
                });
            }, [
                fireTrigger
            ]);
            const { fireTrigger: fireSidenavNudgeShown } = (0, $6m3nS.useFirePostOfficeTrigger)({
                triggerId: (0, $7ongw.LOOM_MEETING_NUDGE_SIDENAV_SHOWN)
            });
            const handleMessageShown = (0, $cozmU.useCallback)(()=>{
                fireSidenavNudgeShown({
                    isActive: true
                });
                fireNudgeSeen();
            }, [
                fireNudgeSeen,
                fireSidenavNudgeShown
            ]);
            (0, $cozmU.useEffect)(()=>{
                if (hasTitleNudgeShown) resetTrigger();
            }, [
                hasTitleNudgeShown,
                resetTrigger
            ]);
            if (!waitForTrigger) return null;
            const messageContent = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bfb9bc5a8a856bae$export$94e8b357dbd6604c), {
                cloudId: cloudId,
                handleOnDismissed: handleOnDismissed,
                flags: flags
            });
            // waitForTrigger shows the message once isActive is true; on stop/dismiss its
            // onTeardown resets the trigger to false so product code can re-fire it.
            return waitForTrigger({
                isTriggerActive: !!isActive && !hasTitleNudgeShown,
                messageContent: messageContent,
                onMessageShown: handleMessageShown,
                onTeardown: resetTrigger
            });
        }
    }
});









/* SideNavBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
































var $b2719158748354db$exports = {};
$b2719158748354db$exports = new URL("coins.cb86ee9e.svg", import.meta.url).toString();





const $8645816a6fbeb0cf$var$bannerStyles = {
    banner: "_0bjKvD8fU6 _4c065U8HPE _0KLXrunmFW _0LQT5EgVvo _03SyCP2ADO _1kOSYtDpdQ _3Z9K0w2HTN _1eOmH6Bee8",
    button: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _2fwxA5ecOK _0KLXrujOvk _39xV02N91d"
};
function $8645816a6fbeb0cf$export$bf92408866c0c2b3({ onClick: onClick, onDismiss: onDismiss, productName: productName, edition: edition, bannerName: bannerName, analyticsAttributes: analyticsAttributes }) {
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onClosed: onClosed, onCtaActioned: onCtaActioned } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        onCtaActioned({
            interactionIdentifier: 'bannerOpen'
        });
        onClick();
    }, [
        onCtaActioned,
        onClick
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        messageDismissed();
        onClosed({
            interactionIdentifier: 'dismiss'
        });
        onDismiss();
    }, [
        messageDismissed,
        onClosed,
        onDismiss
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        messageInstanceViewed({
            name: bannerName,
            ...analyticsAttributes
        });
    }, [
        messageInstanceViewed,
        analyticsAttributes,
        bannerName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        xcss: $8645816a6fbeb0cf$var$bannerStyles.banner,
        gap: "space.200",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                xcss: $8645816a6fbeb0cf$var$bannerStyles.button,
                testId: "recent-downgrade-discount-banner-cta",
                onClick: handleOnClick,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b2719158748354db$exports))),
                        alt: "",
                        height: 32,
                        width: 32
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "medium",
                                weight: "medium",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    id: "growth-transmuters.recent-downgrade-discount.banner.title",
                                    defaultMessage: "Get 20% off 3 months of {productName} {edition}",
                                    values: {
                                        productName: productName,
                                        edition: edition
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "medium",
                                weight: "medium",
                                color: "color.link",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    id: "growth-transmuters.recent-downgrade-discount.banner.cta",
                                    defaultMessage: "View offer"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                appearance: "subtle",
                label: "Close",
                isTooltipDisabled: false,
                onClick: handleDismiss,
                spacing: "compact"
            })
        ]
    });
}


/* PromoModal.tsx generated by @compiled/babel-plugin v3.0.2 */ 

















var $rBCwg = parcelRequire("rBCwg");


var $hMcNB = parcelRequire("hMcNB");


var $eh6Ml = parcelRequire("eh6Ml");





var $cDs9S = parcelRequire("cDs9S");


var $aGB72 = parcelRequire("aGB72");




























var $cffed7960fcbb38f$exports = {};
$cffed7960fcbb38f$exports = new URL("illustration.e23e526b.png", import.meta.url).toString();


var $e7aa52a89051f5a2$exports = {};
$e7aa52a89051f5a2$exports = new URL("illustration-dark.fffe4019.png", import.meta.url).toString();


/** When the discount offer expires. Month is 0-indexed, so this is November 8, 2026. */ const $dce69407c7980761$var$OFFER_EXPIRY_DATE = new Date(2026, 10, 8);
const $dce69407c7980761$var$styles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC",
    scrollContainer: "_2O5Vij7dHp _4kiQYAdnbC _2WAcuGIZbP",
    hero: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0jFU0VGVdc _2C2kUQyzSk _1Lz9loyzSk",
    closeButton: "_1mT5xdWVPG _2IhTonNHnM _4ApkO2NHnM _42Yu6B7dHp",
    content: "_46hvQmNHnM _0xmtko5zaO _0LQT5ENHnM _03SyCPNHnM",
    feature: "_2mHwu88HPE _0hPCNLDIqT"
};
const $dce69407c7980761$var$JIRA_PRODUCT_DISCOVERY = 'Jira Product Discovery';
const $dce69407c7980761$var$getFeatures = (productName)=>[
        {
            id: 'pickUp',
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($rBCwg))),
            message: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "growth-transmuters.recent-downgrade-discount.modal.feature.pick-up",
                defaultMessage: "Instantly pick up where you left off"
            })
        },
        {
            id: 'limits',
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))),
            message: productName === $dce69407c7980761$var$JIRA_PRODUCT_DISCOVERY ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "growth-transmuters.recent-downgrade-discount.modal.feature.automation-steps-per-user",
                defaultMessage: "Get more automation steps per user"
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "growth-transmuters.recent-downgrade-discount.modal.feature.automation-steps",
                defaultMessage: "Get more automation steps and AI credits"
            })
        },
        {
            id: 'cancel',
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
            message: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "growth-transmuters.recent-downgrade-discount.modal.feature.cancel",
                defaultMessage: "Cancel or switch back anytime"
            })
        }
    ]; /**
     * The modal's close button, shown over the illustration. Uses the modal's own `onClose` (the
     * same one `ModalHeader` would use) so the close analytics event is created by modal-dialog.
     */ 
const $dce69407c7980761$var$PromoModalCloseButton = ()=>{
    const { onClose: onClose, testId: testId } = (0, $aGB72.useModal)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cDs9S.CloseButton), {
        onClick: onClose,
        testId: testId
    });
}; /** The visible heading, used as the modal's accessible title via `titleId` from `useModal()`. */ 
const $dce69407c7980761$var$PromoModalTitle = ({ children: children })=>{
    const { titleId: titleId } = (0, $aGB72.useModal)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
        size: "large",
        as: "h1",
        id: titleId,
        children: children
    });
};
const $dce69407c7980761$export$423d052f1b57be4b = ({ isOpen: isOpen, onClose: onClose, productName: productName, edition: edition, placeOrderHref: placeOrderHref, modalName: modalName })=>{
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onCtaActioned: onCtaActioned, onDeclined: onDeclined } = (0, $3jNKT.usePostOfficeUserInteractions)();
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: modalName,
            attributes: {
                team: 'growth-transmuters',
                productName: productName,
                edition: edition
            }
        });
    }, [
        isOpen,
        messageInstanceViewed,
        fireAnalyticsEvent,
        productName,
        edition,
        modalName
    ]); /**
                                                                                             * Fires a `ui button clicked` event on the Post Office channel. Reuses the event created by
                                                                                             * the ADS component so its context and attributes are kept, adding our actionSubjectId and
                                                                                             * the same attributes as the modal's screen event.
                                                                                             */ 
    const fireButtonClicked = (0, $cozmU.useCallback)((analyticsEvent, actionSubjectId)=>{
        analyticsEvent.update((payload)=>({
                ...payload,
                eventType: 'ui',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...payload.attributes,
                    team: 'growth-transmuters',
                    productName: productName,
                    edition: edition
                }
            })).fire((0, $9TNXZ.ANALYTICS_CHANNEL));
    }, [
        productName,
        edition
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((_e, analyticsEvent)=>{
        fireButtonClicked(analyticsEvent, `${modalName}Close`);
        onClose();
    }, [
        fireButtonClicked,
        onClose,
        modalName
    ]);
    const handleNoThanks = (0, $cozmU.useCallback)((_e, analyticsEvent)=>{
        fireButtonClicked(analyticsEvent, `${modalName}NoThanks`);
        onDeclined({
            interactionIdentifier: 'noThanks'
        });
        onClose();
    }, [
        fireButtonClicked,
        onClose,
        onDeclined,
        modalName
    ]);
    const handleClaimOffer = (0, $cozmU.useCallback)((_e, analyticsEvent)=>{
        // The LinkButton's native navigation opens placeOrderHref in a new tab.
        fireButtonClicked(analyticsEvent, `${modalName}ClaimOffer`);
        onCtaActioned({
            interactionIdentifier: 'claimOffer'
        });
    }, [
        fireButtonClicked,
        onCtaActioned,
        modalName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7aRdF.default // "medium" is 600px wide. Height grows to fit the content.
        ), {
            width: "medium",
            onClose: handleOnClose,
            testId: "recent-downgrade-discount-modal",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                    xcss: $dce69407c7980761$var$styles.root,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $dce69407c7980761$var$styles.closeButton,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)($dce69407c7980761$var$PromoModalCloseButton, {})
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                            xcss: $dce69407c7980761$var$styles.scrollContainer,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: $dce69407c7980761$var$styles.hero,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cffed7960fcbb38f$exports))),
                                        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($e7aa52a89051f5a2$exports))),
                                        alt: "",
                                        width: 1200,
                                        height: 480,
                                        testId: "recent-downgrade-discount-modal-illustration"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                                    space: "space.300",
                                    xcss: $dce69407c7980761$var$styles.content,
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                                            space: "space.150",
                                            children: [
                                                /*#__PURE__*/ (0, $8aG6j.jsx)($dce69407c7980761$var$PromoModalTitle, {
                                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                        id: "growth-transmuters.recent-downgrade-discount.modal.heading",
                                                        defaultMessage: "Get 20% off your next 3 months"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                        id: "growth-transmuters.recent-downgrade-discount.modal.body",
                                                        defaultMessage: "Restore your {productName} {edition} plan today and get 20% off your bill for 3 months.<sup>*</sup>",
                                                        values: {
                                                            productName: productName,
                                                            edition: edition,
                                                            sup: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("sup", {
                                                                    children: chunks
                                                                })
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
                                            space: "space.200",
                                            children: $dce69407c7980761$var$getFeatures(productName).map(({ id: id, Icon: Icon, message: message })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                                                    xcss: $dce69407c7980761$var$styles.feature,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                                                            label: "",
                                                            color: "var(--ds-icon-accent-blue, #357DE8)"
                                                        }),
                                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                            children: message
                                                        })
                                                    ]
                                                }, id))
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                            size: "small",
                                            color: "color.text.subtlest",
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                id: "growth-transmuters.recent-downgrade-discount.modal.footnote",
                                                defaultMessage: "<sup>*</sup>Offer expires on {expiryDate}",
                                                values: {
                                                    expiryDate: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedDate), {
                                                        value: $dce69407c7980761$var$OFFER_EXPIRY_DATE,
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric"
                                                    }),
                                                    sup: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("sup", {
                                                            children: chunks
                                                        })
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $eQiT1.default), {
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                            appearance: "default",
                            onClick: handleNoThanks,
                            testId: "recent-downgrade-discount-modal-no-thanks",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "growth-transmuters.recent-downgrade-discount.modal.secondary-action",
                                defaultMessage: "No thanks"
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                            appearance: "primary",
                            href: placeOrderHref,
                            target: "_blank",
                            onClick: handleClaimOffer,
                            testId: "recent-downgrade-discount-modal-claim-offer",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "growth-transmuters.recent-downgrade-discount.modal.primary-action",
                                defaultMessage: "Claim offer"
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $f9XbP = parcelRequire("f9XbP");




// Created on first use: constructing a StorageClient on the server defines a global `window`.
let $d850a6ec828be3c6$var$storageClient;
const $d850a6ec828be3c6$var$getStorageClient = ()=>$d850a6ec828be3c6$var$storageClient ?? ($d850a6ec828be3c6$var$storageClient = new (0, $f9XbP.StorageClient)('confluence-recent-downgrade-discount-modal', {
        storageEngine: 'localStorage'
    }));
const $d850a6ec828be3c6$var$SEEN_KEY = 'seen';
const $d850a6ec828be3c6$var$getSeenValue = ()=>$d850a6ec828be3c6$var$getStorageClient().getItem($d850a6ec828be3c6$var$SEEN_KEY) === true;
const $d850a6ec828be3c6$var$setSeenValue = ()=>$d850a6ec828be3c6$var$getStorageClient().setItemWithExpiry($d850a6ec828be3c6$var$SEEN_KEY, true);
const $d850a6ec828be3c6$export$fa9bb46961aca2cc = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $iqz3m.noValidation)(),
        Component: ({ productName: productName, edition: edition, entitlementId: entitlementId, placeOrderHref: placeOrderHref, shouldForceOpenModal: shouldForceOpenModal, handleOnDismissed: handleOnDismissed })=>{
            const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(()=>shouldForceOpenModal && !$d850a6ec828be3c6$var$getSeenValue());
            const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
                    productName: productName,
                    edition: edition,
                    entitlementId: entitlementId
                }), [
                productName,
                edition,
                entitlementId
            ]);
            (0, $cozmU.useEffect)(()=>{
                if (isModalOpen && !$d850a6ec828be3c6$var$getSeenValue()) $d850a6ec828be3c6$var$setSeenValue();
            }, [
                isModalOpen
            ]);
            const handleBannerClick = (0, $cozmU.useCallback)(()=>{
                setIsModalOpen(true);
            }, []);
            const handleModalClose = (0, $cozmU.useCallback)(()=>{
                $d850a6ec828be3c6$var$setSeenValue();
                setIsModalOpen(false);
            }, []);
            const handleDismissBanner = (0, $cozmU.useCallback)(()=>{
                $d850a6ec828be3c6$var$setSeenValue();
                handleOnDismissed();
            }, [
                handleOnDismissed
            ]);
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8645816a6fbeb0cf$export$bf92408866c0c2b3), {
                        onClick: handleBannerClick,
                        onDismiss: handleDismissBanner,
                        productName: productName,
                        edition: edition,
                        bannerName: "confluenceRecentDowngradeDiscountBanner",
                        analyticsAttributes: analyticsAttributes
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dce69407c7980761$export$423d052f1b57be4b), {
                        isOpen: isModalOpen,
                        onClose: handleModalClose,
                        productName: productName,
                        edition: edition,
                        placeOrderHref: placeOrderHref,
                        modalName: 'confluenceRecentDowngradeDiscountModal'
                    })
                ]
            });
        }
    }
});



var $kYBsP = parcelRequire("kYBsP");


var $eaqtE = parcelRequire("eaqtE");


var $jWOGk = parcelRequire("jWOGk");


var $gIcFu = parcelRequire("gIcFu");


var $6XRKH = parcelRequire("6XRKH");


var $7QguR = parcelRequire("7QguR");


var $afYui = parcelRequire("afYui");


var $1Neys = parcelRequire("1Neys");


var $bq5SV = parcelRequire("bq5SV");


var $4Vy0p = parcelRequire("4Vy0p");


var $cPGgH = parcelRequire("cPGgH");

const $5ff77a05c5151e9a$export$bfba3ccd9d9038f9 = (0, $kYBsP.createWithI18n)((0, $eaqtE.messagesLoader), (0, $jWOGk.messagesLoader), (0, $gIcFu.messagesLoader), (0, $6XRKH.messagesLoader), (0, $7QguR.messagesLoader), (0, $afYui.messagesLoader), (0, $1Neys.messagesLoader), (0, $bq5SV.messagesLoader), (0, $4Vy0p.messagesLoader), (0, $cPGgH.messagesLoader));


const $551110a8e230ccb7$var$messageFrontends = [
    (0, $6ea7ffe375aacf42$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-create-a-space'
    }),
    (0, $7188179b528a7f61$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge'
    }),
    (0, $cc3d520df71c5cda$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge'
    }),
    (0, $789eae1659236b56$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-side-nav-create-a-space'
    }),
    (0, $cb9f44e7a7a4173f$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge'
    }),
    (0, $bc4239413241ab3e$export$fa9bb46961aca2cc)({
        messageTemplateId: 'rovo-extension-install-cta-left-nav'
    }),
    (0, $b18ab7fb83d8776b$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-sidenav-banner'
    }),
    (0, $22a65248c86e7a72$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-sidenav-a-a-banner'
    }),
    (0, $e4c6014e88ba8d6e$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-rovo-onboarding-banner'
    }),
    (0, $51e17eb8c89c6db3$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-3p-tools-nudge-banner'
    }),
    (0, $b9098d3ce6e94275$export$fa9bb46961aca2cc)({
        messageTemplateId: 'rovo-non-mau-chat-cta-jira-confluence-left-nav'
    }),
    (0, $4d419829100a6c6e$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-agents-mcp-nudge-banner'
    }),
    (0, $2278b8786009bca6$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-loom-meeting-nudge-sidenav'
    }),
    (0, $d850a6ec828be3c6$export$fa9bb46961aca2cc)({
        messageTemplateId: 'recent-downgrade-discount'
    })
];
const $551110a8e230ccb7$export$7b621692a0aa2333 = (0, $a2042fb57734ba2e$export$55486c2b6964dcf2).createPlacementFrontendComponent({
    messageTemplates: $551110a8e230ccb7$var$messageFrontends
});
const $551110a8e230ccb7$export$af2bcbdc04a2d456 = (0, $5ff77a05c5151e9a$export$bfba3ccd9d9038f9)($551110a8e230ccb7$export$7b621692a0aa2333);
const $551110a8e230ccb7$export$7d3d92a960f07a28 = $551110a8e230ccb7$export$7b621692a0aa2333;



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $g95v4 = parcelRequire("g95v4");


var $bZSO8 = parcelRequire("bZSO8");


var $bAyaS = parcelRequire("bAyaS");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $eB1TF = parcelRequire("eB1TF");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV = 'poConfluenceSideNavCreate';
const $45373df583cce1d3$var$PlacementInternal = /*#__PURE__*/ (0, $cozmU.memo)(({ flags: flags })=>{
    const [preloadedInitialData, setInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('confluence-side-nav');
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const openAgentsAwarenessModal = (0, $g95v4.useOpenAgentsAwarenessModal)();
    const sideNavRef = (0, $cozmU.useRef)(null);
    const currentRoute = (0, $dPJCf.useRouteUrl)({
        selector: (routeUrl)=>routeUrl || ''
    });
    const { setIsOpen: setIsUniversalCreateOpen } = (0, $eB1TF.useUniversalCreateActions)();
    const { templateXflow: templateXflow } = (0, $cozmU.useContext)((0, $5nuFe.ConfluenceExperimentsContext));
    const sideNavMessages = (0, $ibHYv.usePostOfficeSideNavMessages)();
    const enableSideNavMessage = sideNavMessages?.enablePostOfficeSideNavMessage;
    const disableSideNavMessage = sideNavMessages?.disablePostOfficeSideNavMessage;
    const isTemplateXflowEligible = templateXflow?.currentPageTemplateData.isEligible === true && templateXflow.reminderState !== 'dismissed' && !templateXflow.isTerminallyDismissed && (0, $9wGTI.fg)('twcg-2112-twc-xflow-conf-pages-templates-gate');
    (0, $cozmU.useEffect)(()=>{
        if (!enableSideNavMessage || !disableSideNavMessage) return;
        if (isTemplateXflowEligible) enableSideNavMessage((0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY));
        else disableSideNavMessage((0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY));
        return ()=>{
            disableSideNavMessage((0, $ibHYv.TEMPLATE_XFLOW_EXPERIMENT_KEY));
        };
    }, [
        disableSideNavMessage,
        enableSideNavMessage,
        isTemplateXflowEligible
    ]);
    const onDismiss = (0, $cozmU.useCallback)((data)=>{
        setInitialData(data);
    }, [
        setInitialData
    ]);
    const onSideNavClick = (0, $cozmU.useCallback)((nextBestActionType, data)=>{
        setInitialData(data);
        switch(nextBestActionType){
            case 'CREATE_PAGE':
                push((0, $bZSO8.buildCreationLink)({
                    contentType: 'page',
                    source: $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV
                }));
                break;
            case 'CREATE_WHITEBOARD':
                push((0, $bZSO8.buildCreationLink)({
                    contentType: 'whiteboard',
                    source: $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV
                }));
                break;
            case 'CREATE_SPACE':
                // The second argument for openDrawer is the location string, which can be undefined or 'topCreateNav'
                // Since we're using the side nav to open the drawer, undefined is passed here.
                openDrawer(sideNavRef, undefined);
                break;
            case 'CREATE_WITH_ROVO_NUDGE':
                setIsUniversalCreateOpen(true);
                (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY, 'true');
                break;
            case 'MCP_SETUP_NUDGE':
                openAgentsAwarenessModal({
                    initialStep: 'mcp-setup'
                });
                break;
            case 'RESURRECTED_USER_NUDGE':
                push((0, $1NBp8.HOME).toUrl(undefined, {
                    query: {
                        feedType: 'POPULAR'
                    }
                }));
                break;
            default:
                return;
        }
    }, [
        openAgentsAwarenessModal,
        openDrawer,
        push,
        setInitialData,
        setIsUniversalCreateOpen
    ]);
    const memoizedPlacementProps = (0, $cozmU.useMemo)(()=>({
            preloadedInitialData: preloadedInitialData,
            onDismiss: onDismiss,
            onSideNavClick: onSideNavClick,
            currentRoute: currentRoute,
            ...flags && {
                flags: flags
            },
            disableInitialData: Boolean(preloadedInitialData)
        }), [
        preloadedInitialData,
        onDismiss,
        onSideNavClick,
        currentRoute,
        flags
    ]);
    /**
   * This is memoized to avoid any fetch calls getting cancelled inside `ConfluenceSideNav` due to
   * rerenders from changing context values (.ie usePostOfficeSideNavMessages).
   */ const PlacementInternals = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $551110a8e230ccb7$export$af2bcbdc04a2d456), memoizedPlacementProps)), [
        memoizedPlacementProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "confluence-side-nav-placement",
        "data-vc": "confluence-side-nav-placement",
        ...ssrPlaceholderIdProp
    }, PlacementInternals);
});
const $45373df583cce1d3$var$PostOfficeConfluenceSideNavPlacementWithFlags = (0, $7aRa9.withFlags)(({ flags: flags })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45373df583cce1d3$var$PlacementInternal, {
        flags: flags
    }));
const $45373df583cce1d3$export$f78bffe31fffa115 = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
    const isMeetingSignalExperimentEnabled = (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
    return isMeetingSignalExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45373df583cce1d3$var$PostOfficeConfluenceSideNavPlacementWithFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45373df583cce1d3$var$PlacementInternal, null);
});
module.exports["PostOfficeConfluenceSideNavPlacement"] = $45373df583cce1d3$export$f78bffe31fffa115;

});

parcelRegister("92JEG", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $d66becf3e4056778$export$8bcdb86a7ad5ef4b = ()=>{
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED)
    ]);
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $ivb8S.deserializeState)(data);
    return {
        isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed
    };
};
module.exports["useHasDismissedNav4CollapseReminderSpotlight"] = $d66becf3e4056778$export$8bcdb86a7ad5ef4b;

});

parcelRegister("c2h0x", function(module, exports) {
"use strict";
var $8c32dd4b29124a64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c32dd4b29124a64$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8c32dd4b29124a64$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8c32dd4b29124a64$var$__exportStar((parcelRequire("kB4yd")), module.exports);

$8c32dd4b29124a64$var$__exportStar((parcelRequire("aePf0")), module.exports);

});


//# sourceMappingURL=PageLayout.843827cc.js.map
